import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, AfterViewInit, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { File} from '../../../_models/file';
import { Workstep} from '../../../_models/workstep';
import { Parameter } from '../../../_models/parameter';
import { CuttingTable } from '../../../_models/cutting_table';
import { DataInput } from '../../../_models/data_input';
import { DataSheetInput } from '../../../_models/data_sheet_input';
import { Easel } from '../../../_models/easel';
import { OptiData } from '../../../_models/opti_data';
import { OptiPiece } from '../../../_models/opti_piece';
import { OptiSheet } from '../../../_models/opti_sheet';
import { Inventory} from '../../../_models/inventory_loc';
import { Location } from '@angular/common';

import { FormValidator } from '../../../_helpers/form.validator';
import { FileValidator } from '../../file.validator';

import { OptiFunction } from '../../../_helpers/opti.function';
import { AuxFunction } from '../../../_helpers/aux.function';
import { DbTransform } from '../../../_helpers/db.transform';
import {
  normalizeLegacyStructuralRightStrips,
  synchronizeSnapshotGraphicsWithCutOrder,
  validateSnapshotGraphicsAgainstCutOrder
} from '../../../_helpers/layout-snapshot-sync';
import {
  buildForm28Geometry,
  getForm28SagittaInfo
} from '../../../_helpers/form28-geometry';

import * as fromSortableColumn from '../../../sortableColumn/sortableColumn.function';

import { Translation } from '../../../_languages/translations';

import { Globals } from '../../../_globals/globals';
import { FileService } from '../../file.service';

@Component({
  selector: 'app-file',
  templateUrl: './file-list.component.html'
})
export class FileComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  // Para el control del diccionario de traducción.
  tr: {};

  title: string;
  subtitle: string;

  sub: any;
  // paramNum: number;
  paramChargeOpti: string;

  // Información del usuario actual logueado.
  current_user_id: number;
  current_user_email: string;
  current_user_name: string;
  current_user_group_id: number;
  current_user_lang: string;
  current_user_enviroment: string;
  current_user_company: string;

  // Control de permisos
  permissions: string;
  cncExportOptions: string[] = ['V40'];

  setTimeout_aux: number;

  // Para controlar tiempos de inicio y fin de procesos.
  time_start: number;
  time_end: number;
  time_duration: string;

  fromDate: Date;
  toDate: Date;

  fileForm: FormGroup;
  detailForm: FormGroup;
  pathForm: FormGroup;
  optiForm: FormGroup;
  piecesForm: FormGroup;
  sheetsForm: FormGroup;
  newPieceForm: FormGroup;
  newSheetForm: FormGroup;
  searchInventoryForm: FormGroup;
  searchPieceForm: FormGroup;
  figureForm: FormGroup;

  actionModal: boolean;
  alertModal: boolean;
  infoModal: boolean;

  fileModal: boolean;
  fileSheetModal: boolean;
  detailFileModal: boolean;
  saveOptiModal: boolean;
  inventoryModal: boolean;
  pieceModal: boolean;
  addPieceModal: boolean;
  figureModal: boolean;
  lastExportedFileModal: boolean;
  simulationsModal: boolean;
  helpModal: boolean;
  helpSection: string;
  optimizerTourModal: boolean;
  optimizerTourIndex: number;
  optimizerTourCardStyle: any;
  optimizerTourSpotlightStyle: any;
  optimizerTourPlacement: string;
  figureCatalogFilter: string;
  figureCatalogTagFilter: string;
  figureCatalogIds: number[];
  figureDxfName: string;
  figureDxfError: string;
  figureDxfRepairAvailable: boolean;
  figureDxfPoints: any[];
  figureDxfWidth: number;
  figureDxfHeight: number;
  figureDxfSourceFile: any;
  figureDxfBrowserModal: boolean;
  figureDxfBrowserFilter: string;
  figureDxfBrowserDirName: string;
  figureDxfBrowserFiles: any[];
  figureDxfBrowserSelectedIndex: number;
  figureDxfBrowserError: string;
  figureDxfBackupName: string;
  figureDxfBackupPoints: any[];
  figureDxfBackupWidth: number;
  figureDxfBackupHeight: number;

  showOptiId: boolean;
  routeOptiIdLabel: string;

  oefEnabled: boolean;
  oefPreset: string;
  oefBenchmark: boolean;
  oefPhase: number;
  oefAllowMirror: boolean;
  lastOefPreSearch: any;
  oefCandidatesModal: boolean;
  oefCandidateList: any[];
  oefCandidateSelectedIndex: number;
  oefSelectedCandidate: any;
  oefCandidateSelectionMap: any;
  private oefCandidatesResolver: any;
  private oefCandidateBorderSessionMap: any;
  private oefRuntimeOptimizationList: any[];
  private oefRuntimeSimulationVariants: any[][];
  private disableOefForVsBudgetDirectInput: boolean;

  actionInfo: string;
  alertInfo: string;
  infoInfo: string;

  today: Date;

  dbt: DbTransform;
  auxFunction: AuxFunction;
  opti: OptiFunction;

  // Variable para el control de las validaciones del formulario y sus mensajes.
  formValidator: FormValidator;

  selectedFile: File;

  filterFields: any;

  infoListAux: any;

  // Almacenan el valor por defecto de los parámetros generales de la aplicación.
  general_ancho_muela: Parameter;
  general_solapamiento: Parameter;
  general_ruta_destino: Parameter;
  general_retal_width: Parameter;
  general_retal_height: Parameter;

  filename: string;
  filenameList: any;
  filesheetname: string;
  filesheetnameList: any;

  mesa_destino: CuttingTable;

  tabs: {
    tabPiece: boolean;
    tabSheet: boolean;
    tabGraphic: boolean;
    tabFile: boolean;
  };

  checkAllPieces: boolean;
  checkAllSheets: boolean;

  optimizationList: any;
  initialSheetList: any;
  sheetList_datafile: any;

  local_pieceToEaselList: any;
  cutTotalOrderList: any;
  level0TraverseList: any;

  graphic_container: any;
  graphic_carousel: any;
  graphic_carousel_cell: any;
  canvas: any;

  max_bucle_count: number;

  axis: string;
  // set: boolean; // Indica si se intenta ajustar la pieza volteándola, en caso que no quepa después de ser modificada.
  // rotate: boolean; // Indica si se va a forzar el rotar los elementos.
  // turn: boolean; // Indica si se va a querer girar la pieza según alguna condición de proximidad.
  // near: boolean; // Indica la condición de proximidad usada (cerca o lejos de un borde) si el campo "turn" está activado.
  // diecutting: number; // Distancia mínima de tronzado.
  disband: any; // Distancia general de desbande (internamente tiene un valor para cada lado de la hoja).

  // Indica si se ha encontrado piezas que sobrepasan el ancho máximo de travera indicado.
  max_traverse_ok = false;
  // Indica si se ha encontrado piezas más largas que las hojas usadas.
  too_long_piece = false;
  // Indica si ha encontrado piezas con dimensiones nulas.
  null_dimension_piece = false;
  // Indica si se ha encontrado una relación "lote-secuencia"" repetida.
  lot_sequence_rep = false;

  kg_m2: number;

  default_depth: number;

  max_travera: number;
  max_retal_width: number;
  max_retal_height: number;
  disband_l: number;
  disband_b: number;
  disband_r: number;
  disband_t: number;
  diecutting_default: number;
  default_level: number;
  default_mode: number;

  total_area_D: number;
  total_area_B: number;
  total_area_S: number;
  total_area_X: number;
  total_area_X_OEF: number;
  total_area_T: number;
  total_area_T_OEF_IN: number;
  total_area_R: number;
  total_area_P: number;
  total_area_C: number;
  total_area_J: number;
  num_sheet: number;

  actual_sheet: number;
  actual_piece: any;
  actual_piece_graphic: any;

  // Para saber si se supera el nivel de anidamiento permitido para exportar Lisec.
  opti_level_fault: boolean;

  // Albergará el resultado de los datos obtenidos tras procesar cada una de las hojas de entrada.
  total_sheet_results: any[];

  // Tendrá los resultados de la última "simulación de mejora" realizada.
  total_better_opti_list: any;
  // Guarda la información de la optimización seleccionada por el usuario como "mejor".
  actual_better_opti: any;

  // Listado con todos los lotes que intervienen en la optimización.
  totalLotList: any;

  // Listado con todos los materiales que intervienen en la optimización.
  totalMaterialList: any;
  totalMaterialIdList: any;

  totalPieces: number;
  totalSelectedPieces: number;
  totalSelectedSheets: number;

  plus = '<label class="has-text-info"><strong>&nbsp;+</strong></label>';
  minus = '<label class="has-text-info"><strong>&nbsp;-</strong></label>';

  // Número de hijos que van a colgar de cada una de las páginas que se van a visualizar.
  num_page_children: number;

  // Listado de materiales del inventario.
  inventoriesList: Inventory[]; // Listado de inventario a mostrar.
  sku_mode: boolean;

  itemsPerPage: number;
  currentPage: number;
  piecesItemsPerPage: number;
  piecesCurrentPage: number;

  // -----------------
  // FUENTES Y COLORES
  // -----------------
  letra_10_currier: string;
  letra_bold_10_currier: string;
  letra_bold_12_currier: string;
  letra_bold_18_currier: string;
  amarillo_claro: string;
  naranja_rojo: string;
  naranja_oscuro: string;
  naranja_claro: string;
  azul_claro: string;
  rojo_claro: string;
  gris_claro: string;
  rosa: string;
  rosa_claro: string;

  fill_piece: boolean;
  show_order: boolean;

  blockedList: any;
  blocked_opti_export: boolean;
  blocked_opti_save: boolean;

  one_sheet: boolean;
  one_sheet_max: number;

  cronoModal: boolean;

  // Variables para el cronómetro.
  h: number;
  m: number;
  s: number;
  crono_id: any;

  autoBatchMode: boolean;
  autoBatchStage: string;
  autoBatchJob: any;
  autoBatchPendingResult: any;
  autoBatchWarnings: string[];
  autoBatchStartTimeMs: number;
  autoBatchHeartbeatTimer: any;
  autoBatchHeartbeatTicks: number;
  waitingChargeOptiById: boolean;
  pendingChargeOptiAutoStart: boolean;
  pendingChargeOptiAutoStartBlock: boolean;
  autoRunImproveOnLoad: boolean;
  usingPersistedLayoutSnapshot: boolean;
  persistedLayoutSnapshotMeta: any;
  lastTotalGraphicList: any[];
  optimizerTourViewportHandler: any;
  optimizerTourKeydownHandler: any;

  // @ViewChild('searchButton',  {static: true}) searchButton: ElementRef;
  @ViewChild('optiButton',  {static: true}) optiButton: ElementRef;
  @ViewChild('maxTravField',  {static: true}) maxTravField: ElementRef;
  @ViewChild('graphicContainer',  {static: true}) graphicContainer: ElementRef;
  // @ViewChild('graphicCarousel',  {static: true}) graphicCarousel: ElementRef;
  // @ViewChild('graphicCarouselCell',  {static: true}) graphicCarouselCell: ElementRef;
  @ViewChild('canvasGraphic',  {static: true}) canvasGraphic: ElementRef;
  @ViewChild('figureDxfFileInput', {static: false}) figureDxfFileInput: ElementRef;
  @ViewChild('figureDxfDirectoryInput', {static: false}) figureDxfDirectoryInput: ElementRef;
  @ViewChild('figureDxfBrowserListPanel', {static: false}) figureDxfBrowserListPanel: ElementRef;
  // @ViewChild('jumpLine',  {static: true}) jumpLine: ElementRef;
  @ViewChild('infoSheet',  {static: true}) infoSheet: ElementRef;
  // @ViewChild('optiNameField',  {static: true}) optiNameField: ElementRef;


  @Input() file: File;
  @Input() infoList: any;
  @Input() fileList: File[];
  @Input() cuttingTables: CuttingTable[];
  @Input() easelList: Easel[];
  @Input() workstepsList: Workstep[];
  @Input() optiPieceList: any;
  @Input() pieceList: any;
  @Input() currentOpti: any;
  @Input() chargeOpti: OptiPiece[];
  @Input() chargeSheetOpti: OptiSheet[];
  @Input() parameters: Parameter[];
  @Input() lastExportedFileName: any;
  @Output() updateFile = new EventEmitter<File>();
  @Output() saveFile = new EventEmitter<File>();
  @Output() optimizerFile = new EventEmitter<any>();
  @Output() infoFileList = new EventEmitter<any>();
  @Output() makeCsvFile = new EventEmitter<{file_name: string, content: any}>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();
  @Output() changingLoading = new EventEmitter<boolean>();
  @Output() changingLoading2 = new EventEmitter<boolean>();
  @Output() printEasels = new EventEmitter<any>();
  @Output() printSheets = new EventEmitter<any>();
  @Output() saveOptiPiece = new EventEmitter<any>();
  @Output() loadPiece = new EventEmitter<any>();
  @Output() loadChargeOptiById = new EventEmitter<any>();
  @Output() setExportedFileName = new EventEmitter<any>();

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private globals: Globals,
    private fileService: FileService,
    private formBuilder: FormBuilder,
    private _location: Location,
    public trans: Translation
  ) {
    this.formValidator = new FormValidator();
  }

  // convenience getter for easy access to form fields
  get f() { return this.fileForm.controls; }
  get d() { return this.detailForm.controls; }
  get p() { return this.pathForm.controls; }
  get o() { return this.optiForm.controls; }
  get fi() { return this.figureForm.controls; }

  private findGeneralParameterByKeys(keyListIn: string[]): Parameter {
    if (!this.parameters || !Array.isArray(this.parameters) || !keyListIn || keyListIn.length === 0) {
      return null;
    }

    return this.parameters.find(item =>
      item &&
      item.setup_key &&
      keyListIn.indexOf(item.setup_key.toString().toLowerCase()) > -1
    );
  }

  private toPositiveNumber(valueIn: any): number {
    const value = Number(valueIn);
    if (!isNaN(value) && isFinite(value) && value > 0) {
      return value;
    }
    return null;
  }

  private applyGeneralRetalParameters(): void {
    if (!this.fileForm || !this.fileForm.controls) {
      return;
    }

    const prevDefaultWidth = this.max_retal_width;
    const prevDefaultHeight = this.max_retal_height;
    const loadedFromOptimization = !!(this.selectedFile && this.sheetList_datafile && this.sheetList_datafile.length > 0);

    if (this.general_retal_width) {
      const retalWidth = this.toPositiveNumber(this.general_retal_width.setup_value);
      if (retalWidth !== null) {
        this.max_retal_width = retalWidth;
        const currentWidth = this.toPositiveNumber(this.fileForm.controls.f_retal_width.value);
        if (!loadedFromOptimization && (currentWidth === null || currentWidth === prevDefaultWidth)) {
          this.fileForm.controls.f_retal_width.setValue(retalWidth);
        }
      }
    }

    if (this.general_retal_height) {
      const retalHeight = this.toPositiveNumber(this.general_retal_height.setup_value);
      if (retalHeight !== null) {
        this.max_retal_height = retalHeight;
        const currentHeight = this.toPositiveNumber(this.fileForm.controls.f_retal_height.value);
        if (!loadedFromOptimization && (currentHeight === null || currentHeight === prevDefaultHeight)) {
          this.fileForm.controls.f_retal_height.setValue(retalHeight);
        }
      }
    }
  }

  private formatMmLabel(widthIn: any, heightIn: any): string {
    const width = Number(widthIn);
    const height = Number(heightIn);
    const widthInt = Number.isFinite(width) ? Math.round(width) : 0;
    const heightInt = Number.isFinite(height) ? Math.round(height) : 0;
    return widthInt + 'x' + heightInt;
  }

  roundMmDisplay(valueIn: any): number {
    const value = Number(valueIn);
    return Number.isFinite(value) ? Math.round(value) : 0;
  }

  private drawStackedMeasureLabel(contextIn: any, labelIn: any, suffixIn: string, stackedIn: boolean): void {
    const label = labelIn ? labelIn.toString() : '';
    if (!stackedIn) {
      contextIn.fillText(label + suffixIn, 0, 0);
      return;
    }
    const match = label.match(/^\s*([0-9]+(?:[.,][0-9]+)?)x([0-9]+(?:[.,][0-9]+)?)/i);
    if (!match) {
      contextIn.fillText(label + suffixIn, 0, 0);
      return;
    }
    const w = Number(match[1].replace(',', '.'));
    const h = Number(match[2].replace(',', '.'));
    const wTxt = Number.isFinite(w) ? Math.round(w).toString() : match[1];
    const hTxt = Number.isFinite(h) ? Math.round(h).toString() : match[2];

    contextIn.fillText(wTxt, 0, -10);
    contextIn.fillText('x', 0, 2);
    contextIn.fillText(hTxt, 0, 14);
  }

  private drawCompactMeasureInsideRect(
    contextIn: any,
    labelIn: any,
    cxIn: number,
    cyIn: number,
    widthPxIn: number,
    heightPxIn: number
  ): boolean {
    const label = labelIn ? labelIn.toString() : '';
    const match = label.match(/^\s*([0-9]+(?:[.,][0-9]+)?)x([0-9]+(?:[.,][0-9]+)?)/i);
    if (!match) { return false; }

    const w = Number(match[1].replace(',', '.'));
    const h = Number(match[2].replace(',', '.'));
    const wTxt = Number.isFinite(w) ? Math.round(w).toString() : match[1];
    const hTxt = Number.isFinite(h) ? Math.round(h).toString() : match[2];

    const widthPx = Math.abs(Number(widthPxIn));
    const heightPx = Math.abs(Number(heightPxIn));
    if (!Number.isFinite(widthPx) || !Number.isFinite(heightPx) || widthPx < 26 || heightPx < 18) {
      return false;
    }

    const padding = 2;
    const minFont = 6;
    const maxFont = 11;
    let pickedFont = 0;
    let pickedGap = 0;
    let pickedHeight = 0;

    contextIn.save();
    contextIn.textAlign = 'center';
    contextIn.textBaseline = 'middle';

    for (let font = maxFont; font >= minFont; font--) {
      const gap = font <= 7 ? 1 : 2;
      contextIn.font = font + 'pt Courier New';
      const maxTextWidth = Math.max(contextIn.measureText(wTxt).width, contextIn.measureText(hTxt).width);
      const requiredHeight = (font * 2) + gap;

      if (maxTextWidth <= (widthPx - (padding * 2)) && requiredHeight <= (heightPx - (padding * 2))) {
        pickedFont = font;
        pickedGap = gap;
        pickedHeight = requiredHeight;
        break;
      }
    }

    if (pickedFont === 0) {
      contextIn.restore();
      return false;
    }

    contextIn.font = pickedFont + 'pt Courier New';
    contextIn.beginPath();
    contextIn.rect(
      cxIn - (widthPx / 2) + 1,
      cyIn - (heightPx / 2) + 1,
      Math.max(0, widthPx - 2),
      Math.max(0, heightPx - 2)
    );
    contextIn.clip();

    const topY = cyIn - (pickedHeight / 2) + (pickedFont / 2);
    const bottomY = topY + pickedFont + pickedGap;
    contextIn.fillText(wTxt, cxIn, topY);
    contextIn.fillText(hTxt, cxIn, bottomY);

    contextIn.restore();
    // Evita que el rectángulo usado para clip quede como path activo y se acabe trazando.
    contextIn.beginPath();
    return true;
  }

  ngAfterViewInit() {

	console.log(' --> ngAfterViewInit window = ');
	//console.log(document);
    console.log(this.optiButton);

	this.optiButton.nativeElement.focus();

  } // End function ngAfterViewInit.

  ngOnDestroy() {
    this.stopAutoBatchHeartbeat(false);
    this.closeOptimizerTour();
  }

  ngOnInit() {

    // IMPORTANTE: pasar el entorno de la clase como parámetro para
    // que las funciones internas puedan reconocer y modificar las variables.
    // let that = this;

    // Colocamos inicialmente el foco en el campo del nombre de la ventana de guardado de optimización.
    // this.optiNameField.nativeElement.focus();
    // document.getElementById('optiNameField').focus();
    this.optiButton.nativeElement.focus();

    this.default_depth = 4; // Cuatro milímetros es espesor por defecto.

    this.max_travera = 6000;
    this.max_retal_width = 900;
    this.max_retal_height = 900;
    this.disband_l = 0;
  	this.disband_b = 0;
  	this.disband_r = 0;
  	this.disband_t = 0;
  	this.diecutting_default = 0;
  	this.default_level = 20;
    this.default_mode = 2;

    this.autoBatchMode = false;
    this.autoBatchStage = '';
    this.autoBatchJob = null;
    this.autoBatchPendingResult = null;
    this.autoBatchWarnings = [];
    this.autoBatchStartTimeMs = 0;
    this.autoBatchHeartbeatTimer = null;
    this.autoBatchHeartbeatTicks = 0;
    this.waitingChargeOptiById = false;
    this.pendingChargeOptiAutoStart = false;
    this.pendingChargeOptiAutoStartBlock = false;
    this.autoRunImproveOnLoad = false;
    this.usingPersistedLayoutSnapshot = false;
    this.persistedLayoutSnapshotMeta = null;
    this.lastTotalGraphicList = [];
    this.optimizerTourViewportHandler = () => {
      if (this.optimizerTourModal) {
        this.positionOptimizerTourForCurrentStep();
      }
    };
    this.optimizerTourKeydownHandler = (eventIn: any) => {
      if (this.optimizerTourModal && eventIn && (eventIn.key === 'Escape' || eventIn.keyCode === 27)) {
        this.closeOptimizerTour();
      }
    };

    // Inicialmente existirán 4 hijos por página: el canvas, un salto, la etiqueta informativa y otro salto final.
    this.num_page_children = 2;

    this.opti_level_fault = false;

    this.totalLotList = [];
    this.totalMaterialList = [];
    this.totalMaterialIdList = [];
    this.totalPieces = 0;
    this.totalSelectedPieces = 0;
    this.totalSelectedSheets = 0;
    this.total_better_opti_list = [];
    this.helpModal = false;
    this.helpSection = 'flujo';
    this.optimizerTourModal = false;
    this.optimizerTourIndex = 0;
    this.optimizerTourCardStyle = {};
    this.optimizerTourSpotlightStyle = {};
    this.optimizerTourPlacement = 'right';

    this.checkAllPieces = false;
    this.checkAllSheets = false;

    this.fill_piece = true;
    this.show_order = false;

    this.letra_10_currier = '10pt Courier New';
    this.letra_bold_10_currier = 'bold 10pt Courier New';
    this.letra_bold_12_currier = 'bold 12pt Courier New';
    this.letra_bold_18_currier = 'bold 18pt Courier New';

    this.amarillo_claro = 'rgba(255, 255, 224, 0.8)';
    this.naranja_rojo = 'rgba(255, 69, 0)';
    this.naranja_oscuro = 'rgba(255, 140, 0)';
    this.naranja_claro = 'rgba(255, 69, 0, 0.2)';
    this.azul_claro = 'rgba(135, 206, 250, 0.8)';
    this.gris_claro = 'rgba(135, 135, 135, 0.1)';
    // En canvas OEF el "resto" del primitivo compuesto se representa en verde claro.
    this.rojo_claro = 'rgba(144, 238, 144, 0.45)';
    this.rosa = 'rgba(255 105 180)';
    this.rosa_claro = 'rgba(255, 105, 180, 0.2)';

    this.tr = this.trans.vocabulary;

    this.dbt = new DbTransform(localStorage.getItem('enviroment')); //this.globals.currentUserEnviroment);
    this.auxFunction = new AuxFunction();
    this.opti = new OptiFunction();

    this.permissions = localStorage.getItem('permissions');
    this.cncExportOptions = this.globals.getCncExportFamilies(this.permissions);
    console.log('-> -> Iniciando file-list permissions:' + this.permissions);

    this.current_user_id = Number(localStorage.getItem('user_id'));
    this.current_user_email = localStorage.getItem('email');
    this.current_user_name = localStorage.getItem('name');
    this.current_user_group_id = Number(localStorage.getItem('group_id'));
    this.current_user_lang = localStorage.getItem('lang');
    this.current_user_enviroment = localStorage.getItem('enviroment');
    this.current_user_company = localStorage.getItem('company');

    console.log(' -> file-list current_user_id: ' + this.current_user_id);
    console.log(' -> file-list current_user_email: ' + this.current_user_email);
    console.log(' -> file-list current_user_name: ' + this.current_user_name);
    console.log(' -> file-list current_user_group_id: ' + this.current_user_group_id);
    console.log(' -> file-list current_user_lang: ' + this.current_user_lang);
    console.log(' -> file-list current_user_enviroment: ' + this.current_user_enviroment);
    console.log(' -> file-list current_user_company: ' + this.current_user_company);

    console.log('--> Parámetros generales de entrada:');
    console.log(this.parameters);

    // Se obtiene la lista de elementos bloqueados para la compañía actual.

    // METODO A: Por lista en archivo global.
    this.blockedList = this.globals.blockedCompanyList[this.current_user_enviroment];

    // Se averigua si deben o no estar bloqueados ciertos elementos de la sección.
    // El entorno demoes bloquea históricamente estas acciones para los perfiles
    // de demostración. Manufacturer es el perfil de evaluación de Turomas y debe
    // poder guardar resultados y generar los CNC permitidos para ese perfil.
    this.blocked_opti_export = this.permissions !== 'Manufacturer'
      && this.auxFunction.blockElement(this.permissions, 'opti_export', this.blockedList);
    this.blocked_opti_save = this.permissions !== 'Manufacturer'
      && this.auxFunction.blockElement(this.permissions, 'opti_save', this.blockedList);

    // METODO B: Por parámetros generales de la base de datos.
    // this.blocked_opti_export = this.auxFunction.blockElementByGeneralParameter(this.permissions, 'opti_export', this.parameters);
    // this.blocked_opti_save = this.auxFunction.blockElementByGeneralParameter(this.permissions, 'opti_save', this.parameters);

    console.log('--> file-list blockedCompanyList:');
    console.log(this.blockedList);

    this.filterFields = [];
    this.infoListAux = [];

    this.filename = null;
    this.filenameList = [];
    this.filesheetname = null;
    this.filesheetnameList = [];

    this.tabs = {
      tabPiece: false,
      tabSheet: false,
      tabGraphic: false,
      tabFile: false
    }

    this.showOptiId = false;
    this.routeOptiIdLabel = '';
    this.disableOefForVsBudgetDirectInput = false;
    this.oefEnabled = false;
    this.oefPreset = 'equilibrado';
    this.oefBenchmark = false;
    this.oefPhase = 2;
    this.oefAllowMirror = false;
    this.lastOefPreSearch = null;
    this.oefCandidatesModal = false;
    this.oefCandidateList = [];
    this.oefCandidateSelectedIndex = -1;
    this.oefSelectedCandidate = null;
    this.oefCandidateSelectionMap = {};
    this.oefCandidatesResolver = null;
    this.oefCandidateBorderSessionMap = this.loadOefCandidateBorderSessionMap();
    this.oefRuntimeOptimizationList = null;
    this.oefRuntimeSimulationVariants = [];
    this.loadOefSettingsFromStorage();

    let subtract_days = 30;

    // Declaración de variables para el control de rango de fechas.
    this.today = new Date();

    // Declaración de variables para el control de rango de fechas.
    this.fromDate = new Date();

    // NOTA: Colocamos la fecha inicial de búsqueda unos cuantos días atrás
    // dependiendo del perfil del usuario que esté logueado.
    this.fromDate.setDate(this.fromDate.getDate() - subtract_days);

    this.toDate = new Date();

    // this.toDate.setMinutes(this.toDate.getMinutes() + (13 * 60));

    if (this.filterFields['f_start_date'] === undefined || this.filterFields['f_start_date'] === null) {
      this.filterFields['f_start_date'] = this.fromDate;
    }

    if (this.filterFields['f_end_date'] === undefined || this.filterFields['f_end_date'] === null) {
      this.filterFields['f_end_date'] = this.toDate;
    }

    this.filterFields['f_id'] = null;
    this.filterFields['f_vidrio'] = '';
    this.filterFields['f_grupo'] = null;

    this.fileForm = this.formBuilder.group({

      f_level: this.default_level,
      f_mode: this.default_mode,
      f_free: this.filterFields['f_free'],
      f_free_in: this.filterFields['f_free_in'],
      f_grade: this.filterFields['f_grade'],
      f_grade_rep: this.filterFields['f_grade_rep'],
      f_export: this.filterFields['f_export'],
      f_rute: true,
      f_origin: this.filterFields['f_origin'],
      f_axis: this.filterFields['f_axis'],
      f_rot: this.filterFields['f_rot'],
      f_info: this.filterFields['f_info'],
      f_set: this.filterFields['f_set'],
      f_turn: this.filterFields['f_turn'],
      f_near: this.filterFields['f_near'],
      f_disband_l: this.filterFields['f_disband_l'],
      f_disband_b: this.filterFields['f_disband_b'],
      f_disband_r: this.filterFields['f_disband_r'],
      f_disband_t: this.filterFields['f_disband_t'],
      f_diecutting: this.filterFields['f_diecutting'],
      f_max_diecutting: this.filterFields['f_max_diecutting'],
      f_retal_width: this.filterFields['f_retal_width'],
      f_retal_height: this.filterFields['f_retal_height'],
      f_zoom: this.filterFields['f_zoom'],
      f_old: this.filterFields['f_old'],
      f_blocks: this.filterFields['f_blocks'],
      f_base: this.filterFields['f_base'],
      f_order: this.filterFields['f_order'],
      f_fill_piece: this.fill_piece,
      f_show_order: this.show_order,
      f_filename: null,
      f_filesheetname: null,

      f_id: this.filterFields['f_id'],
      f_mesa_corte: this.filterFields['f_mesa_corte'],
      f_cutting_table_id: null,
      f_vidrio: this.filterFields['f_vidrio'],
      f_grupo: this.filterFields['f_grupo'],
      f_start_date: this.filterFields['f_start_date'],
      f_end_date: this.filterFields['f_end_date'],
      f_general_ancho_muela: null, // IMPORTANTE: Debe cogerlo de los generales, pero no tiene valor aquí aún.
      f_general_solapamiento: null,
      f_general_ruta_destino: null,
      f_force: false,
      f_print: 'easels',
      f_speed: 'fast'
    });

    // Se fuerza el valor V40 por defecto.
    this.fileForm.controls.f_export.setValue('V40');

    this.detailForm = this.formBuilder.group({
      id_vidrio: null,
      desc_vidrio: null,
      nombre_opti: null,
      mesa_corte: null,
      fecha_produccion: null,
      alto_hoja_restante: null,
      ancho_hoja_restante: null,
      area_total_neta: null,
      cant_hojas: null,
      medidas: null,
      // ancho: null,
      // alto: null,
      // cantidad: null,
      merma: null,
      tso: false,
      capa: false,
      formas: false,
      lotes: null,
      grupo: null,
      max_ancho_subtravera: null,
      min_ancho_subtravera: null,
      min_distancia_corte: null,
      opti_sin_limites: null,
      ruta: null,
      ruta_destino: null,
      trimcut_abajo: null,
      trimcut_arriba: null,
      trimcut_derecha: null,
      trimcut_izquierda: null,
      ancho_muela: null,
      solapamiento: null,
      mesa_ancho_muela: null,
      mesa_solapamiento: null,
      path: null,
      download: false,
      enviroment: this.current_user_enviroment,
      user_id: this.current_user_id,
      user_name: this.current_user_name
    });

    this.pathForm = this.formBuilder.group({
      myfile: './'
    });

    this.optiForm = this.formBuilder.group({
      save: true,
      opti_name: ''
    });

    this.optiForm.controls.save.setValue(true);

    this.piecesForm = this.formBuilder.group({
      unit: 0,
      width: 0,
      height: 0
    });

    this.newPieceForm = this.formBuilder.group({
	  id: null,
      width: 0,
      height: 0,
      depth: 4, // 4mm es el mínimo por defecto
      mat_id: null,
      mat_name: null,
      mat_desc: null,
      units: 0,
      lot: null,
      sequence: null,
      steps: null,
      orderno: null,
	  orderpos: null,
	  paneno: null,
      priority: 0,
      figure: null, // identificador forma
      l: null,
      l1: null,
      l2: null,
      h: null,
      h1: null,
      h2: null,
	  r: null,
	  r2: null,
	  r3: null,
	  r4: null,
	  b1: null,
	  b2: null,
	  b3: null,
	  b4: null,
      easel: '',
      decoat: 0,
      group: 'A',
      check: false
    });

    this.figureForm = this.formBuilder.group({
      figure_id: null, // identificador forma
      figure_l: null,
      figure_l1: null,
      figure_l2: null,
      figure_h: null,
      figure_h1: null,
      figure_h2: null,
      figure_r: null,
      figure_r2: null,
      figure_r3: null,
      figure_r4: null,
      figure_b1: null,
      figure_b2: null,
      figure_b3: null,
      figure_b4: null
    });

    this.newSheetForm = this.formBuilder.group({
      width: 0,
      height: 0,
      deepth: 0,
      units: 0,
      mat_id: null,
      mat_name: null,
      mat_desc: null,
      reference: null,
      retal: false

    });

    this.searchPieceForm = this.formBuilder.group({
	  f_broke:  this.filterFields.f_broke,
	  f_finished: this.filterFields.f_finished,
	  f_batchno: this.filterFields.f_batchno,
	  f_barcode: this.filterFields.f_barcode,
      f_mat: this.filterFields.f_mat,
      f_width: this.filterFields.f_width,
      f_height: this.filterFields.f_height,
      offset: this.piecesCurrentPage,
      pagesize: this.piecesItemsPerPage
    });

    // Inicialmente sólo aparecerán las piezas de VS-Floor que son "roturas".
    this.searchPieceForm.controls.f_broke.setValue(true);
    this.searchPieceForm.controls.f_finished.setValue(true);

    this.searchInventoryForm = this.formBuilder.group({
	  f_lager: this.filterFields.f_lager,
	  f_barcode: this.filterFields.f_barcode,
      f_mat: this.filterFields.f_mat,
      f_width: this.filterFields.f_width,
      f_height: this.filterFields.f_height,
      f_consume: this.filterFields.f_consume,
      filterField_0: this.filterFields['filterField_0'], // Filtro de almacén
      filterField_1: this.filterFields['filterField_1'],
      filterField_2: this.filterFields['filterField_2'], // Filtro de ubicación
      filterField_3: this.filterFields['filterField_3'], // Filtro de material
      filterField_4: this.filterFields['filterField_4'], // Filtro de ancho de hoja
      filterField_5: this.filterFields['filterField_5'], // Filtro de alto de hoja
      filterField_6: this.filterFields['filterField_6'], // Filtro de Mat ID
      sku_mode: false,
      filterReserve: 'all',
      zone: null,
      zoneItem: null,
      // userId: this.current_user_id,
      groupId: this.current_user_group_id,
      offset: this.currentPage,
      pagesize: this.itemsPerPage
    });

    // Asignamos los mensajes de error asociados a las validaciones que vamos a usar en el formulario.
    this.formValidator.setTemplateMessages(FileValidator.templateMessages);

    this.title = this.tr['st1_title'];
    this.subtitle = this.tr['st1_subtitle'];

    this.actionInfo = this.tr['st1_a ctionInfo'];

    this.infoInfo = this.tr['st1_actionOk'];

    this.actionModal = false;
    this.fileModal = false;
    this.fileSheetModal = false;
    this.detailFileModal = false;
    this.saveOptiModal = false;
    this.figureModal = false;
    this.lastExportedFileModal = false;
    this.figureCatalogFilter = '';
    this.figureCatalogTagFilter = '';
    this.figureCatalogIds = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
      10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
      20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
      30, 31, 32, 33, 34, 35, 36, 37, 38, 40,
      41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
      51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
      61, 62, 926, 371, 372
    ];
    this.figureDxfName = '';
    this.figureDxfError = '';
    this.figureDxfRepairAvailable = false;
    this.figureDxfPoints = [];
    this.figureDxfWidth = 0;
    this.figureDxfHeight = 0;
    this.figureDxfSourceFile = null;
    this.figureDxfBrowserModal = false;
    this.figureDxfBrowserFilter = '';
    this.figureDxfBrowserDirName = '';
    this.figureDxfBrowserFiles = [];
    this.figureDxfBrowserSelectedIndex = -1;
    this.figureDxfBrowserError = '';
    this.figureDxfBackupName = '';
    this.figureDxfBackupPoints = [];
    this.figureDxfBackupWidth = 0;
    this.figureDxfBackupHeight = 0;

    this.setTimeout_aux = 10;

    // -----------------------------
    // Listener atentos a modificaciones de campos

    const ControlNumPieces = this.piecesForm.get('num_pieces');

    // -----------------------------
    // Variables para el optimizador
    // -----------------------------

    this.optimizationList = [];
    this.initialSheetList = [];
    this.sheetList_datafile = [];
    this.local_pieceToEaselList = [];
    this.cutTotalOrderList = [];
    this.level0TraverseList = [];

    this.disband = {
      left: 0, // this.fileForm.controls.f_disband_l.value,
      bottom: 0, // this.fileForm.controls.f_disband_b.value,
      right: 0, // this.fileForm.controls.f_disband_r.value,
      top: 0 // this.fileForm.controls.f_disband_t.value,
    }

    this.graphic_container = this.graphicContainer.nativeElement;
    // this.graphic_carousel = this.graphic_container.firstChild;
    // this.graphic_carousel_cell = this.graphicCarouselCell.nativeElement;

    // Se oculta el div usado para albergar los gráficos.
    this.graphic_container.style.display = 'none';

    console.log('-> -> graphic_container:');
    console.log(this.graphic_container);

    // console.log('-> -> graphic_carousel:');
    // console.log(this.graphic_carousel);

    // console.log('-> -> graphic_carousel_cell:');
    // console.log(this.graphic_carousel_cell);

    // Obtener el elemento del DOM del canvas donde se dibujarán los gráficos.
    // let canvas = document.querySelector("#canvasGraphic");
    this.canvas = this.canvasGraphic.nativeElement;
    this.canvas.width = 0;
    this.canvas.height = 0;

    // Densidad media de un vídrio (dato general aproximado).
    this.kg_m2 = 2.5;

    this.total_area_D = 0;
    this.total_area_B = 0;
    this.total_area_S = 0;
    this.total_area_X = 0;
    this.total_area_X_OEF = 0;
    this.total_area_T = 0;
    this.total_area_T_OEF_IN = 0;
    this.total_area_R = 0;
    this.total_area_P = 0;
    this.total_area_C = 0;
    this.total_area_J = 0;
    this.num_sheet = 0;
    this.actual_sheet = 0;

    this.actual_piece = null;
    this.actual_piece_graphic = './assets/forms/form_0.png';

    // CASO 3: CONTADOR ITERACIONES PIEZAS
    // Número máximo de iteraciones al que se va a limitar los
    // bucles internos para prevenir posibles ciclos sin fin.
    this.max_bucle_count = 1000;

    // Si hay un número preficado en las variables globales se coge ese.
    if (this.globals.maxNumPieces) {
      this.max_bucle_count = this.globals.maxNumPieces;
    }

    // Si el desbande o el tronzado no están definidos se ponen por defecto a 15.
    // El desbande por defecto será a 15 para la izquierda y abajo (que esl f_disband_t "top" por la orientación del canvas gráfico).
    if (!this.fileForm.controls.f_disband_l.value) {
      this.fileForm.controls.f_disband_l.setValue(this.disband_l);
    }
    if (!this.fileForm.controls.f_disband_b.value) {
      this.fileForm.controls.f_disband_b.setValue(this.disband_b);
    }
    if (!this.fileForm.controls.f_disband_r.value) {
      this.fileForm.controls.f_disband_r.setValue(this.disband_r);
    }
    if (!this.fileForm.controls.f_disband_t.value) {
      this.fileForm.controls.f_disband_t.setValue(this.disband_t);
    }

    if (!this.fileForm.controls.f_diecutting.value) {
      this.fileForm.controls.f_diecutting.setValue(this.diecutting_default);
    }

    if (!this.fileForm.controls.f_max_diecutting.value) {
      // Inicialmente por defecto se coloca un máximo de ancho de travera de un 70% del ancho de la hoja.
      this.fileForm.controls.f_max_diecutting.setValue(this.max_travera); //Math.trunc(this.max_travera * 0.70));
    }

    // Si las medidas de retal no están definidas se ponen por defecto 0.
    if (!this.fileForm.controls.f_retal_width.value) {
      this.fileForm.controls.f_retal_width.setValue(this.max_retal_width);
    }
    if (!this.fileForm.controls.f_retal_height.value) {
      this.fileForm.controls.f_retal_height.setValue(this.max_retal_height);
    }

	if (!this.fileForm.controls.f_origin.value) {
      this.fileForm.controls.f_origin.setValue('1');
    }

    if (!this.fileForm.controls.f_axis.value) {
      this.fileForm.controls.f_axis.setValue('X');
    }

    if (!this.fileForm.controls.f_zoom.value) {
      this.fileForm.controls.f_zoom.setValue(0.19);
    }

    if (!this.fileForm.controls.f_old.value) {
      this.fileForm.controls.f_old.setValue(true);
    }

    if (!this.fileForm.controls.f_level.value) {
      this.fileForm.controls.f_level.setValue(20);
    }

    if (!this.fileForm.controls.f_free.value) {
      this.fileForm.controls.f_free.setValue(2);
    }

    if (!this.fileForm.controls.f_free_in.value) {
      this.fileForm.controls.f_free_in.setValue(1);
    }

    if (!this.fileForm.controls.f_grade.value) {
      this.fileForm.controls.f_grade.setValue(0);
    }

    if (!this.fileForm.controls.f_grade_rep.value) {
      this.fileForm.controls.f_grade_rep.setValue(999);
    }

    // if (!this.fileForm.controls.f_blocks.value) {
    //   this.fileForm.controls.f_blocks.setValue(true);
    // }

    if (!this.fileForm.controls.f_base.value) {
      this.fileForm.controls.f_base.setValue(true);
    }

    if (!this.fileForm.controls.f_order.value) {
      this.fileForm.controls.f_order.setValue(false);
    }

    // Por defecto no se mostrará la información adicional de las piezas en el gráfico.
    this.fileForm.controls.f_info.setValue(false);

    // Activamos por defecto la opción de "Rotar" y "Encajar".
    // if (!this.fileForm.controls.f_rot.value) {
    //   this.fileForm.controls.f_rot.setValue(true);
    // }
    if (!this.fileForm.controls.f_set.value) {
      this.fileForm.controls.f_set.setValue(true);
    }

    // -----------------------------
    // ONE SHEET
    // -----------------------------

    // Indica si se usa optimización para ONE SHEET o no.
    this.one_sheet = false;

    // Número máximo de resultados de hoja única que se quiere guardar.
    this.one_sheet_max = 20;

    // -----------------------------
    //		RELOJ CRONÓMETRO
    // -----------------------------
    this.h = 0;
  	this.m = 0;
  	this.s = 0;

  	this.cronoModal = true;

  	// let clock = document.getElementById("clock");

  	// clock.style.display = "block";

    // this.auxFunction.iniciar_crono(that);

    // -----------------------------
    //     PARÁMETROS DE ENTRADA
    // -----------------------------

    this.sub = this.route.params.subscribe(params => {
      // this.paramNum = +params['num']; // Importante el '+' para obtener números
      this.paramChargeOpti = params['opt'];
    });
    console.log('--> Parámetro de entrada opt = ' + this.paramChargeOpti);
    if (this.paramChargeOpti === 'charge') {
      this.disableOefForVsBudgetDirectInput = false;
      // Si se abre una optimización ya guardada (incluyendo "Ver cortes" desde Auto Opti),
      // hay que mostrar el identificador real y no el texto de prueba.
      this.showOptiId = true;
      const optiIdQuery = this.route.snapshot.queryParamMap.get('opti_id');
      if (optiIdQuery && optiIdQuery !== '') {
        this.routeOptiIdLabel = optiIdQuery.toString();
        const optiId = Number(optiIdQuery);
        if (!isNaN(optiId) && optiId > 0) {
          this.waitingChargeOptiById = true;
          this.loadChargeOptiById.emit({ opti_id: optiId });
        } else {
          this.chargePiecesOpti();
        }
      } else {
        this.chargePiecesOpti();
      }
    } else if (this.paramChargeOpti === 'auto') {
      this.disableOefForVsBudgetDirectInput = false;
      this.startAutoBatchJob();
    } else {
      this.tryLoadVsBudgetDirectInput();
    }

    // -----------------------------

    this.inventoriesList = [];
    this.sku_mode = false;

    // Número de elementos por página de las tablas.
    this.itemsPerPage = 10;
    this.piecesItemsPerPage = 8;
    // Pagina inicial de las tablas.
    this.currentPage = 1;
    this.piecesCurrentPage = 1;

    // ------------

    // Se crean las subscripciones para el control de los campos del formulario.
    this.formValidator.subscribeFormGroup(this.fileForm);

  } // End function OnInit

  ngOnChanges(changes: SimpleChanges) {

    console.log('->-> Entrando en ngOnChanges de file-edit: ');
    console.log(changes);

    if (changes.pieceList) {
      console.log('--> ngOnChanges file-list pieceList:');

      // Si no es la primera vez que se ejecuta entonces se validan los selectores.
      // Esto evita un error inicial que se produciría al cargar la página debido
      // a que intentaría obtener los valores del formulario antes de estar creado.
      if (!changes.pieceList.isFirstChange()) {

        console.log('--> ngOnChanges file-list pieceList: NO es la primera vez.');
        console.log(changes.pieceList.currentValue);

        // Se recorre todos los elementos y se ponen a check=true
		// todos los ya añadidos a la optimización.
        if (this.autoBatchMode && this.autoBatchStage === 'loading_pieces') {
          this.runAutoBatchJobWithPieceList(changes.pieceList.currentValue);
        }
      }
    }

    if (changes.currentOpti) {
      if (this.autoBatchMode && this.autoBatchStage === 'saving' && !changes.currentOpti.isFirstChange()) {
        const optiCurrent = changes.currentOpti.currentValue;
        const optiId = optiCurrent && optiCurrent.id ? optiCurrent.id : null;
        const result = this.autoBatchPendingResult ? this.autoBatchPendingResult : this.buildAutoBatchResult(true, '', null);
        result.opti_id = optiId ? optiId : '-';
        this.autoBatchStage = 'generating_docs';
        this.emitAutoBatchHeartbeat('generating_docs', true);
        this.generateAutoBatchPdfSections(optiCurrent).then(pdfResult => {
          result.pdf_groups_section = pdfResult.groups;
          result.pdf_cutting_section = pdfResult.cutting;
          this.finishAutoBatchJob(true, '', result);
        }).catch(() => {
          this.finishAutoBatchJob(true, '', result);
        });
      }
    }

    if (changes.chargeOpti && this.waitingChargeOptiById && !changes.chargeOpti.isFirstChange()) {
      const piecesLoaded = changes.chargeOpti.currentValue && changes.chargeOpti.currentValue.length > 0;
      const sheetsLoaded = this.chargeSheetOpti && this.chargeSheetOpti.length > 0;
      if (piecesLoaded && sheetsLoaded) {
        this.waitingChargeOptiById = false;
        this.chargePiecesOpti();
      }
    }

    if (changes.chargeSheetOpti && this.waitingChargeOptiById && !changes.chargeSheetOpti.isFirstChange()) {
      const sheetsLoaded = changes.chargeSheetOpti.currentValue && changes.chargeSheetOpti.currentValue.length > 0;
      const piecesLoaded = this.chargeOpti && this.chargeOpti.length > 0;
      if (piecesLoaded && sheetsLoaded) {
        this.waitingChargeOptiById = false;
        this.chargePiecesOpti();
      }
    }

    if (changes.file) {
      console.log('--> ngOnChanges file-list file:');

      // Si no es la primera vez que se ejecuta entonces se validan los selectores.
      // Esto evita un error inicial que se produciría al cargar la página debido
      // a que intentaría obtener los valores del formulario antes de estar creado.
      if (!changes.file.isFirstChange()) {

        console.log('--> ngOnChanges file-list file: NO es la primera vez.');
        console.log(changes.file.currentValue);
      }
    }

    if (changes.infoList) {
      console.log('--> ngOnChanges file-list infoList:');
      console.log(changes.infoList.currentValue);

      if (!changes.infoList.isFirstChange()) {

        this.infoListAux = changes.infoList.currentValue;

        // Ordenamos el listado según la fecha de producción.
        this.infoListAux = fromSortableColumn.sortByColumn(this.infoListAux, 'ruta', 'desc', false);

        this.buttonFilterList();
      }
    }

    if (changes.parameters) {
      console.log('--> ngOnChanges file-list parameters:');
      console.log(changes.parameters.currentValue);

      // Buscamos los parámetros que necesitamos cargar con su valor por defecto.
      this.general_ancho_muela = this.findGeneralParameterByKeys(['ancho_muela']);
      this.general_solapamiento = this.findGeneralParameterByKeys(['solapamiento']);
      this.general_ruta_destino = this.findGeneralParameterByKeys(['ruta_destino']);
      this.general_retal_width = this.findGeneralParameterByKeys([
        'retal_min_width', 'retal_width_min', 'retal_width',
        'retal_ancho_minimo', 'retal_ancho_min', 'retal_ancho',
        'ancho_retal_minimo', 'ancho_retal_min', 'ancho_retal',
        'f_retal_width'
      ]);
      this.general_retal_height = this.findGeneralParameterByKeys([
        'retal_min_height', 'retal_height_min', 'retal_height',
        'retal_alto_minimo', 'retal_alto_min', 'retal_alto',
        'alto_retal_minimo', 'alto_retal_min', 'alto_retal',
        'f_retal_height'
      ]);

      // Se asigna el valor a los campos del formulario correspondiente.
      // En algunas cargas históricas ngOnChanges(parameters) puede dispararse antes de inicializar fileForm.
      if (this.fileForm && this.fileForm.controls) {
        if (this.general_ancho_muela) this.fileForm.controls.f_general_ancho_muela.setValue(this.general_ancho_muela.setup_value);
        if (this.general_solapamiento) this.fileForm.controls.f_general_solapamiento.setValue(this.general_solapamiento.setup_value);
        if (this.general_ruta_destino) this.fileForm.controls.f_general_ruta_destino.setValue(this.general_ruta_destino.setup_value6);
        this.applyGeneralRetalParameters();
      }

      // Se recopila toda la información de los directorios al iniciar la sección.
      // this.infoFileListAction();
    }

    if (changes.cuttingTables) {
      console.log('--> ngOnChanges file-list cuttingTables:');
      console.log(changes.cuttingTables.currentValue);

      if (this.autoBatchMode && this.autoBatchStage === 'loading_pieces' && this.autoBatchJob) {
        const currentTableId = Number(this.fileForm && this.fileForm.controls && this.fileForm.controls.f_cutting_table_id
          ? this.fileForm.controls.f_cutting_table_id.value
          : 0);
        if (!(currentTableId > 0)) {
          const resolvedTableId = this.mapAutoCuttingTableId(this.autoBatchJob);
          if (resolvedTableId && Number(resolvedTableId) > 0) {
            this.fileForm.controls.f_cutting_table_id.setValue(resolvedTableId);
          }
        }
      }

      // No pisar parámetros ya cargados (por ejemplo, al recuperar una optimización desde BD).
      // Si los campos están vacíos se rellenarán igualmente con maestros.
      // Excepción Auto Opti: durante el arranque sí queremos forzar el maestro
      // para que origen/desbandes de mesa prevalezcan sobre valores temporales del job.
      const preserveValues = !(this.autoBatchMode && this.autoBatchStage === 'loading_pieces');
      this.applySelectedCuttingTable(false, preserveValues);

      if (this.pendingChargeOptiAutoStart) {
        if (this.ensureCuttingTableResolvedForChargeOpti()) {
          this.pendingChargeOptiAutoStart = false;
          // Carga histórica: reproducir la optimización guardada con sus
          // parámetros persistidos (sin relanzar "Mejorar" ni re-seleccionar variantes).
          const persistedSnapshot = this.parseLayoutSnapshotFromCurrentOpti();
          const snapshotApplied = this.applyLayoutSnapshot(persistedSnapshot);
          if (!snapshotApplied) {
            this.buttonStartOptimization(false, this.pendingChargeOptiAutoStartBlock);
          } else {
            this.tryHistoricalPdfAutogen();
          }
          this.activateTab('tabGraphic');
          this.showOptiId = true;
        } else if (this.cuttingTables && this.cuttingTables.length > 0) {
          // Si ya hay mesas cargadas y aún no se pudo resolver, evitar bucle.
          this.pendingChargeOptiAutoStart = false;
        }
      }
    }

    if (changes.mesa_destino) {
      console.log('--> ngOnChanges file-list mesa_destino:');
      console.log(changes.mesa_destino.currentValue);

      if (!changes.mesa_destino.isFirstChange()) {

        // Se asigna el valor a los campos del formulario correspondiente.
        this.detailForm.controls.mesa_ancho_muela.setValue(changes.mesa_destino.currentValue.param2);
        this.detailForm.controls.mesa_solapamiento.setValue(changes.mesa_destino.currentValue.param3);
      }
    }

    if (changes.inventoriesList) {
		console.log('--> ngOnChanges inventoriesList:');
		console.log(changes.inventoriesList.currentValue);
	}

  } // End function ngOnChanges

  onCuttingTableChange(): void {
    this.applySelectedCuttingTable(true);
    this.ensureDefaultSheetFromSelectedCuttingTable();
  }

  private hasOptimizerFormsReady(): boolean {
    return !!(this.fileForm && this.fileForm.controls && this.detailForm && this.detailForm.controls);
  }

  applySelectedCuttingTable(showLog: boolean, preserveCurrentValues: boolean = false): void {
    if (!this.hasOptimizerFormsReady()) {
      return;
    }

    const selectedId = Number(this.fileForm.controls.f_cutting_table_id.value);
    if (!(selectedId > 0) || !this.cuttingTables || this.cuttingTables.length < 1) {
      this.mesa_destino = null;
      this.detailForm.controls.mesa_corte.setValue(null);
      return;
    }

    const selectedTable = this.cuttingTables.find(item => Number(item.id) === selectedId);
    if (!selectedTable) return;

    this.applyCuttingTableMasterData(selectedTable, showLog, preserveCurrentValues);
  }

  applyCuttingTableMasterData(tableIn: CuttingTable, showLog: boolean, preserveCurrentValues: boolean = false): void {
    if (!tableIn || !this.hasOptimizerFormsReady()) return;

    const masterData = this.parseCuttingTableMasterData(tableIn);

    this.mesa_destino = tableIn;
    this.detailForm.controls.mesa_corte.setValue(tableIn.name ? tableIn.name : null);

    if (this.shouldApplyCuttingTableValue('f_export', preserveCurrentValues)) {
      this.fileForm.controls.f_export.setValue(this.normalizeCncExportForProfile(masterData.cnc_family));
    }
    if (this.shouldApplyCuttingTableValue('f_origin', preserveCurrentValues)) {
      this.fileForm.controls.f_origin.setValue(String(masterData.origin));
    }
    if (this.shouldApplyCuttingTableValue('f_axis', preserveCurrentValues)) {
      this.fileForm.controls.f_axis.setValue(masterData.axis);
    }
    if (this.shouldApplyCuttingTableValue('f_level', preserveCurrentValues)) {
      this.fileForm.controls.f_level.setValue(masterData.level);
    }
    if (this.shouldApplyCuttingTableValue('f_max_diecutting', preserveCurrentValues)) {
      this.fileForm.controls.f_max_diecutting.setValue(masterData.max_diecutting);
    }
    if (this.shouldApplyCuttingTableValue('f_disband_l', preserveCurrentValues)) {
      this.fileForm.controls.f_disband_l.setValue(masterData.disband_l);
    }
    if (this.shouldApplyCuttingTableValue('f_disband_b', preserveCurrentValues)) {
      this.fileForm.controls.f_disband_b.setValue(masterData.disband_b);
    }
    if (this.shouldApplyCuttingTableValue('f_disband_r', preserveCurrentValues)) {
      this.fileForm.controls.f_disband_r.setValue(masterData.disband_r);
    }
    if (this.shouldApplyCuttingTableValue('f_disband_t', preserveCurrentValues)) {
      this.fileForm.controls.f_disband_t.setValue(masterData.disband_t);
    }

    if (showLog) {
      console.log('--> Mesa aplicada en optimizador:');
      console.log(tableIn);
      console.log(masterData);
    }
  }

  parseCuttingTableMasterData(tableIn: CuttingTable): any {
    const defaults = {
      cnc_family: 'V40',
      sheet_width: 6000,
      sheet_height: 3210,
      origin: 1,
      disband_l: 0,
      disband_b: 0,
      disband_r: 0,
      disband_t: 0,
      max_diecutting: 2500,
      level: 20,
      axis: 'X'
    };

    const parsed = this.parseCuttingTableParam4(tableIn ? tableIn.param4 : null);
    const descTxt = tableIn && tableIn.desc ? tableIn.desc.toString() : '';
    const pathTxt = tableIn && tableIn.path ? tableIn.path.toString() : '';

    const getNum = (objIn: any, keysIn: string[], fallbackIn: number): number => {
      if (objIn && typeof objIn === 'object') {
        const keyMap = {};
        Object.keys(objIn).forEach((k) => {
          keyMap[k.toLowerCase()] = objIn[k];
        });
        for (let i = 0; i < keysIn.length; i++) {
          const key = keysIn[i];
          const value = objIn[key] !== undefined ? objIn[key] : keyMap[key.toLowerCase()];
          if (value !== undefined && value !== null && value !== '') {
            const num = Number(value);
            if (!isNaN(num)) return num;
          }
        }
      }
      return fallbackIn;
    };

    const getTxt = (objIn: any, keysIn: string[], fallbackIn: string): string => {
      if (objIn && typeof objIn === 'object') {
        for (let i = 0; i < keysIn.length; i++) {
          const key = keysIn[i];
          if (objIn[key] !== undefined && objIn[key] !== null && objIn[key] !== '') {
            return String(objIn[key]);
          }
        }
      }
      return fallbackIn;
    };

    let cnc = getTxt(parsed, ['cnc_family', 'cnc', 'export', 'export_type'], '').toUpperCase();
    if (!cnc) {
      const descMatch = descTxt.match(/(?:CNC\s*)?(V40|LSW|LIOPT|OTD|BTR|ELO|TEC)/i);
      const pathMatch = pathTxt.match(/(V40|LSW|LIOPT|OTD|BTR|ELO|TEC)/i);
      if (descMatch && descMatch[1]) cnc = descMatch[1].toUpperCase();
      else if (pathMatch && pathMatch[1]) cnc = pathMatch[1].toUpperCase();
    }
    if (['V40', 'LSW', 'LIOPT', 'OTD', 'BTR', 'ELO', 'TEC'].indexOf(cnc) < 0) cnc = defaults.cnc_family;

    const originRaw = getNum(parsed, ['origin', 'f_origin'], Number(tableIn && tableIn.param1 ? tableIn.param1 : defaults.origin));
    const maxTravRaw = getNum(parsed, ['max_diecutting', 'maxtrav', 'max_trav', 'max_travera', 'f_max_diecutting'], Number(tableIn && tableIn.param2 ? tableIn.param2 : defaults.max_diecutting));
    const levelRaw = getNum(parsed, ['level', 'f_level'], Number(tableIn && tableIn.param3 ? tableIn.param3 : defaults.level));

    const widthRaw = getNum(parsed, ['sheet_width', 'width', 'ancho', 'f_width'], NaN);
    const heightRaw = getNum(parsed, ['sheet_height', 'height', 'alto', 'f_height'], NaN);
    const descSizeMatch = descTxt.match(/([0-9]{3,5})\s*[xX]\s*([0-9]{3,5})/);
    const descWidth = descSizeMatch && descSizeMatch[1] ? Number(descSizeMatch[1]) : NaN;
    const descHeight = descSizeMatch && descSizeMatch[2] ? Number(descSizeMatch[2]) : NaN;

    let finalWidth = !isNaN(widthRaw) && widthRaw > 0 ? widthRaw : defaults.sheet_width;
    let finalHeight = !isNaN(heightRaw) && heightRaw > 0 ? heightRaw : defaults.sheet_height;

    if (isNaN(widthRaw) && !isNaN(descWidth) && descWidth > 0) {
      finalWidth = descWidth;
    }
    if (isNaN(heightRaw) && !isNaN(descHeight) && descHeight > 0) {
      finalHeight = descHeight;
    }

    // Corrección para mesas legacy con altura no serializada en param4:
    // si el ancho coincide con el texto descriptivo pero el alto cae al valor por defecto,
    // tomamos el alto del texto "Ancho x Alto" de la descripción.
    if (
      !isNaN(descWidth) && !isNaN(descHeight) &&
      descWidth > 0 && descHeight > 0 &&
      finalWidth === descWidth &&
      finalHeight === defaults.sheet_height &&
      descHeight !== finalHeight
    ) {
      finalHeight = descHeight;
    }

    return {
      cnc_family: cnc,
      sheet_width: finalWidth,
      sheet_height: finalHeight,
      origin: originRaw >= 1 && originRaw <= 4 ? originRaw : defaults.origin,
      disband_l: getNum(parsed, ['disband_l', 'f_disband_l'], Number(tableIn && tableIn.disband_l !== undefined ? tableIn.disband_l : defaults.disband_l)),
      disband_b: getNum(parsed, ['disband_b', 'f_disband_b'], Number(tableIn && tableIn.disband_b !== undefined ? tableIn.disband_b : defaults.disband_b)),
      disband_r: getNum(parsed, ['disband_r', 'f_disband_r'], Number(tableIn && tableIn.disband_r !== undefined ? tableIn.disband_r : defaults.disband_r)),
      disband_t: getNum(parsed, ['disband_t', 'f_disband_t'], Number(tableIn && tableIn.disband_t !== undefined ? tableIn.disband_t : defaults.disband_t)),
      max_diecutting: maxTravRaw > 0 ? maxTravRaw : defaults.max_diecutting,
      level: levelRaw > 0 ? levelRaw : defaults.level,
      axis: getTxt(parsed, ['axis', 'f_axis'], defaults.axis).toUpperCase() === 'Y' ? 'Y' : 'X'
    };
  }

  shouldApplyCuttingTableValue(controlNameIn: string, preserveCurrentValues: boolean): boolean {
    if (!preserveCurrentValues) {
      return true;
    }

    if (!this.fileForm || !this.fileForm.controls || !this.fileForm.controls[controlNameIn]) {
      return true;
    }

    const currentValue = this.fileForm.controls[controlNameIn].value;
    return currentValue === undefined || currentValue === null || currentValue === '';
  }

  parseCuttingTableParam4(param4In: any): any {
    if (param4In === undefined || param4In === null) return null;
    if (typeof param4In === 'object') {
      return param4In.masterData && typeof param4In.masterData === 'object'
        ? param4In.masterData
        : param4In;
    }
    const txt = String(param4In).trim();
    if (txt === '') return null;

    const parseJsonSafe = (txtIn: string) => {
      try { return JSON.parse(txtIn); } catch (error) { return null; }
    };

    let parsed = parseJsonSafe(txt);
    if (parsed && typeof parsed === 'string') {
      const nested = parseJsonSafe(parsed);
      if (nested) parsed = nested;
    }
    if (parsed && typeof parsed === 'object') {
      return parsed.masterData && typeof parsed.masterData === 'object'
        ? parsed.masterData
        : parsed;
    }

    let txtAux = txt;
    if ((txtAux.startsWith('"') && txtAux.endsWith('"')) || (txtAux.startsWith("'") && txtAux.endsWith("'"))) {
      txtAux = txtAux.substring(1, txtAux.length - 1);
      txtAux = txtAux.replace(/\\"/g, '"');
      txtAux = txtAux.replace(/\\'/g, "'");
      const parsedWrapped = parseJsonSafe(txtAux);
      if (parsedWrapped && typeof parsedWrapped === 'object') {
        return parsedWrapped.masterData && typeof parsedWrapped.masterData === 'object'
          ? parsedWrapped.masterData
          : parsedWrapped;
      }
    }

    const firstBrace = txtAux.indexOf('{');
    const lastBrace = txtAux.lastIndexOf('}');
    if (firstBrace >= 0 && lastBrace > firstBrace) {
      const objTxt = txtAux.substring(firstBrace, lastBrace + 1);
      const parsedObj = parseJsonSafe(objTxt);
      if (parsedObj && typeof parsedObj === 'object') {
        return parsedObj.masterData && typeof parsedObj.masterData === 'object'
          ? parsedObj.masterData
          : parsedObj;
      }
    }

    const separators = txtAux.indexOf(';') >= 0 ? ';' : (txtAux.indexOf('|') >= 0 ? '|' : ',');
    const tokens = txtAux.split(separators).map((t) => t.trim()).filter((t) => t !== '');
    if (tokens.length < 2) return null;

    const out = {};
    tokens.forEach((token) => {
      const idx = token.indexOf('=');
      if (idx < 1) return;
      const key = token.substring(0, idx).trim().toLowerCase();
      const value = token.substring(idx + 1).trim();
      out[key] = value;
    });

    return Object.keys(out).length > 0 ? out : null;
  }

  private tryLoadVsBudgetDirectInput(): boolean {
    let transportRaw = '';
    let transportData = null;

    try {
      transportRaw = window && window.name ? window.name.toString() : '';
    } catch (error) {
      transportRaw = '';
    }

    if (!transportRaw || transportRaw.trim() === '') {
      return false;
    }

    try {
      transportData = JSON.parse(transportRaw);
    } catch (error) {
      return false;
    }

    if (!transportData || transportData.channel !== 'vs_budget_direct_input') {
      return false;
    }

    const payload = transportData.payload;
    if (!payload || payload.type !== 'piece_list_v1' || !Array.isArray(payload.items)) {
      return false;
    }

    const expectedEnv = payload && payload.meta && payload.meta.source_env !== undefined && payload.meta.source_env !== null
      ? payload.meta.source_env.toString().trim().toLowerCase()
      : '';
    const currentEnv = this.current_user_enviroment ? this.current_user_enviroment.toString().trim().toLowerCase() : '';

    if (expectedEnv !== '' && currentEnv !== '' && expectedEnv !== currentEnv) {
      this.alertInfo = 'La función de optimización de documentos no está disponible.<br>' +
        'El entorno activo en VS.cut (' + currentEnv + ') no coincide con el entorno de VS.budget (' + expectedEnv + ').<br>' +
        'Debe iniciar sesión en VS.cut con el entorno correcto para continuar.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      window.name = '';
      return false;
    }

    const parseNumber = (valueIn: any, defaultIn: number = 0): number => {
      const value = Number(valueIn);
      return isNaN(value) || !isFinite(value) ? defaultIn : value;
    };

    const mappedRows = payload.items.map((item, index) => {
      if (!item) {
        return null;
      }

      const width = parseNumber(item.width, 0);
      const height = parseNumber(item.height, 0);
      const units = parseNumber(item.units, 0);

      if (width <= 0 || height <= 0 || units <= 0) {
        return null;
      }

      return {
        id: null,
        priority: parseNumber(item.priority, 0),
        barcode: item.barcode !== undefined && item.barcode !== null ? item.barcode.toString() : null,
        orderno: parseNumber(item.orderno, 0),
        orderpos: parseNumber(item.orderpos, index + 1),
        reference: item.reference !== undefined && item.reference !== null ? item.reference.toString() : '',
        project_reference: item.project_reference !== undefined && item.project_reference !== null ? item.project_reference.toString() : '',
        figure: parseNumber(item.figure, 0),
        mat_id: parseNumber(item.mat_id, 0),
        mat_name: item.mat_name !== undefined && item.mat_name !== null ? item.mat_name.toString() : 'Material',
        mat_desc: item.mat_desc !== undefined && item.mat_desc !== null ? item.mat_desc.toString() : 'Material',
        stock_length: parseNumber(item.stock_length, this.default_depth),
        width: width,
        height: height,
        units: units,
        insertion_id: 0,
        steps: item.steps !== undefined && item.steps !== null ? item.steps.toString() : 'CORTE',
        date: new Date(),
        easel: parseNumber(item.easel, 0),
        packing: parseNumber(item.packing, 0),
        route: parseNumber(item.route, 0),
        group: item.group !== undefined && item.group !== null ? item.group.toString() : 'A',
        lot: parseNumber(item.lot, 1),
        sequence: parseNumber(item.sequence, index + 1),
        decoat: parseNumber(item.decoat, 0),
        id_line: parseNumber(item.id_line, parseNumber(item.orderpos, index + 1)),
        id_client: parseNumber(item.id_client, this.current_user_id),
        client: item.client !== undefined && item.client !== null ? item.client.toString() : this.current_user_name,
        l: parseNumber(item.l, 0),
        l1: parseNumber(item.l1, 0),
        l2: parseNumber(item.l2, 0),
        h: parseNumber(item.h, 0),
        h1: parseNumber(item.h1, 0),
        h2: parseNumber(item.h2, 0),
        r: parseNumber(item.r, 0),
        r2: parseNumber(item.r2, 0),
        r3: parseNumber(item.r3, 0),
        r4: parseNumber(item.r4, 0),
        b1: parseNumber(item.b1, 0),
        b2: parseNumber(item.b2, 0),
        b3: parseNumber(item.b3, 0),
        b4: parseNumber(item.b4, 0),
        num_of: parseNumber(item.num_of, 0),
        pos_of: parseNumber(item.pos_of, 0),
        paneno: parseNumber(item.paneno, 0),
        source_from_vs_budget_direct: true,
        check: true
      };
    }).filter(item => item !== null);

    if (!mappedRows || mappedRows.length === 0) {
      this.disableOefForVsBudgetDirectInput = false;
      return false;
    }

    this.optimizationList = mappedRows;
    this.disableOefForVsBudgetDirectInput = true;
    this.checkAllPieces = true;
    this.countSelectedPieces();
    this.activateTab('tabPiece');

    // Limpia el transporte para no volver a recargarlo en refrescos sucesivos.
    window.name = '';

    return true;
  }

  // -------------- PESTAÑAS

  activateTab(value: string) {

    console.log('*..> activateTab ejecutándose:');
    console.log(value);

    this.tabs.tabPiece = false;
    this.tabs.tabSheet = false;
    this.tabs.tabGraphic = false;
    this.tabs.tabFile = false;

    this.tabs[value] = true;

    if (value === 'tabGraphic') {
      this.graphic_container.style.display = 'block';
    } else {
      this.graphic_container.style.display = 'none';
    }

  } // End function activateTab

  // ---------- Fin PESTAÑAS

  // Función que hace que se desplieguen o se cierren todos los lotes de un elemento.
  clickLotes(idIn: string, arrayIn: any) {

    console.log('->> >> clickLotes:');
    // console.log(arrayIn);
    console.log(idIn);

    let target = document.getElementById(idIn);

    console.log('->> >> clickLotes target:');
    console.log(target);

    let slit_plus = target.innerHTML.split('+');
    let slit_minus = target.innerHTML.split('-');

    if (arrayIn.length > 1 && target.id.includes('lote_')) {

      if (slit_plus.length > 1) {
        console.log('->> >> clickLotes estaba cerrado con + y se va a abrir con -.');
        target.innerHTML = this.writeLotes(arrayIn) + this.minus;

      } else if (slit_minus.length > 1) {
        console.log('->> >> clickLotes estaba abierto con - y se va a cerrar con +.');
        target.innerHTML = arrayIn[0] + this.plus;
      }
    }
  } // End function clickLotes

  // Función que escribe el valor inicial que se debe mostrar en el campo "lotes" de cada fila.
  inicializeLotes(arraIn: any) {

    return arraIn.length > 1 ? arraIn[0] + this.plus : arraIn[0];
  } // End function inicializeLotes

  writeLotes(arrayIn: []): string {

    let result = '';

    arrayIn.forEach((element, index) => {
      if (index !== 0) {
        result += ' ' + element;
      } else {
        result += element;
      }
    });

    return result;
  } // End writeLotes

  onEntryListKeydown(event: KeyboardEvent, listTypeIn: 'piece' | 'sheet'): void {
    if (!event) return;

    const key = event.key ? event.key.toString() : '';
    const isPlusKey =
      key === '+' ||
      key === 'Add' ||
      key === 'NumpadAdd' ||
      event.code === 'NumpadAdd' ||
      (event.shiftKey && key === '=');

    if (!isPlusKey) return;

    event.preventDefault();
    event.stopPropagation();

    if (listTypeIn === 'sheet') {
      this.buttonAddSheet();
      return;
    }
    this.buttonAddPiece();
  }

  writeDimensions(arrayIn: [], comas: boolean): string {

    let arrayAux = [];
    let result = '';

    arrayIn.forEach(element => {
      arrayAux.push(element);
    });

    if (!comas) {
      arrayAux.forEach(dim => {
        result += dim.ancho + 'x' + dim.alto + '/' + dim.cantidad + 'ud. ';
      });
    } else {
      arrayAux.forEach((dim, i) => {
        if (i !== 0) {
          result += ' - ' + dim.ancho + 'x' + dim.alto + '/' + dim.cantidad + 'ud.';
        } else {
          result += dim.ancho + 'x' + dim.alto + '/' + dim.cantidad + 'ud.';
        }
      });
    }

    return result;
  } // End writeDimensions

  buttonEditFile(itemIn): void {
    console.log('->> >> buttonEditFile:');
    console.log(itemIn);

    this.selectedFile = itemIn;

    // Se vuelca a formulario del modal informativo los valores de la optimización seleccionada.
    this.detailForm.controls.id_vidrio.setValue(this.selectedFile['id_vidrio']);
    this.detailForm.controls.nombre_opti.setValue(this.selectedFile['nombre_opti']);
    this.detailForm.controls.desc_vidrio.setValue(this.selectedFile['desc_vidrio']);
    this.detailForm.controls.mesa_corte.setValue(this.selectedFile['mesa_corte']);
    this.detailForm.controls.fecha_produccion.setValue(this.selectedFile['fecha_produccion']);
    this.detailForm.controls.alto_hoja_restante.setValue(this.selectedFile['alto_hoja_restante']);
    this.detailForm.controls.ancho_hoja_restante.setValue(this.selectedFile['ancho_hoja_restante']);
    this.detailForm.controls.area_total_neta.setValue(this.selectedFile['area_total_neta']);
    this.detailForm.controls.cant_hojas.setValue(this.selectedFile['cant_hojas']);
    this.detailForm.controls.medidas.setValue(this.writeDimensions(this.selectedFile['medidas'][0], true));
    // this.detailForm.controls.ancho.setValue(this.selectedFile['medidas'][0][0].ancho);
    // this.detailForm.controls.alto.setValue(this.selectedFile['medidas'][0][0].alto);
    // this.detailForm.controls.cantidad.setValue(this.selectedFile['medidas'][0][0].cantidad);
    this.detailForm.controls.merma.setValue(this.selectedFile['merma']);
    this.detailForm.controls.tso.setValue(this.selectedFile['tso']);
    this.detailForm.controls.capa.setValue(this.selectedFile['capa']);
    this.detailForm.controls.formas.setValue(this.selectedFile['formas']);
    this.detailForm.controls.lotes.setValue(this.selectedFile['lotes']);
    this.detailForm.controls.grupo.setValue(this.selectedFile['grupo']);
    this.detailForm.controls.max_ancho_subtravera.setValue(this.selectedFile['max_ancho_subtravera']);
    this.detailForm.controls.min_ancho_subtravera.setValue(this.selectedFile['min_ancho_subtravera']);
    this.detailForm.controls.min_distancia_corte.setValue(this.selectedFile['min_distancia_corte']);
    // NOTA: El valor será al contraio aquí, es decir, si es cero se activa el checkbox.
    this.detailForm.controls.opti_sin_limites.setValue(!this.selectedFile['opti_sin_limites']);
    this.detailForm.controls.ruta.setValue(this.selectedFile['ruta']);
    this.detailForm.controls.trimcut_abajo.setValue(this.selectedFile['trimcut_abajo']);
    this.detailForm.controls.trimcut_arriba.setValue(this.selectedFile['trimcut_arriba']);
    this.detailForm.controls.trimcut_derecha.setValue(this.selectedFile['trimcut_derecha']);
    this.detailForm.controls.trimcut_izquierda.setValue(this.selectedFile['trimcut_izquierda']);

    console.log('--> Parámetros generales de entrada:');
    console.log(this.parameters)

    this.detailForm.controls.path.setValue(this.selectedFile['ruta']);

    this.mesa_destino = this.cuttingTables.find (item => {
      if (this.selectedFile['mesa_corte'] !== null && this.selectedFile['mesa_corte'] !== '' &&
          item.name.toUpperCase().indexOf(this.selectedFile['mesa_corte'].toUpperCase()) > -1) {
          console.log('->> >> Encontrada mesa de corte asociada:');
          console.log(item);

        return true;
      }
      return false;
    });

    // Si la antigua optimización tenía valor de "ancho muela" entonces se coge ese valor.
    // Si no se coge el valor de "ancho muela" de la mesa si lo tuviese.
    // Finalmente se cogería el valor general de "ancho muela" si no existiese ninguno de los anteriore.
    if (this.selectedFile['ancho_muela']) {
      this.detailForm.controls.ancho_muela.setValue(this.selectedFile['ancho_muela'] / 10);
    } else if (this.mesa_destino && this.mesa_destino.param2) {
      this.detailForm.controls.ancho_muela.setValue(Number(this.mesa_destino.param2) / 10);
    } else {
      this.detailForm.controls.ancho_muela.setValue(Number(this.general_ancho_muela.setup_value) / 10);
    }

    // Igual se hace para el "solapamiento".
    if (this.selectedFile['solapamiento']) {
      this.detailForm.controls.solapamiento.setValue(this.selectedFile['solapamiento'] / 10);
    } else if (this.mesa_destino && this.mesa_destino.param3) {
      this.detailForm.controls.ancho_muela.setValue(Number(this.mesa_destino.param3) / 10);
    } else {
      this.detailForm.controls.solapamiento.setValue(Number(this.general_solapamiento.setup_value) / 10);
    }

    this.showDetailFileModal(true);

  } // End function buttonEditFile

  buttonFilterList(): void {

    console.log('->> >> buttonFilterList:');

    if (this.fileForm) {

      console.log(this.fileForm.controls);

      let date_s = new Date(this.fileForm.controls.f_start_date.value);
      let date_e = new Date(this.fileForm.controls.f_end_date.value);
      // console.log(date_s);
      // console.log(date_e);

      // Hay que poner las horas a cero o las incluirá en la comparación y se obtendrá el resultado deseado.
      date_e.setHours(0, 0, 0, 0);
      date_s.setHours(0, 0, 0, 0);

      if (this.infoList && this.infoList.length > 0) {
        this.infoListAux = this.infoList.filter(item => {
          // console.log('- Item lista:');
          // console.log(item);

          if (item) {
            let date_aux = item.fecha_produccion.split('/');
            let date_item = new Date(+date_aux[2], date_aux[1] - 1, +date_aux[0]);

            // console.log(date_item);

            if (item.desc_vidrio.toUpperCase().indexOf(this.fileForm.controls.f_vidrio.value.toUpperCase()) > -1
                && (date_item >= date_s && date_item <= date_e)) {

              if (this.fileForm.controls.f_mesa_corte.value !== null && this.fileForm.controls.f_mesa_corte.value !== ''
                  && item.mesa_corte.toUpperCase().indexOf(this.fileForm.controls.f_mesa_corte.value.toUpperCase()) > -1) {
                // console.log('->> >> Coincidencia en el filtrado de mesa también.');
                return true;

              } else if (this.fileForm.controls.f_mesa_corte.value === null || this.fileForm.controls.f_mesa_corte.value === '') {
                return true;

              } else {
                // console.log('->> >> No hay coincidencia en el filtrado.');
                return false;
              }
            }

            return false;
          }

          return false;
        });
      } // End If infoList
    } // End If fileForm.controls
  } // End function buttonFilterList

  saveFileAction(): void {

    // NOTA: Se copian los cambios sobre el archivo inicial.
    const p = { ...this.file, ...this.fileForm.value };

    this.updateFile.emit(p);

  } // End function saveFileAction


  // Función que procesa las piezas leídas cuando se cargó el archivo de entrada de piezas.
  loadDataFile(): void {
    this.disableOefForVsBudgetDirectInput = false;

    console.log('->> >> loadDataFile getContentCSV:');
    // console.log(this.auxFunction.getContentCSV('piece'));

    let error_msg = '';

    // Primero se procesa el contenido leído en el fichero para comprobar que son datos válidos
    // y si es así transformarlos y calcular la información que va a necesitar el controlador.
    [this.optimizationList, error_msg ] = this.calculateGroupOptimization(this.auxFunction.getContentCSV('piece'));

	this.countSelectedPieces();

    console.log('->> >> loadDataFile optimizationList result:');
    console.log(this.optimizationList);

    // Si no se ha cargado bien el "fichero de corte" se advierte al usuario.
    if (!this.optimizationList || this.optimizationList.length === 0 || error_msg !== '') {

      this.alertInfo = error_msg + '\nSeleccione un archivo de carga con un formato correcto.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    }
  } // End function loadDataFile

  // Función que procesa las piezas leídas cuando se cargaron los multiples archivos de entrada a la vez.
  loadDataMultipleFile(): void {
    this.disableOefForVsBudgetDirectInput = false;

    console.log('->> >> loadDataMultipleFile getContentCSV:');
    // console.log(this.auxFunction.getContentCSV('piece'));

    let error_msg = '';

    // Primero se procesa el contenido leído en el fichero para comprobar que son datos válidos
    // y si es así transformarlos y calcular la información que va a necesitar el controlador.
    [this.optimizationList, error_msg ] = this.calculateGroupOptimization(this.auxFunction.getContentCSV('piece'));

	this.countSelectedPieces();

    console.log('->> >> loadDataMultipleFile optimizationList result:');
    console.log(this.optimizationList);

    // Si no se ha cargado bien el "fichero de corte" se advierte al usuario.
    if (!this.optimizationList || this.optimizationList.length === 0 || error_msg !== '') {

      this.alertInfo = error_msg + '\nSeleccione un archivo de carga con un formato correcto.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    } else {
      this.checkAllPieces = true;
    }

  } // End function loadDataMultipleFile

  // Función que procesa las hojas leídas cuando se cargó el archivo de entrada de hojas.
  loadSheetFile(): void {
    console.log('->> >> loadSheetFile getContentCSV:');
    console.log(this.auxFunction.getContentCSV('sheet'));

    this.sheetList_datafile = this.auxFunction.getContentCSV('sheet');

    let error_msg = '';

    let first_column = [
      { nombre: 'Material', campo: 'mat_id', tipo: 'texto' },
      { nombre: 'Nombre', campo: 'mat_name', tipo: 'texto' },
      { nombre: 'Descripcion', campo: 'mat_desc', tipo: 'texto' },
      { nombre: 'Retal', campo: 'retal', tipo: 'booleano' }, // NOTA: Es un booleano.
      { nombre: 'Codigo', campo: 'barcode', tipo: 'numero' },
      { nombre: 'Ancho', campo: 'width', tipo: 'numero' },
      { nombre: 'Alto', campo: 'height', tipo: 'numero' },
      { nombre: 'Espesor', campo: 'depth', tipo: 'numero' },
      { nombre: 'Peso', campo: 'weight', tipo: 'numero' },
      { nombre: 'Unidades', campo: 'unit', tipo: 'numero' },
      { nombre: 'Cara', campo: 'side', tipo: 'texto' },
      { nombre: 'Proceso', campo: 'id_process', tipo: 'texto' },
      { nombre: 'Almacen', campo: 'lager', tipo: 'texto' },
      { nombre: 'Ubicacion', campo: 'location', tipo: 'texto' },
      { nombre: 'Referencia', campo: 'reference', tipo: 'texto' },
      { nombre: 'DesbandeIzquierda', campo: 'disband_l', tipo: 'numero' },
      { nombre: 'DesbandeDerecha', campo: 'disband_r', tipo: 'numero' },
      { nombre: 'DesbandeArriba', campo: 'disband_t', tipo: 'numero' },
      { nombre: 'DesbandeAbajo', campo: 'disband_b', tipo: 'numero' },
      { nombre: 'Tronzado', campo: 'diecutting', tipo: 'numero' },
      { nombre: 'TronzadoMaximo', campo: 'max_diecutting', tipo: 'numero' },
      { nombre: 'RetalAncho', campo: 'retal_w', tipo: 'numero' },
      { nombre: 'RetalAlto', campo: 'retal_h', tipo: 'numero' },
      { nombre: 'Formato', campo: 'format', tipo: 'texto' }
    ];

    // console.log('--> Primera columna:');
    // console.log(first_column);


    let element_instance = new DataSheetInput();
    let error_msg_file = '';

    [this.sheetList_datafile, error_msg_file ] = this.auxFunction.validateFileFormat(first_column, this.sheetList_datafile, element_instance);

    console.log('->> >> loadSheetFile sheetList_datafile:');
    console.log(this.sheetList_datafile);
    console.log(this.sheetList_datafile.length);
    console.log('->> error_msg_file:');
    console.log(error_msg_file);

	this.totalSelectedSheets = 0;

	// Inicialmente todas las planchas estarán seleccionadas.
	this.selectAllSheets();

	this.countTotalSheets();

    this.checkAllSheets = true;

    // El ancho de la hoja más grande usada será colocado automáticamente como "max travera". La
	// hoja pudiera llevar un max_travera asociado en su información, pero no se tendría en cuenta.
	let max_trav_aux = this.calculateMaxTrav();

	this.fileForm.controls.f_max_diecutting.setValue(max_trav_aux);

    // Si no se ha cargado bien el "fichero de corte" se advierte al usuario.
    if (!this.sheetList_datafile || this.sheetList_datafile.length === 0 || error_msg_file !== '') {

      // Se vacían los datos que se hayan podido leer.
      this.sheetList_datafile = [];
      this.fileForm.controls.f_filesheetname.setValue(null);

      this.alertInfo = error_msg + '\nSeleccione un archivo de carga de planchas con un formato correcto.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    } else {

      // Se muestra el nombre del archivo seleccionado en el campo correspondiente del formulario.
      this.fileForm.controls.f_filesheetname.setValue(this.filesheetname);

      // Se actualizan en el formulario los valores de entrada de pudiesen ya venir especificados
      // en el fichero de carga (ancho y alto del retal, tronzado, desbande, etc.).

      if (this.sheetList_datafile[0]) {
        this.fileForm.controls.f_retal_width.setValue(this.sheetList_datafile[0].retal_w);
      	this.fileForm.controls.f_retal_height.setValue(this.sheetList_datafile[0].retal_h);

      	this.fileForm.controls.f_disband_l.setValue(this.sheetList_datafile[0].disband_l);
      	this.fileForm.controls.f_disband_b.setValue(this.sheetList_datafile[0].disband_b);
      	this.fileForm.controls.f_disband_r.setValue(this.sheetList_datafile[0].disband_r);
      	this.fileForm.controls.f_disband_t.setValue(this.sheetList_datafile[0].disband_t);

      	this.fileForm.controls.f_diecutting.setValue(this.sheetList_datafile[0].diecutting);

      	// NOTA: de momento los ficheros no contemplan estos campos, así que sólo
      	// actualizará en los casos que encontrara esos valores dentro de ellos.
      	if (this.sheetList_datafile[0].block)
      		this.fileForm.controls.f_blocks.setValue(this.sheetList_datafile[0].block);

      	if (this.sheetList_datafile[0].base)
      		this.fileForm.controls.f_base.setValue(this.sheetList_datafile[0].base);

      	if (this.sheetList_datafile[0].order)
      		this.fileForm.controls.f_order.setValue(this.sheetList_datafile[0].order ? true : false);

      	if (this.sheetList_datafile[0].resite)
      		this.fileForm.controls.f_old.setValue(this.sheetList_datafile[0].resite);

      	if (this.sheetList_datafile[0].level)
      		this.fileForm.controls.f_level.setValue(this.sheetList_datafile[0].level ? this.sheetList_datafile[0].level : 20);

      	if (this.sheetList_datafile[0].mode)
      		this.fileForm.controls.f_mode.setValue(this.sheetList_datafile[0].mode ? this.sheetList_datafile[0].mode : 1);

      	if (this.sheetList_datafile[0].free)
			this.fileForm.controls.f_free.setValue(this.sheetList_datafile[0].free ? this.sheetList_datafile[0].free : 0);

		if (this.sheetList_datafile[0].free_in)
			this.fileForm.controls.free_in.setValue(this.sheetList_datafile[0].free_in ? this.sheetList_datafile[0].free_in : 1);

      	if (this.sheetList_datafile[0].grade)
			this.fileForm.controls.f_grade.setValue(this.sheetList_datafile[0].grade ? this.sheetList_datafile[0].grade : 0);

		if (this.sheetList_datafile[0].grade_rep)
			this.fileForm.controls.f_grade_rep.setValue(this.sheetList_datafile[0].grade_rep ? this.sheetList_datafile[0].grade_rep : 999);

		if (this.sheetList_datafile[0].origin)
			this.fileForm.controls.f_origin.setValue(this.sheetList_datafile[0].origin ? this.sheetList_datafile[0].origin.toString() : '1');

		if (this.sheetList_datafile[0].axis)
			this.fileForm.controls.f_axis.setValue(this.sheetList_datafile[0].axis);

		if (this.sheetList_datafile[0].zoom)
			this.fileForm.controls.f_zoom.setValue(this.sheetList_datafile[0].zoom);

		if (this.sheetList_datafile[0].paths)
			this.fileForm.controls.f_rute.setValue(this.sheetList_datafile[0].paths);

		if (this.sheetList_datafile[0].resite)
			this.fileForm.controls.f_old.setValue(this.sheetList_datafile[0].resite);

		if (this.sheetList_datafile[0].color)
			this.fileForm.controls.f_fill_piece.setValue(this.sheetList_datafile[0].color);

		if (this.sheetList_datafile[0].cut_order)
			this.fileForm.controls.f_show_order.setValue(this.sheetList_datafile[0].cut_order);

      	if (this.sheetList_datafile[0].max_diecutting) {
      		this.fileForm.controls.f_max_diecutting.setValue(this.sheetList_datafile[0].max_diecutting);
      	} else {
          // Se coloca por defecto un máximo de travera de el 70% del ancho de la hoja.
          //this.fileForm.controls.f_max_diecutting.setValue(Math.trunc(this.max_travera * 0.70));
          // Se coloca el valor del ancho de la hoja más grande.
          // Se calcula cual es el ancho mayor de todas las hojas.
      	  let sh_max_width = this.getMaxSheetWidth();
          this.fileForm.controls.f_max_diecutting.setValue(sh_max_width);
        }

      	switch (this.sheetList_datafile[0].format) {
          case 'V40':
          case 'LSW':
          case 'LIOPT':
          case 'OTD':
          case 'BTR':
		  case 'ELO':

            this.fileForm.controls.f_export.setValue(
              this.normalizeCncExportForProfile(this.sheetList_datafile[0].format)
            );

            break;

          default:
          	this.fileForm.controls.f_export.setValue('V40');
        } // End switch

      } // End If sheetList_datafile

    }
  } // End function loadSheetFile

  // Función que calcula cual es el ancho mayor de todas las hojas.
  getMaxSheetWidth(): number {

	  // Se calcula cual es el ancho mayor de todas las hojas.
	  let sh_max_width = 0;

	  if (this.sheetList_datafile) {
			this.sheetList_datafile.forEach(sh => {
			if (sh_max_width < sh.width) sh_max_width = sh.width;
		  });
	  }

	  return sh_max_width;
  } // End function getMaxSheetWidth.

  optimizerFileAction(download: boolean): void {

    // Primero se multiplica el valor del ancho de muela y del solapamiento por 10 (para que realmente sean milímetros).
    this.detailForm.controls.ancho_muela.setValue(this.detailForm.controls.ancho_muela.value * 10);
    this.detailForm.controls.solapamiento.setValue(this.detailForm.controls.solapamiento.value * 10);

    // Se indica si se va a querer descargar o no el archivo.
    this.detailForm.controls.download.setValue(download);

    // Se copian los cambios del formulario sobre el archivo inicial.

    const p = { ...this.selectedFile, ...this.detailForm.value };

    this.optimizerFile.emit(p);

    // Volvemos a dividir por 10 los valores de los campos de ancho de muela y solapamiento
    // para que tengan el valor correcto y puedan ser visibles en el selector correspondiente.
    this.detailForm.controls.ancho_muela.setValue(this.detailForm.controls.ancho_muela.value / 10);
    this.detailForm.controls.solapamiento.setValue(this.detailForm.controls.solapamiento.value / 10);

    // Nos aseguramos de volver a poner el campo de "forzado" a falso.
    this.fileForm.controls.f_force.setValue(false);

    // Se tiene que volver a rehacer la lista de directorios para reflejar los posibles cambios.
    this.infoFileListAction();

  } // End function optimizerFileAction

  infoFileListAction(): void {

    const p = { ...this.file, ...this.fileForm.value };

    this.infoFileList.emit(p);

    // Nos aseguramos de volver a poner el campo de "forzado" a falso.
    this.fileForm.controls.f_force.setValue(false);

  } // End function infoFileListAction

  buttonRecharge(): void {
    console.log('->> >> buttonRecharge:');

    // Poner el campo de "forzado" a true para forzar a que se vuelvan a reescribir todos las optimizaciones.
    this.fileForm.controls.f_force.setValue(true);

    this.infoFileListAction();

  } // End function infoFileListAction

  buttonCopyToTable() {

    console.log('->> >> buttonCopyToTable:');

    this.showActionModal(true);

    this.showDetailFileModal(false);

  } // End function buttonCopyToTable

  // Función que selecciona o deselecciona todas las piezas o planchas
  // según el valor del parámetro de entrada indique.
  changeAllCheck(event: any, tabIn: string) {

    console.log('->> changeAllCheck event:');
    console.log(event.target.checked);

    let value = event.target.checked;

    if (tabIn === 'tabPiece') {
      this.checkAllPieces = value; // !this.checkAllPieces;

      console.log('-> changeAllCheck Piece pulsado:');
      console.log(this.checkAllPieces);

	  this.totalSelectedPieces = 0;

      this.optimizationList.forEach(dt => {
        if (this.checkAllPieces) {
          dt['check'] = true;
          // Contamos las unidades de piezas seleccionadas.
      	  this.totalSelectedPieces += this.getSelectedPieceUnits(dt);
        } else {
          dt['check'] = false;
        }
      });
    } else if (tabIn === 'tabSheet') {
      this.checkAllSheets = value;

      console.log('-> changeAllCheck Sheet pulsado:');
      console.log(this.checkAllSheets);

      this.totalSelectedSheets = 0;

	  let infinite = false;

      this.sheetList_datafile.forEach((st, index) => {
        if (this.checkAllSheets) {
          st['check'] = true;
          // Contamos las unidades de hojas seleccionadas.
      	  this.totalSelectedSheets += st['unit'];

      	  if (st['unit'] === -1) infinite = true;
        } else {
          st['check'] = false;
        }
      });
      // Con que exista una plancha con infinitas unidades se
      //  mostrará el total también como infinito.
      if (infinite) this.totalSelectedSheets = -1;
    }
  } // End function changeAllCheck

  changeCheck(itemIn: any) {

    console.log('-> itemIn pulsado:');
    console.log(itemIn);

    if (itemIn['check']) {
      itemIn['check'] = false;
      this.totalSelectedPieces -= this.getSelectedPieceUnits(itemIn);
    } else {
      itemIn['check'] = true;
      this.totalSelectedPieces += this.getSelectedPieceUnits(itemIn);
    }
  } // End function changeCheck

  changeSheetCheck(itemIn: any) {

    console.log('-> changeSheetCheck itemIn pulsado:');
    console.log(itemIn);

    if (itemIn['check']) {
      itemIn['check'] = false;
      this.totalSelectedSheets -= itemIn['unit'];
    } else {
      itemIn['check'] = true;
      this.totalSelectedSheets += itemIn['unit'];
    }

    // El ancho de la hoja más grande usada será colocado automáticamente como "max travera".
	let max_trav_aux = this.calculateMaxTrav();

	this.fileForm.controls.f_max_diecutting.setValue(max_trav_aux);

  } // End function changeSheetCheck

  // Función que modifica el valor del nombre del último archivo exportado.
  buttonSetExportedFileName(valueIn: any) {

	console.log('->> >> buttonSetExportedFileName: ' + valueIn);

	this.setExportedFileName.emit(null);

  } // End function buttonSetExportedFileName.

  // Función que lanza la optimización y la representa gráficamente.
  async buttonStartOptimization(saveIn: boolean, blockIn: boolean) {

    if (!this.validateCuttingTableSelection()) {
      if (this.autoBatchMode) {
        this.finishAutoBatchJob(false, this.alertInfo);
      }
      return;
    }

    // Se coloca el icono de carga para blequear la aplicación mientras se hace la optimización.
    this.changingLoading.emit(true);
    this.resetOptimizationCancelState();
    this.usingPersistedLayoutSnapshot = false;
    this.persistedLayoutSnapshotMeta = null;

    // let that = this;

    console.log('->> >> buttonStartOptimization: ' + saveIn);

    // Se inicializan las planchas iniciales.
    this.opti.sheetList = [];
    this.opti.nextSheet = null;

    // Se inicializa el listado de piezas.
    this.opti.pieceInfoList = [];

    // Se inicializan los listados de traveras.
    this.opti.traverseList = [];
    this.opti.oldTraverseList = [];

    // Mantener visible el ID sólo si seguimos en contexto de optimización guardada.
    // Si previamente se marcó como simulación de prueba (showOptiId=false),
    // no volver a activarlo automáticamente aquí.
    const hasStoredOptiId = !!(
      (this.currentOpti && this.currentOpti.id !== undefined && this.currentOpti.id !== null && this.currentOpti.id !== '') ||
      (this.routeOptiIdLabel && this.routeOptiIdLabel !== '')
    );
    this.showOptiId = this.showOptiId && hasStoredOptiId;

    const optimizationSourceList = (this.oefRuntimeOptimizationList && this.oefRuntimeOptimizationList.length > 0)
      ? this.oefRuntimeOptimizationList
      : this.optimizationList;
    this.opti.useSharedStripLookahead = (optimizationSourceList || [])
      .some(item => item && item.packing_shared_strip_lookahead === true);
    this.opti.sharedStripAlignmentTarget = null;
    this.opti.useRemainderConsolidation = true;
    const oefSourceSummary = (optimizationSourceList || []).filter(it => it && it.check === true).map(it => ({
      id: it.id,
      units: Number(it.units),
      width: Number(it.width),
      height: Number(it.height),
      figure: Number(
        (it.figure !== undefined && it.figure !== null)
          ? it.figure
          : it.piece_figure_input
      ),
      oef: !!(it.oef_generated === true || (Array.isArray(it.oef_internal_polygons) && it.oef_internal_polygons.length > 0)),
      oef_polygons: Array.isArray(it.oef_internal_polygons) ? it.oef_internal_polygons.length : 0
    }));
    console.log('[OEF simulate] source summary:', JSON.stringify(oefSourceSummary));

    if (!optimizationSourceList || optimizationSourceList.length === 0) {
      console.log('->> >> No hay datos que optimizar cargados.');

      this.alertInfo = 'No hay datos cargados para optimizar.\nSeleccione un archivo de carga con un formato correcto.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      // Se sale de la función cerrando antes la ventana de carga para que no blequee la aplicación.
      this.changingLoading.emit(false);
      if (this.autoBatchMode) {
        this.finishAutoBatchJob(false, this.alertInfo);
      }
      return;
    }

    // Sólo se pasan las planchas que estén seleccionadas en el formulario.
    let sheetList_aux = [];

    this.sheetList_datafile.forEach((pl, index) => {
      // console.log('- Plancha dataInput: ');
      // console.log(pl);
      if (pl['check'] === true) {
		pl['list_order'] = (index + 1);
        // console.log('->> Plancha seleccionada añadida: ' + pl.id);
        sheetList_aux.push(pl);
      }
    });

    // Para cargar la pila de planchas de prueba usando una función fija como "lista inicial de hojas disponibles".
    this.initialSheetList = this.opti.createSheetList(sheetList_aux);

	    if (!this.initialSheetList || this.initialSheetList.length === 0) {
      console.log('->> >> No hay cargada ninguna lista de hojas de entrada.');

      this.alertInfo = 'No hay unidades de planchas de entrada.' +
      				   '\nIntroduzca un valor superior a cero o el valor -1 para tener unidades infinitas.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      let result_modal = await this.changeChargeModal(false);

	      if (this.autoBatchMode) {
	        this.finishAutoBatchJob(false, this.alertInfo);
	      }
	      return;
	    }

    // Sólo se pasan las piezas que estén seleccionadas en el formulario.
    // También se quitan las que sobrepasen el ancho máximo de travera especificado.
    let optimizationList_aux = [];
    let no_optimizationList_aux = [];
    let no_by_too_long = [];
    let no_by_dimension = [];

	this.max_traverse_ok = false;
	this.null_dimension_piece = false;
	this.too_long_piece = false;
	this.lot_sequence_rep = false;

	let pieces_check = 0;

	let dimension_check = [];

	// Se opera sólo con las piezas seleccionadas en ese momento.
	// NOTA: No se pueden dejar líneas idénticas, en tal caso
	// habría que agruparlas en una y sumar sus cantidades.
    optimizationSourceList.forEach((ps, index) => {
      // console.log('- Pieza dataInput: ');
      // console.log(ps);
      if (ps['check'] === true) {

		if (ps.height < 1 || ps.width < 1) {
			console.log('->> Pieza no añadida por dimensiones 0: ' + ps.id);
			this.null_dimension_piece = true;
          	no_by_dimension.push(ps);
          	this.alertInfo = '<p>No se ha podido realizar la optimización.</p>';

		} else if (ps.height > this.opti.max_sheet_width || ps.width > this.opti.max_sheet_width) {
			console.log('->> Pieza no añadida por largo superior al de las hojas usadas: ' + ps.id);
			this.too_long_piece = true;
          	no_by_too_long.push(ps);
          	this.alertInfo = '<p>No se ha podido realizar la optimización.</p>';

		} else if (Number(this.fileForm.controls.f_max_diecutting.value) >= ps.height || Number(this.fileForm.controls.f_max_diecutting.value) >= ps.width) {
        	// console.log('->> Pieza seleccionada añadida: ' + ps.id);
        	ps['list_order'] = (index + 1);
        	optimizationList_aux.push(ps);
        	pieces_check += this.getSelectedPieceUnits(ps);
        	this.alertInfo = '<p>No se ha podido realizar la optimización.</p>';

        } else {
          console.log('->> Pieza seleccionada NO añadida por sobrepasar el ancho máximo de travera: ' + ps.id);
          this.max_traverse_ok = true;
          no_optimizationList_aux.push(ps);
        }

        let l_max = ps.width;
        let l_min = ps.height;

        if (ps.width < ps.height) {
			l_min = ps.width;
			l_max = ps.height;
		}

        if (this.isOefCompositeItem(ps)) {
          // En OEF compuesto es normal mezclar dimensiones bajo mismo lote/secuencia.
        } else if (!dimension_check['ls_' + ps.lot + ps.sequence]) {
        	dimension_check['ls_' + ps.lot + ps.sequence] = { w: l_min, h: l_max };
        } else if (dimension_check['ls_' + ps.lot + ps.sequence].w !== l_min ||
			dimension_check['ls_' + ps.lot + ps.sequence].h !== l_max) {

			console.log('-> Encontrada pieza con lote y secuencia similar a otra:');
			console.log(ps);
			console.log(dimension_check);

			this.lot_sequence_rep = true;

		} // End Else dimension_check.
      } // End If check.
    }); // End ForEach optimizationList.

    if (this.max_traverse_ok) {
	    this.alertInfo += '<p>&nbsp;</p><p>Estas piezas sobrepasan el ancho máximo de travera:</p>';
	    // Enumeramos las piezas no incluidas.
	    no_optimizationList_aux.forEach((nps, index) => {
			// console.log('- Pieza no incluida: ');
      		// console.log(nps);
			this.alertInfo +=  '<p>   · ' + nps.units +	' uds -> ' + nps.mat_name + ' - ' + nps.width + ' x ' + nps.height + '</p>';
		});
	}

	if (this.null_dimension_piece) {
	    this.alertInfo += '<p>&nbsp;</p><p>Estas piezas tienen dimensiones nulas:</p>';
	    // Enumeramos las piezas no incluidas.
	    no_by_dimension.forEach((nps, index) => {
			// console.log('- Pieza no incluida: ');
      		// console.log(nps);
			this.alertInfo +=  '<p>   · ' + nps.units +	' uds -> ' + nps.mat_name + ' - ' + nps.width + ' x ' + nps.height + '</p>';
		});
	}

	if (this.too_long_piece) {
	    this.alertInfo += '<p>&nbsp;</p><p>Estas piezas tienen dimensiones mayores que la plancha:</p>';
	    // Enumeramos las piezas no incluidas.
	    no_by_too_long.forEach((nps, index) => {
			// console.log('- Pieza no incluida: ');
      		// console.log(nps);
			this.alertInfo +=  '<p>   · ' + nps.units +	' uds -> ' + nps.mat_name + ' - ' + nps.width + ' x ' + nps.height + '</p>';
		});
	}

	if (this.lot_sequence_rep) {
	    this.alertInfo += '<p>&nbsp;</p><p> Encontrada pieza con lote y secuencia similar a otra pieza que tiene diferentes dimensiones.</p>';
		this.alertInfo += '<p> · Debe solventar este problema para poder continuar correctamente con la optimización.</p>';
	}

	// Línea para el chequeo de todas las comprobaciones cruciales.
	// Si alguna falla se detiene la optimización.
	if (this.max_traverse_ok || this.too_long_piece || this.null_dimension_piece || this.lot_sequence_rep) {

		this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

	    // Se sale de la función para cancelar la optimización cerrando
		// antes la ventana de carga para que no blequee la aplicación.
        this.changingLoading.emit(false);
        if (this.autoBatchMode) {
          this.finishAutoBatchJob(false, this.alertInfo);
        }
	    return;
	}

	// -------------------------------
	// “Modo Optimización 1: máximo rendimiento 2D con clasificación manual de vidrios”
	// “Modo Optimización 2: óptimo rendimiento 2D con clasificación automática de vidrios”.
	// “Modo Optimización 3: mínimo rendimiento 2D con clasificación mejorada de vidrios.”.

	// Antes de pasar las piezas hay que agrupar las líneas que sean iguales y dajar sólo
	// una que tenga el total de unidades de todas ellas sumadas.
	// NOTA: Si no se hace así puede que a la hora de sacar la ordenación de salida
	// para los caballetes se cuelen secuencias de piezas mal entre medias de un apilo.

	let final_optimizationList = [];

		optimizationList_aux.forEach((ps, index) => {
	      const psMergeKey = this.buildOefMergeKey(ps);
	      const psStdMergeKey = this.buildStandardPieceMergeKey(ps);
	      const psIsOef = this.isOefCompositeItem(ps);

			let find_ps = final_optimizationList.find(px =>
	      !psIsOef &&
	      !this.isOefCompositeItem(px) &&
				px.lot === ps.lot &&
				px.sequence === ps.sequence &&
	            this.buildStandardPieceMergeKey(px) === psStdMergeKey &&
	            this.buildOefMergeKey(px) === psMergeKey &&
			// Number(px.mat_id) === Number(ps.mat_id) &&
			// px.orderpos === ps.orderpos &&
			// ((px.width === ps.width && px.height === ps.height) ||
			//  (px.width === ps.height && px.height === ps.width))
			// Hay que separar por paneno para que distinga
			// el orden de los vídrios de una misma ventana.
			// NOTA: el problema es que al aparecer secuencias repetidas podrá
			// colarse piezas mal entre las secuencias colocadas dentro de un caballete.
			px.paneno === ps.paneno);

		if (!find_ps) {

			// Se añade los "detalles" de optimización para la pieza.
			final_optimizationList.push(JSON.parse(JSON.stringify(ps)));

		} else {

			// console.log('-> Pieza ya existente:');
			// console.log(ps);

			// Sólo sumamos más unidades a los "detalles de pieza" ya existentes.
				find_ps.units += Number(ps.units);
			}
		});

	// console.log('-> Lista pestaña piezas -> final_optimizationList:');
	// console.log(final_optimizationList);	// */
	final_optimizationList = this.orderOefRowsByLayoutPriority(final_optimizationList);

    console.log('->> buttonStartOptimization Optimizando en MODO 1, 2, 3...');
    [this.opti.groupInfoList, this.opti.pieceInfoList] = this.pieceToEasel(final_optimizationList, this.easelList, Number(this.fileForm.controls.f_mode.value), this.fileForm.controls.f_base.value);

    // Se inicializan las piezas candidatas.
    this.opti.nextPiece = [];

    // Se pone a false la bandera de fin de piezas.
    this.opti.end_pieces = false;

    // Se inicializan los contadores.
    this.opti.traverse_count = 0;

    // Se pone a cero el número total de piezas para la optimización.
    this.totalPieces = 0;

    // console.log('->> Hoja actual:');
    // console.log(this.opti.nextSheet);

    let sheet_actual_w = this.opti.nextSheet.width;
    let sheet_actual_h = this.opti.nextSheet.height;

    // NOTA: Se empieza la optimización indicando los sigu¡entes parámetros:
    // 1 - La hoja/plancha por la que se va a empezar.
    // 2 - Uno de los tres tipos de "eje de travera" permitidos (X, Y , XY). Según el elegido variará el resultado final.
    // 3 - La distancia de "desbande".
    // 4 - La distancia mínima necedaria para destroquelar.

    let aux_disband_l = 0;
    let aux_disband_b = 0;
    let aux_disband_r = 0;
    let aux_disband_t = 0;

    if (this.fileForm.controls.f_disband_l.value) {
      aux_disband_l = this.fileForm.controls.f_disband_l.value;
    } else {
      this.fileForm.controls.f_disband_l.setValue(0);
    }

    if (this.fileForm.controls.f_disband_b.value) {
      aux_disband_b = this.fileForm.controls.f_disband_b.value;
    } else {
      this.fileForm.controls.f_disband_b.setValue(0);
    }

    if (this.fileForm.controls.f_disband_r.value) {
      aux_disband_r = this.fileForm.controls.f_disband_r.value;
    } else {
      this.fileForm.controls.f_disband_r.setValue(0);
    }

    if (this.fileForm.controls.f_disband_t.value) {
      aux_disband_t = this.fileForm.controls.f_disband_t.value;
    } else {
      this.fileForm.controls.f_disband_t.setValue(0);
    }

    this.disband = {
      left: aux_disband_l, // this.fileForm.controls.f_disband_l.value,
      bottom: aux_disband_b, // this.fileForm.controls.f_disband_b.value,
      right: aux_disband_r, // this.fileForm.controls.f_disband_r.value,
      top: aux_disband_t // this.fileForm.controls.f_disband_t.value,
    }

    let sheet_area = 0;

    if (this.opti.nextSheet) sheet_area = (sheet_actual_w * sheet_actual_h) / 1000000;

	console.log(' -> Area de la hoja actual = ' + sheet_area);
	console.log();

	if (this.one_sheet) {

		// ------------ MEJORES OPCIONES DE HOJA
		this.opti.addOneSheetTraverse(
	      this.opti.nextSheet,
	      this.fileForm.controls.f_axis.value,
	      this.disband,
	      this.fileForm.controls.f_diecutting.value,
	      this.fileForm.controls.f_max_diecutting.value,
	      this.fileForm.controls.f_old.value,
	      blockIn // this.fileForm.controls.f_blocks.value
	    );

	    this.opti.pieceListMultiple = this.opti.getMultiplePieceList(this.opti.pieceInfoList, sheet_area, 3);

		console.log(' -> pieceListMultiple = ');
		console.log(this.opti.pieceListMultiple);

	} else {
		this.opti.addSheetTraverse(
	      this.opti.nextSheet,
	      this.fileForm.controls.f_axis.value,
	      this.disband,
	      this.fileForm.controls.f_diecutting.value,
	      this.fileForm.controls.f_max_diecutting.value,
	      this.fileForm.controls.f_old.value,
	      blockIn // this.fileForm.controls.f_blocks.value
	    );
	}

	// ------------ BLOQUES
	// Incorporar el uso de bloques si procede.
	// if (blockIn && this.fileForm.controls.f_export.value !== 'V40') { // this.fileForm.controls.f_blocks.value) {
	if (blockIn) {

		console.log('->> buttonStartOptimization: se va a usar el método por BLOQUES.');
		console.log('->> Número de piezas para optimizar = ' + pieces_check);

		// Primero se hacen conjuntos de piezas iguales para crear "marcos internos".
		// Para ello transforma la lista de entrada de piezas "pieceInfoList" de forma
		// que deja las "piezas marco" únicas y dentro en su campo "piece_set" el listado
		// de las piezas similares a la del marco (la pieza marco no se incluye aquí dentro).
		//if (pieces_check <= 1000)
			this.opti.groupSimilarPieces(this.opti.pieceInfoList);
	}
	// ------------ Fin Bloques

    console.log('->> buttonStartOptimization: groupInfoList información final listado caballetes.');
    // console.log(this.opti.groupInfoList)

    console.log('->> buttonStartOptimization: pieceInfoList.');
    // console.log(this.opti.pieceInfoList);

    console.log('->> buttonStartOptimization: lanzando bucleWhile...');

    // this.calculateSequence(this.local_pieceToEaselList, this.opti.nextSheet);

    // ------------

    // Obtenemos la pieza con el lado más grande y la pieza
	// con el lado mmás pequeño de la optimización (carácter informativo).
    [this.opti.min_side,
     this.opti.max_side,
     this.opti.piece_min_side,
     this.opti.piece_max_side,
     this.opti.min_area,
     this.opti.max_area,
     this.opti.piece_min,
     this.opti.piece_max] = this.pieceMinMax();

    // ------------

    // IMPORTANTE: Hay que dar tiempo a que se visualice el "icono de cargando..." antes de
    // lanzar el bucle "while" que va a paralizar el avance del código y causaría que no se viera.
    let auxaux = await this.myAsyncFunction();

	    let total_graphicList = [];
		const applySheetOrder = !!this.fileForm.controls.f_order.value;
    const hasOefRowsForOrdering = (Array.isArray(optimizationSourceList) ? optimizationSourceList : [])
      .some(item => this.isOefCompositeItem(item));

		let better_opti = false;

	let one_sheet_results = [];

	let one_sheet_count = 0;

    while (!better_opti) {
      if (this.isOptimizationCancellationRequested()) {
        this.alertInfo = 'Optimización cancelada por el usuario.';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'info'});
        this.changingLoading.emit(false);
        return;
      }

		// Variable que indicará las iteraciones producidas del bucle al terminar.
		let bucle_result = null;

	    if (this.one_sheet) {
			console.log('->> buttonStartOptimization: ONE SHEET...' + one_sheet_count);
			// Se cortan piezas hasta llenar una única hoja (la vigente actual).
	    	bucle_result = await this.bucleWhileOneSheet(one_sheet_count, this.fileForm.controls.f_max_diecutting.value, true);
	    } else {
			console.log('->> buttonStartOptimization: TOTAL SHEETS...');
			// Se cortan piezas hasta terminar todas las posibles o quedarse sin planchas.
			bucle_result = await this.bucleWhile(this.fileForm.controls.f_max_diecutting.value, true);
		}

	    console.log('->> buttonStartOptimization: se ha salido del bucleWhile. bucle_result = ');
	    console.log(bucle_result);
      if (this.isOptimizationCancellationRequested()) {
        this.alertInfo = 'Optimización cancelada por el usuario.';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'info'});
        this.changingLoading.emit(false);
        return;
      }
	    /*
	    // NUEVO: Tratar la última travera X principal para intentar mejorarla.
		this.opti.modifyLastXTraverse(this.fileForm.controls.f_max_diecutting.value);

		let count_while = 0;

		let exit = false;

		let promese_traverse_exist = null;

		let level_aux = Number(this.fileForm.controls.f_level.value);

	  	if (this.fileForm.controls.f_axis.value === 'Y') level_aux++;

	  	console.log('-> nextPiece EXTRA:');
	  	console.log(this.opti.nextPiece);

		while (count_while === 0 ||
	      (this.opti.nextPiece &&
	      this.opti.nextPiece.length > 0 &&
	      // !this.opti.end_pieces && // NOTA: Si no se quisiera dibujar las traveras de las hojas no usadas.
	      !exit && count_while < this.max_bucle_count)) {

	      count_while++;

	      console.log('-> bucle EXTRA:' + count_while);
	  	  console.log(this.opti.nextPiece[0]);

		  // Las promesa devuelve "true" cuando ya no quedan planchas que colocar en la máquina por lo que
	      // lo usamos como indicativo para salir del bucle de piezas ya que no se van a poder colocar.
	      promese_traverse_exist = await this.opti.cutPieceInTraverse(
	        this.fileForm.controls.f_axis.value,
	        this.fileForm.controls.f_diecutting.value, // this.diecutting,
	        this.fileForm.controls.f_max_diecutting.value,
	        this.fileForm.controls.f_set.value, // this.set,
	        this.fileForm.controls.f_rot.value, // this.rotate,
	        this.fileForm.controls.f_turn.value, //this.turn,
	        this.fileForm.controls.f_near.value, // this.near
	        this.fileForm.controls.f_retal_width.value,
	        this.fileForm.controls.f_retal_height.value,
	        this.fileForm.controls.f_export.value,
	        level_aux
	      ).then(async function(extra_cut) {

	        console.log('->> modifyLastXTraverse result => ');
	        console.log(extra_cut);

	        return extra_cut;
	      });

	      // Si no hay travera para la pieza se sale.
	      if (!promese_traverse_exist) {

	        console.log('->> No se continúa con la optimización EXTRA. Ya no existen traveras que poder usar.');
	        exit = true;

	        break;
	      }
		} // End while nextPiece. // */

	    // Dibujamos los gráficos resultantes de cada hoja usada en un mismo canvas.
	    // let graphicList = this.opti.drawGraphics(this.fileForm.controls.f_origin.value);

		// Creamos "traveras X principales" que puedan reducir los niveles de corte
		// para que facilite la normativa de estructura de LISEC.
		// if (this.fileForm.controls.f_export.value === 'LSW')
		this.opti.createTraverseX();

		// Se ordenan aquí las hojas según las secuencias de las piezas que contienene.
		if (applySheetOrder && !hasOefRowsForOrdering) {
			this.opti.sheetList = this.opti.orderSheetsBySequence(this.opti.sheetList, false);
		}

	    // Dibujamos cada hoja en un canvas diferente.
	    total_graphicList = this.opti.drawGraphicsBySheet(Number(this.fileForm.controls.f_origin.value), this.fileForm.controls.f_export.value);
	    this.mergeOefCentralFreeRectangles(total_graphicList);

		if (this.one_sheet) {

			// Se añade resultado de la hoja única.
			one_sheet_results.push(bucle_result);

			one_sheet_count++;

			// Se finalizan las iteraciones de hojas únicas cuando
			// se supera el máximo de resultados que deseamos guardar.
			if (one_sheet_results.length > this.one_sheet_max ||
			    one_sheet_results.length >= this.opti.pieceListMultiple.length) {

				better_opti = true;
			}

		} else {
			better_opti = true;
		}
	} // End While better_opti.

	if (this.one_sheet) {
	    console.log('->> buttonStartOptimization -> one_sheet_results:');
	    console.log(one_sheet_results);
	}

    console.log('->> buttonStartOptimization -> listado de graficos graphicList - total_graphicList:');
    // console.log(total_graphicList);

    // console.log('->> buttonStartOptimization: listado de traveras traverseList:');
    // console.log(this.opti.traverseList);
    // console.log('->> buttonStartOptimization: listado de piezas bien asignadas pieceList:');
    // console.log(this.opti.pieceList);
    // console.log('->> buttonStartOptimization: dibujo Piezas ->');
    // console.log(this.opti.piece_draw);
    // console.log('->> buttonStartOptimization: dibujo Traveras ->');
    // console.log(this.opti.traverse_draw);
    console.log('->> buttonStartOptimization -> listado de hojas resultante:');
    // console.log(this.opti.getSheetList());

    // Se vacía el contenedor gráfico de posibles dibujos de hojas anteriores.
    this.removeGraphic(this.graphic_container); // graphic_carousel

    // A) Para dibujar todos los puntos en un único gráfico.
    // this.drawElementList(this.canvas, graphicList, this.fileForm.controls.f_disband.value);

    // B) Para dibujar cada hoja en un gráfico independiente.

    this.total_area_D = 0;
    this.total_area_B = 0;
    this.total_area_S = 0;
    this.total_area_X = 0;
    this.total_area_X_OEF = 0;
    this.total_area_T = 0;
    this.total_area_T_OEF_IN = 0;
    this.total_area_R = 0;
    this.total_area_P = 0;
    this.total_area_J = 0;
    // this.total_area_C = 0;
    this.num_sheet = 0;

    this.cutTotalOrderList = [];
    this.level0TraverseList = [];

    this.opti_level_fault = false;

    // GIRAR ÚLTIMA PIEZA COLA: Se da una primera vuelta a los gráficos para buscar "piezas de cola"
    // que estén tumbadas. Se girarán para crear un mayor retal de cola. La condición
    // es que sea una única pieza en la travera adyacente a la cola de la hoja.
    this.turnLastPiece(total_graphicList);

    // Se crea un retal de cola, si no existiera, con los retales del extremo derecho
    // de la hoja. Aparecen sobre todo si se ha usado el "Eje Y" al optimizar.
    // this.createTail(total_graphicList);

    // Se calcula el orden de tronzado y se actualiza la variable global correspondiente.
    this.getCutOrder(total_graphicList, true);

    // console.log(' -> level0TraverseList: ');
    // console.log(this.level0TraverseList);

    // Se ordenan aquí las hojas según las secuencias de las piezas que contienene.
	if (applySheetOrder) {
		this.level0TraverseList = this.opti.orderTravXBySequence(this.level0TraverseList, total_graphicList, false);

		// Se vuelve a calcular el orden de tronzado pero ya con las traveras X reordenadas
		// (ahora el segundo parámetro está a false porque no hace falta incluir los retales).
	    this.getCutOrder(total_graphicList, false);
	}

    let apile_list = [];

    if (Number(this.fileForm.controls.f_mode.value) === 2 || Number(this.fileForm.controls.f_mode.value) === 3) {
      console.log('->> buttonStartOptimization: Optimizando en MODO2 o MODO3...');

      // IMPORTANTE:
      // Aquí se organizan los "caballetes/apilos" según las piezas y su orden de tronzado,
      // que es lo que tiene de especial el MODO 2.
      // Aquí se detectan y se marcan las piezas que rompen la secuencia.
      [this.opti.groupListMode2, this.opti.pieceInfoList, apile_list] = this.cutPieceToEasel(this.cutTotalOrderList, this.easelList, this.fileForm.controls.f_mode.value);

    } // End If f_mode
    // -------

    // El snapshot debe capturarse después de reordenar las traveras y asignar
    // caballetes. Si se clona antes, el canvas histórico conserva la geometría
    // previa mientras CNC, orden de corte y pilas usan la geometría final.
    this.lastTotalGraphicList = JSON.parse(JSON.stringify(total_graphicList || []));

    console.log('--> Resultado cutTotalOrderList: ');
    // console.log(this.cutTotalOrderList);

    // IMPORTANTE: Hay que contar "a mano" la cantidad de caballetes debido a que el tipo de array por
    // "prop" siempre va a tener una longitud "length" igual a cero aunque tenga varios elementos dentro.

    console.log('-->> buttonStartOptimization local_pieceToEaselList:');
    // console.log(this.local_pieceToEaselList);

    let easel_list_count = 0;

    for (let prop in this.local_pieceToEaselList) {

      // console.log('-->> local_pieceToEaselList item:');
      // console.log(this.local_pieceToEaselList[prop]);

      if (this.local_pieceToEaselList[prop]) {
        easel_list_count++;
      }
    }

    if (easel_list_count === 0) {
      console.log('->> >> No hay caballetes adecuados disponibles para albergar las piezas de corte cargadas.');

      this.alertInfo = 'No hay caballetes adecuados disponibles para albergar las piezas de corte cargadas.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      // Se sale de la función cerrando antes la ventana de carga para que no blequee la aplicación.
      this.changingLoading.emit(false);
      if (this.autoBatchMode) {
        this.finishAutoBatchJob(false, this.alertInfo);
      }
      return;
    }

    // Se dibujan las hojas una a una.
    this.total_sheet_results = [];

    // Se inicializan las listas que van a almacenar los materiales que intervienen en la optimización.
    // NOTA: actualmente realmente sólo va a considerarse un único material por optimización, pero
    // estos elementos están preparados para el día que haga falta incluir varios a la vez (optimizaciones
    // con varias planchas donde cada una puede tener un material diferente).
    this.totalMaterialList = [];
    this.totalMaterialIdList = [];
    this.totalLotList = [];

    // Se irán almacenando en este listado la información de cada pieza optimizada.
    let info_data_piece = [];

    // Se renderiza toda la información para dibujar gráficamente el contenido de cada hoja.
    this.renderSheet(total_graphicList, info_data_piece);

    console.log('-->> buttonStartOptimization info_data_piece:');
    console.log(info_data_piece);

    if (total_graphicList.length > 0) {
      this.actual_sheet = 1;
      this.hideGraphic(this.actual_sheet);
    }

    console.log('->> ->> buttonStartOptimization total_sheet_results:');
    // console.log(this.total_sheet_results);

    // ---------------
    // Se calculan los tantos por ciento con la información recopilada al dibujar cada hoja una a una.

    // Area Neta: la suma de las areas de todas las piezas.
    this.total_area_P = this.total_area_P;

    // console.log('-> total_area_P = ' + this.total_area_P);

    // Area de Resto: Suma de los metros cuadrados de las piezas de resto que se tiran a la basura.
    // A esto hay que sumarle la cantidad desperdiciada en el desbande.
    this.total_area_T += this.total_area_D;
    // console.log('-> total_area_D = ' + this.total_area_D);
    // console.log('-> total_area_T = ' + this.total_area_T);

    // Area de Retal: suma de los metros cuadrados de todas las piezas que se han detectado como retal.
    // this.total_area_R = this.total_area_R;

    // Area de Hojas: suma de los metros cuadrados de todas las hojas usadas (incluido el desbande).
    // this.total_area_S = this.total_area_S;

    // console.log('-> total_area_S = ' + this.total_area_S);
    // console.log('-> total_area_R = ' + this.total_area_R);
    // console.log('-> total_area_J = ' + this.total_area_J);

    // Area Bruta: Se calcula sumando el área de cada una de las planchas utilizadas y restando el área de los retales detectados.
    // Sería igual también al area de todas las piezas más el area desperdiciada, es decir, lo realmente gastado para siempre de cristal.
    // this.total_area_B = this.total_area_S - this.total_area_R;
    this.total_area_B = this.total_area_S - this.total_area_R - this.total_area_J;
    // this.total_area_B = this.total_area_P + this.total_area_T;

	// console.log('-> total_area_B = ' + this.total_area_B);

	if (this.total_area_B <= 0) {
		console.log('-> total_area_B es cero. Se modifica. ');
		this.total_area_B = this.total_area_S;
	}

    // Porcentaje de Merma: Porcentaje que representa sobre la "área bruta" la cantidad de m2 del "área del resto".
    this.total_area_X = (this.total_area_T * 100) / this.total_area_B;
    // Merma OEF específica: solo penaliza el hueco interno generado al agrupar primitivas OEF.
    const oefBase = this.total_area_P + this.total_area_T_OEF_IN;
    this.total_area_X_OEF = oefBase > 0 ? (this.total_area_T_OEF_IN * 100) / oefBase : 0;

    // console.log('-> total_area_X = ' + this.total_area_X);

    // Se indica que ya no hay ningún contenido de archivo cargado.
    // this.fileForm.controls.f_filename.setValue(null);
    // this.fileForm.controls.f_filesheetname.setValue(null);

    // Se muestra automáticamente la pestaña de gráficos.
    this.activateTab('tabGraphic');

    // Se para el cronómetro.
    // this.auxFunction.parar_crono(that);

    // NOTA: Guardamos la información en la base de datos si se ha solicitado.
    if (saveIn && this.optiForm.controls.save.value) {

		// Se muestra el número de optimización en la etiqueta de la pestaña de "Resultado".
		this.showOptiId = true;

        // Se recoge la información general necesaria guardar sobre la optimización.
		let info_data_opti = new OptiData();

		const optimizationSeconds = this.getOptimizationDurationSeconds();
		const optimizationEndDate = new Date();
		const optimizationStartDate = optimizationSeconds > 0
		  ? new Date(optimizationEndDate.getTime() - Math.round(optimizationSeconds * 1000))
		  : optimizationEndDate;

		info_data_opti.od_batch_date = optimizationEndDate;
		info_data_opti.od_cut_end_date = optimizationEndDate;
		info_data_opti.od_cut_start_date = optimizationStartDate;
		info_data_opti.od_batch_number = 0;
		info_data_opti.od_opti_group = 0;
		info_data_opti.od_product_id = JSON.stringify(this.totalMaterialIdList); // Será un listado de Ids por si hay más de un material.
		info_data_opti.od_width = this.opti.nextSheet ? this.opti.nextSheet.width : 0; // Realmente habría que tener un listado de medidas por cada hoja diferente.
		info_data_opti.od_height = this.opti.nextSheet ? this.opti.nextSheet.height : 0;
		info_data_opti.od_depth = this.opti.nextSheet ? this.opti.nextSheet.depth : 0;
		info_data_opti.od_stock_plates_number = this.num_sheet;
		info_data_opti.od_product_desc = JSON.stringify(this.totalMaterialList); // Será un listado de descripciones por si hay más de un material.
		info_data_opti.od_net_area = Number(this.total_area_P.toFixed(2));
		info_data_opti.od_gross_area = Number(this.total_area_B.toFixed(2));
		info_data_opti.od_porcentage_wastage = Number(this.total_area_X.toFixed(2));
		info_data_opti.od_optimization_time = optimizationSeconds > 0 ? Number(optimizationSeconds.toFixed(2)) : 0;
		const oefSettings = this.getOefSettings();
		const oefSelectedPrimitives = this.lastOefPreSearch && Array.isArray(this.lastOefPreSearch.selected_primitives)
		  ? this.lastOefPreSearch.selected_primitives
		  : [];
		info_data_opti.od_oef_used = !!(oefSettings.enabled && oefSelectedPrimitives.length > 0);
		info_data_opti.od_oef_phase = info_data_opti.od_oef_used ? Number(oefSettings.params && oefSettings.params.phase ? oefSettings.params.phase : 2) : null;
		info_data_opti.od_oef_preset = info_data_opti.od_oef_used ? (oefSettings.preset || 'equilibrado') : null;
		info_data_opti.od_oef_summary = info_data_opti.od_oef_used
		  ? JSON.stringify({
		      selected_count: oefSelectedPrimitives.length,
		      selected_primitives: oefSelectedPrimitives.map((p: any) => ({
		        pieces: Number(p && p.pieces ? p.pieces : 0),
		        width: Number(p && p.width ? p.width : 0),
		        height: Number(p && p.height ? p.height : 0),
		        waste_pct: Number(p && p.waste_pct ? p.waste_pct : 0),
		        improvement_pct: Number(p && p.improvement_pct ? p.improvement_pct : 0),
		        source: p && p.source ? p.source : null
		      }))
		    })
		  : null;

		if(!info_data_opti.od_porcentage_wastage) {
			console.log('-> No hay porcentaje de desperdicio: ' + info_data_opti.od_porcentage_wastage);
			info_data_opti.od_porcentage_wastage = 1;
			console.log('-> Se coloca a uno: ' + info_data_opti.od_porcentage_wastage);
		};

		// Guardamos el área de cola para que esté disponible en resúmenes históricos.
		info_data_opti.od_net_area_weight = Number(this.total_area_J.toFixed(2));
		info_data_opti.od_customers_number = 0;
		info_data_opti.od_customers = '';
		info_data_opti.od_total_pieces = this.totalPieces;
		info_data_opti.od_total_easels = this.total_area_C;

		let free_value = Number(this.fileForm.controls.f_free.value);
		let free_string = '0';

		switch(free_value) {
			case 1:
				free_string = 'H';
				break;
			case 2:
				free_string = 'X';
				break;
			case 3:
				free_string = 'Y';
				break;
			case 4:
				free_string = 'Z';
				break;
		}

		info_data_opti.od_configuration =
			this.fileForm.controls.f_level.value + ',' +
			this.fileForm.controls.f_mode.value + ',' +
			free_string + this.fileForm.controls.f_free_in.value + ',' +
			this.fileForm.controls.f_grade.value + ',' +
			this.fileForm.controls.f_grade_rep.value;

		info_data_opti.od_opti_number = '';
		info_data_opti.od_lots_number = this.getPrimaryLotForSave();
		if (this.autoBatchMode) {
			info_data_opti.od_notes = this.buildAutoBatchNote();
		} else {
			info_data_opti.od_notes = this.optiForm.controls.opti_name.value ? this.optiForm.controls.opti_name.value : '';
		}
		const selectedTableId = Number(this.fileForm.controls.f_cutting_table_id.value);
		const selectedTable = (this.cuttingTables && selectedTableId > 0)
		  ? this.cuttingTables.find(ct => Number(ct.id) === selectedTableId)
		  : null;
		const selectedTableName = selectedTable && selectedTable.name ? selectedTable.name.toString() : '';
		info_data_opti.od_state =
		  'CUTTING_TABLE_ID=' + (selectedTableId > 0 ? selectedTableId : '') +
		  ';CUTTING_TABLE_NAME=' + selectedTableName +
		  ';CNC=' + this.fileForm.controls.f_export.value;
    info_data_opti.od_layout_snapshot = this.serializeLayoutSnapshot();
		info_data_opti.od_user_id = this.current_user_id;

		// Se modifica la información de opciones de corte para las hojas
		// actualizando sus valores acorde a los del formulario de optimización.

		sheetList_aux.forEach((sh, i) => {

			sh.disband_l = this.fileForm.controls.f_disband_l.value;
			sh.disband_b = this.fileForm.controls.f_disband_b.value;
			sh.disband_r = this.fileForm.controls.f_disband_r.value;
			sh.disband_t = this.fileForm.controls.f_disband_t.value;

			sh.retal_w = this.fileForm.controls.f_retal_width.value;
			sh.retal_h = this.fileForm.controls.f_retal_height.value;

			sh.diecutting = this.fileForm.controls.f_diecutting.value;
			sh.max_diecutting = this.fileForm.controls.f_max_diecutting.value;

			sh.block = blockIn; // this.fileForm.controls.f_blocks.value;
			sh.base = this.fileForm.controls.f_base.value;
			sh.order = this.fileForm.controls.f_order.value ? 1 : 0;
			sh.format = this.fileForm.controls.f_export.value;
			sh.level = Number(this.fileForm.controls.f_level.value);
			sh.mode = Number(this.fileForm.controls.f_mode.value);
			sh.free = Number(this.fileForm.controls.f_free.value);
			sh.free_in = Number(this.fileForm.controls.f_free_in.value);
			sh.grade = Number(this.fileForm.controls.f_grade.value);
			sh.grade_rep = Number(this.fileForm.controls.f_grade_rep.value);
			sh.origin = Number(this.fileForm.controls.f_origin.value);
			sh.axis = this.fileForm.controls.f_axis.value;
			sh.zoom = this.fileForm.controls.f_zoom.value;
			sh.paths = this.fileForm.controls.f_rute.value;
			sh.resite = this.fileForm.controls.f_old.value;
			sh.color = this.fileForm.controls.f_fill_piece.value;
			sh.cut_order = this.fileForm.controls.f_show_order.value;

			// console.log('-> Hoja actualizada con los nuevos parámetros de corte:' + (i + 1));
			// console.log(sh);

		});

        this.saveOptiData(info_data_opti, info_data_piece, sheetList_aux);

        if (this.autoBatchMode && this.autoBatchStage === 'running') {
          this.autoBatchPendingResult = this.buildAutoBatchResult(true, '', null);
          this.autoBatchStage = 'saving';
        }
    } // End If saveIn.

    if (this.autoBatchMode && this.autoBatchStage === 'running') {
      this.finishAutoBatchJob(true, '');
    }

    // Se cierra el modal de guardado de datos.
    this.showSaveOptiModal(false);

    // Se cierra el modal de carga de fichero de piezas.
    // NOTA: se hace por si acaso porque en ocasiones se muestra al pulsar "INTRO"
    // (por ser foco automático por defecto de la página).
    this.showFileModal(false);

    // Si se está ejecutando el worker histórico de Auto Opti, lanzamos aquí
    // la generación de PDFs una vez que la optimización ya está completada.
    this.tryHistoricalPdfAutogen();

  } // End function buttonStartOptimization

  // Función que modifica el modal de "carga" para bloquear o desbloquear la sección.
  // IMPORTANTE: Se hace mediante el uso de una función asíncrona para que sea captados
  // bien el cierre en la secuencia de eventos en el tiempo.
  async changeChargeModal(value: boolean) {

    this.changingLoading.emit(value);

  } // End function changeChargeModal

  resetOptimizationCancelState() {
    localStorage.setItem('vs_cut_cancel_optimization', '0');
    localStorage.setItem('vs_cut_progress_sheets', '0');
    const speed = this.fileForm && this.fileForm.controls && this.fileForm.controls.f_speed
      ? this.fileForm.controls.f_speed.value
      : 'fast';
    localStorage.setItem('vs_cut_progress_speed', speed ? speed.toString() : 'fast');
  }

  isOptimizationCancellationRequested(): boolean {
    return localStorage.getItem('vs_cut_cancel_optimization') === '1';
  }

  updateOptimizationSheetsProgress() {
    let sheetCount = 0;
    if (this.opti && this.opti.sheetList && this.opti.sheetList.length > 0) {
      this.opti.sheetList.forEach(sh => {
        if (sh && sh.used) {
          sheetCount++;
        }
      });
    }
    localStorage.setItem('vs_cut_progress_sheets', sheetCount.toString());
  }

  // Función que encaja todas las piezas que pueda y deja el resultado
  // en la variable "this.sheetList" donde están también todos los calculos.
  async bucleWhile(maxTraverseIn: number, alertMsg: boolean) {

    console.log('->> bucleWhile.');

    let count_while = 0;

    let exit = false;

    let promese_traverse_exist = null;

    // Vaciamos el listado que va a almacenar las piezas bien colocadas.
    this.opti.pieceList = [];

    // console.log('->> ->> bucleWhile -> pieceInfoList inicio:');
    // console.log(this.opti.pieceInfoList);

    // Se prepara el listado inicial de las piezas para la optimización.
    let promese_piece_exist = await this.opti.chargePieceList().then(async function(pieces_cut: any) {
		// console.log('->> pieces_cut data => ');
        // console.log(pieces_cut);

        // return pieces_cut.filter( pz => !pz.piece_cut);
        return pieces_cut;
    });

	// Si no hay piezas candidatas.
    if (!promese_piece_exist || promese_piece_exist.length === 0) {

      console.log('->> No hay piezas candidatas disponibles en ninguno de los "grupos de optimización".');

      this.opti.nextPiece = [];

    } else {
      this.opti.nextPiece = promese_piece_exist;
    }

    // Se saldrá del bucle por dos razones:
    // 1. Cuando se hayan colocado todas las piezas.
    // 2. Cuando no queden planchas candidatas en almacén para usar.
    // 3. Cuando se supere el límite máximo de piezas impuesto para una sóla optimización.
    while (count_while === 0 ||
      (this.opti.nextPiece &&
      this.opti.nextPiece.length > 0 &&
      // !this.opti.end_pieces && // NOTA: Si no se quisiera dibujar las traveras de las hojas no usadas.
      !exit && count_while < this.max_bucle_count)) {
      if (this.isOptimizationCancellationRequested()) {
        console.log('->> bucleWhile cancelado por usuario.');
        exit = true;
        break;
      }
    // for (let prop in this.opti.pieceInfoList) {

      // let group_list = this.opti.pieceInfoList[prop];

      count_while++;

      // console.log('->> Entrando en bucle vuelta => ' + count_while);

	  // Si el eje elegido es el "Y" se aumenta en 1 el nivel
	  // de profundidad que va a soportar la optimización.
	  let level_aux = Number(this.fileForm.controls.f_level.value);

	  if (this.fileForm.controls.f_axis.value === 'Y') level_aux++;

      // Las promesa devuelve "true" cuando ya no quedan planchas que colocar en la máquina por lo que
      // lo usamos como indicativo para salir del bucle de piezas ya que no se van a poder colocar.
      promese_traverse_exist = await this.opti.cutPieceInTraverse(
        this.fileForm.controls.f_axis.value,
        this.fileForm.controls.f_diecutting.value, // this.diecutting,
        maxTraverseIn, // this.fileForm.controls.f_max_diecutting.value,
        this.fileForm.controls.f_set.value, // this.set,
        this.fileForm.controls.f_rot.value, // this.rotate,
        this.fileForm.controls.f_turn.value, //this.turn,
        this.fileForm.controls.f_near.value, // this.near
        this.fileForm.controls.f_retal_width.value,
        this.fileForm.controls.f_retal_height.value,
        this.fileForm.controls.f_export.value,
        level_aux
      ).then(async function(continue_cut) {

        // console.log('->> file-list cutPieceInTraverse result count_while => ' + count_while);
        // console.log(continue_cut);

        return continue_cut;
      });

      // Se vuelve a desagrupar las piezas que aún queden "pendientes" para
      // volver a hacer nuevos bloques con las piezas aún no cortadas.
      // this.opti.breakBlock(this.opti.pieceInfoList);

      // console.log('->> promese_traverse_exist: ' + count_while);
      // console.log(promese_traverse_exist);

      // Si no hay travera para la pieza se sale.
      if (!promese_traverse_exist) {

        console.log('->> No se continúa con la optimización. Ya no existen traveras que poder usar.');
        exit = true;

        break;
      }

      this.updateOptimizationSheetsProgress();

      // console.log('->> bucleWhile: Siguiente pieza para cortar -> nextPiece:' + count_while);
      // console.log(this.opti.nextPiece);

    } // End while nextPiece

    // Se cortan los retales de forma que no se sobrepase el ancho máximo de travera permitido en la optimización.
    // this.opti.cutMaxTraverse(this.fileForm.controls.f_max_diecutting.value);

	if (alertMsg) {
		this.alertInfo = '';

      if (this.isOptimizationCancellationRequested()) {
        this.alertInfo += 'Optimización cancelada por el usuario. <br>';
      }

	    if (exit) {
	      console.log('->> FINAL 1: No existen traveras que poder usar.');

	      this.alertInfo += 'No existen planchas que poder usar. <br>';
	    }

	    if (count_while === this.max_bucle_count) {
	      console.log('->> FINAL 2: Se ha llegado al número máximo permitido de iteraciones = ' + this.max_bucle_count);

	      this.alertInfo += 'Se ha sobrepasado el número máximo permitido de piezas (' + this.max_bucle_count +
	                       ').  <br> La optimización no se ha terminado de completar. No se mostrarán todas las planchas.  <br>';
	      // this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
	    }

	    // if (this.opti.pieceInfoList.length === 0) {
	    if (this.opti.nextPiece.length === 0) {
	      console.log('->> FINAL 3: Se han colocado todas las piezas de la optimización.  <br>');

	    } else {
	      console.log('->> FINAL 4: Han quedado piezas por colocar en la optimización:');
	      console.log(this.opti.nextPiece);

	      this.alertInfo += 'Han quedado piezas por colocar en la optimización: <br>';

	      // Se indicarán los elementos que han faltado por tratar.
	      this.opti.nextPiece.forEach(pz => {
			this.alertInfo += ' · Uds = ' + (pz.piece_set ? (pz.piece_set.length + 1) : 1) + ' -> ' + pz.piece_material + ': ' + pz.piece_width + ' x ' + pz.piece_height + '<br>';
		  });

	    }

	    if (this.alertInfo !== '') {
			this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
		}
	} // End If alertMsg.

    // console.log('->> bucleWhile -> pieceInfoList final:');
    // console.log(this.opti.pieceInfoList);

    // Se guarda el estado de optimización de la hoja que estaba en curso antes de terminar el proceso.
    this.opti.saveSheet();
    this.updateOptimizationSheetsProgress();

    // console.log('->> buttonStartOptimization: se ha terminado el bucleWhile B ' + count);
    // console.log(this.opti.traverseList);

    // Se esconde el modal de "carga" que bloqueaba la sección.
    this.changingLoading.emit(false);

    exit = true;

    // Se vuelve a reiniciar la pieza actual.
    this.opti.currentPiece = [];

    return count_while;

  } // End function bucleWhile.

  // Función que encaja todas las piezas que pueda en una única hoja y deja el resultado
  // en la variable "this.opti.sheetOneList" donde están también todos sus calculos.
  async bucleWhileOneSheet(numListIn: number, maxTraverseIn: number, alertMsg: boolean) {

    console.log('->> bucleWhileOneSheet ' + numListIn);

    let count_while = 0;

    let exit = false;

    let promese_traverse_exist = null;

    // Vaciamos el listado que va a almacenar las piezas bien colocadas.
    this.opti.pieceOneList = [];

    // console.log('->> ->> bucleWhile -> pieceInfoList inicio:');
    // console.log(this.opti.pieceInfoList);

    // Se saldrá del bucle por dos razones:
    // 1. Cuando se hayan colocado todas las piezas.
    // 2. Cuando no queden planchas candidatas en almacén para usar.
    // 3. Cuando se supere el límite máximo de piezas impuesto para una sóla optimización.
    while (count_while === 0 ||
      (this.opti.nextOnePiece[numListIn] &&
      this.opti.nextOnePiece[numListIn].length > 0 &&
      // !this.opti.end_pieces && // NOTA: Si no se quisiera dibujar las traveras de las hojas no usadas.
      !exit && count_while < this.max_bucle_count)) {
      if (this.isOptimizationCancellationRequested()) {
        console.log('->> bucleWhileOneSheet cancelado por usuario.');
        exit = true;
        break;
      }
    // for (let prop in this.opti.pieceInfoList) {

      // let group_list = this.opti.pieceInfoList[prop];

      count_while++;

      // console.log('->> Entrando en bucle vuelta => ' + count_while);

      // La promesa devuelve "false" cuando ya no puede colocar más piezas en la hoja vigente.
      // Lo usamos como indicativo para salir del bucle y parar la optimización.
      promese_traverse_exist = await this.opti.cutPieceInSheet(
        this.fileForm.controls.f_axis.value,
        this.fileForm.controls.f_diecutting.value, // this.diecutting,
        maxTraverseIn, // this.fileForm.controls.f_max_diecutting.value,
        this.fileForm.controls.f_set.value, // this.set,
        this.fileForm.controls.f_rot.value, // this.rotate,
        this.fileForm.controls.f_turn.value, //this.turn,
        this.fileForm.controls.f_near.value, // this.near
        this.fileForm.controls.f_retal_width.value,
        this.fileForm.controls.f_retal_height.value,
        this.fileForm.controls.f_export.value,
        this.fileForm.controls.f_level.value,
        numListIn
      ).then(async function(continue_cut) {

        console.log('->> file-list cutPieceInSheet result count_while => ' + count_while);
        console.log(continue_cut);

        return continue_cut;
      });

      // console.log('->> promese_traverse_exist: ' + count_while);
      // console.log(promese_traverse_exist);

      // Si no hay travera para la pieza se sale.
      if (!promese_traverse_exist) {

        console.log('->> bucleWhileOneSheet: No se continúa con la optimización. No se pueden poner más piezas en la hoja.');
        exit = true;

        break;
      }

      this.updateOptimizationSheetsProgress();

      // console.log('->> bucleWhile: Siguiente pieza para cortar -> nextPiece:' + count_while);
      // console.log(this.opti.nextOnePiece[numListIn]);

    } // End while nextOnePiece

    // Se cortan los retales de forma que no se sobrepase el ancho máximo de travera permitido en la optimización.
    // this.opti.cutMaxTraverse(this.fileForm.controls.f_max_diecutting.value);

	if (alertMsg) {
		this.alertInfo = '';

      if (this.isOptimizationCancellationRequested()) {
        this.alertInfo += 'Optimización cancelada por el usuario. <br>';
      }

	    if (exit) {
	      console.log('->> bucleWhileOneSheet FINAL 1: No se pueden poner más piezas en la hoja.');

	      // this.alertInfo += 'No se pueden poner más piezas en la hoja. <br>';
	    }

	    if (count_while === this.max_bucle_count) {
	      console.log('->> bucleWhileOneSheet FINAL 2: Se ha llegado al número máximo permitido de iteraciones = ' + this.max_bucle_count);

	      this.alertInfo += 'Se ha sobrepasado el número máximo permitido de piezas (' + this.max_bucle_count +
	                       ').  <br> La optimización no se ha terminado de completar. No se mostrarán todas las planchas.  <br>';
	      // this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
	    }

	    if (this.opti.nextOnePiece[numListIn] && this.opti.nextOnePiece[numListIn].length === 0) {
	      console.log('->> bucleWhileOneSheet FINAL 3: Se han colocado todas las piezas de la optimización.  <br>');

	    } else if (this.opti.nextOnePiece[numListIn]) {
	      console.log('->> bucleWhileOneSheet FINAL 4: Han quedado piezas por colocar en la optimización:');
	      console.log(this.opti.nextOnePiece[numListIn]);

	      this.alertInfo += 'Han quedado piezas por colocar en la optimización: <br>';

	      // Se indicarán los elementos que han faltado por tratar.
	      this.opti.nextOnePiece[numListIn].forEach(pz => {
			this.alertInfo += ' · Uds = ' + (pz.piece_set ? (pz.piece_set.length + 1) : 1) + ' -> ' + pz.piece_material + ': ' + pz.piece_width + ' x ' + pz.piece_height + '<br>';
		  });

	    } else {
		  console.log('->> bucleWhileOneSheet FINAL 5: No existe nextOnePiece ' + numListIn);
		}

	    if (this.alertInfo !== '') {
			this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
		}
	} // End If alertMsg.

    // console.log('->> bucleWhileOneSheet -> pieceListMultiple final:');
    // console.log(this.opti.pieceListMultiple);

    // Se guarda el estado de optimización de la hoja que estaba en curso antes de terminar el proceso.
    this.opti.saveOneSheet();
    this.updateOptimizationSheetsProgress();

    // console.log('->> bucleWhileOneSheet: se ha terminado el bucleWhile B ' + count);
    // console.log(this.opti.traverseList);

    // Se esconde el modal de "carga" que bloqueaba la sección.
    this.changingLoading.emit(false);

    exit = true;

    // Guardamos la info recopilada en esta optimización de hoja
    // para luego poder compararlas todas y escoger la mejor.
    let p_aux = [];
    let a_aux = 0;

    // Sólo se escogen las hojas con piezas.
    let s_aux = this.opti.sheetList.filter(s => s.pieces);

    s_aux.forEach(s => {
		console.log('->> bucleWhileOneSheet this.opti.sheetList: ');
		console.log(s);

		s.pieces.forEach(p => {
			p_aux.push(p.piece);
			a_aux += p.piece.piece_area;
		});
	});

	let one_opti_result = { pieces: p_aux, area: a_aux, count: count_while };

	console.log('->> bucleWhileOneSheet one_opti_result: ');
	console.log(one_opti_result);

    return one_opti_result;

  } // End function bucleWhileOneSheet.

  // ------------------------------------
  //    VALIDACIÓN FINAL DEL FORMULARIO
  // ------------------------------------

  validateFile(): void {

    // Se realizan las comprobaciones pertinentes para confirmar que los campos del formulario son correctos.

    if (this.fileForm.valid) {
      console.log('-------> Formulario fileForm correcto.');

      // Comprobaciones que no estén definidas ya en la declaración del formulario.
      if (this.fileForm.controls.path.value.trim() === '') {

        this.alertInfo = 'Debe indicar una ruta para el directorio.';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      } else {

        this.showActionModal(true);
      }
    } else {
      console.log('-------> Formulario fileForm NO válido:');
      console.log(this.fileForm);

      this.alertInfo = 'El formulario no está correctamente rellenado:<br>';

      if (this.fileForm.controls.path.value === '') {

        this.alertInfo += ' - Debe indicar una ruta para el directorio.';
      }

      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    }
  } // End function validateFile

  // ------- Función de regreso
  back(): void {
    // this._location.back();
    this.router.navigate(['/main']);
  } // End function back


  // ------------------------------------------------
  //  FUNCIONES PARA ASIGNAR LAS PIEZAS A CABALLETES
  // ------------------------------------------------

  // Función que lanza el inicio de los procesos para la asignación de caballetes
  // teniendo en cuenta sólamente las medidas de las piezas, es decir, averiguar en
  // qué familia cabe e ir llenando los caballetes que vayan saliendo para cada tipo.
  // Posteriormente habrá que llenar esos caballetes siguiendo un orden de "salida de
  // tronzado" que será un orden diferente al obtenido en esta función.
  pieceToEasel(piecesListIn: DataInput[], easelListIn: Easel[], modeIn: number, baseMaxSideIn: boolean): any {

    // console.log('-->> pieceToEasel piecesListIn:');
    // console.log(piecesListIn);

    // console.log('-->> pieceToEasel easelListIn:');
    // console.log(easelListIn);

    // NOTA ORDEN: Hay que hecerlo justo en este momento o si no las "formas" no saldrán bien.
    if (baseMaxSideIn) {

		// Se modifican las piezas para que todas tenga el ancho como su lado mayor.
		this.setBaseMaxSide(piecesListIn);

	} else {
		// Se modifican las piezas para que todas tenga el ancho como su lado menor.
		this.setBaseMinSide(piecesListIn);
	}

    // ----------
    // Se hace una copia del listado de piezas de entrada.

    let optimizationList_aux = JSON.parse(JSON.stringify(piecesListIn));

    let total_optimizationList = [];

    // Se agrupan las líneas sumando unidades de secuencias con
    // diferente paneno (esto evita roturas de secuencias en caballetes).
	    piecesListIn.forEach((ps, index) => {
	      const psIsOef = this.isOefCompositeItem(ps);
	      const psStdMergeKey = this.buildStandardPieceMergeKey(ps);

			// console.log('-->> Pieza original:');
	    	// console.log(ps);

				let find_ps = total_optimizationList.find(px =>
	        !psIsOef &&
	        !this.isOefCompositeItem(px) &&
					px.lot === ps.lot &&
					px.sequence === ps.sequence &&
					this.buildStandardPieceMergeKey(px) === psStdMergeKey
				// Number(px.mat_id) === Number(ps.mat_id) &&
			// ((px.width === ps.width && px.height === ps.height) ||
			//  (px.width === ps.height && px.height === ps.width))
			// && px.orderpos === ps.orderpos
			);
			// Esta no se tiene en cuenta el paneno para no crear distinciones.

		if (!find_ps) {

			// console.log('-->> Se añade la pieza original con paneno = ' + ps.paneno);

			// Se añade los "detalles" de optimización para la pieza.
			total_optimizationList.push(JSON.parse(JSON.stringify(ps)));
		} else {

			// console.log('-->> Encontrada pieza original. Se le suman cantidades');
    		// console.log(find_ps);

			// Sólo sumamos más unidades a los "detalles de pieza" ya existentes.
			find_ps.units += Number(ps.units);
		}
	});

	// console.log('-> Lista piezas sumadas -> total_optimizationList:');
	// console.log(total_optimizationList);

	// Se consigue el listado de piezas con el paneno agrupado.
	piecesListIn = total_optimizationList;

    // ----------

    let easelCSV = '';
    let packageCSV = '';

    // Array en el que cada uno de sus elementos va a contener a su vez el
    // listado de los productos que caben dentro de la familia que representa.
    // let finalPackageArray = [];
    let groupEaselList = [];

    let ocupation = 0;

    // console.log('------------------------------');
    // console.log('   ASIGNACIÓN PIEZA - ATRIL   ');
    // console.log('------------------------------');

    // Se inicializa el contador de piezas.
    let piece_count = 0;

    // NOTA: Hay que tener en cuenta que la linea no contenga información de "cabecera de
    // fichero" ya que realmente no son piezas y no hay que llegar a tratarlas como tales.
    // Realmente no hace falta filtrarlo aquí porque debería llegar ya limpio de información.
    // piecesListIn = piecesListIn.filter(p => p.mat_id !== 'Material');

    // Se ordenan los caballetes para probar primero los de dimensiones más pequeñas.
    // Así nos aseguramos de que el elegido sea al que menos espacio sobrará.
    easelListIn = this.auxFunction.orderEaselByDimension(easelListIn);

    // console.log('-->> pieceToEasel easelListIn orderEaselByDimension:');
    // console.log(JSON.parse(JSON.stringify(easelListIn)));

	let piece_max_traverse = false;
	let no_easel_piece = false;
	let no_material_piece = false;

    // Se recorren todos los elementos (piezas) para buscarle un caballete adecuado a cada uno.
    // for (let prop in piecesListIn) {
    piecesListIn.forEach( (piece, i) => {

      // console.log('-->> Tramitando entrada de pieza para asignar caballete:');
      // console.log(piece);


      // Si es una "forma" entonces habrá que calcular sus dimensiones para saber su "ancho x alto".
      // EXCEPCIÓN OEF: cuando ya viene como primitivo compuesto (polígonos internos),
      // NO se debe recalcular con la fórmula de la forma simple (p.ej. figura 20),
      // porque eso pisa el bounding-box compuesto.
      const isOefCompositePiece = (
        piece &&
        piece.oef_generated === true &&
        Array.isArray(piece.oef_internal_polygons) &&
        piece.oef_internal_polygons.length > 0
      );

      if (isOefCompositePiece) {
        const primitiveW = Number(piece.oef_primitive_w);
        const primitiveH = Number(piece.oef_primitive_h);
        if (Number.isFinite(primitiveW) && primitiveW > 0) {
          piece.width = primitiveW;
        }
        if (Number.isFinite(primitiveH) && primitiveH > 0) {
          piece.height = primitiveH;
        }

        // Fallback de seguridad por si faltan primitive_w/h.
        if (!(Number(piece.width) > 0) || !(Number(piece.height) > 0)) {
          const merged = [];
          piece.oef_internal_polygons.forEach(poly => {
            (poly || []).forEach(pt => merged.push(pt));
          });
          const xs = merged.map(pt => Number(pt && pt.x)).filter(v => Number.isFinite(v));
          const ys = merged.map(pt => Number(pt && pt.y)).filter(v => Number.isFinite(v));
          if (xs.length && ys.length) {
            piece.width = Math.max.apply(null, xs) - Math.min.apply(null, xs);
            piece.height = Math.max.apply(null, ys) - Math.min.apply(null, ys);
          }
        }
      } else if (piece.figure && Number(piece.figure) > 0) {

        switch (Number(piece.figure)) {
          case 1:

            // console.log('-->> Calculando datos para fórmula FORMA 1 = ' + piece.figure);
            piece.width = piece.b3 + piece.l + piece.b1;
            piece.height = piece.h + piece.b2;

            console.log(piece);

            break;

          case 2:

            // let aux_h = 0;
            // let aux_b3 = 0;
            // let aux_h1 = 0;
            // let aux_b1 = 0;

            // aux_h = Number(piece.h);
            // aux_b3 = Number(piece.b3);
            // aux_h1 = Number(piece.h1);
            // aux_b1 = Number(piece.b1);

            // piece.h = aux_h1;
            // piece.h1 = aux_h;
            // piece.b3 = aux_b1;
            // piece.b1 = aux_b3;

            // console.log('-->> Calculando datos para fórmula FORMA 2 = ' + piece.figure);
            piece.width = piece.b3 + piece.l + piece.b1;
            piece.height = piece.h + piece.b2;

            console.log(piece);

            break;

          // ------------ Nuevas formas añadidas A.

          case 3: // Lógica para la figura 3
            piece.width = piece.l + piece.b1;
            piece.height = piece.h + piece.b2;
            console.log(piece);
            break;

          case 4: // Lógica para la figura 4
            piece.width = piece.l + piece.b1;
            piece.height = piece.h + piece.b2;
            console.log(piece);
            break;

          case 5: // Lógica para la figura 5, 6 y 7
          case 6:
          case 7:
          case 8:
            piece.width = piece.l + piece.b1 + piece.b3;
            piece.height = piece.h + piece.b2 + piece.b2;
            console.log(piece);
            break;

          case 9:
          case 10:
            piece.width = piece.l + piece.b1 + piece.b3;
            piece.height = piece.h + piece.b2;
            console.log(piece);
            break;

          case 11:
          case 12:
          case 13:
            piece.width = piece.l + piece.b1 + piece.b3;
            // Utilizaremos b3 como b4 porque no lo tenemos en el formulario web todavía
            piece.height = piece.h + piece.b2 + piece.b4;
            console.log(piece);
            break;

          case 14:
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
            piece.width = piece.l + piece.b1 + piece.b3;
            // Utilizaremos b3 como b4 porque no lo tenemos en el formulario web todavía
            piece.height = piece.h + piece.b2 + piece.b3;
            console.log(piece);
            break;

          case 20:
            piece.width = piece.l + piece.b1 + piece.b1;
            piece.height = Math.ceil(((Math.sqrt(3) / 2) * piece.l) + piece.b1 + piece.b2);
            console.log(piece);
            break;
          case 21:
          case 22:
          case 23: {
            const n = Number(piece.figure) - 16;
            const side = Number(piece.l);
            const R = side / (2 * Math.sin(Math.PI / n));
            const a = side / (2 * Math.tan(Math.PI / n));
            const polyW = 2 * R;
            let polyH = a + R;
            if (Number(piece.figure) === 22) {
              polyH = 2 * a;
            }
            piece.width = Math.ceil(polyW + (2 * Number(piece.b2 || 0)));
            piece.height = Math.ceil(polyH + (2 * Number(piece.b1 || 0)));
            console.log(piece);
            break;
          }
          case 24: {
            const n = 8;
            const side = Number(piece.l);
            const a = side / (2 * Math.tan(Math.PI / n));
            const polyW = 2 * a;
            const polyH = 2 * a;
            piece.width = Math.ceil(polyW + (2 * Number(piece.b1 || 0)));
            piece.height = Math.ceil(polyH + (2 * Number(piece.b1 || 0)));
            console.log(piece);
            break;
          }

          case 25: // Lógica para la figura 25
            piece.width = piece.l + piece.b1 + piece.b1;
            piece.height = piece.h + piece.b2 + piece.b3;
            console.log(piece);
            break;

          case 26: // Lógica para la figura 26
            piece.width = piece.l + piece.b1 + piece.b1;
            piece.height = piece.h + piece.b2 + piece.b2;
            console.log(piece);
            break;

          // ------------ Fin nuevas formas añadidas A.

          case 27:

            // console.log('-->> Calculando datos para fórmula FORMA 27 = ' + piece.figure);
            piece.width = piece.l + piece.b1 + piece.b2;
            // NOTA: Realmente no sabemos el alto (height) real del marco rectangular que
            // engloba a la forma (ya que hay una distancia que se desconoce entre B3 y H).
            // Se va a poner una aproximación usando de momento el valor de la mitad de R.
            piece.height = piece.h + piece.b3 + (piece.r / (piece.h - piece.h1 ? 2 : 1));

            break;
          case 28: {
            // Figura arqueada con bandas laterales B1/B2 y superior B3.
            const geometry28 = this.buildFigure28Geometry(piece.b1, piece.b2, piece.b3, piece.l, piece.h, piece.h1, piece.r, false);
            piece.width = geometry28 ? geometry28.width : (piece.l + piece.b1 + piece.b2);
            piece.height = geometry28 ? geometry28.height : (piece.h + piece.b3);
            break;
          }
          case 30:
          case 31:
            // Marco lateral B1 en ambos lados.
            piece.width = piece.l + piece.b1 + piece.b1;
            piece.height = piece.h;
            break;
          case 32:
            // Trapecios con bandas laterales B1 y bandas superior/inferior B2.
            piece.width = piece.l + piece.b1 + piece.b1;
            piece.height = piece.h + piece.b2 + piece.b2;
            break;
          case 33:
          case 34:
            // Rectángulo LxH con bandas laterales/superior/inferior B2.
            // B1 se usa como separación entre diagonales.
            piece.width = piece.l + piece.b2 + piece.b2;
            piece.height = piece.h + piece.b2 + piece.b2;
            break;
          case 35:
          case 36:
            // Paralelogramo con bandas laterales B1 y superior/inferior B2.
            piece.width = piece.l + piece.b1 + piece.b1;
            piece.height = piece.h + piece.b2 + piece.b2;
            break;
          case 38:
            // Espejo de la figura 37.
            piece.width = piece.l + (2 * piece.b1);
            piece.height = piece.h + (2 * piece.b2);
            break;
          case 40:
            // Pentágono tipo "casa" con banda inferior B2 y superior B3.
            piece.width = piece.l + piece.b1 + piece.b1;
            piece.height = piece.h + piece.b2 + piece.b3;
            break;
          case 41: {
            // Pentágono simétrico con lados definidos por L1 y L2.
            const L = Number(piece.l || 0);
            const L1 = Number(piece.l1 || 0);
            const L2 = Number(piece.l2 || 0);
            const H = Number(piece.h || 0);
            let d1 = 0;
            const dMin = 0;
            const dMax = Math.min(L1, L2 - (L / 2));
            if (dMax > dMin && H > 0) {
              const f = (d) => {
                const a1 = (L1 * L1) - (d * d);
                const b1 = (L2 * L2) - ((d + (L / 2)) * (d + (L / 2)));
                if (a1 < 0 || b1 < 0) return -H;
                return Math.sqrt(a1) + Math.sqrt(b1) - H;
              };
              let lo = dMin;
              let hi = dMax;
              let flo = f(lo);
              let fhi = f(hi);
              if (flo === 0) {
                d1 = lo;
              } else if (fhi === 0) {
                d1 = hi;
              } else if ((flo > 0 && fhi < 0) || (flo < 0 && fhi > 0)) {
                for (let i = 0; i < 40; i++) {
                  const mid = (lo + hi) / 2;
                  const fmid = f(mid);
                  if (fmid === 0) {
                    lo = mid;
                    hi = mid;
                    break;
                  }
                  if ((flo > 0 && fmid > 0) || (flo < 0 && fmid < 0)) {
                    lo = mid;
                    flo = fmid;
                  } else {
                    hi = mid;
                    fhi = fmid;
                  }
                }
                d1 = (lo + hi) / 2;
              }
            }
            piece.width = Math.round(L + (2 * d1) + Number(piece.b1 || 0) + Number(piece.b3 || 0));
            piece.height = Math.round(Number(piece.h || 0) + Number(piece.b2 || 0));
            break;
          }
          case 42:
            // Hexágono irregular con bandas laterales/superior/inferior.
            piece.width = piece.l + piece.b1 + piece.b1;
            piece.height = piece.h + piece.b2 + piece.b2;
            break;

          case 29:

            // console.log('-->> Calculando datos para fórmula FORMA 29 círculo = ' + piece.figure);
            piece.width = (piece.r + piece.b1) * 2;
            piece.height = (piece.r + piece.b1) * 2;

            break;

          case 37:
		  case 371:
          case 372:
          case 43:

            // console.log('-->> Calculando datos para fórmula FORMA 37 o FORMA 43 = ' + piece.figure);
            if (Number(piece.figure) === 372) {
              const L3 = Number(piece.b3 || 0);
              const L1 = Number(piece.l1 || 0);
              const L2 = Number(piece.l2 || 0);
              const H1 = Number(piece.h1 || 0);
              const H2 = Number(piece.h2 || 0);
              piece.width = Math.max(L3, L3 + L2, L1) + (2 * Number(piece.b1 || 0));
              piece.height = Math.max(H1, H2) + (2 * Number(piece.b2 || 0));
            } else {
              piece.width = piece.l + (2 * piece.b1);
              piece.height = piece.h + (2 * piece.b2);
            }

            break;
          case 44: {
            const L = Number(piece.l || 0);
            const L1 = Number(piece.l1 || 0);
            const L2 = Number(piece.l2 || 0);
            let h = 0;
            if (L > 0) {
              const x = ((L1 * L1) - (L2 * L2) + (L * L)) / (2 * L);
              const hSq = (L1 * L1) - (x * x);
              if (hSq > 0) h = Math.sqrt(hSq);
            }
            piece.width = Math.round(L + (2 * Number(piece.b1 || 0)));
            piece.height = Math.round(h + (2 * Number(piece.b2 || 0)));
            break;
          }
          case 45:
          case 46: {
            const L = Number(piece.l || 0);
            const H = Number(piece.h || 0);
            const L1 = Number(piece.l1 || 0);
            const L2 = Number(piece.l2 || 0);
            let cx = L;
            let cy = H;
            if (Number(piece.figure) === 45) {
              const l1c = Math.max(0, Math.min(H, L1));
              const l2c = Math.max(0, Math.min(L, L2));
              cx = L - l2c;
              cy = H - l1c;
              if (cy < 0) cy = 0;
            } else {
              const d = Math.sqrt((L * L) + (H * H));
              if (d > 0) {
                const a = ((L1 * L1) - (L2 * L2) + (d * d)) / (2 * d);
                const hSq = (L1 * L1) - (a * a);
                if (hSq >= 0) {
                  const hh = Math.sqrt(hSq);
                  const ux = L / d;
                  const uy = -H / d;
                  const p2x = a * ux;
                  const p2y = H + (a * uy);
                  const c1x = p2x - (hh * uy);
                  const c1y = p2y + (hh * ux);
                  const c2x = p2x + (hh * uy);
                  const c2y = p2y - (hh * ux);
                  if (c1y >= c2y) { cx = c1x; cy = c1y; } else { cx = c2x; cy = c2y; }
                }
              }
            }
            const innerW = Number(piece.figure) === 46 ? Math.max(L, cx) : L;
            const innerH = Number(piece.figure) === 46 ? Math.max(H, cy) : H;
            piece.width = Math.round(Number(piece.b1 || 0) + innerW + Number(piece.b3 || 0));
            piece.height = Math.round(Number(piece.b2 || 0) + innerH + Number(piece.b3 || 0));
            break;
          }
          case 47: {
            const L = Number(piece.l || 0);
            const H = Number(piece.h || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            const B3 = Number(piece.b3 || 0);
            piece.width = Math.round(L + (2 * B1));
            piece.height = Math.round(H + B2 + B3);
            break;
          }
          case 48: {
            const L = Number(piece.l || 0);
            const H = Number(piece.h || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            const B3 = Number(piece.b3 || 0);
            piece.width = Math.round(L + (2 * B1));
            piece.height = Math.round(H + B2 + B3);
            break;
          }
          case 49: {
            const L = Number(piece.l || 0);
            const H = Number(piece.h || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            const B3 = Number(piece.b3 || 0);
            piece.width = Math.round(L + (2 * B1));
            piece.height = Math.round(H + B2 + B3);
            break;
          }

          case 50:

            // console.log('-->> Calculando datos para fórmula FORMA 50 semicírculo = ' + piece.figure);
            piece.width = piece.l + (piece.b1 * 2);
            piece.height = piece.b2 + piece.h + piece.b3;

            break;
          case 51: {
            const L = Number(piece.l || 0);
            const R = Number(piece.r || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            const B3 = Number(piece.b3 || 0);
            let h = 0;
            if (R > 0 && (L / 2) <= R) {
              const d = Math.sqrt((R * R) - ((L / 2) * (L / 2)));
              h = R - d;
            }
            piece.width = Math.round(L + (2 * B1));
            piece.height = Math.round(B2 + h + B3);
            break;
          }
          case 52:
          case 53: {
            const L = Number(piece.l || 0);
            const H = Number(piece.h || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            piece.width = Math.round(L + (2 * B1));
            piece.height = Math.round(H + (2 * B2));
            break;
          }
          case 54: {
            const L1 = Number(piece.l1 || 0);
            const L2 = Number(piece.l2 || 0);
            const H1 = Number(piece.h1 || 0);
            const H2 = Number(piece.h2 || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            piece.width = Math.round(L1 + L2 + (2 * B1));
            piece.height = Math.round(H1 + H2 + (2 * B2));
            break;
          }
          case 56: {
            const L = Number(piece.l || 0);
            const H = Number(piece.h || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            piece.width = Math.round(L + (2 * B1));
            piece.height = Math.round(H + (2 * B2));
            break;
          }
          case 57:
          case 58: {
            const L = Number(piece.l || 0);
            const H = Number(piece.h || 0);
            const H1 = Number(piece.h1 || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            const B3 = Number(piece.b3 || 0);
            piece.width = Math.round(L + (2 * B1));
            piece.height = Math.round(Math.max(H, H1) + B2 + B3);
            break;
          }
          case 59: {
            const H = Number(piece.h || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            piece.width = Math.round(B1 + H + B2);
            piece.height = Math.round(B1 + H + B2);
            break;
          }
          case 60: {
            const L = Number(piece.l || 0);
            const H = Number(piece.h || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            const B3 = Number(piece.b3 || 0);
            piece.width = Math.round(B1 + L + B3);
            piece.height = Math.round(B2 + H + B3);
            break;
          }
          case 61: {
            const L = Number(piece.l || 0);
            const H = Number(piece.h || 0);
            const RIn = Number(piece.r || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            const B3 = Number(piece.b3 || 0);
            const minR = Math.max(L / 2, H / 2) + 0.000001;
            const R = (RIn > minR) ? RIn : minR;
            const cx = B1 + (L / 2);
            const cy = B2 + (H / 2);
            piece.width = Math.round((cx + R) + B3);
            piece.height = Math.round((cy + R) + B3);
            break;
          }
          case 62: {
            const L = Number(piece.l || 0);
            const R = Number(piece.r || 0);
            const R1 = Number(piece.r2 || 0);
            const B1 = Number(piece.b1 || 0);
            const B2 = Number(piece.b2 || 0);
            const B3 = Number(piece.b3 || 0);
            let angleRad = (R1 * Math.PI) / 180;
            if (angleRad < (1 * Math.PI / 180)) angleRad = 1 * Math.PI / 180;
            if (angleRad > (120 * Math.PI / 180)) angleRad = 120 * Math.PI / 180;
            const rIn = Math.max(0, R - L);
            const cosA = Math.cos(angleRad);
            const leftNeedOuter = rIn - (R * cosA);
            const leftNeedInner = rIn * (1 - cosA);
            const leftExtra = Math.max(0, rIn - B1, leftNeedOuter, leftNeedInner);
            const shapeH = (angleRad <= (Math.PI / 2)) ? Math.max(0, (R * Math.sin(angleRad))) : R;
            piece.width = Math.round(B1 + L + B2 + leftExtra);
            piece.height = Math.round((2 * B3) + shapeH);
            break;
          }
          case 926:
          case 926:
          case 2026:
          case 63: {
            const w = Number(piece.dxf_w || 0);
            const h = Number(piece.dxf_h || 0);
            const b1 = Number(piece.b1 || 0);
            const b2 = Number(piece.b2 || 0);
            const b3 = Number(piece.b3 || 0);
            const b4 = Number(piece.b4 || 0);
            piece.width = Math.round(b1 + w + b3);
            piece.height = Math.round(b2 + h + b4);
            break;
          }

          case 55:

            // console.log('-->> Calculando datos para fórmula FORMA 55 rectángulo esquinas curvas = ' + piece.figure);
            piece.width = piece.l + piece.b4 + piece.b2;
            piece.height = piece.b1 + piece.h + piece.b3;

            break;

          default:

            console.log('-->> Forma de catálogo no encontrada para el id = ' + piece.figure);
            break;
        }
      }

      if (piece.mat_id !== null) {

        if (piece.height > this.fileForm.controls.f_max_diecutting.value &&
      	    piece.width > this.fileForm.controls.f_max_diecutting.value) {

            piece_max_traverse = true;
        }

        // console.log('-->> Se obtiene el caballete que mejor se ajusta a la pieza: ' + piece.mat_id);

        // BORRAR: Ya se ordena más arriba.
        // Se ordenan los caballetes para probar primero los de dimensiones más pequeñas.
        // Así nos aseguramos de que el elegido sea al que menos espacio sobrará.
        // easelListIn = this.auxFunction.orderEaselByDimension(easelListIn);

        // Se recorren los caballetes en busca del que más se ajuste, es decir, el que menor cantidad de espacio deje libre.
        // NOTA: Lo mejor igual sería poner un campo de orden para seguir siempre la ordenación predeterminada que el usuario quiera.
        let easelOk = null;
        let count = 0;

        while (easelOk === null && easelListIn.length > count) {

          // console.log('- Probando caballete; '); // + easelListIn[count].name);
          // console.log(easelListIn[count]);

          // NOTA ORDEN: Se coloca como "ancho" la medida más pequeña y como "alto" la mayor.
          let widthAux = piece.width;
          let heightAux = piece.height;

          // if (widthAux > heightAux) {
		  if (widthAux < heightAux) {
            widthAux = piece.height;
            heightAux = piece.width;
          }

          // NOTA: Cuando se compara por rango (entre un mínimo y un máximo).
          // if (widthAux >= easelListIn[count].width &&
          //     widthAux <= easelListIn[count].max_width ) {

          // Cuando se compara sólo contra un máximo permitido.
          // NOTA: Se puede tener en cuenta aquí intentar buscar si existe otra familia con dos o más "pilas"
          // donde pueda caber también y convenga ese aprovechamiento (poner un parámetro "preferir apilaiento").
          if (widthAux <= easelListIn[count].max_width ) {
            // console.log('- El Ancho entra en caballete ' + easelListIn[count].id + '-' + easelListIn[count].name);

            // if (heightAux >= easelListIn[count].height &&
            //     heightAux <= easelListIn[count].max_height ) {
            if (heightAux <= easelListIn[count].max_height ) {
              // console.log('- El Alto entra en caballete ' + easelListIn[count].id + '-' + easelListIn[count].name);

              // Se elige ese caballete para colocar la pieza/entrada.
              easelOk = easelListIn[count];
            }
          }

          // Si se encuentra caballete no aumentamos el contador para fijar así su posición.
          if (!easelOk) {
            count++;
          }
        } // End while easelOk

        // console.log('-->> pieceToEasel easelOk:');
        // console.log(easelOk);

        // Si se ha podido elegir un caballete.
        if (easelOk) {

          piece.easel = Number(easelOk.id);

          // IMPORTANTE: Si el key_string estuviese compuesto sólo por números entonces a la hora
          // de acceder a él mediante la opción "NombreArray[key_string]" lo que hace es que crea
          // un array con esa cantidad de elementos y lo guarda en el último. Esto es peligroso.
          // Por esta razó se coloca un sufijo delante hecho de caracteres para asegurar que sea
          // una cadena lo que se use como identificador de acceso.

          // NOTA: Como la pieza puede haber cambiado de familia de caballete entonces se vuelve
          // a construir su identificador de "grupo de optimización" ya que influye en su valor.
          // IMPORTANTE: Aquí se forma la cadena identificadora que se
          // usará para diferenciar todos los grupos de optimización.

          let group_number = '';

          // Si se quiere tener en cuenta los "pasos de trabajo" para diferenciar grupos.
          if (this.fileForm.controls.f_rute.value) {
            group_number = piece['priority'].toString() + // Para tener en cuenta la "prioridad"
                           //  piece['orderno'].toString() + // Para tener en cuenta el "pedido"
                           //  piece['packing'].toString() + // Para diferenciar por "tipo embalaje" (caballete)
                           piece['lot'].toString() + // Para diferenciar por Lote.
                           piece['easel'].toString() + // Para tener en la familia de embalaje "tipo de caballete"
                           piece['steps'].toString(); // Par tener en cuenta "pasos/procesos" aplicados a la pieza.
                          //  piece['route'].toString(); // Para tener en cuenta la "ruta/pasos" de la linea que seguirá la pieza.
          } else {
            group_number = piece['priority'].toString() +
                           piece['lot'].toString() +
                           piece['easel'].toString();
                          //  piece['route'].toString();
          }

          // Modificamos el valor del "grupo de optimización" de la pieza con el nuevo valor después de haber asignado el caballete.
          piece['group'] = group_number; // piece.group;

          let key_string = group_number.toString(); // piece.group.toString();

          // console.log(' -> * pieceToEasel group_number = key_string = ' + group_number);
          // console.log(piece['group']);

          // Metros cuadrados de la pieza (una unidad).
          let m2Aux = Number(((piece.width * piece.height) / 1000000));

          let depthAux = Number(piece.stock_length);

          // console.log(' -> * depthAux = ' + depthAux);

          // Peso aproximado de la pieza (una unidad).
          let weightAux = Number(m2Aux * this.kg_m2 * depthAux);

          // Se incluye el elemento en el lugar correspondiente del array final del "grupo".
          if (groupEaselList[key_string] === undefined || groupEaselList[key_string] === null) {

            // Se inicializa incluyendo los metros cuadrados de todas las unidades que hay del elemento.
			// console.log('Se añade un nuevo grupo = ' + key_string);

            groupEaselList[key_string] = {
              m2: m2Aux * Number(piece.units),
              weight: weightAux * Number(piece.units),
              thickness: depthAux * Number(piece.units),
              separator: easelOk.separator,
              unitAuxByWeight: 0, // Unidades de ese tipo de caballete que se van a necesitar según peso.
              unitAuxByThickness: 0, // Unidades de ese tipo de caballete que se van a necesitar según espesor.
              unitProducts: Number(piece.units),
              actualUnit: 0, // Número de piezas (de cualquier tipo y tamaño) que lleva albergado el caballete.
              actualWeight: 0, // Total de peso acumulado en el caballete vigente.
              actualWidth: 0, // Total de ancho acumulado en el caballete vigente (por si existen varias pilas).
              actualDepth: 0, // Total de profundidad acumulada en el caballete vigente.
              actualSide: 1, // Lado actual usado en el caballete vigente.
              actualStack: 1, // Pila actual usada en el caballete vigente.
              actualStackDepth: 1, // Indica el "espesor máximo" alcanzado en la pila vigente.
              actualRow: 1, // Fila, por si dentro de una pila se pudiese colocar encima piezas ("Remontar").
              actualIndex: 1,
              flip: false,
              units: 0,
              family: easelOk.family,
              item: easelOk
            };
          } else {
            // Se suma el peso del elmento al caballete donde se va a meter.
            // Luego ya se comprobará realmente cuántos embalajes de ese tipo serán
            // necearios para contener todos los metros cuadrados asignados.
            groupEaselList[key_string].m2 += m2Aux * Number(piece.units);
            groupEaselList[key_string].weight += weightAux * Number(piece.units);
            groupEaselList[key_string].thickness += depthAux * Number(piece.units);
            groupEaselList[key_string].unitProducts += Number(piece.units);
          }

        } else {
          console.log('-->> pieceToEasel: No se ha encontrado caballete para la pieza:');
          console.log(piece)

		  no_easel_piece = true;

          piece.group = 'Z';

          // Metros cuadrados de la pieza (una unidad).
          let m2Aux = Number(((piece.width * piece.height) / 1000000));

          let depthAux = Number(piece.stock_length);

          // Peso aproximado de la pieza (una unidad).
          let weightAux = Number(m2Aux * this.kg_m2 * depthAux);

          let easelOkSpecial = {
            id: 0,
            name: 'Especial',
            desc: 'Caballete especial para cualquier medida de pieza.',
            type: 22,
            family: 26,
            sides: 1,
            staks: 1,
            width: 1200,
            height: 1700,
            depth: 600,
            weight: 120,
            max_width: 9999,
            max_height: 9999,
            max_weight: 2000,
            thickness: 550,
            separator: 0,
            utilization: 0,
            safety_margin: 0,
            active: 0
          }

          groupEaselList['Z'] = {
            m2: m2Aux * Number(piece.units),
            weight: weightAux * Number(piece.units),
            thickness: depthAux * Number(piece.units),
            separator: easelOkSpecial.separator,
            unitAuxByWeight: 0, // Unidades de ese tipo de caballete que se van a necesitar según peso.
            unitAuxByThickness: 0, // Unidades de ese tipo de caballete que se van a necesitar según espesor.
            unitProducts: Number(piece.units),
            actualUnit: 0, // Número de piezas (de cualquier tipo y tamaño) que lleva albergado el caballete.
            actualWeight: 0, // Total de peso acumulado en el caballete vigente.
            actualWidth: 0, // Total de ancho acumulado en el caballete vigente (por si existen varias pilas).
            actualDepth: 0, // Total de profundidad acumulada en el caballete vigente.
            actualSide: 1, // Lado actual usado en el caballete vigente.
            actualStack: 1, // Pila actual usada en el caballete vigente.
            actualStackDepth: 1, // Indica el "espesor máximo" alcanzado en la pila vigente.
            actualRow: 1, // Fila, por si dentro de una pila se pudiese colocar encima piezas ("Remontar").
            actualIndex: 1,
            flip: false,
            units: 0,
            family: easelOkSpecial.family,
            item: easelOkSpecial
          };

          groupEaselList['Z'].m2 += m2Aux * Number(piece.units);
          groupEaselList['Z'].weight += weightAux * Number(piece.units);
          groupEaselList['Z'].thickness += depthAux * Number(piece.units);
          groupEaselList['Z'].unitProducts += Number(piece.units);

        } // End Else easelOk
      } else {
        console.log('-->> pieceToEasel: No existe material para la pieza:');
        console.log(piece);

        no_material_piece = true;

	    this.alertInfo += 'No existe material para la pieza: ' + piece.id;
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      }
    }); // End forEach piecesListIn

    this.alertInfo = '';

    // NOTA: Comprobaciones que NO detienen la optimización a pesar de que se cumplan.
	if (no_easel_piece) {
    	this.alertInfo += '<p>· Hay piezas para las que no se ha encontrado caballete donde poder albergarlas.</p>';
        this.alertInfo += '<p>Como solución temporal se les ha asignado a un caballete ficticio tipo ESPECIAL Z.</p>'
        this.alertInfo += '<p>&nbsp;</p>';
        this.addAutoBatchWarning('Hay piezas sin caballete válido; se asignaron a caballete especial Z.');
    }

    if (piece_max_traverse) {
        this.alertInfo += '<p>· Existen piezas que sobrepasan el ancho máximo de travera. No serán incluidas en la optimización.</p>';
		this.alertInfo += '<p>&nbsp;</p>';
        this.addAutoBatchWarning('Existen piezas que sobrepasan el ancho máximo de travera y no se incluyeron.');
	}

	if (no_material_piece) {
     	this.alertInfo += '<p>· Hay piezas para las que no se ha encontrado el material correspondiente.';
     	this.alertInfo += '<p>&nbsp;</p>';
        this.addAutoBatchWarning('Hay piezas sin material asociado y fueron excluidas.');
    }

    if (piece_max_traverse || no_easel_piece || no_material_piece) {
      	this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    }

    // IMPORTANTE: Con estas dos formas de recorrer el array
    // no funciona porque su longitud aparece siempre como cero.
    // groupEaselList.forEach( package_element => {
    // for ( let i = 0; i < groupEaselList.length; i++) {

    // --------------------------
    //  Creación de ficheros CSV
    // --------------------------

    // IMPORTANTE: Contador de posición para los nuevos atriles/embalajes.
    let countGroup = 0;
    ocupation = 0;

    let pieceToEaselList = [];

    let easel_list_count = 0;


	// ---------------
    // NOTA: Para poner un nombre identificador del grupo más simple.
    let new_name_group = [];

    let count_group = 0;
    // No se incluye la Z porque es la letra reservada para los caballetes especiales.
    let letters_group = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y'];

    // IMPORTANTE: Hay que contar "a mano" la cantidad de caballetes debido a que el tipo de array por
    // "prop" siempre va a tener una longitud "length" igual a cero aunque tenga varios elementos dentro.
    for (let prop in groupEaselList) {

      // console.log('-->> pieceToEasel groupEaselList: ' + prop);
      // console.log(groupEaselList[prop]);

      new_name_group[letters_group[count_group]] = groupEaselList[prop];
      new_name_group[letters_group[count_group]]['name_group'] = letters_group[count_group];

      groupEaselList[prop]['name_group'] = letters_group[count_group];

      count_group++;

      if (groupEaselList[prop]) {
        easel_list_count++;
      }
    }

    // console.log('**-> pieceToEasel new_name_group:');
    // console.log(new_name_group);

    groupEaselList = new_name_group;

	// NOTA: Comprobaciones que SI detienen la optimización si se cumplen.
    // Si no hay caballete alguno seleccionado entonces se sale directamente de la función.
    if (easel_list_count === 0) {

      console.log('-->> pieceToEasel: No se ha encontrado ningún caballete apropiado para las piezas.');

      this.alertInfo += 'No se ha encontrado ningún caballete apropiado para las piezas. ';
      this.alertInfo += 'Compruebe los caballetes dados de alta para verificar que exista ';
      this.alertInfo += 'alguno capaz de soportar las medidas de las piezas.';

      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      // Indicamos globalmente que no hay listado de caballetes.
      this.local_pieceToEaselList = pieceToEaselList;

      return [groupEaselList, pieceToEaselList];
    }

    // *!* IMPORTANTE: Indicar un ORDEN en el que van a ir pasando las piezas en la optimización.
    // Este es el único lugar donde de verdad influye la ordenación que se le haga a las piezas.

    // console.log('-->> pieceToEasel piecesListIn A:');
    // console.log(JSON.parse(JSON.stringify(piecesListIn)));

    // Según el modo se elige una forma de ordenar las piezas inicialmente.
    // Este orden marca cómo irán entrando y colocándose en la máquina.
    if (Number(modeIn) === 3) {

		console.log('-->> pieceToEasel: Ordenación piezas para MODO 3.');

		// Se ordenan las piezas según estos campos: "BATCHNO,BATCHSEQ,PANENO".
	    // Valor del segundo parámetro a "true" para que se coloquen primero las piezas
	    // con mayor secuencia para que al sacarlas vayan al fondo del caballete.
		piecesListIn = this.opti.orderByLot(piecesListIn, '',  true);
	} else {

		console.log('-->> pieceToEasel: Ordenación piezas para MODO 1 y MODO 2.');

		// NOTA ORDEN: Ordenamos el listado de piezas para que salgan según algún criterio de preparación.
	    piecesListIn = this.opti.preparePieceOrder(piecesListIn);
		// piecesListIn = this.opti.orderByRotateHorizontal(piecesListIn, 'width', 'height', true, true);
	}
	piecesListIn = this.opti.applyUrgencyPreference(piecesListIn);
	// Las estrategias OEF pueden necesitar un primitivo ancla (el brazo
	// vertical de la L) antes que el orden genérico por dimensiones/lote.
	piecesListIn = this.orderOefRowsByLayoutPriority(piecesListIn);

    // console.log('-->> pieceToEasel piecesListIn B:');
    // console.log(JSON.parse(JSON.stringify(piecesListIn)));

    // ---------------
    // NOTA: Para poner un nombre identificador del grupo más simple.
    let new_resultList = [];

    let count = 0;

    piecesListIn.forEach((item, index) => {

      new_resultList['g_' + item.group] = index;

    });

    for (let prop in new_resultList) {
      new_resultList[prop] = letters_group[count];
      count++;
    }

    // console.log('**-> pieceToEasel new_resultList:');
    // console.log(new_resultList);

    let resultList_final = [];

    piecesListIn.forEach((item, index) => {

      item.group = new_resultList['g_' + item.group];

      // VOLTEOS -------
      // Añadimos el campo que va a indicar si el conjunto de pasos que
      // se aplican a cada grupo implica un "volteo" del orden de salida.
      let steps = item.steps.split('-');

      let flip_count = 0;

      if (steps && steps.length > 1) {
        steps.forEach( stp => {

          // console.log('--> calculateGroupOptimization paso acronym:');
          // console.log(stp);

          let step_aux = this.workstepsList.find(w => w.acronym === stp);

          // console.log('--> step_aux: ');
          // console.log(step_aux);

          if (step_aux && step_aux.flip) {
            // console.log('--> Se añade volteo a la cuenta por el proceso: ');
            // console.log(step_aux);
            flip_count++;
          }

        });
      }

      // console.log('--> Números de volteos: ' + flip_count);

      let group_flip = false;

      if (flip_count % 2 === 0) {
        // console.log('--> volteo PAR. No hay que invertir la secuencia. ' + flip_count % 2);
      } else {
        // console.log('--> volteo IMPAR. Hay que invertir la secuencia. ' + flip_count % 2);
        group_flip = true;
      }

      item['step_flip'] = group_flip;

      // ---------------

      resultList_final.push(item);

    }); // End ForEach piecesListIn.

	// Si el modo es 3 aquí aparecerán las piezas bien ordenadas
	// por lote y secuencia ascendente.

    // console.log('--> pieceToEasel resultList_final:');
    // console.log(resultList_final);

    piecesListIn = resultList_final;

    // --------------- */

    piecesListIn.forEach( (piece, i) => {

      // Añadimos a la entrada/pieza un campo más llamado "unitIncluded"
      // que nos va a servir para saber cuántas unidades se han asignado
      // a un caballete.
      piece['unitIncluded'] = 0;
      piece['weightIncluded'] = 0;
      piece['thicknessIncluded'] = 0;

      // console.log('-----------------------------------------------');
      // console.log('               POSICIÓN ' + piecesListIn[prop].item.group_id + '                ');
      // console.log('-----------------------------------------------');
      // console.log(' ; ; ; ; ');
      // console.log('Posición;Id Elemento;Medidas;Atril Id;Familia');

      // Metros cuadrados de la pieza (una unidad).
      let m2Aux = Number(((piece.width * piece.height) / 1000000));

      let depthAux = Number(piece.stock_length);
      let widthAux = Number(piece.width);

      // Peso aproximado de la pieza (una unidad).
      let weightAux = Number(m2Aux * this.kg_m2 * depthAux);

      // La primera línea del CSV va a ser el nombre de las columnas.
      easelCSV = easelCSV.concat(' ; ; ; ; \n', 'Grupo;Pieza;Medidas;Id caballete;Tipo caballete\n');

      // piecesListIn[prop].item.info3.split('_');

      let key_string2 = piece.group.toString(); // + '_' + easelOk.id;

      // console.log('-->> pieceToEasel key_string2: ' + key_string2);

      // Se va asignando unidad a unidad de los productos contabilizables a un caballete concreto.
      // En piezas OEF compuestas cargadas desde BD se puede visualizar units>1 en la pestaña
      // pero su colocación en hoja debe tratarse como 1 primitivo compuesto.
      // En apilado/easel se trabaja por "packs" OEF, no por unidades internas del polígono.
      const runtimeUnits = this.isOefCompositeItem(piece)
        ? this.getOefPackUnits(piece)
        : this.getSelectedPieceUnits(piece);
      for (let i = 1; i <= runtimeUnits; i++) {

        groupEaselList[key_string2].actualUnit++;

        // NOTA: aquí se va a tener en cuenta cuantos "lados" va a tener el caballete (uno o dos)
        // y cada lado cuántas pilas de elementos se permite (actualmente 1 o 2 sólamente).

        // Si es el primer elemento no lleva separador, se suma sólo el espesor y el ancho del elemento.
        if (groupEaselList[key_string2].actualDepth === null ||
            groupEaselList[key_string2].actualDepth === undefined ||
            groupEaselList[key_string2].actualDepth === 0) {

              groupEaselList[key_string2].actualDepth = Number(depthAux);
              groupEaselList[key_string2].actualWidth = widthAux;

        } else { // Else -> 1.

          // Si al sumar el ancho se pasa el ancho permitido por el caballete habrá que colocar la pieza en la primera pila.
          // Si no se supera entonces se pasa a la siguiente pila.
          if (groupEaselList[key_string2].actualWidth + widthAux > groupEaselList[key_string2].item.max_width ) {

            // console.log(' -> La colocación de la pieza supera el ancho permitido por el caballete');

            // Pasamos a la primera pila.
            groupEaselList[key_string2].actualStack = 1;

            // Fijamos el ancho altual al de la pieza.
            groupEaselList[key_string2].actualWidth = widthAux;

            // Para los siguientes elementos primero sumamos el espesor del separador y comprobamos que cabe.
            groupEaselList[key_string2].actualDepth += Number(groupEaselList[key_string2].separator);

          } else { // Aún queda ancho en el caballete.

            // Si estamos en la última pila.
            if (groupEaselList[key_string2].actualStack + 1 > groupEaselList[key_string2].item.stacks) {

              // console.log(' -> La colocación de la pieza supera el número de pilas permitido por el caballete.');
              // Pasamos a la primera pila.
              groupEaselList[key_string2].actualStack = 1;

              // Fijamos el ancho altual al de la pieza.
              groupEaselList[key_string2].actualWidth = widthAux;

              // Sumamos el espesor del separador.
              groupEaselList[key_string2].actualDepth += Number(groupEaselList[key_string2].separator);
            } else {
              // Pasamos a la siguiente pila, por lo que no hay que sumar ni el espesor del elemento ni
              // del separador porque ya se hizo cuando colocamos en la primera pila y de momento eso basta.
              groupEaselList[key_string2].actualStack++;
            }
          } // Fin else actualWidth

          // Se calcula la profundidad que corresponde a cada lado del caballete.
          let depthSide = groupEaselList[key_string2].item.depth / groupEaselList[key_string2].item.sides;

          // Se comprueba si se ha pasado de la mitad de capacidad de espesor del primer lado del caballete.
          if (groupEaselList[key_string2].actualDepth > depthSide &&
            groupEaselList[key_string2].actualDepth < depthSide + groupEaselList[key_string2].separator) {
              // Se ha sobrepasado la primera mitad y no cabe ni el separador, así que se pasa al segundo lado.
              // Se quita el espesor del separador que hemos sumado antes y se pone sólo el espesor del elemento.
              groupEaselList[key_string2].actualDepth += (Number(depthAux) - Number(groupEaselList[key_string2].separator));
              groupEaselList[key_string2].actualSide++;

              // console.log(' Se ha llenado cambiado de lado A...');
          } else { // Else -> 2.
            // El separador ha cabido por lo que ahora se intenta colocar el elemento.
            groupEaselList[key_string2].actualDepth += Number(depthAux);

            // Se comprueba si se ha pasado de la mitad de capacidad de espesor del primer lado del atril.
            if (groupEaselList[key_string2].actualDepth > depthSide &&
              groupEaselList[key_string2].actualDepth < depthSide + depthAux) {

              groupEaselList[key_string2].actualSide++;
              // console.log(' Se ha llenado cambiado de lado B...');

              // Al meter el elemento se ha sobrepasado el primer lado. Entonces quitamos el valor del separador
              // al añadir el espesor del elemento, ya que al colocarlo en el otro lado no va a necesitar separador.
              groupEaselList[key_string2].actualDepth -= groupEaselList[key_string2].separator;

            }
          } // End Else -> 2.
        } // End Else -> 1.

        groupEaselList[key_string2].actualWeight += weightAux;
        groupEaselList[key_string2].actualWidth += widthAux;
        piece['unitIncluded']++;

        // Incrementamos también el total de peso y espesor del producto incluido ya en caballetes.
        piece['weightIncluded'] += weightAux;
        piece['thicknessIncluded'] += Number(depthAux);

        // console.log('· Comparar actualDepth = ' + groupEaselList[key_string2].actualDepth);
        // console.log('· Comparar actualWeight = ' + groupEaselList[key_string2].actualWeight);

        // NOTA: Si tenemos en cuenta el peso y el espesor para pasar a otro atril.
        // Si se pasa por peso o por espesor los límites del caballete entonces hay que añadir otro más.
        if (groupEaselList[key_string2].actualWeight > groupEaselList[key_string2].item.max_weight ||
            groupEaselList[key_string2].actualDepth > groupEaselList[key_string2].item.thickness) {

          console.log(' Se ha pasado a otro caballete por peso o por espesor:');
          // console.log(' -> actualWeight = ' + groupEaselList[key_string2].actualWeight +
          //              ' -> max_weight = ' + groupEaselList[key_string2].item.max_weight);
          // console.log(' -> actualDepth = ' + groupEaselList[key_string2].actualDepth +
          //              ' -> length_max = ' + groupEaselList[key_string2].item.thickness);

          // console.log(groupEaselList[key_string2]);
          // console.log(groupEaselList[key_string2].item);

          groupEaselList[key_string2].actualUnit = 1;
          groupEaselList[key_string2].actualWeight = weightAux;
          // Al ser el primero no se suma separador.
          groupEaselList[key_string2].actualDepth = Number(depthAux);

          // Se suma uno al indicador que cuenta los caballetes de este tipo y familia que hacen falta.
          groupEaselList[key_string2].actualIndex++;
          // Se indica que el lado del caballete va a ser el primero y la pila también la primera.
          groupEaselList[key_string2].actualSide = 1;
          groupEaselList[key_string2].actualStack = 1;
        }

        // console.log('-----------------------------------------------');
        // console.log('->> Posición: ' + piecesListIn[prop].item.group_id + ' Id_Elemento:' + piecesListIn[prop].item.group_id + '_' + i +
        //             '- Medidas:' + piecesListIn[prop].item.stockwidth + ' x ' + piecesListIn[prop].item.stockheight +
        //             '->> Atril id = ' + groupEaselList[key_string2].item.id + '_' + groupEaselList[key_string2].actualIndex + ' - Familia: ' + groupEaselList[key_string2].item.name);

        // console.log(piecesListIn[prop].item.group_id + ';' +
        //             piecesListIn[prop].item.group_id + '_' + i + ';' +
        //             piecesListIn[prop].item.stockwidth + ' x ' + piecesListIn[prop].item.stockheight + ';' +
        //             groupEaselList[key_string2].item.id + '_' + groupEaselList[key_string2].actualIndex + ';' +
        //             groupEaselList[key_string2].item.name);

        // Los valores de cada columna del CSV se separan con ';' y el final del elemento se marca con '\n'.
        easelCSV = easelCSV.concat(
          piece.group + ';',
          i + ';',
          piece.width + ' x ' + piece.height + ';', // Se indican las dimensiones
          groupEaselList[key_string2].item.id + '_' + groupEaselList[key_string2].actualIndex + '_' + // Se indica el ID del caballete y número
          groupEaselList[key_string2].actualSide + '_' + groupEaselList[key_string2].actualStack + ';', // Se indica el lado y la pila.
          groupEaselList[key_string2].item.name + '\n'
        );

        // Se comprueba que existe un listado de piezas candidatas para el "grupo de optimización" que estamos tratando.
        // Si no es así se crea asignándole una lista inicialmente vacía.
        if (pieceToEaselList[key_string2] === undefined || pieceToEaselList[key_string2] === null) {

          pieceToEaselList[key_string2] = [];
        }

        // Se incrementa el contador de pieza.
        piece_count++;

        // console.log('--> pieceToEasel pieza añadida a caballete:');
    	// console.log(piece);

        // Añadimos a la contabilización la información de la pieza asignada y
        // su localización exacta (caballete en que se situa).
        pieceToEaselList[key_string2].push({
          easel_id: groupEaselList[key_string2].item.id,
          easel_num: groupEaselList[key_string2].actualIndex,
          easel_name: groupEaselList[key_string2].item.name,
          easel_side: groupEaselList[key_string2].actualSide,
          easel_stack: groupEaselList[key_string2].actualStack,
          easel_width: groupEaselList[key_string2].item.width,
          easel_height: groupEaselList[key_string2].item.height,
          easel_depth: groupEaselList[key_string2].item.depth,
          easel_weight: groupEaselList[key_string2].item.weight,
          easel_max_width: groupEaselList[key_string2].item.max_width,
          easel_max_height: groupEaselList[key_string2].item.max_height,
          easel_max_depth: groupEaselList[key_string2].item.thickness,
          easel_max_weight: groupEaselList[key_string2].item.max_weight,
          easel_separator: groupEaselList[key_string2].item.separator,
          easel_barcode: groupEaselList[key_string2].barcode,
          easel_flip: piece['step_flip'],
          piece_id: 0, // Inicialmente sin un ID asignado,
	          // Debe ser único por línea para evitar colisiones cuando OEF genera
	          // varias filas con mismo lote/secuencia (ej. 6+1, 3+2+2, etc.).
	          piece_name_id: piece.lot + '#' + piece.sequence + '@' + i + '/' + runtimeUnits +
              '|id:' + (piece.id !== undefined && piece.id !== null ? piece.id : 0) +
              '|ln:' + (piece.id_line !== undefined && piece.id_line !== null ? piece.id_line : 0) +
              '|f:' + (piece.figure !== undefined && piece.figure !== null ? piece.figure : 0),
          piece_steps: piece.steps.trim(),
          piece_mat_id: piece.mat_id,
          piece_material: piece.mat_name,
          piece_desc: piece.mat_desc,
          piece_width: piece.width,
          piece_height: piece.height,
          piece_area: (Number(piece.oef_effective_area) > 0 ? Number(piece.oef_effective_area) : (piece.width * piece.height)) / 1000000,
          piece_depth: piece.stock_length,
          piece_group: piece.group,
          piece_lot: piece.lot,
          piece_sequence: piece.sequence,
          piece_sequence_unit: i,
          piece_sequence_broked: false,
          piece_orderno: piece.orderno,
          piece_orderpos: piece.orderpos,
          piece_priority: Number(piece.priority) > 0 ? 1 : 0,
          piece_paneno: piece.paneno,
          piece_barcode: piece.barcode,
          piece_num: piece_count,
          piece_cut: false,
          piece_decoat: piece.decoat,
          piece_id_line: piece.id_line,
          piece_id_client: piece.id_client,
          piece_client: piece.client ? piece.client : '',
          // piece_unit: 1 // Siempre uno
          // Persistimos las unidades runtime reales para mantener coherencia al recargar.
          // total_unit debe conservar el total de packs del primitivo para no
          // contaminar recálculos posteriores (canvas/PDF) con multiplicaciones dobles.
          piece_total_unit: Number(runtimeUnits),
          piece_rotation: 0, // Inicialmente la rotación de la pieza es cero.
          piece_figure: piece.figure,
          piece_figure_input: piece.figure,
          piece_l: piece.l,
          piece_l1: piece.l1,
          piece_l2: piece.l2,
          piece_h: piece.h,
          piece_h1: piece.h1,
          piece_h2: piece.h2,
          piece_r: piece.r,
          piece_r2: piece.r2,
          piece_r3: piece.r3,
          piece_r4: piece.r4,
          piece_b1: piece.b1,
          piece_b2: piece.b2,
          piece_b3: piece.b3,
          piece_b4: piece.b4,
          piece_dxf_name: piece.dxf_name,
          piece_dxf_points: piece.dxf_points,
          piece_dxf_w: piece.dxf_w,
          piece_dxf_h: piece.dxf_h,
          piece_oef_internal_polygons: piece.oef_internal_polygons ? JSON.parse(JSON.stringify(piece.oef_internal_polygons)) : null,
          piece_oef_generated: piece.oef_generated === true || (Array.isArray(piece.oef_internal_polygons) && piece.oef_internal_polygons.length > 0),
          piece_oef_primitive_w: piece.oef_primitive_w ? Number(piece.oef_primitive_w) : 0,
          piece_oef_primitive_h: piece.oef_primitive_h ? Number(piece.oef_primitive_h) : 0,
          piece_oef_primitive_b1: Number(piece.oef_primitive_b1) > 0 ? Number(piece.oef_primitive_b1) : 0,
          piece_oef_primitive_b2: Number(piece.oef_primitive_b2) > 0 ? Number(piece.oef_primitive_b2) : 0,
          piece_oef_primitive_b3: Number(piece.oef_primitive_b3) > 0 ? Number(piece.oef_primitive_b3) : 0,
          piece_oef_primitive_b4: Number(piece.oef_primitive_b4) > 0 ? Number(piece.oef_primitive_b4) : 0,
          piece_oef_effective_area: Number(piece.oef_effective_area) > 0 ? Number(piece.oef_effective_area) : 0,
          piece_oef_lock_rotation: (piece as any).oef_lock_rotation === true,
          piece_oef_layout_priority: Number.isFinite(Number((piece as any).oef_layout_priority))
            ? Number((piece as any).oef_layout_priority)
            : 1,
          piece_oef_real_units: Math.max(
            1,
            Math.round(
              Number(
                (piece as any) && (
                  (piece as any).oef_real_units !== undefined
                    ? (piece as any).oef_real_units
                    : (
                      Array.isArray(piece && piece.oef_internal_polygons) && piece.oef_internal_polygons.length > 0
                        ? piece.oef_internal_polygons.length
                        : 1
                    )
                )
              ) || 1
            )
          ),
          piece_oef_base_unit_area: Number((piece as any) && (piece as any).oef_base_unit_area) > 0 ? Number((piece as any).oef_base_unit_area) : 0,
          piece_num_of: piece.num_of,
          piece_pos_of: piece.pos_of,
          piece_set: null,
          piece_matrix: null,
          piece_flip: false
        });

      } // End For units
    }); // End For groupEaselList

    for (let prop in groupEaselList) {

      // console.log('-->> pieceToEasel groupEaselList asignando grupo a caballetes: ' + prop);
      //console.log(groupEaselList[prop]);

      // let unitAuxByWeight = groupEaselList[prop]['weight'] / groupEaselList[prop]['family'].max_weight;
      // let unitAuxByThickness = (groupEaselList[prop]['thickness'] +
      //                       (groupEaselList[prop]['actualIndex'] * groupEaselList[prop]['separation']))
      //                       / groupEaselList[prop]['family'].length_max;

      // console.log('-->> unitAuxByWeight:');
      // console.log(unitAuxByWeight);

      // console.log('-->> unitAuxByThickness:');
      // console.log(unitAuxByThickness);

      // groupEaselList[prop].unitAuxByWeight = unitAuxByWeight;
      // groupEaselList[prop].unitAuxByThickness = unitAuxByThickness;

      // if (unitAuxByWeight >= unitAuxByThickness) {
      //   console.log('Elegidas unidades por peso = ' + unitAuxByWeight);

      //   groupEaselList[prop].item.unit = Math.ceil(unitAuxByWeight);
      // } else {
      //   console.log('Elegidas unidades por profundidad = ' + unitAuxByThickness);

      //   groupEaselList[prop].item.unit = Math.ceil(unitAuxByThickness);
      // }

      groupEaselList[prop].item.unit = Math.ceil(groupEaselList[prop]['actualIndex']);

      countGroup++;

      // Se asigna el que va a ser su identificador de "grupo".
      groupEaselList[prop].item.group_id = countGroup;


      // IMPORTANTE: O se hace de esta forma (creando un nuevo array y asignándole una copia
      // del item y la familia) o no actualiza bien en el item el contador para la posición.
      // finalPackageArray[prop] = {};
      // finalPackageArray[prop].item = JSON.parse(JSON.stringify(groupEaselList[prop].item));
      // finalPackageArray[prop].family = JSON.parse(JSON.stringify(groupEaselList[prop].family));

    } // End For groupEaselList // */

    // console.log('-->> pieceToEasel groupEaselList lista caballetes:');
    // console.log(groupEaselList);

    // console.log('-->> pieceToEasel pieceToEaselList localización de todas las piezas:');
    // console.log(pieceToEaselList);

    // console.log('-->> pieceToEasel finalPackageArray:');
    // console.log(finalPackageArray);


    // Finalmente se calcula cuántos fletes(camiones/contenedores) hacen falta
    // para meter todas las unidades de embalajes (atriles/jabas) calculadas (cada
    // familia de embalaje ocupa en el flete una proporción de espacio diferente).

    // console.log('-->> ocupation:' + this.ocupation);
    // console.log(Math.ceil(this.ocupation / 100));

    // console.log('-----------------------------------------------');
    // console.log('      ASIGNACIÓN DE CADA ATRIL A UN FLETE      ');
    // console.log('-----------------------------------------------');
    // console.log('-----------------------------------------------');

    // Vaciamos la variable Redux que guarda el array de datos de archivos.
    // this.resetFileList.emit();

    // Se mandan crear los archivos CSV que guardaran la información de la asignación
    // para la estimación del flete que se acaba de realizar. Son dos los archivos:
    // - Uno para la relación unidad de producto -> atril donde se mete.
    // - Uno para la relación unidad de atril -> camión/flete donde se mete.

    // NOTA: Instrucción para crear y escribir el fichero físico con la información.
    // console.log('-->> pieceToEasel: Se escribe el fichero csv_caballetes.csv');
    // this.makeCsvEaselPieceList('csv_caballetes.csv', easelCSV);

    // -------------------------------------
    //  Creación del Catálogo de las piezas
    // -------------------------------------

    let pieceCatalog = [];
    let catalogList = [];
    let id_count = 0;

    for (let prop in pieceToEaselList) {
      pieceToEaselList[prop].forEach((piece, index) => {
        // console.log('-->> pieceCatalog piece:');
    	// console.log(piece);

        const geometryKey = [
          piece.piece_figure_input,
          piece.piece_l,
          piece.piece_l1,
          piece.piece_l2,
          piece.piece_h,
          piece.piece_h1,
          piece.piece_h2,
          piece.piece_r,
          piece.piece_r2,
          piece.piece_r3,
          piece.piece_r4,
          piece.piece_b1,
          piece.piece_b2,
          piece.piece_b3,
          piece.piece_b4,
          piece.piece_dxf_name
        ].join('|');

    	let key_string = piece.piece_mat_id + ' ' + piece.piece_group  + piece.easel_num + ' ' + piece.piece_width + ' x ' + piece.piece_height + ' ' + geometryKey;
    	let key_string2 = piece.piece_mat_id + ' ' + piece.piece_group  + piece.easel_num + ' ' + piece.piece_height + ' x ' + piece.piece_width + ' ' + geometryKey;
	      if(!pieceCatalog[key_string] && !pieceCatalog[key_string2]) {
            // Se incrementa el contador de ID.
            id_count++;
            piece.piece_id = id_count;
	        pieceCatalog[key_string] = {id: id_count, num: 1, key: key_string};
	      } else if (pieceCatalog[key_string] || pieceCatalog[key_string2]) {

    		if (pieceCatalog[key_string2]) {
				pieceCatalog[key_string2].num++;
          		piece.piece_id = pieceCatalog[key_string2].id;
			} else {
				pieceCatalog[key_string].num++;
          		piece.piece_id = pieceCatalog[key_string].id;
			}

          }
      });
    };
    // ------
    // Se da una vuelta para volver a asignar el paneno original
    // que tenían inicialmente cada pieza seleccionada.
    for (let prop in pieceToEaselList) {
      pieceToEaselList[prop].forEach((piece, index) => {
        // console.log('-->> piece paneno text:');
    	// console.log(piece);

    	let find_p = optimizationList_aux.find(px => {

    		if (px.lot === piece.piece_lot &&
				px.sequence === piece.piece_sequence &&
				// Number(px.mat_id) === Number(piece.piece_mat_id) &&
				Number(px.units) > 0
				// ((px.width === piece.piece_width && px.height === piece.piece_height) ||
				//  (px.width === piece.piece_height && px.height === piece.piece_width)) &&
				// px.orderpos === piece.piece_orderpos
			) {

				return true;
			}

			return false;
		});

    	// console.log('-->> piece paneno find:');
    	// console.log(find_p);

    	// Se le vuelve a poner el paneno original que tuviese la pieza antes
    	// de sumar las unidades y perder el valor inicial de su paneno.
    	if (find_p) {

			// console.log('-->> Se vuelve a poner el valor original del paneno en la pieza:');
    		// console.log(piece);
    		// console.log('-->> Pieza original recogida:');
    		// console.log(find_p);

			piece.piece_paneno = find_p.paneno;

			// Se quita una unidad. De este modo irá restando piezas
			// sin importar el valor del paneno. Cuando ya no queden
			// para ningún valor de paneno querrá decir que todas las
			// piezas que hay en los grupos tendrán repartidas todos
			// los valores de paneno iniciales nuevamente.
			find_p.units--;
		}
      });
    };
    // -------
    // console.log('**-> pieceCatalog final:');
    // console.log(pieceCatalog);

    for (let prop in pieceCatalog) {
      catalogList.push(pieceCatalog[prop])
    }

    // console.log('**-> pieceToEasel catalogList:');
    // console.log(catalogList.reverse());

    // Se devuelve la lista de grupos para los caballetes y la desglosada para la localización final de cada pieza.
    this.local_pieceToEaselList = pieceToEaselList;
    // console.log('**-> pieceToEasel local_pieceToEaselList:');
    // console.log(this.local_pieceToEaselList);

    // console.log('**-> pieceToEasel groupEaselList:');
    // console.log(groupEaselList);

    let easel_count = 0;

    // Se cuenta el total de caballetes que se han obtenido.
    for (let prop in groupEaselList) {

		let group_aux = groupEaselList[prop];

		// console.log('**-> pieceToEasel group_aux = ');
		// console.log(group_aux);

		easel_count+= group_aux.actualIndex;

	} // End For groupEaselList.

	// console.log('**-> pieceToEasel easel_count = ' + easel_count);

	// Se asigna el número de caballetes que inicialmente va a usar la optimización.
	this.total_area_C = easel_count;

	// console.log('**-> pieceToEasel groupEaselList = ');
	// console.log(groupEaselList);

	// console.log('**-> pieceToEasel pieceToEaselList = ');
	// console.log(pieceToEaselList);

    return [groupEaselList, pieceToEaselList];

  } // End function pieceToEasel

  // ------------
  // Función que devuelve la pieza más pequeña y más grande de la optimización.
  pieceMinMax(): any {

	// console.log('-->> pieceMinMax piecesListIn:');

	let piece_min;
	let piece_max;

	let piece_min_side;
	let piece_max_side;

	let min_side = 0;
	let max_side = 0;

	let min_area = 0;
	let max_area = 0;

    this.optimizationList.forEach((p, i) => {
		// console.log('-->> pieceMinMax p = ');
		// console.log(p);

		let piece_act = {w: p.width, h: p.height};

		if (p.height > p.width) {
			piece_act = {w: p.height, h: p.width};
		}

		let area_act = piece_act.w * piece_act.h;

		if (piece_act.w * piece_act.h < min_area || min_area === 0) {
			min_area = area_act;
			piece_min = piece_act;
		}

		if (piece_act.w * piece_act.h > max_area) {
			max_area = area_act;
			piece_max = piece_act;
		}

		if (i === 0) piece_min_side = piece_max_side = piece_act;

		if (piece_act.w >= max_side) {

			// console.log('-->> Pieza con lado mayor encontrada.');
			max_side = piece_act.w;

			if (piece_act.w === piece_max_side.w) {

				if (piece_act.h < piece_max_side.h) {
					// console.log('-->> Pero la actual tiene un alto mayor. Se actualiza.');
					piece_max_side = piece_act;
				}

			} else {
				piece_max_side = piece_act;
			}
		}

		if (piece_act.h <= min_side || min_side === 0) {

			// console.log('-->> Pieza con lado menor encontrada.');
			min_side = piece_act.h;

			if (piece_act.h === piece_min_side.h) {

				if (piece_act.w < piece_min_side.w) {
					// console.log('-->> Pero la actual tiene un ancho menor. Se actualiza.');
					piece_min_side = piece_act;
				}

			} else {
				piece_min_side = piece_act;
			}
		}
	});

	// console.log('-->> max_side w = ' + max_side);
	// console.log('-->> min_side h = ' + min_side);
	// console.log('-->> min_area = ' + min_area);
	// console.log('-->> max_area = ' + max_area);
	// console.log('-->> piece_min_side = ');
	// console.log(piece_min_side);
	// console.log('-->> piece_min = ');
	// console.log(piece_min);
	// console.log('-->> piece_max = ');
	// console.log(piece_max);

	// console.log('-->> piece_max_side = ');
	// console.log(piece_max_side);

	return [min_side, max_side, piece_min_side, piece_max_side, min_area, max_area, piece_min, piece_max];

  } // End function pieceMinMax

  // ------------

  // Función que coloca las piezas en caballetes teniendo en cuenta el orden
  // de salida de tronzado y el "lote y secuencia" que tiene cada una.
  cutPieceToEasel(piecesListIn: any[], easelListIn: Easel[], modeIn: number): any {

    console.log('-->> cutPieceToEasel piecesListIn que es this.cutTotalOrderList:');
    // console.log(piecesListIn);

    // console.log('-->> cutPieceToEasel easelListIn:');
    // console.log(easelListIn);

    // console.log('-->> cutPieceToEasel modeIn:');
    // console.log(modeIn);

    let easelCSV = '';
    let packageCSV = '';

    // Array en el que cada uno de sus elementos va a contener a su vez el
    // listado de los productos que caben dentro de la familia que representa.
    // let finalPackageArray = [];
    let groupEaselList = [];
    let pieceEaselList = [];

    let ocupation = 0;

    // console.log('-----------------------------------------');
    // console.log('   ASIGNACIÓN PIEZA CORTADA - CABALLETE  ');
    // console.log('-----------------------------------------');

    // Se inicializa el contador de piezas.
    let piece_count = 0;

    let pieceToEaselList = [];

    let only_pieces = piecesListIn.filter(p => p.type === 'P');

/*  // --------- Intercambiar piezas similares según secuencia --------
    // Por ahora no lo hace bien.

    only_pieces.forEach( (piece, i) => {
		console.log(i + ' -> list 1 N = ' + piece.num + ' -> ' + piece.name_id);
	});

    // Intercambiamos piezas que sean iguales pero que tengan
    // un número de secuencia mayor que otra que aparezca primero.
    only_pieces.forEach( (piece, i) => {

		let index_similar = -1;

		let similar_list = only_pieces.find((pr, ind) => {
			if (pr.name_id !== piece.name_id &&
			 	pr.width === piece.width && pr.height === piece.height &&
			 	pr.lot === piece.lot && pr.sequence > piece.sequence &&
			 	pr.cut_order > piece.cut_order) {

				index_similar = ind;
				return true;
			}

			return false;
		});

		if (similar_list) {

			console.log('-> pieza similar encontrada para sustituir = ' + index_similar);
			console.log(similar_list);
			console.log('-> pieza intercambiada = ' + i);
			console.log(piece);

			// Se guarda su orden de corte original.
			let cut_order_piece = piece.cut_order;
			let cut_order_similar = similar_list.cut_order;

			// Se intercambian de posición.
			let similar_aux = JSON.parse(JSON.stringify(only_pieces[index_similar]));
			let piece_aux = JSON.parse(JSON.stringify(piece));

			only_pieces[index_similar] = JSON.parse(JSON.stringify(piece_aux));
			only_pieces[i] = JSON.parse(JSON.stringify(similar_aux));

			// Se coloca el número de orden original para mantenerlo.
			only_pieces[index_similar].cut_order = cut_order_similar;
			only_pieces[i].cut_order = cut_order_piece;
		}
	});

	only_pieces.forEach( (piece, i) => {
		console.log(i + ' -> list 2 N = ' + piece.num + ' -> ' + piece.name_id);
	});
	// --------- FIN Intercambiar piezas similares según secuencia ---------- // */

    // Se recorren todos los elementos (piezas) para indicarles la localización exacta del caballete al
    // que serán destinados (el tipo de familia y el grupo ya se averiguaron y lo llevan ya indicados aquí).
    only_pieces.forEach( (piece, i_pieces) => {

      // console.log('-->> cutPieceToEasel Tramitando entrada de pieza para asignar caballete:');
      // console.log(piece);

      // Se comprueba si la pieza va en un caballete ESPECIAL Z (su id es cero).
      // if (piece.easel_id === 0) {
	  // 	console.log('-->> Pieza a caballete especial.');
      // }

      let easelOk = easelListIn.find(p => p.id === piece.easel_id);

      let easelOkSpecial = null;

      // ------- caballete ESPECIAL Z

      if (!easelOk) {
        console.log('-->> cutPieceToEasel: No se ha encontrado caballete para la pieza:');
        console.log(piece);

        piece.group = 'Z';

        // Metros cuadrados de la pieza (una unidad).
        let m2Aux = Number(((piece.width * piece.height) / 1000000));

        let depthAux = Number(piece.stock_length);

        // Peso aproximado de la pieza (una unidad).
        let weightAux = Number(m2Aux * this.kg_m2 * depthAux);

        easelOkSpecial = {
          id: 0,
          name: 'Especial',
          desc: 'Caballete especial para cualquier medida de pieza.',
          type: 22,
          family: 26,
          sides: 1,
          staks: 1,
          width: 1200,
          height: 1700,
          depth: 600,
          weight: 120,
          max_width: 9999,
          max_height: 9999,
          max_weight: 2000,
          thickness: 550,
          separator: 0,
          utilization: 0,
          safety_margin: 0,
          active: 0
        }

        easelOk = easelOkSpecial;

        // groupEaselList['Z'] = {
        //   m2: m2Aux * Number(piece.units),
        //   weight: weightAux * Number(piece.units),
        //   thickness: depthAux * Number(piece.units),
        //   separator: easelOkSpecial.separator,
        //   unitAuxByWeight: 0, // Unidades de ese tipo de caballete que se van a necesitar según peso.
        //   unitAuxByThickness: 0, // Unidades de ese tipo de caballete que se van a necesitar según espesor.
        //   unitProducts: Number(piece.units),
        //   actualUnit: 0, // Número de piezas (de cualquier tipo y tamaño) que lleva albergado el caballete.
        //   actualWeight: 0, // Total de peso acumulado en el caballete vigente.
        //   actualWidth: 0, // Total de ancho acumulado en el caballete vigente (por si existen varias pilas).
        //   actualDepth: 0, // Total de profundidad acumulada en el caballete vigente.
        //   actualSide: 1, // Lado actual usado en el caballete vigente.
        //   actualStack: 1, // Pila actual usada en el caballete vigente.
        //   actualStackDepth: 1, // Indica el "espesor máximo" alcanzado en la pila vigente.
        //   actualRow: 1, // Fila, por si dentro de una pila se pudiese colocar encima piezas ("Remontar").
        //   actualIndex: 1,
        //   flip: false,
        //   units: 0,
        //   family: easelOkSpecial.family,
        //   item: easelOkSpecial
        // };

        // groupEaselList['Z'].m2 += m2Aux * Number(piece.units);
        // groupEaselList['Z'].weight += weightAux * Number(piece.units);
        // groupEaselList['Z'].thickness += depthAux * Number(piece.units);
        // groupEaselList['Z'].unitProducts += Number(piece.units);

        // this.alertInfo = 'Hay piezas para las que no se ha encontrado caballete donde poder albergarlas. ';
        // this.alertInfo += ' Como solución temporal se les ha asignado a un caballete ficticio tipo ESPECIAL Z.'
        // this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      } else {
        easelOkSpecial = easelOk;
      }// End Else easelOk


      // ------- Fin caballete ESPECIAL Z

      // console.log('-->> cutPieceToEasel tipo caballete asignado a la pieza:');
      // console.log(easelOk);

      // Tiene que tener grupo y material (indicadores que es un elemento "pieza") .
      if (piece.group && piece.mat_id !== null) {

		// ------- MODO ASIGNACIÓN DE CABALLETES -------
	  	let easel_short_mode = Number(modeIn);

	  	// Número máximo de piezas con "secuencia rota" que un
	  	// caballete va a poder tener apoyadas a su lado.
	  	let max_broken_seq = Number(this.fileForm.controls.f_grade.value);

	  	// Número máximo de piezas con secuencia rota repetida.
	  	let max_rep_seq = Number(this.fileForm.controls.f_grade_rep.value);

		if (easel_short_mode === 2 || easel_short_mode === 3) {

			// console.log(' -> * Modo ordenación 2 y 3.');

			// El lugar que ocupa dentro de la pila será inicialmente 0 porque aún no está colocada.
	        piece['stack_num'] = 0;

	        let key_string = piece.group.toString();

	        // Metros cuadrados de la pieza (una unidad).
	        let m2Aux = Number(((piece.width * piece.height) / 1000000));

	        let depthAux = Number(piece.depth);

	        // console.log(' -> * depthAux = ' + depthAux);

	        // Peso aproximado de la pieza (una unidad).
	        let weightAux = Number(m2Aux * this.kg_m2 * depthAux);

	        // Se incluye el elemento en el lugar correspondiente del array final del "grupo".
	        if (groupEaselList[key_string] === undefined || groupEaselList[key_string] === null) {
	          // Se inicializa incluyendo los metros cuadrados de todas las unidades que hay del elemento.
			  // console.log ('Piece easel = ');
			  // console.log(piece);

	          groupEaselList[key_string] = {
	            m2: m2Aux * Number(piece.total_unit), // Number(piece.total_paneno),
	            weight: weightAux * Number(piece.total_unit), // Number(piece.total_paneno),
	            thickness: depthAux * Number(piece.total_unit), // Number(piece.total_paneno),
	            separator: piece.separator,
	            unitAuxByWeight: 0, // Unidades de ese tipo de caballete que se van a necesitar según peso.
	            unitAuxByThickness: 0, // Unidades de ese tipo de caballete que se van a necesitar según espesor.
	            unitProducts: Number(piece.total_unit), // Number(piece.total_paneno),
	            actualUnit: 0, // Número de piezas (de cualquier tipo y tamaño) que lleva albergado el grupo.
	            actualWeight: 0, // Total de peso acumulado en el caballete vigente.
	            actualWidth: 0, // Total de ancho acumulado en el caballete vigente (por si existen varias pilas).
	            actualDepth: 0, // Total de profundidad acumulada en el caballete vigente.
	            actualSide: 1, // Lado actual usado en el caballete vigente.
	            actualStack: 1, // Pila actual usada en el caballete vigente.
	            actualStackDepth: 1, // Indica el "espesor máximo" alcanzado en la pila vigente.
	            actualRow: 1, // Fila, por si dentro de una pila se pudiese colocar encima piezas ("Remontar").
	            actualIndex: 1,
	            flip: piece.easel_flip,
	            units: 0, // Número de aballetes
	            family: easelOkSpecial.family,
	            item: easelOkSpecial,
	            // Para el control de secuencias.
	            easels: []
	          };

	          let new_sequence_aux = (piece.total_unit === 1 ? true : false);

	          groupEaselList[key_string].easels.push({

	            lot: piece.lot, // Lote de la pieza. Un caballete sólo puede tener piezas de un único lote.
	            actualSequence: piece.sequence, // Secuencia actual (en orden) que lleva este caballete en su interior.
	            actualUnitSequence: 1, // Cuenta el número de unidades que se llavan almacenadas en la secuencia actual.
	            actualFinalSequence: Number(piece.total_unit), // Número total de unidades que completa la secuencia actual.
	            aceptNewSequence: new_sequence_aux, // Indica si el caballete acepta piezas de un secuencia distinta a su actual.
	            actualUnit: 1, // Número de piezas (de cualquier tipo y tamaño) que lleva albergado este caballete.
	            sequences: [piece.sequence], // Contiene las secuencias que ha ido almacenando este caballete.
	            pieces: [piece.name_id], // Contiene el identificador de las piezas que alberga este caballete.
	            completed: false, // Se pondrá a "true" cuando el caballete esté completo por peso o por espesor.
	            easel_num: 1, // Va a ser el primer caballete del grupo.
	            broken_seq: [],
	            thickness: depthAux,
	            weight: weightAux,
	            flip: piece.easel_flip
	          });

	          // Indicar el orden de pila para este caso de inicio de "grupo/caballete".
	          piece['stack_num'] = 1;
	          // Indicar el nombre identificador del caballete.
	          piece['easel'] = piece.group + '' + 1;
	          // Identificar el número de caballete dentro de su grupo.
	          piece['easel_num'] = 1;

	        } else {  // End If groupEaselList[key_string]
	          // Se suma el peso del elmento al caballete donde se va a meter.
	          // Luego ya se comprobará realmente cuántos caballetes de ese tipo serán
	          // necearios para contener todos los metros cuadrados asignados.
	          groupEaselList[key_string].m2 += m2Aux * Number(piece.total_unit);
	          groupEaselList[key_string].weight += weightAux;
	          groupEaselList[key_string].thickness += depthAux;
	          groupEaselList[key_string].unitProducts += Number(piece.total_unit);

	          let selected_easel = null;
	          let candidated_easel = null;

	          // let max_easels = 3;
	          // let new_easel_needed = false;

	          selected_easel = groupEaselList[key_string].easels.find( e =>

	                                e.lot === piece.lot &&
	                                e.actualSequence === piece.sequence &&
	                                !e.completed &&
	                                ((e.thickness + depthAux) <= groupEaselList[key_string].item.thickness));

			  /*
			  // NOTA: No se va a usar por ahora el método de "Aceptar Nueva Secuencia".
	          candidated_easel = groupEaselList[key_string].easels.find( e =>

	                                e.lot === piece.lot &&
	                                e.aceptNewSequence &&
	                                e.actualSequence > piece.sequence &&  // Opción A orden secuencias
	                                // e.actualSequence < piece.sequence && // Opción B orden secuencias
	                                !e.completed &&
	                                ((e.thickness + depthAux) <= groupEaselList[key_string].item.thickness));
	           */

	          // Si no hay candidato con una secuencia completada que acepte una nueva secuencia
	          // entonces se busca un caballete que tenga una secuencia actual mayor.
	          if (!selected_easel && !candidated_easel) {
				candidated_easel = groupEaselList[key_string].easels.find( e =>

									// Ahora va a dar igual que no esté completada la secuencia.
	                                e.lot === piece.lot &&
	                                (piece.easel_flip ? (e.actualSequence < piece.sequence) :
	                                (e.actualSequence > piece.sequence)) &&  // Opción A orden secuencias
	                                // e.actualSequence < piece.sequence && // Opción B orden secuencias
	                                !e.completed &&
	                                ((e.thickness + depthAux) <= groupEaselList[key_string].item.thickness));
			  }

	          // if (groupEaselList[key_string].easels.length <= max_easels && easel_short_mode === 3) {
				// new_easel_needed = true;
			  // }

	          // Modificamos el caballete del grupo en el que va a ir la pieza tratada.
	          // if (selected_easel && !new_easel_needed) {
			  if (selected_easel) {

	            // console.log('-->> cutPieceToEasel: encontrado caballete con esa secuencia.');

	            selected_easel.actualUnitSequence++;
	            selected_easel.actualUnit++;
	            selected_easel.pieces.push(piece.name_id);
	            selected_easel.thickness += depthAux;
	            selected_easel.weight += weightAux;

	            // NOTA: de momento el lugar que ocupa dentro de la pila se va a indicar que es el orden
	            // en que entró en el caballete a nivel general (como si sólo hubiera una única pila).
	            piece['stack_num'] = selected_easel.actualUnit;
	            // NOTA: Se cambia el orden del nombre para que coincida con la nomenclarura Lisec.
	            piece['easel'] = piece.group + '' + selected_easel.easel_num;
	            // piece['easel'] = selected_easel.easel_num + '' + piece.group;
	            piece['easel_num'] = selected_easel.easel_num;

	            // if (selected_easel.actualUnitSequence === selected_easel.actualFinalSequence) {
	            //   selected_easel.aceptNewSequence = true; // Ha terminado las unidades de la secuencia actual.
	            // }

	          // } else if (candidated_easel && !new_easel_needed) {
			  } else if (candidated_easel) {

	            // console.log('-->> cutPieceToEasel: encontrado caballete con otra secuencia válida.');

	            // Se escoge un caballete que puede llenarse con otra secuencia
	            // nueva siempre que sea menor que la secuencia antigua.

				candidated_easel.actualSequence = piece.sequence;
	            candidated_easel.actualUnitSequence = 1;
	            candidated_easel.actualFinalSequence = Number(piece.total_unit);
	            candidated_easel.sequences.push(piece.sequence); // Se añade el número de la nueva secuencia incluída.
	            candidated_easel.actualUnit++;
		        candidated_easel.pieces.push(piece.name_id);
		        candidated_easel.thickness += depthAux;
	            candidated_easel.weight += weightAux;

	            // NOTA: de momento el lugar que ocupa dentro de la pila se va a indicar que es el orden
	            // en que entró en el caballete a nivel general (como si sólo hubiera una única pila).
	            piece['stack_num'] = candidated_easel.actualUnit;
	            // NOTA: Se cambia el orden del nombre para que coincida con la nomenclarura Lisec.
	            piece['easel'] = piece.group + '' + candidated_easel.easel_num;
	            // piece['easel'] = candidated_easel.easel_num + '' + piece.group;
	            piece['easel_num'] = candidated_easel.easel_num;

	            // if (candidated_easel.actualUnitSequence < candidated_easel.actualFinalSequence) {
	              // candidated_easel.aceptNewSequence = false; // Ya no se podrá cambiar de secuencia hasta completarla.
	            // }
	          } else { // Hay que abrir un caballete nuevo vacío.

	            // console.log('-> La pieza no encaja en ningún caballete abierto.');
	            // console.log(groupEaselList[key_string].easels);

				// Primero se comprueba si aún se puede romper más veces la
				// secuencia en algún caballete (apoyando la pieza a su lado).
				let easel_broked_seq_rep = groupEaselList[key_string].easels.find( e => {

					let broked_aux = e.broken_seq.find(p => {

						if (p.seq === piece.sequence &&
							p.w === piece.width && p.h === piece.height &&
							p.rep < max_rep_seq) {

							// console.log('-> Caballete con pieza apoyada repetida que permite más: ');
							// console.log(piece);
							// console.log(p);

							return true;
						}

						return false;
					});

					if (broked_aux) {
						return true;
					}

					return false;
				});

	            let easel_broked_seq = null;

	            if (easel_broked_seq_rep) {
					easel_broked_seq = easel_broked_seq_rep;
				} else {
					easel_broked_seq = groupEaselList[key_string].easels.find( e =>
	                                max_broken_seq !== 0 &&
	                                e.lot === piece.lot &&
	                                e.broken_seq.length < max_broken_seq &&
	                                !e.completed);
				}

	            // let prop_pieces = only_pieces.length - (i_pieces + 1);

	            let prop_pieces = (i_pieces * 100) / only_pieces.length

	            // console.log('-->> cutPieceToEasel: Proporción de piezas ya tramitadas = ' + prop_pieces);

		  		// APOYAR PIEZA EN CABALLETE ---------------------------------------------

			  	// Sólo se mete la pieza con secuencia rota si aún no se ha
			  	// sobrepasado el límite de "piezas apoyadas" para el caballete.
				if (easel_broked_seq &&
				// IMPORTANTE: Si hay más de 2 pilas o se ha colocado ya la mitad de las piezas
				// entonces se permite ya apoyar piezas en los caballetes.
					(groupEaselList[key_string].easels.length > 2 || prop_pieces > 50)) {

					// console.log('-->> cutPieceToEasel: se rompe secuencia en caballete.');
		            // easel_broked_seq.actualUnitSequence++; // No se suma contabiliza aquí.
		            easel_broked_seq.actualUnit++;

		            // Las piezas apoyadas no cuentan para el peso y el espesor soportado.
		            // easel_broked_seq.thickness += depthAux;
	            	// easel_broked_seq.weight += weightAux;

		            piece['stack_num'] = easel_broked_seq.actualUnit;
		            piece['easel'] = piece.group + '' + easel_broked_seq.easel_num;
		            piece['easel_num'] = easel_broked_seq.easel_num;
		            // piece['sequence_broked'] = true;

		            let broked_aux = easel_broked_seq.broken_seq.find((p, ind) => {

						if (p.seq === piece.sequence &&
							p.w === piece.width && p.h === piece.height &&
							p.rep < max_rep_seq) {
							// console.log('-> Pieza apoyada repetida: ');
							// console.log(piece);
							// console.log(p);

							piece['sequence_broked'] = (ind + 1);

							return true;
						}

						return false;
					});

		            // Sólo se mete la secuencia en el listdo de "secuencias rotas" si no había ya una pieza similar.
		            // De este modo las piezas repetidas contabilizan como una porque se apoyarán una encima de otra.
		            if (!broked_aux) {

						// console.log('-> Metiendo secuencia rota: ');
						// console.log(piece);

						// Se introduce dentro del caballete una nueva secuencia de rotura.
						easel_broked_seq.broken_seq.push({seq: piece.sequence, w: piece.width , h: piece.height, rep: 1});

						// Se le indica el número para la pila de "secuencias rotas".
						piece['sequence_broked'] = easel_broked_seq.broken_seq.length;
					} else {

						broked_aux.rep++;
						// console.log('-> No se contabiliza la secuencia rota. Se suma la repetición = ' + broked_aux.rep);
					}

		            easel_broked_seq.pieces.push(piece.name_id);

					// console.log('-->> cutPieceToEasel: pieza que rompe la secuencia = ');
					// console.log(piece);

					// NO hace falta cuando se rompe secuencia.
		            // if (easel_broked_seq.actualUnitSequence === easel_broked_seq.actualFinalSequence) {
		            //   easel_broked_seq.aceptNewSequence = true; // Ha terminado las unidades de la secuencia actual.
		            // }
				} else {

		            // console.log('-->> cutPieceToEasel: Se abre caballete nuevo para la secuencia ' + piece.sequence + ' del lote ' + piece.lot);
					// console.log(piece);

		            // Se añade un caballete vacío para iniciar una secuencia en el "grupo".
		            // Si cuando le llega una primera pieza esta tiene un número de secuencia igual o inferior
		            // (si el orden no hay que voltearlo), entonces si "acepta nuevas secuencias" (el campo
		            // "aceptNewSequence" está a "true" porque el caballete tiene almacenadas todas las unidades de
		            // su secuencia actual) podrá modificar su secuencia actual y aceptar piezas a partir de ahora de ella.
		            // hasta que no complete todas las unidades de la nueva secuencia no podrá pasar a otra secuencia diferente.

		            let new_sequence_aux = piece.total_unit === 1 ? true : false;

		            groupEaselList[key_string].easels.push({

		              lot: piece.lot, // Lote de la pieza. Un caballete sólo puede tener piezas de un único lote.
		              actualSequence: piece.sequence, // Secuencia actual (en orden) que lleva este caballete en su interior.
		              actualUnitSequence: 1, // Cuenta el número de unidades que se llavan almacenadas en la secuencia actual.
		              actualFinalSequence: piece.total_unit, // Número total de unidades que completa la secuencia actual.
		              aceptNewSequence: new_sequence_aux, // Indica si el caballete acepta piezas de un secuencia distinta a su actual.
		              actualUnit: 1, // Número de piezas (de cualquier tipo y tamaño) que lleva albergado este caballete.
		              sequences: [piece.sequence], // Contiene las secuencias que ha ido almacenando este caballete.
		              pieces: [piece.name_id], // Contiene el identificador de las piezas que alberga este caballete.
		              completed: false, // Se pondrá a "true" cuando el caballete esté completo por peso o por espesor.
		              easel_num: groupEaselList[key_string].easels.length + 1, // Hay que sumar 1 porque aquí aún no se ha añadido el nuevo caballete.
		              broken_seq: [], // El nuevo caballete no lleva "secuencias rotas" aún.
		              thickness: depthAux,
	            	  weight: weightAux,
	            	  flip: piece.easel_flip
		            });

		            // El lugar que ocupa dentro de la pila será también 1,la primera en ser colocada dentro.
		            piece['stack_num'] = 1;

		            // El número del caballete lo marca la longitud en ese momento del array del campo "easels".
		            // Faltaría averiguar aún el orden que ocupa la pieza dentro de la pila en la que esté colocada.
		            piece['easel'] = piece.group + '' + groupEaselList[key_string].easels.length;
		            piece['easel_num'] = groupEaselList[key_string].easels.length;

		            // console.log('-->> cutPieceToEasel: Nuevo caballete creado "opt.1" = ');
					// console.log(groupEaselList[key_string].easels[groupEaselList[key_string].easels.length - 1]);

		         } // End Else broked_seq.
	          } // End Else abrir nuevo caballete.
	        } // End Else groupEaselList[key_string]
	/*
	        let key_string2 = piece.group.toString();

			// NOTA: Ests líneas no parecen necesarias pero realmente resuelven una incidencia que se produce en ciertos casos.
	        // Se comprueba que existe un listado de piezas candidatas para el "grupo de optimización" que estamos tratando.
	        // Si no es así se crea asignándole una lista inicialmente vacía.
	        if (pieceToEaselList[key_string2] === undefined || pieceToEaselList[key_string2] === null) {

	          pieceToEaselList[key_string2] = [];
	        } // */

	        // Se incrementa el contador de pieza.
	        piece_count++;

		} // End If 2 y 3.


		// ------- FIN MODO ASIGNACIÓN DE CABALLETES -------

      } else {
        console.log('-->> cutPieceToEasel: Tratando un elemento que no es pieza "pieza".');
        // console.log(piece);

        // this.alertInfo = 'No existe material para la pieza: ' + piece.id;
        // this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      }
    }); // End forEach piecesListIn

    // Se obtienen caballetes con secuencias continuas
    let apile_list = this.getAdjacentEaselList(groupEaselList);
    // console.log('-->> cutPieceToEasel apile_list:');
    // console.log(apile_list);

    // console.log('-->> cutPieceToEasel groupEaselList lista caballetes:');
    // console.log(groupEaselList);

    // console.log('-->> cutPieceToEasel pieceEaselList lista caballetes:');
    // console.log(pieceEaselList);

    return [groupEaselList, pieceEaselList, apile_list];

  } // End function cutPieceToEasel

  // ------------

  // --------------------------------------------
  // REFUNDIR caballetes con secuencias continuas
  // --------------------------------------------
  getAdjacentEaselList(groupEaselListIn) {

	// console.log('-->> getAdjacentEaselList...');
	// console.log(groupEaselListIn);

    let apile_list = [];

    for (let prop in groupEaselListIn) {

      // console.log('-->> getAdjacentEaselList grupo: ' + prop);
      // console.log(groupEaselListIn[prop]);

      let group_easel = groupEaselListIn[prop];
      let easel_list = [];

      let easel_item = group_easel.item;

      if (group_easel && group_easel.easels && group_easel.easels.length > 0)
      	easel_list = group_easel.easels;

      easel_list.forEach((ea, index) => {
		// console.log('-> Easel sequence = ');
		// console.log(ea);

		// No se añade nada sin secuencia actual (normalmente un ESPECIAL Z).
		if (ea.actualSequence) {
			let ad_min = 0;
			let ad_max = 0;
			let sequences_aux = null;

			// NOTA: según el orden de secuencia en los caballetes se
			// elige una opción u otra.

			// Opción A: la secuencia desciende conforme baja hacia abajo el cristal en el caballete.
			let max = ea.sequences[0];
			let min = ea.sequences[ea.sequences.length - 1];

			// Opción B: la secuencia asciende conforme baja hacia abajo el cristal en el caballete.
			// let min = ea.sequences[0];
			// let max = ea.sequences[ea.sequences.length - 1];

			easel_list.forEach(ea2 => {
				// console.log('-> Sequence match = ');
				// console.log(ea2.sequences);

				if (ea2.sequences) {
					// Opción A:
					let max2 = ea2.sequences[0];
					let min2 = ea2.sequences[ea2.sequences.length - 1];

					// Opción B:
					// let min2 = ea2.sequences[0];
					// let max2 = ea2.sequences[ea2.sequences.length - 1];

					if (min > max2 && max2 > ad_max && ea.easel_num !== ea2.easel_num) { // Opción A.
					// if (min > max2 && max2 > ad_max && ea.easel_num !== ea2.easel_num) {	 // Opción B.
						sequences_aux = ea2;
						ad_max = sequences_aux.sequences[0];
						ad_min = sequences_aux.sequences[sequences_aux.sequences.length - 1];
					}
				} // End If sequences.
			});
			/*
			let find_easel = fussion_list.find(eas => eas.num === sequences_aux.easel_num);

			if (!find_easel) {
				console.log('-> Se añade apilo = ');
				console.log(sequences_aux);

				// Se añade al principio o al final del array dependiendo.
				fussion_list.push({num: sequences_aux.easel_num, seq: sequences_aux.sequences});
			} else {
				console.log('-> Apilo ya existente = ');
				console.log(find_easel);
			} // */

			ea['adjacent'] = sequences_aux ? ('' + prop + sequences_aux.easel_num) : null;

			apile_list.push({name: '' + prop + ea.easel_num, id: easel_item.id, id_name: easel_item.name, desc: easel_item.desc, group: prop, num: ea.easel_num , adjacent: sequences_aux ? ('' + prop + sequences_aux.easel_num) : null, pieces: ea.pieces ? ea.pieces.length : 0});

		} // End ea.actualSequence.

	  });
	  /*
	  easel_list.forEach((g, i) => {
		  if (g && g.name && g.content) {
		      console.log('---> Grupos info: ' + (i + 1));
		      console.log(g.name);
		      console.log(g.content.easels);

		      g.content.easels.forEach((ea, j) => {
				console.log('---> Apilo in: ' + (j + 1));
		        console.log(ea.easel_num);
		        //console.log(ea.adjacent.easel_num);
		        apile_list.push({group: g.name, num: ea.easel_num , adjacent: ea.adjacent.easel_num, pieces: Number(ea.units)});
			  });
		  }
	  }); */

	  // console.log('-->> getAdjacentEaselList apile_lis IN: ');
      // console.log(apile_list);

    } // End For groupEaselListIn

    // console.log('-->> getAdjacentEaselList apile_list final: ');
    // console.log(apile_list);

    // Guardamos el valor de pilas/caballetes totales obtenidos.
    this.total_area_C = apile_list.length;

    if (this.total_area_C === 0) this.total_area_C = 1;

    return apile_list;

  } // End function getAdjacentEaselList.

  // Función que escribe un fichero CSV con el nombre especificado como primer parámetro y con contenido pasado como segundo parámetro.
  makeCsvEaselPieceList(nameCsv: string, contentCsv: any) {

    this.makeCsvFile.emit({file_name: nameCsv, content: contentCsv});
    // this.makeCsvFile.emit({file_name: 'csv_packages.csv', content: packageCSV});

    // NOTA: Esperar a que se termine de escribir el archivo y entonces descargarlo
    // directamente en el navegador (o que aparezca un botón de "descarga estimación").

  } // End function makeCsvEaselPieceList


  // ------------------------------------------------
  //  FUNCIONES PARA CALCULAR GRUPOS DE OPTIMIZACIÓN
  // ------------------------------------------------

  calculateGroupOptimization(dataFileIn: any): any {
    console.log('--> - -> AuxFunction: calculateGroupOptimization:');
    console.log(dataFileIn);

    let resultList = [];
    let ok = true;
    let error_msg = '';
    let first_column = [
      { nombre: 'Prioridad', campo: 'priority', tipo: 'texto' },
      { nombre: 'Codigo', campo: 'barcode', tipo: 'texto' },
      { nombre: 'Pedido', campo: 'orderno', tipo: 'numero' },
      { nombre: 'Posicion', campo: 'orderpos', tipo: 'numero' },
      { nombre: 'Ancho', campo: 'width', tipo: 'numero' },
      { nombre: 'Alto', campo: 'height', tipo: 'numero' },
      { nombre: 'Espesor', campo: 'stock_length', tipo: 'numero' },
      { nombre: 'Referencia', campo: 'reference', tipo: 'texto' },
      { nombre: 'ReferenciaObra', campo: 'project_reference', tipo: 'texto' },
      { nombre: 'Unidades', campo: 'units', tipo: 'numero' },
      { nombre: 'Embalaje', campo: 'packing', tipo: 'numero' },
      { nombre: 'Caballete', campo: 'easel', tipo: 'numero' },
      { nombre: 'Ruta', campo: 'route', tipo: 'numero' },
      { nombre: 'Pasos', campo: 'steps', tipo: 'texto' },
      { nombre: 'Material', campo: 'mat_id', tipo: 'texto' },
      { nombre: 'Nombre', campo: 'mat_name', tipo: 'texto' },
      { nombre: 'Descripcion', campo: 'mat_desc', tipo: 'texto' },
      { nombre: 'Grupo', campo: 'group', tipo: 'texto' },
      { nombre: 'Lote', campo: 'lot', tipo: 'numero' },
      { nombre: 'Secuencia', campo: 'sequence', tipo: 'numero' },
      { nombre: 'Decoat', campo: 'decoat', tipo: 'numero' },
      { nombre: 'LineaId', campo: 'id_line', tipo: 'numero' },
      { nombre: 'ClienteId', campo: 'id_client', tipo: 'numero' },
      { nombre: 'Cliente', campo: 'client', tipo: 'texto' },
      { nombre: 'Figura', campo: 'figure', tipo: 'numero' },
      { nombre: 'L', campo: 'l', tipo: 'numero' },
      { nombre: 'L1', campo: 'l1', tipo: 'numero' },
      { nombre: 'L2', campo: 'l2', tipo: 'numero' },
      { nombre: 'H', campo: 'h', tipo: 'numero' },
      { nombre: 'H1', campo: 'h1', tipo: 'numero' },
      { nombre: 'H2', campo: 'h2', tipo: 'numero' },
      { nombre: 'R', campo: 'r', tipo: 'numero' },
      { nombre: 'R2', campo: 'r2', tipo: 'numero' },
      { nombre: 'R3', campo: 'r3', tipo: 'numero' },
      { nombre: 'R4', campo: 'r4', tipo: 'numero' },
      { nombre: 'B1', campo: 'b1', tipo: 'numero' },
      { nombre: 'B2', campo: 'b2', tipo: 'numero' },
      { nombre: 'B3', campo: 'b3', tipo: 'numero' },
      { nombre: 'B4', campo: 'b4', tipo: 'numero' },

      { nombre: 'NumOF', campo: 'num_of', tipo: 'numero' },
      { nombre: 'PosOF', campo: 'pos_of', tipo: 'numero' },
      { nombre: 'Paneno', campo: 'paneno', tipo: 'numero' }
    ];

    console.log('--> Primera columna:');
    console.log(first_column);

    let element_instance = new DataInput();

    let element_file_list = [];
    let error_msg_file = '';

    // let file_content_list = [];
    // dataFileIn.foreEach(ar => file_content_list.push(ar.content));

    [element_file_list, error_msg_file ] = this.auxFunction.validateFileFormat(first_column, dataFileIn, element_instance);

    // console.log('--> calculateGroupOptimization element_file_list:');
    // console.log(element_file_list);f_fill_piece
    // console.log('--> calculateGroupOptimization error_msg_file:');
    // console.log(error_msg_file);

    element_file_list.forEach(elem => {

      let group_number = '';

      // Si se quiere tener en cuenta los "pasos de trabajo" para diferenciar grupos.
      if (this.fileForm.controls.f_rute.value) {

        console.log('--> calculateGroupOptimization: SI tiene en cuenta los "pasos de trabajo".');

        group_number = elem['priority'].toString() + // Para tener en cuenta la "prioridad"
                    //  elem['orderno'].toString() + // Para tener en cuenta el "pedido"
                    //  elem['packing'].toString() + // Para diferenciar por "tipo embalaje" (caballete)
                    elem['lot'].toString() + // Para diferenciar por lote.
                    elem['easel'].toString() + // Para tener en la familia de embalaje "tipo de caballete"
                    elem['steps'].toString(); // Para tener en cuenta "pasos/procesos" aplicados a la pieza.
                    // elem['route'].toString(); // Para tener en cuenta la "ruta/linea" de la linea que seguirá la pieza.
      } else {

        console.log('--> calculateGroupOptimization: NO tiene en cuenta los "pasos de trabajo".');

        group_number = elem['priority'].toString() +
                    elem['lot'].toString() +
                    elem['easel'].toString();
                    // elem['route'].toString();
      }

      elem['group'] = group_number; // Grupo

      console.log(' -> * calculateGroupOptimization group_number = ' + group_number);
      console.log(elem['group']);

      // El ID siempre se pondrá a null para que se cree como nuevo elemento en la optimización.
      elem.id = null;

      // NOTA: Fecha actual se pasa desde cliente para incluir
      // directamente la fecha y hora del navegador usado.
      elem.date = this.today;

    });

    resultList = element_file_list;

    // NOTA: Se ordenan las piezas según el campo "Prioridad" para que primero se asignen éstas.
    resultList = this.opti.orderPiecesByPriority(resultList, true);

    // --------------
    // NOTA: Para poner un nombre identificador del grupo más simple.
    let new_resultList = [];

    let count = 0;
    // No se incluye la Z porque es la letra reservada para los caballetes especiales.
    let letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y'];

    resultList.forEach((item, index) => {

      new_resultList['g_' + item.group] = index;

    });

    for (let prop in new_resultList) {
      new_resultList[prop] = letters[count];
      count++;
    }

    console.log('**-> new_resultList:');
    console.log(new_resultList);

    let resultList_final = [];

    resultList.forEach((item, index) => {

      item.group = new_resultList['g_' + item.group];

      // VOLTEOS -------
      // Añadimos el campo que va a indicar si el conjunto de pasos que
      // se aplican a cada grupo implica un "volteo" del orden de salida.
      let steps = item.steps.split('-');

      let flip_count = 0;

      if (steps && steps.length > 1) {
        steps.forEach( stp => {

          // console.log('--> calculateGroupOptimization paso:');
          // console.log(stp);

          let step_aux = this.workstepsList.find(w => w.acronym === stp);

          if (step_aux && step_aux.flip) {
            console.log('--> Se añade volteo a la cuenta por el proceso: ');
            console.log(step_aux);
            flip_count++;
          }

        });
      }

      // console.log('--> Números de volteos: ' + flip_count);

      let group_flip = false;

      if (flip_count % 2 === 0) {
        // console.log('--> volteo PAR. No hay que invertir la secuencia. ' + flip_count % 2);
      } else {
        // console.log('--> volteo IMPAR. Hay que invertir la secuencia. ' + flip_count % 2);
        group_flip = true;
      }

      item['step_flip'] = group_flip;

      // ---------------

      resultList_final.push(item);

    });

    // console.log('--> calculateGroupOptimization resultList_final:');
    // console.log(resultList_final);

    return [resultList_final, error_msg];
  } // End function calculateGroupOptimization

  countSelectedPieces() {

	this.totalSelectedPieces = 0;

    // Señalamos todo el listdo como "marcado".
    this.optimizationList.forEach(dt => {
      dt['check'] = true;

      // Contamos las unidades de piezas seleccionadas.
      this.totalSelectedPieces += this.getSelectedPieceUnits(dt);
    });

  } // End function countSelectedPieces

  private getSelectedPieceUnits(itemIn: any): number {
    const unitsRaw = Number(itemIn && itemIn.units);
    const units = Number.isFinite(unitsRaw) && unitsRaw > 0 ? unitsRaw : 1;
    if (this.isOefCompositeItem(itemIn)) {
      return this.getOefCompositeTotalUnits(itemIn);
    }
    return units;
  }

  getPieceUnitsDisplay(itemIn: any): number {
    return this.getSelectedPieceUnits(itemIn);
  }

  isOefRuntimeUnitsReadOnly(itemIn: any): boolean {
    if (!itemIn) {
      return false;
    }
    const source = itemIn && itemIn.source ? itemIn.source.toString() : '';
    const fromRuntimeSource =
      source.indexOf('oef_runtime_') === 0 ||
      source.indexOf('trap_runtime_') === 0 ||
      source.indexOf('form38_') === 0 ||
      source.indexOf('triangle_') === 0;
    const hasRuntimeFlag = itemIn.oef_runtime_remainder === true || Number(itemIn.oef_runtime_units) > 0;
    const hasOefGeometry =
      itemIn.oef_generated === true ||
      (Array.isArray(itemIn.oef_internal_polygons) && itemIn.oef_internal_polygons.length > 0);
    return !!(hasOefGeometry && (fromRuntimeSource || hasRuntimeFlag));
  }

  anidSequence(nextPieceListIn: any, index: number, sequenceIn: string, sequenceItemIn: any, areaMaxIn: number, areaIn: number): number {

    console.log('--> anidSequence sequenceIn:');
    console.log(sequenceIn);

    // Se quita el elemento actual para no incluirlo en las comprobaciones.
    nextPieceListIn.splice(index, 1);

    let sequence_aux = sequenceIn;
    let sequence_item_aux = sequenceItemIn;

    // Se recorren todos los elementos restantes comprobando la condición.
    // nextPieceListIn.forEach((next, j) => {
    for ( let j = 0; j < nextPieceListIn.length; j++) {
      let item_area = (nextPieceListIn[j].piece_width * nextPieceListIn[j].piece_height) / 1000000;

      if (areaIn + item_area > areaMaxIn) {
        console.log('Se ha sobrepasado el area de la hoja. i =' + index + ' ;j = ' + j);
      } else {
        // Se añade la pieza a la secuencia.
        sequence_item_aux.push(nextPieceListIn[j]);

        sequence_aux += ',' + nextPieceListIn[j].piece_group + '_' + j;

        // Se aumenta el area contabilizada.
        areaIn += item_area;
      }

    }

    return areaIn;

  } // End function anidSequence

  // Función que dado un listado de grupos de piezas y una hoja, devuelve otro listado
  // con una secuencia de piezas que cabe dentro de la hoja haciendo que sobre el mínimo posible.
  calculateSequence(optionPieceListIn: any, sheetData: any): any {
    console.log('--> calculateSequence:');
    // console.log(optionPieceListIn);

    let piles = [];

    let max_width = sheetData.width;
    let max_height = sheetData.height;

    // Area máxima marcada por las dimensiones de la hoja.
    let max_area = (sheetData.width * sheetData.height) / 1000000;
    console.log('--> calculateSequence: max_area = ' + max_area);

    let sequence = [];
    let sequence_item = [];

    // Se crea una array con todos los elementos que van a intervenir.
    for (let prop in optionPieceListIn) {
      // console.log('--> calculateSequence piles prop: ' + prop);
      // console.log(optionPieceListIn[prop]);

      optionPieceListIn[prop].forEach((pile, i) => {
        piles.push(optionPieceListIn[prop][i]);
        sequence.push('');
        sequence_item.push([]);
      });

    }

    console.log('--> calculateSequence piles:');
    console.log(piles);

    let piles_fix = JSON.parse(JSON.stringify(piles));


    // let i, j,count, n = 0;

    // piles.forEach((item, i) => {
    for ( let i = 0; i < piles.length; i++) {

      let piles_aux = JSON.parse(JSON.stringify(piles_fix));

      let area_aux = 0;

      sequence[i] = piles[i].piece_group + '_' + i;
      sequence_item[i] = [];
      sequence_item[i].push(piles[i]);

      area_aux = this.anidSequence(piles_aux, i, sequence[i], sequence_item[i], max_area, area_aux);

    }

    console.log('------------ secuence = ' + sequence.length);
    console.log(sequence);
    console.log('------------ secuence Item = ' + sequence_item.length);
    console.log(sequence_item);

 /*
    // piles.forEach((pile, i) => {
    for ( i = 0; i < piles.length; i++) {

      let area_aux = 0;

      // pile.forEach((item, j) => {
      for ( j = 0; j < piles[i].length && area_aux < max_area; j++) {

        // La primera pieza ya se suma en la primera iteración si cuadra, no hace falta añadirla al principio.
        // sequence_item.push(piles[i][j]);
        // area_aux += ((piles[i][j].piece_width * piles[i][j].piece_height) / 1000000);

        for ( count = i; count < piles.length && area_aux < max_area; count++) {

          // piles[count].forEach((itemIn, n) => {
          for ( n = 0; n < piles[count].length && area_aux < max_area; n++) {
            let item_area = ((piles[count][n].piece_width * piles[count][n].piece_height) / 1000000);

            if (area_aux + item_area > max_area) {
              console.log('Se ha sobrepasado el area de la hoja. i =' + i + ' ;j = ' + j + ' ;n = ' + n);
              // area_aux = 0;

              break;
            } else {
              // Se añade la pieza a la secuencia.
              sequence.push(i + '_' + j + '_' + count + '_' + n);
              sequence_item.push(piles[count][n]);

              // Se aumenta el area contabilizada.
              area_aux += item_area;
            }
          // });
          }

          if (area_aux > max_area) {
            break;
          }
        }
      // });
      }
      if (area_aux > max_area) {
        break;
      }

      console.log('------------ secuence = ' + sequence.length);
      console.log(sequence);
      console.log('------------ secuence Item = ' + sequence_item.length);
      console.log(sequence_item);
      // console.log('--> pile[' + (i + 1) + '][' + (j + 1) + ']: ');
      // console.log(piles[i][j]);
      // console.log('--> pile2[' + (count + 1) + '][' + (n + 1) + ']');
      // console.log(piles[count][n]);

      console.log('------------ area = ' + area_aux);
    // });
    } // End for i
*/
    return optionPieceListIn;

  } // End function calculateSequence

  // -------------------------
  //  FUNCIONES DE FICHEROS
  // -------------------------

  // Función que carga el contenido del archivo seleccionado desde el "input file simple".
  async fileCharged(targetIn) {
    console.log('--> fileCharged:');
    console.log(targetIn);
    console.log(targetIn.files);
    console.log(targetIn.files[0]);
    console.log(targetIn.files[0].name);

    let promese_file = await this.auxFunction.onFileSelect(targetIn).then(async function(data_file) {

                console.log('->> fileCharged data_file => ');
                console.log(data_file);

                return data_file;
              });

    console.log('->> promese_file: ');
    console.log(promese_file);

    // Guardamos el nombre del archivo (para carga de piezas) que hemos seleccionado.
    this.filename = promese_file.filename;
    this.filenameList.push(promese_file.filename);

  } // End function fileCharged

  // Función que carga el contenido de varios archivos seleccionados a la vez desde el "input file multiple".
  async fileMultipleCharged(targetIn) {
    console.log('--> fileMultipleCharged:');
    // console.log(targetIn);
    console.log(targetIn.files);
    // console.log(targetIn.files[0]);
    // console.log(targetIn.files[0].name);

    let promese_file = await this.auxFunction.onMultipleFileSelect(targetIn, 'piece').then(async function(data_file) {

                console.log('->> fileMultipleCharged data_file => ');
                console.log(data_file);

                return data_file;
              });

    console.log('->> fileMultipleCharged promese_file: ' + promese_file.length);
    console.log(promese_file);

    // Guardamos los nombres de los archivos que hemos seleccionado.
    promese_file.forEach((r, i) => {
      if (i === 0) {
        this.filename = r.filename;
      } else {
        this.filename += ', ' + r.filename;
      }

      this.filenameList.push(r.filename);
    });

  } // End function fileMultipleCharged

  async fileSheetCharged(targetIn) {
    console.log('--> fileSheetCharged:');
    console.log(targetIn);

    let promese_file = await this.auxFunction.onFileSelect(targetIn).then(async function(data_file) {

                console.log('->> fileSheetCharged data_file => ');
                console.log(data_file);

                return data_file;
              });

    console.log('->> promese_file: ');
    console.log(promese_file);

    // Guardamos el nombre del archivo que hemos seleccionado.
    this.filesheetname = promese_file.filename;
    this.filesheetnameList.push(promese_file.filename);

  } // End function fileSheetCharged

  async fileSheetMultipleCharged(targetIn) {
    console.log('--> fileSheetMultipleCharged:');
    console.log(targetIn);

    let promese_file = await this.auxFunction.onMultipleFileSelect(targetIn, 'sheet').then(async function(data_file) {

                console.log('->> fileSheetMultipleCharged data_file => ');
                console.log(data_file);

                return data_file;
              });

    console.log('->> fileSheetMultipleCharged promese_file: ');
    console.log(promese_file);

    // Guardamos los nombres de los archivos que hemos seleccionado.
    promese_file.forEach((r, i) => {
      if (i === 0) {
        this.filesheetname = r.filename;
      } else {
        this.filesheetname += ', ' + r.filename;
      }

      this.filesheetnameList.push(r.filename);
    });

  } // End function fileSheetMultipleCharged

  // Función que vacía del "almacén de ficheros" los que son de tipo pasado como
  // parámetro (si es "all" borrará todos los tipos y lo vacía completamente).
  emptyCSV(typeIn: string) {

    console.log('-> emptyCSV: ' + typeIn);

    this.auxFunction.clearContentCSV(typeIn);

    if (typeIn === 'piece') {
      this.optimizationList = [];
      this.totalSelectedPieces = 0;
      this.oefRuntimeOptimizationList = null;
      this.oefRuntimeSimulationVariants = [];
      this.lastOefPreSearch = null;
      this.usingPersistedLayoutSnapshot = false;
      this.persistedLayoutSnapshotMeta = null;
      this.cutTotalOrderList = [];
      this.level0TraverseList = [];
      this.total_sheet_results = [];
      this.lastTotalGraphicList = [];
      if (this.opti) {
        this.opti.pieceInfoList = [];
        this.opti.groupInfoList = [];
        this.opti.groupListMode1 = [];
        this.opti.groupListMode2 = [];
        this.opti.pieceList = [];
      }
    } else if (typeIn === 'sheet') {
      this.sheetList_datafile = [];
      this.totalSelectedSheets = 0;
    }

  } // End function emptyCSV

  downloadPieceCsvTemplate(): void {
    const rows = [
      [
        'Prioridad', 'Codigo', 'Pedido', 'Posicion', 'Ancho', 'Alto', 'Espesor', 'Referencia', 'ReferenciaObra',
        'Unidades', 'Embalaje', 'Caballete', 'Ruta', 'Pasos', 'Material', 'Nombre', 'Descripcion', 'Grupo',
        'Lote', 'Secuencia', 'Decoat', 'LineaId', 'ClienteId', 'Cliente', 'Figura', 'L', 'L1', 'L2', 'H', 'H1',
        'H2', 'R', 'R2', 'R3', 'R4', 'B1', 'B2', 'B3', 'B4', 'NumOF', 'PosOF', 'Paneno'
      ],
      [
        'prio', 'barcode', 'n_pedido', 'pos', 'mm', 'mm', 'mm_stock', 'ref_int', 'ref_obra',
        'uds', 'tipo_emb', 'id_caballete', 'ruta', 'pasos_ej_CORTE', 'id_mat', 'nom_mat', 'desc_mat', 'grupo',
        'lote', 'secuencia', '0_o_1', 'id_linea', 'id_cliente', 'cliente', 'id_forma', 'L', 'L1', 'L2', 'H', 'H1',
        'H2', 'R', 'R2', 'R3', 'R4', 'B1', 'B2', 'B3', 'B4', 'num_of', 'pos_of', 'paneno'
      ]
    ];
    this.downloadCsvTemplate('template_piezas_vs_cut.csv', rows);
  }

  downloadSheetCsvTemplate(): void {
    const rows = [
      [
        'Material', 'Nombre', 'Descripcion', 'Retal', 'Codigo', 'Ancho', 'Alto', 'Espesor', 'Peso', 'Unidades',
        'Cara', 'Proceso', 'Almacen', 'Ubicacion', 'Referencia', 'DesbandeIzquierda', 'DesbandeDerecha',
        'DesbandeArriba', 'DesbandeAbajo', 'Tronzado', 'TronzadoMaximo', 'RetalAncho', 'RetalAlto', 'Formato'
      ],
      [
        'id_mat', 'nombre_mat', 'desc_mat', 'true_o_false', 'barcode', 'mm', 'mm', 'mm', 'kg', 'uds',
        'A_o_B', 'id_proc', 'almacen', 'ubicacion', 'referencia', 'mm', 'mm', 'mm', 'mm', 'mm', 'mm', 'mm', 'mm', 'texto'
      ],
      [
        '100', 'LUNA 4', 'Luna Incolora 4mm', 'false', '10001', '6000', '3210', '4', '192.6', '10',
        'A', 'CORTE', 'GEN', 'A01', 'DEMO', '0', '0', '0', '0', '0', '1800', '0', '0', 'JUMBO'
      ]
    ];
    this.downloadCsvTemplate('template_hojas_vs_cut_demo.csv', rows);
  }

  private downloadCsvTemplate(filenameIn: string, rowsIn: string[][]): void {
    const csvText = rowsIn
      .map(row => row.map(value => {
        const safe = (value === null || value === undefined) ? '' : String(value);
        return safe.replace(/;/g, ',').replace(/\r?\n/g, ' ');
      }).join(';'))
      .join('\n');
    const blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filenameIn;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  }

  // -----------------------------------------------
  //  FUNCIONES PARA EL CONTROL DE VENTANAS MODALES
  // -----------------------------------------------

  showSimulationsModal(value: boolean) {
    this.simulationsModal = value;

  } // End function showSimulationsModal

  showHelpModal(value: boolean) {
    this.helpModal = value;
    if (value) {
      this.helpSection = 'flujo';
    }

  } // End function showHelpModal

  setHelpSection(sectionIn: string): void {
    this.helpSection = sectionIn;
  }

  isHelpSection(sectionIn: string): boolean {
    return this.helpSection === sectionIn;
  }

  getOptimizerTourSteps(): Array<{title: string, body: string, targetId: string}> {
    return [
      {
        title: 'Preparar la máquina y la búsqueda',
        body: 'Selecciona primero la mesa de corte. Velocidad regula la profundidad de Mejorar y OEF permite preparar primitivos especiales cuando existen formas compatibles.',
        targetId: 'vsCutTourSetup'
      },
      {
        title: 'Ajustar las reglas de corte',
        body: 'Nivel, eje, libertad, origen, desbandes, tronzado, retal mínimo y travera condicionan el encaje y la viabilidad industrial. Conviene mantenerlos estables al comparar resultados.',
        targetId: 'vsCutTourParameters'
      },
      {
        title: 'Cargar piezas y hojas',
        body: 'Importa piezas por CSV o desde VS.floor y planchas por CSV o inventario. Las pestañas inferiores permiten revisar y editar cada dato antes de optimizar.',
        targetId: 'vsCutTourData'
      },
      {
        title: 'Elegir el método de optimización',
        body: 'Mejorar genera un conjunto de alternativas con distintas configuraciones. Optimizar repite únicamente la configuración manual que se muestra en pantalla.',
        targetId: 'vsCutTourActions'
      },
      {
        title: 'Comparar antes de decidir',
        body: 'Ver simulaciones permite comparar merma, hojas, pilas, retal final y estrategias OEF antes de cargar la propuesta más adecuada.',
        targetId: 'vsCutTourSimulations'
      },
      {
        title: 'Validar y llevar el resultado a planta',
        body: 'Revisa Piezas, Hojas y Gráfico. Después puedes imprimir PDF, guardar la optimización y exportar el CNC compatible con la mesa seleccionada.',
        targetId: 'vsCutTourOutputs'
      }
    ];
  }

  getCurrentOptimizerTourStep(): {title: string, body: string, targetId: string} {
    const steps = this.getOptimizerTourSteps();
    if (this.optimizerTourIndex < 0) {
      this.optimizerTourIndex = 0;
    }
    if (this.optimizerTourIndex >= steps.length) {
      this.optimizerTourIndex = steps.length - 1;
    }
    return steps[this.optimizerTourIndex];
  }

  startOptimizerTour(): void {
    this.helpModal = false;
    this.closeOptimizerTour();
    this.optimizerTourIndex = 0;
    this.setDefaultOptimizerTourPosition();
    this.optimizerTourModal = true;
    window.addEventListener('resize', this.optimizerTourViewportHandler);
    window.addEventListener('scroll', this.optimizerTourViewportHandler, true);
    document.addEventListener('keydown', this.optimizerTourKeydownHandler);
    this.focusOptimizerTourTarget();
  }

  closeOptimizerTour(): void {
    this.optimizerTourModal = false;
    if (this.optimizerTourViewportHandler) {
      window.removeEventListener('resize', this.optimizerTourViewportHandler);
      window.removeEventListener('scroll', this.optimizerTourViewportHandler, true);
    }
    if (this.optimizerTourKeydownHandler) {
      document.removeEventListener('keydown', this.optimizerTourKeydownHandler);
    }
  }

  nextOptimizerTourStep(): void {
    const steps = this.getOptimizerTourSteps();
    if (this.optimizerTourIndex < steps.length - 1) {
      this.optimizerTourIndex += 1;
      this.focusOptimizerTourTarget();
      return;
    }
    this.closeOptimizerTour();
  }

  previousOptimizerTourStep(): void {
    if (this.optimizerTourIndex > 0) {
      this.optimizerTourIndex -= 1;
      this.focusOptimizerTourTarget();
    }
  }

  private focusOptimizerTourTarget(): void {
    const step = this.getCurrentOptimizerTourStep();
    if (!step || !step.targetId) {
      return;
    }

    setTimeout(() => {
      const target = document.getElementById(step.targetId);
      if (!target) {
        this.setDefaultOptimizerTourPosition();
        return;
      }
      target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      setTimeout(() => this.positionOptimizerTourNearElement(target), 360);
    }, 80);
  }

  positionOptimizerTourForCurrentStep(): void {
    const step = this.getCurrentOptimizerTourStep();
    const target = step && step.targetId ? document.getElementById(step.targetId) : null;
    if (!target) {
      this.setDefaultOptimizerTourPosition();
      return;
    }
    this.positionOptimizerTourNearElement(target);
  }

  private positionOptimizerTourNearElement(targetIn: HTMLElement): void {
    const rect = targetIn.getBoundingClientRect();
    const viewportWidth = window.innerWidth || 1280;
    const viewportHeight = window.innerHeight || 800;
    const targetPadding = 8;
    const viewportPadding = 12;
    const gap = 22;
    const cardWidth = Math.min(430, Math.max(300, viewportWidth - (viewportPadding * 2)));
    const cardElement = document.getElementById('vsCutOptimizerTourCard');
    const cardHeight = cardElement && cardElement.offsetHeight
      ? cardElement.offsetHeight
      : 245;

    const spotlightLeft = Math.max(viewportPadding, rect.left - targetPadding);
    const spotlightTop = Math.max(viewportPadding, rect.top - targetPadding);
    const spotlightRight = Math.min(viewportWidth - viewportPadding, rect.right + targetPadding);
    const spotlightBottom = Math.min(viewportHeight - viewportPadding, rect.bottom + targetPadding);
    this.optimizerTourSpotlightStyle = {
      left: Math.round(spotlightLeft) + 'px',
      top: Math.round(spotlightTop) + 'px',
      width: Math.max(20, Math.round(spotlightRight - spotlightLeft)) + 'px',
      height: Math.max(20, Math.round(spotlightBottom - spotlightTop)) + 'px'
    };

    const rightSpace = viewportWidth - rect.right;
    const leftSpace = rect.left;
    const belowSpace = viewportHeight - rect.bottom;
    const aboveSpace = rect.top;
    let top = viewportPadding;
    let left = viewportPadding;

    if (rightSpace >= cardWidth + gap) {
      this.optimizerTourPlacement = 'right';
      left = rect.right + gap;
      top = rect.top + (rect.height / 2) - (cardHeight / 2);
    } else if (leftSpace >= cardWidth + gap) {
      this.optimizerTourPlacement = 'left';
      left = rect.left - cardWidth - gap;
      top = rect.top + (rect.height / 2) - (cardHeight / 2);
    } else if (belowSpace >= cardHeight + gap || belowSpace >= aboveSpace) {
      this.optimizerTourPlacement = 'bottom';
      left = rect.left + (rect.width / 2) - (cardWidth / 2);
      top = rect.bottom + gap;
    } else {
      this.optimizerTourPlacement = 'top';
      left = rect.left + (rect.width / 2) - (cardWidth / 2);
      top = rect.top - cardHeight - gap;
    }

    left = Math.max(viewportPadding, Math.min(left, viewportWidth - cardWidth - viewportPadding));
    top = Math.max(viewportPadding, Math.min(top, viewportHeight - cardHeight - viewportPadding));
    this.optimizerTourCardStyle = {
      width: Math.round(cardWidth) + 'px',
      left: Math.round(left) + 'px',
      top: Math.round(top) + 'px'
    };
  }

  private setDefaultOptimizerTourPosition(): void {
    const viewportWidth = window.innerWidth || 1280;
    const cardWidth = Math.min(430, Math.max(300, viewportWidth - 24));
    this.optimizerTourPlacement = 'none';
    this.optimizerTourSpotlightStyle = {
      left: '50%',
      top: '50%',
      width: '1px',
      height: '1px'
    };
    this.optimizerTourCardStyle = {
      width: cardWidth + 'px',
      left: Math.max(12, (viewportWidth - cardWidth) / 2) + 'px',
      top: '24px'
    };
  }

  confirmSimulationsModal(itemIn: any, indexIn: number): void {

    console.log('--> - -> Confirmada selección de simulación: ' + indexIn);
    console.log(itemIn);
    console.log('--> - -> Selección de simulación (resumen): ' + JSON.stringify({
      row_index: indexIn,
      variant_index: Number(itemIn && itemIn.oef_variant_index),
      strategy: itemIn && itemIn.oef_layout_strategy,
      shared_strip_lookahead: itemIn && itemIn.packing_shared_strip_lookahead === true,
      np: Number(itemIn && itemIn.np),
      ns: Number(itemIn && itemIn.ns),
      ne: Number(itemIn && itemIn.ne),
      tm: Number(itemIn && itemIn.tm)
    }));

    let final_better_opti = itemIn;

    const selectedVariantIndex = Number(final_better_opti && final_better_opti.oef_variant_index);
    if (Number.isFinite(selectedVariantIndex) &&
      selectedVariantIndex >= 0 &&
      Array.isArray(this.oefRuntimeSimulationVariants) &&
      this.oefRuntimeSimulationVariants.length > selectedVariantIndex) {
      const selectedRuntimeList = this.oefRuntimeSimulationVariants[selectedVariantIndex];
      if (Array.isArray(selectedRuntimeList) && selectedRuntimeList.length > 0) {
        // IMPORTANTE:
        // No sustituir this.optimizationList (entrada de pestaña Piezas / persistencia),
        // solo la lista runtime que usa buttonStartOptimization para calcular.
        this.oefRuntimeOptimizationList = JSON.parse(JSON.stringify(selectedRuntimeList));
        console.log('--> confirmSimulationsModal: aplicada variante OEF runtime seleccionada.');
        console.log({
          variant_index: selectedVariantIndex,
          source_summary: this.oefRuntimeOptimizationList
            .filter(it => it && it.check === true)
            .map(it => ({
              id: it.id,
              units: Number(it.units),
              width: Number(it.width),
              height: Number(it.height),
              oef_polygons: Array.isArray(it.oef_internal_polygons) ? it.oef_internal_polygons.length : 0
            }))
        });
      }
    }

    // Ahora se lanza la optimización real deseada.
    // Para eso antes se colocan los valores adecuados en el formulario.
    if (final_better_opti && final_better_opti.maxtrav > 0) {

		// Se indica en el formulario el valor del "Máximo de travera" correspondiente.
		this.fileForm.controls.f_max_diecutting.setValue(final_better_opti.maxtrav);

		// Si la optimización elegida usa "bloques" entonces
		// se activa en el formulario el campo correspondiente.
		if (final_better_opti.bl) {
			this.fileForm.controls.f_blocks.setValue(true);
		} else {
			this.fileForm.controls.f_blocks.setValue(false);
		}
		// Si la optimización elegida usa "máxima base" entonces
		// se activa en el formulario el campo correspondiente.
		if (final_better_opti.mb) {
			this.fileForm.controls.f_base.setValue(true);
		} else {
			this.fileForm.controls.f_base.setValue(false);
		}
		// Si la optimización elegida usa "ordenación de hoja" entonces
		// se activa en el formulario el campo correspondiente.
		if (final_better_opti.os) {
			this.fileForm.controls.f_order.setValue(true);
		} else {
			this.fileForm.controls.f_order.setValue(false);
		}
		// Si usa "Recolocar".
		if (final_better_opti.re) {
			this.fileForm.controls.f_old.setValue(true);
		} else {
			this.fileForm.controls.f_old.setValue(false);
		}
		// Se indica en el formulario el valor del "Modo" correspondiente.
		if (final_better_opti.md) {
			this.fileForm.controls.f_mode.setValue(final_better_opti.md);
		}

		// Se lanza la optimización.
		if (this.autoBatchMode) {
		  this.buttonStartOptimization(true, this.fileForm.controls.f_blocks.value);
		} else {
		  this.buttonStartOptimization(false, this.fileForm.controls.f_blocks.value);
		}
    } // End If final_better_opti.

    this.showSimulationsModal(false);

  } // End function confirmSimulationsModal

  showAddPieceModal(value: boolean) {
    this.addPieceModal = value;

  } // End function showAddPieceModal

  confirmAddPieceModal() {

    console.log('--> - -> Confirmada creación de nueva pieza.');

  } // End function confirmAddPieceModal

  showPieceModal(value: boolean) {
    this.pieceModal = value;

  } // End function showPieceModal

  confirmPieceModal() {

    console.log('--> - -> Confirmada selección de piezas desde VS-Floor.');

  } // End function confirmPieceModal

  showFigureModal(value: boolean) {
    this.figureModal = value;

  } // End function showFigureModal

  confirmFigureModal() {

    console.log('--> - -> Confirmada selección de forma para la pieza.');

    const figureValueKeys = [
      'figure', 'b1', 'b2', 'b3', 'b4', 'l', 'l1', 'l2',
      'h', 'h1', 'h2', 'r', 'r2', 'r3', 'r4',
      'dxf_points', 'dxf_name', 'dxf_w', 'dxf_h'
    ];
    const previousFigureValues = {};
    figureValueKeys.forEach((key) => {
      previousFigureValues[key] = {
        exists: Object.prototype.hasOwnProperty.call(this.actual_piece, key),
        value: this.actual_piece[key]
      };
    });

    // Se asignan a la pieza los valores introducidos en el formulario de edición.
    this.actual_piece['figure'] = Number(this.figureForm.controls.figure_id.value);
    this.actual_piece['b1'] = this.figureForm.controls.figure_b1.value;
    this.actual_piece['b2'] = this.figureForm.controls.figure_b2.value;
    this.actual_piece['b3'] = this.figureForm.controls.figure_b3.value;
    this.actual_piece['b4'] = this.figureForm.controls.figure_b4.value;
    this.actual_piece['l'] = this.figureForm.controls.figure_l.value;
    this.actual_piece['l1'] = this.figureForm.controls.figure_l1.value;
    this.actual_piece['l2'] = this.figureForm.controls.figure_l2.value;
    this.actual_piece['h'] = this.figureForm.controls.figure_h.value;
    this.actual_piece['h1'] = this.figureForm.controls.figure_h1.value;
    this.actual_piece['h2'] = this.figureForm.controls.figure_h2.value;
    this.actual_piece['r'] = this.figureForm.controls.figure_r.value;
    this.actual_piece['r2'] = this.figureForm.controls.figure_r2.value;
    this.actual_piece['r3'] = this.figureForm.controls.figure_r3.value;
    this.actual_piece['r4'] = this.figureForm.controls.figure_r4.value;
    if (Number(this.actual_piece['figure']) === 926 || Number(this.actual_piece['figure']) === 2026 || Number(this.actual_piece['figure']) === 63) {
      this.actual_piece['dxf_points'] = JSON.parse(JSON.stringify(this.figureDxfPoints || []));
      this.actual_piece['dxf_name'] = this.figureDxfName || '';
      this.actual_piece['dxf_w'] = Number(this.figureDxfWidth || 0);
      this.actual_piece['dxf_h'] = Number(this.figureDxfHeight || 0);
    } else {
      this.actual_piece['dxf_points'] = null;
      this.actual_piece['dxf_name'] = null;
      this.actual_piece['dxf_w'] = null;
      this.actual_piece['dxf_h'] = null;
    }

    // --------------- Control de valores de la forma.
    let ko_action = false;

    this.alertInfo = '';

    switch (this.actual_piece['figure']) {

		case 1:
		case 2:
			console.log('--> Controlando valores de la forma 1:');

			if (this.figureForm.controls.figure_h1.value > this.figureForm.controls.figure_h.value) {
				console.log('--> El valor de H tiene que ser mayor o igual que el valor de H1.');

				this.alertInfo += '<p>El valor de H tiene que ser mayor o igual que el valor de H1.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_h.value < 1) {
				console.log('--> El valor de H tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de H tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_l1.value < 0) {
				console.log('--> El valor de H1 no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de H1 no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_l.value < 1) {
				console.log('--> El valor de L tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de L tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_b1.value < 0) {
				console.log('--> El valor de B1 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B1 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_b2.value < 0) {
				console.log('--> El valor de B2 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B2 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_b3.value < 0) {
				console.log('--> El valor de B3 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B3 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

		break;

		// ----------- Nuevas formas añadidas B.

		case 3:
	      console.log('--> Controlando valores de la forma 3:');
	      if (this.figureForm.controls.figure_h1.value > this.figureForm.controls.figure_h.value) {
	        console.log('--> El valor de H tiene que ser mayor o igual que el valor de H1.');

	        this.alertInfo += '<p>El valor de H tiene que ser mayor o igual que el valor de H1.</p>';

	        ko_action = true;
	      }

	      if (this.figureForm.controls.figure_l1.value > this.figureForm.controls.figure_l.value) {
	        console.log('--> El valor de L tiene que ser mayor o igual que el valor de L1.');

	        this.alertInfo += '<p>El valor de L tiene que ser mayor o igual que el valor de L1.</p>';

	        ko_action = true;
	      }
	      /* Controles de los valores de la forma 3 */
	      break;

	    case 4:
	      /* Controles de los valores de la forma 4 */
	      console.log('--> Controlando valores de la forma 4:');
	      if (this.figureForm.controls.figure_h1.value > this.figureForm.controls.figure_h.value) {
	        console.log('--> El valor de H tiene que ser mayor o igual que el valor de H1.');

	        this.alertInfo += '<p>El valor de H tiene que ser mayor o igual que el valor de H1.</p>';

	        ko_action = true;
	      }

	      if (this.figureForm.controls.figure_l1.value > this.figureForm.controls.figure_l.value) {
	        console.log('--> El valor de L tiene que ser mayor o igual que el valor de L1.');

	        this.alertInfo += '<p>El valor de L tiene que ser mayor o igual que el valor de L1.</p>';

	        ko_action = true;
	      }

	      break;

	    case 5:
	    case 6:
	      /* Controles de los valores de la forma 5 y 6 */
	      console.log('--> Controlando valores de la forma 5 ó 6:');
	      if (this.figureForm.controls.figure_l1.value + this.figureForm.controls.figure_l2.value
	          > this.figureForm.controls.figure_l.value) {
	        console.log('--> El valor de L tiene que ser mayor o igual que el valor de L1+L2.');

	        this.alertInfo += '<p>El valor de L tiene que ser mayor o igual que el valor de L1+L2.</p>';

	        ko_action = true;
	      }

	      break;

	    case 7:
	    case 8:
	      /* Controles de los valores de la forma 7 y 8 */
	      console.log('--> Controlando valores de la forma 7 ó 8:');
	      if   (this.figureForm.controls.figure_l1.value + this.figureForm.controls.figure_l2.value
	        > this.figureForm.controls.figure_l.value) {
	        console.log('--> El valor de L tiene que ser mayor o igual que el valor de L1+L2.');

	        this.alertInfo += '<p>El valor de L tiene que ser mayor o igual que el valor de L1+L2.</p>';

	        ko_action = true;
	      }

	      if (this.figureForm.controls.figure_h1.value > this.figureForm.controls.figure_h.value) {
	        console.log('--> El valor de H tiene que ser mayor o igual que el valor de H1.');

	        this.alertInfo += '<p>El valor de H tiene que ser mayor o igual que el valor de H1.</p>';

	        ko_action = true;
	      }

	      break;

	    case 9:
	    case 10:
	      /* Controles de los valores de la forma 9 y 10 */
	      console.log('--> Controlando valores de la forma 9 ó 10:');
	      if   (this.figureForm.controls.figure_l1.value + this.figureForm.controls.figure_l2.value
	        > this.figureForm.controls.figure_l.value) {
	        console.log('--> El valor de L tiene que ser mayor o igual que el valor de L1+L2.');

	        this.alertInfo += '<p>El valor de L tiene que ser mayor o igual que el valor de L1+L2.</p>';

	        ko_action = true;
	      }

	      if (this.figureForm.controls.figure_h1.value > this.figureForm.controls.figure_h.value) {
	        console.log('--> El valor de H tiene que ser mayor o igual que el valor de H1.');

	        this.alertInfo += '<p>El valor de H tiene que ser mayor o igual que el valor de H1.</p>';

	        ko_action = true;
	      }

	      if (this.figureForm.controls.figure_h2.value > this.figureForm.controls.figure_h.value) {
	        console.log('--> El valor de H tiene que ser mayor o igual que el valor de H1.');

	        this.alertInfo += '<p>El valor de H tiene que ser mayor o igual que el valor de H2.</p>';

	        ko_action = true;
	      }

	      break;

	    case 11:
	    case 12:
	    case 13:
	    case 14:
	    case 15:
	    case 16:
	    case 17:
	    case 18:
	    case 19:
	      /* Controles de los valores de la forma 11,12,13,14,15,16,17,18 y 19 */
	      console.log('--> Controlando valores de la forma 11,12,13,14,15,16,17,18 ó 19:');
	      if   (this.figureForm.controls.figure_l1.value > this.figureForm.controls.figure_l.value) {
	        console.log('--> El valor de L tiene que ser mayor o igual que el valor de L1.');

	        this.alertInfo += '<p>El valor de L tiene que ser mayor o igual que el valor de L1.</p>';

	        ko_action = true;
	      }

	      if (this.figureForm.controls.figure_h1.value > this.figureForm.controls.figure_h.value) {
	        console.log('--> El valor de H tiene que ser mayor o igual que el valor de H1.');

	        this.alertInfo += '<p>El valor de H tiene que ser mayor o igual que el valor de H1.</p>';

	        ko_action = true;
	      }

	      break;

	    case 20:
	      /* Controles de los valores de la forma 20 */
	      console.log('--> Controlando valores de la forma 20:');
	      if (!this.figureForm.controls.figure_l.value || this.figureForm.controls.figure_l.value < 1) {
	        console.log('--> El valor de L tiene que ser mayor que cero.');

	        this.alertInfo += '<p>El valor de L tiene que ser mayor que cero.</p>';

	        ko_action = true;
	      }

	      if ((!this.figureForm.controls.figure_b1.value && this.figureForm.controls.figure_b1.value !== 0) || this.figureForm.controls.figure_b1.value < 0) {
	        console.log('--> El valor de B1 tiene que ser igual o mayor que cero.');

	        this.alertInfo += '<p>El valor de B1 tiene que ser igual o mayor que cero.</p>';

	        ko_action = true;
	      }

	      if ((!this.figureForm.controls.figure_b2.value && this.figureForm.controls.figure_b2.value !== 0) || this.figureForm.controls.figure_b2.value < 0) {
	        console.log('--> El valor de B2 tiene que ser igual o mayor que cero.');

	        this.alertInfo += '<p>El valor de B2 tiene que ser igual o mayor que cero.</p>';

	        ko_action = true;
	      }

	      break;
	    case 21:
	    case 22:
	    case 23:
	      console.log('--> Controlando valores de la forma 21,22 ó 23:');
	      if (!this.figureForm.controls.figure_l.value || this.figureForm.controls.figure_l.value < 1) {
	        this.alertInfo += '<p>El valor de L tiene que ser mayor que cero.</p>';
	        ko_action = true;
	      }
	      if ((!this.figureForm.controls.figure_b1.value && this.figureForm.controls.figure_b1.value !== 0) || this.figureForm.controls.figure_b1.value < 0) {
	        this.alertInfo += '<p>El valor de B1 tiene que ser igual o mayor que cero.</p>';
	        ko_action = true;
	      }
	      if ((!this.figureForm.controls.figure_b2.value && this.figureForm.controls.figure_b2.value !== 0) || this.figureForm.controls.figure_b2.value < 0) {
	        this.alertInfo += '<p>El valor de B2 tiene que ser igual o mayor que cero.</p>';
	        ko_action = true;
	      }
	      break;
	    case 24:
	      console.log('--> Controlando valores de la forma 24:');
	      if (!this.figureForm.controls.figure_l.value || this.figureForm.controls.figure_l.value < 1) {
	        this.alertInfo += '<p>El valor de L tiene que ser mayor que cero.</p>';
	        ko_action = true;
	      }
	      if ((!this.figureForm.controls.figure_b1.value && this.figureForm.controls.figure_b1.value !== 0) || this.figureForm.controls.figure_b1.value < 0) {
	        this.alertInfo += '<p>El valor de B1 tiene que ser igual o mayor que cero.</p>';
	        ko_action = true;
	      }
	      break;

	    case 25:
	    /* Controles de los valores de la forma 25 */
	    break;

	    case 26:
	    /* Controles de los valores de la forma 26 */
	    break;

		// ------------ Fin nuevas formas añadidas B.

		case 27:
			console.log('--> Controlando valores de la forma 27:');

			if (this.figureForm.controls.figure_h1.value > this.figureForm.controls.figure_h.value) {
				console.log('--> El valor de H tiene que ser mayor o igual que el valor de H1.');

				this.alertInfo += '<p>El valor de H tiene que ser mayor o igual que el valor de H1.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_h.value < 1) {
				console.log('--> El valor de H tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de H tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_l.value < 1) {
				console.log('--> El valor de L tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de L tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_b1.value < 0) {
				console.log('--> El valor de B1 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B1 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_b2.value < 0) {
				console.log('--> El valor de B2 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B2 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_b3.value < 0) {
				console.log('--> El valor de B3 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B3 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}
			/*
			// Valor máximo que puede tomar R dependiendo de los valores de H y H1.
			let r_max = Math.sqrt(Math.pow((this.figureForm.controls.figure_h.value - this.figureForm.controls.figure_h1.value), 2)) / 2;

			if (this.figureForm.controls.figure_r.value > r_max) {
				console.log('--> El valor de R tiene que ser menor o igual que la raíz cuadrada de (L² + (H - H1)²) dividido entre 2. r_max = ' + r_max);

				this.alertInfo += '<p>El valor de R tiene que ser menor o igual que la raíz cuadrada de (L² + (H - H1)²) dividido entre 2.</p>';
				this.alertInfo += '<p>En este caso R debería de tener un valor inferior o igual a ' + r_max + '.</p>';

				ko_action = true;
			} */

		break;
		case 28:
			console.log('--> Controlando valores de la forma 28:');
			const figure28Info = this.getFigure28RadiusRangeValues(
				this.figureForm.controls.figure_l.value,
				this.figureForm.controls.figure_h.value,
				this.figureForm.controls.figure_h1.value
			);
			const figure28R = Number(this.figureForm.controls.figure_r.value);
			if (this.figureForm.controls.figure_l.value < 1) {
				this.alertInfo += '<p>El valor de L tiene que ser mayor que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_h.value < 1) {
				this.alertInfo += '<p>El valor de H tiene que ser mayor que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_h1.value < 0) {
				this.alertInfo += '<p>El valor de H1 tiene que ser igual o mayor que cero.</p>';
				ko_action = true;
			}
			if (!(figure28R >= 1)) {
				this.alertInfo += '<p>En la Forma 28, R* es la flecha (Stichmaß) y debe ser igual o mayor que 1 mm.</p>';
				ko_action = true;
			}
			if (figure28Info && figure28Info.max < figure28Info.min) {
				this.alertInfo += '<p>No existe un valor entero de R* válido para la geometría actual. Modifique L, H o H1.</p>';
				ko_action = true;
			} else if (figure28Info && figure28R > figure28Info.max) {
				this.alertInfo += '<p>En la Forma 28, R* debe estar entre ' + figure28Info.min + ' y ' + figure28Info.max + ' mm. Un valor superior hace que el arco invada una banda lateral del marco envolvente.</p>';
				ko_action = true;
			} else if (figure28Info && figure28R >= figure28Info.min && !this.buildFigure28Geometry(
				this.figureForm.controls.figure_b1.value,
				this.figureForm.controls.figure_b2.value,
				this.figureForm.controls.figure_b3.value,
				this.figureForm.controls.figure_l.value,
				this.figureForm.controls.figure_h.value,
				this.figureForm.controls.figure_h1.value,
				figure28R,
				false
			)) {
				this.alertInfo += '<p>R* produce un contorno que se cruza con uno de sus lados rectos. Reduzca la flecha o modifique L, H y H1.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		case 30:
		case 31:
			console.log('--> Controlando valores de la forma 30 ó 31:');
			if (this.figureForm.controls.figure_l.value < 1) {
				this.alertInfo += '<p>El valor de L tiene que ser mayor que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_h.value < 1) {
				this.alertInfo += '<p>El valor de H tiene que ser mayor que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_h1.value < 0 || this.figureForm.controls.figure_h2.value < 0) {
				this.alertInfo += '<p>Los valores H1 y H2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_h1.value > this.figureForm.controls.figure_h.value || this.figureForm.controls.figure_h2.value > this.figureForm.controls.figure_h.value) {
				this.alertInfo += '<p>Los valores H1 y H2 no pueden superar H.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0) {
				this.alertInfo += '<p>El valor de B1 debe ser igual o mayor que cero.</p>';
				ko_action = true;
			}
			break;
		case 32:
			console.log('--> Controlando valores de la forma 32:');
			if (this.figureForm.controls.figure_l.value < 1 || this.figureForm.controls.figure_h.value < 1) {
				this.alertInfo += '<p>Los valores de L y H deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_l1.value < 0 || this.figureForm.controls.figure_l2.value < 0) {
				this.alertInfo += '<p>Los valores L1 y L2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_l1.value > this.figureForm.controls.figure_l.value ||
				this.figureForm.controls.figure_l2.value > this.figureForm.controls.figure_l.value) {
				this.alertInfo += '<p>Los valores L1 y L2 no pueden superar L.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		case 33:
		case 34:
			console.log('--> Controlando valores de la forma 33 ó 34:');
			if (this.figureForm.controls.figure_l.value < 1 || this.figureForm.controls.figure_h.value < 1) {
				this.alertInfo += '<p>Los valores de L y H deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value > this.figureForm.controls.figure_h.value) {
				this.alertInfo += '<p>El valor de B1 no puede superar H en las figuras 33 y 34.</p>';
				ko_action = true;
			}
			break;
		case 35:
		case 36:
			console.log('--> Controlando valores de la forma 35 ó 36:');
			if (this.figureForm.controls.figure_l.value < 1 || this.figureForm.controls.figure_h.value < 1) {
				this.alertInfo += '<p>Los valores de L y H deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_l1.value < 0) {
				this.alertInfo += '<p>El valor de L1 debe ser igual o mayor que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_l1.value > this.figureForm.controls.figure_l.value) {
				this.alertInfo += '<p>El valor de L1 no puede superar L.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		case 38:
			console.log('--> Controlando valores de la forma 38:');
			if (this.figureForm.controls.figure_l.value < 1 || this.figureForm.controls.figure_h.value < 1) {
				this.alertInfo += '<p>Los valores de L y H deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_l1.value < 0) {
				this.alertInfo += '<p>El valor de L1 debe ser igual o mayor que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_l1.value >= this.figureForm.controls.figure_l.value) {
				this.alertInfo += '<p>El valor de L tiene que ser mayor que el valor de L1.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		case 40:
			console.log('--> Controlando valores de la forma 40:');
			if (this.figureForm.controls.figure_l.value < 1 || this.figureForm.controls.figure_h.value < 1) {
				this.alertInfo += '<p>Los valores de L y H deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_l1.value < 0 || this.figureForm.controls.figure_l1.value > this.figureForm.controls.figure_l.value) {
				this.alertInfo += '<p>El valor de L1 debe estar entre 0 y L.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_h1.value < 0 || this.figureForm.controls.figure_h1.value > this.figureForm.controls.figure_h.value) {
				this.alertInfo += '<p>El valor de H1 debe estar entre 0 y H.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_h2.value < 0 || this.figureForm.controls.figure_h2.value > this.figureForm.controls.figure_h.value) {
				this.alertInfo += '<p>El valor de H2 debe estar entre 0 y H.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		case 41: {
			console.log('--> Controlando valores de la forma 41:');
			if (this.figureForm.controls.figure_l.value < 1 || this.figureForm.controls.figure_h.value < 1) {
				this.alertInfo += '<p>Los valores de L y H deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_l1.value <= 0 || this.figureForm.controls.figure_l2.value <= 0) {
				this.alertInfo += '<p>Los valores L1 y L2 deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const L1 = Number(this.figureForm.controls.figure_l1.value || 0);
			const L2 = Number(this.figureForm.controls.figure_l2.value || 0);
			const H = Number(this.figureForm.controls.figure_h.value || 0);
			const dMax = Math.min(L1, L2 - (L / 2));
			if (dMax < 0) {
				this.alertInfo += '<p>Los valores de L, L1 y L2 no permiten construir la figura 41.</p>';
				ko_action = true;
			} else {
				const f = (d) => {
					const a1 = (L1 * L1) - (d * d);
					const b1 = (L2 * L2) - ((d + (L / 2)) * (d + (L / 2)));
					if (a1 < 0 || b1 < 0) return -H;
					return Math.sqrt(a1) + Math.sqrt(b1) - H;
				};
				const f0 = f(0);
				const f1 = f(dMax);
				if (!((f0 === 0) || (f1 === 0) || ((f0 > 0 && f1 < 0) || (f0 < 0 && f1 > 0)))) {
					this.alertInfo += '<p>La combinación de L, L1, L2 y H no define una geometría válida para la forma 41.</p>';
					ko_action = true;
				}
			}
			break;
		}
		case 42:
			console.log('--> Controlando valores de la forma 42:');
			if (this.figureForm.controls.figure_l.value < 1 || this.figureForm.controls.figure_h.value < 1) {
				this.alertInfo += '<p>Los valores de L y H deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_l1.value < 0 || this.figureForm.controls.figure_l1.value > this.figureForm.controls.figure_l.value) {
				this.alertInfo += '<p>El valor de L1 debe estar entre 0 y L.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_l2.value < 0 || this.figureForm.controls.figure_l2.value > this.figureForm.controls.figure_l.value) {
				this.alertInfo += '<p>El valor de L2 debe estar entre 0 y L.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_h1.value < 0 || this.figureForm.controls.figure_h1.value > this.figureForm.controls.figure_h.value) {
				this.alertInfo += '<p>El valor de H1 debe estar entre 0 y H.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_h2.value < 0 || this.figureForm.controls.figure_h2.value > this.figureForm.controls.figure_h.value) {
				this.alertInfo += '<p>El valor de H2 debe estar entre 0 y H.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;

		case 29:
			console.log('--> Controlando valores de la forma 29:');

			if (this.figureForm.controls.figure_r.value < 1) {
				console.log('--> El valor de R tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de H tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_b1.value < 0) {
				console.log('--> El valor de B1 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B1 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

		break;

		case 37:
			console.log('--> Controlando valores de la forma 37:');

			if (this.figureForm.controls.figure_l1.value >= this.figureForm.controls.figure_l.value) {
				console.log('--> El valor de L tiene que ser mayor que el valor de L1.');

				this.alertInfo += '<p>El valor de L tiene que ser mayor que el valor de L1.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_h.value < 1) {
				console.log('--> El valor de H tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de H tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_l1.value < 0) {
				console.log('--> El valor de L1 no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de L1 no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_b1.value < 0) {
				console.log('--> El valor de B1 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B1 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_b2.value < 0) {
				console.log('--> El valor de B2 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B2 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

		break;

		case 371:
			console.log('--> Controlando valores de la forma 371:');

			this.actual_piece['h1'] = this.figureForm.controls.figure_h1.value;
			this.actual_piece['b3'] = this.figureForm.controls.figure_b3.value;
			this.actual_piece['l2'] = this.figureForm.controls.figure_l2.value;
			this.actual_piece['r'] = this.figureForm.controls.figure_r.value;

			// console.log('--> H = ' + this.actual_piece['h1']);
			// console.log('--> W = ' + this.actual_piece['b3']);
			// console.log('--> A1 = ' + this.actual_piece['l2']);
			// console.log('--> A2 = ' + this.actual_piece['r']);

			let angle = 0;

			angle = 90 - this.actual_piece['l2'];

			// console.log('--> Angulo 90 - A1 = ' + angle);

			let l1 =  Number(this.actual_piece['h1'] ) * Math.sin(angle * (Math.PI / 180));
			let l =  Number(this.actual_piece['b3']) + l1;
			let h = Number(this.actual_piece['h1']) * Math.cos(Number(angle) * (Math.PI / 180));

		    this.actual_piece['r'] = (180 - Number(this.actual_piece['l2']));
		    this.actual_piece['h'] = Math.ceil(h);
		    this.actual_piece['l'] = Math.ceil(l);
		    this.actual_piece['l1'] = Math.ceil(l1);

		    this.figureForm.controls.figure_r.setValue(this.actual_piece['r']);

			if (!this.figureForm.controls.figure_h1.value || this.figureForm.controls.figure_h1.value < 1) {
				console.log('--> El valor de H tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de H tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (!this.figureForm.controls.figure_b3.value || this.figureForm.controls.figure_b3.value < 1) {
				console.log('--> El valor de W tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de W tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_l2.value && this.figureForm.controls.figure_l2.value !== 0) || this.figureForm.controls.figure_l2.value < 1) {
				console.log('--> El valor de A1 tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de A1 tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_l2.value > 90) {
				console.log('--> El valor de A1 no puede ser mayor de 90.');

				this.alertInfo += '<p>El valor de A1 no puede ser mayor de 90.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_r.value && this.figureForm.controls.figure_r.value !== 0) || this.figureForm.controls.figure_r.value < 1) {
				console.log('--> El valor de A2 tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de A2 tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (this.figureForm.controls.figure_r.value > 180) {
				console.log('--> El valor de A2 no puede ser mayor de 180.');

				this.alertInfo += '<p>El valor de A2 no puede ser mayor de 180.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b1.value && this.figureForm.controls.figure_b1.value !== 0) || this.figureForm.controls.figure_b1.value < 0) {
				console.log('--> El valor de B1 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B1 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b2.value && this.figureForm.controls.figure_b2.value !== 0) || this.figureForm.controls.figure_b2.value < 0) {
				console.log('--> El valor de B2 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B2 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

			break;

		case 372: {
			console.log('--> Controlando valores de la forma 372:');

			const resolved372 = this.getFigure372ResolvedValuesFromForm(true);
			if (!resolved372.ok) {
				this.alertInfo += '<p>' + resolved372.error + '</p>';
				ko_action = true;
				break;
			}
			const values372 = resolved372.values;
			this.actual_piece['l'] = values372.L;
			this.actual_piece['l1'] = values372.L1;
			this.actual_piece['l2'] = values372.L2;
			this.actual_piece['b3'] = values372.L3;
			this.actual_piece['h'] = Math.max(values372.H1, values372.H2);
			this.actual_piece['h1'] = values372.H1;
			this.actual_piece['h2'] = values372.H2;

			if ((!this.figureForm.controls.figure_b1.value && this.figureForm.controls.figure_b1.value !== 0) || this.figureForm.controls.figure_b1.value < 0) {
				this.alertInfo += '<p>El valor de B1 no puede ser menor de cero.</p>';
				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b2.value && this.figureForm.controls.figure_b2.value !== 0) || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>El valor de B2 no puede ser menor de cero.</p>';
				ko_action = true;
			}

			break;
		}

		case 43:
			console.log('--> Controlando valores de la forma 43:');

			if (this.figureForm.controls.figure_l1.value > this.figureForm.controls.figure_l.value) {
				console.log('--> El valor de L tiene que ser mayor o igual que el valor de L1.');

				this.alertInfo += '<p>El valor de L tiene que ser mayor o igual que el valor de L1.</p>';

				ko_action = true;
			}

			if (!this.figureForm.controls.figure_h.value || this.figureForm.controls.figure_h.value < 1) {
				console.log('--> El valor de H tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de H tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_l1.value && this.figureForm.controls.figure_l1.value !== 0) || this.figureForm.controls.figure_l1.value < 0) {
				console.log('--> El valor de L1 no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de L1 no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b1.value && this.figureForm.controls.figure_b1.value !== 0) || this.figureForm.controls.figure_b1.value < 0) {
				console.log('--> El valor de B1 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B1 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b2.value && this.figureForm.controls.figure_b2.value !== 0) || this.figureForm.controls.figure_b2.value < 0) {
				console.log('--> El valor de B2 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B2 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

		break;
		case 44: {
			console.log('--> Controlando valores de la forma 44:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const L1 = Number(this.figureForm.controls.figure_l1.value || 0);
			const L2 = Number(this.figureForm.controls.figure_l2.value || 0);
			if (L < 1 || L1 <= 0 || L2 <= 0) {
				this.alertInfo += '<p>Los valores de L, L1 y L2 deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			if (!(L1 + L2 > L && Math.abs(L1 - L2) < L)) {
				this.alertInfo += '<p>La combinación de L, L1 y L2 no define una geometría válida para la forma 44.</p>';
				ko_action = true;
			}
			break;
		}
		case 45:
		case 46: {
			console.log('--> Controlando valores de la forma 45 ó 46:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const H = Number(this.figureForm.controls.figure_h.value || 0);
			const L1 = Number(this.figureForm.controls.figure_l1.value || 0);
			const L2 = Number(this.figureForm.controls.figure_l2.value || 0);
			if (L < 1 || H < 1 || L1 <= 0 || L2 <= 0) {
				this.alertInfo += '<p>Los valores de L, H, L1 y L2 deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 47:
		case 49: {
			console.log('--> Controlando valores de la forma 47 ó 49:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const H = Number(this.figureForm.controls.figure_h.value || 0);
			const H1 = Number(this.figureForm.controls.figure_h1.value || 0);
			const L1 = Number(this.figureForm.controls.figure_l1.value || 0);
			const L2 = Number(this.figureForm.controls.figure_l2.value || 0);
			if (L < 1 || H < 1 || H1 < 1 || L1 < 0 || L2 < 0) {
				this.alertInfo += '<p>Los valores L, H y H1 deben ser mayores que cero; L1 y L2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			if (H1 > H) {
				this.alertInfo += '<p>El valor H1 no puede superar H.</p>';
				ko_action = true;
			}
			if ((L1 > L) || (L2 > L)) {
				this.alertInfo += '<p>Los valores L1 y L2 no pueden superar L.</p>';
				ko_action = true;
			}
			if ((L1 + L2) > L) {
				this.alertInfo += '<p>La suma L1 + L2 no puede superar L.</p>';
				ko_action = true;
			}
			if (Number(this.figureForm.controls.figure_id.value) === 49 && H > 0) {
				const dxTopRight = (L1 * H1) / H;
				if (dxTopRight > L2) {
					this.alertInfo += '<p>En la forma 49 debe cumplirse L2 >= (L1*H1/H) para mantener la geometría dentro del marco.</p>';
					ko_action = true;
				}
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 48: {
			console.log('--> Controlando valores de la forma 48:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const H = Number(this.figureForm.controls.figure_h.value || 0);
			const L1 = Number(this.figureForm.controls.figure_l1.value || 0);
			const L2 = Number(this.figureForm.controls.figure_l2.value || 0);
			const H1 = Number(this.figureForm.controls.figure_h1.value || 0);
			const H2 = Number(this.figureForm.controls.figure_h2.value || 0);
			if (L < 1 || H < 1) {
				this.alertInfo += '<p>Los valores de L y H deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (L1 < 0 || L2 < 0 || H1 < 0 || H2 < 0) {
				this.alertInfo += '<p>Los valores L1, L2, H1 y H2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			if ((2 * L1) > L || (2 * L2) > L) {
				this.alertInfo += '<p>Los valores L1 y L2 no pueden superar L/2.</p>';
				ko_action = true;
			}
			if ((H1 + H2) > H) {
				this.alertInfo += '<p>La suma H1 + H2 no puede superar H.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}

		case 50:
			console.log('--> Controlando valores de la forma 50:');

			const toNum = (v: any): number => {
	          const n = Number(v);
	          return Number.isFinite(n) ? n : NaN;
	        };

	        const L  = toNum(this.figureForm.controls.figure_l.value);
	        const H  = toNum(this.figureForm.controls.figure_h.value);
	        const B1 = toNum(this.figureForm.controls.figure_b1.value);
	        const B2 = toNum(this.figureForm.controls.figure_b2.value);
	        const B3 = toNum(this.figureForm.controls.figure_b3.value);

	        const addErr = (msg: string) => {
	          console.log('--> ' + msg);
	          this.alertInfo += `<p>${msg}</p>`;
	          ko_action = true;
	        };

	        const addWarn = (msg: string) => {
	          console.log('--> ' + msg);
	          this.alertInfo += `<p>${msg}</p>`;
	        };

	        // 0) NaN / vacíos
	        if (!Number.isFinite(L))  addErr('El valor de L no es válido.');
	        if (!Number.isFinite(H))  addErr('El valor de H no es válido.');
	        if (!Number.isFinite(B1)) addErr('El valor de B1 no es válido.');
	        if (!Number.isFinite(B2)) addErr('El valor de B2 no es válido.');
	        if (!Number.isFinite(B3)) addErr('El valor de B3 no es válido.');

	        if (ko_action) break;

	        // 1) Básicos
	        if (!(L > 0)) addErr('El valor de L debe ser mayor que cero.');
	        if (!(H > 0)) addErr('El valor de H debe ser mayor que cero.');
	        if (B1 < 0) addErr('El valor de B1 no puede ser negativo.');
	        if (B2 < 0) addErr('El valor de B2 no puede ser negativo.');
	        if (B3 < 0) addErr('El valor de B3 no puede ser negativo.');

	        if (ko_action) break;

	        // 2) Regla geométrica de segmento circular (segmento menor)
	        // Para una cuerda L y una flecha H, la geometría válida cumple: 0 < H <= L/2
	        const Hmax = L / 2;

	        if (H > Hmax) {
	          addErr(
	            `Geometría inválida: para la figura 50 debe cumplirse H <= L/2. ` +
	            `Con L=${L}, el máximo H permitido es ${Hmax.toFixed(2)}.`
	          );
	        }

	        // 3) Aviso si el arco es extremadamente plano (no error)
	        // Si H es muy pequeño, el radio sale enorme y algunos postprocesados/máquinas
	        // pueden simplificar demasiado el arco.
	        const HminWarn = 5; // mm, ajústalo a tu realidad
	        if (H < HminWarn) {
	          addWarn(
	            `Aviso: H muy pequeño (${H} mm). El arco será muy plano y puede ser simplificado por la máquina.`
	          );
	        }

			/*
			if (!this.figureForm.controls.figure_h.value || this.figureForm.controls.figure_h.value < 1) {
				console.log('--> El valor de H tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de H tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (!this.figureForm.controls.figure_l.value || this.figureForm.controls.figure_l.value < 1) {
				console.log('--> El valor de L tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de L tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b1.value && this.figureForm.controls.figure_b1.value !== 0) || this.figureForm.controls.figure_b1.value < 0) {
				console.log('--> El valor de B1 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B1 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b2.value && this.figureForm.controls.figure_b2.value !== 0) || this.figureForm.controls.figure_b2.value < 0) {
				console.log('--> El valor de B2 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B2 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b3.value && this.figureForm.controls.figure_b3.value !== 0) || this.figureForm.controls.figure_b3.value < 0) {
				console.log('--> El valor de B3 tiene que no puede ser menor de cero.');

				this.alertInfo += '<p>El valor de B3 tiene que no puede ser menor de cero.</p>';

				ko_action = true;
			} // */

		break;
		case 51: {
			console.log('--> Controlando valores de la forma 51:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const R = Number(this.figureForm.controls.figure_r.value || 0);
			if (L < 1 || R <= 0) {
				this.alertInfo += '<p>Los valores de L y R deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (R < (L / 2)) {
				this.alertInfo += '<p>El valor de R debe ser igual o mayor que L/2 para construir la forma 51.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 52: {
			console.log('--> Controlando valores de la forma 52:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const H = Number(this.figureForm.controls.figure_h.value || 0);
			const R = Number(this.figureForm.controls.figure_r.value || 0);
			const R1 = Number(this.figureForm.controls.figure_r2.value || 0);
			if (L < 1 || H < 1 || R < 0 || R1 < 0) {
				this.alertInfo += '<p>Los valores L y H deben ser mayores que cero; R y R1 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 53: {
			console.log('--> Controlando valores de la forma 53:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const H = Number(this.figureForm.controls.figure_h.value || 0);
			if (L < 1 || H < 1) {
				this.alertInfo += '<p>Los valores L y H deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 54: {
			console.log('--> Controlando valores de la forma 54:');
			const L1 = Number(this.figureForm.controls.figure_l1.value || 0);
			const L2 = Number(this.figureForm.controls.figure_l2.value || 0);
			const H1 = Number(this.figureForm.controls.figure_h1.value || 0);
			const H2 = Number(this.figureForm.controls.figure_h2.value || 0);
			if (L1 < 1 || L2 < 1 || H1 < 1 || H2 < 1) {
				this.alertInfo += '<p>Los valores L1, L2, H1 y H2 deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 56: {
			console.log('--> Controlando valores de la forma 56:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const H = Number(this.figureForm.controls.figure_h.value || 0);
			const R = Number(this.figureForm.controls.figure_r.value || 0);
			const R1 = Number(this.figureForm.controls.figure_r2.value || 0);
			const R2 = Number(this.figureForm.controls.figure_r3.value || 0);
			const R3 = Number(this.figureForm.controls.figure_r4.value || 0);
			if (L < 1 || H < 1 || R < 0 || R1 < 0 || R2 < 0 || R3 < 0) {
				this.alertInfo += '<p>Los valores L y H deben ser mayores que cero; R, R1, R2 y R3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			if ((R1 + R2) > L || (R + R3) > L || (R1 + R) > H || (R2 + R3) > H) {
				this.alertInfo += '<p>La combinación de radios no es válida para L y H en la forma 56.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 57:
		case 58: {
			console.log('--> Controlando valores de la forma 57/58:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const H = Number(this.figureForm.controls.figure_h.value || 0);
			const H1 = Number(this.figureForm.controls.figure_h1.value || 0);
			const R = Number(this.figureForm.controls.figure_r.value || 0);
			const R1 = Number(this.figureForm.controls.figure_r2.value || 0);
			const R2 = Number(this.figureForm.controls.figure_r3.value || 0);
			if (L < 1 || H < 1 || H1 < 1 || R <= 0 || R1 < 0 || R2 < 0) {
				this.alertInfo += '<p>Los valores L, H, H1 y R deben ser mayores que cero; R1 y R2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
			case 59: {
				console.log('--> Controlando valores de la forma 59:');
				const H = Number(this.figureForm.controls.figure_h.value || 0);
				if (H < 1) {
					this.alertInfo += '<p>El valor H debe ser mayor que cero.</p>';
					ko_action = true;
				}
				if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0) {
				this.alertInfo += '<p>Los valores B1 y B2 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 60: {
			console.log('--> Controlando valores de la forma 60:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const H = Number(this.figureForm.controls.figure_h.value || 0);
			const H1 = Number(this.figureForm.controls.figure_h1.value || 0);
			if (L < 1 || H < 1 || H1 <= 0) {
				this.alertInfo += '<p>Los valores L, H y H1 deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (H1 > H) {
				this.alertInfo += '<p>En la forma 60 debe cumplirse H1 <= H.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 61: {
			console.log('--> Controlando valores de la forma 61:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const H = Number(this.figureForm.controls.figure_h.value || 0);
			const R = Number(this.figureForm.controls.figure_r.value || 0);
			if (L < 1 || H < 1 || R <= 0) {
				this.alertInfo += '<p>Los valores L, H y R deben ser mayores que cero.</p>';
				ko_action = true;
			}
			const minR = this.computeFigure61ContainmentMinRadius(L, H);
			if (R < minR) {
				this.alertInfo += `<p>En la forma 61 debe cumplirse R >= ${Math.ceil(minR)} (centro de círculo en punto medio L/H).</p>`;
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 62: {
			console.log('--> Controlando valores de la forma 62:');
			const L = Number(this.figureForm.controls.figure_l.value || 0);
			const R = Number(this.figureForm.controls.figure_r.value || 0);
			const R1 = Number(this.figureForm.controls.figure_r2.value || 0);
			if (L < 1 || R <= 0 || R1 <= 0) {
				this.alertInfo += '<p>Los valores L, R y R1 deben ser mayores que cero.</p>';
				ko_action = true;
			}
			if (R < L) {
				this.alertInfo += '<p>En la forma 62 debe cumplirse R >= L.</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 || this.figureForm.controls.figure_b2.value < 0 || this.figureForm.controls.figure_b3.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2 y B3 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}
		case 926:
		case 2026:
		case 63: {
			console.log('--> Controlando valores de la forma 926 (DXF libre):');
			if (!this.figureDxfPoints || this.figureDxfPoints.length < 3 || this.figureDxfWidth <= 0 || this.figureDxfHeight <= 0) {
				this.alertInfo += '<p>Debes subir un DXF válido (contorno cerrado con entidades LINE).</p>';
				ko_action = true;
			}
			if (this.figureForm.controls.figure_b1.value < 0 ||
			    this.figureForm.controls.figure_b2.value < 0 ||
			    this.figureForm.controls.figure_b3.value < 0 ||
			    this.figureForm.controls.figure_b4.value < 0) {
				this.alertInfo += '<p>Los valores B1, B2, B3 y B4 deben ser iguales o mayores que cero.</p>';
				ko_action = true;
			}
			break;
		}

		case 55:
	      console.log('--> Controlando valores de la forma 55:');

			if (!this.figureForm.controls.figure_h.value || this.figureForm.controls.figure_h.value < 1) {
				console.log('--> El valor de H tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de H tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if (!this.figureForm.controls.figure_l.value || this.figureForm.controls.figure_l.value < 1) {
				console.log('--> El valor de L tiene que ser mayor que cero.');

				this.alertInfo += '<p>El valor de L tiene que ser mayor que cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b1.value && this.figureForm.controls.figure_b1.value !== 0) || this.figureForm.controls.figure_b1.value < 0) {
				console.log('--> El valor de B1 tiene que ser igual o mayor que cero.');

				this.alertInfo += '<p>El valor de B1 tiene que ser igual o mayor que cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b2.value && this.figureForm.controls.figure_b2.value !== 0) || this.figureForm.controls.figure_b2.value < 0) {
				console.log('--> El valor de B2 tiene que ser igual o mayor que cero.');

				this.alertInfo += '<p>El valor de B2 tiene que ser igual o mayor que cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b3.value && this.figureForm.controls.figure_b3.value !== 0) || this.figureForm.controls.figure_b3.value < 0) {
				console.log('--> El valor de B3 tiene que ser igual o mayor que cero.');

				this.alertInfo += '<p>El valor de B3 tiene que ser igual o mayor que cero.</p>';

				ko_action = true;
			}

			if ((!this.figureForm.controls.figure_b4.value && this.figureForm.controls.figure_b4.value !== 0) || this.figureForm.controls.figure_b4.value < 0) {
				console.log('--> El valor de B4 tiene que ser igual o mayor que cero.');

				this.alertInfo += '<p>El valor de B4 tiene que ser igual o mayor que cero.</p>';

				ko_action = true;
			}
	    break;
	}

    // ---------------

    if (!ko_action) {

		// Hay que recalcular los valores de ancho y alto de
		// la pieza según la forma que tenga para que actualice
		// en la pestaña de piezas las modificaciones aplicadas.

		switch (Number(this.actual_piece.figure)) {
          case 1:

            // console.log('-->> Calculando datos para fórmula FORMA 1 = ' + this.actual_piece.figure);
            this.actual_piece.width = this.actual_piece.b3 + this.actual_piece.l + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2;

            break;

          case 2:

            // console.log('-->> Calculando datos para fórmula FORMA 2 = ' + this.actual_piece.figure);
            this.actual_piece.width = this.actual_piece.b3 + this.actual_piece.l + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2;

            break;

          // ------------ Nuevas formas añadidas C.

          case 3:

            // console.log('-->> Calculando datos para fórmula FORMA 3 = ' + this.actual_piece.figure);
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2;

            break;

          case 4:

            // console.log('-->> Calculando datos para fórmula FORMA 4 = ' + this.actual_piece.figure);
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2;

            break;

          case 5:
          case 6:
          case 7:
          case 8:
            // console.log('-->> Calculando datos para fórmula FORMA 5, 6, 7 y 8 = ' + this.actual_piece.figure);
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b3;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2 + this.actual_piece.b2;

            break;

          case 9:
          case 10:
            // console.log('-->> Calculando datos para fórmula FORMA 9 y 10 = ' + this.actual_piece.figure);
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b3;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2;

            break;

          case 11:
          case 12:
          case 13:
            // console.log('-->> Calculando datos para fórmula FORMA 11,12 y 13 = ' + this.actual_piece.figure);
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b3;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2 + this.actual_piece.b4;

            break;


	      case 14:
	      case 15:
	      case 16:
	      case 17:
	      case 18:
	      case 19:
	        // console.log('-->> Calculando datos para fórmula FORMA 14,15 y 16 = ' + this.actual_piece.figure);
	        this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b3;
	        this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2 + this.actual_piece.b3;

	        break;

	      case 20:
	        this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b1;
	        this.actual_piece.height = Math.ceil(((Math.sqrt(3) / 2) * this.actual_piece.l) + this.actual_piece.b1 + this.actual_piece.b2);

	        break;
	      case 21:
	      case 22:
	      case 23: {
	        const n = Number(this.actual_piece.figure) - 16;
	        const side = Number(this.actual_piece.l);
	        const R = side / (2 * Math.sin(Math.PI / n));
	        const a = side / (2 * Math.tan(Math.PI / n));
	        const polyW = 2 * R;
	        let polyH = a + R;
	        if (Number(this.actual_piece.figure) === 22) {
	          polyH = 2 * a;
	        }
	        this.actual_piece.width = Math.ceil(polyW + (2 * Number(this.actual_piece.b2 || 0)));
	        this.actual_piece.height = Math.ceil(polyH + (2 * Number(this.actual_piece.b1 || 0)));
	        break;
	      }
	      case 24: {
	        const n = 8;
	        const side = Number(this.actual_piece.l);
	        const a = side / (2 * Math.tan(Math.PI / n));
	        const polyW = 2 * a;
	        const polyH = 2 * a;
	        this.actual_piece.width = Math.ceil(polyW + (2 * Number(this.actual_piece.b1 || 0)));
	        this.actual_piece.height = Math.ceil(polyH + (2 * Number(this.actual_piece.b1 || 0)));
	        break;
	      }

          case 25:

            // console.log('-->> Calculando datos para fórmula FORMA 25 = ' + this.actual_piece.figure);
            this.actual_piece.width = this.actual_piece.b1 + this.actual_piece.l + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.b2 + this.actual_piece.h + this.actual_piece.b3;

            break;

          case 26:
            console.log('-->> Calculando datos para fórmula FORMA 26 = ' + this.actual_piece.figure);
            this.actual_piece.width = this.actual_piece.b1 + this.actual_piece.l + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.b2 + this.actual_piece.h + this.actual_piece.b2;

            break;

		  // ------------ Fin nuevas formas añadidas C.

          case 27:

            console.log('-->> Calculando datos para fórmula FORMA 27 = ' + this.actual_piece.figure);
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b2;
            // NOTA: Realmente no sabemos el alto (height) real del marco rectangular que
            // engloba a la forma (ya que hay una distancia que se desconoce entre B3 y H).
            // Se va a poner una aproximación usando de momento el valor de la mitad de R.
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b3 + (this.actual_piece.r / (this.actual_piece.h - this.actual_piece.h1 ? 2 : 1));

			console.log(this.actual_piece.width);
			console.log(this.actual_piece.height);

            break;
          case 28: {
            const geometry28 = this.buildFigure28Geometry(
              this.actual_piece.b1,
              this.actual_piece.b2,
              this.actual_piece.b3,
              this.actual_piece.l,
              this.actual_piece.h,
              this.actual_piece.h1,
              this.actual_piece.r,
              false
            );
            this.actual_piece.width = geometry28 ? geometry28.width : (this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b2);
            this.actual_piece.height = geometry28 ? geometry28.height : (this.actual_piece.h + this.actual_piece.b3);
            break;
          }
          case 30:
          case 31:
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.h;
            break;
          case 32:
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2 + this.actual_piece.b2;
            break;
          case 33:
          case 34:
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b2 + this.actual_piece.b2;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2 + this.actual_piece.b2;
            break;
          case 35:
          case 36:
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2 + this.actual_piece.b2;
            break;
          case 38:
            this.actual_piece.width = this.actual_piece.l + (2 * this.actual_piece.b1);
            this.actual_piece.height = this.actual_piece.h + (2 * this.actual_piece.b2);
            break;
          case 40:
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2 + this.actual_piece.b3;
            break;
          case 41: {
            const L = Number(this.actual_piece.l || 0);
            const L1 = Number(this.actual_piece.l1 || 0);
            const L2 = Number(this.actual_piece.l2 || 0);
            const H = Number(this.actual_piece.h || 0);
            let d1 = 0;
            const dMin = 0;
            const dMax = Math.min(L1, L2 - (L / 2));
            if (dMax > dMin && H > 0) {
              const f = (d) => {
                const a1 = (L1 * L1) - (d * d);
                const b1 = (L2 * L2) - ((d + (L / 2)) * (d + (L / 2)));
                if (a1 < 0 || b1 < 0) return -H;
                return Math.sqrt(a1) + Math.sqrt(b1) - H;
              };
              let lo = dMin;
              let hi = dMax;
              let flo = f(lo);
              let fhi = f(hi);
              if (flo === 0) {
                d1 = lo;
              } else if (fhi === 0) {
                d1 = hi;
              } else if ((flo > 0 && fhi < 0) || (flo < 0 && fhi > 0)) {
                for (let i = 0; i < 40; i++) {
                  const mid = (lo + hi) / 2;
                  const fmid = f(mid);
                  if (fmid === 0) {
                    lo = mid;
                    hi = mid;
                    break;
                  }
                  if ((flo > 0 && fmid > 0) || (flo < 0 && fmid < 0)) {
                    lo = mid;
                    flo = fmid;
                  } else {
                    hi = mid;
                    fhi = fmid;
                  }
                }
                d1 = (lo + hi) / 2;
              }
            }
            this.actual_piece.width = Math.round(L + (2 * d1) + Number(this.actual_piece.b1 || 0) + Number(this.actual_piece.b3 || 0));
            this.actual_piece.height = Math.round(Number(this.actual_piece.h || 0) + Number(this.actual_piece.b2 || 0));
            break;
          }
          case 42:
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b1 + this.actual_piece.b1;
            this.actual_piece.height = this.actual_piece.h + this.actual_piece.b2 + this.actual_piece.b2;
            break;

          case 29:

            // console.log('-->> Calculando datos para fórmula FORMA 29 círculo = ' + this.actual_piece.figure);
            this.actual_piece.width = (this.actual_piece.r + this.actual_piece.b1) * 2;
            this.actual_piece.height = (this.actual_piece.r + this.actual_piece.b1) * 2;

            break;

          case 37:
		  case 371:
          case 372:
          case 43:

            // console.log('-->> Calculando datos para fórmula FORMA 37 o FORMA 43 = ' + this.actual_piece.figure);
            if (this.actual_piece.figure === 372) {
              const L3 = Number(this.actual_piece.b3 || 0);
              const L1 = Number(this.actual_piece.l1 || 0);
              const L2 = Number(this.actual_piece.l2 || 0);
              this.actual_piece.width = Math.max(L3, L3 + L2, L1) + (2 * Number(this.actual_piece.b1 || 0));
              this.actual_piece.height = Math.max(Number(this.actual_piece.h1 || 0), Number(this.actual_piece.h2 || 0)) + (2 * Number(this.actual_piece.b2 || 0));
            } else {
              this.actual_piece.width = this.actual_piece.l + (2 * this.actual_piece.b1);
              this.actual_piece.height = this.actual_piece.h + (2 * this.actual_piece.b2);
            }

            break;
          case 44: {
            const L = Number(this.actual_piece.l || 0);
            const L1 = Number(this.actual_piece.l1 || 0);
            const L2 = Number(this.actual_piece.l2 || 0);
            let h = 0;
            if (L > 0) {
              const x = ((L1 * L1) - (L2 * L2) + (L * L)) / (2 * L);
              const hSq = (L1 * L1) - (x * x);
              if (hSq > 0) h = Math.sqrt(hSq);
            }
            this.actual_piece.width = Math.round(L + (2 * Number(this.actual_piece.b1 || 0)));
            this.actual_piece.height = Math.round(h + (2 * Number(this.actual_piece.b2 || 0)));
            break;
          }
          case 45:
          case 46: {
            const L = Number(this.actual_piece.l || 0);
            const H = Number(this.actual_piece.h || 0);
            const L1 = Number(this.actual_piece.l1 || 0);
            const L2 = Number(this.actual_piece.l2 || 0);
            let cx = L;
            let cy = H;
            if (Number(this.actual_piece.figure) === 45) {
              const l1c = Math.max(0, Math.min(H, L1));
              const l2c = Math.max(0, Math.min(L, L2));
              cx = L - l2c;
              cy = H - l1c;
              if (cy < 0) cy = 0;
            } else {
              const d = Math.sqrt((L * L) + (H * H));
              if (d > 0) {
                const a = ((L1 * L1) - (L2 * L2) + (d * d)) / (2 * d);
                const hSq = (L1 * L1) - (a * a);
                if (hSq >= 0) {
                  const hh = Math.sqrt(hSq);
                  const ux = L / d;
                  const uy = -H / d;
                  const p2x = a * ux;
                  const p2y = H + (a * uy);
                  const c1x = p2x - (hh * uy);
                  const c1y = p2y + (hh * ux);
                  const c2x = p2x + (hh * uy);
                  const c2y = p2y - (hh * ux);
                  if (c1y >= c2y) { cx = c1x; cy = c1y; } else { cx = c2x; cy = c2y; }
                }
              }
            }
            const innerW = Number(this.actual_piece.figure) === 46 ? Math.max(L, cx) : L;
            const innerH = Number(this.actual_piece.figure) === 46 ? Math.max(H, cy) : H;
            this.actual_piece.width = Math.round(Number(this.actual_piece.b1 || 0) + innerW + Number(this.actual_piece.b3 || 0));
            this.actual_piece.height = Math.round(Number(this.actual_piece.b2 || 0) + innerH + Number(this.actual_piece.b3 || 0));
            break;
          }
          case 47: {
            const L = Number(this.actual_piece.l || 0);
            const H = Number(this.actual_piece.h || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            const B3 = Number(this.actual_piece.b3 || 0);
            this.actual_piece.width = Math.round(L + (2 * B1));
            this.actual_piece.height = Math.round(H + B2 + B3);
            break;
          }
          case 48: {
            const L = Number(this.actual_piece.l || 0);
            const H = Number(this.actual_piece.h || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            const B3 = Number(this.actual_piece.b3 || 0);
            this.actual_piece.width = Math.round(L + (2 * B1));
            this.actual_piece.height = Math.round(H + B2 + B3);
            break;
          }
          case 49: {
            const L = Number(this.actual_piece.l || 0);
            const H = Number(this.actual_piece.h || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            const B3 = Number(this.actual_piece.b3 || 0);
            this.actual_piece.width = Math.round(L + (2 * B1));
            this.actual_piece.height = Math.round(H + B2 + B3);
            break;
          }

          case 50:

            // console.log('-->> Calculando datos para fórmula FORMA 50 semicírculo = ' + piece.figure);
            this.actual_piece.width = this.actual_piece.l + (this.actual_piece.b1 * 2);
            this.actual_piece.height = this.actual_piece.b2 + this.actual_piece.h + this.actual_piece.b3;

            break;
          case 51: {
            const L = Number(this.actual_piece.l || 0);
            const R = Number(this.actual_piece.r || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            const B3 = Number(this.actual_piece.b3 || 0);
            let h = 0;
            if (R > 0 && (L / 2) <= R) {
              const d = Math.sqrt((R * R) - ((L / 2) * (L / 2)));
              h = R - d;
            }
            this.actual_piece.width = Math.round(L + (2 * B1));
            this.actual_piece.height = Math.round(B2 + h + B3);
            break;
          }
          case 52:
          case 53: {
            const L = Number(this.actual_piece.l || 0);
            const H = Number(this.actual_piece.h || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            this.actual_piece.width = Math.round(L + (2 * B1));
            this.actual_piece.height = Math.round(H + (2 * B2));
            break;
          }
          case 54: {
            const L1 = Number(this.actual_piece.l1 || 0);
            const L2 = Number(this.actual_piece.l2 || 0);
            const H1 = Number(this.actual_piece.h1 || 0);
            const H2 = Number(this.actual_piece.h2 || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            this.actual_piece.width = Math.round(L1 + L2 + (2 * B1));
            this.actual_piece.height = Math.round(H1 + H2 + (2 * B2));
            break;
          }
          case 56: {
            const L = Number(this.actual_piece.l || 0);
            const H = Number(this.actual_piece.h || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            this.actual_piece.width = Math.round(L + (2 * B1));
            this.actual_piece.height = Math.round(H + (2 * B2));
            break;
          }
          case 57:
          case 58: {
            const L = Number(this.actual_piece.l || 0);
            const H = Number(this.actual_piece.h || 0);
            const H1 = Number(this.actual_piece.h1 || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            const B3 = Number(this.actual_piece.b3 || 0);
            this.actual_piece.width = Math.round(L + (2 * B1));
            this.actual_piece.height = Math.round(Math.max(H, H1) + B2 + B3);
            break;
          }
          case 59: {
            const H = Number(this.actual_piece.h || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            this.actual_piece.width = Math.round(B1 + H + B2);
            this.actual_piece.height = Math.round(B1 + H + B2);
            break;
          }
          case 60: {
            const L = Number(this.actual_piece.l || 0);
            const H = Number(this.actual_piece.h || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            const B3 = Number(this.actual_piece.b3 || 0);
            this.actual_piece.width = Math.round(B1 + L + B3);
            this.actual_piece.height = Math.round(B2 + H + B3);
            break;
          }
          case 61: {
            const L = Number(this.actual_piece.l || 0);
            const H = Number(this.actual_piece.h || 0);
            const RIn = Number(this.actual_piece.r || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            const B3 = Number(this.actual_piece.b3 || 0);
            const minR = Math.max(L / 2, H / 2) + 0.000001;
            const R = (RIn > minR) ? RIn : minR;
            const cx = B1 + (L / 2);
            const cy = B2 + (H / 2);
            this.actual_piece.width = Math.round((cx + R) + B3);
            this.actual_piece.height = Math.round((cy + R) + B3);
            break;
          }
          case 62: {
            const L = Number(this.actual_piece.l || 0);
            const R = Number(this.actual_piece.r || 0);
            const R1 = Number(this.actual_piece.r2 || 0);
            const B1 = Number(this.actual_piece.b1 || 0);
            const B2 = Number(this.actual_piece.b2 || 0);
            const B3 = Number(this.actual_piece.b3 || 0);
            let angleRad = (R1 * Math.PI) / 180;
            if (angleRad < (1 * Math.PI / 180)) angleRad = 1 * Math.PI / 180;
            if (angleRad > (120 * Math.PI / 180)) angleRad = 120 * Math.PI / 180;
            const rIn = Math.max(0, R - L);
            const cosA = Math.cos(angleRad);
            const leftNeedOuter = rIn - (R * cosA);
            const leftNeedInner = rIn * (1 - cosA);
            const leftExtra = Math.max(0, rIn - B1, leftNeedOuter, leftNeedInner);
            const shapeH = (angleRad <= (Math.PI / 2)) ? Math.max(0, (R * Math.sin(angleRad))) : R;
            this.actual_piece.width = Math.round(B1 + L + B2 + leftExtra);
            this.actual_piece.height = Math.round((2 * B3) + shapeH);
            break;
          }
          case 926:
          case 2026:
          case 63: {
            const w = Number(this.actual_piece.dxf_w || 0);
            const h = Number(this.actual_piece.dxf_h || 0);
            const b1 = Number(this.actual_piece.b1 || 0);
            const b2 = Number(this.actual_piece.b2 || 0);
            const b3 = Number(this.actual_piece.b3 || 0);
            const b4 = Number(this.actual_piece.b4 || 0);
            this.actual_piece.width = Math.round(b1 + w + b3);
            this.actual_piece.height = Math.round(b2 + h + b4);
            break;
          }

          case 55:

            // console.log('-->> Calculando datos para fórmula FORMA 55 rectángulo esquinas curvas = ' + piece.figure);
            this.actual_piece.width = this.actual_piece.l + this.actual_piece.b4 + this.actual_piece.b2;
            this.actual_piece.height = this.actual_piece.b1 + this.actual_piece.h + this.actual_piece.b3;

            break;

          default:

            console.log('-->> Forma de catálogo no encontrada para el id = ' + this.actual_piece.figure);
            break;
        } // End If figure.

        console.log('-->> Pieza FORMA modificada = ');
        console.log(this.actual_piece);

		this.showFigureModal(false);

	    // Se resetean los valores del formulario de edición.
	    this.figureForm.controls.figure_id.setValue(0); // Pieza sin forma.
	    this.figureForm.controls.figure_b1.setValue(null);
	    this.figureForm.controls.figure_b2.setValue(null);
	    this.figureForm.controls.figure_b3.setValue(null);
	    this.figureForm.controls.figure_b4.setValue(null);
	    this.figureForm.controls.figure_l.setValue(null);
	    this.figureForm.controls.figure_l1.setValue(null);
	    this.figureForm.controls.figure_l2.setValue(null);
	    this.figureForm.controls.figure_h.setValue(null);
	    this.figureForm.controls.figure_h1.setValue(null);
	    this.figureForm.controls.figure_h2.setValue(null);
	    this.figureForm.controls.figure_r.setValue(null);
	    this.figureForm.controls.figure_r2.setValue(null);
	    this.figureForm.controls.figure_r3.setValue(null);
	    this.figureForm.controls.figure_r4.setValue(null);
	        this.figureDxfName = '';
	        this.figureDxfError = '';
	        this.figureDxfRepairAvailable = false;
	        this.figureDxfPoints = [];
        this.figureDxfWidth = 0;
        this.figureDxfHeight = 0;

	} else {

		// La validación no debe dejar valores inválidos en la pieza si el usuario
		// corrige el formulario o cierra el modal.
		figureValueKeys.forEach((key) => {
			const previous = previousFigureValues[key];
			if (previous.exists) this.actual_piece[key] = previous.value;
			else delete this.actual_piece[key];
		});

		// Se muestran al usuario todos los mensajes de valores mal asignados.
		this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

	} // End If ko_action.

  } // End function confirmFigureModal

  showInventoryModal(value: boolean) {
    this.inventoryModal = value;

  } // End function showInventoryModal

  confirmInventoryModal() {

    console.log('--> - -> Confirmada selección de material de stock.');

  } // End function confirmInventoryModal

  // Función que muestra un mensaje informativo cuando se desactiva el campo Rutas.
  showRuteModal(event: any) {
	console.log('--> showRuteModal = ');
	console.log(event.target.checked);

    if(!event.target.checked) {
		console.log('--> showRuteModal desactivando campo Rutas.');

		this.alertInfo = '<p> Al deshabilitar esta opción de Rutas los vidrios no se separarán según manufacturas en los caballetes de corte.</p>';

		// Se muestran al usuario todos los mensajes de valores mal asignados.
		this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
	}
  } // End function showRuteModal

  showSaveOptiModal(value: boolean) {
    this.saveOptiModal = value;
    let actual_time = new Date();
    let default_opti_name = 'Opt. ' + actual_time.getFullYear() + '-' + (actual_time.getMonth() + 1) + '-' + actual_time.getDate() + ' ' + actual_time.getHours() + ':' + ((actual_time.getMinutes().toString().length) > 1 ? actual_time.getMinutes() : '0' + actual_time.getMinutes()) + ':' + actual_time.getSeconds()

  	this.optiForm.controls.opti_name.setValue(value ? default_opti_name : null);

    if (value) {
      setTimeout(() => {
        const input = document.getElementById('saveOptiNameInput') as HTMLInputElement;
        if (input && typeof input.focus === 'function') {
          input.focus();
          if (typeof input.select === 'function') {
            input.select();
          }
        }
      }, 120);
    }

  	// Colocamos inicialmente el foco en el campo del nombre.
    // this.optiNameField.nativeElement.focus();
    // document.getElementById('optiNameField').focus();

  	console.log('-> default_opti_name: ' + default_opti_name);

  } // End function showSaveOptiModal

  showFileModal(value: boolean) {
	console.log('--> showFileModal = ' + value);
    this.fileModal = value;

    // this.filename = null;

  } // End function showFileModal

  showFileSheetModal(value: boolean) {
    this.fileSheetModal = value;

    // this.filesheetname = null;

  } // End function showFileSheetModal

  showDetailFileModal(value: boolean) {
    this.detailFileModal = value;
  } // End function showDetailFileModal

  confirmFileModal() {

    console.log('--> confirmFileModal.');
    // console.log(this.p['myfile'].value);
    // this.loadDataFile();
    this.loadDataMultipleFile();

    // Cargamos ya directamente el archivo de planchas.
    // this.loadSheetFile();

    // Se muestra el nombre del archivo seleccionado en el campo correspondiente del formulario.
    this.fileForm.controls.f_filename.setValue(this.filename);

    this.showFileModal(false);

    this.activateTab('tabPiece');

    // Se pone el check de todas las piezas en valor activo.
    this.checkAllPieces = true;

  } // End function confirmFileModal

  confirmFileSheetModal() {

    console.log('--> confirmFileSheetModal.');
    console.log(this.p['myfile'].value);
    this.loadSheetFile();

    this.showFileSheetModal(false);

    this.activateTab('tabSheet');

    // Se pone el check de todas las hojas en valor activo.
    this.checkAllSheets = true;

  } // End function confirmFileSheetModal

  confirmDetailModal() {

    console.log('--> Confirmada acción de optimizar.');

    this.optimizerFileAction(false);

    // this.showDetailFileModal(false);
  } // End function confirmDetailModal

  confirmDownloadModal() {

    console.log('--> Confirmada acción de Download.');

    this.optimizerFileAction(true);

    // this.showDetailFileModal(false);
  } // End function confirmDownloadModal

  confirmCopyModal() {

    console.log('--> Confirmada acción de Copiar.');


    this.showDetailFileModal(false);
  } // End function confirmCopyModal

  copyTable() {

    console.log('--> Confirmada acción de Copiar a Mesa.');

    // Rellenamos el correspondiente campo del formulario para indicar
    // que se quiere escribir el archivo un la "ruta general" o "ruta de mesa".
    // this.detailForm.controls.ruta_destino.setValue(this.general_ruta_destino.setup_value6);
    this.detailForm.controls.ruta_destino.setValue(this.mesa_destino.path);

    this.detailForm.controls.mesa_ancho_muela.setValue(this.mesa_destino.param2);
    this.detailForm.controls.mesa_solapamiento.setValue(this.mesa_destino.param3);

    this.optimizerFileAction(false);

    // Volvemos a poner a nulo la ruta destino para que no interfiera en otras acciones futuras.
    this.detailForm.controls.ruta_destino.setValue(null);
    this.detailForm.controls.mesa_ancho_muela.setValue(null);
    this.detailForm.controls.mesa_solapamiento.setValue(null);

    this.showActionModal(false);
    this.showDetailFileModal(true);
  } // End function confirmCopyTableModal

  showActionModal(value: boolean) {
    this.actionModal = value;

  } // End function showActionModal

  confirmActionModal() {

    console.log('--> - -> Confirmada acción del modal.');

    // this.saveFileAction();

    this.copyTable();

  } // End function confirmActionModal

  confirmSaveOptiModal() {

    console.log('--> - -> Confirmada acción del modal de optimización.');

    this.buttonStartOptimization(this.optiForm.controls.save.value, this.fileForm.controls.f_blocks.value);

  } // End function confirmSaveOptiModal

  // IMPORTANTE: Cuando el array que alimenta la tabla html se le incluye un "filtro/pipe" entonces no ordena, no funciona.
  // En este caso no funcionará la ordenación porque estamos usando el filtro "| filterFunction: filterCompany"
  // a la hora de listar los agentes.
  // Función que ordena el listado de elementos.
  onSorted(event: any) {
    console.log('--> onSorted Tabla directiva lanzada:');
    console.log(event);

    // console.log(' -> Columna a ordenar: ' + event.sortColumn);
    // console.log(' -> Dirección orden: ' + event.sortDirection);
    // console.log(' -> Es número: ' + event.isNumeric);

    // Si hubiese que realizar alguna acción específica para la columna seleccionada.
    // switch (event.sortColumn) {
    //   case 'mat_desc':
    //     break;

    //   case 'lagm_platz':
    //     break;
    // }

    // Se lanza la función de ordenación del array de inventario.
    // Modifica directamente el array pasado como primer parámetro.
    // NOTA: el nombre de la columna, al ser para ORACLE, tendrá que estar en mayúsculas.
    this.infoListAux = fromSortableColumn.sortByColumn(
      this.infoListAux, event.sortColumn, event.sortDirection, event.isNumeric);

    console.log('--> Array de elementos de la ordenación:');
    // console.log(this.infoListAux);

  } // End function onSorted

  onSortedOpti(event: any) {
    console.log('--> onSortedOpti Tabla directiva lanzada:');
    console.log(event);

    this.total_better_opti_list = fromSortableColumn.sortByColumn(
      this.total_better_opti_list, event.sortColumn, event.sortDirection, event.isNumeric);

    console.log('--> Array de elementos de la ordenación:');
    // console.log(this.total_better_opti_list);

  } // End function onSortedOpti

  // Función que devuelve el índice absoluto de una tabla paginada.
  absoluteIndex(indexOnPage: number): number {
    return this.itemsPerPage * (this.currentPage - 1) + indexOnPage;
  } // End function absoluteIndex

  // Función que se dispara cuando se pulsa un botón del control de paginación.
  pageChanged(event: any) {
    console.log('--> pageChanged:');
    console.log(event);

    // Primero se actualiza la página actual que se quiere obtener.
    this.currentPage = event;

    // Se indica la nueva página en el campo correspondiente del formulario.
    this.searchInventoryForm.controls.offset.setValue(event);

    // Se realiza la nueva búsqueda para obtener los datos de la página que se quiere mostrar.
    this.loadInventory();

  } // End function pageChanged

  // Función que devuelve el índice absoluto de una tabla paginada.
  pieceAbsoluteIndex(indexOnPage: number): number {
    return this.itemsPerPage * (this.currentPage - 1) + indexOnPage;
  } // End function pieceAbsoluteIndex

  // Función que se dispara cuando se pulsa un botón del control de paginación.
  piecePageChanged(event: any) {
    console.log('--> piecePageChanged:');
    console.log(event);

    // Primero se actualiza la página actual que se quiere obtener.
    this.piecesCurrentPage = event;

    // Se indica la nueva página en el campo correspondiente del formulario.
    this.searchPieceForm.controls.offset.setValue(event);

    // Se realiza la nueva búsqueda para obtener los datos de la página que se quiere mostrar.
    this.loadPieces();

  } // End function piecePageChanged

  // Dibujar gráficos.

  // Función que elimina todos los hijos de un elemento HTML pasado como parámetro.
  removeGraphic(containerIn: any) {
    console.log('--> removeGraphic:');
    // console.log(containerIn);

    while (containerIn.firstChild) {
      containerIn.removeChild(containerIn.firstChild);
    }

  } // End function removeGraphic


  // Función que guarda en base de datos la información de todas las piezas obtenidas la optimización.
  // En el primer parámetro se pasa la información general de la optimización y en el segundo el
  // listado de todas las piezas obtenidas con su correspondiente información para cada una.
  saveOptiData(optiDataInfo: any, optiDataList: any, optiSheetList: any) {

    console.log('--> saveOptiData optiDataInfo:');
    console.log(optiDataInfo);
    console.log('--> saveOptiData optiDataList:');
    console.log(optiDataList);
    console.log('--> saveOptiData optiSheetList:');
    console.log(optiSheetList);

	// Usando la solicitud POST
	/*
	fetch("https://jsonplaceholder.typicode.com/posts", {
	  method: "POST",
	  body: JSON.stringify({
	    title: "Hello World",
	    body: "My POST request",
	    userId: 900,
	  }),
	  headers: {
	    "Content-type": "application/json; charset=UTF-8",
	  },
	})
	.then((response) => response.json())
	.then((json) => console.log(json)); // */

    // Hay que averiguar un identificador único para la optimización. Todas las piezas aquí obtenidas
    // estarán vinculadas a esta optimización teniendo en cuenta este identificador.
    // optiDataList.forEach( pz => {

    // });

    // Se llama a la función del controlador que se encargará de
    // almacenar en la BD toda la información de la optimización.
    this.saveOptiPiece.emit({ opti_info: optiDataInfo, pieces_info: optiDataList, sheets_info: optiSheetList });

    // Llamar webservice usando Fetch nativo.
    // Usando la solicitud por defecto GET.
    // fetch('http://betawebapp.vidrioservice.com:8079/api/create_remnant_opti?pax=331122&usx=oracle&opti=34')
	// .then((response) => response.json())
	// .then((json) => console.log(json));

	// fetch('http://betawebapp.vidrioservice.com:8079/api/load_prod_data?pax=331122&usx=oracle&opti=34')
	// .then((response) => response.json())
	// .then((json) => console.log(json));

	// fetch('http://betawebapp.vidrioservice.com:8079/api/load_inventory?pax=331122&usx=oracle&opti=34')
	// .then((response) => response.json())
	// .then((json) => console.log(json));

  } // End function saveOptiData

  private cloneForSnapshot(dataIn: any): any {
    try {
      return JSON.parse(JSON.stringify(dataIn));
    } catch (e) {
      return null;
    }
  }

  private collectPieceDrawsFromSnapshotSheetList(sheetListIn: any[]): any[] {
    const out = [];
    (Array.isArray(sheetListIn) ? sheetListIn : []).forEach(sheet => {
      (Array.isArray(sheet && sheet.pieces) ? sheet.pieces : []).forEach(wrapper => {
        const piece = wrapper && wrapper.piece ? wrapper.piece : null;
        const draw = piece && piece.draw ? piece.draw : null;
        if (!draw) {
          return;
        }
        // Con "Bloques" una pieza marco representa varias unidades. El gráfico
        // real se compone de draw_set, igual que en drawGraphicsBySheet.
        if (Array.isArray(draw.draw_set) && draw.draw_set.length > 0) {
          draw.draw_set.forEach(child => {
            if (child) out.push(child);
          });
        } else if (draw.type === 'P') {
          out.push(draw);
        }
      });
    });
    return out;
  }

  private collectOefDrawsFromSnapshotSheetList(sheetListIn: any[]): any[] {
    return this.collectPieceDrawsFromSnapshotSheetList(sheetListIn)
      .filter(draw => draw && (
        draw.oef_generated === true ||
        Number(draw.oef_generated) === 1 ||
        (Array.isArray(draw.oef_internal_polygons) && draw.oef_internal_polygons.length > 0)
      ));
  }

  private getSnapshotDrawSignature(drawIn: any): string {
    if (!drawIn) {
      return 'null';
    }
    const pts = Array.isArray(drawIn.points) ? drawIn.points : [];
    const pointSig = pts.map(pt => [
      Number(pt && pt.x).toFixed(2),
      Number(pt && pt.y).toFixed(2)
    ].join(',')).join(';');
    return [
      drawIn.name !== undefined && drawIn.name !== null ? drawIn.name.toString() : '',
      Number(drawIn.width || 0).toFixed(2),
      Number(drawIn.height || 0).toFixed(2),
      Number(drawIn.rotation || 0).toFixed(0),
      Number(drawIn.oef_primitive_w || 0).toFixed(2),
      Number(drawIn.oef_primitive_h || 0).toFixed(2),
      Number(drawIn.oef_primitive_b1 || drawIn.piece_oef_primitive_b1 || 0).toFixed(2),
      Number(drawIn.oef_primitive_b2 || drawIn.piece_oef_primitive_b2 || 0).toFixed(2),
      Number(drawIn.oef_primitive_b3 || drawIn.piece_oef_primitive_b3 || 0).toFixed(2),
      Number(drawIn.oef_primitive_b4 || drawIn.piece_oef_primitive_b4 || 0).toFixed(2),
      pointSig
    ].join('|');
  }

  private snapshotNeedsOefGraphicRepair(graphicListIn: any[], sheetListIn: any[], originIn?: any): boolean {
    const sheetOefDraws = this.collectOefDrawsFromSnapshotSheetList(sheetListIn);
    if (sheetOefDraws.length < 1) {
      const sheetPieceDraws = this.collectPieceDrawsFromSnapshotSheetList(sheetListIn);
      const graphicPieceDraws = (Array.isArray(graphicListIn) ? graphicListIn : [])
        .reduce((acc, group) => acc.concat(Array.isArray(group) ? group : []), [])
        .filter(draw => draw && draw.type === 'P');

      // Si el snapshot gráfico contiene más piezas, no se sustituye por una
      // sheetList histórica incompleta (caso cristalant 3212). Los bloques se
      // expanden antes de comparar para no confundir piezas marco con unidades.
      // Con igual número, sheetList/CNC es la referencia si las posiciones no
      // coinciden (casos 3196 y 3240).
      if (sheetPieceDraws.length < 1 || sheetPieceDraws.length !== graphicPieceDraws.length) {
        return false;
      }
      const graphicByName = {};
      graphicPieceDraws.forEach(draw => {
        const key = draw && draw.name !== undefined && draw.name !== null ? draw.name.toString() : '';
        if (key) graphicByName[key] = draw;
      });
      return sheetPieceDraws.some(sheetDraw => {
        const key = sheetDraw && sheetDraw.name !== undefined && sheetDraw.name !== null
          ? sheetDraw.name.toString()
          : '';
        const graphicDraw = key && graphicByName[key] ? graphicByName[key] : null;
        return !graphicDraw || this.getSnapshotDrawSignature(graphicDraw) !== this.getSnapshotDrawSignature(sheetDraw);
      });
    }
    const origin = Number(originIn);
    if (origin === 2 || origin === 3 || origin === 4) {
      return true;
    }
    const graphicOefDraws = (Array.isArray(graphicListIn) ? graphicListIn : [])
      .reduce((acc, group) => acc.concat(Array.isArray(group) ? group : []), [])
      .filter(draw => draw && draw.type === 'P' && (
        draw.oef_generated === true ||
        Number(draw.oef_generated) === 1 ||
        (Array.isArray(draw.oef_internal_polygons) && draw.oef_internal_polygons.length > 0)
      ));
    if (graphicOefDraws.length !== sheetOefDraws.length) {
      return true;
    }

    const graphicByName = {};
    graphicOefDraws.forEach(draw => {
      const key = draw && draw.name !== undefined && draw.name !== null ? draw.name.toString() : '';
      if (key) {
        graphicByName[key] = draw;
      }
    });

    return sheetOefDraws.some(sheetDraw => {
      const key = sheetDraw && sheetDraw.name !== undefined && sheetDraw.name !== null ? sheetDraw.name.toString() : '';
      const graphicDraw = key && graphicByName[key] ? graphicByName[key] : null;
      return !graphicDraw || this.getSnapshotDrawSignature(graphicDraw) !== this.getSnapshotDrawSignature(sheetDraw);
    });
  }

  private preTransformSnapshotDrawForOrigin(drawIn: any, sheetIn: any, originIn: any): any {
    const draw = this.cloneForSnapshot(drawIn);
    if (!draw || !Array.isArray(draw.points) || draw.points.length < 4) {
      return draw;
    }
    const drawName = draw.name !== undefined && draw.name !== null ? draw.name.toString() : '';
    const isCentralPostprocess = drawName.indexOf('_central') !== -1 ||
      drawName.indexOf('_left') !== -1 || drawName.indexOf('_right') !== -1;
    // Estos retales se guardan en sheetList en coordenadas estructurales. El canvas
    // aplicará el origen al renderizar; pretransformarlos aquí produciría un doble
    // reflejo al recuperar una optimización histórica.
    if (isCentralPostprocess) {
      return draw;
    }
    const origin = Number(originIn);
    if (!(origin === 2 || origin === 3 || origin === 4)) {
      return draw;
    }
    const sheetWidth = Number(sheetIn && sheetIn.width);
    const sheetHeight = Number(sheetIn && sheetIn.height);
    if (!(Number.isFinite(sheetWidth) && sheetWidth > 0 && Number.isFinite(sheetHeight) && sheetHeight > 0)) {
      return draw;
    }
    const disband = sheetIn && sheetIn.disband
      ? sheetIn.disband
      : { left: 0, right: 0, top: 0, bottom: 0 };

    this.opti.changeOriginPoint(draw.points, sheetWidth, sheetHeight, disband, origin);
    if (Array.isArray(draw.draw_set)) {
      draw.draw_set = draw.draw_set.map(child => this.preTransformSnapshotDrawForOrigin(child, sheetIn, origin));
    }
    return draw;
  }

  private buildGraphicListFromSnapshotSheetList(sheetListIn: any[], fallbackGraphicListIn: any[], originIn?: any): any[] {
    const fallbackGroups = Array.isArray(fallbackGraphicListIn) ? fallbackGraphicListIn : [];
    return (Array.isArray(sheetListIn) ? sheetListIn : []).map((sheet, index) => {
      const fallbackGroup = Array.isArray(fallbackGroups[index]) ? fallbackGroups[index] : [];
      const fallbackSheetDraw = fallbackGroup.find(draw => draw && draw.type === 'S');
      const group = [];

      if (fallbackSheetDraw) {
        group.push(this.cloneForSnapshot(fallbackSheetDraw));
      } else {
        const width = Number(sheet && sheet.width);
        const height = Number(sheet && sheet.height);
        group.push({
          sheet_id: sheet && sheet.id ? sheet.id : index + 1,
          old: false,
          name: 'Hoja ' + (index + 1),
          num: index + 1,
          label: (Number.isFinite(width) ? width : 0) + 'x' + (Number.isFinite(height) ? height : 0),
          mat_id: sheet && sheet.mat_id !== undefined ? sheet.mat_id : null,
          mat_name: sheet && sheet.mat_name !== undefined ? sheet.mat_name : '',
          mat_desc: sheet && sheet.mat_desc !== undefined ? sheet.mat_desc : '',
          width: Number.isFinite(width) ? width : 0,
          height: Number.isFinite(height) ? height : 0,
          depth: Number(sheet && sheet.depth ? sheet.depth : 0),
          area: Number.isFinite(width) && Number.isFinite(height) ? Number((width * height / 1000000).toFixed(2)) : 0,
          points: [
            { x: 0, y: 0 },
            { x: 0, y: Number.isFinite(height) ? height : 0 },
            { x: Number.isFinite(width) ? width : 0, y: Number.isFinite(height) ? height : 0 },
            { x: Number.isFinite(width) ? width : 0, y: 0 }
          ],
          type: 'S',
          rotation: 0,
          form_id: 0
        });
      }

      (Array.isArray(sheet && sheet.traverses) ? sheet.traverses : []).forEach(traverse => {
        const draw = traverse && traverse.draw ? traverse.draw : null;
        if (draw) {
          group.push(this.preTransformSnapshotDrawForOrigin(draw, sheet, originIn));
        }
      });

      (Array.isArray(sheet && sheet.pieces) ? sheet.pieces : []).forEach(wrapper => {
        const piece = wrapper && wrapper.piece ? wrapper.piece : null;
        const draw = piece && piece.draw ? piece.draw : null;
        if (draw) {
          const pieceDraws = Array.isArray(draw.draw_set) && draw.draw_set.length > 0
            ? draw.draw_set
            : [draw];
          pieceDraws.forEach(pieceDraw => {
            group.push(this.preTransformSnapshotDrawForOrigin(pieceDraw, sheet, originIn));
          });
        }
      });

      return group.filter(item => !!item);
    });
  }

  private buildLayoutSnapshotPayload(): any {
    const optiSheetListSnapshot = this.cloneForSnapshot((this.opti && this.opti.sheetList) ? this.opti.sheetList : []);
    const graphicListSnapshot = this.cloneForSnapshot(this.lastTotalGraphicList || []);
    const cutOrderListSnapshot = this.cloneForSnapshot(this.cutTotalOrderList || []);
    const repairedGraphicList = this.snapshotNeedsOefGraphicRepair(
        graphicListSnapshot,
        optiSheetListSnapshot,
        this.fileForm.controls.f_origin.value
      )
      ? this.buildGraphicListFromSnapshotSheetList(optiSheetListSnapshot, graphicListSnapshot, this.fileForm.controls.f_origin.value)
      : graphicListSnapshot;
    const syncStats = synchronizeSnapshotGraphicsWithCutOrder(
      repairedGraphicList,
      cutOrderListSnapshot
    );
    const syncIssues = validateSnapshotGraphicsAgainstCutOrder(
      repairedGraphicList,
      cutOrderListSnapshot,
      { compareGeometry: false }
    );
    if (syncIssues.length > 0) {
      console.warn('--> Snapshot layout: persisten divergencias gráfico/corte.', {
        stats: syncStats,
        issues: syncIssues.slice(0, 20)
      });
    }

    return {
      version: 2,
      created_at: new Date().toISOString(),
      route_opti_id: this.routeOptiIdLabel ? this.routeOptiIdLabel.toString() : '',
      form: {
        mode: Number(this.fileForm.controls.f_mode.value),
        level: Number(this.fileForm.controls.f_level.value),
        blocks: !!this.fileForm.controls.f_blocks.value,
        base: !!this.fileForm.controls.f_base.value,
        order: !!this.fileForm.controls.f_order.value,
        old: !!this.fileForm.controls.f_old.value,
        origin: this.fileForm.controls.f_origin.value,
        axis: this.fileForm.controls.f_axis.value,
        zoom: this.fileForm.controls.f_zoom.value,
        export: this.fileForm.controls.f_export.value,
        max_diecutting: Number(this.fileForm.controls.f_max_diecutting.value),
        diecutting: Number(this.fileForm.controls.f_diecutting.value)
      },
      metrics: {
        total_area_d: this.total_area_D,
        total_area_b: this.total_area_B,
        total_area_s: this.total_area_S,
        total_area_x: this.total_area_X,
        total_area_x_oef: this.total_area_X_OEF,
        total_area_t: this.total_area_T,
        total_area_t_oef_in: this.total_area_T_OEF_IN,
        total_area_r: this.total_area_R,
        total_area_p: this.total_area_P,
        total_area_c: this.total_area_C,
        total_area_j: this.total_area_J,
        num_sheet: this.num_sheet
      },
      optimization_list: this.cloneForSnapshot(this.optimizationList || []),
      sheet_list_datafile: this.cloneForSnapshot(this.sheetList_datafile || []),
      total_graphic_list: repairedGraphicList,
      cut_total_order_list: cutOrderListSnapshot,
      level0_traverse_list: this.cloneForSnapshot(this.level0TraverseList || []),
      local_piece_to_easel_list: this.cloneForSnapshot(this.local_pieceToEaselList || []),
      total_sheet_results: this.cloneForSnapshot(this.total_sheet_results || []),
      total_lot_list: this.cloneForSnapshot(this.totalLotList || []),
      total_material_list: this.cloneForSnapshot(this.totalMaterialList || []),
      total_material_id_list: this.cloneForSnapshot(this.totalMaterialIdList || []),
      opti_sheet_list: optiSheetListSnapshot,
      opti_piece_info_list: this.cloneForSnapshot((this.opti && this.opti.pieceInfoList) ? this.opti.pieceInfoList : []),
      opti_group_info_list: this.cloneForSnapshot((this.opti && this.opti.groupInfoList) ? this.opti.groupInfoList : []),
      opti_group_list_mode2: this.cloneForSnapshot((this.opti && this.opti.groupListMode2) ? this.opti.groupListMode2 : [])
    };
  }

  private buildPrintGraphicListSnapshot(): any[] {
    const optiSheetListSnapshot = this.cloneForSnapshot((this.opti && this.opti.sheetList) ? this.opti.sheetList : []);
    const graphicListSnapshot = this.cloneForSnapshot(this.lastTotalGraphicList || []);
    // El postproceso "retal central" se realiza sobre el plano ya orientado para
    // canvas. Reconstruirlo desde sheetList vuelve a las coordenadas estructurales
    // de máquina y desplaza el rectángulo central en el PDF.
    const hasPostProcessedCentralRemainder = (Array.isArray(graphicListSnapshot) ? graphicListSnapshot : [])
      .some(group => Array.isArray(group) && group.some(draw =>
        draw && draw.name !== undefined && draw.name !== null &&
        draw.name.toString().indexOf('_central') !== -1
      ));
    const repairedGraphicList = !hasPostProcessedCentralRemainder && this.snapshotNeedsOefGraphicRepair(
        graphicListSnapshot,
        optiSheetListSnapshot,
        this.fileForm.controls.f_origin.value
      )
      // El PDF de planos representa la disposición física de la hoja. El origen se marca
      // visualmente, pero no debe invertir la geometría: la cola/resto debe permanecer
      // en el lado opuesto al primer corte desde el origen.
      ? this.buildGraphicListFromSnapshotSheetList(optiSheetListSnapshot, graphicListSnapshot, 1)
      : graphicListSnapshot;
    synchronizeSnapshotGraphicsWithCutOrder(
      repairedGraphicList,
      this.cloneForSnapshot(this.cutTotalOrderList || [])
    );

    return Array.isArray(repairedGraphicList) ? repairedGraphicList : [];
  }

  private serializeLayoutSnapshot(): string {
    try {
      const payload = this.buildLayoutSnapshotPayload();
      return JSON.stringify(payload);
    } catch (e) {
      console.warn('--> serializeLayoutSnapshot: no se pudo generar snapshot.', e);
      return null;
    }
  }

  private parseLayoutSnapshotFromCurrentOpti(): any {
    if (!this.currentOpti || !this.currentOpti['od_layout_snapshot']) {
      return null;
    }
    const raw = this.currentOpti['od_layout_snapshot'];
    if (typeof raw !== 'string' || raw.trim() === '') {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch (e) {
      console.warn('--> parseLayoutSnapshotFromCurrentOpti: JSON inválido.', e);
      return null;
    }
  }

  private applyLayoutSnapshot(snapshotIn: any): boolean {
    if (!snapshotIn) {
      return false;
    }

    const graphics = Array.isArray(snapshotIn.total_graphic_list) ? snapshotIn.total_graphic_list : [];
    if (!graphics || graphics.length < 1) {
      return false;
    }

    const clone = (valueIn: any, fallbackIn: any) => {
      const parsed = this.cloneForSnapshot(valueIn);
      return parsed !== null && parsed !== undefined ? parsed : fallbackIn;
    };

    const snapshotSheetList = clone(snapshotIn.opti_sheet_list, []);
    const snapshotVersion = snapshotIn.version ? Number(snapshotIn.version) : 1;
    const legacyStripStats = snapshotVersion < 2
      ? normalizeLegacyStructuralRightStrips(snapshotSheetList)
      : {
          inspectedSheets: 0,
          removedStrips: 0,
          resizedStrips: 0,
          affectedStrips: []
        };
    const repairedLegacyStrips =
      legacyStripStats.removedStrips > 0 || legacyStripStats.resizedStrips > 0;
    if (repairedLegacyStrips) {
      console.warn('--> Snapshot histórico: franjas estructurales v1 reparadas.', legacyStripStats);
    }
    const snapshotOrigin = snapshotIn && snapshotIn.form ? snapshotIn.form.origin : this.fileForm.controls.f_origin.value;
    const repairedGraphics = repairedLegacyStrips ||
      this.snapshotNeedsOefGraphicRepair(graphics, snapshotSheetList, snapshotOrigin)
      ? this.buildGraphicListFromSnapshotSheetList(
          snapshotSheetList,
          graphics,
          snapshotOrigin
        )
      : clone(graphics, []);
    const snapshotCutOrderList = clone(snapshotIn.cut_total_order_list, []);
    const syncStats = synchronizeSnapshotGraphicsWithCutOrder(
      repairedGraphics,
      snapshotCutOrderList
    );
    const syncIssues = validateSnapshotGraphicsAgainstCutOrder(
      repairedGraphics,
      snapshotCutOrderList,
      { compareGeometry: false }
    );
    if (syncIssues.length > 0) {
      console.warn('--> Snapshot histórico: divergencias gráfico/corte no resueltas.', {
        stats: syncStats,
        issues: syncIssues.slice(0, 20)
      });
    }

    this.optimizationList = clone(snapshotIn.optimization_list, this.optimizationList || []);
    this.sheetList_datafile = clone(snapshotIn.sheet_list_datafile, this.sheetList_datafile || []);
    this.lastTotalGraphicList = clone(repairedGraphics, []);

    this.cutTotalOrderList = snapshotCutOrderList;
    this.level0TraverseList = clone(snapshotIn.level0_traverse_list, []);
    this.local_pieceToEaselList = clone(snapshotIn.local_piece_to_easel_list, []);

    this.totalLotList = clone(snapshotIn.total_lot_list, []);
    this.totalMaterialList = clone(snapshotIn.total_material_list, []);
    this.totalMaterialIdList = clone(snapshotIn.total_material_id_list, []);

    if (this.opti) {
      this.opti.sheetList = snapshotSheetList;
      this.opti.pieceInfoList = clone(snapshotIn.opti_piece_info_list, []);
      this.opti.groupInfoList = clone(snapshotIn.opti_group_info_list, []);
      this.opti.groupListMode2 = clone(snapshotIn.opti_group_list_mode2, []);
    }

    this.total_area_D = 0;
    this.total_area_B = 0;
    this.total_area_S = 0;
    this.total_area_X = 0;
    this.total_area_X_OEF = 0;
    this.total_area_T = 0;
    this.total_area_T_OEF_IN = 0;
    this.total_area_R = 0;
    this.total_area_P = 0;
    this.total_area_J = 0;
    this.num_sheet = 0;
    this.total_sheet_results = [];

    this.removeGraphic(this.graphic_container);
    const infoDataPiece = [];
    this.renderSheet(this.lastTotalGraphicList, infoDataPiece);

    // Recalcular indicadores globales (mismo criterio que en buttonStartOptimization).
    this.total_area_T += this.total_area_D;
    this.total_area_B = this.total_area_S - this.total_area_R - this.total_area_J;
    if (this.total_area_B <= 0) {
      this.total_area_B = this.total_area_S;
    }
    this.total_area_X = this.total_area_B > 0 ? (this.total_area_T * 100) / this.total_area_B : 0;
    const oefBase = this.total_area_P + this.total_area_T_OEF_IN;
    this.total_area_X_OEF = oefBase > 0 ? (this.total_area_T_OEF_IN * 100) / oefBase : 0;

    const snapshotMetrics = snapshotIn && snapshotIn.metrics ? snapshotIn.metrics : {};
    const toFinite = (valueIn: any): number => {
      const num = Number(valueIn);
      return Number.isFinite(num) ? num : null;
    };

    // Número de pilas/caballetes.
    if (toFinite(snapshotMetrics.total_area_c) !== null) {
      this.total_area_C = toFinite(snapshotMetrics.total_area_c);
    } else {
      let easelCount = 0;
      const localList = this.local_pieceToEaselList || [];
      for (const prop in localList) {
        if (localList[prop]) {
          easelCount++;
        }
      }
      this.total_area_C = easelCount;
    }

    // En histórico, las métricas persistidas son la fuente autoritativa.
    // El recálculo se deja como respaldo para snapshots incompletos.
    const persistedWaste = toFinite(this.currentOpti && this.currentOpti.od_porcentage_wastage);
    const persistedGross = toFinite(this.currentOpti && this.currentOpti.od_gross_area);
    const persistedNet = toFinite(this.currentOpti && this.currentOpti.od_net_area);
    const persistedStacks = toFinite(this.currentOpti && this.currentOpti.od_total_easels);

    const snapshotWaste = toFinite(snapshotMetrics.total_area_x);
    const snapshotGross = toFinite(snapshotMetrics.total_area_b);
    const snapshotNet = toFinite(snapshotMetrics.total_area_p);
    const snapshotStacks = toFinite(snapshotMetrics.total_area_c);
    const snapshotWasteOef = toFinite(snapshotMetrics.total_area_x_oef);

    if (persistedWaste !== null) this.total_area_X = persistedWaste;
    else if (snapshotWaste !== null) this.total_area_X = snapshotWaste;

    if (persistedGross !== null) this.total_area_B = persistedGross;
    else if (snapshotGross !== null) this.total_area_B = snapshotGross;

    if (persistedNet !== null) this.total_area_P = persistedNet;
    else if (snapshotNet !== null) this.total_area_P = snapshotNet;

    // El snapshot describe el layout que se está mostrando y, por tanto, es la
    // fuente autoritativa para el número de pilas. El valor persistido queda como
    // respaldo para optimizaciones históricas sin snapshot.
    if (snapshotStacks !== null) this.total_area_C = snapshotStacks;
    else if (persistedStacks !== null) this.total_area_C = persistedStacks;

    if (snapshotWasteOef !== null) this.total_area_X_OEF = snapshotWasteOef;

    if (this.lastTotalGraphicList && this.lastTotalGraphicList.length > 0) {
      this.actual_sheet = 1;
      this.hideGraphic(this.actual_sheet);
    } else {
      this.actual_sheet = 0;
      this.hideGraphic(this.actual_sheet);
    }

    this.usingPersistedLayoutSnapshot = true;
    this.persistedLayoutSnapshotMeta = {
      version: snapshotIn.version ? Number(snapshotIn.version) : 1,
      created_at: snapshotIn.created_at ? snapshotIn.created_at.toString() : null
    };

    return true;
  }

  // ------------------------ SIMULACIÓN

  // Función que calcula el máximo de travera que podría tener
  // la optimización para poder usar la hoja con el ancho más grande.
  calculateMaxTrav(): number {

	console.log('--> Ejecutando calculateMaxTrav:');

	let max_side = 0;

    this.sheetList_datafile.forEach((sh, index) => {
      // console.log('- Medidas hoja: ');
      // console.log(sh);

      let max_piece_side = sh.width;

      // Se escoge como referncia el lado más largo de la hoja.
      if (sh.height > sh.width) max_piece_side = sh.height;

      if (sh['check'] === true) {

        if (max_piece_side > max_side) {
			max_side = max_piece_side;
		}
      }
    });

    // console.log('* max_trav =');
    // console.log(max_side);

    return max_side;

  } // End function calculateMaxTrav

  // Función que calcula el mínimo de travera que podría tener
  // la optimización para poder meter la pieza más grande.
  // Este valor coincide también con el lado mínimo que tendrá que tener
  // un retal para poder ser tener probabilidad de ser usado alguna vez.
  calculateMinTrav(): number {

	console.log('--> Ejecutando calculateMinTrav:');

	let max_side = 0;

    this.optimizationList.forEach((ps, index) => {
      // console.log('- Pieza medidas: ');
      // console.log(ps);

      let min_piece_side = ps.height;

      // Se escoge como referncia el lado más corto de la pieza.
      if (ps.height > ps.width) min_piece_side = ps.width;

      if (ps['check'] === true) {

        if (min_piece_side > max_side) {
			max_side = min_piece_side;
		}
      }
    });

    // console.log('* max_side =');
    // console.log(max_side);

    return max_side;

  } // End function calculateMinTrav

  // Función que añade en una lista los puntos medios comprendidos entre
  // dos valores dados en un rango dado por el último parámetro de entrada.
  async addCenterOpti(opti_list, left_opti, rigth_opti, exit_range) {

	console.log('--> Ejecutando addCenterOpti: ' + exit_range);

	let current_range = rigth_opti - left_opti;

	if (current_range > 1) {

		let center_trav = Math.round(current_range / 2) + left_opti;
	    console.log('--> * center_trav = ' + center_trav);

	    // Se lanza otra optimización con el valor intermedio entre las dos anteriores.
	    opti_list.push(center_trav);

	    if (current_range > exit_range) {
			// Se continúa buscando por la izquiera.
	    	this.addCenterOpti(opti_list, left_opti, center_trav, exit_range);

		    // Se continúa buscando por la derecha.
		    this.addCenterOpti(opti_list, center_trav, rigth_opti, exit_range);
		} else {
			console.log('-> addCenterOpti: Se ha superado el rango por llegar a ' + current_range);
		}
    } else {
		console.log('-> addCenterOpti: current_range es menor que 1.');
		return;
	}
  } // End function addCenterOpti.

  // Función que dada dos "informaciones de resultados"" de
  // optimizaciones devuelve primero la peor y segundo la mejor.
  async compareOptis(result_opti, better_opti, modeIn) {

	let promise_in = new Promise((resolve, reject) => {
    // console.log('->> Inicio Promesa de compareOptis:');

		if (result_opti && result_opti.ns && better_opti && better_opti.ns && result_opti.ns <= better_opti.ns && result_opti.ns > 0
			&& result_opti.ns <= better_opti.ns) {

			if (result_opti.ns < better_opti.ns && result_opti.np >= better_opti.np) {
				better_opti = result_opti;
			} else if (result_opti.ns === better_opti.ns && result_opti.np >= better_opti.np) {
				// console.log('--> * cumple ns = ' + current_max_trav);
				if (result_opti.np >= better_opti.np){
					// console.log('--> * cumple np = ' + current_max_trav);

					// Si el Modo no es igual a 3 se compara como siempre.
					if (Number(modeIn) !== 3) {

						if (result_opti.tn >= better_opti.tn && result_opti.tn > 0) {
							// console.log('--> * cumple tn = ' + current_max_trav);

							if (result_opti.tn === better_opti.tn) {

								// Comparamos el área del retal más grande.
								if (result_opti.rm >= better_opti.rm) {

									if (result_opti.rm === better_opti.rm) {

										if (result_opti.tb < better_opti.tb) {
											// console.log('--> * Neto igual, pero cumple tb < ' + current_max_trav);
											// console.log('--> Encontrada mejor optimización con max_travera = ' + current_max_trav);

											better_opti = result_opti;
										} else if (result_opti.tb === better_opti.tb) {
											// Comparamos por el número de pila. Más bajo el número mejor será la optimización.
											if (result_opti.ne < better_opti.ne) {

												better_opti = result_opti;
											}
										}

										// } // End If rp.
									} else { // Quiere decir que result_opti.rm > better_opti.rm
										// console.log('--> * Encontrado retal más grande = ' + result_opti.rm);
										better_opti = result_opti;
									} // End If rm.
								}
							} else {
								// console.log('--> * Neto mayor. Mejor optimización encontrada = ' + current_max_trav);
								better_opti = result_opti;
							}

						} // End If tn.
					} else { // Para el Modo 3 se compara teniendo en cuenta el número de pilas.

						// console.log('--> *Comparando opti Modo 3');

						// Comparamos por el número de pila. Más bajo el número mejor será la optimización.
						if (result_opti.ne <= better_opti.ne) {

							if (result_opti.ne === better_opti.ne) {

								// console.log('--> *Igual número de pilas.');

								if (result_opti.tn >= better_opti.tn && result_opti.tn > 0) {
								// console.log('--> * cumple tn = ' + current_max_trav);

									if (result_opti.tn === better_opti.tn) {

										// Comparamos el área del retal más grande.
										if (result_opti.rm >= better_opti.rm) {

											if (result_opti.rm === better_opti.rm) {

												if (result_opti.tb < better_opti.tb) {
													// console.log('--> * Neto igual, pero cumple tb < ' + current_max_trav);
													// console.log('--> Encontrada mejor optimización con max_travera = ' + current_max_trav);

													better_opti = result_opti;
												} else if (result_opti.tb === better_opti.tb) {
													// Comparamos por el número de pila. Más bajo el número mejor será la optimización.
													if (result_opti.ne < better_opti.ne) {

														better_opti = result_opti;
													}
												}

												// } // End If rp.
											} else { // Quiere decir que result_opti.rm > better_opti.rm
												// console.log('--> * Encontrado retal más grande = ' + result_opti.rm);
												better_opti = result_opti;
											} // End If rm.
										}
									} else {
										// console.log('--> * Neto mayor. Mejor optimización encontrada = ' + current_max_trav);
										better_opti = result_opti;
									}
								} // End If tn.
							} else { // Quiere decir que result_opti.ne < better_opti.ne
								// console.log('--> * Encontradas menos pilas = ' + result_opti.ne);
								better_opti = result_opti;
							} // End If rm.
						}
					} // Fin Else mode
				} // End If np.
			} // End Else If ns igual.
		} // End If ns.

	resolve(better_opti);
  	});

  	return promise_in.then((response: any) => {
      // console.log('->> Respuesta de compareOptis:');
      // console.log(response);
      return response;

    }).catch((error) => {
      console.log('->> Error en compareOptis:');
      console.log(error);
    });

	// Se devuelve que better_opti es la mejor.
	// return [result_opti, better_opti];
	// return better_opti;

  } // End function compareOptis.

  // Función que dada dos "informaciones de resultados de
  // optimizaciones devuelve true si la primera es mejor.
  isBetterOpti(result_opti, better_opti, modeIn) :number {

	let is_better = 0;

	if (result_opti && result_opti.ns && better_opti && better_opti.ns && result_opti.ns <= better_opti.ns && result_opti.ns > 0
		&& result_opti.ns <= better_opti.ns) {

		if (result_opti.ns < better_opti.ns && result_opti.np >= better_opti.np) {

			is_better = 1;
		} else if (result_opti.ns === better_opti.ns && result_opti.np >= better_opti.np) {
			// console.log('--> * cumple ns = ' + current_max_trav);
			if (result_opti.np >= better_opti.np){
				// console.log('--> * cumple np = ' + current_max_trav);

				// Si el Modo no es igual a 3 se compara como siempre.
				if (Number(modeIn) !== 3) {

					if (result_opti.tn >= better_opti.tn && result_opti.tn > 0) {
						// console.log('--> * cumple tn = ' + current_max_trav);

						if (result_opti.tn === better_opti.tn) {

							// Comparamos el área del retal más grande.
							if (result_opti.rm >= better_opti.rm) {

								if (result_opti.rm === better_opti.rm) {

									if (result_opti.tb < better_opti.tb) {
										// console.log('--> * Neto igual, pero cumple tb < ' + current_max_trav);
										// console.log('--> Encontrada mejor optimización con max_travera = ' + current_max_trav);

										is_better = 1;
									} else if (result_opti.tb === better_opti.tb) {
										// Comparamos por el número de pila. Más bajo el número mejor será la optimización.
										if (result_opti.ne < better_opti.ne) {

											is_better = 1;
										}
									}

									// } // End If rp.
								} else { // Quiere decir que result_opti.rm > better_opti.rm
									// console.log('--> * Encontrado retal más grande = ' + result_opti.rm);

									is_better = 1;
								} // End If rm.
							}
						} else {
							// console.log('--> * Neto mayor. Mejor optimización encontrada = ' + current_max_trav);

							is_better = 1;
						}

					} // End If tn.
				} else { // Para el Modo 3 se compara teniendo en cuenta el número de pilas.

					// console.log('--> *Comparando opti Modo 3');

					// Comparamos por el número de pila. Más bajo el número mejor será la optimización.
					if (result_opti.ne <= better_opti.ne) {

						if (result_opti.ne === better_opti.ne) {

							// console.log('--> *Igual número de pilas.');

							if (result_opti.tn >= better_opti.tn && result_opti.tn > 0) {
							// console.log('--> * cumple tn = ' + current_max_trav);

								if (result_opti.tn === better_opti.tn) {

									// Comparamos el área del retal más grande.
									if (result_opti.rm >= better_opti.rm) {

										if (result_opti.rm === better_opti.rm) {

											if (result_opti.tb < better_opti.tb) {
												// console.log('--> * Neto igual, pero cumple tb < ' + current_max_trav);
												// console.log('--> Encontrada mejor optimización con max_travera = ' + current_max_trav);

												is_better = 1;
											} else if (result_opti.tb === better_opti.tb) {
												// Comparamos por el número de pila. Más bajo el número mejor será la optimización.
												if (result_opti.ne < better_opti.ne) {

													is_better = 1;
												}
											}

											// } // End If rp.
										} else { // Quiere decir que result_opti.rm > better_opti.rm
											// console.log('--> * Encontrado retal más grande = ' + result_opti.rm);

											is_better = 1;
										} // End If rm.
									}
								} else {
									// console.log('--> * Neto mayor. Mejor optimización encontrada = ' + current_max_trav);

									is_better = 1;
								}
							} // End If tn.
						} else { // Quiere decir que result_opti.ne < better_opti.ne
							// console.log('--> * Encontradas menos pilas = ' + result_opti.ne);

							is_better = 1;
						} // End If rm.
					}
				} // Fin Else mode
			} // End If np.
		} // End Else If ns igual.
	} // End If ns.

	return is_better;

  } // End function isBetterOpti.

  getOptimizationSpeedProfile() {
    const speedRaw = this.fileForm && this.fileForm.controls && this.fileForm.controls.f_speed
      ? this.fileForm.controls.f_speed.value
      : 'fast';

    if (speedRaw === 'fast') {
      return { level: 'fast', traverse_jump: 300 };
    }
    if (speedRaw === 'medium') {
      return { level: 'medium', traverse_jump: 200 };
    }
    if (speedRaw === 'optimal') {
      return { level: 'optimal', traverse_jump: 100 };
    }
    return { level: 'fast', traverse_jump: 300 };
  }

  getSimulationCombos(speedIn: string, modeIn: number) {
    const combos = [];

    // Comunes mínimas.
    combos.push({ bl: false, re: true, mb: true, os: true });
    combos.push({ bl: true,  re: true, mb: true, os: true });

    if (speedIn === 'fast') {
      combos.push({ bl: false, re: true, mb: false, os: true });
      combos.push({ bl: true,  re: true, mb: false, os: true });
      return combos;
    }

    // Nivel medio y óptimo: se prueban combinaciones de base/orden.
    combos.push({ bl: false, re: true, mb: true,  os: false });
    combos.push({ bl: false, re: true, mb: false, os: true });
    combos.push({ bl: false, re: true, mb: false, os: false });
    combos.push({ bl: true,  re: true, mb: true,  os: false });
    combos.push({ bl: true,  re: true, mb: false, os: true });
    combos.push({ bl: true,  re: true, mb: false, os: false });

    // Sólo en "óptima" y modo 3 se añade sin recolocación.
    if (speedIn === 'optimal' && modeIn === 3) {
      combos.push({ bl: false, re: false, mb: true,  os: true });
      combos.push({ bl: false, re: false, mb: true,  os: false });
      combos.push({ bl: false, re: false, mb: false, os: true });
      combos.push({ bl: false, re: false, mb: false, os: false });
      combos.push({ bl: true,  re: false, mb: true,  os: true });
      combos.push({ bl: true,  re: false, mb: true,  os: false });
      combos.push({ bl: true,  re: false, mb: false, os: true });
      combos.push({ bl: true,  re: false, mb: false, os: false });
    }

    return combos;
  }

  // Función que lanza múltiples optimizaciones y selecciona una (según criterio)
  // que devuelve para continuar la simulación real con ella.
  async multipleOptimization() {

    if (!this.validateCuttingTableSelection()) {
      this.autoRunImproveOnLoad = false;
      return;
    }

    const autoAcceptOnLoad = this.autoRunImproveOnLoad === true;
    this.autoRunImproveOnLoad = false;
    this.usingPersistedLayoutSnapshot = false;
    this.persistedLayoutSnapshotMeta = null;

    // Si el usuario pulsa "Mejorar" sobre una optimización cargada desde BD,
    // pasamos a contexto de simulación en memoria: el ID mostrado debe ser "Prueba"
    // y las impresiones posteriores no deben usar el opti_id histórico.
    if (!this.autoBatchMode && !autoAcceptOnLoad) {
      this.showOptiId = false;
    }

	console.log('--> Ejecutando multipleOptimization:');

	this.time_start = performance.now();

	// Se coloca el icono de carga para blequear la aplicación mientras se hace la optimización.
    this.changingLoading2.emit(true);
    this.resetOptimizationCancelState();
    this.oefRuntimeOptimizationList = null;
    this.oefRuntimeSimulationVariants = [];
    const optimizationListBackup = JSON.parse(JSON.stringify(this.optimizationList || []));
    let optimizationListPatched = false;
    const restoreOptimizationListIfNeeded = () => {
      if (optimizationListPatched) {
        this.optimizationList = JSON.parse(JSON.stringify(optimizationListBackup));
        optimizationListPatched = false;
      }
    };

    const requiredPiecesForFilter = (optimizationListBackup || []).reduce((acc, item) => {
      if (!item || item.check !== true) {
        return acc;
      }
      return acc + this.getSelectedPieceUnits(item);
    }, 0);
    const fromVsBudgetDirectInput = (optimizationListBackup || []).some(item =>
      item && item.source_from_vs_budget_direct === true
    );
    let simulationVariants = [this.optimizationList];

    const oefRuntimeAllowed = this.getOefSettings().enabled === true;
    if (fromVsBudgetDirectInput || !oefRuntimeAllowed) {
      this.lastOefPreSearch = null;
      this.oefRuntimeOptimizationList = null;
      this.oefRuntimeSimulationVariants = [];
      if (fromVsBudgetDirectInput) {
        console.log('--> OEF runtime desactivado para entrada directa VS.budget.');
      } else {
        console.log('--> OEF runtime desactivado: OEF no habilitado por usuario.');
      }
    } else {
      const oefPreSearch = this.runOefPrimitiveSearchBeforeOptimization();
      if (oefPreSearch && oefPreSearch.enabled) {
        console.log('--> OEF pre-search (antes de Mejorar):');
        console.log(oefPreSearch);
        console.log('--> OEF pre-search resumen:');
        console.log({
          allow_mirror: !!(oefPreSearch && oefPreSearch.params && oefPreSearch.params.allow_mirror),
          expanded_count: Number(oefPreSearch && oefPreSearch.expanded_count ? oefPreSearch.expanded_count : 0),
          primitive_count: Number(oefPreSearch && oefPreSearch.primitive_count ? oefPreSearch.primitive_count : 0),
          primitive_pieces: Array.isArray(oefPreSearch && oefPreSearch.primitives)
            ? oefPreSearch.primitives.map(p => Number(p && p.pieces ? p.pieces : 0))
            : []
        });

        const autoAcceptOefCandidates = this.autoBatchMode || autoAcceptOnLoad;
        if (!autoAcceptOefCandidates && oefPreSearch.has_candidates && (oefPreSearch.primitives || []).length > 0) {
          this.changingLoading2.emit(false);
          const accepted = await this.promptOefCandidatesSelection(oefPreSearch);
          if (!accepted) {
            this.changingLoading2.emit(false);
            this.alertInfo = 'Proceso cancelado por el usuario en la selección de primitivos OEF.';
            this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'info'});
            return;
          }
          this.changingLoading2.emit(true);
        } else if (autoAcceptOefCandidates && oefPreSearch.has_candidates && (oefPreSearch.primitives || []).length > 0) {
          const primitives = Array.isArray(oefPreSearch.primitives) ? oefPreSearch.primitives : [];
          let selectedMany = primitives.filter(item => this.getOefCandidateImprovementPct(item) > 0);
          if (!selectedMany.length && primitives.length > 0) {
            selectedMany = [primitives[0]];
          }
          this.oefCandidateSelectedIndex = primitives.length > 0 ? 0 : -1;
          this.oefSelectedCandidate = this.oefCandidateSelectedIndex >= 0 ? primitives[this.oefCandidateSelectedIndex] : null;
          this.lastOefPreSearch.selected_index = this.oefCandidateSelectedIndex;
          this.lastOefPreSearch.selected_primitive = this.oefSelectedCandidate;
          this.lastOefPreSearch.selected_primitives = selectedMany;
        }
      }

      const oefRuntimeVariants = this.buildOefRuntimeOptimizationVariants();
      const normalizedRuntimeVariants = ((oefRuntimeVariants && oefRuntimeVariants.length > 0)
        ? oefRuntimeVariants
        : [this.buildOefRuntimeOptimizationList()])
        .filter(list => Array.isArray(list) && list.length > 0)
        .map(list => this.ensureRuntimeVariantCoverage(optimizationListBackup, list));
      const coveredRuntimeVariants = normalizedRuntimeVariants.filter(list => {
        const variantUnits = (Array.isArray(list) ? list : []).reduce((acc, item) => {
          if (!item || item.check !== true) {
            return acc;
          }
          return acc + this.getSelectedPieceUnits(item);
        }, 0);
        return variantUnits >= requiredPiecesForFilter;
      });
      const effectiveRuntimeVariants = coveredRuntimeVariants.length > 0
        ? coveredRuntimeVariants
        : normalizedRuntimeVariants;
      if (coveredRuntimeVariants.length === 0 && requiredPiecesForFilter > 0) {
        console.log('--> OEF runtime: variantes sin cobertura total, fallback a lista base.');
        console.log({
          required_units: requiredPiecesForFilter,
          generated_variants: normalizedRuntimeVariants.length
        });
      }
      this.oefRuntimeOptimizationList = normalizedRuntimeVariants.length > 0
        ? effectiveRuntimeVariants[0]
        : null;
      if (this.oefRuntimeOptimizationList && this.oefRuntimeOptimizationList.length > 0) {
        // Fuerza coherencia en todo el flujo posterior (simulación, dibujo, exportación).
        this.optimizationList = JSON.parse(JSON.stringify(this.oefRuntimeOptimizationList));
        optimizationListPatched = true;
      }

      const baseSimulationVariants = effectiveRuntimeVariants.length > 0
        ? effectiveRuntimeVariants
        : [this.optimizationList];
      const selectedSheetDimensions = (this.sheetList_datafile || [])
        .filter(sheet => sheet && sheet.check === true)
        .map(sheet => ({
          width: Number(sheet.width),
          height: Number(sheet.height)
        }))
        .filter(sheet => sheet.width > 0 && sheet.height > 0);
      const canUseSharedStripLookahead = (listIn: any[]): boolean => {
        const rows = (listIn || []).filter(item =>
          item && item.check === true && !this.isOefCompositeItem(item)
        );
        const orientations = (itemIn: any): any[] => {
          const width = Number(itemIn && itemIn.width);
          const height = Number(itemIn && itemIn.height);
          if (!(width > 0 && height > 0)) return [];
          return width === height
            ? [{ width: width, height: height }]
            : [{ width: width, height: height }, { width: height, height: width }];
        };

        return rows.some((host, hostIndex) => {
          if (this.getSelectedPieceUnits(host) < 2) return false;
          return rows.some((guest, guestIndex) => {
            if (guestIndex === hostIndex) return false;
            return selectedSheetDimensions.some(sheet =>
              orientations(host).some(hostSize =>
                orientations(guest).some(guestSize =>
                  hostSize.width >= guestSize.width &&
                  hostSize.width <= sheet.width &&
                  guestSize.width / hostSize.width >= 0.75 &&
                  ((2 * hostSize.height) + guestSize.height) <= sheet.height
                )
              )
            );
          });
        });
      };

      // Se conserva siempre la variante histórica. La anticipación se añade
      // únicamente cuando las dimensiones de entrada contienen una oportunidad
      // real, evitando duplicar simulaciones (y coste) en el resto de trabajos.
      simulationVariants = [];
      baseSimulationVariants.forEach(baseVariant => {
        simulationVariants.push(baseVariant);
        if (canUseSharedStripLookahead(baseVariant)) {
          const lookaheadVariant = JSON.parse(JSON.stringify(baseVariant || []));
          lookaheadVariant.forEach(item => {
            if (item) item.packing_shared_strip_lookahead = true;
          });
          simulationVariants.push(lookaheadVariant);
        }
      });
      this.oefRuntimeSimulationVariants = JSON.parse(JSON.stringify(simulationVariants || []));
    }
    const selectedRowsThreshold = (optimizationListBackup || []).reduce((acc, item) => {
      if (!item || item.check !== true) {
        return acc;
      }
      return acc + 1;
    }, 0);
    const hasOefCompositeVariant = (simulationVariants || []).some(list =>
      (list || []).some(item => item && item.check === true && this.isOefCompositeItem(item))
    );
    const minPiecesThreshold = requiredPiecesForFilter > 0
      ? requiredPiecesForFilter
      : this.totalSelectedPieces;

    // Se van a simular varias optimizaciones y luego se va a escoger
    // una que será con la que se va a elegir para dibujar graficamente.
    let opti_list = [];

    // Control para la detección de repetición de secuencias.
    this.lot_sequence_rep = false;

    // Por defecto se usa el "Modo" seleccionado en ese momento.
  	let mode_aux = Number(this.fileForm.controls.f_mode.value);

    let better_opti = { maxtrav: 0, ne: 0, ts: 0, tb: 0, tn: 0, tr: 0, td: 0, tm: 0 , np: 0, nr: 0, ns: 0, rp: 0, rm: 0, bl: false, mb: true, os: true, re: false, md: mode_aux };

    let better_ns_opti = { maxtrav: 0, ne: 0, ts: 0, tb: 0, tn: 0, tr: 0, td: 0, tm: 0 , np: 0, nr: 0, ns: 0, rp: 0, rm: 0, bl: false, mb: true, os: true, re: false, md: mode_aux };
    let better_ne_opti = { maxtrav: 0, ne: 0, ts: 0, tb: 0, tn: 0, tr: 0, td: 0, tm: 0 , np: 0, nr: 0, ns: 0, rp: 0, rm: 0, bl: false, mb: true, os: true, re: false, md: mode_aux };

    let exit_count = 200;
    let count = 0;

    // Se empieza a buscar empezando por el valor más alto del lado más largo de las planchas usadas.
    let final_max_trav = this.calculateMaxTrav(); // Number(this.fileForm.controls.f_max_diecutting.value);
    if (!Number.isFinite(Number(final_max_trav)) || Number(final_max_trav) <= 0) {
      final_max_trav = Number(this.fileForm.controls.f_max_diecutting.value);
    }
    if (!Number.isFinite(Number(final_max_trav)) || Number(final_max_trav) <= 0) {
      this.alertInfo = 'No se puede iniciar la simulación: valor inválido de Max.Trav.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    this.changingLoading2.emit(false);
      restoreOptimizationListIfNeeded();
      return;
    }

    const oefFastPath = !!(
      this.oefRuntimeOptimizationList &&
      this.oefRuntimeOptimizationList.length > 0 &&
      this.oefRuntimeOptimizationList.some(item =>
        item &&
        item.check === true &&
        this.isOefCompositeItem(item)
      )
    );

    // Valor de los saltos de "máximo de travera". Se ajusta según el selector de velocidad.
    let traverse_jump = 100;
    const speedProfile = this.getOptimizationSpeedProfile();
    traverse_jump = speedProfile.traverse_jump;
    if (oefFastPath) {
      // Con OEF activo no se necesita barrido exhaustivo:
      // evita esperas largas y mantiene la simulación estable.
      traverse_jump = Math.max(traverse_jump, 800);
      exit_count = 12;
    }

    // let traverse_range = 1000;

    let exit_while = false;

    // Número máximo de veces que se quiere intentar probar acercar una optimización.
    // let max_test_number = 1000;

    // Se asigna el valor mínimo de travera necesario para que quepan todas las piezas.
    let max_piece_size = this.opti.min_traverse_side = this.calculateMinTrav();
    if (!Number.isFinite(Number(max_piece_size)) || Number(max_piece_size) < 0) {
      max_piece_size = 0;
    }

    // console.log('--> * max_piece_size = ');
	// console.log(max_piece_size);

    // ------------

	// Obtenemos la pieza con el lado más grande y la pieza
	// con el lado mmás pequeño de la optimización (carácter informativo).
    [this.opti.min_side,
     this.opti.max_side,
     this.opti.piece_min_side,
     this.opti.piece_max_side,
     this.opti.min_area,
     this.opti.max_area,
     this.opti.piece_min,
     this.opti.piece_max] = this.pieceMinMax();

    // ------------

    // IMPORTANTE: Hay que dar tiempo a que se visualice el "icono de cargando..." antes de
    // lanzar el bucle "while" que va a paralizar el avance del código y causaría que no se viera.
    let auxaux = await this.myAsyncFunction();

    // ------------------------------------
    // METODO SALTO MEDIO
    // ------------------------------------
    // Se van a realizar optimizaciones hasta que se encuentre una peor que la última hecha.


    // ------------------------------------
    // METODO RANGO DE INTERVALOS
    // ------------------------------------

  // ------------------------------------
  // METODO RECORRIDO COMPLETO POR SALTO
  // ------------------------------------
  let total_better_opti_list = [];
  this.total_better_opti_list = [];

  let all_simulation_result = [];

  const modeStart = oefFastPath ? Number(this.fileForm.controls.f_mode.value) : 2;
  const modeEnd = oefFastPath ? Number(this.fileForm.controls.f_mode.value) : 3;

  const getOefVariantStats = (sourceListIn: any[]): any => {
    const stats = {
      packCount: 0,
      maxGroup: 0,
      totalUnits: 0,
      stripWidthMax: 0,
      layoutStrategy: 'standard',
      layoutStrategyLabel: 'OEF estándar',
      sharedStripLookahead: false
    };
    if (!Array.isArray(sourceListIn)) {
      return stats;
    }
	    sourceListIn.forEach((item: any) => {
	      if (!item || item.check !== true) return;
	      if (item.oef_layout_strategy) {
	        stats.layoutStrategy = item.oef_layout_strategy.toString();
	      }
	      if (item.oef_layout_strategy_label) {
	        stats.layoutStrategyLabel = item.oef_layout_strategy_label.toString();
	      }
	      if (item.packing_shared_strip_lookahead === true) {
	        stats.sharedStripLookahead = true;
	      }
	      const packsRaw = Number(item.units);
	      const packs = Number.isFinite(packsRaw) && packsRaw > 0 ? Math.round(packsRaw) : 1;
      const polygonsCount = Array.isArray(item.oef_internal_polygons) ? item.oef_internal_polygons.length : 0;
      const runtimeUnitsRaw = Number(item.oef_runtime_units);
      const groupUnits = (polygonsCount > 1)
        ? polygonsCount
        : (Number.isFinite(runtimeUnitsRaw) && runtimeUnitsRaw > 0 ? Math.round(runtimeUnitsRaw) : 1);
	      stats.packCount += packs;
	      stats.totalUnits += (packs * groupUnits);
	      if (groupUnits > stats.maxGroup) stats.maxGroup = groupUnits;
	      const width = Number(item && item.width);
	      const height = Number(item && item.height);
	      const xWidth = (Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0)
	        ? Math.min(width, height)
	        : width;
	      if (Number.isFinite(xWidth) && xWidth > stats.stripWidthMax) {
	        stats.stripWidthMax = xWidth;
	      }
	    });
	    if (stats.sharedStripLookahead) {
	      stats.layoutStrategyLabel += ' · travera compartida';
	    }
	    return stats;
	  };

  for (let variantIndex = 0; variantIndex < simulationVariants.length; variantIndex++) {
  const simulationSourceList = simulationVariants[variantIndex] || this.optimizationList;
  const oefVariantStats = getOefVariantStats(simulationSourceList);
  if (simulationSourceList && simulationSourceList.length > 0) {
    this.oefRuntimeOptimizationList = JSON.parse(JSON.stringify(simulationSourceList));
  }
  console.log('--> OEF variante simulación:');
  console.log({ variant: variantIndex + 1, total: simulationVariants.length });

  for (let count_mode = modeStart; count_mode <= modeEnd; count_mode++) {

	// console.log('--> Simulando para el Modo ' + count_mode);

	exit_while = false;

	let current_max_trav = final_max_trav;

	count = 0;

	better_opti = { maxtrav: 0, ne: 0, ts: 0, tb: 0, tn: 0, tr: 0, td: 0, tm: 0 , np: 0, nr: 0, ns: 0, rp: 0, rm: 0, bl: false, mb: true, os: true, re: false, md: count_mode };

	// ---------------------------------------------------------------------
	// Orden de los PARÁMETROS de la función de simulación:
	// max.travera, bloques, modo, recolocar, base.max., reordenación.
	// ---------------------------------------------------------------------

    // Se lanza una primera optimización con el valor máximo que puede tener la travera.
    // better_opti = await this.simulateOptimization(current_max_trav, false, count_mode, true, true, true);

    // if (better_opti && better_opti.maxtrav > 0) {
	if (current_max_trav > 0) {

		// La primera simulación se cogerá de partida como la mejor
		// optimización en hojas y en número de pilas.
		// better_ns_opti = better_opti;
		// better_ne_opti = better_opti;

		// total_better_opti_list.push(better_opti);
		// this.saveSimulation(total_better_opti_list, better_opti, all_simulation_result, better_ns_opti, better_ne_opti);

	    // Se vuelve a lanzar la primera optimización pero sin "reordenación" de hojas.
	    // better_opti = await this.simulateOptimization(current_max_trav, false, count_mode, true, true, false);

		// total_better_opti_list.push(better_opti);
		// this.saveSimulation(total_better_opti_list, better_opti, all_simulation_result, better_ns_opti, better_ne_opti);

		// Se guarda la primera simulación que de patida será momentáneamente "la mejor".
    	// total_better_opti_list.push(better_opti);

		// Cuando una optimización mejore el número de hojas,
		// el número de pilas o la merma, entonces se guardará

		// all_simulation_result['ns_' + better_opti.ns] = [];
		// all_simulation_result['ne_' + better_opti.ne] = [];

		// all_simulation_result['ns_' + better_opti.ns].push(better_opti);
		// all_simulation_result['ne_' + better_opti.ne].push(better_opti);

		// ---------------------------------------------------------------------------
		// NOTA: Comprobaciones de las dimensiones de las piezas y sus secuencias.
		// Si no se cumple alguna de las condiciones entonces se aborta la simulación.

		// Sólo se pasan las piezas que estén seleccionadas en el formulario.
	    // También se quitan las que sobrepasen el ancho máximo de travera especificado.
	    let optimizationList_aux = [];
	    let no_optimizationList_aux = [];

	    let pieces_check = 0;

	    let dimension_check = [];

		// this.max_traverse_ok = false;
		let max_traverse_ok = false;

	    simulationSourceList.forEach((ps, index) => {
	      // console.log('- Pieza dataInput: ');
	      // console.log(ps);
	      if (ps['check'] === true) {

	        //if (Number(this.fileForm.controls.f_max_diecutting.value) >= ps.height || Number(this.fileForm.controls.f_max_diecutting.value) >= ps.width) {
			if (current_max_trav >= ps.height || current_max_trav >= ps.width) {
	        	// console.log('->> Pieza seleccionada añadida: ' + ps.id);
	        	ps['list_order'] = (index + 1);
	        	optimizationList_aux.push(ps);
	        	pieces_check += this.getSelectedPieceUnits(ps);
	        } else {
	          // console.log('->> Pieza seleccionada NO añadida por sobrepasar el ancho máximo de travera: ' + ps.id);
	          max_traverse_ok = true; // this.max_traverse_ok = true;
	          no_optimizationList_aux.push(ps);
	        }

	        let l_max = ps.width;
	        let l_min = ps.height;

	        if (ps.width < ps.height) {
				l_min = ps.width;
				l_max = ps.height;
			}

	        if (this.isOefCompositeItem(ps)) {
	          // En OEF compuesto es normal mezclar dimensiones bajo mismo lote/secuencia.
	        } else if (!dimension_check['ls_' + ps.lot + ps.sequence]) {
	        	dimension_check['ls_' + ps.lot + ps.sequence] = { w: l_min, h: l_max };
	        } else if (dimension_check['ls_' + ps.lot + ps.sequence].w !== l_min ||
				dimension_check['ls_' + ps.lot + ps.sequence].h !== l_max) {

				console.log('-> Encontrada pieza con lote y secuencia similar a otra:');
				console.log(ps);
				console.log(dimension_check);

				this.lot_sequence_rep = true;

			} // End Else dimension_check.

	      }
	    });

	    this.alertInfo = '';

	    if (max_traverse_ok) {

		    this.alertInfo = '<p>No se ha podido realizar la optimización.</p><p>Estas piezas sobrepasan el ancho máximo de travera:</p><p>&nbsp;</p>';
		    // Enumeramos las piezas no incluidas.
		    no_optimizationList_aux.forEach((nps, index) => {
				console.log('- Pieza no incluida: ');
	      		console.log(nps);
				this.alertInfo +=  '<p>   · ' + nps.units +	' uds -> ' + nps.mat_name + ' - ' + nps.width + ' x ' + nps.height + '</p>';
			}); // */


			    this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

			    // Se sale de la función para cancelar la optimización cerrando
				// antes la ventana de carga para que no blequee la aplicación.
			        this.changingLoading2.emit(false);
              restoreOptimizationListIfNeeded();

				    return;
				}

		if (this.lot_sequence_rep) {
		    this.alertInfo += '<p>&nbsp;</p><p> Encontrada pieza con lote y secuencia similar a otra pieza que tiene diferentes dimensiones.</p>';
			this.alertInfo += '<p> · Debe solventar este problema para poder continuar correctamente con la optimización.</p>';

				this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

				this.changingLoading2.emit(false);

				this.lot_sequence_rep = false;
        restoreOptimizationListIfNeeded();

				return;
			}

		// -------------------------

				let result_opti = null;
				const combos = oefFastPath
          ? [{ bl: false, re: true, mb: true, os: true }]
          : this.getSimulationCombos(speedProfile.level, count_mode);

			while (!exit_while && count <= exit_count) {
	        if (this.isOptimizationCancellationRequested()) {
	          this.alertInfo = 'Optimización cancelada por el usuario.';
	          this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'info'});
	          this.changingLoading2.emit(false);
            restoreOptimizationListIfNeeded();
	          return;
	        }

					for (let c = 0; c < combos.length; c++) {
	          if (this.isOptimizationCancellationRequested()) {
	            this.alertInfo = 'Optimización cancelada por el usuario.';
	            this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'info'});
	            this.changingLoading2.emit(false);
              restoreOptimizationListIfNeeded();
	            return;
	          }
					const combo = combos[c];
						result_opti = await this.simulateOptimization(
							current_max_trav,
							combo.bl,
							count_mode,
							combo.re,
							combo.mb,
							combo.os
						);
							if (result_opti && Number.isFinite(Number(result_opti.np))) {
              if (oefFastPath) {
                result_opti.oef_variant_index = variantIndex;
                result_opti.oef_variant_pack_count = Number(oefVariantStats.packCount);
                result_opti.oef_variant_max_group = Number(oefVariantStats.maxGroup);
                result_opti.oef_variant_total_units = Number(oefVariantStats.totalUnits);
                result_opti.oef_variant_strip_w = Number(oefVariantStats.stripWidthMax);
                result_opti.oef_layout_strategy = oefVariantStats.layoutStrategy;
                result_opti.oef_layout_strategy_label = oefVariantStats.layoutStrategyLabel;
                result_opti.packing_shared_strip_lookahead = oefVariantStats.sharedStripLookahead;
                console.log('--> OEF simulation result (raw):');
                const oefSimulationSummary = {
                  variant: Number(variantIndex + 1),
                  np: Number(result_opti.np),
                  tm: Number(result_opti.tm),
                  td: Number(result_opti.td),
                  ns: Number(result_opti.ns),
                  ne: Number(result_opti.ne),
                  free_rect_area: Number(result_opti.oef_free_rect_area),
                  free_rect_count: Number(result_opti.oef_free_rect_count),
                  variant_total_units: Number(oefVariantStats.totalUnits),
                  variant_max_group: Number(oefVariantStats.maxGroup),
                  variant_pack_count: Number(oefVariantStats.packCount),
                  variant_strip_w: Number(oefVariantStats.stripWidthMax),
                  layout_strategy: oefVariantStats.layoutStrategy,
                  shared_strip_lookahead: oefVariantStats.sharedStripLookahead
                };
                console.log(oefSimulationSummary);
                console.log('--> OEF simulation result (json): ' + JSON.stringify(oefSimulationSummary));
              }
								total_better_opti_list.push(result_opti);
							}
					}

          if (oefFastPath) {
            // En OEF se evalúa una única simulación por variante con la travera máxima:
            // evita degradar el resultado al barrer valores menores de max_trav.
            exit_while = true;
          }

				// Rebajamos el valor "máximo de travera" que se va a probar en la siguiente simulación.
				current_max_trav -= traverse_jump;
				count++;

        if (!Number.isFinite(Number(current_max_trav))) {
          console.log('--> multipleOptimization: current_max_trav inválido. Se fuerza salida del bucle.');
          exit_while = true;
        }

			if (current_max_trav < max_piece_size) exit_while = true;

			} // End While exit_while. // */

      if (count > exit_count) {
        this.addAutoBatchWarning('Búsqueda interrumpida por límite de iteraciones (' + exit_count + ').');
      }

		// console.log('--> * Salida del bucle: count = ' + count);
		// console.log(exit_count);

	} else {
		console.log('--> * better_opti no definido.');

    	this.changingLoading2.emit(false);
	} // End If better_opti. // */
   } // End For count_mode.
  } // End For variantIndex.

   // console.log('--> * better_ns_opti = ');
   // console.log(better_ns_opti);
   // console.log('--> * better_ne_opti = ');
   // console.log(better_ne_opti);

   console.log('--> * total_better_opti_list = ');
   console.log(total_better_opti_list);

   // console.log('--> * all_simulation_result = ');
   // console.log(all_simulation_result);

   let final_better_optis = [];

	   total_better_opti_list
     .filter(op => op && Number.isFinite(Number(op.np)))
     .forEach(op => {

		// if (op.rm === 14.54 || op.tm === 17.62 || op.td === 4.14) {
		// 	console.log('--> Opti buscada =');
		// 	console.log(op);
		// }

		const variantKeySuffix = oefFastPath
      ? ('_vg' + Number(op && op.oef_variant_max_group ? op.oef_variant_max_group : 0) +
         '_vp' + Number(op && op.oef_variant_pack_count ? op.oef_variant_pack_count : 0) +
         '_vw' + Number(op && op.oef_variant_strip_w ? op.oef_variant_strip_w : 0) +
         '_vs' + (op && op.oef_layout_strategy ? op.oef_layout_strategy : 'standard') +
         '_sl' + (op && op.packing_shared_strip_lookahead === true ? '1' : '0'))
      : '';
		let key_string = op.np + '_' + op.ne + '_' + op.ns + '_' + op.tb.toFixed(1) + '_' + op.tn.toFixed(1) + '_' + op.td.toFixed(1) + '_' + op.tr.toFixed(1) + '_' + op.tm.toFixed(1) + '_' + op.rm.toFixed(1) + variantKeySuffix;
		// Si no existía ya un resultado similar entonces se almacena.
		if (!final_better_optis[key_string]) final_better_optis[key_string] = op;
   });

   console.log('--> * final_better_optis = ');
   console.log(final_better_optis);

   const buildFilteredBetter = (minPiecesIn: number): any => {
    let filtered = [];
    for (let prop in final_better_optis) {
      let opti = final_better_optis[prop];
      if (!opti || Number(opti.np) < minPiecesIn) {
        continue;
      }
      const filteredVariantSuffix = oefFastPath
        ? ('_vg' + Number(opti && opti.oef_variant_max_group ? opti.oef_variant_max_group : 0) +
           '_vp' + Number(opti && opti.oef_variant_pack_count ? opti.oef_variant_pack_count : 0) +
           '_vw' + Number(opti && opti.oef_variant_strip_w ? opti.oef_variant_strip_w : 0) +
           '_vs' + (opti && opti.oef_layout_strategy ? opti.oef_layout_strategy : 'standard') +
           '_sl' + (opti && opti.packing_shared_strip_lookahead === true ? '1' : '0'))
        : '';
      const filteredKey = opti.np + '_' + opti.ns + '_' + opti.ne + '_' + Number(opti.oef_variant_strip_w || 0).toFixed(1) + '_' + opti.tm.toFixed(1) + '_' + opti.rm.toFixed(1) + filteredVariantSuffix;
      let saved_opti = filtered[filteredKey];

      if (!saved_opti) {
        filtered[filteredKey] = opti;
      } else if (saved_opti.ns > opti.ns ||
        saved_opti.ne > opti.ne ||
        (saved_opti.rm < opti.rm && saved_opti.tm > opti.tm) ||
        (saved_opti.ns === opti.ns && (saved_opti.rm < opti.rm || saved_opti.tm > opti.tm))
      ) {
        filtered[filteredKey] = opti;
      }
    }
    return filtered;
   };

   let result_filter_better = buildFilteredBetter(minPiecesThreshold);
   if (Object.keys(result_filter_better).length === 0 && selectedRowsThreshold > 0 && selectedRowsThreshold < minPiecesThreshold) {
    console.log('--> multipleOptimization: fallback umbral NP por filas seleccionadas.');
    console.log({ strict_np_threshold: minPiecesThreshold, row_np_threshold: selectedRowsThreshold });
    result_filter_better = buildFilteredBetter(selectedRowsThreshold);
   }
   if (Object.keys(result_filter_better).length === 0) {
    console.log('--> multipleOptimization: fallback final NP>=1 para no perder resultados válidos.');
    result_filter_better = buildFilteredBetter(1);
   }

   let result_better_optis = [];

   for (let prop in result_filter_better) {

		result_better_optis.push(result_filter_better[prop]);
   }

   if (oefFastPath) {
    const validOefResults = result_better_optis.filter(op => op && op.oef_geometry_valid !== false);
    const rejectedOefResults = result_better_optis.length - validOefResults.length;
    if (rejectedOefResults > 0) {
      console.warn('--> OEF: simulaciones rechazadas por geometría/retales solapados:', rejectedOefResults);
    }
    result_better_optis = validOefResults;
   }

   // Hay que ordenar los resultados por "número de pila", "hojas" y "merma".
   // En flujo OEF primero se garantiza el máximo número de piezas colocadas.
   if (oefFastPath) {
    const targetNp = Number(minPiecesThreshold) > 0 ? Number(minPiecesThreshold) : Number(this.totalSelectedPieces || 0);
    const feasibleByTarget = result_better_optis.filter(op => {
      const np = Number(op && op.np);
      return Number.isFinite(np) && np > 0 && (targetNp <= 0 || np <= targetNp);
    });
    const poolForMax = feasibleByTarget.length > 0 ? feasibleByTarget : result_better_optis;
    const maxNpByStrategy = {};
    poolForMax.forEach(op => {
      const np = Number(op && op.np);
      const strategy = op && op.oef_layout_strategy ? op.oef_layout_strategy.toString() : 'standard';
      if (Number.isFinite(np) && np > Number(maxNpByStrategy[strategy] || 0)) {
        maxNpByStrategy[strategy] = np;
      }
    });
    if (Object.keys(maxNpByStrategy).length > 0) {
      result_better_optis = poolForMax.filter(op => {
        const strategy = op && op.oef_layout_strategy ? op.oef_layout_strategy.toString() : 'standard';
        return Number(op && op.np) >= Number(maxNpByStrategy[strategy] || 0);
      });
      console.log('--> OEF filtro por máximo NP de cada estrategia antes de ordenar:');
      console.log({ target_np: targetNp, max_np_by_strategy: maxNpByStrategy, kept: result_better_optis.length });
    }

    result_better_optis.sort((a, b) => {
      const aNp = Number(a && a.np);
      const bNp = Number(b && b.np);
      if (Number.isFinite(aNp) && Number.isFinite(bNp) && aNp !== bNp) {
        return bNp - aNp;
      }
      // Prioridad de negocio: a igualdad de piezas colocadas,
      // minimizar primero número de hojas y después caballetes.
      const aNs = Number(a && a.ns);
      const bNs = Number(b && b.ns);
      if (Number.isFinite(aNs) && Number.isFinite(bNs) && aNs !== bNs) {
        return aNs - bNs;
      }
      const aNe = Number(a && a.ne);
      const bNe = Number(b && b.ne);
      if (Number.isFinite(aNe) && Number.isFinite(bNe) && aNe !== bNe) {
        return aNe - bNe;
      }
      // A igualdad de producción, hojas y caballetes, OEF favorece un único
      // rectángulo libre grande. Es la disposición en L buscada para que el
      // resto sea reutilizable en lugar de quedar fragmentado en bandas.
      const aFreeRect = Number(a && a.oef_free_rect_area);
      const bFreeRect = Number(b && b.oef_free_rect_area);
      if (Number.isFinite(aFreeRect) && Number.isFinite(bFreeRect) && aFreeRect !== bFreeRect) {
        return bFreeRect - aFreeRect;
      }
      const aFreeCount = Number(a && a.oef_free_rect_count);
      const bFreeCount = Number(b && b.oef_free_rect_count);
      if (Number.isFinite(aFreeCount) && Number.isFinite(bFreeCount) && aFreeCount !== bFreeCount) {
        return aFreeCount - bFreeCount;
      }
      const aTm = Number(a && a.tm);
      const bTm = Number(b && b.tm);
      if (Number.isFinite(aTm) && Number.isFinite(bTm) && aTm !== bTm) {
        return aTm - bTm;
      }
      const aTd = Number(a && a.td);
      const bTd = Number(b && b.td);
      if (Number.isFinite(aTd) && Number.isFinite(bTd) && aTd !== bTd) {
        return aTd - bTd;
      }
      const aTb = Number(a && a.tb);
      const bTb = Number(b && b.tb);
      if (Number.isFinite(aTb) && Number.isFinite(bTb) && aTb !== bTb) {
        return aTb - bTb;
      }
      const aStripW = Number(a && a.oef_variant_strip_w);
      const bStripW = Number(b && b.oef_variant_strip_w);
      if (Number.isFinite(aStripW) && Number.isFinite(bStripW) && aStripW !== bStripW) {
        return aStripW - bStripW;
      }
      const aMaxTrav = Number(a && a.maxtrav);
      const bMaxTrav = Number(b && b.maxtrav);
      if (Number.isFinite(aMaxTrav) && Number.isFinite(bMaxTrav) && aMaxTrav !== bMaxTrav) {
        return bMaxTrav - aMaxTrav;
      }
      const aMaxGroup = Number(a && a.oef_variant_max_group);
      const bMaxGroup = Number(b && b.oef_variant_max_group);
      if (Number.isFinite(aMaxGroup) && Number.isFinite(bMaxGroup) && aMaxGroup !== bMaxGroup) {
        return bMaxGroup - aMaxGroup;
      }
      const aPackCount = Number(a && a.oef_variant_pack_count);
      const bPackCount = Number(b && b.oef_variant_pack_count);
      if (Number.isFinite(aPackCount) && Number.isFinite(bPackCount) && aPackCount !== bPackCount) {
        return aPackCount - bPackCount;
      }
      const aRm = Number(a && a.rm);
      const bRm = Number(b && b.rm);
      if (Number.isFinite(bRm) && Number.isFinite(aRm) && bRm !== aRm) {
        return bRm - aRm;
      }
      const aVariant = Number(a && a.oef_variant_index);
      const bVariant = Number(b && b.oef_variant_index);
      if (Number.isFinite(aVariant) && Number.isFinite(bVariant) && aVariant !== bVariant) {
        return aVariant - bVariant;
      }
      const aKey = (a && a.oef_variant_max_group !== undefined ? a.oef_variant_max_group : '') + '|' +
        (a && a.oef_variant_pack_count !== undefined ? a.oef_variant_pack_count : '') + '|' +
        (a && a.oef_variant_strip_w !== undefined ? a.oef_variant_strip_w : '') + '|' +
        (a && a.maxtrav !== undefined ? a.maxtrav : '') + '|' +
        (a && a.rm !== undefined ? a.rm : '') + '|' +
        (a && a.tm !== undefined ? a.tm : '');
      const bKey = (b && b.oef_variant_max_group !== undefined ? b.oef_variant_max_group : '') + '|' +
        (b && b.oef_variant_pack_count !== undefined ? b.oef_variant_pack_count : '') + '|' +
        (b && b.oef_variant_strip_w !== undefined ? b.oef_variant_strip_w : '') + '|' +
        (b && b.maxtrav !== undefined ? b.maxtrav : '') + '|' +
        (b && b.rm !== undefined ? b.rm : '') + '|' +
        (b && b.tm !== undefined ? b.tm : '');
      if (aKey !== bKey) {
        return aKey < bKey ? -1 : 1;
      }
      return 0;
    });
   } else {
    result_better_optis = this.opti.orderByOpti(result_better_optis, '', false);
   }

   console.log('--> * result_better_optis = ');
   console.log(result_better_optis);

   // Recorremos los mejores resultados y se descartan los que no merezcan la pena
   // porque existe otra optimización que la mejora en todo.

   let only_better = [];
   /*
   let better_ne = 99999;
   let better_ns = 99999;
   let better_tm = 100;
   let better_rm = -1; // */

   let better_ne = null;
   let better_ns = null;
   let better_tm = null;
   let better_rm = null;

   result_better_optis.forEach((opt, ind) => {

	if (ind === 0) {

		only_better.push(opt);

	    better_ne = opt;
	    better_ns = opt;
	    better_tm = opt;
	    better_rm = opt;

	} else {

		let no_saved = true;

		if (better_ns.ns > opt.ns) {

			better_ns = opt;

			only_better.push(opt);
			no_saved = false;
		}

		if (better_ne.ne > opt.ne) {

			better_ne = opt;

			if (no_saved) {
				only_better.push(opt);
				no_saved = false;
			}
		}

		if ((better_ns.ns >= opt.ns || better_ne.ne >= opt.ne) && better_tm.tm > opt.tm) {

			better_tm = opt;

			if (no_saved) {
				only_better.push(opt);
				no_saved = false;
			}
		}

		if ((better_ns.ns >= opt.ns || better_ne.ne >= opt.ne) && better_rm.rm < opt.rm) {

			better_rm = opt;

			if (no_saved) {
				only_better.push(opt);
				no_saved = false;
			}
		}
	} // */

		/*
		if (ind === 0) {

			only_better.push(opt);

		    better_ne = opt.ne;
		    better_ns = opt.ns;
		    better_tm = opt.tm;
		    better_rm = opt.rm;

		} else {

			let before_opt = null;

			before_opt = result_better_optis[ind - 1];

			if (before_opt) {

				if ((opt.ne > before_opt.ne && opt.ns !== before_opt.ns)
					|| (opt.ne >= before_opt.ne && better_tm > opt.tm)
					|| (opt.ne >= before_opt.ne && better_rm < opt.rm)
				) {

					if (better_tm > opt.tm) {
						better_tm = opt.tm;
					}

					if (better_rm < opt.rm) {
						better_rm = opt.rm;
					}

					only_better.push(opt);

				}

			} // End If before_opt.
		} // */
   });

   console.log('--> * only_better = ');
   console.log(only_better);

   if (oefFastPath && result_better_optis && result_better_optis.length > 0) {
    const numberOr = (valueIn: any, fallbackIn: number): number => {
      const value = Number(valueIn);
      return Number.isFinite(value) ? value : fallbackIn;
    };
    const compareProductionResult = (a: any, b: any): number => {
      return (numberOr(b && b.np, 0) - numberOr(a && a.np, 0)) ||
        (numberOr(a && a.ns, 999999) - numberOr(b && b.ns, 999999)) ||
        (numberOr(a && a.ne, 999999) - numberOr(b && b.ne, 999999)) ||
        (numberOr(a && a.tm, 999999) - numberOr(b && b.tm, 999999)) ||
        (numberOr(a && a.td, 999999) - numberOr(b && b.td, 999999)) ||
        (numberOr(b && b.oef_free_rect_area, 0) - numberOr(a && a.oef_free_rect_area, 0)) ||
        (numberOr(a && a.oef_free_rect_count, 999999) - numberOr(b && b.oef_free_rect_count, 999999)) ||
        (numberOr(b && b.rm, 0) - numberOr(a && a.rm, 0)) ||
        (numberOr(a && a.oef_variant_index, 999999) - numberOr(b && b.oef_variant_index, 999999));
    };
    const compareCentralRemainderLayout = (a: any, b: any): number => {
      return (numberOr(b && b.np, 0) - numberOr(a && a.np, 0)) ||
        (numberOr(a && a.ns, 999999) - numberOr(b && b.ns, 999999)) ||
        (numberOr(a && a.ne, 999999) - numberOr(b && b.ne, 999999)) ||
        (numberOr(b && b.oef_free_rect_area, 0) - numberOr(a && a.oef_free_rect_area, 0)) ||
        (numberOr(a && a.oef_free_rect_count, 999999) - numberOr(b && b.oef_free_rect_count, 999999)) ||
        (numberOr(a && a.tm, 999999) - numberOr(b && b.tm, 999999)) ||
        (numberOr(a && a.td, 999999) - numberOr(b && b.td, 999999)) ||
        (numberOr(b && b.rm, 0) - numberOr(a && a.rm, 0)) ||
        (numberOr(a && a.oef_variant_index, 999999) - numberOr(b && b.oef_variant_index, 999999));
    };

    // El modal conserva una selección amplia para que el usuario decida:
    // - las cuatro mejores soluciones por producción/merma;
    // - hasta dos alternativas elegidas por la calidad del retal central.
    // Una misma simulación nunca se presenta dos veces.
    const bestWasteLimit = 4;
    const centralRemainderLimit = 2;
    const bestWasteResults = result_better_optis
      .slice()
      .sort(compareProductionResult)
      .slice(0, bestWasteLimit);
    const centralRemainderResults = result_better_optis
      .filter(op => op && op.oef_layout_strategy === 'central_remainder')
      .slice()
      .sort(compareCentralRemainderLayout)
      .slice(0, centralRemainderLimit);

    only_better = [];
    result_better_optis.forEach(op => {
      if (!op) return;
      op.oef_recommended = false;
      op.oef_selected_for_waste = false;
      op.oef_selected_for_central_remainder = false;
    });

    const addModalResult = (opIn: any, reasonIn: string): void => {
      if (!opIn) return;
      if (reasonIn === 'waste') {
        opIn.oef_selected_for_waste = true;
      }
      if (reasonIn === 'central_remainder') {
        opIn.oef_selected_for_central_remainder = true;
      }
      if (only_better.indexOf(opIn) < 0) {
        only_better.push(opIn);
      }
    };
    bestWasteResults.forEach(op => addModalResult(op, 'waste'));
    centralRemainderResults.forEach(op => addModalResult(op, 'central_remainder'));
    only_better.sort(compareProductionResult);
    only_better.forEach((op, index) => {
      op.oef_recommended = index === 0;
    });
    console.log('--> OEF simulaciones presentadas al usuario:');
    const oefBestByStrategySummary = only_better.map(op => ({
      strategy: op && op.oef_layout_strategy,
      recommended: op && op.oef_recommended === true,
      selected_for_waste: op && op.oef_selected_for_waste === true,
      selected_for_central_remainder: op && op.oef_selected_for_central_remainder === true,
      variant: Number(op && op.oef_variant_index) + 1,
      shared_strip_lookahead: op && op.packing_shared_strip_lookahead === true,
      np: Number(op && op.np),
      tm: Number(op && op.tm),
      td: Number(op && op.td),
      ns: Number(op && op.ns),
      ne: Number(op && op.ne),
      free_rect_area: Number(op && op.oef_free_rect_area),
      free_rect_count: Number(op && op.oef_free_rect_count)
    }));
    console.log(oefBestByStrategySummary);
    console.log('--> OEF simulaciones presentadas al usuario (json): ' +
      JSON.stringify(oefBestByStrategySummary));
   }

   if (!only_better || only_better.length === 0) {
    if (result_better_optis && result_better_optis.length > 0) {
      only_better = [result_better_optis[0]];
      console.log('--> multipleOptimization: fallback usando mejor simulación ordenada.');
      console.log(only_better[0]);
    } else {
	      this.alertInfo = 'No se ha encontrado una simulación válida para mostrar resultados.';
	      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
	      this.changingLoading2.emit(false);
        restoreOptimizationListIfNeeded();
	      return;
	    }
	   }

   // Se asigna a la variable global que almacena la información
   // de todos los mejores resultados de la última simulación.
   this.total_better_opti_list = only_better;

   if (this.autoBatchMode && this.autoBatchStage === 'running') {
     const autoSelected = this.chooseAutoSimulationByStrategy(this.total_better_opti_list);

	     if (!autoSelected) {
	       this.changingLoading2.emit(false);
	       this.finishAutoBatchJob(false, 'No se ha encontrado una simulación válida en Mejorar.');
         restoreOptimizationListIfNeeded();
	       return;
	     }

	     this.changingLoading2.emit(false);
	     this.confirmSimulationsModal(autoSelected, -1);
       restoreOptimizationListIfNeeded();
	     return;
	   }

   if (autoAcceptOnLoad) {
     const strategySelected = this.chooseAutoSimulationByStrategy(this.total_better_opti_list);
     const autoSelected = strategySelected
       ? strategySelected
       : (this.total_better_opti_list && this.total_better_opti_list.length > 0 ? this.total_better_opti_list[0] : null);

     if (!autoSelected) {
       this.alertInfo = 'No se ha encontrado una simulación válida para abrir la optimización.';
       this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
       this.changingLoading2.emit(false);
       restoreOptimizationListIfNeeded();
       return;
     }

     this.changingLoading2.emit(false);
     this.confirmSimulationsModal(autoSelected, -1);
     restoreOptimizationListIfNeeded();
     return;
   }

   this.showSimulationsModal(true);

   this.changingLoading2.emit(false);

	   this.time_end = performance.now();

	   this.time_duration = this.formatarTiempo((this.time_end - this.time_start) / 1000);
     restoreOptimizationListIfNeeded();

  } // End function multipleOptimization.

  validateCuttingTableSelection(): boolean {
    const selectedId = Number(this.fileForm && this.fileForm.controls && this.fileForm.controls.f_cutting_table_id
      ? this.fileForm.controls.f_cutting_table_id.value
      : 0);

    if (selectedId > 0) {
      return true;
    }

    this.alertInfo = 'Debe seleccionar una mesa de corte antes de comenzar la optimización.';
    this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    return false;
  }

  resolveCuttingTableForLoadedOptimization(): void {
    if (!this.cuttingTables || this.cuttingTables.length < 1) {
      return;
    }

    let selectedTable: CuttingTable = null;
    const stateTxt = this.currentOpti && this.currentOpti['od_state'] ? this.currentOpti['od_state'].toString() : '';
    const stateObj = this.parseOptiStateInfo(stateTxt);

    if (stateObj['CUTTING_TABLE_ID']) {
      const stateId = Number(stateObj['CUTTING_TABLE_ID']);
      if (stateId > 0) {
        selectedTable = this.cuttingTables.find(item => Number(item.id) === stateId);
      }
    }

    if (!selectedTable && stateObj['CUTTING_TABLE_NAME']) {
      const stateName = stateObj['CUTTING_TABLE_NAME'].toString().toUpperCase();
      selectedTable = this.cuttingTables.find(item =>
        item && item.name && item.name.toString().toUpperCase().indexOf(stateName) !== -1
      );
    }

    if (!selectedTable) {
      const exportCode = this.fileForm && this.fileForm.controls && this.fileForm.controls.f_export
        ? (this.fileForm.controls.f_export.value ? this.fileForm.controls.f_export.value.toString().toUpperCase() : '')
        : '';
      if (exportCode) {
        selectedTable = this.cuttingTables.find(item => {
          if (!item) return false;
          const master = this.parseCuttingTableMasterData(item);
          return master && master.cnc_family && master.cnc_family.toString().toUpperCase() === exportCode;
        });
      }
    }

    if (!selectedTable) {
      return;
    }

    this.fileForm.controls.f_cutting_table_id.setValue(selectedTable.id);
    // Carga desde BD: no pisar parámetros ya cargados desde la propia optimización.
    this.applyCuttingTableMasterData(selectedTable, false, true);
  }

  ensureCuttingTableResolvedForChargeOpti(): boolean {
    this.resolveCuttingTableForLoadedOptimization();
    let selectedId = Number(this.fileForm.controls.f_cutting_table_id.value);
    if (selectedId > 0) {
      return true;
    }

    if (this.cuttingTables && this.cuttingTables.length > 0) {
      // Último fallback para históricos sin metadatos consistentes.
      this.fileForm.controls.f_cutting_table_id.setValue(this.cuttingTables[0].id);
      this.applySelectedCuttingTable(false, true);
      selectedId = Number(this.fileForm.controls.f_cutting_table_id.value);
    }

    return selectedId > 0;
  }

  parseOptiStateInfo(txtIn: string): any {
    const out = {};
    if (!txtIn || txtIn.trim() === '') return out;

    const raw = txtIn.toString().trim();
    const sep = raw.indexOf(';') >= 0 ? ';' : ',';
    const tokens = raw.split(sep).map(t => t.trim()).filter(t => t !== '');

    tokens.forEach(token => {
      const idx = token.indexOf('=');
      if (idx < 1) return;
      const key = token.substring(0, idx).trim().toUpperCase();
      const value = token.substring(idx + 1).trim();
      out[key] = value;
    });

    return out;
  }


  // Función para almacenar una optimización en una variable.
  saveSimulation(total_better_opti_list, result_opti, all_simulation_result, better_ns_opti, better_ne_opti) {

	// console.log('-> ** Entrando en saveSimulation...');
	// console.log(result_opti);

	// Guardamos todas las simulaciones que se vayan haciendo.
	total_better_opti_list.push(result_opti);
	/*
	if (result_opti.ns < better_ns_opti.ns && result_opti.ns !== 0) {

		if (!all_simulation_result['ns_' + result_opti.ns]) all_simulation_result['ns_' + result_opti.ns] = [];

		all_simulation_result['ns_' + result_opti.ns].push(result_opti);
		better_ns_opti = result_opti;

	} else if (result_opti.ns === better_ns_opti.ns && result_opti.ns !== 0) {

		let bet_opti = this.isBetterOpti(result_opti, better_ns_opti, 2);

		if (bet_opti > 0) {

			if (!all_simulation_result['ns_' + result_opti.ns]) all_simulation_result['ns_' + result_opti.ns] = [];

			all_simulation_result['ns_' + result_opti.ns].push(result_opti);
			better_ns_opti = result_opti;
		}
	} else {
		// Aunque no sea mejor que otras optimizaciones se guarda para tener al menos una muestra de ese valor.
		if (!all_simulation_result['ns_' + result_opti.ns] && result_opti.ns !== 0) {
			all_simulation_result['ns_' + result_opti.ns] = [];
			all_simulation_result['ns_' + result_opti.ns].push(result_opti);
		} else if (result_opti.ns !== 0) {
			let bet_opti = this.isBetterOpti(result_opti, all_simulation_result['ns_' + result_opti.ns][0], 2);

			if (bet_opti > 0) {
				all_simulation_result['ns_' + result_opti.ns][0] = result_opti;
			}
		}
	}

	if (result_opti.ne < better_ne_opti.ne && result_opti.ne !== 0) {

		if (!all_simulation_result['ne_' + result_opti.ne]) all_simulation_result['ne_' + result_opti.ne] = [];

		all_simulation_result['ne_' + result_opti.ne].push(result_opti);
		better_ne_opti = result_opti;

	} else if (result_opti.ne === better_ne_opti.ne && result_opti.ne !== 0) {

		let bet_opti = this.isBetterOpti(result_opti, better_ne_opti, 2);

		if (bet_opti > 0) {

			if (!all_simulation_result['ne_' + result_opti.ne]) all_simulation_result['ne_' + result_opti.ne] = [];

			all_simulation_result['ne_' + result_opti.ne].push(result_opti);
			better_ne_opti = result_opti;
		}
	} else {
		// Aunque no sea mejor que otras optimizaciones se guarda para tener al menos una muestra de ese valor.
		if (!all_simulation_result['ne_' + result_opti.ne] && result_opti.ne !== 0) {
			all_simulation_result['ne_' + result_opti.ne] = [];
			all_simulation_result['ne_' + result_opti.ne].push(result_opti);
		} else if (result_opti.ne !== 0) {
			let bet_opti = this.isBetterOpti(result_opti, all_simulation_result['ne_' + result_opti.ne][0], 2);

			if (bet_opti > 0) {
				all_simulation_result['ne_' + result_opti.ne][0] = result_opti;
			}
		}
	} // */
  } // End saveSimulation.

  // Función que recoge la información del gráfico de 1 hoja pasada como parámetro.
  getOptimizationInfo(indexIn: number, graphicListIn: any, disbandIn: any, blockIn: boolean, baseMaxSideIn: boolean, orderSheetIn: boolean, oldIn: boolean, modeIn: number, maxTravIn: number): any {

    // console.log('--> getOptimizationInfo:' + this.num_sheet + ' ;index = ' + indexIn);
    // console.log(graphicListIn);
    // console.log('-> getOptimizationInfo tail: ');
	// console.log(graphicListIn['tail']);

    // Se evita dibujar cualquier hoja que llegue vacía (sin piezas asignadas dentro).
    if (graphicListIn === null || graphicListIn === undefined || graphicListIn.length === 0) {
      console.log('--> getOptimizationInfo: No existen piezas asignadas a esta hoja.');
      return;
    }

    let tail_area = 0;
    let tail_num = 0;

    let disband_area = 0;

    // Area del retal de cola (sea aprovechable o no).
    if (graphicListIn['tail'] && graphicListIn['tail'].area) {

		tail_area = graphicListIn['tail'].area;
		tail_num = graphicListIn['tail'].num;
	}

	// console.log('-> tail_area = ' + tail_area);
	// console.log('-> tail_num = ' + tail_num);

	let graphicListCopy = JSON.parse(JSON.stringify(graphicListIn));

    let ts = 0; // Total area hoja (sheet).
    let tb = 0; // Total area bruta.
    let tn = 0; // Total area neta.
    let tr = 0; // Total area retal.
    let td = 0; // Total area desperdicio.
    let td_oef_in = 0; // Desperdicio interno de primitivas OEF.
    let tm = 0; // Total merma tanto por ciento.
    let tm_oef = 0; // Merma OEF específica (interna).
    let tj = 0; // Total area colas y desbandes.

    let sheet_count = 0;

    // Vuelta para calcular las dimensiones del canvas.
    graphicListCopy.forEach( gr => {

      if (gr.points && gr.points.length > 0) {

        // Según el tipo de gráfico (Hoja S, Travera T o Pieza P)
        // se indica un grosor y color de línea distinto en el dibujo.
        if (gr.type === 'S' || gr.type === 'U') {

          // Si es una hoja de tipo "Unused" (no usada).
          if (gr.type === 'U') {

            // console.log('--> Encontrada hoja tipo U.');

          } else {
            sheet_count++;

            let des_aux = Number((((gr.width - (Number(disbandIn.left) + Number(disbandIn.right))) * (gr.height - (Number(disbandIn.bottom) + Number(disbandIn.top)))) / 1000000).toFixed(2));

            // Se guarda el valor del área aplicada en el desbande.
            disband_area =  gr.area - des_aux;

            tj += tail_area + disband_area;

            // NOTA: No se va a sumar el desbande al desperdicio (como lo hace Lisec).
            // let des_aux = Number((((gr.width - (Number(disbandIn.left) + Number(disbandIn.right))) * (gr.height - (Number(disbandIn.bottom) + Number(disbandIn.top)))) / 1000000).toFixed(2));

            // Se calcula el área gastada en el desbande.
            // this.total_area_D += gr.area - des_aux;
            // td += gr.area - des_aux;

            //this.total_area_S += gr.area;
            ts += gr.area;

          }
        }
      } // End gr.points

    });

    sheet_count = 0;

    let sheet_num_pieces = 0;
    let sheet_num_retal = 0;

    let max_retal_area = 0;
    let max_free_rect_area = 0;
    let free_rect_count = 0;

    const registerFreeRectangle = (graphicIn: any): void => {
      const width = Number(graphicIn && graphicIn.width);
      const height = Number(graphicIn && graphicIn.height);
      const explicitArea = Number(graphicIn && graphicIn.area);
      const area = Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0
        ? ((width * height) / 1000000)
        : explicitArea;
      if (!(Number.isFinite(area) && area > 0.0001)) {
        return;
      }
      free_rect_count++;
      if (area > max_free_rect_area) {
        max_free_rect_area = area;
      }
    };

    graphicListCopy.forEach( gr => {

      // console.log(' GR -> ');
      // console.log(gr);

      if (gr.points && gr.points.length > 0) {

        // Según el tipo de gráfico (Hoja S, Travera T o Pieza P)
        // se indica un grosor y color de línea distinto en el dibujo.
        switch (gr.type) {

          case 'S': // case 'U':

            // console.log('--> grafico tipo S o U. Area = ' + this.total_area_S);
            // console.log(gr);

            sheet_count++;

            break;

          case 'T':

		    // La cola no se cuenta como desperdicio en Lisec.
		    if (gr.num !== tail_num) {
				//this.total_area_T += gr.area;
		    	td += gr.area;
				registerFreeRectangle(gr);
		    } //else {
				//console.log('--> grafico tipo T Cola. No se contabiliza como desperdicio.');
			//}

            // console.log('--> grafico tipo T.');

            break;

          case 'R':

			sheet_num_retal++;

            // La cola no se cuenta como retal en Lisec.
			if (gr.num !== tail_num) {
				//this.total_area_R += gr.area;
				tr += gr.area;
				registerFreeRectangle(gr);
			}// else {
			//	console.log('--> grafico tipo R Cola. No se contabiliza como retal.');
			//}

            if (gr.area > max_retal_area) max_retal_area = gr.area;

            // console.log('--> grafico tipo R.');

            break;


          case 'P':
            {
              const hasOefCompositeUnits = this.isOefCompositeItem(gr) || (Number(gr && gr.oef_real_units) > 1);
              if (hasOefCompositeUnits) {
                sheet_num_pieces += this.getOefCompositeTotalUnits(gr);
              } else {
                sheet_num_pieces += 1;
              }
            }

            //this.total_area_P += gr.area;
            tn += gr.area;
            if (gr && Array.isArray(gr.oef_internal_polygons) && gr.oef_internal_polygons.length > 0 && Number(gr.width) > 0 && Number(gr.height) > 0 && Number(gr.area) > 0) {
              const bboxArea = Number((Number(gr.width) * Number(gr.height) / 1000000).toFixed(2));
              const effectiveArea = Number(
                gr && (
                  Number(gr.oef_effective_area) > 0
                    ? gr.oef_effective_area
                    : gr.area
                )
              );
              const innerWaste = Number((bboxArea - Number(effectiveArea)).toFixed(2));
              if (innerWaste > 0) {
                td_oef_in += innerWaste;
                td += innerWaste;
              }
            }

            break; // End CASE elemento tipo 'P' (pieza).
        } // End switch
      } // End gr.points
    }); // End If piece.

    // Se calculan el resto de datos necesarios sobre la hoja.

    // Area Bruta: Se calcula sumando el área utilizada (el total de la hoja)
    // y restando el área de los retales detectados (material que podrá reutilizarse).
    //tb += ts - tr;
    tb += ts - tr - tj;  // Lisec cálculos.

    if (tb <= 0) {
		// console.log('-> tb es cero. Se modifica. ');
		tb = ts;
	}

    // Porcentaje de Merma: Porcentaje que representa sobre la
    // "área bruta" la cantidad de m2 del "área del resto" (desperdicio).
    tm += tb <= 0 ? 0 : (td * 100) / tb;
    const oefBase = tn + td_oef_in;
    tm_oef = oefBase > 0 ? (td_oef_in * 100) / oefBase : 0;

    // Una hoja válida no puede contabilizar más superficie entre piezas,
    // retales y desperdicio que la propia plancha. Esta protección evita que
    // una geometría solapada OEF llegue al selector de simulaciones.
    const oefAccountedArea = Number(tn || 0) + Number(tr || 0) + Number(td || 0);
    const oefGeometryTolerance = Math.max(0.05, Number(ts || 0) * 0.01);
    const oefGeometryValid = !this.oefEnabled ||
      oefAccountedArea <= (Number(ts || 0) + oefGeometryTolerance);
    if (!oefGeometryValid) {
      console.warn('[OEF geometry] Simulación descartable por áreas solapadas:', {
        sheet_area: Number(ts || 0),
        accounted_area: oefAccountedArea,
        piece_area: Number(tn || 0),
        retal_area: Number(tr || 0),
        waste_area: Number(td || 0)
      });
    }

    // -----------------------
	let result_data_opti = { ts: ts, tb: tb, tn: tn, tr: tr, td: td, td_oef_in: td_oef_in, tj: tj, tm: tm, tm_oef: tm_oef , np: sheet_num_pieces, nr: sheet_num_retal, ns: sheet_count, rp: tr/sheet_num_retal, rm: max_retal_area, oef_free_rect_area: max_free_rect_area, oef_free_rect_count: free_rect_count, oef_geometry_valid: oefGeometryValid, bl: blockIn, mb: baseMaxSideIn, os: orderSheetIn, re: oldIn};

    if (this.oefEnabled === true) {
      const pItems = graphicListCopy.filter(gr => gr && gr.type === 'P');
      const npTrace = pItems.reduce((acc, gr) => {
        const hasOefCompositeUnits = this.isOefCompositeItem(gr) || (Number(gr && gr.oef_real_units) > 1);
        if (hasOefCompositeUnits) {
          return acc + this.getOefCompositeTotalUnits(gr);
        }
        return acc + 1;
      }, 0);
      console.log('[OEF np trace][sheet]', {
        p_items: pItems.length,
        np_sheet: sheet_num_pieces,
        np_trace: npTrace,
        rows: pItems.map(gr => ({
          name: gr.name,
          name_id: gr.name_id,
          units: Number(gr && gr.total_unit ? gr.total_unit : 1),
          oef_real_units: Number(gr && gr.oef_real_units ? gr.oef_real_units : 0),
          oef_polygons: Array.isArray(gr && gr.oef_internal_polygons) ? gr.oef_internal_polygons.length : 0,
          width: Number(gr && gr.width ? gr.width : 0),
          height: Number(gr && gr.height ? gr.height : 0)
        }))
      });
    }

    // console.log('**-> getOptimizationInfo result:');
    // console.log(result_data_opti);

    // -----------------------

    // Se devuelve la información recopilada sobre la hoja durante su procesamiento.
    return result_data_opti;

  } // End function getOptimizationInfo.

  // Función que simula una optimización (no la dibuja) sólo para obtener
  // el resultado de hojas consumidas y metros de piezas encajadas.
  async simulateOptimization(maxTraverseIn: number, blockIn: boolean, modeIn: number, oldIn: boolean, baseMaxSideIn: boolean, orderSheetIn: boolean) {

	const applySheetOrderForStacks = !!orderSheetIn;
	const applySheetOrderForMath = false;
  const orderingSource = (this.oefRuntimeOptimizationList && this.oefRuntimeOptimizationList.length > 0)
    ? this.oefRuntimeOptimizationList
    : this.optimizationList;
  const hasOefRowsForOrdering = (Array.isArray(orderingSource) ? orderingSource : [])
    .some(item => this.isOefCompositeItem(item));

	console.log('->> >> simulateOptimization: ' + maxTraverseIn + ' ;Bloque = ' + blockIn + ' ;Base = ' + baseMaxSideIn + ' ;OrdenPilas = ' + applySheetOrderForStacks + ' ;OrdenCalculo = ' + applySheetOrderForMath + ' ;Modo = ' + modeIn + ' ;Recolocar = ' + oldIn);

	let result_simulation = {
		maxtrav: 0,
		ts: 0,
		tb: 0,
		tn: 0,
		tr: 0,
		td: 0,
		td_oef_in: 0,
		tm: 0,
		tm_oef: 0,
		tj: 0,
		np: 0,
		nr: 0,
		ns: 0,
		rp: 0,
		rm: 0,
		oef_free_rect_area: 0,
		oef_free_rect_count: 0,
		oef_geometry_valid: true,
		ne: 0,
		bl: blockIn,
		mb: baseMaxSideIn,
		os: applySheetOrderForStacks,
		re: oldIn,
		md: modeIn
	};

    if (this.isOptimizationCancellationRequested()) {
      return result_simulation;
    }

    // let that = this;

    // Se inicializan las planchas iniciales.
    this.opti.sheetList = [];
    this.opti.nextSheet = null;

    // Se inicializa el listado de piezas.
    this.opti.pieceInfoList = [];

    // Se inicializan los listados de traveras.
    this.opti.traverseList = [];
    this.opti.oldTraverseList = [];

	    // Mantener visible el ID si seguimos trabajando sobre una optimización cargada.
	    // Evita perder contexto de impresión/BD al simular "Mejorar".
	    const hasStoredOptiId = !!(
	      (this.currentOpti && this.currentOpti.id !== undefined && this.currentOpti.id !== null && this.currentOpti.id !== '') ||
	      (this.routeOptiIdLabel && this.routeOptiIdLabel !== '')
	    );
	    this.showOptiId = this.showOptiId && hasStoredOptiId;

    const optimizationSourceList = (this.oefRuntimeOptimizationList && this.oefRuntimeOptimizationList.length > 0)
      ? this.oefRuntimeOptimizationList
      : this.optimizationList;
    this.opti.useSharedStripLookahead = (optimizationSourceList || [])
      .some(item => item && item.packing_shared_strip_lookahead === true);
    this.opti.sharedStripAlignmentTarget = null;
    this.opti.useRemainderConsolidation = true;

    if (!optimizationSourceList || optimizationSourceList.length === 0) {
      console.log('->> >> No hay datos que optimizar cargados.');

      this.alertInfo = 'No hay datos cargados para optimizar.\nSeleccione un archivo de carga con un formato correcto.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      // Se sale de la función cerrando antes la ventana de carga para que no blequee la aplicación.
      this.changingLoading2.emit(false);
      return;
    }

    // Sólo se pasan las planchas que estén seleccionadas en el formulario.
    let sheetList_aux = [];

    this.sheetList_datafile.forEach((pl, index) => {
      // console.log('- Plancha dataInput: ');
      // console.log(pl);
      if (pl['check'] === true) {
		pl['list_order'] = (index + 1);
        // console.log('->> Plancha seleccionada añadida: ' + pl.id);
        sheetList_aux.push(pl);
      }
    });

    // Para cargar la pila de planchas de prueba usando una función fija como "lista inicial de hojas disponibles".
    this.initialSheetList = this.opti.createSheetList(sheetList_aux);

    if (!this.initialSheetList || this.initialSheetList.length === 0) {
      console.log('->> >> No hay cargada ninguna lista de hojas de entrada.');

      this.alertInfo = 'No hay unidades de planchas de entrada.' +
       				   '\nIntroduzca un valor superior a cero o el valor -1 para tener unidades infinitas.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      let result_modal = await this.changeChargeModal(false);

      return result_simulation;
    }

    // Sólo se pasan las piezas que estén seleccionadas en el formulario.
    // También se quitan las que sobrepasen el ancho máximo de travera especificado.
    let optimizationList_aux = [];
    let no_optimizationList_aux = [];

    let pieces_check = 0;

	// this.max_traverse_ok = false;
	let max_traverse_ok = false;

    optimizationSourceList.forEach((ps, index) => {
      // console.log('- Pieza dataInput: ');
      // console.log(ps);
      if (ps['check'] === true) {

        //if (Number(this.fileForm.controls.f_max_diecutting.value) >= ps.height || Number(this.fileForm.controls.f_max_diecutting.value) >= ps.width) {
		if (maxTraverseIn >= ps.height || maxTraverseIn >= ps.width) {
        	// console.log('->> Pieza seleccionada añadida: ' + ps.id);
        	ps['list_order'] = (index + 1);
        	optimizationList_aux.push(ps);
        	pieces_check += this.getSelectedPieceUnits(ps);
        } else {
          // console.log('->> Pieza seleccionada NO añadida por sobrepasar el ancho máximo de travera: ' + ps.id);
          max_traverse_ok = true; // this.max_traverse_ok = true;
          no_optimizationList_aux.push(ps);
        }
      }
    });

	// if (this.max_traverse_ok) {
	if (max_traverse_ok) {
      const omittedUnits = no_optimizationList_aux.reduce((acc, piece) => {
        return acc + this.getSelectedPieceUnits(piece);
      }, 0);
      this.addAutoBatchWarning(
        'Piezas omitidas por Max.Trav=' + maxTraverseIn + ': ' +
        no_optimizationList_aux.length + ' línea(s), ' + omittedUnits + ' unidad(es).'
      );
		/*
	    this.alertInfo = '<p>No se ha podido realizar la optimización.</p><p>Estas piezas sobrepasan el ancho máximo de travera:</p><p>&nbsp;</p>';
	    // Enumeramos las piezas no incluidas.
	    no_optimizationList_aux.forEach((nps, index) => {
			console.log('- Pieza no incluida: ');
      		console.log(nps);
			this.alertInfo +=  '<p>   · ' + nps.units +	' uds -> ' + nps.mat_name + ' - ' + nps.width + ' x ' + nps.height + '</p>';
		}); // */


	    // this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

	    // Se sale de la función para cancelar la optimización cerrando
		// antes la ventana de carga para que no blequee la aplicación.
        // this.changingLoading.emit(false);
	    return result_simulation;
	}

	// -------------------------------
	// “Modo Optimización 1: máximo rendimiento 2D con clasificación manual de vidrios”
	// “Modo Optimización 2: optimo rendimiento 2D con clasificación automática de vidrios”.

	optimizationList_aux = this.orderOefRowsByLayoutPriority(optimizationList_aux);
    console.log('->> simulateOptimization Optimizando en MODO 1, 2, 3...');
    [this.opti.groupInfoList, this.opti.pieceInfoList] = this.pieceToEasel(optimizationList_aux, this.easelList, modeIn, baseMaxSideIn);

    // Se inicializan las piezas candidatas.
    this.opti.nextPiece = [];

    // Se pone a false la bandera de fin de piezas.
    this.opti.end_pieces = false;

    // Se inicializan los contadores.
    this.opti.traverse_count = 0;

    // Se pone a cero el número total de piezas para la optimización.
    this.totalPieces = 0;

    //console.log('->> Hoja actual:');
    // console.log(this.opti.nextSheet);

    // NOTA: Se empieza la optimización indicando los sigu¡entes parámetros:
    // 1 - La hoja/plancha por la que se va a empezar.
    // 2 - Uno de los tres tipos de "eje de travera" permitidos (X, Y , XY). Según el elegido variará el resultado final.
    // 3 - La distancia de "desbande".
    // 4 - La distancia mínima necedaria para destroquelar.

    let aux_disband_l = 0;
    let aux_disband_b = 0;
    let aux_disband_r = 0;
    let aux_disband_t = 0;

    if (this.fileForm.controls.f_disband_l.value) {
      aux_disband_l = this.fileForm.controls.f_disband_l.value;
    } else {
      this.fileForm.controls.f_disband_l.setValue(0);
    }

    if (this.fileForm.controls.f_disband_b.value) {
      aux_disband_b = this.fileForm.controls.f_disband_b.value;
    } else {
      this.fileForm.controls.f_disband_b.setValue(0);
    }

    if (this.fileForm.controls.f_disband_r.value) {
      aux_disband_r = this.fileForm.controls.f_disband_r.value;
    } else {
      this.fileForm.controls.f_disband_r.setValue(0);
    }

    if (this.fileForm.controls.f_disband_t.value) {
      aux_disband_t = this.fileForm.controls.f_disband_t.value;
    } else {
      this.fileForm.controls.f_disband_t.setValue(0);
    }

    this.disband = {
      left: aux_disband_l, // this.fileForm.controls.f_disband_l.value,
      bottom: aux_disband_b, // this.fileForm.controls.f_disband_b.value,
      right: aux_disband_r, // this.fileForm.controls.f_disband_r.value,
      top: aux_disband_t // this.fileForm.controls.f_disband_t.value,
    }

    this.opti.addSheetTraverse(
      this.opti.nextSheet,
      this.fileForm.controls.f_axis.value,
      this.disband,
      this.fileForm.controls.f_diecutting.value,
      maxTraverseIn, // this.fileForm.controls.f_max_diecutting.value,
      oldIn, // this.fileForm.controls.f_old.value,
      blockIn // this.fileForm.controls.f_blocks.value
    );

	// ------------ BLOQUES
	// Incorporar el uso de bloques si procede.
	if(blockIn) { // this.fileForm.controls.f_blocks.value) {

		console.log('->> Número de piezas para optimizar = ' + pieces_check);

		// console.log('->> simulateOptimization: se va a usar el método por BLOQUES.');

		// Primero se hacen conjuntos de piezas iguales para crear "marcos internos".
		// Para ello transforma la lista de entrada de piezas "pieceInfoList" de forma
		// que deja las "piezas marco" únicas y dentro en su campo "piece_set" el listado
		// de las piezas similares a la del marco (la pieza marco no se incluye aquí dentro).
		if (pieces_check <= 1000){
			this.opti.groupSimilarPieces(this.opti.pieceInfoList);
		} else {
			console.log('->> No se usarán bloques por incluir demasiadas piezas.');

			// Se devuelve la optimización sin datos resueltos.
			return result_simulation;
		}

	}
	// ------------ Fin Bloques

    // IMPORTANTE: Hay que dar tiempo a que se visualice el "icono de cargando..." antes de
    // lanzar el bucle "while" que va a paralizar el avance del código y causaría que no se viera.
    let auxaux = await this.myAsyncFunction();

    let total_graphicList = [];

	// --------------- ZONA MULTIPLE OPTIMIZACIÓN ------

	// La función bucleWhile se encarga de cortar las planchas con el
	// tamaño de las piezas cargadas en la optimización.
    let result = await this.bucleWhile(maxTraverseIn, false);
    console.log('->> simulateOptimization: se ha salido del bucleWhile:' + result);

    // Creamos "traveras X principales" que puedan reducir los niveles de corte
	// para que facilite la normativa de estructura de LISEC.
	// if (this.fileForm.controls.f_export.value === 'LSW')
	this.opti.createTraverseX();

	// Se ordenan aquí las hojas según las secuencias de las piezas que contienene.
	if (applySheetOrderForMath && !hasOefRowsForOrdering) {
		this.opti.sheetList = this.opti.orderSheetsBySequence(this.opti.sheetList, false);
	}

    // Dibujamos los gráficos resultantes de cada hoja usada en un mismo canvas.
    // let graphicList = this.opti.drawGraphics(this.fileForm.controls.f_origin.value);

    // Dibujamos cada hoja en un canvas diferente.
    total_graphicList = this.opti.drawGraphicsBySheet(Number(this.fileForm.controls.f_origin.value), this.fileForm.controls.f_export.value);
    this.mergeOefCentralFreeRectangles(total_graphicList);

    // --------------- FIN ZONA MULTIPLE OPTIMIZACIÓN ------

    // console.log('->> simulateOptimization -> listado de graficos graphicList - total_graphicList:');
    // console.log(total_graphicList);

    this.total_area_D = 0;
    this.total_area_B = 0;
    this.total_area_S = 0;
    this.total_area_X = 0;
    this.total_area_X_OEF = 0;
    this.total_area_T = 0;
    this.total_area_T_OEF_IN = 0;
    this.total_area_R = 0;
    this.total_area_P = 0;
    this.total_area_C = 0;
    this.total_area_J = 0;
    this.num_sheet = 0;

    this.cutTotalOrderList = [];
    this.level0TraverseList = [];

    this.opti_level_fault = false;

    // Se giran las últimas piezas de cola si existieran en alguna hoja.
    this.turnLastPiece(total_graphicList);

    // Se calcula el orden de tronzado y se actualiza la variable global correspondiente.
    this.getCutOrder(total_graphicList, true);

    // Se ordenan aquí las hojas según las secuencias de las piezas que contienene.
	if (applySheetOrderForStacks) {
		this.level0TraverseList = this.opti.orderTravXBySequence(this.level0TraverseList, total_graphicList, false);

		// Se vuelve a calcular el orden de tronzado pero ya con las traveras X reordenadas
		// (ahora el segundo parámetro está a false porque no hace falta incluir los retales).
	    this.getCutOrder(total_graphicList, false);
	}

    let apile_list = [];

    if (Number(modeIn) === 2 || Number(modeIn) === 3) {
      console.log('->> simulateOptimization: Optimizando en MODO2 o MODO3...');
      // Se organizan los caballetes según las piezas y su orden de tronzado.
      [this.opti.groupListMode2, this.opti.pieceInfoList, apile_list] = this.cutPieceToEasel(this.cutTotalOrderList, this.easelList, Number(modeIn));
	  // console.log('->> simulateOptimization: cutPieceToEasel apile_list = ');
	  // console.log(apile_list);
    } // End If f_mode
    // -------

    // console.log('-->> simulateOptimization local_pieceToEaselList:');
    // console.log(this.local_pieceToEaselList);

    let easel_list_count = 0;

    for (let prop in this.local_pieceToEaselList) {

      // console.log('-->> local_pieceToEaselList item:');
      // console.log(this.local_pieceToEaselList[prop]);

      if (this.local_pieceToEaselList[prop]) {
        easel_list_count++;
      }
    }

	    if (easel_list_count === 0) {
      //console.log('->> >> No hay caballetes adecuados disponibles para albergar las piezas de corte cargadas.');

      // this.alertInfo = 'No hay caballetes adecuados disponibles para albergar las piezas de corte cargadas.';
      // this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      // Se sale de la función cerrando antes la ventana de carga para que no blequee la aplicación.
      // this.changingLoading.emit(false);
	      return result_simulation;
	    }

    // Se calculan los datos de cada hoja una a una y se almacenan en este listado.
    let sheet_results = [];

    total_graphicList.forEach((h_graphic, index) => {

    	sheet_results.push(this.getOptimizationInfo(index, h_graphic, this.disband, blockIn, baseMaxSideIn, applySheetOrderForStacks, oldIn, modeIn, maxTraverseIn));

    });

    // console.log('->> ->> simulateOptimization sheet_results:');
    // console.log(sheet_results);

	let total_area_P = 0;
	let total_area_T = 0;
	let total_area_T_OEF_IN = 0;
	let total_area_B = 0;
	let total_area_X = 0;
	let total_area_X_OEF = 0;
	let total_area_R = 0;
	let total_area_S = 0;
	let total_area_J = 0;

	let num_pieces = 0;
	let num_retal = 0;
	let sheet_count = 0;

	let max_retal_area = 0;
	let max_free_rect_area = 0;
	let free_rect_count = 0;
	let oef_geometry_valid = true;

	sheet_results.forEach(re => {
		// console.log('->> result sheet:');
    	// console.log(re);

		if (re) {
			if (re.oef_geometry_valid === false) {
				oef_geometry_valid = false;
			}

			sheet_count += re.ns;

			num_pieces += re.np;

			num_retal += re.nr;

	    	// Area Neta: la suma de las areas de todas las piezas.
		    total_area_P += re.tn;

		    // Area de Resto: Suma de los metros cuadrados de las piezas de resto que se tiran a la basura.
		    // A esto hay que sumarle la cantidad desperdiciada en el desbande.
		    total_area_T += re.td; // this.total_area_D;
		    total_area_T_OEF_IN += re.td_oef_in ? re.td_oef_in : 0;

		    total_area_R += re.tr;

		    total_area_S += re.ts;

		    total_area_J += re.tj;

		    // Area Bruta: Se calcula sumando el área de cada una de las planchas utilizadas y restando el área de los retales detectados.
		    // Sería igual también al area de todas las piezas más el area desperdiciada, es decir, lo realmente gastado para siempre de cristal.
		    total_area_B += re.tb; // this.total_area_S - this.total_area_R;

		    if (max_retal_area < re.rm) max_retal_area = re.rm;
		    if (Number(re.oef_free_rect_area) > max_free_rect_area) {
		      max_free_rect_area = Number(re.oef_free_rect_area);
		    }
		    free_rect_count += Number(re.oef_free_rect_count) || 0;

		} // End IF re.
	});

	// Porcentaje de Merma: Porcentaje que representa sobre la "área bruta" la cantidad de m2 del "área del resto".
	total_area_X += (total_area_T * 100) / total_area_B;
	const oefBase = total_area_P + total_area_T_OEF_IN;
	total_area_X_OEF = oefBase > 0 ? (total_area_T_OEF_IN * 100) / oefBase : 0;

    result_simulation = {
		maxtrav: maxTraverseIn,
		ts: Number(Number(total_area_S).toFixed(2)),
		tb: Number(Number(total_area_B).toFixed(2)),
		tn: Number(Number(total_area_P).toFixed(2)),
		tr: Number(Number(total_area_R).toFixed(2)),
		td: Number(Number(total_area_T).toFixed(2)),
		td_oef_in: Number(Number(total_area_T_OEF_IN).toFixed(2)),
		tm: Number(Number(total_area_X).toFixed(2)),
		tm_oef: Number(Number(total_area_X_OEF).toFixed(2)),
		tj: Number(Number(total_area_J).toFixed(2)),
		np: num_pieces,
		nr: num_retal,
		ns: sheet_count,
		// Coeficiente rp => Retal/Pieza --> "suma metros retal aprovechable" / "número piezas retal aprovechable"
		rp: num_retal ? Number(Number(total_area_R / num_retal).toFixed(2)) : 0,
		rm: Number(max_retal_area.toFixed(2)),
		oef_free_rect_area: Number(max_free_rect_area.toFixed(4)),
		oef_free_rect_count: Math.max(0, Math.round(free_rect_count)),
		oef_geometry_valid: oef_geometry_valid,
		ne: apile_list.length,
		bl: blockIn,
		mb: baseMaxSideIn,
		os: applySheetOrderForStacks,
		re: oldIn,
		md: modeIn
	};

	// console.log('->> >> result_simulation: ');
	// console.log(result_simulation);

	return result_simulation;

  } // End function simulateOptimization.

  // -------------------------
  private mergeOefCentralFreeRectangles(totalGraphicListIn: any[]): void {
    const isCentral = (Array.isArray(this.oefRuntimeOptimizationList) ? this.oefRuntimeOptimizationList : [])
      .some(item => item && item.check === true && item.oef_layout_strategy === 'central_remainder');
    if (!isCentral || !Array.isArray(totalGraphicListIn)) return;

    const eps = 0.5;
    const boundsOf = (graphicIn: any): any => {
      const points = graphicIn && Array.isArray(graphicIn.points) ? graphicIn.points : [];
      const xs = points.map(p => Number(p && p.x)).filter(v => Number.isFinite(v));
      const ys = points.map(p => Number(p && p.y)).filter(v => Number.isFinite(v));
      if (!xs.length || !ys.length) return null;
      const bounds = {
        left: Math.min.apply(null, xs), right: Math.max.apply(null, xs),
        top: Math.min.apply(null, ys), bottom: Math.max.apply(null, ys)
      };
      return (bounds.right - bounds.left > eps && bounds.bottom - bounds.top > eps) ? bounds : null;
    };
    const updateRect = (graphicIn: any, boundsIn: any, suffixIn: string): any => {
      const graphic = graphicIn;
      graphic.width = Number((boundsIn.right - boundsIn.left).toFixed(2));
      graphic.height = Number((boundsIn.bottom - boundsIn.top).toFixed(2));
      graphic.area = Number(((graphic.width * graphic.height) / 1000000).toFixed(6));
      graphic.label = this.formatMmLabel(graphic.width, graphic.height);
      graphic.points = [
        { x: boundsIn.left, y: boundsIn.top },
        { x: boundsIn.left, y: boundsIn.bottom },
        { x: boundsIn.right, y: boundsIn.bottom },
        { x: boundsIn.right, y: boundsIn.top }
      ];
      graphic.origin_x = boundsIn.left;
      graphic.origin_y = boundsIn.top;
      graphic.name = (graphic.name || 'oef_central_free') + suffixIn;
      graphic.type = (
        Number(this.fileForm.controls.f_retal_width.value) <= graphic.width &&
        Number(this.fileForm.controls.f_retal_height.value) <= graphic.height
      ) ? 'R' : 'T';
      return graphic;
    };
    const sameValue = (aIn: any, bIn: any): boolean =>
      Number.isFinite(Number(aIn)) && Number.isFinite(Number(bIn)) &&
      Math.abs(Number(aIn) - Number(bIn)) <= eps;
    const traverseMatches = (traverseIn: any, entryIn: any): boolean => {
      if (!traverseIn || traverseIn.piece || !entryIn || !entryIn.bounds) return false;
      const bounds = entryIn.bounds;
      const geometryMatches =
        sameValue(traverseIn.origin_x, bounds.left) &&
        sameValue(traverseIn.origin_y, bounds.top) &&
        sameValue(Number(traverseIn.origin_x) + Number(traverseIn.width), bounds.right) &&
        sameValue(Number(traverseIn.origin_y) + Number(traverseIn.height), bounds.bottom);
      if (!geometryMatches) return false;
      const graphicName = entryIn.graphic && entryIn.graphic.name;
      const traverseName = traverseIn.draw && traverseIn.draw.name !== undefined
        ? traverseIn.draw.name
        : traverseIn.name;
      return graphicName === undefined || graphicName === null ||
        traverseName === undefined || traverseName === null ||
        graphicName.toString() === traverseName.toString();
    };
    const nextTraverseId = (): number => {
      let maxId = 0;
      const sheets = this.opti && Array.isArray(this.opti.sheetList) ? this.opti.sheetList : [];
      sheets.forEach(sheet => {
        (Array.isArray(sheet && sheet.traverses) ? sheet.traverses : []).forEach((traverse: any) => {
          const candidates = [traverse && traverse.id, traverse && traverse.num,
            traverse && traverse.draw && traverse.draw.id, traverse && traverse.draw && traverse.draw.num];
          candidates.forEach(value => {
            const numeric = Number(value);
            if (Number.isFinite(numeric) && numeric > maxId) maxId = numeric;
          });
        });
      });
      return Math.max(900000, Math.floor(maxId) + 1);
    };
    let generatedTraverseId = nextTraverseId();
    const updateTraverseRect = (traverseIn: any, graphicIn: any, boundsIn: any, idIn: number): any => {
      const traverse = traverseIn;
      const points = [
        { x: boundsIn.left, y: boundsIn.top },
        { x: boundsIn.left, y: boundsIn.bottom },
        { x: boundsIn.right, y: boundsIn.bottom },
        { x: boundsIn.right, y: boundsIn.top }
      ];
      const width = Number((boundsIn.right - boundsIn.left).toFixed(2));
      const height = Number((boundsIn.bottom - boundsIn.top).toFixed(2));
      const area = Number(((width * height) / 1000000).toFixed(6));
      traverse.id = idIn;
      traverse.num = idIn;
      traverse.name = graphicIn.name;
      traverse.width = width;
      traverse.height = height;
      traverse.origin_x = boundsIn.left;
      traverse.origin_y = boundsIn.top;
      traverse.points = JSON.parse(JSON.stringify(points));
      traverse.piece = null;
      traverse.used = false;
      if (!traverse.draw) traverse.draw = {};
      traverse.draw.id = idIn;
      traverse.draw.num = idIn;
      traverse.draw.name = graphicIn.name;
      traverse.draw.width = width;
      traverse.draw.height = height;
      traverse.draw.area = area;
      traverse.draw.label = this.formatMmLabel(width, height);
      traverse.draw.type = graphicIn.type;
      traverse.draw.points = JSON.parse(JSON.stringify(points));
      traverse.draw.sheet_id = graphicIn.sheet_id;
      graphicIn.id = idIn;
      graphicIn.num = idIn;
      return traverse;
    };
    const syncTraverseMerge = (upperIn: any, lowerIn: any, narrowIn: any, wideIn: any,
      mergedIn: any, leftoversIn: any[]): void => {
      const sheetId = mergedIn && mergedIn.sheet_id;
      const sheets = this.opti && Array.isArray(this.opti.sheetList) ? this.opti.sheetList : [];
      const sheet = sheets.find(item => item && item.id != null && sheetId != null &&
        item.id.toString() === sheetId.toString());
      if (!sheet || !Array.isArray(sheet.traverses)) return;

      const upperTraverse = sheet.traverses.find(item => traverseMatches(item, upperIn));
      const lowerTraverse = sheet.traverses.find(item => item !== upperTraverse && traverseMatches(item, lowerIn));
      if (!upperTraverse || !lowerTraverse) return;
      const narrowTraverse = narrowIn === upperIn ? upperTraverse : lowerTraverse;
      const wideTraverse = wideIn === upperIn ? upperTraverse : lowerTraverse;
      const mergedBounds = boundsOf(mergedIn);
      if (!mergedBounds) return;

      const replacement = [];
      replacement.push(updateTraverseRect(
        JSON.parse(JSON.stringify(narrowTraverse)), mergedIn, mergedBounds,
        Number.isFinite(Number(narrowTraverse.id)) ? Number(narrowTraverse.id) : generatedTraverseId++
      ));
      leftoversIn.forEach((leftover, index) => {
        const leftoverBounds = boundsOf(leftover);
        if (!leftoverBounds) return;
        const reuseWideId = index === 0 && Number.isFinite(Number(wideTraverse.id));
        replacement.push(updateTraverseRect(
          JSON.parse(JSON.stringify(wideTraverse)), leftover, leftoverBounds,
          reuseWideId ? Number(wideTraverse.id) : generatedTraverseId++
        ));
      });
      sheet.traverses = sheet.traverses.filter(item => item !== upperTraverse && item !== lowerTraverse);
      replacement.forEach(item => sheet.traverses.push(item));
    };

    totalGraphicListIn.forEach((sheetGraphics: any[]) => {
      if (!Array.isArray(sheetGraphics)) return;
      let mergeCount = 0;
      while (mergeCount < 20) {
        const freeItems = sheetGraphics
          .map((graphic, index) => ({ graphic: graphic, index: index, bounds: boundsOf(graphic) }))
          .filter(entry =>
            entry.bounds &&
            entry.graphic &&
            (entry.graphic.type === 'T' || entry.graphic.type === 'R') &&
            // La pasada general de facilidad de tronzado es la decisión final.
            // No permitir que la estrategia histórica de retal central vuelva
            // a partir esos mismos restos y reconstruya su geometría anterior.
            entry.graphic.remainder_cut_ease_locked !== true
          );
        let best = null;
        freeItems.forEach((a, ai) => freeItems.slice(ai + 1).forEach(b => {
          let upper = a;
          let lower = b;
          if (Math.abs(Number(b.bounds.bottom) - Number(a.bounds.top)) <= eps) {
            upper = b;
            lower = a;
          } else if (Math.abs(Number(a.bounds.bottom) - Number(b.bounds.top)) > eps) {
            return;
          }
          const left = Math.max(Number(upper.bounds.left), Number(lower.bounds.left));
          const right = Math.min(Number(upper.bounds.right), Number(lower.bounds.right));
          const width = right - left;
          const upperWidth = Number(upper.bounds.right) - Number(upper.bounds.left);
          const lowerWidth = Number(lower.bounds.right) - Number(lower.bounds.left);
          if (width <= eps || Math.abs(width - Math.min(upperWidth, lowerWidth)) > eps) return;
          const mergedArea = width * (Number(lower.bounds.bottom) - Number(upper.bounds.top));
          const previousMax = Math.max(
            upperWidth * (Number(upper.bounds.bottom) - Number(upper.bounds.top)),
            lowerWidth * (Number(lower.bounds.bottom) - Number(lower.bounds.top))
          );
          const gain = mergedArea - previousMax;
          if (gain > eps && (!best || gain > best.gain)) {
            best = { upper: upper, lower: lower, left: left, right: right, gain: gain };
          }
        }));
        if (!best) break;

        const upper = best.upper;
        const lower = best.lower;
        const upperWidth = Number(upper.bounds.right) - Number(upper.bounds.left);
        const lowerWidth = Number(lower.bounds.right) - Number(lower.bounds.left);
        const narrow = upperWidth <= lowerWidth ? upper : lower;
        const wide = narrow === upper ? lower : upper;
        const merged = updateRect(JSON.parse(JSON.stringify(narrow.graphic)), {
          left: best.left, right: best.right,
          top: Number(upper.bounds.top), bottom: Number(lower.bounds.bottom)
        }, '_central');
        const leftovers = [];
        if (Number(wide.bounds.left) < best.left - eps) {
          leftovers.push(updateRect(JSON.parse(JSON.stringify(wide.graphic)), {
            left: Number(wide.bounds.left), right: best.left,
            top: Number(wide.bounds.top), bottom: Number(wide.bounds.bottom)
          }, '_left'));
        }
        if (Number(wide.bounds.right) > best.right + eps) {
          leftovers.push(updateRect(JSON.parse(JSON.stringify(wide.graphic)), {
            left: best.right, right: Number(wide.bounds.right),
            top: Number(wide.bounds.top), bottom: Number(wide.bounds.bottom)
          }, '_right'));
        }
        syncTraverseMerge(upper, lower, narrow, wide, merged, leftovers);
        [Number(upper.index), Number(lower.index)]
          .sort((a, b) => b - a)
          .forEach(index => sheetGraphics.splice(index, 1));
        sheetGraphics.push(merged);
        leftovers.forEach(item => sheetGraphics.push(item));
        mergeCount++;
      }
    });
  }

  // -------------------------
  //	CREAR PIEZA DE COLA
  // -------------------------
  createTail(totaGraphicListIn: any) {

	console.log(' -> Entrando en createTail...');

	// Los nuevos retales tomarán este valor como número de partida para su ID.
	let id_new_retal = 99999;

    // Se recorren los gráficos para buscar "piezas de cola".
    // Se girarán para crear un mayor retal de cola.
    totaGraphicListIn.forEach((h_graphic, hg_index) => {

		// console.log(' -> Vuelta 1: h_graphic index ' + hg_index);
	  	// console.log(h_graphic);

		let sheet_graphic = null;

		// El elemento cero es el gráfico del marco de la hoja.
		if (h_graphic && h_graphic[0]) {
			sheet_graphic = h_graphic[0];
		}

		// console.log(' -> Vuelta 1: Hoja ' + hg_index);
		// console.log(sheet_graphic);

		let tail_list = [];

		h_graphic.forEach((elem, ind_elem) => {

			if (ind_elem !== 0) {

				if (elem.points[2].x + this.disband.right === sheet_graphic.points[2].x) {
					// console.log(' -> Vuelta 1: Encontrado retal extremo derecho.');
					tail_list.push(elem);
				}

			} // End IF ind_elem !== 0.

		}); // End ForEach h_graphic.

		// console.log('-> tail_list: ');
		// console.log(tail_list);

		// Hay que comprobar que todas sean retales (no piezas).
		tail_list = tail_list.filter(ret => ret.type !== 'P');

		// Se escoge el retal más estrecho que será el que marque
		// el ancho del nuevo "retal de cola".
		let new_tail = null;

		tail_list.forEach((ret, ind_ret) => {

			if (ind_ret === 0) {

				new_tail = ret;

			} else {

				if (ret.width < new_tail.width) {
					new_tail = ret;
				}
			}
		});

		// console.log('-> new_tail: ');
		// console.log(new_tail);

		if (new_tail) {

			let new_retal = null;

			let cut_ok = true;

			let increase = 0;

			// Primera vuelta para ver si se incumple "tronzado mínimo".
			// El resto de retales se transforman restándoles el ancho de la cola.
			tail_list.forEach((ret, ind_ret) => {

				if (ret.name !== new_tail.name) {

					let width_aux = ret.width - new_tail.width;

					if (width_aux < this.fileForm.controls.f_diecutting.value) {
						// console.log('-> Al recortar el retal no cumple la condición de mínimo tronzado.');

						// Entonces se va a intentar estrechar la cola para ampliar el retal.
						let increase_aux = this.fileForm.controls.f_diecutting.value - width_aux;

						// Hay que comprobar si se le puede quitar a la cola esa distancia.
						if (new_tail.width - increase_aux >= 0) {

							// Sólo se guarda la distancia de incremento de
							// recorte si supera a la que ya había definida.
							if (increase_aux > increase) increase = increase_aux;

							console.log('-> Se va a necesitar recortar la cola. Ancho recortado = ' + increase);
						} else {

							console.log('-> No se puede recortar la cola la distancia necesaria: ' + increase_aux);
							cut_ok = false;
						}
					}
				}
			});

			if (cut_ok) {

				// Si hay incremento hay que crear un nuevo retal nacido
				// de separar el retal de cola de la pieza adyacente.
				if (increase) {

					// Se crea retal con un ancho igual a la distancia mínima de tronzado.
					// Esa misma distancia se le sumará al ancho del resto de retales.
					// Se crea una copia del candidato a "retal de cola".
					new_retal = JSON.parse(JSON.stringify(new_tail));

					// Se varía el nombre para diferenciarlo de su retal origen.
					new_retal.name += '_new';

					// Se le crea un nuevo ID de retal partiendo de otra numeración
					// para intentar que no coincida con posibles IDs de otros retales.
					// Este identificador es esencial para poder exportar bien a V40.
					// Hay que asignarlo al campo "num" también.
					new_retal.id = new_retal.num = id_new_retal - new_tail.num;

					new_retal.width = this.fileForm.controls.f_diecutting.value;

					new_retal.points[2].x = new_retal.points[0].x + this.fileForm.controls.f_diecutting.value;
					new_retal.points[3].x = new_retal.points[0].x + this.fileForm.controls.f_diecutting.value;

					new_retal.label = this.formatMmLabel(new_retal.width, new_retal.height);

					if (this.fileForm.controls.f_retal_width.value <= new_retal.width &&
						this.fileForm.controls.f_retal_height.value <= new_retal.height) {

						// Cumple las dimensiones de un retal.
						new_retal.type = 'R';

					} else {
						// El trozo obtenido no es aprovechable para convertirlo en un retal.
						new_retal.type = 'T';
					}

					// Se añade al gráfico de la hoja.
					h_graphic.push(new_retal);

					// ---- Retal de cola

					// Se recorta la cola y con eso se aumentan los retales
					// de modo que cumplirán la condición mínima de tonzado.
					new_tail.width -= increase;

					new_tail.points[0].x += this.fileForm.controls.f_diecutting.value;
					new_tail.points[1].x += this.fileForm.controls.f_diecutting.value;

					// Se crea retal con un ancho de la distancia mínima de tronzado.
					// Esa misma distancia se le sumará al ancho del resto de retales.

				} // End If increase.

				// Si hay candidato para retal de cola entonces se
				// transforman sus dimensiones (alto igual a alto de hoja).
				new_tail.points[0].y = sheet_graphic.points[0].y;
				new_tail.points[1].y = sheet_graphic.points[1].y;
				new_tail.points[2].y = sheet_graphic.points[2].y;
				new_tail.points[3].y = sheet_graphic.points[3].y;

				new_tail.width = new_tail.points[3].x - new_tail.points[0].x;
				new_tail.height = new_tail.points[1].y - new_tail.points[0].y;
				new_tail.area = Number((new_tail.width * new_tail.height) / 1000000);

				new_tail.label = this.formatMmLabel(new_tail.width, new_tail.height);

				if (this.fileForm.controls.f_retal_width.value <= new_tail.width &&
					this.fileForm.controls.f_retal_height.value <= new_tail.height) {

					// Cumple las dimensiones de un retal.
					new_tail.type = 'R';

				} else {
					// El trozo obtenido no es aprovechable para convertirlo en un retal.
					new_tail.type = 'T';
				}
				// ----
				// El resto de retales se transforman restándoles el ancho de la cola.
				tail_list.forEach((ret, ind_ret) => {

					if (ret.name !== new_tail.name) {

						ret.points[2].x -= new_tail.width;
						ret.points[3].x -= new_tail.width;

						ret.width = ret.points[3].x - ret.points[0].x;
						ret.height = ret.points[1].y - ret.points[0].y;
						ret.area = Number((ret.width * ret.height) / 1000000);

						ret.label = this.formatMmLabel(ret.width, ret.height);

						if (this.fileForm.controls.f_retal_width.value <= ret.width &&
							this.fileForm.controls.f_retal_height.value <= ret.height) {

							// Cumple las dimensiones de un retal.
							ret.type = 'R';

						} else {
							// El trozo obtenido no es aprovechable para convertirlo en un retal.
							ret.type = 'T';
						}
					} // End If name.
				});
			} // End If cut_ok.

			// Se añade también al listado de retales tratados.
			if (new_retal) tail_list.push(new_retal);

		} // End If new_tail.

		// ---------------------------------------------
		// MODIFICACIÓN también en la ESTRUCTURA GENERAL
		// ---------------------------------------------
		// Buscamos esos elementos en la estructura general que guarda la
		// información de la hoja y modificamos ahí también su cambios.

		// let last_sheet = this.opti.sheetList[this.opti.sheetList.length -1];
		let last_sheet = this.opti.sheetList.find(sh_in => sh_in.id === new_tail.sheet_id);

		// console.log(' -> last_sheet = ');
		// console.log(last_sheet);

		if (last_sheet && last_sheet.traverses) {

			let find_retal_tail = last_sheet.traverses.find(tr => tr.draw.name === new_tail.name);

			// Se hace una copia del retal de cola antes de que se modifique.
			let new_retal = JSON.parse(JSON.stringify(find_retal_tail));

			tail_list.forEach((ret, ind_ret) => {

				let find_retal = last_sheet.traverses.find(tr => tr.draw.name === ret.name);

				if (find_retal) {
					console.log(' -> Encontrado retal recortado en estructura general = ');
					console.log(find_retal);

					find_retal.width = ret.width;
					find_retal.height = ret.height;
					// find_retal.draw.rotation = ret.rotation;
					// find_retal.draw.points = ret.points;
					find_retal.points = ret.points;
					find_retal.origin_x = ret.points[0].x;
					find_retal.origin_y = ret.points[0].y;

				} else {
					// Es un retal creado ahora.
					console.log(' -> Nuevo retal recortado para añadir en estructura general = ');
					console.log(ret);

					// console.log(' -> Nuevo retal usado de base:');
					// console.log(JSON.parse(JSON.stringify(new_retal)));

					new_retal.id = new_retal.draw.id = ret.id;
					new_retal.num = new_retal.draw.num = ret.num;
					new_retal.name = new_retal.draw.name = ret.name;
					new_retal.width = new_retal.draw.width = ret.width;
					new_retal.height = new_retal.draw.height = ret.height;

					new_retal.draw.label = this.formatMmLabel(ret.width, ret.height);
					new_retal.points = new_retal.draw.points = ret.points;
					new_retal.origin_x = ret.points[0].x;
					new_retal.origin_y = ret.points[0].y;

					// Se añade el nuevo retal a la lista de traveras de la hoja.
					last_sheet.traverses.push(new_retal);

					// console.log(' -> Nuevo retal transformado para estructura general:');
					// console.log(JSON.parse(JSON.stringify(new_retal)));

				} // End Else find_retal.

			}); // End Foreach tail_list.
		} // End If last_sheet.
	}); // End Foreach totaGraphicListIn.
  } // End function createTail.

  // -------------------------
  //  GIRAR ÚLTIMA PIEZA COLA
  // -------------------------
  turnLastPiece(totaGraphicListIn: any) {

	console.log(' -> Entrando en turnLastPiece...');

    // Se recorren los gráficos para buscar "piezas de cola"
    // que estén tumbadas. Se girarán para crear un mayor retal de cola.
    totaGraphicListIn.forEach((h_graphic, hg_index) => {

		// console.log(' -> Vuelta 1: h_graphic index ' + hg_index);
	  	// console.log(h_graphic);

		let sheet_graphic = null;

		// El elemento cero es el gráfico del marco de la hoja.
		if (h_graphic && h_graphic[0]) {
			sheet_graphic = h_graphic[0];
		}

		// console.log(' -> Vuelta 1: Hoja ' + hg_index);
		// console.log(sheet_graphic);

		let tail = null;

		h_graphic.forEach(elem => {

			if (elem.height === sheet_graphic.height - this.disband.top - this.disband.bottom) {
				// console.log(' -> Vuelta 1: Encontrado retal de cola.');

				tail = elem;
			}

		}); // End ForEach h_graphic.

		let ady_pieces = [];

		if (tail) {

			// Guardamos el elemento de cola de la hoja tratada.
			h_graphic['tail'] = tail;

			h_graphic.forEach(elem => {

				if (elem.points[3].x === tail.points[0].x)
					ady_pieces.push(elem);

			}); // End ForEach h_graphic.
		}

		// console.log(' -> Vuelta 1: Adyacentes al retal de cola:');
		// console.log(ady_pieces);

		let retal_tail = null;
		let piece_tail = null;

		if (ady_pieces.length === 2) {

			retal_tail = ady_pieces.find(ob => ob.type !== 'P');
			piece_tail = ady_pieces.find(ob => ob.type === 'P');
		}

		// El giro histórico de la pieza de cola solo actualiza el rectángulo
		// exterior. En un primitivo OEF dejaría los polígonos internos en la
		// orientación anterior y crearía un retal superpuesto a toda la hoja.
		const pieceTailIsOefComposite = !!(piece_tail && this.isOefCompositeItem(piece_tail));
		if (tail && retal_tail && piece_tail && !pieceTailIsOefComposite && piece_tail.width > piece_tail.height &&
			piece_tail.width <= sheet_graphic.height - this.disband.top - this.disband.bottom &&
			// Deben coincidir en la X de origen porque si no habría que crear y añadir un nuevo retal.
			retal_tail.points[0].x === piece_tail.points[0].x) {
			// console.log(' -> Encontrada pieza de cola para voltear =');
			// console.log(piece_tail);

			let turn_ok = true;

			let points_piece_aux = JSON.parse(JSON.stringify(piece_tail.points));
			let points_retal_aux = JSON.parse(JSON.stringify(retal_tail.points));

			// Se gira la pieza y se transforman las dimensiones de los otros dos elementos.
			this.opti.turnPiece(piece_tail,'width', 'height', 'rotation');

			piece_tail.label = this.formatMmLabel(piece_tail.width, piece_tail.height);

			// piece_tail.points[0] = El punto cero no cambia, es el origen de la pieza;
			piece_tail.points[1].y = piece_tail.points[0].y + piece_tail.height;
			piece_tail.points[2].x = piece_tail.points[0].x + piece_tail.width;
			piece_tail.points[2].y = piece_tail.points[1].y;
			piece_tail.points[3].x = piece_tail.points[2].x;
			piece_tail.points[3].y = piece_tail.points[0].y;

			retal_tail.points[0].x = piece_tail.points[1].x;
			retal_tail.points[0].y = piece_tail.points[1].y;
			// retal_tail.points[1] = El punto uno no cambia.
			retal_tail.points[2].x = piece_tail.points[3].x;
			retal_tail.points[3].x = piece_tail.points[2].x;
			retal_tail.points[3].y = piece_tail.points[2].y;

			// Si el nuevo retal no cumple la distancia mínima de tronzado
			// entonces hay que volver a dejar los valores como estaban.
			if (retal_tail.points[1].y - retal_tail.points[0].y < this.fileForm.controls.f_diecutting.value) {
				console.log('-> Al girar la pieza de cola no cumple la condición de mínimo tronzado.');

				turn_ok = false;

				// Se gira la pieza y se transforman las dimensiones de los otros dos elementos.
				this.opti.turnPiece(piece_tail,'width', 'height', 'rotation');

				piece_tail.label = this.formatMmLabel(piece_tail.width, piece_tail.height);

				piece_tail.points = points_piece_aux;

				retal_tail.points = points_retal_aux;
			}

			// Si tras girar se cumplen las condiciones entonces se continúa
			// modificando el resto de elementos afectados por el giro.
			if (turn_ok) {

				retal_tail.width = retal_tail.points[3].x - retal_tail.points[0].x;
				retal_tail.height = retal_tail.points[1].y - retal_tail.points[0].y;
				retal_tail.area = Number((retal_tail.width * retal_tail.height) / 1000000);

				retal_tail.label = this.formatMmLabel(retal_tail.width, retal_tail.height);

				if (this.fileForm.controls.f_retal_width.value <= retal_tail.width &&
					this.fileForm.controls.f_retal_height.value <= retal_tail.height) {

					// Cumple las dimensiones de un retal.
					retal_tail.type = 'R';

				} else {
					// El trozo obtenido no es aprovechable para convertirlo en un retal.
					retal_tail.type = 'T';
				}

				tail.points[0].x = retal_tail.points[3].x;
				tail.points[1].x = retal_tail.points[3].x;

				tail.width = tail.points[3].x - tail.points[0].x;
				tail.height = tail.points[1].y - tail.points[0].y;
				tail.area = Number((tail.width * tail.height) / 1000000);

				tail.label = this.formatMmLabel(tail.width, tail.height);

				if (this.fileForm.controls.f_retal_width.value <= tail.width &&
					this.fileForm.controls.f_retal_height.value <= tail.height) {

					// Cumple las dimensiones de un retal.
					tail.type = 'R';

				} else {
					// El trozo obtenido no es aprovechable para convertirlo en un retal.
					tail.type = 'T';
				}

				// -------------------------------------------
				// MODIFICACIÓN DEL GIRO EN ESTRUCTURA GENERAL
				// -------------------------------------------
				// Buscamos esos elementos en la estructura general que guarda la
				// información de la hoja y modificamos ahí también su colocación.

				// let last_sheet = this.opti.sheetList[this.opti.sheetList.length -1];
				let last_sheet = this.opti.sheetList.find(sh_in => sh_in.id === piece_tail.sheet_id);

				// console.log(' -> last_sheet = ');
				// console.log(last_sheet);

				let find_piece_tail = null;

				if (last_sheet && last_sheet.pieces) {

					find_piece_tail = last_sheet.pieces.find(p => p.piece.piece_name_id === piece_tail.name_id);

					if (find_piece_tail) {
						// console.log(' -> Encontrada pieza de cola en estructura general = ');
						// console.log(find_piece_tail);

						find_piece_tail.piece.piece_width = piece_tail.width;
						find_piece_tail.piece.piece_height = piece_tail.height;
						find_piece_tail.piece.piece_rotation = piece_tail.rotation;
						find_piece_tail.piece.points = piece_tail.points;
						find_piece_tail.origin_x = piece_tail.points[0].x;
						find_piece_tail.origin_y = piece_tail.points[0].y;
					}

					let find_retal_tail = last_sheet.traverses.find(tr => tr.draw.name === retal_tail.name);

					if (find_retal_tail) {
						// console.log(' -> Encontrado retal adyacente a cola en estructura general = ');
						// console.log(find_retal_tail);

						find_retal_tail.width = retal_tail.width;
						find_retal_tail.height = retal_tail.height;
						// find_retal_tail.draw.rotation = retal_tail.rotation;
						// find_retal_tail.draw.points = retal_tail.points;
						find_retal_tail.points = retal_tail.points;
						find_retal_tail.origin_x = retal_tail.points[0].x;
						find_retal_tail.origin_y = retal_tail.points[0].y;
					}

					let find_tail = last_sheet.traverses.find(tr => tr.draw.name === tail.name);

					if (find_tail) {
						// console.log(' -> Encontrado retal de cola en estructura general = ');
						// console.log(find_tail);

						find_tail.width = tail.width;
						find_tail.height = tail.height;
						// find_tail.draw.rotation = tail.rotation;
						// find_tail.draw.points = tail.points;
						find_tail.points = tail.points;
						find_tail.origin_x = tail.points[0].x;
						find_tail.origin_y = tail.points[0].y;
					}

				} // End If last_sheet.
			} // End If turn_ok.
		}
	});

  } // End function turnLastPiece.

  // Función que calcula el orden de tronzado y actualiza las variables globales correspondientes.
  getCutOrder(totalGraphicListIn: any, include_retal: boolean) {

	console.log(' -> Entrando en getCutOrder...');

	// Se inicializa el total de piezas a tronzar.
	this.cutTotalOrderList = [];

		// Se da una vuelta a los gráficos para poder sacar el "orden de tronzado" correcto.
    totalGraphicListIn.forEach((h_graphic, index1) => {

      // let cutOrderList = JSON.parse(JSON.stringify(h_graphic));
      let cutOrderList = h_graphic;

      // console.log(' -> cutOrderList h_graphic index ' + index1);
	  // console.log(cutOrderList);

	  let sheet_aux = null;

	  // El elemento cero es el gráfico del marco de la hoja.
	  if (cutOrderList && cutOrderList[0]) {
		sheet_aux = cutOrderList[0];
	  }

	  // console.log(' -> cutOrderList sheet_aux: ');
	  // console.log(sheet_aux);

      let traverse0List = [];
      let traverse1List = [];
      // let traverse2List = [];
      let sheet_level_fault = null;

	  // Para usar la última versión mejorada de "estructura de niveles".
      // [cutOrderList, traverse0List, traverse1List, sheet_level_fault] = this.opti.orderPiecesLevel(cutOrderList, false);
      [cutOrderList, traverse0List, traverse1List, sheet_level_fault] = this.opti.orderPiecesFreeGrade(cutOrderList, Number(this.fileForm.controls.f_free.value), Number(this.fileForm.controls.f_free_in.value), false);

	  // Para usar la primera versión de "estructura de niveles".
      // [cutOrderList, traverse0List, traverse1List, sheet_level_fault] = this.opti.orderPiecesByCut(cutOrderList, false);

      // Para usar la versión que genera un "orden de corte" recorriendo las piezas de arriba hacia abajo y de izquierda a derecha.
      // NOTA: Al final esta versión no es útil porque los caballetes salen ordenados de forma
      // que las secuencias con menor número están al fondo, y eso no interesa.
      // [cutOrderList, traverse0List, traverse1List, sheet_level_fault] = this.opti.cutOrderTopDownLeftRight(cutOrderList, false);

	  // console.log(' -> cutOrderList después de orderPiecesByCut: ');
	  // console.log(cutOrderList);

	  if (cutOrderList && traverse0List) {
	      // Si no se quiere tener en cuenta algún tipo concreto de elemento, como las planchas.
	      cutOrderList = cutOrderList.filter(p => p.type !== 'S');

	      // console.log(' -> cutOrderList index ' + index1);
	      // console.log(cutOrderList);

	      // console.log(' -> traverse0List ' + index1);
	      // console.log(traverse0List);

	      // console.log(' -> traverse1List ' + index1);
	      // console.log(traverse1List);

	      // console.log(' -> level_fault ' + index1);
	      // console.log(sheet_level_fault);

	      this.max_travera = this.fileForm.controls.f_max_diecutting.value;

	      if (sheet_level_fault) {
	        this.opti_level_fault = true;
	      }

	      // Añadimos todas las piezas de esta hoja al total de piezas a tronzar.
	      cutOrderList.forEach((p, index2) => {
			// console.log(' -> cutOrderList p cut_order = ' + (index2 + 1));
	        // console.log(p.name);
	        // console.log(p.label);
	        p['cut_order'] = index2 + 1;
	        this.cutTotalOrderList.push(p);
	      });

		      let traverses_aux = [];

		      // IMPORTANTE LSW:
		      // La estructura `level0TraverseList` es el contrato que consume backend `optimization_LSW2.js`.
		      // - `tr_coordinates`: coordenadas transformadas al origen activo.
		      // - `tr_pieces`: piezas/retales de la travera X.
		      // - `sub_tr`: estructura de niveles asociada (traveras Y / cortes internos).
		      // Cualquier cambio aquí impacta directamente en TRA1/TRA2/TRA3/TRA4.
		      traverse0List.forEach((t, index3) => {
		        if (t.pieces && t.pieces.length > 0) {

				  if (!include_retal) {

					// Sólo se escogen las piezas, no los retales y restos.
		            // Sí se cogería también el retal/resto si es de "cola".
		            traverses_aux = t.pieces.filter(p =>
		              p.type === 'P' || ((p.type === 'T' || p.type === 'R') &&
		              //index3 === traverse0List.length - 1 &&
		              t.pieces.length === 1)
		            );
				  } else {
					// Sólo se escogen las piezas, no los retales y restos.
		             // Sí se cogería también el retal/resto si es de "cola".
		            traverses_aux = t.pieces;
				  }
		        }

		        // Compatibilidad de cargas históricas:
		        // en ciertas reconstrucciones `opti.nextSheet` llega vacío; usamos `sheet_aux` como respaldo.
		        const origin_sheet = this.opti.nextSheet || sheet_aux;
		        if (traverses_aux.length > 0 && origin_sheet) {

		          if (!this.level0TraverseList['sheet_' + index1]) {
		            this.level0TraverseList['sheet_' + index1] = [];
		          }

		          // Se aplica a las coordenadas las transformaciones para adaptarlo al punto de origen actual.
		          this.opti.changeOriginPoint(t.coordinates, origin_sheet.width, origin_sheet.height, this.disband, this.fileForm.controls.f_origin.value);

    		  let index_final = index3;

    		  // NOTA CRÍTICA:
    		  // Se invierte el índice para formatos CNC (incluyendo LSW) porque backend
    		  // reconstruye traveras X en orden inverso durante TRA1 (`sh.reverse()`).
    		  // Si este emparejado se rompe, aparecen colas inválidas y el simulador rechaza.
    		  // NOTA: Se invierte el valor del índice para el formato 'BTR'
    		  // para que cuadre la información de las subtraveras "sub_tr"
    		  // con las piezas "tr_pieces" y las coordenadas "tr_coordinates"
    		  // cuando se use la información para la exportación en el servidor.
    		  if (this.fileForm.controls.f_export.value === 'BTR'
    		  	  || this.fileForm.controls.f_export.value === 'OTD'
    		  	  || this.fileForm.controls.f_export.value === 'ELO'
    		  	  || this.fileForm.controls.f_export.value === 'LSW'
    		  	  || this.fileForm.controls.f_export.value === 'LIOPT'
    		  	  || this.fileForm.controls.f_export.value === 'V40'
    		  ) {

				index_final = traverse0List.length - (index3 + 1);
			  }

			  // console.log(' -> cutOrderList sub_tr: traverse1List >> index_final = ' + index_final);
	          // console.log(traverse1List[index_final]);

					  // En metadatos de hoja priorizamos `sheet_aux` (marco gráfico original).
					  // Si no está disponible, se usa `origin_sheet`.
					  const meta_sheet = sheet_aux || origin_sheet;
				  this.level0TraverseList['sheet_' + index1].push({ sheet_width: meta_sheet.width,
				  													sheet_height: meta_sheet.height,
				  													sheet_depth: meta_sheet.depth,
				  													mat_id: meta_sheet.mat_id,
				  													mat_desc: meta_sheet.mat_desc,
			  													disband: this.disband,
			  													origin: Number(this.fileForm.controls.f_origin.value),
	        													tr_pieces: traverses_aux,
																tr_coordinates: t.coordinates,
																sub_tr: traverse1List[index_final],
																axis: this.fileForm.controls.f_axis.value});

	        } // End If traverses_aux.length.
	      }); // End Foreach traverse0List.

	   } // End If cutOrderList.
    }); // End Foreach totalGraphicListIn.
  } // End function getCutOrder.

  // Función que renderiza el contenido de toda la optimización dibujando hoja por hoja.
  renderSheet(totalGraphicListIn: any, infoDataPieceIn: any) {

	console.log(' -> Entrando en renderSheet...');

	// Se da una tercera vuelta para dibujar el contenido de cada hoja.
	// Almacena en el segundo parámetro todas las piezas y retales aprovechables.
    totalGraphicListIn.forEach((h_graphic, index) => {

	  // Se dibujan y se calculan los datos resultantes para cada hoja. Además
	  // los va sumando para obtener los globales de toda la optimización.
      let h_result = this.drawSheetCanvas(
        index,
        this.canvas,
        this.graphic_container,
        h_graphic,
        this.disband,
        this.fileForm.controls.f_axis.value,
        totalGraphicListIn.length,
        Number(this.fileForm.controls.f_origin.value)
      );

	  // console.log('-->> buttonStartOptimization drawSheetCanvas h_result:');
      // console.log(h_result);

      // Sólo se añade la hoja si contiene algún tipo de dato.
      // Si no es que estará vacía (no se ha incluido nada dentro).
      if (h_result && h_result.tb && h_result.tb >= 0) {
        this.total_sheet_results.push(h_result);
      }

      // Sólo se quieren almacenar la información de piezas y también de los retales aprovechables.
      h_graphic.forEach(pz => {
        if (pz.type === 'P' || pz.type === 'R') {

         	// Marcamos que se trata de un retal.
			if (pz.type === 'R')  pz['reference'] = 'retal';

			infoDataPieceIn.push(pz);
        }
      });
    }); // End totalGraphicListIn.

  } // End renderSheet.

  // ------------------------

  // Función que dibuja una hoja y los puntos (pasados como tercer pármetro) usando como plantilla
  // un canvas pasado como primer parámetro y añadiéndolo como hijo a un "div" pasado como segundo parámetro.
  // También calcula los datos informativos de la hoja (area bruta, neta, merma, etc.).
  drawSheetCanvas(indexIn: number, canvasIn: any, containerIn: any, graphicListIn: any, disbandIn: any, axisIn: string, totalNumSheets: number, originIn: number): any {

    // console.log('--> drawSheetCanvas:' + this.num_sheet + ' ;index = ' + indexIn);
    // console.log(graphicListIn);

    // Se evita dibujar cualquier hoja que llegue vacía (sin piezas asignadas dentro).
    if (graphicListIn === null || graphicListIn === undefined || graphicListIn.length === 0) {
      // console.log('--> drawSheetCanvas: No existen piezas asignadas a esta hoja.');
      return;
    }

    let tail_area = 0;
    let tail_num = 0;

    // Area del retal de cola (sea aprovechable o no).
    if (graphicListIn['tail'] && graphicListIn['tail'].area) {

		tail_area = graphicListIn['tail'].area;
		tail_num = graphicListIn['tail'].num;
	}

    let disband_area = 0;

    // Se clona una nueva "gráfica canvas" donde dibujar.
    let new_canvas = canvasIn.cloneNode('canvasGraphic' + this.num_sheet);

    // Se clona una nueva "celda del carrusel" .
    // let new_carousel_cell = carouselCellIn.cloneNode('carouselCell' + this.graphic_carousel_cell);

    let label_width = 90; // Ancho mínimo de etiqueta que contiene las medidas de una pieza.
    let label_height = 40; // Alto mínimo de etiqueta que contiene las medidas de una pieza.
    let zoom = this.fileForm.controls.f_zoom.value; // Zoom que se va a usar para el dibujo;
    let sheet_count = 0;
    let h_separation = 74; // 200;
    let w_separation = 50;
    let y_plus = h_separation;
    let x_plus = w_separation;
    let last_width = 0;
    let last_height = 0;
    let max_width = 0;

    let ts = 0; // Total area hoja (sheet).
    let tb = 0; // Total area bruta.
    let tn = 0; // Total area neta.
    let tr = 0; // Total area retal.
    let td = 0; // Total area desperdicio.
    let td_oef_in = 0; // Desperdicio interno de primitivas OEF.
    let tm = 0; // Total merma tanto por ciento.
    let tm_oef = 0; // Merma OEF específica (interna).
    let tj = 0; // Total area de desbandes y elementos de cola.

    let sheet_width = 0;
    let sheet_height = 0;

    // Del canvas, obtener el contexto para poder dibujar
    const contexto = new_canvas.getContext('2d');
    // contexto.fillRect(0, 0, contexto.width, contexto.height);

    // Hay que saber de antemano el tamaño total del canvas
    // porque sólo se puede asignar sus dimensiones una vez
    // ya que al hacerlo se borra todo lo que hubiera antes.

    // Vuelta para calcular las dimensiones del canvas.
    graphicListIn.forEach( gr => {

      if (gr.points && gr.points.length > 0) {

        // Según el tipo de gráfico (Hoja S, Travera T o Pieza P)
        // se indica un grosor y color de línea distinto en el dibujo.
        if (gr.type === 'S' || gr.type === 'U') {

          // Si es una hoja de tipo "Unused" (no usada).
          if (gr.type === 'U') {

            // console.log('--> Encontrada hoja tipo U.');

            // Aumentamos el número de hojas sobrantes no usadas.
            this.num_sheet++;
          } else {
            sheet_count++;

            sheet_width = gr.width;
            sheet_height = gr.height;

            let des_aux = Number((((gr.width - (Number(disbandIn.left) + Number(disbandIn.right))) * (gr.height - (Number(disbandIn.bottom) + Number(disbandIn.top)))) / 1000000).toFixed(2));

            // Se calcula el área gastada en el desbande y se suma
            // al total de área desperdiciada.
            // NOTA: No se suma el desbande al desperdicio.
            // this.total_area_D += gr.area - des_aux;
            // td += gr.area - des_aux;

            // Se guarda el valor del área aplicada en el desbande.
            disband_area =  gr.area - des_aux;

            // Opcion A
            let area_sheet_final = gr.area;

            // Opcion B
            // let area_sheet_final = gr.area - tail_area - disband_area;

            this.total_area_J += tail_area + disband_area;
            tj += tail_area + disband_area;

            this.total_area_S += area_sheet_final;
            ts += area_sheet_final;

            last_width = gr.points[gr.points.length - 1].x - gr.points[0].x;
            last_height = gr.points[1].y - gr.points[0].y;

            if (last_width > max_width) {
              max_width = last_width;
            }

            if (sheet_count > 0) {
              y_plus += last_height + h_separation;
              // console.log('--> Otra S = ' + y_plus);
            } else {
              y_plus += last_height;
              // console.log('--> Primera S = ' + y_plus);
            }
          }
        }
      } // End gr.points

    });

    new_canvas.width = ((2 * w_separation) + max_width) * zoom;
    new_canvas.height = (y_plus + h_separation) * zoom;

    // IMPORTANTE: Cambiar el punto de origen del "canvas" a la esquina inferior izquierda
    // e invertir las coordenadas del eje Y (para dibujar como en V40 y lisec).
    // contexto.transform(1, 0, 0, -1, 0, new_canvas.height);

    // Es exactamente igual el resultado.
    // contexto.translate(0, new_canvas.height);
    // contexto.scale(1, -1);

    // console.log('--> new_canvas.width = ' + new_canvas.width);
    // console.log('--> new_canvas.height = ' + new_canvas.height);

    // console.log('-->--> w_separation = ' + w_separation);
    // console.log('-->--> max_width = ' + max_width);
    // console.log('-->--> zoom = ' + zoom);
    // console.log('-->--> y_plus = ' + y_plus);
    // console.log('-->--> h_separation = ' + h_separation);

    y_plus = h_separation;
    x_plus = w_separation;
    last_height = 0;
    sheet_count = 0;

    // Para almacenar el listado de lotes de la hoja.
    let lotList = [];

    let sheetMaterial = '';
    let sheetIdMaterial = '';
    let sheet_num_pieces = 0;

    // Disposición puntos pieza en VS-Cut.

    // P[0] ----------- P[3]
    //  |				 |
    //  |				 |
    //  |				 |
    // P[1] ----------- P[2]

    // Vuelta para representar los gráficos.
    // NOTA: cada gráfico debe ir dibujado en la hoja indicada en el elemento,
    // no tiene porqué ser la hoja actual (piezas colocadas en traveras "pasadas").
    graphicListIn.forEach( gr => {

      // console.log(' GR -> ');
      // console.log(gr);

      if (gr.mat_desc) {
        sheetMaterial = gr.mat_desc ? gr.mat_desc.toString() : '';
        sheetIdMaterial = gr.mat_id ? gr.mat_id.toString() : '';

        // Guardamos el lote de la pieza si aún no se había incluído en el listado total de lotes.
        if (!this.totalMaterialList.includes(sheetMaterial)) {
          this.totalMaterialList.push(sheetMaterial);
          this.totalMaterialIdList.push(sheetIdMaterial);
        }
      }

      // Guardamos el lote de la pieza si aún no se había incluído en el listado de lotes de la hoja.
      if (gr.lot && !lotList.includes(gr.lot)) {
        lotList.push(gr.lot);

        // Guardamos el lote de la pieza si aún no se había incluído en el listado total de lotes.
        if (!this.totalLotList.includes(gr.lot)) {
          this.totalLotList.push(gr.lot);
        }
      }

      if (gr.points && gr.points.length > 0) {

        // Según el tipo de gráfico (Hoja S, Travera T o Pieza P)
        // se indica un grosor y color de línea distinto en el dibujo.
        switch (gr.type) {

          case 'S': // case 'U':

            // console.log('--> grafico tipo S o U. Area = ' + this.total_area_S);
            // console.log(gr);

            // Comenzar
            contexto.beginPath();

            // Grosor de línea
            contexto.lineWidth = 2;
            // Color de línea
            contexto.strokeStyle = 'black';
            contexto.fillStyle = 'black';

            if (sheet_count > 0) {
              y_plus += last_height + h_separation;
              // console.log('--> Otra S = ' + y_plus);
            } else {
              y_plus += last_height;
              // console.log('--> Primera S = ' + y_plus);
            }

            // Situamos el cursor en el primer punto.
            // console.log('--> Situando origen. X=' + gr.points[0].x * zoom + ' ;Y=' + (y_plus + gr.points[0].y) * zoom);
            contexto.moveTo((x_plus + gr.points[0].x) * zoom, (y_plus + gr.points[0].y) * zoom);

            // Se recorren todos los puntos del gráfico.
            gr.points.forEach( p => {
              // console.log('--> Dibujando línea. X=' + p.x * zoom + ' ;Y=' + (y_plus + p.y) * zoom);
              contexto.lineTo((x_plus + p.x) * zoom, (y_plus + p.y) * zoom);
            });

            // Se cierra la gráfica uniendo el primer y último punto.
            // console.log('--> Cerrando elemento. X=' + gr.points[0].x * zoom + ' ;Y=' + (y_plus + gr.points[0].y) * zoom);
            contexto.lineTo((x_plus + gr.points[0].x) * zoom, (y_plus + gr.points[0].y) * zoom);

            // NOTA: Cuando es una hoja se van a dibujar las "líneas de corte de desbande"
            // dependiendo del eje usado. Situamos el cursor en el primer punto.
            // console.log('--> Situando origen. X=' + gr.points[0].x * zoom + ' ;Y=' + (y_plus + gr.points[0].y) * zoom);
            contexto.stroke();
            contexto.beginPath();

            contexto.lineWidth = 8;
            contexto.strokeStyle = 'grey';
            contexto.fillStyle = 'grey';

            // Se dibuja la marca para señalar la esquina donde está el punto de origen.
            switch(originIn) {
              case 1:

                // Esquina superior izquierda
                contexto.moveTo((x_plus + gr.points[0].x - 28) * zoom, (y_plus + gr.points[0].y - 28) * zoom);
              	contexto.lineTo((x_plus + gr.points[0].x - 28) * zoom, (h_separation + gr.points[0].y + 50) * zoom);

              	contexto.moveTo((x_plus + gr.points[0].x - 50) * zoom, (y_plus + gr.points[0].y - 28) * zoom);
              	contexto.lineTo((x_plus + gr.points[0].x + 50) * zoom, (h_separation + gr.points[0].y - 28) * zoom);

                break;

              case 2:

                // Esquina inferior izquierda
                contexto.moveTo((x_plus + gr.points[1].x - 28) * zoom, (y_plus + gr.points[1].y - 50) * zoom);
              	contexto.lineTo((x_plus + gr.points[1].x - 28) * zoom, (h_separation + gr.points[1].y + 50) * zoom);

              	contexto.moveTo((x_plus + gr.points[1].x - 50) * zoom, (y_plus + gr.points[1].y + 28) * zoom);
              	contexto.lineTo((x_plus + gr.points[1].x + 50) * zoom, (h_separation + gr.points[1].y + 28) * zoom);

                break;

              case 3:

                // Esquina inferior derecha
                contexto.moveTo((x_plus + gr.points[2].x + 28) * zoom, (y_plus + gr.points[2].y - 50) * zoom);
              	contexto.lineTo((x_plus + gr.points[2].x + 28) * zoom, (h_separation + gr.points[2].y + 50) * zoom);

              	contexto.moveTo((x_plus + gr.points[2].x + 50) * zoom, (y_plus + gr.points[2].y + 28) * zoom);
              	contexto.lineTo((x_plus + gr.points[2].x - 50) * zoom, (h_separation + gr.points[2].y + 28) * zoom);

                break;

              case 4:

                // Esquina superior derecha
                contexto.moveTo((x_plus + gr.points[3].x + 28) * zoom, (y_plus + gr.points[3].y - 28) * zoom);
              	contexto.lineTo((x_plus + gr.points[3].x + 28) * zoom, (h_separation + gr.points[3].y + 50) * zoom);

              	contexto.moveTo((x_plus + gr.points[3].x - 50) * zoom, (y_plus + gr.points[3].y - 28) * zoom);
              	contexto.lineTo((x_plus + gr.points[3].x + 50) * zoom, (h_separation + gr.points[3].y - 28) * zoom);

                break;
            }
            contexto.stroke();
            contexto.beginPath();

            contexto.lineWidth = 1;
            contexto.strokeStyle = 'red';
            contexto.fillStyle = 'red';

            if (axisIn === 'X') {
              // Esquina superior izquierda
              contexto.moveTo((disbandIn.left + x_plus + gr.points[0].x) * zoom, (y_plus + gr.points[0].y) * zoom);
              contexto.lineTo((disbandIn.left + x_plus) * zoom, (h_separation + disbandIn.top) * zoom);

              // Esquina superior derecha
              contexto.moveTo(((gr.points[3].x - disbandIn.right) + x_plus) * zoom, (y_plus + gr.points[3].y) * zoom);
              contexto.lineTo(((gr.points[3].x - disbandIn.right) + x_plus) * zoom, (h_separation + disbandIn.top) * zoom);

              // Esquina inferior izquierda
              contexto.moveTo((disbandIn.left + x_plus + gr.points[1].x) * zoom, ((gr.points[1].y) + y_plus) * zoom);
              contexto.lineTo((disbandIn.left + x_plus + gr.points[1].x) * zoom, (gr.points[1].y + h_separation - disbandIn.bottom) * zoom);

              // Esquina inferior derecha
              contexto.moveTo(((gr.points[2].x - disbandIn.right) + x_plus) * zoom, ((gr.points[2].y) + y_plus) * zoom);
              contexto.lineTo(((gr.points[2].x - disbandIn.right) + x_plus) * zoom, (gr.points[2].y + h_separation - disbandIn.bottom) * zoom);

            } else if (axisIn === 'Y') {
              // Esquina superior izquierda
              contexto.moveTo(x_plus * zoom, (disbandIn.top + y_plus) * zoom);
              contexto.lineTo((disbandIn.left + x_plus + gr.points[0].x) * zoom, (disbandIn.top + y_plus + gr.points[0].y) * zoom);

              // Esquina superior derecha
              contexto.moveTo((gr.points[3].x + x_plus) * zoom, (disbandIn.top + y_plus + gr.points[0].y) * zoom);
              contexto.lineTo(((gr.points[3].x - disbandIn.left) + x_plus) * zoom, (disbandIn.top + y_plus + gr.points[3].y) * zoom);

              // Esquina inferior izquierda
              contexto.moveTo((disbandIn.left + x_plus + gr.points[1].x) * zoom, ((gr.points[1].y - disbandIn.bottom) + y_plus) * zoom);
              contexto.lineTo((x_plus + gr.points[1].x) * zoom, ((gr.points[1].y - disbandIn.bottom) + y_plus) * zoom);

              // Esquina inferior derecha
              contexto.moveTo(((gr.points[2].x - disbandIn.left) + x_plus) * zoom, ((gr.points[2].y - disbandIn.bottom) + y_plus) * zoom);
              contexto.lineTo((gr.points[2].x + x_plus) * zoom, ((gr.points[2].y - disbandIn.bottom) + y_plus) * zoom);

            }

            // -------- Etiqueta para el elemento.

            let zoom_aux = 20

            if (zoom <= 0.1) {
              zoom_aux = 12;
            } else if (zoom > 0.1 && zoom <= 0.15) {
              zoom_aux = 16;
            }

            // Crear un punto de guardado del contexto.
            contexto.save();

            contexto.translate(
              ((x_plus + gr.points[gr.points.length - 2].x) * zoom ),
              ((y_plus + gr.points[gr.points.length - 2].y) * zoom) + zoom_aux
            );
            // contexto.scale(1, -1);

            contexto.stroke();
            contexto.beginPath();
            contexto.textAlign = 'right';
            contexto.font = '10pt Courier New';
            contexto.fillStyle = 'black';
            contexto.strokeStyle = 'black';

            contexto.fillText(gr.name + ': ' + gr.label, 0, 0);

            // "Guardar" cambios
            contexto.stroke();

            // Reestrablecer el contexto al último punto de guardado.
            contexto.restore();

            last_height = gr.points[1].y - gr.points[0].y;

            sheet_count++;

            break;

          case 'T':

            this.opti.changeOriginPoint(gr.points, sheet_width, sheet_height, disbandIn, originIn);

	        // El área de travera es área desperdiciada.
	        // NOTA: La cola no se cuenta como desperdicio (método de cálculo Lisec).
	        if (gr.num !== tail_num) {
				this.total_area_T += gr.area;
				td += gr.area;
			}

            // console.log('--> grafico tipo T.');
            contexto.lineWidth = 1;
            contexto.fillStyle = 'red';
            contexto.strokeStyle = 'red';

            contexto.beginPath();

            // Situamos el cursor en el primer punto.
            // console.log('--> Situando origen. X=' + gr.points[0].x * zoom + ' ;Y=' + (y_plus + gr.points[0].y) * zoom);
            contexto.moveTo((disbandIn.left + x_plus + gr.points[0].x) * zoom, (disbandIn.top + y_plus + gr.points[0].y) * zoom);

            // Se recorren todos los puntos del gráfico.
            gr.points.forEach( p => {
              // console.log('--> Dibujando línea. X=' + p.x * zoom + ' ;Y=' + (y_plus + p.y) * zoom);
              contexto.lineTo((disbandIn.left + x_plus + p.x) * zoom, (disbandIn.top + y_plus + p.y) * zoom);
            });

            // Se cierra la gráfica uniendo el primer y último punto.
            // console.log('--> Cerrando elemento. X=' + gr.points[0].x * zoom + ' ;Y=' + (y_plus + gr.points[0].y) * zoom);
            contexto.lineTo((disbandIn.left + x_plus + gr.points[0].x) * zoom, (disbandIn.top + y_plus + gr.points[0].y) * zoom);

            contexto.stroke();

            // Etiqueta para el elemento.
            contexto.textAlign = 'right';
            // contexto.font = this.letra_bold_10_currier;
            contexto.font = this.letra_10_currier;
            contexto.fillStyle = 'red';
            contexto.strokeStyle = 'red';

            if ((gr.points[2].x - gr.points[0].x) * zoom < label_width / 2 ) {

              contexto.save();

              contexto.textAlign = 'left';
              contexto.font = this.letra_10_currier;

              contexto.beginPath();

              if ((gr.points[2].x - gr.points[0].x) * zoom < 20 ) {
                contexto.translate(
                ((disbandIn.left + x_plus + gr.points[2].x) * zoom ) - 10,
                ((disbandIn.top + y_plus + gr.points[gr.points.length - 1].y) * zoom) + 10);

              } else {
                contexto.translate(
                ((disbandIn.left + x_plus + gr.points[2].x) * zoom ) - 14,
                ((disbandIn.top + y_plus + gr.points[gr.points.length - 1].y) * zoom) + 10);
              }

              let rad = 90 * Math.PI / 180; //pasar a radianes 90 grados.
              contexto.rotate(rad);

              // CAMBIAR: pone la etiqueta del nombre de la pieza.
              // contexto.fillText(gr.name, 0, 0);

              // Número de orden.
              if (this.fileForm.controls.f_show_order.value) {
                contexto.font = this.letra_bold_12_currier;
                contexto.fillStyle = this.rosa;
                contexto.fillText(gr['cut_order'] ? '#' + gr['cut_order'] : '', 0, 0);
              }

              // contexto.stroke();
              contexto.restore();
            } else {

              contexto.save();

              let zoom_aux = 18;
              // if (zoom <= 0.1) {
              if ((gr.points[2].y - gr.points[3].y) * zoom < label_height / 2) {
                zoom_aux = 10;
              }

              // CAMBIAR: pone la etiqueta del nombre de la pieza.
              // contexto.fillText(
              //   gr.name,
              //   ((disbandIn.left + x_plus + gr.points[gr.points.length - 1].x) * zoom) - 10,
              //   ((disbandIn.top + y_plus + gr.points[gr.points.length - 1].y) * zoom) + zoom_aux);

              if (this.fileForm.controls.f_show_order.value) {
                contexto.font = this.letra_bold_12_currier;
                contexto.fillStyle = this.rosa;

                contexto.fillText(
                  gr['cut_order'] ? '#' + gr['cut_order'] : '',
                  ((disbandIn.left + x_plus + gr.points[gr.points.length - 1].x) * zoom) - 10,
                  ((disbandIn.top + y_plus + gr.points[gr.points.length - 1].y) * zoom) + zoom_aux);
              }
              // contexto.stroke();
              contexto.restore();
            }

            // Escribimos las medidas (compactas, sin "x", dentro del contorno).
            const tMinX = Math.min(gr.points[0].x, gr.points[2].x);
            const tMaxX = Math.max(gr.points[0].x, gr.points[2].x);
            const tMinY = Math.min(gr.points[0].y, gr.points[2].y);
            const tMaxY = Math.max(gr.points[0].y, gr.points[2].y);
            const tWidthPx = (tMaxX - tMinX) * zoom;
            const tHeightPx = (tMaxY - tMinY) * zoom;
            const tCx = ((disbandIn.left + x_plus + ((tMinX + tMaxX) / 2)) * zoom);
            const tCy = ((disbandIn.top + y_plus + ((tMinY + tMaxY) / 2)) * zoom);

            contexto.fillStyle = 'red';
            contexto.strokeStyle = 'red';
            this.drawCompactMeasureInsideRect(contexto, gr.label, tCx, tCy, tWidthPx, tHeightPx);

            break;

          case 'R':

            this.opti.changeOriginPoint(gr.points, sheet_width, sheet_height, disbandIn, originIn);

            let cut_order_retal = this.cutTotalOrderList.find(p => p.name_id === gr.name_id && p.num === gr.num);
            if (!cut_order_retal) {
              // Compatibilidad OEF: en ciertos flujos runtime el número local puede variar
              // aunque el name_id sea estable y único por pieza.
              cut_order_retal = this.cutTotalOrderList.find(p => p.name_id === gr.name_id);
            }
            if (!cut_order_retal) {
              // Fallback tolerante: comparar base de name_id sin sufijos técnicos.
              cut_order_retal = this.cutTotalOrderList.find(p => this.isSameNameIdLoose(p && p.name_id, gr && gr.name_id));
            }
            if (!cut_order_retal) {
              // Fallback final: comparar lote#secuencia (+ forma si existe).
              cut_order_retal = this.cutTotalOrderList.find(p => this.isSameNameIdByLotSeqAndFigure(p && p.name_id, gr && gr.name_id));
            }

            if (cut_order_retal) {
              // console.log('· MODO2 -> Retal tronzado: ');
              // console.log(cut_order_retal);

              gr['cut_order'] = cut_order_retal.cut_order;
            }

            // NOTA: La cola no se cuenta como retal (método de cálculo Lisec).
	        if (gr.num !== tail_num) {
				this.total_area_R += gr.area;
            	tr += gr.area;
			}

            // console.log('--> grafico tipo R.');
            contexto.lineWidth = 1;
            contexto.fillStyle = this.gris_claro; // 'green';
            contexto.strokeStyle = 'green';

            contexto.beginPath();

            // Situamos el cursor en el primer punto.
            // console.log('--> Situando origen. X=' + gr.points[0].x * zoom + ' ;Y=' + (y_plus + gr.points[0].y) * zoom);
            contexto.moveTo((disbandIn.left + x_plus + gr.points[0].x) * zoom, (disbandIn.top + y_plus + gr.points[0].y) * zoom);

            // Se recorren todos los puntos del gráfico.
            gr.points.forEach( p => {
              // console.log('--> Dibujando línea. X=' + p.x * zoom + ' ;Y=' + (y_plus + p.y) * zoom);
              contexto.lineTo((disbandIn.left + x_plus + p.x) * zoom, (disbandIn.top + y_plus + p.y) * zoom);
            });

            // Se cierra la gráfica uniendo el primer y último punto.
            // console.log('--> Cerrando elemento. X=' + gr.points[0].x * zoom + ' ;Y=' + (y_plus + gr.points[0].y) * zoom);
            contexto.lineTo((disbandIn.left + x_plus + gr.points[0].x) * zoom, (disbandIn.top + y_plus + gr.points[0].y) * zoom);

			// Para rellenar de color de un retal aprovechable.
            if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

            contexto.stroke();

            // Etiqueta para el elemento.
            contexto.textAlign = 'right';
            // contexto.font = this.letra_bold_10_currier;
            contexto.font = '10pt Courier New';
            contexto.fillStyle = 'green';
            contexto.strokeStyle = 'green';

            if ((gr.points[2].x - gr.points[0].x) * zoom < label_width / 2 ) {

              contexto.save();

              contexto.textAlign = 'left';
              contexto.font = '10pt Courier New';

              contexto.beginPath();

              if ((gr.points[2].x - gr.points[0].x) * zoom < 20 ) {
                contexto.translate(
                ((disbandIn.left + x_plus + gr.points[2].x) * zoom ) - 10,
                ((disbandIn.top + y_plus + gr.points[gr.points.length - 1].y) * zoom) + 10);

              } else {
                contexto.translate(
                ((disbandIn.left + x_plus + gr.points[2].x) * zoom ) - 14,
                ((disbandIn.top + y_plus + gr.points[gr.points.length - 1].y) * zoom) + 10);
              }

              let rad = 90 * Math.PI / 180; //pasar a radianes 90 grados.
              contexto.rotate(rad);

              // CAMBIAR: pone la etiqueta del nombre de la pieza.
              // contexto.fillText(gr.name, 0, 0);

              // contexto.stroke();
              contexto.restore();
            } else {
              contexto.save();

              // CAMBIAR: pone la etiqueta del nombre de la pieza.
              // contexto.fillText(
              //   gr.name,
              //   ((disbandIn.left + x_plus + gr.points[gr.points.length - 1].x) * zoom) - 10,
              //   ((disbandIn.top + y_plus + gr.points[gr.points.length - 1].y) * zoom) + 18);

              if (this.fileForm.controls.f_show_order.value) {
                contexto.font = this.letra_bold_12_currier;
                contexto.fillStyle = this.rosa;
                contexto.fillText(
                  gr['cut_order'] ? '#' + gr['cut_order'] : '',
                  ((disbandIn.left + x_plus + gr.points[gr.points.length - 1].x) * zoom) - 10,
                  ((disbandIn.top + y_plus + gr.points[gr.points.length - 1].y) * zoom) + 18);
              }
              // contexto.stroke();
              contexto.restore();
            }

            // Escribimos las medidas (compactas, sin "x", dentro del contorno).
            const rMinX = Math.min(gr.points[0].x, gr.points[2].x);
            const rMaxX = Math.max(gr.points[0].x, gr.points[2].x);
            const rMinY = Math.min(gr.points[0].y, gr.points[2].y);
            const rMaxY = Math.max(gr.points[0].y, gr.points[2].y);
            const rWidthPx = (rMaxX - rMinX) * zoom;
            const rHeightPx = (rMaxY - rMinY) * zoom;
            const rCx = ((disbandIn.left + x_plus + ((rMinX + rMaxX) / 2)) * zoom);
            const rCy = ((disbandIn.top + y_plus + ((rMinY + rMaxY) / 2)) * zoom);

            contexto.fillStyle = 'green';
            contexto.strokeStyle = 'green';
            this.drawCompactMeasureInsideRect(contexto, gr.label, rCx, rCy, rWidthPx, rHeightPx);

            // "Guardar" cambios
            contexto.stroke();

            break;


          case 'P':

            this.opti.changeOriginPoint(gr.points, sheet_width, sheet_height, disbandIn, originIn);

            {
              const hasOefCompositeUnits = this.isOefCompositeItem(gr) || (Number(gr && gr.oef_real_units) > 1);
              if (hasOefCompositeUnits) {
                sheet_num_pieces += this.getOefCompositeTotalUnits(gr);
              } else {
                sheet_num_pieces += 1;
              }
            }

            let stack_aux = gr.stack;
            const isOefComposite = !!(gr && Array.isArray(gr.oef_internal_polygons) && gr.oef_internal_polygons.length > 0);
            if (isOefComposite) {
              this.normalizeOefCompositeCanvasBox(gr, sheet_width, sheet_height);
            }
            const showDetailedInfo = this.fileForm.controls.f_info.value && !isOefComposite;
            const showCompactEaselInfo = !isOefComposite && !showDetailedInfo;
            const showFullEaselInfo = !isOefComposite && showDetailedInfo;

            if (Number(this.fileForm.controls.f_mode.value) === 2 || Number(this.fileForm.controls.f_mode.value) === 3) {
              // Se obtiene la pieza asociada en el listado de "orden de tronzado" para coger
              // de ella la información de la ubicación exacta de la pieza en los caballetes.
              let cut_order_piece = this.cutTotalOrderList.find(p => p.name_id === gr.name_id && Number(p.num) === Number(gr.num));
              if (!cut_order_piece) {
                // Compatibilidad OEF: usar name_id como clave fuerte si num no coincide.
                cut_order_piece = this.cutTotalOrderList.find(p => p.name_id === gr.name_id);
              }
              if (!cut_order_piece) {
                // Fallback tolerante: comparar base de name_id sin sufijos técnicos.
                cut_order_piece = this.cutTotalOrderList.find(p => this.isSameNameIdLoose(p && p.name_id, gr && gr.name_id));
              }
              if (!cut_order_piece) {
                // Fallback final: comparar lote#secuencia (+ forma si existe).
                cut_order_piece = this.cutTotalOrderList.find(p => this.isSameNameIdByLotSeqAndFigure(p && p.name_id, gr && gr.name_id));
              }

              if (cut_order_piece) {
                // console.log('· MODO2 -> Pieza tronzada: ' + cut_order_piece.stack_num);
                // console.log(cut_order_piece);

				// Asignación del caballete al que va la pieza.
                gr.easel = cut_order_piece.easel;

                gr['cut_order'] = cut_order_piece.cut_order;
                gr['sequence_broked'] = cut_order_piece.sequence_broked;

                if (cut_order_piece.stack_num !== undefined && cut_order_piece.stack_num !== null) {

                  // console.log('-> Hay orden dentro de la pila: ' + cut_order_piece.stack_num);
                  stack_aux += '/' + cut_order_piece.stack_num;
                }
              } else {
				console.log('· MODO2 o MODO3 -> Gráfico no encontrado. Piezas número: ' + gr.num );
				console.log(gr.name_id);
				// console.log('this.cutTotalOrderList = ');
				// console.log(this.cutTotalOrderList);
			  }
            } else {
              if (gr.stack_num !== undefined && gr.stack_num !== null) {

                // console.log('-> MODO1 -> Hay orden dentro de la pila: ' + gr.stack_num);
                stack_aux += '/' + gr.stack_num;
              }
            } // End If f_mode

            this.total_area_P += gr.area;
            tn += gr.area;
            if (isOefComposite && Number(gr.width) > 0 && Number(gr.height) > 0 && Number(gr.area) > 0) {
              const bboxArea = Number((Number(gr.width) * Number(gr.height) / 1000000).toFixed(2));
              const innerWaste = Number((bboxArea - Number(gr.area)).toFixed(2));
              if (innerWaste > 0) {
                this.total_area_T += innerWaste;
                this.total_area_T_OEF_IN += innerWaste;
                td_oef_in += innerWaste;
                td += innerWaste;
              }
            }

            // console.log('--> grafico tipo P.');
            contexto.lineWidth = 1;

            contexto.strokeStyle = 'blue';

            contexto.beginPath();

            // Situamos el cursor en el primer punto.
            // console.log('--> Situando origen. X=' + gr.points[0].x * zoom + ' ;Y=' + (y_plus + gr.points[0].y) * zoom);
            contexto.moveTo((disbandIn.left + x_plus + gr.points[0].x) * zoom, (disbandIn.top + y_plus + gr.points[0].y) * zoom);

            // Se recorren todos los puntos del gráfico.
            gr.points.forEach( p => {
              // console.log('--> Dibujando línea. X=' + p.x * zoom + ' ;Y=' + (y_plus + p.y) * zoom);
              contexto.lineTo((disbandIn.left + x_plus + p.x) * zoom, (disbandIn.top + y_plus + p.y) * zoom);
            });

            // Modo A: Se cierra la gráfica uniendo el primer y último punto.
            // console.log('--> Cerrando elemento. X=' + gr.points[0].x * zoom + ' ;Y=' + (y_plus + gr.points[0].y) * zoom);
            // contexto.lineTo((disbandIn.left + x_plus + gr.points[0].x) * zoom, (disbandIn.top + y_plus + gr.points[0].y) * zoom);

            // Modo B: Cierra la forma, es decir, sería como usar la instrucción "closing the loop"
            // que une el punto final con el punto de inicio del path que se estaba tratando.
            contexto.closePath();

            contexto.stroke();

            // Si la pieza proviene de un primitivo OEF, dibujamos las líneas internas
            // de corte auxiliar para visualizar el despiece triangular.
            this.drawOefInternalCuts(contexto, gr, disbandIn, x_plus, y_plus, zoom);

            // -------------
            // Si existe "forma" se dibuja en el interior del contorno rectangular que ya hemos dibujado.

            if (gr.form_id > 0 && !isOefComposite) {

              // console.log('->> Tratando una pieza con forma.');

              contexto.strokeStyle = 'orange';
              contexto.fillStyle = this.amarillo_claro;
              // contexto.fillStyle = this.azul_claro;

              let p_1 = JSON.parse(JSON.stringify(gr.points[0]));
              let p_2 = JSON.parse(JSON.stringify(gr.points[1]));
              let p_3 = JSON.parse(JSON.stringify(gr.points[2]));
              let p_4 = JSON.parse(JSON.stringify(gr.points[3]));

              switch (gr.form_id) {

                 case 1:
                  // console.log('->> Dibujando figura 1 en optimizador.');

                  contexto.lineWidth = 1;
                  contexto.beginPath();

                  if (gr.rotation === 0) {

                    // Dibujamos las líneas auxiliares.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_3.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_4.y) * zoom
                    );

                    // Se dibujan las líneas de la forma (versión invertida comentada).
                    // Colocamos el puntero en el punto de inicio de la forma.
                    /*
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_3.y - (gr.form_H + gr.form_B2 - gr.form_H1)) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_4.y) * zoom
                    );
                    */
                   contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_3.y) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B2 + gr.form_H - gr.form_H1) * zoom
                    );

                  } else if (gr.rotation === 90 || gr.rotation === 270) {

                    // Dibujamos las líneas auxiliares.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B3) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B3) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B1) * zoom
                    );

                    // Se dibujan las líneas de la forma (versión invertida comentada).
                    /*
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B3) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B3) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - (gr.form_H + gr.form_B2 - gr.form_H1)) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B1) * zoom
                    );
                    */
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B3) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - (gr.form_H + gr.form_B2 - gr.form_H1)) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B3) * zoom
                     );
                  } else if (gr.rotation === 270) {

                    // console.log('->> Forma rotada 270 grados.');

                    contexto.moveTo(
                      (disbandIn.left  + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left  + x_plus + p_2.x + (gr.form_H + gr.form_B2 - gr.form_H1)) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left  + x_plus + p_3.x) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left  + x_plus + p_4.x) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B3) * zoom
                    );
                  } else if (gr.flip === 'vertical') {

                    // console.log('->> Forma volteada por eje vertical.');

                    contexto.moveTo(
                      (disbandIn.left  + x_plus + p_1.x + gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left  + x_plus + p_2.x + gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left  + x_plus + p_3.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_3.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left  + x_plus + p_4.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_4.y + (gr.form_H + gr.form_B2 - gr.form_H1)) * zoom
                    );
                  } else if (gr.flip === 'vertical' && (gr.rotation === 90 || gr.rotation === 270)) {

                    // console.log('->> Forma volteada por eje vertical y rotada 90 grados.');

                    contexto.moveTo(
                      (disbandIn.left  + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B3) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left  + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left  + x_plus + p_3.x - (gr.form_H + gr.form_B2 - gr.form_H1)) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left  + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B3) * zoom
                    );
                  }

                  contexto.closePath();

                  if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                  contexto.stroke();

                  break;

                case 2:
                  // console.log('->> Dibujando figura 2 en optimizador.');

                  contexto.lineWidth = 1;
                  contexto.beginPath();

                  if (gr.rotation === 0) {

                    // Dibujamos las líneas auxiliares.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_3.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_4.y) * zoom
                    );

                    // Se dibujan las líneas de la forma (versión invertida comentada).
                    // Colocamos el puntero en el punto de inicio de la forma.
                    /*
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_H1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_4.y) * zoom
                    );
                    */
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_3.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B3) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_1.y + (gr.form_H + gr.form_B2 - gr.form_H1)) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );
                  } else if (gr.rotation === 90 || gr.rotation === 270) {

                    // Dibujamos las líneas auxiliares.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B1) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B3) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B3) * zoom
                    );

                    // Se dibujan las líneas de la forma.
                    /*
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B3) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_H1) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B3) * zoom
                    ); */
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B3) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B3) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - (gr.form_H + gr.form_B2 - gr.form_H1)) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B1) * zoom
                    );

                  }

                  contexto.closePath();

                  if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                  contexto.stroke();

                  break;

                case 29:
                  // console.log('->> Dibujando figura 29 CIRCULO en optimizador.');
                  contexto.beginPath();

                  // Dibujamos las líneas auxiliares.
                  contexto.moveTo(
                    (disbandIn.left + x_plus + p_1.x) * zoom,
                    (disbandIn.top + y_plus + p_1.y + (gr.height / 2)) * zoom
                  );

                  contexto.lineTo(
                    (disbandIn.left + x_plus + p_1.x + gr.form_B1) * zoom,
                    (disbandIn.top + y_plus + p_1.y + (gr.height / 2)) * zoom
                  );

                  contexto.moveTo(
                    (disbandIn.left + x_plus + p_4.x - gr.form_B1) * zoom,
                    (disbandIn.top + y_plus + p_4.y + (gr.height / 2)) * zoom
                  );

                  contexto.lineTo(
                    (disbandIn.left + x_plus + p_4.x) * zoom,
                    (disbandIn.top + y_plus + p_4.y + (gr.height / 2)) * zoom
                  );

                  contexto.stroke();
                  contexto.beginPath();

                  // Se mueve el punto al centro
                  contexto.arc(
                    (disbandIn.left + x_plus + (gr.points[0].x + gr.points[2].x ) / 2 ) * zoom, // X del punto del centro de la circunferencia.
                    (disbandIn.top + y_plus + (gr.points[0].y + gr.points[2].y ) / 2 ) * zoom, // Y del punto del centro de la circunferencia.
                    gr.form_R * zoom, //  // Radio de la circunferencia.
                    0, // Ángulo de inicio en radianes.
                    2 * Math.PI // Ángulo de fin en radianes.
                  );

                  if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                  contexto.stroke();

                  break;

                // ------------ Nuevas formas añadidas D.

                case 3: {

	                contexto.save();

	                try {
	                  contexto.beginPath();

	                  const B1 = gr.form_B1; // margen derecho
	                  const B2 = gr.form_B2; // margen superior

	                  const L  = gr.form_L;   // ancho base
	                  const H  = gr.form_H;   // altura izquierda
	                  const H1 = gr.form_H1;  // altura derecha
	                  const L1 = gr.form_L1;  // tramo superior (desde izquierda)

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación (sin ??)
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (ya colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  // - En el plano: B2 arriba, B1 a la derecha
	                  const BW0 = (L + B1) * zoom;
	                  const BH0 = (H + B2) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // --- Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox ---
	                  // (Convención: rotación en sentido horario)
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  // Origen del área útil (arranca en la esquina superior izquierda de la pieza útil)
	                  // B2 desplaza hacia abajo; B1 NO desplaza x0 (es margen derecho)
	                  const x0 = 0;
	                  const y0 = B2 * zoom;

	                  // Puntos (mismos que tu lógica, en local)
	                  const xA = x0;
	                  const yA = y0 + H * zoom;

	                  const xB = x0 + L * zoom;
	                  const yB = yA;

	                  const xC = xB;
	                  const yC = y0 + (H - H1) * zoom;

	                  const xD = x0 + L1 * zoom;
	                  const yD = y0;

	                  const xE = x0;
	                  const yE = y0;

	                  // Contorno
	                  contexto.moveTo(xA, yA); // A
	                  contexto.lineTo(xB, yB); // B
	                  contexto.lineTo(xC, yC); // C
	                  contexto.lineTo(xD, yD); // D
	                  contexto.lineTo(xE, yE); // E
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();
	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	            case 4: {

	                contexto.save();

	                try {
	                  contexto.beginPath();

	                  const B1 = gr.form_B1; // margen izquierdo
	                  const B2 = gr.form_B2; // margen superior

	                  const L  = gr.form_L;   // ancho base
	                  const H  = gr.form_H;   // altura derecha (total)
	                  const H1 = gr.form_H1;  // altura izquierda (hasta inicio diagonal)
	                  const L1 = gr.form_L1;  // tramo superior (desde la derecha, según plano)

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación (sin ??)
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (ya colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  // --- En el plano de la 4: margen izquierdo B1, margen superior B2 ---
	                  const BW0 = (L + B1) * zoom;
	                  const BH0 = (H + B2) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // --- Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox ---
	                  // (Convención: rotación en sentido horario)
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  // Origen del área útil: arranca tras margen izquierdo y tras margen superior
	                  const x0 = B1 * zoom;
	                  const y0 = B2 * zoom;

	                  // Puntos (rot=0)
	                  const xA = x0;
	                  const yA = y0 + H * zoom;           // inf-izq

	                  const xB = x0 + L * zoom;
	                  const yB = yA;                      // inf-der

	                  const xE = xB;
	                  const yE = y0;                      // sup-der

	                  // Tramo superior medido desde la derecha (según tu case actual)
	                  const xD = x0 + (L - L1) * zoom;
	                  const yD = y0;                      // sup (punto donde arranca la diagonal)

	                  // Lateral izquierdo parcial: sube hasta (H - H1) desde arriba
	                  const xC = xA;
	                  const yC = y0 + (H - H1) * zoom;    // inicio diagonal en lateral izq

	                  // Recorrido horario: A -> B -> E -> D -> C -> A
	                  contexto.moveTo(xA, yA);
	                  contexto.lineTo(xB, yB);
	                  contexto.lineTo(xE, yE);
	                  contexto.lineTo(xD, yD);
	                  contexto.lineTo(xC, yC);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();
	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	            case 5: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  // Parámetros de la figura 5 (trapecio)
	                  const B1 = gr.form_B1; // margen inferior-izquierdo (según plano, offset desde la izquierda en la base)
	                  const B2 = gr.form_B2; // margen superior e inferior (vertical)
	                  const B3 = gr.form_B3; // margen inferior-derecho (offset desde la derecha en la base)

	                  const L  = gr.form_L;  // ancho base del trapecio (parte inferior)
	                  const H  = gr.form_H;  // altura útil del trapecio (entre B2 y B2)
	                  const L1 = gr.form_L1; // tramo superior derecho (desde la derecha del bbox hacia el interior)
	                  const L2 = gr.form_L2; // tramo superior izquierdo (desde la izquierda del bbox hacia el interior)

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación (sin ??)
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (ya colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // --- BBox en orientación base (rot=0) ---
	                  // Ancho total bbox = B1 + L + B3
	                  // Alto  total bbox = B2 + H + B2
	                  const BW0 = (B1 + L + B3) * zoom;
	                  const BH0 = (B2 + H + B2) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // --- Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox ---
	                  // (Convención: rotación en sentido horario)
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  // Área útil (trapecio) está entre:
	                  //   yTop  = B2
	                  //   yBase = B2 + H
	                  //   xBaseLeft  = B1
	                  //   xBaseRight = B1 + L
	                  //   xTopLeft   = L2
	                  //   xTopRight  = (B1 + L + B3) - L1
	                  const yTop  = B2 * zoom;
	                  const yBase = (B2 + H) * zoom;

	                  const xBaseLeft  = B1 * zoom;
	                  const xBaseRight = (B1 + L) * zoom;

	                  const xTopLeft   = L2 * zoom;
	                  const xTopRight  = (B1 + L + B3 - L1) * zoom;

	                  // Recorrido horario: base izq -> base der -> top der -> top izq -> cierre
	                  contexto.moveTo(xBaseLeft,  yBase);
	                  contexto.lineTo(xBaseRight, yBase);
	                  contexto.lineTo(xTopRight,  yTop);
	                  contexto.lineTo(xTopLeft,   yTop);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();
	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	            case 6: {

	                contexto.save();

	                try {
	                  contexto.beginPath();

	                  const B2 = gr.form_B2; // margen superior e inferior
	                  const B3 = gr.form_B3; // margen izquierdo (en el plano de la 6)
	                  const B1 = gr.form_B1; // margen derecho  (en el plano de la 6)

	                  const L  = gr.form_L;
	                  const H  = gr.form_H;
	                  const L1 = gr.form_L1; // offset superior izquierdo
	                  const L2 = gr.form_L2; // offset superior derecho

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación (sin ??)
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (ya colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0) para la figura 6:
	                  // ancho total = B3 + L + B1
	                  // alto total  = B2 + H + B2
	                  const BW0 = (B3 + L + B1) * zoom;
	                  const BH0 = (B2 + H + B2) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // --- Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox ---
	                  // (Convención: rotación en sentido horario)
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  // Origen del área útil: tras margen izquierdo (B3) y tras margen superior (B2)
	                  const x0 = B3 * zoom;
	                  const y0 = B2 * zoom;

	                  // Base inferior
	                  const xBL = x0;
	                  const yBL = y0 + H * zoom;

	                  const xBR = x0 + L * zoom;
	                  const yBR = yBL;

	                  // Base superior
	                  const xTL = x0 + L1 * zoom;
	                  const yTL = y0;

	                  const xTR = x0 + (L - L2) * zoom;
	                  const yTR = y0;

	                  // Recorrido horario: BL -> BR -> TR -> TL -> cierre
	                  contexto.moveTo(xBL, yBL);
	                  contexto.lineTo(xBR, yBR);
	                  contexto.lineTo(xTR, yTR);
	                  contexto.lineTo(xTL, yTL);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();
	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	            case 7: {

	                contexto.save();

	                try {
	                  contexto.beginPath();

	                  const B2 = gr.form_B2; // margen superior e inferior
	                  const B1 = gr.form_B1; // margen izquierdo
	                  const B3 = gr.form_B3; // margen derecho

	                  const L  = gr.form_L;
	                  const H  = gr.form_H;
	                  const H1 = gr.form_H1;

	                  const L1 = gr.form_L1; // offset superior derecho
	                  const L2 = gr.form_L2; // offset superior izquierdo

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación (sin ??)
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (ya colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  // Figura 7: margen izq B1, margen der B3, margen sup/inf B2
	                  const BW0 = (B1 + L + B3) * zoom;
	                  const BH0 = (B2 + H + B2) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox
	                  // (Convención: rotación en sentido horario)
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  // Origen del área útil: arranca tras margen izquierdo y tras margen superior
	                  const x0 = B1 * zoom;
	                  const y0 = B2 * zoom;

	                  // Puntos (locales)
	                  const xBL = x0;
	                  const yBL = y0 + H * zoom;

	                  const xBR = x0 + L * zoom;
	                  const yBR = yBL;

	                  // Escalón en lado derecho (vertical)
	                  const xStep = xBR;
	                  const yStep = y0 + (H - H1) * zoom;

	                  // Parte superior del trapecio
	                  const xTR = x0 + (L - L1) * zoom;
	                  const yT  = y0;

	                  const xTL = x0 + L2 * zoom;

	                  // Recorrido horario
	                  contexto.moveTo(xBL, yBL);
	                  contexto.lineTo(xBR, yBR);
	                  contexto.lineTo(xStep, yStep);
	                  contexto.lineTo(xTR, yT);
	                  contexto.lineTo(xTL, yT);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();
	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	            case 8: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  const B2 = gr.form_B2; // margen superior e inferior
	                  const B3 = gr.form_B3; // margen izquierdo (en el plano de la 8)
	                  const B1 = gr.form_B1; // margen derecho

	                  const L  = gr.form_L;
	                  const H  = gr.form_H;
	                  const H1 = gr.form_H1;

	                  const L1 = gr.form_L1; // offset superior izquierdo (en la 8)
	                  const L2 = gr.form_L2; // offset superior derecho (en la 8)

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación (sin ??)
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (ya colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  // En la figura 8: ancho total = B3 + L + B1 ; alto total = B2 + H + B2
	                  const BW0 = (B3 + L + B1) * zoom;
	                  const BH0 = (H + 2 * B2) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox
	                  // Convención usada: rotación "horaria" (misma que venimos aplicando)
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  // Origen del área útil: arranca tras margen izquierdo (B3) y tras margen superior (B2)
	                  const x0 = B3 * zoom;
	                  const y0 = B2 * zoom;

	                  // Base inferior
	                  const xBL = x0;
	                  const yBL = y0 + H * zoom;

	                  const xBR = x0 + L * zoom;
	                  const yBR = yBL;

	                  // Base superior (espejo de la 7)
	                  const yT  = y0;
	                  const xTL = x0 + L1 * zoom;
	                  const xTR = x0 + (L - L2) * zoom;

	                  // Escalón en el lado izquierdo
	                  const yStep = y0 + (H - H1) * zoom;
	                  const xStep = xBL;

	                  // Recorrido horario:
	                  // inf-izq -> inf-der -> (diagonal) a sup-der -> sup-izq -> escalón izq -> cierre a base
	                  contexto.moveTo(xBL, yBL);
	                  contexto.lineTo(xBR, yBR);
	                  contexto.lineTo(xTR, yT);
	                  contexto.lineTo(xTL, yT);
	                  contexto.lineTo(xStep, yStep);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	            case 9: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  const B1 = gr.form_B1;
	                  const B2 = gr.form_B2;
	                  const B3 = gr.form_B3;

	                  const L  = gr.form_L;
	                  const H  = gr.form_H;
	                  const H1 = gr.form_H1;
	                  const H2 = gr.form_H2;
	                  const L1 = gr.form_L1;
	                  const L2 = gr.form_L2;

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación (sin ??)
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox base de la forma (rot=0)
	                  // OJO: en figura 9 el alto total es B2 + H (sin margen inferior)
	                  const BW0 = (B1 + L + B3) * zoom;
	                  const BH0 = (B2 + H) * zoom;

	                  // BBox ya rotado (para encajar la transformación)
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación igual que figura 8
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL (como si rot=0) ---
	                  const x0 = B1 * zoom;
	                  const y0 = B2 * zoom;

	                  const xBL = x0;
	                  const yBL = y0 + H * zoom;

	                  const xBR = x0 + L * zoom;
	                  const yBR = yBL;

	                  const yStepR = yBL - (H2 * zoom);     // tramo vertical derecho = H2 desde base
	                  const xStepR = xBR;

	                  const yStepL = yBL - (H1 * zoom);     // tramo vertical izquierdo = H1 desde base
	                  const xStepL = xBL;

	                  const yT  = y0;                       // techo (tras B2)
	                  const xTL = x0 + (L2 * zoom);         // offset superior izq
	                  const xTR = x0 + ((L - L1) * zoom);   // offset superior dcha

	                  // Recorrido horario
	                  contexto.moveTo(xBL, yBL);
	                  contexto.lineTo(xBR, yBR);
	                  contexto.lineTo(xStepR, yStepR);
	                  contexto.lineTo(xTR, yT);
	                  contexto.lineTo(xTL, yT);
	                  contexto.lineTo(xStepL, yStepL);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	              case 10: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  // Márgenes según plano 10:
	                  // B3 = margen izquierdo
	                  // B1 = margen derecho
	                  // B2 = margen superior
	                  const B1 = gr.form_B1;
	                  const B2 = gr.form_B2;
	                  const B3 = gr.form_B3;

	                  // Dimensiones
	                  const L  = gr.form_L;   // ancho base
	                  const H  = gr.form_H;   // altura total útil

	                  // En la 10:
	                  // H2 = altura del tramo vertical izquierdo (desde la base)
	                  // H1 = altura del tramo vertical derecho (desde la base)
	                  const H1 = gr.form_H1;
	                  const H2 = gr.form_H2;

	                  // En la 10:
	                  // L1 = offset superior izquierdo (desde la izquierda)
	                  // L2 = offset superior derecho (desde la derecha)
	                  const L1 = gr.form_L1;
	                  const L2 = gr.form_L2;

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación (sin ??)
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (ya colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  // Figura 10: ancho total = B3 + L + B1 ; alto total = B2 + H
	                  const BW0 = (B3 + L + B1) * zoom;
	                  const BH0 = (B2 + H) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  // Ojo: NO hay margen inferior en el plano; la base L apoya en el bbox.
	                  const x0 = B3 * zoom;  // margen izquierdo
	                  const y0 = B2 * zoom;  // margen superior

	                  // Base inferior
	                  const xBL = x0;
	                  const yBL = y0 + H * zoom;

	                  const xBR = x0 + L * zoom;
	                  const yBR = yBL;

	                  // Tramo vertical derecho hasta el inicio del chaflán (H1 desde la base)
	                  const xStepR = xBR;
	                  const yStepR = y0 + (H - H1) * zoom;

	                  // Tramo vertical izquierdo hasta el inicio del chaflán (H2 desde la base)
	                  const xStepL = xBL;
	                  const yStepL = y0 + (H - H2) * zoom;

	                  // Techo (y = y0)
	                  const yT  = y0;

	                  // Punto superior derecho (a L2 desde la derecha)
	                  const xTR = x0 + (L - L2) * zoom;

	                  // Punto superior izquierdo (a L1 desde la izquierda)
	                  const xTL = x0 + L1 * zoom;

	                  // Recorrido horario:
	                  // base izq -> base der -> sube dcha -> chaflán a techo -> techo -> chaflán izq -> cierre
	                  contexto.moveTo(xBL, yBL);
	                  contexto.lineTo(xBR, yBR);
	                  contexto.lineTo(xStepR, yStepR);
	                  contexto.lineTo(xTR, yT);
	                  contexto.lineTo(xTL, yT);
	                  contexto.lineTo(xStepL, yStepL);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	              case 11: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  // Márgenes (según plano 11)
	                  const B1 = gr.form_B1; // margen izquierdo
	                  const B2 = gr.form_B2; // margen superior
	                  const B3 = gr.form_B3; // margen derecho
	                  const B4 = gr.form_B4; // margen inferior (en 11)

	                  // Dimensiones
	                  const L  = gr.form_L;   // ancho de referencia (entre líneas de cota L)
	                  const L1 = gr.form_L1;  // longitud de la base de la pieza (cota L1)
	                  const H  = gr.form_H;   // altura total (cota H)
	                  const H1 = gr.form_H1;  // altura tramo vertical derecho (cota H1)

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación (sin ??)
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (ya colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  // ancho total = B1 + L + B3
	                  // alto  total = B2 + H + B4
	                  const BW0 = (B1 + L + B3) * zoom;
	                  const BH0 = (B2 + H + B4) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  // Origen del área útil (arriba-izquierda del "hueco" interno):
	                  const x0 = B1 * zoom;
	                  const y0 = B2 * zoom;

	                  // Referencias verticales de la cota L
	                  const xL0 = x0;
	                  const xL1 = x0 + L * zoom;

	                  // Base inferior de la pieza: longitud L1 y termina en el lado derecho (como se ve en el plano)
	                  const yB  = y0 + H * zoom;
	                  const xBR = xL1;
	                  const xBL = xL1 - L1 * zoom;

	                  // Punto donde la diagonal superior llega al lado derecho (altura H1 desde la base)
	                  const yRTop = yB - H1 * zoom;

	                  // Punto superior izquierdo (máxima altura H)
	                  const xTL = xL0;
	                  const yTL = y0;

	                  // Recorrido horario:
	                  // top-left -> (diagonal sup) -> right-vertical -> base -> (diagonal izq) -> cierre
	                  contexto.moveTo(xTL, yTL);        // arriba-izq
	                  contexto.lineTo(xBR, yRTop);      // llega al lado derecho
	                  contexto.lineTo(xBR, yB);         // baja vertical derecho
	                  contexto.lineTo(xBL, yB);         // base inferior (L1)
	                  contexto.closePath();             // diagonal izq hasta arriba-izq

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	              case 12: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  const B1 = gr.form_B1; // margen derecho
	                  const B2 = gr.form_B2; // margen superior (lado derecho en el plano)
	                  const B3 = gr.form_B3; // margen izquierdo
	                  const B4 = gr.form_B4; // margen inferior (y también aparece arriba izq en el plano)

	                  const L  = gr.form_L;   // ancho útil (hasta el vértice superior derecho)
	                  const L1 = gr.form_L1;  // base inferior de la pieza
	                  const H  = gr.form_H;   // altura total útil
	                  const H1 = gr.form_H1;  // altura del tramo vertical izquierdo desde la base

	                  const { left, top } = disbandIn;

	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // Para no recortar si B2 y B4 no coinciden arriba:
	                  const topMargin = Math.max(B2, B4);
	                  const bottomMargin = B4;

	                  // BBox en orientación base (rot=0)
	                  const BW0 = (B3 + L + B1) * zoom;
	                  const BH0 = (topMargin + H + bottomMargin) * zoom;

	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  const x0 = B3 * zoom;
	                  const y0 = topMargin * zoom;

	                  const xBL = x0;
	                  const yBL = y0 + H * zoom;

	                  const xBR = x0 + L1 * zoom;
	                  const yBR = yBL;

	                  const xTR = x0 + L * zoom;
	                  const yTR = y0;

	                  const xK  = x0;
	                  const yK  = y0 + (H - H1) * zoom;

	                  // Recorrido horario
	                  contexto.moveTo(xBL, yBL);
	                  contexto.lineTo(xBR, yBR);
	                  contexto.lineTo(xTR, yTR);
	                  contexto.lineTo(xK,  yK);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	              case 13: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  // Márgenes (bbox)
	                  const B1 = gr.form_B1; // derecha
	                  const B2 = gr.form_B2; // superior
	                  const B3 = gr.form_B3; // izquierda
	                  const B4 = gr.form_B4; // inferior (en estas figuras se usa como banda inferior del bbox)

	                  // Parámetros geométricos
	                  const L  = gr.form_L;   // base útil
	                  const L1 = gr.form_L1;  // posición del punto superior sobre la cota superior (desde la izquierda útil)
	                  const H  = gr.form_H;   // altura útil total
	                  const H1 = gr.form_H1;  // altura del tramo vertical izquierdo (desde la base)

	                  const { left, top } = disbandIn;

	                  // Rotación normalizada (sin ??)
	                  const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  const BW0 = (B3 + L + B1) * zoom;
	                  const BH0 = (B2 + H + B4) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación al sistema local del bbox
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- DIBUJO LOCAL (como si rot=0) ---
	                  // Origen del área útil dentro del bbox:
	                  const x0 = B3 * zoom;
	                  const y0 = B2 * zoom;

	                  const yBottom = y0 + H * zoom;

	                  // Puntos (recorrido horario)
	                  const xBL = x0;
	                  const yBL = yBottom;

	                  const xBR = x0 + L * zoom;
	                  const yBR = yBottom;

	                  // Punto superior (sobre y0) a distancia L1 desde la izquierda útil
	                  const xTop = x0 + L1 * zoom;
	                  const yTop = y0;

	                  // Punto del lado izquierdo donde empieza la diagonal superior (H1 desde la base)
	                  const xLeft = x0;
	                  const yLeft = y0 + (H - H1) * zoom;

	                  contexto.moveTo(xBL, yBL);
	                  contexto.lineTo(xBR, yBR);
	                  contexto.lineTo(xTop, yTop);
	                  contexto.lineTo(xLeft, yLeft);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	              case 14: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  // Parámetros según plano 14
	                  const B1 = gr.form_B1;
	                  const B2 = gr.form_B2;
	                  const B3 = gr.form_B3;

	                  const L  = gr.form_L;   // longitud hasta el vértice superior derecho (x = B3 + L)
	                  const L1 = gr.form_L1;  // base útil de la pieza (hasta el punto C)
	                  const H  = gr.form_H;   // altura útil interior (entre B2 y B3)
	                  const H1 = gr.form_H1;  // altura del vértice D desde la base (inner bottom)

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación (sin ??)
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (ya colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  // ancho total = B3 + L + B3 + B1
	                  // alto total  = B2 + H + B3
	                  const BW0 = (B3 + L + B3 + B1) * zoom;
	                  const BH0 = (B2 + H + B3) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  const x0 = B3 * zoom;        // inner-left
	                  const y0 = B2 * zoom;        // inner-top
	                  const yB = y0 + H * zoom;    // inner-bottom

	                  const xA = x0;
	                  const yA = y0;

	                  const xB = x0;
	                  const yBtm = yB;

	                  const xC = x0 + L1 * zoom;
	                  const yC = yBtm;

	                  const xD = x0 + L * zoom;
	                  const yD = yBtm - H1 * zoom;

	                  // Recorrido (horario)
	                  contexto.moveTo(xA, yA);      // A top-left
	                  contexto.lineTo(xB, yBtm);    // B bottom-left
	                  contexto.lineTo(xC, yC);      // C bottom-right
	                  contexto.lineTo(xD, yD);      // D top-right
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	              case 15: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  // Parámetros según plano 15
	                  const B1 = gr.form_B1;
	                  const B2 = gr.form_B2;
	                  const B3 = gr.form_B3;

	                  const L  = gr.form_L;
	                  const L1 = gr.form_L1;
	                  const H  = gr.form_H;
	                  const H1 = gr.form_H1;

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación
	                  const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox colocado por el optimizador
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox BASE (rot=0) por fórmula del marco (igual que en 14)
	                  // ancho total = B3 + L + B3 + B1
	                  // alto  total = B2 + H + B3
	                  const BW0 = (B1 + L + B3) * zoom;
	                  const BH0 = (B2 + H + B3) * zoom;

	                  // Tamaño del bbox YA ROTADO en pantalla
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Ancla + rotación (patrón probado)
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // Mirror horizontal dentro del bbox base (SIEMPRE BW0)
	                  contexto.translate(BW0, 0);
	                  contexto.scale(-1, 1);

	                  // Dibujo local (mismo que 14)
	                  const x0 = B3 * zoom;        // inner-left
	                  const y0 = B2 * zoom;        // inner-top
	                  const yB = y0 + H * zoom;    // inner-bottom

	                  const xA = x0,        yA = y0;
	                  const xB = x0,        yBtm = yB;
	                  const xC = x0 + L1*zoom, yC = yBtm;
	                  const xD = x0 + L*zoom,  yD = yBtm - H1*zoom;

	                  contexto.moveTo(xA, yA);
	                  contexto.lineTo(xB, yBtm);
	                  contexto.lineTo(xC, yC);
	                  contexto.lineTo(xD, yD);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	              case 16: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  // Parámetros según plano 16
	                  const B1 = gr.form_B1; // margen izq
	                  const B2 = gr.form_B2; // margen sup (inner-top)
	                  const B3 = gr.form_B3; // margen der y margen inf + "subida" del vértice superior

	                  const L  = gr.form_L;   // base útil (inner-left -> inner-right)
	                  const L1 = gr.form_L1;  // distancia horizontal desde vértice superior hasta inner-right
	                  const H  = gr.form_H;   // altura útil interior (inner-top -> inner-bottom)
	                  const H1 = gr.form_H1;  // altura desde inner-bottom hasta el punto donde el techo toca el lateral derecho

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (lo coloca el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  // ancho total = B1 + L + B3
	                  // alto total  = B2 + H + B3
	                  const BW0 = (B1 + L + B3) * zoom;
	                  const BH0 = (B2 + H + B3) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL (como si rot=0) ---
	                  const xL = B1 * zoom;          // inner-left
	                  const xR = xL + L * zoom;      // inner-right
	                  const yT = B2 * zoom;          // inner-top
	                  const yB = yT + H * zoom;      // inner-bottom

	                  // Vértice superior "metido" en el margen superior: sube B3 por encima de yT
	                  const xK = xR - (L1 * zoom);   // punto superior (kink) a L1 de la derecha
	                  const yK = yT - (B3 * zoom);

	                  // Punto donde el techo toca el lateral derecho: a H1 desde la base
	                  const xD = xR;
	                  const yD = yB - (H1 * zoom);

	                  // Polígono (horario)
	                  // A (bottom-left) -> K (top vertex) -> D (right upper) -> C (bottom-right)
	                  const xA = xL, yA = yB;
	                  const xC = xR, yC = yB;

	                  contexto.moveTo(xA, yA);
	                  contexto.lineTo(xK, yK);
	                  contexto.lineTo(xD, yD);
	                  contexto.lineTo(xC, yC);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

	              case 17: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  // Parámetros según plano 17.
	                  const B1 = gr.form_B1;
	                  const B2 = gr.form_B2;
	                  const B3 = gr.form_B3;
	                  const L  = gr.form_L;
	                  const L1 = gr.form_L1;
	                  const H  = gr.form_H;
	                  const H1 = gr.form_H1;

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (lo coloca el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  const BW0 = (B1 + L + B3) * zoom;
	                  const BH0 = (B2 + H + B3) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL (como si rot=0) ---
	                  const xL = B3 * zoom;
	                  const xR = xL + (L * zoom);
	                  const yTop = B2 * zoom;
	                  const yBase = yTop + (H * zoom);
	                  const xK = xL + (Math.min(L, L1) * zoom);
	                  const yK = yBase - (Math.min(H, H1) * zoom);

	                  // Contorno: base izq -> vertical izq -> lado sup izq descendente -> lado sup der descendente -> base
	                  contexto.moveTo(xL, yBase);
	                  contexto.lineTo(xL, yTop);
	                  contexto.lineTo(xK, yK);
	                  contexto.lineTo(xR, yBase);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  // Bandas auxiliares B1/B3 y línea auxiliar oblicua.
	                  contexto.beginPath();
	                  contexto.moveTo(xL, 0);
	                  contexto.lineTo(xL, BH0);
	                  contexto.moveTo(xR, 0);
	                  contexto.lineTo(xR, BH0);
	                  contexto.moveTo(0, yTop);
	                  contexto.lineTo(BW0, yTop);
	                  contexto.moveTo(0, yBase);
	                  contexto.lineTo(BW0, yBase);
	                  {
	                    const xA = xL;
	                    const yA = yTop;
	                    const xB = xK;
	                    const yB0 = yK;
	                    const dx = xB - xA;
	                    if (Math.abs(dx) > 1e-9) {
	                      const xTarget = xR;
	                      const t = (xTarget - xA) / dx;
	                      const yHit = yA + (t * (yB0 - yA));
	                      if (yHit >= 0 && yHit <= BH0) {
	                        contexto.moveTo(xK, yK);
	                        contexto.lineTo(xTarget, yHit);
	                      }
	                    }
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

		              case 18: {
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  // Parámetros según plano 18.
	                  const B1 = gr.form_B1;
	                  const B2 = gr.form_B2;
	                  const B3 = gr.form_B3;
	                  const L  = gr.form_L;
	                  const L1 = gr.form_L1;
	                  const H  = gr.form_H;
	                  const H1 = gr.form_H1;

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (lo coloca el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  // ancho total = B1 + L + B3
	                  // alto total  = B2 + H + B3
	                  const BW0 = (B1 + L + B3) * zoom;
	                  const BH0 = (B2 + H + B3) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL (como si rot=0) ---
	                  const xL = B1 * zoom;
	                  const xR = xL + (L * zoom);
	                  const yTop = B2 * zoom;
	                  const yBase = yTop + (H * zoom);
	                  const xK = xR - (Math.min(L, L1) * zoom);
	                  const yK = yBase - (Math.min(H, H1) * zoom);

	                  // Contorno: base izq -> base der -> vertical der -> lado sup der descendente -> base izq
	                  contexto.moveTo(xL, yBase);
	                  contexto.lineTo(xR, yBase);
	                  contexto.lineTo(xR, yTop);
	                  contexto.lineTo(xK, yK);
	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  // Bandas auxiliares B1/B3 y línea auxiliar oblicua.
	                  contexto.beginPath();
	                  contexto.moveTo(xL, 0);
	                  contexto.lineTo(xL, BH0);
	                  contexto.moveTo(xR, 0);
	                  contexto.lineTo(xR, BH0);
	                  contexto.moveTo(0, yTop);
	                  contexto.lineTo(BW0, yTop);
	                  contexto.moveTo(0, yBase);
	                  contexto.lineTo(BW0, yBase);
	                  {
	                    const xA = xR;
	                    const yA = yTop;
	                    const xB = xK;
	                    const yB0 = yK;
	                    const dx = xB - xA;
	                    if (Math.abs(dx) > 1e-9) {
	                      const xTarget = xL;
	                      const t = (xTarget - xA) / dx;
	                      const yHit = yA + (t * (yB0 - yA));
	                      if (yHit >= 0 && yHit <= BH0) {
	                        contexto.moveTo(xK, yK);
	                        contexto.lineTo(xTarget, yHit);
	                      }
	                    }
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
		                }
		              }

		              case 19: {
		                contexto.save();
		                try {
		                  contexto.beginPath();

		                  // Parámetros según plano 19 (octágono simétrico).
		                  const B1 = gr.form_B1; // margen horizontal izq/der
		                  const B2 = gr.form_B2; // margen vertical sup/inf
		                  const L  = gr.form_L;  // ancho útil entre verticales
		                  const L1 = gr.form_L1; // retranqueo horizontal de chaflanes superior/inferior
		                  const H  = gr.form_H;  // alto útil entre bandas superior e inferior
		                  const H1 = gr.form_H1; // retranqueo vertical de chaflanes laterales

		                  const { left, top } = disbandIn;

		                  const rotRaw =
		                    (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
		                  const rot = ((rotRaw % 360) + 360) % 360;

		                  const bx = (left + x_plus + p_1.x) * zoom;
		                  const by = (top  + y_plus + p_1.y) * zoom;

		                  // BBox base de la figura 19
		                  const BW0 = (B1 + L + B1) * zoom;
		                  const BH0 = (B2 + H + B2) * zoom;

		                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
		                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

		                  contexto.translate(bx, by);
		                  if (rot === 90) {
		                    contexto.translate(BW, 0);
		                    contexto.rotate(Math.PI / 2);
		                  } else if (rot === 180) {
		                    contexto.translate(BW, BH);
		                    contexto.rotate(Math.PI);
		                  } else if (rot === 270) {
		                    contexto.translate(0, BH);
		                    contexto.rotate(-Math.PI / 2);
		                  }

		                  // Sistema local sin rotación
		                  const xL = B1 * zoom;
		                  const xR = xL + L * zoom;
		                  const yT = B2 * zoom;
		                  const yB = yT + H * zoom;

		                  const xLT = xL + L1 * zoom;
		                  const xRT = xR - L1 * zoom;
		                  const yVT = yT + H1 * zoom;
		                  const yVB = yB - H1 * zoom;

		                  // Recorrido horario (8 lados)
		                  contexto.moveTo(xLT, yT);
		                  contexto.lineTo(xRT, yT);
		                  contexto.lineTo(xR,  yVT);
		                  contexto.lineTo(xR,  yVB);
		                  contexto.lineTo(xRT, yB);
		                  contexto.lineTo(xLT, yB);
		                  contexto.lineTo(xL,  yVB);
		                  contexto.lineTo(xL,  yVT);
		                  contexto.closePath();

		                  if (this.fileForm.controls.f_fill_piece.value) {
		                    contexto.fill();
		                  }
		                  contexto.stroke();

		                  break;
		                } finally {
		                  contexto.restore();
		                }
		              }

		              case 20: {
		                contexto.save();
		                try {
		                  contexto.beginPath();

		                  // Parámetros según plano 20.
		                  const B1 = gr.form_B1;
		                  const B2 = gr.form_B2;
		                  const L  = gr.form_L;
		                  const triH = (Math.sqrt(3) / 2) * L;

		                  const { left, top } = disbandIn;

		                  const rotRaw =
		                    (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
		                  const rot = ((rotRaw % 360) + 360) % 360;

		                  const bx = (left + x_plus + p_1.x) * zoom;
		                  const by = (top  + y_plus + p_1.y) * zoom;

		                  const BW0 = (B1 + L + B1) * zoom;
		                  const BH0 = (B1 + triH + B2) * zoom;

		                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
		                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

		                  contexto.translate(bx, by);
		                  if (rot === 90) {
		                    contexto.translate(BW, 0);
		                    contexto.rotate(Math.PI / 2);
		                  } else if (rot === 180) {
		                    contexto.translate(BW, BH);
		                    contexto.rotate(Math.PI);
		                  } else if (rot === 270) {
		                    contexto.translate(0, BH);
		                    contexto.rotate(-Math.PI / 2);
		                  }

		                  const xL = B1 * zoom;
		                  const xR = xL + L * zoom;
		                  const xApex = xL + (L * zoom) / 2;
		                  const yApex = B1 * zoom;
		                  const yBase = yApex + triH * zoom;

		                  // Recorrido horario.
		                  contexto.moveTo(xL, yBase);
		                  contexto.lineTo(xApex, yApex);
		                  contexto.lineTo(xR, yBase);
		                  contexto.closePath();

		                  if (this.fileForm.controls.f_fill_piece.value) {
		                    contexto.fill();
		                  }
		                  contexto.stroke();

		                  break;
		                } finally {
		                  contexto.restore();
		                }
		              }
		              case 21:
		              case 22:
		              case 23:
		              case 24: {
		                contexto.save();
		                try {
		                  contexto.beginPath();
		                  const n = Number(gr.form_id) - 16;
		                  const L = gr.form_L;
		                  const B1 = gr.form_B1;
		                  const B2 = gr.form_B2;
		                  const sideBand = (Number(gr.form_id) === 24) ? B1 : B2;
		                  const bottomBand = B1;
		                  const topBand = B1;
		                  const R = L / (2 * Math.sin(Math.PI / n));
		                  const a = L / (2 * Math.tan(Math.PI / n));
		                  let polyW = 2 * R;
		                  let polyH = a + R;
		                  if (Number(gr.form_id) === 22) {
		                    polyH = 2 * a;
		                  } else if (Number(gr.form_id) === 24) {
		                    polyW = 2 * a;
		                    polyH = 2 * a;
		                  }
		                  const BW0 = (polyW + (2 * sideBand)) * zoom;
		                  const BH0 = (polyH + bottomBand + topBand) * zoom;
		                  const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
		                  const rot = ((rotRaw % 360) + 360) % 360;
		                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
		                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
		                  const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
		                  const by = (disbandIn.top + y_plus + p_1.y) * zoom;
		                  contexto.translate(bx, by);
		                  if (rot === 90) {
		                    contexto.translate(BW, 0);
		                    contexto.rotate(Math.PI / 2);
		                  } else if (rot === 180) {
		                    contexto.translate(BW, BH);
		                    contexto.rotate(Math.PI);
		                  } else if (rot === 270) {
		                    contexto.translate(0, BH);
		                    contexto.rotate(-Math.PI / 2);
		                  }
		                  let cx = sideBand + R;
		                  let cy = bottomBand + a;
		                  if (Number(gr.form_id) === 24) {
		                    cx = sideBand + a;
		                    cy = bottomBand + a;
		                  }
		                  cx = cx * zoom;
		                  cy = cy * zoom;
		                  const start = (-Math.PI / 2) - (Math.PI / n);
		                  for (let i = 0; i < n; i++) {
		                    const ang = start + (i * 2 * Math.PI / n);
		                    const x = cx + (R * Math.cos(ang) * zoom);
		                    const y = cy + (R * Math.sin(ang) * zoom);
		                    if (i === 0) {
		                      contexto.moveTo(x, y);
		                    } else {
		                      contexto.lineTo(x, y);
		                    }
		                  }
		                  contexto.closePath();
		                  if (this.fileForm.controls.f_fill_piece.value) {
		                    contexto.fill();
		                  }
		                  contexto.stroke();
		                  break;
		                } finally {
		                  contexto.restore();
		                }
		              }

		            case 25: {

		          contexto.save();
	              try {
	                contexto.beginPath();

	                // Interpretación según plano:
	                // B1: margen horizontal (izq/der)
	                // B3: margen superior
	                // B2: margen inferior
	                const B1 = gr.form_B1;
	                const B2 = gr.form_B2;
	                const B3 = gr.form_B3;

	                const L  = gr.form_L;   // ancho útil
	                const H  = gr.form_H;   // alto útil
	                const R0 = gr.form_R;   // radio de redondeo superior

	                const { left, top } = disbandIn;

	                // Normaliza rotación (sin ??)
	                const rotRaw =
	                  (gr.rotation !== undefined && gr.rotation !== null)
	                    ? gr.rotation
	                    : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;

	                // Top-left del bbox (lo posiciona el optimizador; es "post-rotación")
	                const bx = (left + x_plus + p_1.x) * zoom;
	                const by = (top  + y_plus + p_1.y) * zoom;

	                // BBox en orientación base (rotation=0): ancho = L + 2*B1, alto = H + B2 + B3
	                const BW0 = (L + 2 * B1) * zoom;
	                const BH0 = (H + B2 + B3) * zoom;

	                // Tamaño del bbox ya rotado (para anclar bien)
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                // --- Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox ---
	                // (Convención: gr.rotation en sentido horario)
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }

	                // --- Dibujo LOCAL como si rot=0 (redondeo SOLO en esquinas superiores) ---
	                // Origen del área útil dentro del bbox
	                const x0 = B1 * zoom;
	                const y0 = B3 * zoom;

	                const w  = L * zoom;
	                const h  = H * zoom;

	                const x1 = x0 + w;
	                const y1 = y0 + h;

	                // Clamp radio: no puede superar L/2 ni H
	                const r = Math.min(R0, L / 2, H) * zoom;

	                // Recorrido horario
	                contexto.moveTo(x0 + r, y0);

	                // superior
	                contexto.lineTo(x1 - r, y0);
	                contexto.arcTo(x1, y0, x1, y0 + r, r);

	                // derecha
	                contexto.lineTo(x1, y1);

	                // inferior
	                contexto.lineTo(x0, y1);

	                // izquierda
	                contexto.lineTo(x0, y0 + r);
	                contexto.arcTo(x0, y0, x0 + r, y0, r);

	                contexto.closePath();

	                if (this.fileForm.controls.f_fill_piece.value) {
	                  contexto.fill();
	                }
	                contexto.stroke();
	                // Banda auxiliar inferior B2.
	                contexto.beginPath();
	                contexto.moveTo(0, y1);
	                contexto.lineTo(BW0, y1);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
				}
	            case 26: {
	                // Código para dibujar la figura 26 en el optimizador
	                contexto.beginPath();

	                console.log('-> Trazando forma 26:');
	                console.log(gr);

					  // B1 = margen horizontal (izq/der)
		              // B2 = margen vertical   (arriba/abajo)
		              const B1 = gr.form_B1;
		              const B2 = gr.form_B2;

		              const L  = gr.form_L;
		              const H  = gr.form_H;
		              const R  = gr.form_R;

		              const { left, top } = disbandIn;

		              // Normaliza rotación (sin operador ??)
		              const rotRaw =
		                (gr.rotation !== undefined && gr.rotation !== null)
		                  ? gr.rotation
		                  : 0;
		              const rot = ((rotRaw % 360) + 360) % 360;

		              // --- Ajuste por rotación (clave) ---
		              // El optimizador ya te coloca el bbox rotado; aquí solo adaptamos dimensiones/márgenes.
		              let Lr = L;
		              let Hr = H;
		              let B1r = B1; // margen X
		              let B2r = B2; // margen Y

		              if (rot === 90 || rot === 270) {
		                // Al rotar 90/270: ancho <-> alto, y márgenes X <-> Y
		                Lr = H;
		                Hr = L;
		                B1r = B2;
		                B2r = B1;
		              }

		              // Origen de la pieza útil dentro del bbox ya rotado
		              const x0 = (left + x_plus + p_1.x + B1r) * zoom;
		              const y0 = (top  + y_plus + p_1.y + B2r) * zoom;

		              const x1 = x0 + Lr * zoom;
		              const y1 = y0 + Hr * zoom;

		              // Clamp radio (evita geometrías imposibles)
		              const r = Math.min(R, Lr / 2, Hr / 2) * zoom;

		              // Rounded-rect horario
		              contexto.moveTo(x0 + r, y0);

		              contexto.lineTo(x1 - r, y0);
		              contexto.arcTo(x1, y0, x1, y0 + r, r);

		              contexto.lineTo(x1, y1 - r);
		              contexto.arcTo(x1, y1, x1 - r, y1, r);

		              contexto.lineTo(x0 + r, y1);
		              contexto.arcTo(x0, y1, x0, y1 - r, r);

		              contexto.lineTo(x0, y0 + r);
		              contexto.arcTo(x0, y0, x0 + r, y0, r);

		              contexto.closePath();

		              if (this.fileForm.controls.f_fill_piece.value) {
		                contexto.fill();
		              }

		              contexto.stroke();
		              break;
	              }
	            case 28: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = gr.form_B1;
	                const B2 = gr.form_B2;
	                const B3 = gr.form_B3;
	                const L = gr.form_L;
	                const H = gr.form_H;
	                const H1 = gr.form_H1;
	                const R = gr.form_R;
	                const geometry28 = this.buildFigure28Geometry(B1, B2, B3, L, H, H1, R, false);
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const localWidth = geometry28 ? geometry28.width : (B1 + L + B2);
	                const localHeight = geometry28 ? geometry28.height : (H + B3);
	                const BW0 = localWidth * zoom;
	                const BH0 = localHeight * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const xL = (geometry28 ? geometry28.xLeft : B1) * zoom;
	                const xR = (geometry28 ? geometry28.xRight : (B1 + L)) * zoom;
	                const xPrimitiveLeft = geometry28 ? (geometry28.primitiveLeft * zoom) : xL;
	                const xPrimitiveRight = geometry28 ? (geometry28.primitiveRight * zoom) : xR;
	                const yFromBottomToCanvas = (yFromBottom) => ((localHeight - yFromBottom) * zoom);
	                const yBottom = geometry28 ? geometry28.yBottom : 0;
	                const yB = yFromBottomToCanvas(yBottom);
	                const yL = yFromBottomToCanvas(geometry28 ? geometry28.yLeft : H);
	                const yR = yFromBottomToCanvas(geometry28 ? geometry28.yRight : H1);
	                contexto.moveTo(xL, yB);
	                contexto.lineTo(xR, yB);
	                contexto.lineTo(xR, yR);
	                if (geometry28) {
	                  const arcPoints = geometry28.arcPoints.slice().reverse();
	                  for (let i = 1; i < arcPoints.length; i++) {
	                    contexto.lineTo(arcPoints[i].x * zoom, yFromBottomToCanvas(arcPoints[i].y));
	                  }
	                } else {
	                  // Compatibilidad con datos históricos sin un R válido.
	                  const yTop = yFromBottomToCanvas(H + B3);
	                  contexto.quadraticCurveTo(((xL + xR) / 2), yTop, xL, yL);
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) {
	                  contexto.fill();
	                }
	                contexto.stroke();
	                // Las bandas auxiliares sólo existen cuando tienen anchura.
	                if (B1 > 0.000001 || B2 > 0.000001) {
	                  contexto.beginPath();
	                  if (B1 > 0.000001) {
	                    contexto.moveTo(xPrimitiveLeft, yFromBottomToCanvas(0));
	                    contexto.lineTo(xPrimitiveLeft, yFromBottomToCanvas(localHeight));
	                  }
	                  if (B2 > 0.000001) {
	                    contexto.moveTo(xPrimitiveRight, yFromBottomToCanvas(0));
	                    contexto.lineTo(xPrimitiveRight, yFromBottomToCanvas(localHeight));
	                  }
	                  contexto.stroke();
	                }
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 30:
	            case 31: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const formId = Number(gr.form_id);
	                const B1 = gr.form_B1;
	                const L = gr.form_L;
	                const H = gr.form_H;
	                const H1 = gr.form_H1;
	                const H2 = gr.form_H2;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = (B1 + L + B1) * zoom;
	                const BH0 = H * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const xL = B1 * zoom;
	                const xR = (B1 + L) * zoom;
	                const y0 = 0;
	                const y1 = H * zoom;
	                contexto.rect(xL, y0, (xR - xL), y1);
	                if (this.fileForm.controls.f_fill_piece.value) {
	                  contexto.fill();
	                }
	                contexto.stroke();
	                contexto.beginPath();
	                const yFromBottomToCanvas = (yFromBottom) => ((H - yFromBottom) * zoom);
	                const yLeft = yFromBottomToCanvas(formId === 30 ? (H - H2) : H1);
	                const yRight = yFromBottomToCanvas(formId === 30 ? H1 : (H - H2));
	                contexto.moveTo(xL, yLeft);
	                contexto.lineTo(xR, yRight);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 32: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = gr.form_B1;
	                const B2 = gr.form_B2;
	                const L = gr.form_L;
	                const L1 = gr.form_L1;
	                const L2 = gr.form_L2;
	                const H = gr.form_H;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = (B1 + L + B1) * zoom;
	                const BH0 = (B2 + H + B2) * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const xL = B1 * zoom;
	                const xR = (B1 + L) * zoom;
	                const yFromBottomToCanvas = (yFromBottom) => ((B2 + H + B2 - yFromBottom) * zoom);
	                const yB = yFromBottomToCanvas(B2);
	                const yT = yFromBottomToCanvas(B2 + H);
	                const xTL = (B1 + L1) * zoom;
	                const xTM = (B1 + L1 + L2) * zoom;
	                const xBR = (B1 + L - L1) * zoom;
	                const xBM = (B1 + L - L1 - L2) * zoom;
	                contexto.moveTo(xL, yB);
	                contexto.lineTo(xBR, yB);
	                contexto.lineTo(xR, yT);
	                contexto.lineTo(xTL, yT);
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) {
	                  contexto.fill();
	                }
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo(xTM, yT);
	                contexto.lineTo(xBM, yB);
	                contexto.moveTo(0, yB);
	                contexto.lineTo(BW0, yB);
	                contexto.moveTo(0, yT);
	                contexto.lineTo(BW0, yT);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 33:
	            case 34: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const formId = Number(gr.form_id);
	                const B1 = gr.form_B1;
	                const B2 = gr.form_B2;
	                const L = gr.form_L;
	                const H = gr.form_H;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = (B2 + L + B2) * zoom;
	                const BH0 = (B2 + H + B2) * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((B2 + H + B2 - yFromBottom) * zoom);
	                const xL = B2 * zoom;
	                const xR = (B2 + L) * zoom;
	                const yB = yFromBottomToCanvas(B2);
	                const yT = yFromBottomToCanvas(B2 + H);
	                contexto.rect(xL, yT, (xR - xL), (yB - yT));
	                if (this.fileForm.controls.f_fill_piece.value) {
	                  contexto.fill();
	                }
	                contexto.stroke();
	                contexto.beginPath();
	                if (formId === 33) {
	                  contexto.moveTo(xL, yT);
	                  contexto.lineTo(xR, yFromBottomToCanvas(B2 + B1));
	                  contexto.moveTo(xL, yFromBottomToCanvas(B2 + H - B1));
	                  contexto.lineTo(xR, yB);
	                } else {
	                  contexto.moveTo(xL, yFromBottomToCanvas(B2 + B1));
	                  contexto.lineTo(xR, yT);
	                  contexto.moveTo(xL, yB);
	                  contexto.lineTo(xR, yFromBottomToCanvas(B2 + H - B1));
	                }
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo(xL, yFromBottomToCanvas(0));
	                contexto.lineTo(xL, yFromBottomToCanvas(B2 + H + B2));
	                contexto.moveTo(xR, yFromBottomToCanvas(0));
	                contexto.lineTo(xR, yFromBottomToCanvas(B2 + H + B2));
	                contexto.moveTo(0, yB);
	                contexto.lineTo((B2 + L + B2) * zoom, yB);
	                contexto.moveTo(0, yT);
	                contexto.lineTo((B2 + L + B2) * zoom, yT);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 35:
	            case 36: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const formId = Number(gr.form_id);
	                const B1 = gr.form_B1;
	                const B2 = gr.form_B2;
	                const L = gr.form_L;
	                const L1 = gr.form_L1;
	                const H = gr.form_H;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = (B1 + L + B1) * zoom;
	                const BH0 = (B2 + H + B2) * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((B2 + H + B2 - yFromBottom) * zoom);
	                const yB = yFromBottomToCanvas(B2);
	                const yT = yFromBottomToCanvas(B2 + H);
	                let xBL = B1;
	                let xBR = B1 + L - L1;
	                let xTR = B1 + L;
	                let xTL = B1 + L1;
	                if (formId === 36) {
	                  xBL = B1 + L1;
	                  xBR = B1 + L;
	                  xTR = B1 + L - L1;
	                  xTL = B1;
	                }
	                const xBM = (xBL + xBR) / 2;
	                const xTM = (xTL + xTR) / 2;
	                contexto.moveTo(xBL * zoom, yB);
	                contexto.lineTo(xBR * zoom, yB);
	                contexto.lineTo(xTR * zoom, yT);
	                contexto.lineTo(xTL * zoom, yT);
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) {
	                  contexto.fill();
	                }
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo(xBM * zoom, yB);
	                contexto.lineTo(xTM * zoom, yT);
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(B2 + H + B2));
	                contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(B2 + H + B2));
	                contexto.moveTo(0, yB);
	                contexto.lineTo((B1 + L + B1) * zoom, yB);
	                contexto.moveTo(0, yT);
	                contexto.lineTo((B1 + L + B1) * zoom, yT);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 38: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = gr.form_B1;
	                const B2 = gr.form_B2;
	                const L = gr.form_L;
	                const L1 = gr.form_L1;
	                const H = gr.form_H;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = (B1 + L + B1) * zoom;
	                const BH0 = (B2 + H + B2) * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((B2 + H + B2 - yFromBottom) * zoom);
	                const yB = yFromBottomToCanvas(B2);
	                const yT = yFromBottomToCanvas(B2 + H);
	                const xTL = B1 * zoom;
	                const xTR = (B1 + L - L1) * zoom;
	                const xBR = (B1 + L) * zoom;
	                const xBL = (B1 + L1) * zoom;
	                contexto.moveTo(xBL, yB);
	                contexto.lineTo(xBR, yB);
	                contexto.lineTo(xTR, yT);
	                contexto.lineTo(xTL, yT);
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) {
	                  contexto.fill();
	                }
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(B2 + H + B2));
	                contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(B2 + H + B2));
	                contexto.moveTo(0, yB);
	                contexto.lineTo((B1 + L + B1) * zoom, yB);
	                contexto.moveTo(0, yT);
	                contexto.lineTo((B1 + L + B1) * zoom, yT);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 40: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = gr.form_B1;
	                const B2 = gr.form_B2;
	                const B3 = gr.form_B3;
	                const L = gr.form_L;
	                const L1 = gr.form_L1;
	                const H = gr.form_H;
	                const H1 = gr.form_H1;
	                const H2 = gr.form_H2;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = (B1 + L + B1) * zoom;
	                const BH0 = (B2 + H + B3) * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((B2 + H + B3 - yFromBottom) * zoom);
	                const xL = B1 * zoom;
	                const xR = (B1 + L) * zoom;
	                const xA = (B1 + L1) * zoom;
	                const yB = yFromBottomToCanvas(B2);
	                const yT = yFromBottomToCanvas(B2 + H);
	                const yL = yFromBottomToCanvas(B2 + H1);
	                const yR = yFromBottomToCanvas(B2 + H2);
	                contexto.moveTo(xL, yB);
	                contexto.lineTo(xR, yB);
	                contexto.lineTo(xR, yR);
	                contexto.lineTo(xA, yT);
	                contexto.lineTo(xL, yL);
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) {
	                  contexto.fill();
	                }
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(B2 + H + B3));
	                contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(B2 + H + B3));
	                contexto.moveTo(0, yB);
	                contexto.lineTo((B1 + L + B1) * zoom, yB);
	                contexto.moveTo(0, yT);
	                contexto.lineTo((B1 + L + B1) * zoom, yT);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 41: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = gr.form_B1;
	                const B2 = gr.form_B2;
	                const B3 = gr.form_B3;
	                const L = gr.form_L;
	                const L1 = gr.form_L1;
	                const L2 = gr.form_L2;
	                const H = gr.form_H;
	                let d1 = 0;
	                let yShoulder = H * 0.5;
	                const dMin = 0;
	                const dMax = Math.min(L1, L2 - (L / 2));
	                if (dMax > dMin && H > 0) {
	                  const f = (d) => {
	                    const a1 = (L1 * L1) - (d * d);
	                    const b1 = (L2 * L2) - ((d + (L / 2)) * (d + (L / 2)));
	                    if (a1 < 0 || b1 < 0) return -H;
	                    return Math.sqrt(a1) + Math.sqrt(b1) - H;
	                  };
	                  let lo = dMin;
	                  let hi = dMax;
	                  let flo = f(lo);
	                  let fhi = f(hi);
	                  if (flo === 0) {
	                    d1 = lo;
	                  } else if (fhi === 0) {
	                    d1 = hi;
	                  } else if ((flo > 0 && fhi < 0) || (flo < 0 && fhi > 0)) {
	                    for (let i = 0; i < 40; i++) {
	                      const mid = (lo + hi) / 2;
	                      const fmid = f(mid);
	                      if (fmid === 0) {
	                        lo = mid;
	                        hi = mid;
	                        break;
	                      }
	                      if ((flo > 0 && fmid > 0) || (flo < 0 && fmid < 0)) {
	                        lo = mid;
	                        flo = fmid;
	                      } else {
	                        hi = mid;
	                        fhi = fmid;
	                      }
	                    }
	                    d1 = (lo + hi) / 2;
	                  }
	                  const rem = (L1 * L1) - (d1 * d1);
	                  if (rem >= 0) {
	                    yShoulder = Math.sqrt(rem);
	                  }
	                }
	                const W0 = B1 + L + (2 * d1) + B3;
	                const H0 = H + B2;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xSL = B1 * zoom;
	                const xBL = (B1 + d1) * zoom;
	                const xBR = (B1 + d1 + L) * zoom;
	                const xSR = (B1 + d1 + L + d1) * zoom;
	                const xA = (B1 + d1 + (L / 2)) * zoom;
	                const yB = yFromBottomToCanvas(0);
	                const yS = yFromBottomToCanvas(yShoulder);
	                const yT = yFromBottomToCanvas(H);
	                contexto.moveTo(xBL, yB);
	                contexto.lineTo(xBR, yB);
	                contexto.lineTo(xSR, yS);
	                contexto.lineTo(xA, yT);
	                contexto.lineTo(xSL, yS);
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) {
	                  contexto.fill();
	                }
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(((W0 - B3) * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo(((W0 - B3) * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yFromBottomToCanvas(H));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(H));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 42: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = gr.form_B1;
	                const B2 = gr.form_B2;
	                const L = gr.form_L;
	                const L1 = gr.form_L1;
	                const L2 = gr.form_L2;
	                const H = gr.form_H;
	                const H1 = gr.form_H1;
	                const H2 = gr.form_H2;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = (B1 + L + B1) * zoom;
	                const BH0 = (B2 + H + B2) * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((B2 + H + B2 - yFromBottom) * zoom);
	                const xL = B1 * zoom;
	                const xR = (B1 + L) * zoom;
	                const yB = yFromBottomToCanvas(B2);
	                const yT = yFromBottomToCanvas(B2 + H);
	                const xTopCh = (B1 + L1) * zoom;
	                const yLeftCh = yFromBottomToCanvas(B2 + H - H1);
	                const xBotCh = (B1 + L - L2) * zoom;
	                const yRightCh = yFromBottomToCanvas(B2 + H2);
	                contexto.moveTo(xL, yB);
	                contexto.lineTo(xBotCh, yB);
	                contexto.lineTo(xR, yRightCh);
	                contexto.lineTo(xR, yT);
	                contexto.lineTo(xTopCh, yT);
	                contexto.lineTo(xL, yLeftCh);
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) {
	                  contexto.fill();
	                }
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(B2 + H + B2));
	                contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(B2 + H + B2));
	                contexto.moveTo(0, yB);
	                contexto.lineTo((B1 + L + B1) * zoom, yB);
	                contexto.moveTo(0, yT);
	                contexto.lineTo((B1 + L + B1) * zoom, yT);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 44: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const L = Number(gr.form_L || 0);
	                const L1 = Number(gr.form_L1 || 0);
	                const L2 = Number(gr.form_L2 || 0);
	                let xApex = (L / 2);
	                let hTri = 0;
	                if (L > 0) {
	                  xApex = ((L1 * L1) - (L2 * L2) + (L * L)) / (2 * L);
	                  const hSq = (L1 * L1) - (xApex * xApex);
	                  if (hSq > 0) hTri = Math.sqrt(hSq);
	                }
	                const W0 = B1 + L + B1;
	                const H0 = B2 + hTri + B2;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xL = B1 * zoom;
	                const xR = (B1 + L) * zoom;
	                const xT = (B1 + xApex) * zoom;
	                const yB = yFromBottomToCanvas(B2);
	                const yT = yFromBottomToCanvas(B2 + hTri);
	                contexto.moveTo(xL, yB);
	                contexto.lineTo(xR, yB);
	                contexto.lineTo(xT, yT);
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
		                contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
		                contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yB);
	                contexto.lineTo((W0 * zoom), yB);
	                contexto.moveTo(0, yT);
	                contexto.lineTo((W0 * zoom), yT);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 45:
	            case 46: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const formId = Number(gr.form_id);
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const B3 = Number(gr.form_B3 || 0);
	                const L = Number(gr.form_L || 0);
	                const H = Number(gr.form_H || 0);
	                const L1 = Number(gr.form_L1 || 0);
	                const L2 = Number(gr.form_L2 || 0);
	                let cx = L;
	                let cy = H;
	                if (formId === 45) {
	                  const l1c = Math.max(0, Math.min(H, L1));
	                  const l2c = Math.max(0, Math.min(L, L2));
	                  cx = L - l2c;
	                  cy = H - l1c;
	                  if (cy < 0) cy = 0;
	                } else {
	                  const d = Math.sqrt((L * L) + (H * H));
	                  if (d > 0) {
	                    const a = ((L1 * L1) - (L2 * L2) + (d * d)) / (2 * d);
	                    const hSq = (L1 * L1) - (a * a);
	                    if (hSq >= 0) {
	                      const hh = Math.sqrt(hSq);
	                      const ux = L / d;
	                      const uy = -H / d;
	                      const p2x = a * ux;
	                      const p2y = H + (a * uy);
	                      const c1x = p2x - (hh * uy);
	                      const c1y = p2y + (hh * ux);
	                      const c2x = p2x + (hh * uy);
	                      const c2y = p2y - (hh * ux);
	                      if (c1y >= c2y) { cx = c1x; cy = c1y; } else { cx = c2x; cy = c2y; }
	                    }
	                  }
	                }
	                const innerW = formId === 46 ? Math.max(L, cx) : L;
	                const innerH = formId === 46 ? Math.max(H, cy) : H;
	                const W0 = B1 + innerW + B3;
	                const H0 = B2 + innerH + B3;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xA = B1 * zoom;
	                const xD = (B1 + L) * zoom;
	                const xC = (B1 + cx) * zoom;
	                const yA = yFromBottomToCanvas(B2);
	                const yBv = yFromBottomToCanvas(B2 + H);
	                const yC = yFromBottomToCanvas(B2 + cy);
		                contexto.moveTo(xA, yA);
		                contexto.lineTo(xA, yBv);
		                contexto.lineTo(xC, yC);
		                contexto.lineTo(xD, yA);
		                contexto.closePath();
		                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
		                contexto.stroke();
		                contexto.beginPath();
		                if (formId === 46) {
		                  contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
		                  contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
		                  contexto.moveTo(0, yFromBottomToCanvas(B2));
		                  contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
		                  const xBmm = B1;
		                  const yBmm = B2 + H;
		                  const xCmm = B1 + cx;
		                  const yCmm = B2 + cy;
		                  if (xCmm !== xBmm) {
		                    const tExt = (W0 - xCmm) / (xCmm - xBmm);
		                    const yExt = yCmm + (tExt * (yCmm - yBmm));
		                    if (isFinite(yExt) && yExt >= 0 && yExt <= H0) {
		                      contexto.moveTo((xCmm * zoom), yFromBottomToCanvas(yCmm));
		                      contexto.lineTo((W0 * zoom), yFromBottomToCanvas(yExt));
		                    }
		                  }
		                } else if (formId === 45) {
		                  contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
		                  contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
		                  contexto.moveTo(0, yFromBottomToCanvas(B2));
		                  contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
		                  const xBmm = B1;
		                  const yBmm = B2 + H;
		                  const xCmm = B1 + cx;
		                  const yCmm = B2 + cy;
		                  if (xCmm !== xBmm) {
		                    const tExt = (W0 - xCmm) / (xCmm - xBmm);
		                    const yExt = yCmm + (tExt * (yCmm - yBmm));
		                    if (isFinite(yExt) && yExt >= 0 && yExt <= H0) {
		                      contexto.moveTo((xCmm * zoom), yFromBottomToCanvas(yCmm));
		                      contexto.lineTo((W0 * zoom), yFromBottomToCanvas(yExt));
		                    }
		                  }
		                } else {
		                  contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
		                  contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
		                  contexto.moveTo(((W0 - B3) * zoom), yFromBottomToCanvas(0));
		                  contexto.lineTo(((W0 - B3) * zoom), yFromBottomToCanvas(H0));
		                  contexto.moveTo(0, yA);
		                  contexto.lineTo((W0 * zoom), yA);
		                  contexto.moveTo(0, yFromBottomToCanvas(B2 + innerH));
		                  contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2 + innerH));
		                }
		                contexto.stroke();
		                break;
		              } finally {
		                contexto.restore();
		              }
	            }
	            case 47:
	            case 49: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const formId = Number(gr.form_id);
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const B3 = Number(gr.form_B3 || 0);
	                const L = Number(gr.form_L || 0);
	                const L1 = Number(gr.form_L1 || 0);
	                const L2 = Number(gr.form_L2 || 0);
	                const H = Number(gr.form_H || 0);
	                const H1 = Number(gr.form_H1 || 0);
	                const W0 = B1 + L + B1;
	                const H0 = B2 + H + B3;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xA = B1 * zoom;
	                const yA = yFromBottomToCanvas(B2);
	                const xB = (B1 + L1) * zoom;
	                const yBv = yFromBottomToCanvas(B2 + H);
	                let xCmm = B1 + L - L2;
	                const xDmm = B1 + L;
	                if (formId === 49 && H > 0) {
	                  const xBR = B1 + L - L2;
	                  const dxTopRight = (L1 * H1) / H;
	                  xCmm = xBR + dxTopRight;
	                  if (xCmm > xDmm) xCmm = xDmm;
	                }
	                const xC = xCmm * zoom;
	                const yC = yFromBottomToCanvas(B2 + H1);
	                let xD = (B1 + L) * zoom;
	                if (formId === 49) {
	                  xD = (B1 + L - L2) * zoom;
	                }
	                const yD = yFromBottomToCanvas(B2);
	                contexto.moveTo(xA, yA);
	                contexto.lineTo(xB, yBv);
	                contexto.lineTo(xC, yC);
	                contexto.lineTo(xD, yD);
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
		                contexto.beginPath();
		                if (formId === 49) {
		                  contexto.moveTo(0, yFromBottomToCanvas(B2));
		                  contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
		                  const xAmm = B1;
		                  const yAmm = B2;
		                  const xBmm = B1 + L1;
		                  const yBmm = B2 + H;
		                  const xCmmAux = xCmm;
		                  const yCmm = B2 + H1;
		                  if (yBmm !== yAmm) {
		                    const tTop = (H0 - yBmm) / (yBmm - yAmm);
		                    const xTopExt = xBmm + (tTop * (xBmm - xAmm));
		                    if (isFinite(xTopExt) && xTopExt >= 0 && xTopExt <= W0) {
		                      contexto.moveTo((xBmm * zoom), yFromBottomToCanvas(yBmm));
		                      contexto.lineTo((xTopExt * zoom), yFromBottomToCanvas(H0));
		                    }
		                  }
		                  if (xCmmAux !== xBmm) {
		                    const tRight = (W0 - xCmmAux) / (xCmmAux - xBmm);
		                    const yRightExt = yCmm + (tRight * (yCmm - yBmm));
		                    if (isFinite(yRightExt) && yRightExt >= 0 && yRightExt <= H0) {
		                      contexto.moveTo((xCmmAux * zoom), yFromBottomToCanvas(yCmm));
		                      contexto.lineTo((W0 * zoom), yFromBottomToCanvas(yRightExt));
		                    }
		                  }
		                } else {
		                  contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
		                  contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
			              contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
			              contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(H0));
		                  contexto.moveTo(0, yFromBottomToCanvas(B2));
		                  contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
		                  contexto.moveTo(0, yFromBottomToCanvas(B2 + H));
		                  contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2 + H));
		                }
		                contexto.stroke();
		                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 48: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const B3 = Number(gr.form_B3 || 0);
	                const L = Number(gr.form_L || 0);
	                const L1 = Number(gr.form_L1 || 0);
	                const L2 = Number(gr.form_L2 || 0);
	                const H = Number(gr.form_H || 0);
	                const H1 = Number(gr.form_H1 || 0);
	                const H2 = Number(gr.form_H2 || 0);
	                const W0 = B1 + L + B1;
	                const H0 = B2 + H + B3;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const pts = [
	                  { x: B1 + L1, y: B2 },
	                  { x: B1 + L - L1, y: B2 },
	                  { x: B1 + L, y: B2 + H1 },
	                  { x: B1 + L, y: B2 + H - H2 },
	                  { x: B1 + L - L2, y: B2 + H },
	                  { x: B1 + L2, y: B2 + H },
	                  { x: B1, y: B2 + H - H2 },
	                  { x: B1, y: B2 + H1 }
	                ];
	                contexto.moveTo(pts[0].x * zoom, yFromBottomToCanvas(pts[0].y));
	                for (let i = 1; i < pts.length; i++) {
	                  contexto.lineTo(pts[i].x * zoom, yFromBottomToCanvas(pts[i].y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
		                contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
		                contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yFromBottomToCanvas(B2));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
	                contexto.moveTo(0, yFromBottomToCanvas(B2 + H));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2 + H));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 51: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const B3 = Number(gr.form_B3 || 0);
	                const L = Number(gr.form_L || 0);
	                const R = Number(gr.form_R || 0);
	                const halfL = L / 2;
	                let d = 0;
	                let h = 0;
	                if (R > 0 && halfL <= R) {
	                  d = Math.sqrt((R * R) - (halfL * halfL));
	                  h = R - d;
	                }
	                const W0 = B1 + L + B1;
	                const H0 = B2 + h + B3;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xL = B1;
	                const xR = B1 + L;
	                const xC = B1 + halfL;
	                const yChord = B2;
	                const yCenter = B2 - d;
	                const xLz = xL * zoom;
	                const xRz = xR * zoom;
	                const yChordZ = yFromBottomToCanvas(yChord);
	                contexto.moveTo(xLz, yChordZ);
	                if (R > 0 && halfL <= R) {
	                  const n = 24;
	                  const leftAng = Math.atan2(d, -halfL);
	                  const rightAng = Math.atan2(d, halfL);
	                  for (let i = 0; i <= n; i++) {
	                    const t = i / n;
	                    const ang = leftAng + ((rightAng - leftAng) * t);
	                    const x = xC + (R * Math.cos(ang));
	                    const y = yCenter + (R * Math.sin(ang));
	                    contexto.lineTo(x * zoom, yFromBottomToCanvas(y));
	                  }
	                } else {
	                  contexto.lineTo(xRz, yChordZ);
	                }
	                contexto.lineTo(xRz, yChordZ);
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo(0, yChordZ);
	                contexto.lineTo((W0 * zoom), yChordZ);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 52: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const L = Number(gr.form_L || 0);
	                const H = Number(gr.form_H || 0);
	                const Rv = Number(gr.form_R || 0);
	                const Rh = Number(gr.form_R2 || 0);
	                const W0 = B1 + L + B1;
	                const H0 = B2 + H + B2;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xOuterL = B1;
	                const xOuterR = B1 + L;
	                const yB = B2;
	                const yT = B2 + H;
	                let rs = Rv > 0 ? Rv : (H / 2);
	                let rt = Rh > 0 ? Rh : (L / 2);
	                const halfL = L / 2;
	                if (rt <= 0) rt = halfL;
	                if (rs <= 0) rs = H / 2;
	                let ss = 0;
	                let st = 0;
	                for (let it = 0; it < 12; it++) {
	                  let cTop = halfL - ss;
	                  if (cTop < 0.001) cTop = 0.001;
	                  if (cTop >= rt) cTop = rt - 0.001;
	                  if (cTop < 0.001) cTop = 0.001;
	                  st = rt - Math.sqrt(Math.max(0, (rt * rt) - (cTop * cTop)));
	                  const halfSide = Math.max(0.001, (H / 2) - st);
	                  if (rs <= halfSide) rs = halfSide + 0.001;
	                  const ssNew = rs - Math.sqrt(Math.max(0, (rs * rs) - (halfSide * halfSide)));
	                  if (Math.abs(ssNew - ss) < 0.0001) {
	                    ss = ssNew;
	                    break;
	                  }
	                  ss = ssNew;
	                }
	                if (ss < 0) ss = 0;
	                if (ss > (halfL - 0.001)) ss = halfL - 0.001;
	                const xLV = xOuterL + ss;
	                const xRV = xOuterR - ss;
	                let cTopFinal = (xRV - xLV) / 2;
	                if (cTopFinal < 0.001) cTopFinal = 0.001;
	                if (cTopFinal >= rt) rt = cTopFinal + 0.001;
	                st = rt - Math.sqrt(Math.max(0, (rt * rt) - (cTopFinal * cTopFinal)));
	                const yVTop = yT - st;
	                const yVBot = yB + st;
	                const halfSideFinal = Math.max(0.001, (yVTop - yVBot) / 2);
	                if (rs <= halfSideFinal) rs = halfSideFinal + 0.001;
	                const yMid = (yVTop + yVBot) / 2;
	                const cxLeft = xOuterL + rs;
	                const cxRight = xOuterR - rs;
	                const xMid = (xOuterL + xOuterR) / 2;
	                const cyTop = yT - rt;
	                const cyBottom = yB + rt;
	                const topY = (x) => {
	                  const dx = x - xMid;
	                  const rad = (rt * rt) - (dx * dx);
	                  const root = rad > 0 ? Math.sqrt(rad) : 0;
	                  return cyTop + root;
	                };
	                const bottomY = (x) => {
	                  const dx = x - xMid;
	                  const rad = (rt * rt) - (dx * dx);
	                  const root = rad > 0 ? Math.sqrt(rad) : 0;
	                  return cyBottom - root;
	                };
	                const nTop = 24;
	                const nSide = 20;
	                const pts = [];
	                const addPt = (x, y) => {
	                  const last = pts.length > 0 ? pts[pts.length - 1] : null;
	                  if (!last || Math.abs(last.x - x) > 0.000001 || Math.abs(last.y - y) > 0.000001) pts.push({ x: x, y: y });
	                };
	                addPt(xLV, yVTop);
	                for (let i = 1; i <= nTop; i++) {
	                  const t = i / nTop;
	                  const x = xLV + ((xRV - xLV) * t);
	                  addPt(x, topY(x));
	                }
	                for (let i = 1; i <= nSide; i++) {
	                  const t = i / nSide;
	                  const y = yVTop + ((yVBot - yVTop) * t);
	                  const dy = y - yMid;
	                  const rad = (rs * rs) - (dy * dy);
	                  const root = rad > 0 ? Math.sqrt(rad) : 0;
	                  addPt(cxRight + root, y);
	                }
	                for (let i = 1; i <= nTop; i++) {
	                  const t = i / nTop;
	                  const x = xRV + ((xLV - xRV) * t);
	                  addPt(x, bottomY(x));
	                }
	                for (let i = 1; i <= nSide; i++) {
	                  const t = i / nSide;
	                  const y = yVBot + ((yVTop - yVBot) * t);
	                  const dy = y - yMid;
	                  const rad = (rs * rs) - (dy * dy);
	                  const root = rad > 0 ? Math.sqrt(rad) : 0;
	                  addPt(cxLeft - root, y);
	                }
	                addPt(xLV, yVTop);
	                contexto.moveTo(pts[0].x * zoom, yFromBottomToCanvas(pts[0].y));
	                for (let i = 1; i < pts.length; i++) {
	                  contexto.lineTo(pts[i].x * zoom, yFromBottomToCanvas(pts[i].y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                const drawArcByX = (x0, x1, yAtX) => {
	                  const nAux = 16;
	                  for (let i = 0; i <= nAux; i++) {
	                    const t = i / nAux;
	                    const x = x0 + ((x1 - x0) * t);
	                    const y = yAtX(x);
	                    if (i === 0) contexto.moveTo(x * zoom, yFromBottomToCanvas(y));
	                    else contexto.lineTo(x * zoom, yFromBottomToCanvas(y));
	                  }
	                };
	                drawArcByX(0, xLV, topY);
	                drawArcByX(xRV, W0, topY);
	                drawArcByX(0, xLV, bottomY);
	                drawArcByX(xRV, W0, bottomY);
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 53: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const L = Number(gr.form_L || 0);
	                const H = Number(gr.form_H || 0);
	                const W0 = B1 + L + B1;
	                const H0 = B2 + H + B2;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xc = B1 + (L / 2);
	                const yc = B2 + (H / 2);
	                const rx = L / 2;
	                const ry = H / 2;
	                const n = 40;
	                for (let i = 0; i <= n; i++) {
	                  const a = (2 * Math.PI * i) / n;
	                  const x = xc + (rx * Math.cos(a));
	                  const y = yc + (ry * Math.sin(a));
	                  if (i === 0) contexto.moveTo(x * zoom, yFromBottomToCanvas(y));
	                  else contexto.lineTo(x * zoom, yFromBottomToCanvas(y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
		                contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
		                contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yFromBottomToCanvas(B2));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
	                contexto.moveTo(0, yFromBottomToCanvas(B2 + H));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2 + H));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 54: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const L1 = Number(gr.form_L1 || 0);
	                const L2 = Number(gr.form_L2 || 0);
	                const H1 = Number(gr.form_H1 || 0);
	                const H2 = Number(gr.form_H2 || 0);
	                const W0 = B1 + L1 + L2 + B1;
	                const H0 = B2 + H1 + H2 + B2;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const x0 = B1 + L1;
	                const y0 = B2 + H1;
	                const n = 56;
	                for (let i = 0; i <= n; i++) {
	                  const a = (2 * Math.PI * i) / n;
	                  const c = Math.cos(a);
	                  const s = Math.sin(a);
	                  const rx = c >= 0 ? L2 : L1;
	                  const ry = s >= 0 ? H2 : H1;
	                  const x = x0 + (rx * c);
	                  const y = y0 + (ry * s);
	                  if (i === 0) contexto.moveTo(x * zoom, yFromBottomToCanvas(y));
	                  else contexto.lineTo(x * zoom, yFromBottomToCanvas(y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(((B1 + L1 + L2) * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo(((B1 + L1 + L2) * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yFromBottomToCanvas(B2));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
	                contexto.moveTo(0, yFromBottomToCanvas(B2 + H1 + H2));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2 + H1 + H2));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 56: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const L = Number(gr.form_L || 0);
	                const H = Number(gr.form_H || 0);
	                let R = Number(gr.form_R || 0);
	                let R1 = Number(gr.form_R2 || 0);
	                let R2 = Number(gr.form_R3 || 0);
	                let R3 = Number(gr.form_R4 || 0);
	                const W0 = B1 + L + B1;
	                const H0 = B2 + H + B2;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                if ((R1 + R2) > L) { const s = L / (R1 + R2); R1 *= s; R2 *= s; }
	                if ((R + R3) > L) { const s = L / (R + R3); R *= s; R3 *= s; }
	                if ((R1 + R) > H) { const s = H / (R1 + R); R1 *= s; R *= s; }
	                if ((R2 + R3) > H) { const s = H / (R2 + R3); R2 *= s; R3 *= s; }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xL = B1;
	                const xR = B1 + L;
	                const yB = B2;
	                const yT = B2 + H;
	                const n = 12;
	                const pts = [];
	                const addPt = (x, y) => {
	                  const nPts = pts.length;
	                  if (nPts > 0) {
	                    const p = pts[nPts - 1];
	                    if (Math.abs(p.x - x) < 0.000001 && Math.abs(p.y - y) < 0.000001) return;
	                  }
	                  pts.push({ x, y });
	                };
	                addPt(xL + R, yB);
	                addPt(xR - R3, yB);
	                for (let i = 0; i <= n; i++) {
	                  const a = Math.PI + (i * ((Math.PI / 2) - Math.PI) / n);
	                  addPt(xR + (R3 * Math.cos(a)), yB + (R3 * Math.sin(a)));
	                }
	                addPt(xR, yT - R2);
	                for (let i = 0; i <= n; i++) {
	                  const a = (-Math.PI / 2) + (i * ((-Math.PI) - (-Math.PI / 2)) / n);
	                  addPt(xR + (R2 * Math.cos(a)), yT + (R2 * Math.sin(a)));
	                }
	                addPt(xL + R1, yT);
	                for (let i = 0; i <= n; i++) {
	                  const a = i * ((-Math.PI / 2) / n);
	                  addPt(xL + (R1 * Math.cos(a)), yT + (R1 * Math.sin(a)));
	                }
	                addPt(xL, yB + R);
	                for (let i = 0; i < n; i++) {
	                  const a = (Math.PI / 2) + (i * (0 - (Math.PI / 2)) / n);
	                  addPt(xL + (R * Math.cos(a)), yB + (R * Math.sin(a)));
	                }
	                contexto.moveTo(pts[0].x * zoom, yFromBottomToCanvas(pts[0].y));
	                for (let i = 1; i < pts.length; i++) {
	                  contexto.lineTo(pts[i].x * zoom, yFromBottomToCanvas(pts[i].y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
		                contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
		                contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yFromBottomToCanvas(B2));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
	                contexto.moveTo(0, yFromBottomToCanvas(B2 + H));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2 + H));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 57: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const B3 = Number(gr.form_B3 || 0);
	                const L = Number(gr.form_L || 0);
	                const H = Number(gr.form_H || 0);
	                const H1 = Number(gr.form_H1 || 0);
	                let R = Number(gr.form_R || 0);
	                let R1 = Number(gr.form_R2 || 0);
	                let R2 = Number(gr.form_R3 || 0);
	                const W0 = B1 + L + B1;
	                const H0 = B2 + Math.max(H, H1) + B3;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xL = B1;
	                const xR = B1 + L;
	                const yB = B2;
	                const yTopL = B2 + H;
	                const yTopR = B2 + H1;
	                R1 = Math.max(0, Math.min(R1, L / 2, H));
	                R2 = Math.max(0, Math.min(R2, L / 2, H1));
	                const pArcA = { x: xL, y: yTopL };
	                const pArcB = { x: xR, y: yTopR };
	                const dxAB = pArcB.x - pArcA.x;
	                const dyAB = pArcB.y - pArcA.y;
	                const dAB = Math.sqrt((dxAB * dxAB) + (dyAB * dyAB));
	                const pts = [];
	                const addPt = (x, y) => {
	                  const nPts = pts.length;
	                  if (nPts > 0) {
	                    const p = pts[nPts - 1];
	                    if (Math.abs(p.x - x) < 0.000001 && Math.abs(p.y - y) < 0.000001) return;
	                  }
	                  pts.push({ x, y });
	                };
	                const addArcByRadius = (p0, p1, radius, preferUpper) => {
	                  const dx = p1.x - p0.x;
	                  const dy = p1.y - p0.y;
	                  const d = Math.sqrt((dx * dx) + (dy * dy));
	                  if (d <= 0.000001 || radius <= 0.000001) {
	                    addPt(p1.x, p1.y);
	                    return;
	                  }
	                  if (preferUpper) {
	                    const dxAbs = Math.abs(dx);
	                    const yUpperLimit = H0;
	                    const roomTop = Math.max(1, yUpperLimit - Math.max(p0.y, p1.y));
	                    const qx = (p0.x * 0.72) + (p1.x * 0.28);
	                    const qy = Math.min(yUpperLimit, Math.max(p0.y, p1.y) + Math.max(80, Math.min(radius * 2.4, roomTop * 0.98)));
	                    const nArc = 96;
	                    for (let i = 1; i < nArc; i++) {
	                      const t = i / nArc;
	                      const u = 1 - t;
	                      const x = (u * u * p0.x) + (2 * u * t * qx) + (t * t * p1.x);
	                      let y = (u * u * p0.y) + (2 * u * t * qy) + (t * t * p1.y);
	                      if (y > yUpperLimit) y = yUpperLimit;
	                      addPt(x, y);
	                    }
	                    addPt(p1.x, p1.y);
	                    return;
	                  }
	                  const yUpperLimit = preferUpper ? (yB + Math.max(H, H1)) : H0;
	                  const yMax = Math.max(p0.y, p1.y);
	                  const yMin = Math.min(p0.y, p1.y);
	                  const roomUp = Math.max(0, yUpperLimit - yMax);
	                  const roomDown = Math.max(0, yMin - yB);
	                  if (preferUpper && roomUp <= 0.000001) {
	                    const cp1 = { x: p0.x + (dx * 0.22), y: Math.min(yUpperLimit, p0.y + Math.max(1, (radius * 0.35))) };
	                    const cp2 = { x: p1.x + Math.max(180, Math.min(Math.abs(dx) * 0.6, 900)), y: Math.max(yB, p1.y - Math.max(20, Math.min(radius * 2.2, (p1.y - yB) * 0.6))) };
	                    const nArc = 96;
	                    for (let i = 1; i <= nArc; i++) {
	                      const t = i / nArc;
	                      const u = 1 - t;
	                      const x = (u * u * u * p0.x) + (3 * u * u * t * cp1.x) + (3 * u * t * t * cp2.x) + (t * t * t * p1.x);
	                      let y = (u * u * u * p0.y) + (3 * u * u * t * cp1.y) + (3 * u * t * t * cp2.y) + (t * t * t * p1.y);
	                      if (preferUpper && y > yUpperLimit) y = yUpperLimit;
	                      addPt(x, y);
	                    }
	                    return;
	                  }
	                  let curveUp = preferUpper;
	                  if (curveUp && roomUp <= 0.000001 && roomDown > 0.000001) curveUp = false;
	                  if (!curveUp && roomDown <= 0.000001 && roomUp > 0.000001) curveUp = true;
	                  const maxCtrl = Math.max(1, (curveUp ? roomUp : roomDown) * 0.98);
	                  let c = Math.max(1, Math.min(radius, maxCtrl));
	                  const s = curveUp ? 1 : -1;
	                  const evalArcY = (ctrl) => {
	                    const cp1t = { x: p0.x, y: p0.y + (s * ctrl) };
	                    const cp2t = { x: p1.x, y: p1.y + (s * ctrl) };
	                    let top = -Infinity;
	                    let bottom = Infinity;
	                    const nEval = 24;
	                    for (let k = 1; k <= nEval; k++) {
	                      const t = k / nEval;
	                      const u = 1 - t;
	                      const y = (u * u * u * p0.y) + (3 * u * u * t * cp1t.y) + (3 * u * t * t * cp2t.y) + (t * t * t * p1.y);
	                      if (y > top) top = y;
	                      if (y < bottom) bottom = y;
	                    }
	                    return { top, bottom };
	                  };
	                  for (let it = 0; it < 8; it++) {
	                    const evalY = evalArcY(c);
	                    if (curveUp) {
	                      if (evalY.top <= (yUpperLimit + 0.000001)) break;
	                      const den = evalY.top - yMax;
	                      if (den <= 0.000001) break;
	                      const scale = (yUpperLimit - yMax) / den;
	                      c = Math.max(1, c * Math.max(0.1, Math.min(0.95, scale)));
	                    } else {
	                      if (evalY.bottom >= (yB - 0.000001)) break;
	                      const den = yMin - evalY.bottom;
	                      if (den <= 0.000001) break;
	                      const scale = (yMin - yB) / den;
	                      c = Math.max(1, c * Math.max(0.1, Math.min(0.95, scale)));
	                    }
	                  }
	                  const cp1 = { x: p0.x, y: p0.y + (s * c) };
	                  const cp2 = { x: p1.x, y: p1.y + (s * c) };
	                  if (preferUpper && curveUp) {
	                    cp2.y = Math.max(yB, p1.y - Math.max(20, Math.min(c * 2.4, (p1.y - yB) * 0.6)));
	                    cp2.x = p1.x + Math.max(180, Math.min(Math.abs(dx) * 0.6, 900));
	                  }
	                  const nArc = 96;
	                  for (let i = 1; i < nArc; i++) {
	                    const t = i / nArc;
	                    const u = 1 - t;
	                    const x = (u * u * u * p0.x) + (3 * u * u * t * cp1.x) + (3 * u * t * t * cp2.x) + (t * t * t * p1.x);
	                    let y = (u * u * u * p0.y) + (3 * u * u * t * cp1.y) + (3 * u * t * t * cp2.y) + (t * t * t * p1.y);
	                    if (preferUpper && y > yUpperLimit) y = yUpperLimit;
	                    addPt(x, y);
	                  }
	                  addPt(p1.x, p1.y);
	                };
	                addPt(xL + R1, yB);
	                addPt(xR - R2, yB);
	                if (R2 > 0) {
	                  const nBR = 12;
	                  for (let i = 1; i <= nBR; i++) {
	                    const a = (-Math.PI / 2) + (i * (Math.PI / 2) / nBR);
	                    addPt((xR - R2) + (R2 * Math.cos(a)), (yB + R2) + (R2 * Math.sin(a)));
	                  }
	                }
	                addPt(xR, yTopR);
	                addArcByRadius(pArcB, pArcA, R, true);
	                addPt(xL, yB + R1);
	                if (R1 > 0) {
	                  const nBL = 12;
	                  for (let i = 1; i <= nBL; i++) {
	                    const a = Math.PI + (i * (Math.PI / 2) / nBL);
	                    addPt((xL + R1) + (R1 * Math.cos(a)), (yB + R1) + (R1 * Math.sin(a)));
	                  }
	                }
	                contexto.moveTo(pts[0].x * zoom, yFromBottomToCanvas(pts[0].y));
	                for (let i = 1; i < pts.length; i++) {
	                  contexto.lineTo(pts[i].x * zoom, yFromBottomToCanvas(pts[i].y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
		                contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
		                contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yFromBottomToCanvas(B2));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 58: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const B3 = Number(gr.form_B3 || 0);
	                const L = Number(gr.form_L || 0);
	                const H = Number(gr.form_H || 0);
	                const H1 = Number(gr.form_H1 || 0);
	                let R = Number(gr.form_R || 0);
	                let R1 = Number(gr.form_R2 || 0);
	                let R2 = Number(gr.form_R3 || 0);
	                const W0 = B1 + L + B1;
	                const H0 = B2 + Math.max(H, H1) + B3;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xL = B1;
	                const xR = B1 + L;
	                const yB = B2;
	                const yTopL = B2 + H;
	                const yTopR = B2 + H1;
	                R1 = Math.max(0, Math.min(R1, L / 2, H));
	                R2 = Math.max(0, Math.min(R2, L / 2, H1));
	                const pArcA = { x: xL, y: yTopL };
	                const pArcB = { x: xR, y: yTopR };
	                const dxAB = pArcB.x - pArcA.x;
	                const dyAB = pArcB.y - pArcA.y;
	                const dAB = Math.sqrt((dxAB * dxAB) + (dyAB * dyAB));
	                const pts = [];
	                const addPt = (x, y) => {
	                  const nPts = pts.length;
	                  if (nPts > 0) {
	                    const p = pts[nPts - 1];
	                    if (Math.abs(p.x - x) < 0.000001 && Math.abs(p.y - y) < 0.000001) return;
	                  }
	                  pts.push({ x, y });
	                };
	                const addArcByRadius = (p0, p1, radius, preferUpper) => {
	                  const dx = p1.x - p0.x;
	                  const dy = p1.y - p0.y;
	                  const d = Math.sqrt((dx * dx) + (dy * dy));
	                  if (d <= 0.000001 || radius <= 0.000001) {
	                    addPt(p1.x, p1.y);
	                    return;
	                  }
	                  if (preferUpper) {
	                    const dxAbs = Math.abs(dx);
	                    const yUpperLimit = H0;
	                    const roomTop = Math.max(1, yUpperLimit - Math.max(p0.y, p1.y));
	                    const qx = (p0.x * 0.72) + (p1.x * 0.28);
	                    const qy = Math.min(yUpperLimit, Math.max(p0.y, p1.y) + Math.max(80, Math.min(radius * 2.4, roomTop * 0.98)));
	                    const nArc = 96;
	                    for (let i = 1; i < nArc; i++) {
	                      const t = i / nArc;
	                      const u = 1 - t;
	                      const x = (u * u * p0.x) + (2 * u * t * qx) + (t * t * p1.x);
	                      let y = (u * u * p0.y) + (2 * u * t * qy) + (t * t * p1.y);
	                      if (y > yUpperLimit) y = yUpperLimit;
	                      addPt(x, y);
	                    }
	                    addPt(p1.x, p1.y);
	                    return;
	                  }
	                  const yUpperLimit = preferUpper ? (yB + Math.max(H, H1)) : H0;
	                  const yMax = Math.max(p0.y, p1.y);
	                  const yMin = Math.min(p0.y, p1.y);
	                  const roomUp = Math.max(0, yUpperLimit - yMax);
	                  const roomDown = Math.max(0, yMin - yB);
	                  if (preferUpper && roomUp <= 0.000001) {
	                    const cp1 = { x: p0.x + (dx * 0.22), y: Math.min(yUpperLimit, p0.y + Math.max(1, (radius * 0.35))) };
	                    const cp2 = { x: p1.x + Math.max(180, Math.min(Math.abs(dx) * 0.6, 900)), y: Math.max(yB, p1.y - Math.max(20, Math.min(radius * 2.2, (p1.y - yB) * 0.6))) };
	                    const nArc = 96;
	                    for (let i = 1; i <= nArc; i++) {
	                      const t = i / nArc;
	                      const u = 1 - t;
	                      const x = (u * u * u * p0.x) + (3 * u * u * t * cp1.x) + (3 * u * t * t * cp2.x) + (t * t * t * p1.x);
	                      let y = (u * u * u * p0.y) + (3 * u * u * t * cp1.y) + (3 * u * t * t * cp2.y) + (t * t * t * p1.y);
	                      if (preferUpper && y > yUpperLimit) y = yUpperLimit;
	                      addPt(x, y);
	                    }
	                    return;
	                  }
	                  let curveUp = preferUpper;
	                  if (curveUp && roomUp <= 0.000001 && roomDown > 0.000001) curveUp = false;
	                  if (!curveUp && roomDown <= 0.000001 && roomUp > 0.000001) curveUp = true;
	                  const maxCtrl = Math.max(1, (curveUp ? roomUp : roomDown) * 0.98);
	                  let c = Math.max(1, Math.min(radius, maxCtrl));
	                  const s = curveUp ? 1 : -1;
	                  const evalArcY = (ctrl) => {
	                    const cp1t = { x: p0.x, y: p0.y + (s * ctrl) };
	                    const cp2t = { x: p1.x, y: p1.y + (s * ctrl) };
	                    let top = -Infinity;
	                    let bottom = Infinity;
	                    const nEval = 24;
	                    for (let k = 1; k <= nEval; k++) {
	                      const t = k / nEval;
	                      const u = 1 - t;
	                      const y = (u * u * u * p0.y) + (3 * u * u * t * cp1t.y) + (3 * u * t * t * cp2t.y) + (t * t * t * p1.y);
	                      if (y > top) top = y;
	                      if (y < bottom) bottom = y;
	                    }
	                    return { top, bottom };
	                  };
	                  for (let it = 0; it < 8; it++) {
	                    const evalY = evalArcY(c);
	                    if (curveUp) {
	                      if (evalY.top <= (yUpperLimit + 0.000001)) break;
	                      const den = evalY.top - yMax;
	                      if (den <= 0.000001) break;
	                      const scale = (yUpperLimit - yMax) / den;
	                      c = Math.max(1, c * Math.max(0.1, Math.min(0.95, scale)));
	                    } else {
	                      if (evalY.bottom >= (yB - 0.000001)) break;
	                      const den = yMin - evalY.bottom;
	                      if (den <= 0.000001) break;
	                      const scale = (yMin - yB) / den;
	                      c = Math.max(1, c * Math.max(0.1, Math.min(0.95, scale)));
	                    }
	                  }
	                  const cp1 = { x: p0.x, y: p0.y + (s * c) };
	                  const cp2 = { x: p1.x, y: p1.y + (s * c) };
	                  if (preferUpper && curveUp) {
	                    cp2.y = Math.max(yB, p1.y - Math.max(20, Math.min(c * 2.4, (p1.y - yB) * 0.6)));
	                    cp2.x = p1.x + Math.max(180, Math.min(Math.abs(dx) * 0.6, 900));
	                  }
	                  const nArc = 96;
	                  for (let i = 1; i < nArc; i++) {
	                    const t = i / nArc;
	                    const u = 1 - t;
	                    const x = (u * u * u * p0.x) + (3 * u * u * t * cp1.x) + (3 * u * t * t * cp2.x) + (t * t * t * p1.x);
	                    let y = (u * u * u * p0.y) + (3 * u * u * t * cp1.y) + (3 * u * t * t * cp2.y) + (t * t * t * p1.y);
	                    if (preferUpper && y > yUpperLimit) y = yUpperLimit;
	                    addPt(x, y);
	                  }
	                  addPt(p1.x, p1.y);
	                };
	                addPt(xL + R1, yB);
	                addPt(xR - R2, yB);
	                if (R2 > 0) {
	                  const nBR = 12;
	                  for (let i = 1; i <= nBR; i++) {
	                    const a = (-Math.PI / 2) + (i * (Math.PI / 2) / nBR);
	                    addPt((xR - R2) + (R2 * Math.cos(a)), (yB + R2) + (R2 * Math.sin(a)));
	                  }
	                }
	                addPt(xR, yTopR);
	                addArcByRadius(pArcB, pArcA, R, false);
	                addPt(xL, yB + R1);
	                if (R1 > 0) {
	                  const nBL = 12;
	                  for (let i = 1; i <= nBL; i++) {
	                    const a = Math.PI + (i * (Math.PI / 2) / nBL);
	                    addPt((xL + R1) + (R1 * Math.cos(a)), (yB + R1) + (R1 * Math.sin(a)));
	                  }
	                }
	                contexto.moveTo(pts[0].x * zoom, yFromBottomToCanvas(pts[0].y));
	                for (let i = 1; i < pts.length; i++) {
	                  contexto.lineTo(pts[i].x * zoom, yFromBottomToCanvas(pts[i].y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
		                contexto.moveTo(((B1 + L) * zoom), yFromBottomToCanvas(0));
		                contexto.lineTo(((B1 + L) * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yFromBottomToCanvas(B2));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
	                contexto.moveTo(0, yFromBottomToCanvas(B2 + Math.max(H, H1)));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2 + Math.max(H, H1)));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
		            case 59: {
			          contexto.save();
		              try {
		                contexto.beginPath();
		                const B1 = Number(gr.form_B1 || 0);
		                const B2 = Number(gr.form_B2 || 0);
		                const H = Number(gr.form_H || 0);
		                const side = H;
		                const W0 = B1 + side + B2;
		                const H0 = B1 + H + B2;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
		                const xL = B1;
		                const xR = B1 + side;
		                const yB = B1;
		                const yT = B1 + H;
		                const n = 28;
		                const pts = [];
		                pts.push({ x: xL, y: yB });
		                pts.push({ x: xR, y: yB });
		                for (let i = 1; i <= n; i++) {
		                  const a = (i * (Math.PI / 2) / n);
		                  pts.push({ x: xL + (side * Math.cos(a)), y: yB + (H * Math.sin(a)) });
		                }
	                contexto.moveTo(pts[0].x * zoom, yFromBottomToCanvas(pts[0].y));
	                for (let i = 1; i < pts.length; i++) {
	                  contexto.lineTo(pts[i].x * zoom, yFromBottomToCanvas(pts[i].y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
		                contexto.moveTo(((B1 + side) * zoom), yFromBottomToCanvas(0));
		                contexto.lineTo(((B1 + side) * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yFromBottomToCanvas(B1));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B1));
	                contexto.moveTo(0, yFromBottomToCanvas(B1 + H));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B1 + H));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 60: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const B3 = Number(gr.form_B3 || 0);
	                const L = Number(gr.form_L || 0);
	                const H = Number(gr.form_H || 0);
	                let H1 = Number(gr.form_H1 || 0);
	                if (H1 > H) H1 = H;
	                const W0 = B1 + L + B3;
	                const H0 = B2 + H + B3;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xL = B1;
	                const xR = B1 + L;
	                const yB = B2;
	                const yA = B2 + H;
	                const p0 = { x: xR, y: yB };
	                const p1 = { x: xL, y: yA };
	                const dx = p1.x - p0.x;
	                const dy = p1.y - p0.y;
	                const d = Math.sqrt((dx * dx) + (dy * dy));
	                if (H1 <= 0) H1 = d / 4;
	                if (H1 >= (d / 2)) H1 = (d / 2) - 0.000001;
	                const xMin = xL;
	                const xMax = xR + B3;
	                const yMin = yB;
	                const yMax = yA + B3;
	                const pts = [];
	                const addPt = (x, y) => {
	                  const nPts = pts.length;
	                  if (nPts > 0) {
	                    const p = pts[nPts - 1];
	                    if (Math.abs(p.x - x) < 0.000001 && Math.abs(p.y - y) < 0.000001) return;
	                  }
	                  pts.push({ x, y });
	                };
	                const addCatalogArc = (a0p, a1p, sagitta) => {
	                  const ddx = a1p.x - a0p.x;
	                  const ddy = a1p.y - a0p.y;
	                  const dd = Math.sqrt((ddx * ddx) + (ddy * ddy));
	                  if (dd <= 0.000001) {
	                    addPt(a1p.x, a1p.y);
	                    return;
	                  }
	                  let s = Number(sagitta || 0);
	                  if (s <= 0.000001) s = dd / 4;
	                  if (s >= (dd / 2)) s = (dd / 2) - 0.000001;
	                  let best = null;
	                  const nEval = 72;
	                  const rr = ((dd * dd) / (8 * s)) + (s / 2);
	                  const mx = (a0p.x + a1p.x) / 2;
	                  const my = (a0p.y + a1p.y) / 2;
	                  const uxChord = ddx / dd;
	                  const uyChord = ddy / dd;
	                  const nx = -uyChord;
	                  const ny = uxChord;
	                  const h = rr - s;
	                  const centers = [
	                    { x: mx + (nx * h), y: my + (ny * h) },
	                    { x: mx - (nx * h), y: my - (ny * h) }
	                  ];
	                  for (let cIdx = 0; cIdx < centers.length; cIdx++) {
	                    const c = centers[cIdx];
	                    const ang0 = Math.atan2(a0p.y - c.y, a0p.x - c.x);
	                    const ang1 = Math.atan2(a1p.y - c.y, a1p.x - c.x);
	                    let dMinor = ang1 - ang0;
	                    while (dMinor > Math.PI) dMinor -= (2 * Math.PI);
	                    while (dMinor <= -Math.PI) dMinor += (2 * Math.PI);
	                    const deltas = [dMinor];
	                    for (let k = 0; k < deltas.length; k++) {
	                      const da = deltas[k];
	                      let overflow = 0;
	                      for (let s = 1; s < nEval; s++) {
	                        const t = s / nEval;
	                        const a = ang0 + (da * t);
	                        const x = c.x + (rr * Math.cos(a));
	                        const y = c.y + (rr * Math.sin(a));
	                        if (x < xMin) overflow += (xMin - x);
	                        else if (x > xMax) overflow += (x - xMax);
	                        if (y < yMin) overflow += (yMin - y);
	                        else if (y > yMax) overflow += (y - yMax);
	                      }
	                      const centerBias = ((c.x - xL) * 1.2) + (c.y - yB);
	                      const candidate = { c, rr, ang0, da, overflow, centerBias };
	                      if (
	                        best === null ||
	                        candidate.overflow < best.overflow ||
	                        (candidate.overflow === best.overflow && candidate.centerBias < best.centerBias) ||
	                        (candidate.overflow === best.overflow && candidate.centerBias === best.centerBias && Math.abs(candidate.da) < Math.abs(best.da))
	                      ) {
	                        best = candidate;
	                      }
	                    }
	                  }
	                  if (best === null) {
	                    addPt(a1p.x, a1p.y);
	                    return;
	                  }
	                  const nArc = 24;
	                  for (let i = 1; i <= nArc; i++) {
	                    const t = i / nArc;
	                    const a = best.ang0 + (best.da * t);
	                    const x = best.c.x + (best.rr * Math.cos(a));
	                    const y = best.c.y + (best.rr * Math.sin(a));
	                    addPt(x, y);
	                  }
	                };
	                addPt(xL, yB);
	                addPt(xR, yB);
	                addCatalogArc(p0, p1, H1);
	                addPt(xL, yB);
	                contexto.moveTo(pts[0].x * zoom, yFromBottomToCanvas(pts[0].y));
	                for (let i = 1; i < pts.length; i++) {
	                  contexto.lineTo(pts[i].x * zoom, yFromBottomToCanvas(pts[i].y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yFromBottomToCanvas(B2));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 61: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const B3 = Number(gr.form_B3 || 0);
	                const L = Number(gr.form_L || 0);
	                const H = Number(gr.form_H || 0);
	                const RIn = Number(gr.form_R || 0);
	                const minContainR = this.computeFigure61ContainmentMinRadius(L, H);
	                const R = (RIn > minContainR) ? RIn : minContainR;
	                const cx = B1 + (L / 2);
	                const cy = B2 + (H / 2);
	                const W0 = (cx + R) + B3;
	                const H0 = (cy + R) + B3;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xL = B1;
	                const xR = B1 + L;
	                const yB = B2;
	                const yT = B2 + H;
	                const best = this.resolveFigure61BestArc(xL, xR, yB, yT, R);
	                const pts = [{ x: xL, y: yB }, best ? { x: best.pStart.x, y: best.pStart.y } : { x: xR, y: yB }];
                if (best) {
                  const nArc = 64;
                  for (let i = 1; i <= nArc; i++) {
                    const t = i / nArc;
                    const a = best.c.a0 + (best.da * t);
                    pts.push({ x: best.c.x + (R * Math.cos(a)), y: best.c.y + (R * Math.sin(a)) });
                  }
                } else {
                  pts.push({ x: xL, y: yT });
                }
                pts.push({ x: xL, y: yB });
	                contexto.moveTo(pts[0].x * zoom, yFromBottomToCanvas(pts[0].y));
	                for (let i = 1; i < pts.length; i++) {
	                  contexto.lineTo(pts[i].x * zoom, yFromBottomToCanvas(pts[i].y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(0, yFromBottomToCanvas(B2));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(B2));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 62: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const B3 = Number(gr.form_B3 || 0);
	                const L = Number(gr.form_L || 0);
	                const RIn = Number(gr.form_R || 0);
	                const AIn = Number(gr.form_R2 || 0);
	                let angleRad = (AIn * Math.PI) / 180;
	                if (angleRad < (1 * Math.PI / 180)) angleRad = 1 * Math.PI / 180;
	                if (angleRad > (120 * Math.PI / 180)) angleRad = 120 * Math.PI / 180;
	                const R = Math.max(0.000001, RIn);
	                const rIn = Math.max(0, R - L);
	                const cosA = Math.cos(angleRad);
	                const leftNeedOuter = rIn - (R * cosA);
	                const leftNeedInner = rIn * (1 - cosA);
	                const leftExtra = Math.max(0, rIn - B1, leftNeedOuter, leftNeedInner);
	                const shapeH = (angleRad <= (Math.PI / 2)) ? Math.max(0, (R * Math.sin(angleRad))) : R;
	                const W0 = B1 + L + B2 + leftExtra;
	                const H0 = (2 * B3) + shapeH;
	                const yBase = B3;
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                const xC = B1 + leftExtra - rIn;
	                const yC = yBase;
	                const pI0 = { x: xC + rIn, y: yC };
	                const pO0 = { x: xC + R, y: yC };
	                const pI1 = { x: xC + (rIn * Math.cos(angleRad)), y: yC + (rIn * Math.sin(angleRad)) };
	                const pO1 = { x: xC + (R * Math.cos(angleRad)), y: yC + (R * Math.sin(angleRad)) };
	                const pts = [];
	                pts.push({ x: pI0.x, y: pI0.y });
	                pts.push({ x: pO0.x, y: pO0.y });
	                const nRight = 48;
	                for (let i = 1; i <= nRight; i++) {
	                  const t = i / nRight;
	                  const a = t * angleRad;
	                  pts.push({ x: xC + (R * Math.cos(a)), y: yC + (R * Math.sin(a)) });
	                }
	                pts.push({ x: pI1.x, y: pI1.y });
	                const nLeft = 24;
	                for (let i = 1; i <= nLeft; i++) {
	                  const t = i / nLeft;
	                  const a = angleRad * (1 - t);
	                  pts.push({ x: xC + (rIn * Math.cos(a)), y: yC + (rIn * Math.sin(a)) });
	                }
	                contexto.moveTo(pts[0].x * zoom, yFromBottomToCanvas(pts[0].y));
	                for (let i = 1; i < pts.length; i++) {
	                  contexto.lineTo(pts[i].x * zoom, yFromBottomToCanvas(pts[i].y));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                contexto.beginPath();
	                // Auxiliar inferior (B3).
	                contexto.moveTo(0, yFromBottomToCanvas(yBase));
	                contexto.lineTo((W0 * zoom), yFromBottomToCanvas(yBase));
	                // Auxiliar oblicua alineada con el corte final (pI1 -> pO1), extendida al bounding box.
	                const dxAux = (pO1.x - pI1.x);
	                const dyAux = (pO1.y - pI1.y);
	                const epsAux = 0.000001;
	                const ptsAux = [];
	                const pushAux = (pt) => {
	                  if (!pt) return;
	                  for (let i = 0; i < ptsAux.length; i++) {
	                    if (Math.abs(ptsAux[i].x - pt.x) < 0.0001 && Math.abs(ptsAux[i].y - pt.y) < 0.0001) return;
	                  }
	                  ptsAux.push(pt);
	                };
	                if (Math.abs(dxAux) > epsAux) {
	                  const tL = (0 - pI1.x) / dxAux;
	                  const yL = pI1.y + (tL * dyAux);
	                  if (yL >= yBase && yL <= H0) pushAux({ x: 0, y: yL });
	                  const tR = (W0 - pI1.x) / dxAux;
	                  const yR = pI1.y + (tR * dyAux);
	                  if (yR >= yBase && yR <= H0) pushAux({ x: W0, y: yR });
	                }
	                if (Math.abs(dyAux) > epsAux) {
	                  const tB = (yBase - pI1.y) / dyAux;
	                  const xB = pI1.x + (tB * dxAux);
	                  if (xB >= 0 && xB <= W0) pushAux({ x: xB, y: yBase });
	                  const tT = (H0 - pI1.y) / dyAux;
	                  const xT = pI1.x + (tT * dxAux);
	                  if (xT >= 0 && xT <= W0) pushAux({ x: xT, y: H0 });
	                }
	                if (ptsAux.length >= 2) {
	                  let iA = 0;
	                  let iB = 1;
	                  let dBest = -1;
	                  for (let i = 0; i < ptsAux.length; i++) {
	                    for (let j = i + 1; j < ptsAux.length; j++) {
	                      const dX = (ptsAux[j].x - ptsAux[i].x);
	                      const dY = (ptsAux[j].y - ptsAux[i].y);
	                      const d2 = (dX * dX) + (dY * dY);
	                      if (d2 > dBest) {
	                        dBest = d2;
	                        iA = i;
	                        iB = j;
	                      }
	                    }
	                  }
	                  contexto.moveTo((ptsAux[iA].x * zoom), yFromBottomToCanvas(ptsAux[iA].y));
	                  contexto.lineTo((ptsAux[iB].x * zoom), yFromBottomToCanvas(ptsAux[iB].y));
	                }
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }
	            case 926:
	            case 2026:
	            case 63: {
		          contexto.save();
	              try {
	                contexto.beginPath();
	                const B1 = Number(gr.form_B1 || 0);
	                const B2 = Number(gr.form_B2 || 0);
	                const B3 = Number(gr.form_B3 || 0);
	                const B4 = Number(gr.form_B4 || 0);
	                const rawPoints = gr.form_DXF_POINTS;
	                let contour = [];
	                if (rawPoints) {
	                  if (typeof rawPoints === 'string') {
	                    try { contour = JSON.parse(rawPoints); } catch (error) { contour = []; }
	                  } else contour = rawPoints;
	                }
	                if (!contour || contour.length < 3) break;
	                const xs = contour.map(p => Number(p.x || 0));
	                const ys = contour.map(p => Number(p.y || 0));
	                const minX = Math.min.apply(null, xs);
	                const maxX = Math.max.apply(null, xs);
	                const minY = Math.min.apply(null, ys);
	                const maxY = Math.max.apply(null, ys);
	                const shapeW = maxX - minX;
	                const shapeH = maxY - minY;
	                if (!(shapeW > 0 && shapeH > 0)) break;
	                const W0 = B1 + shapeW + B3;
	                const H0 = B2 + shapeH + B4;
	                const contourNorm = contour.map(p => ({ x: (Number(p.x || 0) - minX) + B1, y: (Number(p.y || 0) - minY) + B2 }));
	                const rotRaw = (gr.rotation !== undefined && gr.rotation !== null) ? gr.rotation : 0;
	                const rot = ((rotRaw % 360) + 360) % 360;
	                const BW0 = W0 * zoom;
	                const BH0 = H0 * zoom;
	                const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                const BH = (rot === 90 || rot === 270) ? BW0 : BH0;
	                const bx = (disbandIn.left + x_plus + p_1.x) * zoom;
	                const by = (disbandIn.top + y_plus + p_1.y) * zoom;
	                contexto.translate(bx, by);
	                if (rot === 90) {
	                  contexto.translate(BW, 0);
	                  contexto.rotate(Math.PI / 2);
	                } else if (rot === 180) {
	                  contexto.translate(BW, BH);
	                  contexto.rotate(Math.PI);
	                } else if (rot === 270) {
	                  contexto.translate(0, BH);
	                  contexto.rotate(-Math.PI / 2);
	                }
	                const yFromBottomToCanvas = (yFromBottom) => ((H0 - yFromBottom) * zoom);
	                contexto.moveTo(Number(contourNorm[0].x || 0) * zoom, yFromBottomToCanvas(Number(contourNorm[0].y || 0)));
	                for (let i = 1; i < contourNorm.length; i++) {
	                  contexto.lineTo(Number(contourNorm[i].x || 0) * zoom, yFromBottomToCanvas(Number(contourNorm[i].y || 0)));
	                }
	                contexto.closePath();
	                if (this.fileForm.controls.f_fill_piece.value) contexto.fill();
	                contexto.stroke();
	                // Bandas auxiliares: contorno del bounding box con B1/B2/B3/B4.
	                contexto.beginPath();
	                contexto.moveTo(0, yFromBottomToCanvas(0));
	                contexto.lineTo(W0 * zoom, yFromBottomToCanvas(0));
	                contexto.lineTo(W0 * zoom, yFromBottomToCanvas(H0));
	                contexto.lineTo(0, yFromBottomToCanvas(H0));
	                contexto.lineTo(0, yFromBottomToCanvas(0));
	                // Bandas verticales completas (B1 y B3) hasta tocar techo y suelo del bounding box.
	                contexto.moveTo((B1 * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo((B1 * zoom), yFromBottomToCanvas(H0));
	                contexto.moveTo(((B1 + shapeW) * zoom), yFromBottomToCanvas(0));
	                contexto.lineTo(((B1 + shapeW) * zoom), yFromBottomToCanvas(H0));
	                contexto.stroke();
	                break;
	              } finally {
	                contexto.restore();
	              }
	            }

                // ------------ Fin nuevas formas añadidas D.

                case 27:
                  // console.log('->> Dibujando figura 27 en optimizador.');
                  contexto.beginPath();

                  if (gr.rotation === 0) {

                    // console.log('->> Rotación 0 grados en figura 27.');

                    // Dibujamos las líneas auxiliares.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_4.y) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_3.y) * zoom
                    );

                    contexto.stroke();
                    contexto.beginPath();

                    // ----------------- Código para la forma invertida volteada sobre el eje X.
                    /*

                    // Dibujamos las líneas de la forma.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_H1) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2 + gr.form_L) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B1) * zoom,
                      // (disbandIn.top + y_plus + p_4.y + (gr.form_H + gr.form_B3 + (gr.form_R / (gr.form_R / (gr.form_H - gr.form_H1 ? 2 : 1)))) * zoom
                      (disbandIn.top + y_plus + p_4.y + gr.form_H) * zoom
                    );

                    if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                    contexto.stroke();
                    contexto.beginPath();

                    // Se dibuja la semicircunferencia. Se tiene que colocar
                    // el puntero en el supuesto centro de la misma.
                    // 1. Hallar R con fórmula:

                    // Fórmula catetos para sacar el valor del segmento base de la semicircunferencia.
                    // pow2(Base) = pow2(H - H1) + pow2(L);

                    let arc_base = Math.sqrt(Math.pow((gr.form_H - gr.form_H1), 2) + Math.pow(gr.form_L, 2));

                    let radio_aux = (Math.pow(arc_base / 2, 2) + Math.pow(gr.form_R, 2)) / (2 * gr.form_R);

                    console.log(' -> Radio para la semicircunferencia de figura 27 = ' + radio_aux);

                    // Se calcula el ángulo de inclinación de la semicircunferencia.
                    let angle_base = 90 - (Math.acos((gr.form_H - gr.form_H1) / arc_base));

                    console.log(' -> Ángulo inclinación de semicircunferencia de figura 27 = ' + angle_base);

                    let angulo_aux = 2 * Math.acos((radio_aux - gr.form_R) / radio_aux);

                    console.log(' -> Angulo calculado para la semicircunferencia = ' + angulo_aux);
                    if (angulo_aux === 0) {
                      angulo_aux = 360 * Math.PI / 180;
                    }

                    let initial_angle = angulo_aux - angle_base;
                    let final_angle = angulo_aux + angle_base;

                    // Obtenemos los puntos A y B de la semicircunferencia.
                    let A_x = (disbandIn.left + x_plus + p_1.x + gr.form_B2);
                    let A_y = (disbandIn.top + y_plus + p_1.y + gr.form_H1);

                    let B_x = (disbandIn.left + x_plus + p_4.x - gr.form_B1);
                    let B_y = (disbandIn.top + y_plus + p_4.y + gr.form_H);

                    console.log(' -> Punto A = (' + A_x + ', ' + A_y + ')');
                    console.log(' -> Punto B = (' + B_x + ', ' + B_y + ')');

                    // Se halla la localización del punto medio "M" de la base de la semicircunferencia.
                    let M_x = disbandIn.left + x_plus + gr.points[0].x + gr.form_B2 + (gr.form_L / 2);
                    let M_y = disbandIn.top + y_plus + gr.points[0].y + (gr.form_H1 + ((gr.form_H - gr.form_H1) / 2));

                    console.log(' -> Punto M = (' + M_x + ', ' + M_y + ')');

                    // Ahora a M hay que aplicarle el vector unitario de la pendiente de la "recta mediatriz"
                    // tantas veces como la distancia de "radio_aux - R". Con esto conseguimos desplazarlo en
                    // la dirección correcta hasta llevarlo al punto del centro exacto de la circunferencia.

                    // Fórmula vector unitario:
                    // Vector(M·P2) / Módulo[Vector(M·P2)]

                    // Vector(M·P2) = Raiz[(P2_x - M_x, P2_y - M_y)]
                    // Calculamos coordenadas del punto 2

                    let MP_x = B_x - A_x;
                    let MP_y = B_y - A_y;

                    console.log(' -> Vector MP = (' + MP_x + ', ' + MP_y + ')');

                    // Módulo[Vector(M·P2)]
                    let M_module = Math.sqrt(Math.pow(MP_x, 2) + Math.pow(MP_y, 2));

                    console.log(' -> Módulo de M = ' + M_module);

                    // Calculamos los valores del vector unitario
                    let U_x = MP_x / M_module;
                    let U_y = MP_y / M_module;

                    console.log(' -> Vector U = (' + U_x + ', ' + U_y + ')');

                    // Pendiente de la perpendicular al vector = - ( 1 / pendiene)

                    let center_x = M_x + (U_y * (radio_aux - gr.form_R));
                    let center_y = M_y + (-U_x * (radio_aux - gr.form_R));

                    console.log(' -> Centro de la circunferencia = (' + center_x + ', ' + center_y + ')');

                    // NOTA: Modificamos el ángulo de la circunferencia para que cuadre con los puntos
                    // de las esquinas de los extremos superiores de la forma 27. Esto se hace así
                    // porque a la hora de calcular los ángulos de inicio y fin los decimales influyen mucho.

                    contexto.arc(
                      center_x * zoom, // X del punto del centro de la circunferencia.
                      center_y * zoom, // Y del punto del centro de la circunferencia.
                      radio_aux * zoom, //  // Radio de la circunferencia.
                       (-(initial_angle / 2) + (87.5 * Math.PI / 180)), // Ángulo de inicio en radianes.
                      (final_angle / 2) + (87.5 * Math.PI / 180) // Ángulo de fin en radianes. PI para una semicircunferencia.
                    );

                    if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                    contexto.stroke();

                    */
                   // ------------------

                    // Dibujamos las líneas de la forma.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_H1) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_3.y) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_H) * zoom
                    );

                    if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                    contexto.stroke();
                    contexto.beginPath();

                    // Se dibuja la semicircunferencia. Se tiene que colocar
                    // el puntero en el supuesto centro de la misma.
                    // 1. Hallar R con fórmula:

                    // Fórmula catetos para sacar el valor del segmento base de la semicircunferencia.
                    // pow2(Base) = pow2(H - H1) + pow2(L);

                    let arc_base = Math.sqrt(Math.pow((gr.form_H - gr.form_H1), 2) + Math.pow(gr.form_L, 2));

                    let radio_aux = (Math.pow(arc_base / 2, 2) + Math.pow(gr.form_R, 2)) / (2 * gr.form_R);

                    // console.log(' -> Radio para la semicircunferencia de figura 27 = ' + radio_aux);

                    // Se calcula el ángulo de inclinación de la semicircunferencia.
                    // Se le añade 90 grados pero en radianes con varios decimales, es decir, 1.570796326 rad.
                    let angle_base = 2 * (Math.acos((gr.form_H - gr.form_H1) / arc_base));

                    // console.log(' -> Ángulo base figura 27 = ' + angle_base);

                    angle_base = 6.283185 - angle_base;

                    // console.log(' -> Ángulo base corregido = ' + angle_base);

					// Longitud del arco de la circunferencia que deseamos sea visible.
					// Es la necesaria para que toque los dos extremos de la figura en H y H1.
                    let angulo_aux = 2 * Math.acos((radio_aux - gr.form_R) / radio_aux);

                    // console.log(' -> Ángulo que va a indicar la amplitud del arco de la circunferencia que se va a dibujar = ' + angulo_aux);

                    // Para ángulos igual a cero se indica entonces 360 grados en radienes (6.28 rad).
                    if (angulo_aux === 0) {
						// console.log(' -> angulo_aux = 0');
                      angulo_aux = 360 * Math.PI / 180;
                    }

                    let initial_angle = angulo_aux + angle_base;
                    let final_angle = angulo_aux - angle_base;

                    // Obtenemos los puntos A y B de la semicircunferencia.
                    let A_x = (disbandIn.left + x_plus + p_1.x + gr.form_B2);
                    let A_y = (disbandIn.top + y_plus + p_1.y - gr.form_H1);

                    let B_x = (disbandIn.left + x_plus + p_4.x - gr.form_B1);
                    let B_y = (disbandIn.top + y_plus + p_4.y - gr.form_H);

                    // console.log(' -> Punto A = (' + A_x + ', ' + A_y + ')');
                    // console.log(' -> Punto B = (' + B_x + ', ' + B_y + ')');

                    // Se halla la localización del punto medio "M" de la base de la semicircunferencia.
                    let M_x = disbandIn.left + x_plus + gr.points[0].x + gr.form_B2 + (gr.form_L / 2);
                    let M_y = disbandIn.top + y_plus + gr.points[0].y + (gr.form_H1 + ((gr.form_H - gr.form_H1) / 2));

                    // console.log(' -> Punto M = (' + M_x + ', ' + M_y + ')');

                    // Ahora a M hay que aplicarle el vector unitario de la pendiente de la "recta mediatriz"
                    // tantas veces como la distancia de "radio_aux - R". Con esto conseguimos desplazarlo en
                    // la dirección correcta hasta llevarlo al punto del centro exacto de la circunferencia.

                    // Fórmula vector unitario:
                    // Vector(M·P2) / Módulo[Vector(M·P2)]

                    // Vector(M·P2) = Raiz[(P2_x - M_x, P2_y - M_y)]
                    // Calculamos coordenadas del punto 2

                    let MP_x = A_x - B_x;
                    let MP_y = A_y - B_y;

                    // console.log(' -> Vector MP = (' + MP_x + ', ' + MP_y + ')');

                    // Módulo[Vector(M·P2)]
                    let M_module = Math.sqrt(Math.pow(MP_x, 2) + Math.pow(MP_y, 2));

                    // console.log(' -> Módulo de M = ' + M_module);

                    // Calculamos los valores del vector unitario
                    let U_x = MP_x / M_module;
                    let U_y = MP_y / M_module;

                    // console.log(' -> Vector U = (' + U_x + ', ' + U_y + ')');

                    // Pendiente de la perpendicular al vector = - ( 1 / pendiene)

                    let center_x = M_x + (U_y * (radio_aux - gr.form_R));
                    let center_y = M_y + (-U_x * (radio_aux - gr.form_R));

                    // console.log(' -> Centro de la circunferencia = (' + center_x + ', ' + center_y + ')');

                    // NOTA: Modificamos el ángulo de la circunferencia para que cuadre con los puntos
                    // de las esquinas de los extremos superiores de la forma 27. Esto se hace así
                    // porque a la hora de calcular los ángulos de inicio y fin los decimales influyen mucho.
                    // let correction_angle_value = 136 * Math.PI / 180; // Para valores: L = 500, H = 600, H1 = 400, R = 130. Rad-> 2.3736
					// let correction_angle_value = 151.7 * Math.PI / 180; // Para valores: L = 1900, H = 2700, H1 = 1500, R = 100. Rad-> 2.6476

					// NOTA: Para valores iguales de H y H1 -> 1.8029 rad
					// Cuandp H y H1 son iguales entonces la longitud L no influye.
					// let correction_angle_value = 103.3 * Math.PI / 180;
					// let correction_angle_value = 1.8029; // Si no se ponen los cuatro decimales no cuadrará bien.

					let correction_angle_value = 0;

                    contexto.arc(
                      center_x * zoom, // X del punto del centro de la circunferencia.
                      (center_y - gr.form_H + (gr.form_B3 + (gr.form_H - gr.form_H1) + (gr.form_R / (gr.form_H - gr.form_H1 ? 2 : 1)))) * zoom, // Y del punto del centro de la circunferencia.
                      radio_aux * zoom, //  // Radio de la circunferencia.
                       (-(initial_angle / 2) - correction_angle_value), // Ángulo de inicio en radianes.
                      (final_angle / 2) - correction_angle_value // Ángulo de fin en radianes. PI para una semicircunferencia.
                    );

                    if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                    contexto.stroke();

                  } else if (gr.rotation === 90) {

                    // console.log('->> Rotación 90 grados en figura 27.');

                    // Dibujamos las líneas auxiliares.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B2) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B1) * zoom
                    );

                    contexto.stroke();
                    contexto.beginPath();

                    // Líneas de forma.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_H1) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B2) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1) * zoom
                    );
                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_H) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B1) * zoom
                    );

                    if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                    contexto.stroke();
                    contexto.beginPath();

                    // Se dibuja la semicircunferencia. Se tiene que colocar
                    // el puntero en el supuesto centro de la misma.
                    // 1. Hallar R con fórmula:

                    // Fórmula catetos para sacar el valor del segmento base de la semicircunferencia.
                    // pow2(Base) = pow2(H - H1) + pow2(L);

                    let arc_base = Math.sqrt(Math.pow((gr.form_H - gr.form_H1), 2) + Math.pow(gr.form_L, 2));

                    let radio_aux = (Math.pow(arc_base / 2, 2) + Math.pow(gr.form_R, 2)) / (2 * gr.form_R);

                    // console.log(' -> Radio para la semicircunferencia de figura 27 = ' + radio_aux);

                    // Se calcula el ángulo de inclinación de la semicircunferencia.
                    let angle_base = 2 * (Math.acos((gr.form_H - gr.form_H1) / arc_base));

                    // console.log(' -> Ángulo base figura 27 girada = ' + angle_base);

                    // Equivalencia grados -> radianes:
                    // 360 = 6.283185 ; 270 = 4.712388 ; 180 = 3.141592 ; 90 = 1.570796

                    angle_base = angle_base - 3.141592;

                    // console.log(' -> Ángulo base corregido girado = ' + angle_base);

                    let angulo_aux = 2 * Math.acos((radio_aux - gr.form_R) / radio_aux);

                    // console.log(' -> Angulo calculado para la semicircunferencia = ' + angulo_aux);
                    if (angulo_aux === 0) {
                      angulo_aux = 360 * Math.PI / 180;
                    }

                    let initial_angle = angulo_aux - angle_base;
                    let final_angle = angulo_aux + angle_base;

                    // Obtenemos los puntos A y B de la semicircunferencia.
                    let A_x = (disbandIn.left + x_plus + p_2.x + gr.form_H); // (disbandIn.left + x_plus + p_1.x + gr.form_H1);
                    let A_y = (disbandIn.top + y_plus + p_3.y - gr.form_B1); // (disbandIn.top + y_plus + p_1.y + gr.form_B2);

                    let B_x = (disbandIn.left + x_plus + p_1.x + gr.form_H1);
                    let B_y = (disbandIn.top + y_plus + p_1.y + gr.form_B2);

                    // console.log(' -> Punto A = (' + A_x + ', ' + A_y + ')');
                    // console.log(' -> Punto B = (' + B_x + ', ' + B_y + ')');

                    // Se halla la localización del punto medio "M" de la base de la semicircunferencia.
                    let M_x = disbandIn.left + x_plus + gr.points[1].x + (gr.form_H1 + ((gr.form_H - gr.form_H1) / 2));
                    let M_y = disbandIn.top + y_plus + gr.points[0].y + gr.form_B2 + (gr.form_L / 2);

                    // console.log(' -> Punto M = (' + M_x + ', ' + M_y + ')');

                    // Ahora a M hay que aplicarle el vector unitario de la pendiente de la "recta mediatriz"
                    // tantas veces como la distancia de "radio_aux - R". Con esto conseguimos desplazarlo en
                    // la dirección correcta hasta llevarlo al punto del centro exacto de la circunferencia.

                    // Fórmula vector unitario:
                    // Vector(M·P2) / Módulo[Vector(M·P2)]

                    // Vector(M·P2) = Raiz[(P2_x - M_x, P2_y - M_y)]
                    // Calculamos coordenadas del punto 2

                    let MP_x = B_x - A_x;
                    let MP_y = B_y - A_y;

                    // console.log(' -> Vector MP = (' + MP_x + ', ' + MP_y + ')');

                    // Módulo[Vector(M·P2)]
                    let M_module = Math.sqrt(Math.pow(MP_x, 2) + Math.pow(MP_y, 2));

                    // console.log(' -> Módulo de M = ' + M_module);

                    // Calculamos los valores del vector unitario
                    let U_x = MP_x / M_module;
                    let U_y = MP_y / M_module;

                    // console.log(' -> Vector U = (' + U_x + ', ' + U_y + ')');

                    // Pendiente de la perpendicular al vector = - ( 1 / pendiene)

                    let center_x = M_x + (U_y * (radio_aux - gr.form_R));
                    let center_y = M_y + (-U_x * (radio_aux - gr.form_R));

                    // console.log(' -> Centro de la circunferencia = (' + center_x + ', ' + center_y + ')');

					// let correction_angle_value = 24.75 * Math.PI / 180; // Para valores: L = 1900, H = 400, H1 = 400, R = 130.
					// let correction_angle_value = 61.7 * Math.PI / 180; // Para valores: L = 1900, H = 2700, H1 = 1500, R = 100. Rad-> 2.6476
					// let correction_angle_value = 46 * Math.PI / 180; // Para valores: L = 500, H = 400, H1 = 400, R = 130.
					// NOTA: Para valores iguales de H y H1 -> 0.23 rad
					// let correction_angle_value = 0.23;

					let correction_angle_value = 0;

                    contexto.arc(
                      center_x * zoom, // X del punto del centro de la circunferencia.
                      center_y * zoom, // Y del punto del centro de la circunferencia.
                      radio_aux * zoom, //  // Radio de la circunferencia.
                       (-(initial_angle / 2) - correction_angle_value), // Ángulo de inicio en radianes.
                      (final_angle / 2) - correction_angle_value // Ángulo de fin en radianes. PI para una semicircunferencia.
                    );

                    if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                    contexto.stroke();

                  } // End ELSE IF rotation = 90

                  contexto.stroke();

                  break;

                case 372: {
                  contexto.lineWidth = 1;
                  contexto.beginPath();

                  const B1 = Number(gr.form_B1 || 0);
                  const B2 = Number(gr.form_B2 || 0);
                  const L1 = Number(gr.form_L1 || 0);
                  const L2 = Number(gr.form_L2 || 0);
                  const L3 = Number(gr.form_B3 || 0);
                  const H1 = Number(gr.form_H1 || 0);
                  const H2 = Number(gr.form_H2 || 0);
                  const W0 = Math.max(0, (2 * B1) + Math.max(L3, L3 + L2, L1));
                  const H0 = Math.max(0, (2 * B2) + Math.max(H1, H2));
                  const rot = ((Number(gr.rotation || 0) % 360) + 360) % 360;
                  const mapPoint = (pt) => {
                    if (rot === 90) return { x: H0 - pt.y, y: pt.x };
                    if (rot === 180) return { x: W0 - pt.x, y: H0 - pt.y };
                    if (rot === 270) return { x: pt.y, y: W0 - pt.x };
                    return { x: pt.x, y: pt.y };
                  };
                  const clipLineToRect = (a, b) => {
                    const dx = b.x - a.x;
                    const dy = b.y - a.y;
                    const eps = 0.000001;
                    const candidates = [];
                    const addPoint = (t) => {
                      const x = a.x + (dx * t);
                      const y = a.y + (dy * t);
                      if (x >= -eps && x <= W0 + eps && y >= -eps && y <= H0 + eps) {
                        const clamped = {
                          x: Math.max(0, Math.min(W0, x)),
                          y: Math.max(0, Math.min(H0, y))
                        };
                        if (!candidates.some(pt => Math.abs(pt.x - clamped.x) < eps && Math.abs(pt.y - clamped.y) < eps)) {
                          candidates.push(clamped);
                        }
                      }
                    };
                    if (Math.abs(dx) > eps) {
                      addPoint((0 - a.x) / dx);
                      addPoint((W0 - a.x) / dx);
                    }
                    if (Math.abs(dy) > eps) {
                      addPoint((0 - a.y) / dy);
                      addPoint((H0 - a.y) / dy);
                    }
                    if (candidates.length < 2) {
                      return null;
                    }

                    let best = null;
                    let bestDistance = -1;
                    for (let i = 0; i < candidates.length; i++) {
                      for (let j = i + 1; j < candidates.length; j++) {
                        const distance = Math.pow(candidates[i].x - candidates[j].x, 2) + Math.pow(candidates[i].y - candidates[j].y, 2);
                        if (distance > bestDistance) {
                          bestDistance = distance;
                          best = { a: candidates[i], b: candidates[j] };
                        }
                      }
                    }
                    return best;
                  };
                  const drawPoint = (pt, move) => {
                    const mapped = mapPoint(pt);
                    const x = (disbandIn.left + x_plus + p_1.x + mapped.x) * zoom;
                    const y = (disbandIn.top + y_plus + p_1.y + mapped.y) * zoom;
                    if (move) contexto.moveTo(x, y);
                    else contexto.lineTo(x, y);
                  };
                  const bottomY = B2 + Math.max(H1, H2);
                  const points372 = [
                    { x: B1, y: bottomY },
                    { x: B1 + L3, y: bottomY },
                    { x: B1 + L3 + L2, y: bottomY - H1 },
                    { x: B1 + L1, y: bottomY - H2 }
                  ];

                  if (W0 > 0 && H0 > 0) {
                    drawPoint(points372[0], true);
                    drawPoint(points372[1], false);
                    drawPoint(points372[2], false);
                    drawPoint(points372[3], false);
                    contexto.closePath();

                    if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }
                    contexto.stroke();

                    const auxiliaryCuts = [
                      clipLineToRect(points372[0], points372[3]),
                      clipLineToRect(points372[1], points372[2])
                    ].filter(Boolean);
                    if (auxiliaryCuts.length > 0) {
                      contexto.beginPath();
                      auxiliaryCuts.forEach(seg => {
                        drawPoint(seg.a, true);
                        drawPoint(seg.b, false);
                      });
                      contexto.stroke();
                    }
                  }

                  break;
                }

                case 37:
				case 371:
                  // console.log('->> Dibujando figura 37 y 371 en optimizador. Rotación = ' + gr.rotation);

                  contexto.lineWidth = 1;
                  contexto.beginPath();

                  if (gr.rotation === 0) {

                    // Dibujamos las líneas auxiliares.

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_1.x + ((2 * gr.form_B1) + gr.form_L)) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + ((2 * gr.form_B1) + gr.form_L)) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B2) * zoom
                    );

                    // Dibujamos las líneas de forma (invertida girando el eje horizontal).
                    /*
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B1 + gr.form_L1) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B1 - gr.form_L1) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B2) * zoom
                    );
                    */
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B1 + gr.form_L1) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B1 - gr.form_L1) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B2) * zoom
                    );
                  } else if (gr.rotation === 90) {

                    // Dibujamos las líneas auxiliares.

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_3.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y) * zoom
                    );

                   // Dibujamos las líneas de forma (invertida girando el eje horizontal).
                   /*
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y + ((2 * gr.form_B1) + gr.form_L)) * zoom
                    );
                   */

                  	contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1 - gr.form_L1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B1 + gr.form_L1) * zoom
                    );

                  }

                  contexto.closePath();

                  if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                  contexto.stroke();

                  break;

                case 43:
                  // console.log('->> Dibujando figura 43 en optimizador. Rotación = ' + gr.rotation);

                  contexto.lineWidth = 1;
                  contexto.beginPath();

                  if (gr.rotation === 0) {

                    // console.log('->> Rotación 0 grados en figura 43.');

                    // Dibujamos las líneas auxiliares.

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_1.x + ((2 * gr.form_B1) + gr.form_L)) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + ((2 * gr.form_B1) + gr.form_L)) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B2) * zoom
                    );

                    // Dibujamos las líneas de forma (comentada forma inversa volteando sobre eje X).
                    /*
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B1 + gr.form_L1) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B2) * zoom
                    );

                    */
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B1 + gr.form_L1) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B1) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B2) * zoom
                    );
                  } else if (gr.rotation === 90) {

                    // console.log('->> Rotación 90 grados en figura 43.');

                    // Dibujamos las líneas auxiliares.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y + ((2 * gr.form_B1) + gr.form_L)) * zoom
                    );

                    // Dibujamos las líneas de forma (comentado forma invertida volteando sobre el eje X).
                    /*
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B1 -  gr.form_L1) * zoom
                    );

                    */
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B1 + gr.form_L1) * zoom
                    );

                  } else if (gr.flip === 'vertical' && (gr.rotation === 90 || gr.rotation === 270)) {

                    // console.log('->> Rotación 90 grados y flip vertical en figura 43.');

                    // Dibujamos las líneas auxiliares.

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y + ((2 * gr.form_B1) + gr.form_L)) * zoom
                    );

                    // Dibujamos las líneas de forma.

                    // Se comenta para hacer la punta del triángulo.
                    // contexto.moveTo(
                    //   (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                    //   (disbandIn.top + y_plus + p_1.y + gr.form_B1) * zoom
                    // );

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B1 - gr.form_L1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B1) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x - gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B1) * zoom
                    );
                  } // End IF vertical

                  contexto.closePath();

                  if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                  contexto.stroke();

                  break;

                case 50:
                  // console.log('->> Dibujando figura 50 SEMICIRCULO en optimizador.');
                  contexto.beginPath();

                  if (gr.rotation === 0) {

                    // console.log('->> Rotación 0 grados en figura 50.');

                    // Dibujamos las líneas auxiliares, que este caso se puede hacer con sólo un trazo.
                    /*
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x) * zoom,
                      (disbandIn.top + y_plus + p_1.y + gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_4.x) * zoom,
                      (disbandIn.top + y_plus + p_4.y + gr.form_B2) * zoom
                    ); */

                    contexto.stroke();
                    contexto.beginPath();

                    // Se dibuja la semicircunferencia. Se tiene que colocar
                    // el puntero en el supuesto centro de la misma.
                    // 1. Hallar R con fórmula:

                    let radio_aux = (Math.pow(gr.form_L / 2, 2) + Math.pow(gr.form_H, 2)) / (2 * gr.form_H);

                    // console.log(' -> Radio calculado para la semicircunferencia = ' + radio_aux);

                    let angulo_aux = 2 * Math.acos((radio_aux - gr.form_H) / radio_aux);

                    // console.log(' -> Angulo calculado para la semicircunferencia = ' + angulo_aux);
                    if (angulo_aux === 0) {
                      angulo_aux = 360 * Math.PI / 180;
                    }
					/*
                    contexto.arc(
                      (disbandIn.left + x_plus + (gr.points[0].x + gr.points[2].x ) / 2 ) * zoom, // X del punto del centro de la circunferencia.
                      (disbandIn.top + y_plus + gr.points[0].y + gr.height - gr.form_B3 - radio_aux) * zoom, // Y del punto del centro de la circunferencia.
                      radio_aux * zoom, //  // Radio de la circunferencia.
                       (-(angulo_aux / 2) + (90 * Math.PI / 180)), // Ángulo de inicio en radianes.
                      (angulo_aux / 2) + (90 * Math.PI / 180) // Ángulo de fin en radianes. PI para una semicircunferencia.
                    ); */

                    contexto.arc(
                      (disbandIn.left + x_plus + (gr.points[0].x + gr.points[2].x ) / 2 ) * zoom, // X del punto del centro de la circunferencia.
                      (disbandIn.top + y_plus + gr.points[0].y + radio_aux + gr.form_B3) * zoom, // Y del punto del centro de la circunferencia.
                      radio_aux * zoom, //  // Radio de la circunferencia.
                       (-(angulo_aux / 2) + (-90 * Math.PI / 180)), // Ángulo de inicio en radianes.
                      (angulo_aux / 2) + (-90 * Math.PI / 180) // Ángulo de fin en radianes. PI para una semicircunferencia.
                    );

                    if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                    contexto.stroke();

                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_2.x) * zoom,
                      (disbandIn.top + y_plus + p_2.y - gr.form_B2) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_3.x) * zoom,
                      (disbandIn.top + y_plus + p_3.y - gr.form_B2) * zoom
                    );

                  } else if (gr.rotation === 90 || gr.rotation === 270) {

                    // console.log('->> Rotación 90 grados en figura 50.');
                    // console.log(gr);

                    contexto.stroke();
                    contexto.beginPath();

                    // Se dibuja la semicircunferencia. Se tiene que colocar
                    // el puntero en el supuesto centro de la misma.
                    // 1. Hallar R con fórmula:

                    let radio_aux = (Math.pow(gr.form_L / 2, 2) + Math.pow(gr.form_H, 2)) / (2 * gr.form_H);

                    // console.log(' -> Radio calculado para la semicircunferencia = ' + radio_aux);

                    let angulo_aux = 2 * Math.acos((radio_aux - gr.form_H) / radio_aux);

                    // console.log(' -> Angulo calculado para la semicircunferencia = ' + angulo_aux);

                    if (angulo_aux === 0) {
                      angulo_aux = 360 * Math.PI / 180;
                    }

                    // Para controlar "bloques" volteados.
                    let aux_width = gr.width;
                    if (gr.flip) {
                      // console.log(' -> Encontrada semicircunferencia volteada.');
                      aux_width = gr.height;
                    }

                    contexto.arc(
                      (disbandIn.left + x_plus + gr.points[0].x + aux_width - gr.form_B3 - radio_aux) * zoom, // X del punto del centro de la circunferencia.
                      (disbandIn.top + y_plus + ((gr.points[0].y + gr.points[1].y) / 2)) * zoom, // Y del punto del centro de la circunferencia.
                      radio_aux * zoom, //  // Radio de la circunferencia.
                      -(angulo_aux / 2), // Ángulo de inicio en radianes.
                      angulo_aux / 2, // Ángulo de fin en radianes. PI para una semicircunferencia.
                    );

                    if (this.fileForm.controls.f_fill_piece.value) { contexto.fill(); }

                    contexto.stroke();

                    // Dibujamos las líneas auxiliares, que este caso se puede hacer con sólo un trazo.
                    // Se colocan depués de las líneas de forma para que no se superponga su sombreado/color.
                    contexto.moveTo(
                      (disbandIn.left + x_plus + p_1.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_1.y) * zoom
                    );

                    contexto.lineTo(
                      (disbandIn.left + x_plus + p_2.x + gr.form_B2) * zoom,
                      (disbandIn.top + y_plus + p_2.y) * zoom
                    );

                  } // End ELSE IF rotation = 90

                  contexto.stroke();

                  break;

                case 55: {
	                console.log('R', gr.form_R, 'R2', gr.form_R2, 'R3', gr.form_R3, 'R4', gr.form_R4);
	                console.log(gr);
	                contexto.save();
	                try {
	                  contexto.beginPath();

	                  // --- Parámetros según plano 55 ---
	                  const B1 = gr.form_B1; // margen inferior
	                  const B2 = gr.form_B2; // margen derecho
	                  const B3 = gr.form_B3; // margen superior
	                  const B4 = gr.form_B4; // margen izquierdo

	                  const L  = gr.form_L;  // ancho útil interior
	                  const H  = gr.form_H;  // alto útil interior

	                  // Radios por esquina (mm)
	                  // R  = esquina inferior-izquierda (según plano "R")
	                  // R1 = sup-izq, R2 = sup-der, R3 = inf-der
	                  const rBaseRaw =
	                    (gr.form_R !== undefined && gr.form_R !== null)
	                      ? gr.form_R
	                      : 0;

	                  const r1Raw =
	                    (gr.form_R2 !== undefined && gr.form_R2 !== null)
	                      ? gr.form_R2
	                      : rBaseRaw;

	                  const r2Raw =
	                    (gr.form_R3 !== undefined && gr.form_R3 !== null)
	                      ? gr.form_R3
	                      : rBaseRaw;

	                  const r3Raw =
	                    (gr.form_R4 !== undefined && gr.form_R4 !== null)
	                      ? gr.form_R4
	                      : rBaseRaw;

	                  const { left, top } = disbandIn;

	                  // Normaliza rotación
	                  const rotRaw =
	                    (gr.rotation !== undefined && gr.rotation !== null)
	                      ? gr.rotation
	                      : 0;
	                  const rot = ((rotRaw % 360) + 360) % 360;

	                  // Top-left del bbox (ya colocado por el optimizador)
	                  const bx = (left + x_plus + p_1.x) * zoom;
	                  const by = (top  + y_plus + p_1.y) * zoom;

	                  // BBox en orientación base (rot=0)
	                  // ancho total = B4 + L + B2
	                  // alto total  = B3 + H + B1
	                  const BW0 = (B4 + L + B2) * zoom;
	                  const BH0 = (B3 + H + B1) * zoom;

	                  // Tamaño del bbox ya rotado
	                  const BW = (rot === 90 || rot === 270) ? BH0 : BW0;
	                  const BH = (rot === 90 || rot === 270) ? BW0 : BH0;

	                  // Transformación: ancla en (bx,by) y rota el sistema local dentro del bbox
	                  contexto.translate(bx, by);
	                  if (rot === 90) {
	                    contexto.translate(BW, 0);
	                    contexto.rotate(Math.PI / 2);
	                  } else if (rot === 180) {
	                    contexto.translate(BW, BH);
	                    contexto.rotate(Math.PI);
	                  } else if (rot === 270) {
	                    contexto.translate(0, BH);
	                    contexto.rotate(-Math.PI / 2);
	                  }

	                  // --- Dibujo LOCAL como si rot=0 ---
	                  // Rectángulo interior (zona gris) en coordenadas locales
	                  const x0 = B4 * zoom;           // inner-left
	                  const y0 = B3 * zoom;           // inner-top
	                  const x1 = (B4 + L) * zoom;     // inner-right
	                  const y1 = (B3 + H) * zoom;     // inner-bottom

	                  // Radios en px
	                  let rtl = r1Raw * zoom; // top-left
	                  let rtr = r2Raw * zoom; // top-right
	                  let rbr = r3Raw * zoom; // bottom-right
	                  let rbl = rBaseRaw * zoom; // bottom-left

	                  // Clamp para evitar radios imposibles
	                  const maxR = Math.min((x1 - x0) / 2, (y1 - y0) / 2);
	                  rtl = Math.max(0, Math.min(rtl, maxR));
	                  rtr = Math.max(0, Math.min(rtr, maxR));
	                  rbr = Math.max(0, Math.min(rbr, maxR));
	                  rbl = Math.max(0, Math.min(rbl, maxR));

	                  // Path per-esquina con arcTo (sentido horario)
	                  contexto.moveTo(x0 + rtl, y0);

	                  contexto.lineTo(x1 - rtr, y0);
	                  contexto.arcTo(x1, y0, x1, y0 + rtr, rtr);

	                  contexto.lineTo(x1, y1 - rbr);
	                  contexto.arcTo(x1, y1, x1 - rbr, y1, rbr);

	                  contexto.lineTo(x0 + rbl, y1);
	                  contexto.arcTo(x0, y1, x0, y1 - rbl, rbl);

	                  contexto.lineTo(x0, y0 + rtl);
	                  contexto.arcTo(x0, y0, x0 + rtl, y0, rtl);

	                  contexto.closePath();

	                  if (this.fileForm.controls.f_fill_piece.value) {
	                    contexto.fill();
	                  }
	                  contexto.stroke();

	                  break;
	                } finally {
	                  contexto.restore();
	                }
	              }

                default:
                  // console.log('->> Figura no encontrada en optimizador: ' + gr.form_id);

                  break;
              }
            } else {
              if (this.fileForm.controls.f_fill_piece.value) {

                // Las piezas que rompen secuencia se colorean diferente.
                if (!gr.sequence_broked) {
					contexto.fillStyle = this.amarillo_claro;
				} else {
					contexto.fillStyle = this.rosa_claro;
				}

                contexto.fill(); }
            }

            contexto.stroke();

            // -----------------------
            //  DIBUJAR ETIQUETAS 'P'
            // -----------------------

            // console.log('->>** Se va a poner las etiquetas de la pieza: ');
			// console.log(gr);

            // Etiqueta para el elemento.
            contexto.textAlign = 'left';
            // contexto.font = this.letra_bold_10_currier;
            contexto.font = '10pt Courier New';

            contexto.fillStyle = 'blue';

            // contexto.textBaseline = 'top'; // ['top', 'hanging', 'middle', 'alphabetic', 'ideographic', 'bottom'];

			// Ancho y alto de los puntos finales del dibujo de la pieza.
			let points_width = (gr.points[2].x - gr.points[0].x);
			let points_height = (gr.points[2].y - gr.points[0].y);

            // Escribimos el nombre.
            if ((gr.points[2].x - gr.points[0].x) * zoom < label_width / 2) {
			// if (points_width < points_height) {

              contexto.save();

              contexto.beginPath();

              // if ((gr.points[2].x - gr.points[0].x) * zoom < 20 ) {
              //   contexto.translate(
              //   ((disbandIn.left + x_plus + gr.points[0].x) * zoom ) + 2,
              //   ((disbandIn.top + y_plus + gr.points[0].y - (gr.points[0].y / 2)) * zoom) + 8);

              // } else {
              contexto.translate(
              ((disbandIn.left + x_plus + gr.points[0].x) * zoom ) + 8,
              ((disbandIn.top + y_plus + gr.points[0].y) * zoom) + 8);
              // }

              let rad = 90 * Math.PI / 180; //pasar a radianes 90 grados.
              contexto.rotate(rad);
              // console.log('->>** Se gira 90º etiqueta de orden de tronzado = ' + gr.name);

              // Colocamos etiqueta para mostrar el número de orden durante el tronzado.
              if (this.fileForm.controls.f_show_order.value) {
                contexto.font = this.letra_bold_12_currier;
                contexto.fillStyle = this.rosa;
                contexto.fillText(gr['cut_order'] ? '#' + gr['cut_order'] : '', 0, 0);
              }

              // contexto.stroke();
              contexto.restore();
            } else {

              contexto.save();

              // Orden de tronzado.
              if (this.fileForm.controls.f_show_order.value) {
                contexto.font = this.letra_bold_12_currier;
                contexto.fillStyle = this.rosa;
                contexto.fillText(
                  gr['cut_order'] ? '#' + gr['cut_order'] : '',
                  ((disbandIn.left + x_plus + gr.points[0].x) * zoom) + 8,
                  ((disbandIn.top + y_plus + gr.points[0].y) * zoom) + 18);
              }

              // contexto.stroke();
              contexto.restore();
            }

            // console.log('->>** Ajustando orientación -> label_width = ' + label_width);
            // console.log((gr.points[2].x - gr.points[0].x) * zoom);

            // Escribimos las medidas.
            contexto.textAlign = 'center';
            let oefMeasurePlaced = false;
            if (isOefComposite) {
              const oefGeometry = this.getOefTransformedGeometry(gr);
              if (oefGeometry && Array.isArray(oefGeometry.polygons) && oefGeometry.polygons.length > 0) {
                const firstPolygon = oefGeometry.polygons[0];
                const slot = this.findFirstMeasureSlotInPolygon(firstPolygon);
                if (slot) {
                  const cxPx = (disbandIn.left + x_plus + Number(oefGeometry.minX) + Number(slot.cx)) * zoom;
                  const cyPx = (disbandIn.top + y_plus + Number(oefGeometry.minY) + Number(slot.cy)) * zoom;
                  const wPx = Number(slot.w) * zoom;
                  const hPx = Number(slot.h) * zoom;
                  contexto.fillStyle = 'blue';
                  contexto.strokeStyle = 'blue';
                  oefMeasurePlaced = this.drawCompactMeasureInsideRect(contexto, gr.label, cxPx, cyPx, wPx, hPx);
                }
              }
            }
            // Si el ancho de la pieza aplicando el zoom no cubre el mínimo del ancho de una etiqueta
            // entonces habrá que girarla (siempre que el alto sea mayor que el ancho, claro).
            if (!oefMeasurePlaced && points_width * zoom < label_width && points_height > points_width ) {
			// if (points_width < points_height) {
              // console.log('->>** Escribiendo medidas orientación A. Etiqueta Vertical. Se rota.');

              contexto.save();

              contexto.beginPath();

              // console.log('->>** Ajustando colocación etiqueta eje X: ');
              // console.log((gr.points[2].x - gr.points[0].x) * zoom);

              if ((gr.points[2].x - gr.points[0].x) * zoom < 20 ) {
                // console.log('->>** Escribiendo medidas orientación A1.');
                contexto.translate(
                ((disbandIn.left + x_plus + gr.points[0].x) * zoom ) + 2,
                ((disbandIn.top + y_plus + gr.points[0].y + (gr.points[2].y - gr.points[0].y) / 2) * zoom));

              } else {
                // console.log('->>** Escribiendo medidas orientación A2.');
                contexto.translate(
                ((disbandIn.left + x_plus + gr.points[0].x) * zoom) + 8,
                ((disbandIn.top + y_plus + gr.points[0].y + (gr.points[2].y - gr.points[0].y) / 2) * zoom));
              }

              let rad = 90 * Math.PI / 180; //pasar a radianes 90 grados.
              contexto.rotate(rad);
              // console.log('->>** Se gira 90º etiqueta medidas = ' + gr.name);

              // console.log('->>** Ajustando colocación etiqueta eje Y: ');
              // console.log((gr.points[1].y - gr.points[0].y) * zoom);

			  // Piezas con tamaño normal.
              if ((gr.points[0].y - gr.points[1].y) * zoom > 150) {
                // console.log('->>** Etiqueta orientación A3 a una altura.');
                contexto.fillText(gr.label, -54, 0);

                if (showCompactEaselInfo) {

					// Etiqueta con sólo el número de "apilado".
	                contexto.font = this.letra_bold_18_currier;
	                contexto.fillStyle = this.naranja_oscuro;
	                contexto.fillText(gr.easel, 54 , 0);

				} else if (showFullEaselInfo) {
					// Etiqueta con información completa.
					// console.log('->>** Etiqueta orientación A4.');
	                contexto.fillText(gr.easel + '/' + gr.side + '/' + stack_aux + ' N' + gr.name, 54 , 0);

	                // Escribir Lote y Secuencia.
	                contexto.font = this.letra_bold_10_currier;
	                contexto.fillStyle = this.naranja_rojo;
	                contexto.fillText(gr.name_id, 76 , 0);
				}
              } else { // Piezas pequeñas.
                // console.log('->>** Etiqueta orientación A5 a dos alturas.');
                // NOTA: el valor "-14" que se resta a "y_aux" controla lo elevada que estará una etiqueta sobre otra.

                contexto.fillText(gr.label, 0, 0);

                if (showCompactEaselInfo) {
					// Etiqueta con sólo el número de "apilado".
	                contexto.font = this.letra_bold_18_currier;
	                contexto.fillStyle = this.naranja_oscuro;
	                contexto.fillText(gr.easel,  0 , -14);

				} else if (showFullEaselInfo) {
					// Etiqueta con información completa.
	                contexto.fillText(gr.easel + '/' + gr.side + '/' + stack_aux + ' N' + gr.name, 0 , -14);

	                // Escribir Lote y Secuencia.
	                contexto.font = this.letra_bold_10_currier;
	                contexto.fillStyle = this.naranja_rojo;
	                contexto.fillText(gr.name_id, 0 , -28);
				}
              }
              // contexto.fillText(gr.label, -54, 0);
              // contexto.fillText('CB_' + gr.easel + ' GR_' + gr.group, 54 , 0);
              // contexto.fillText(gr.easel + '/' + gr.name, 54 , 0);

              // contexto.lineWidth = 4;
              // contexto.moveTo(0, 0); //inicio en el centro
              // contexto.lineTo(1000, 1000);

              // contexto.stroke();
              contexto.restore();

            } else if (!oefMeasurePlaced) {

              // console.log('->>** Escribiendo medidas orientación B. Etiqueta Horizontal. No se gira.');

              contexto.textAlign = 'center';

              let x_aux = ((disbandIn.left + x_plus + gr.points[0].x + ((gr.points[2].x - gr.points[0].x) / 2)) * zoom);
              // let y_aux = ((disbandIn.left + y_plus + gr.points[2].y - ((gr.points[2].y - gr.points[0].y) * 0.05)) * zoom));
              let y_aux = ((disbandIn.top + y_plus + gr.points[2].y) * zoom) - 6;

              if ((gr.points[2].y - gr.points[0].y) * zoom < 40 ) {

				// console.log('->>** Altura menor de 40 medidas orientación B1');

                contexto.fillText(gr.label, x_aux, y_aux + 3);
                //contexto.fillText('CB_' + gr.easel + ' GR_' + gr.group, x_aux , y_aux - 11);

                if (showCompactEaselInfo) {

					// Etiqueta con sólo el número de "apilado".
	                contexto.font = this.letra_bold_18_currier;
	                contexto.fillStyle = this.naranja_oscuro;
	                contexto.fillText(gr.easel, x_aux , y_aux - 11);

				} else if (showFullEaselInfo) {
					// Etiqueta con información completa.
	                contexto.fillText(gr.easel + '/' + gr.side + '/' + stack_aux + ' N' + gr.name, x_aux , y_aux - 11);

	                // Escribir Lote y Secuencia.
	                contexto.font = this.letra_bold_10_currier;
	                contexto.fillStyle = this.naranja_rojo;
	                contexto.fillText(gr.name_id, x_aux , y_aux - 25);
				}
              } else {
				// console.log('->>** Altura mayor de 40 medidas orientación B2. Rotamos.');
                contexto.fillText(gr.label, x_aux, y_aux);
                // contexto.fillText('CB_' + gr.easel + ' GR_' + gr.group, x_aux , y_aux - 20);

                if (showCompactEaselInfo) {
					// NOTA: el valor "-11" que se resta a "y_aux" controla lo elevada que estará una etiqueta sobre otra.
	                // Etiqueta con sólo el número de "apilado".
	                contexto.font = this.letra_bold_18_currier;
	                contexto.fillStyle = this.naranja_oscuro;
	                contexto.fillText(gr.easel, x_aux , y_aux - 14);
				} else if (showFullEaselInfo) {
					// Etiqueta con información completa.
	                contexto.fillText(gr.easel + '/' + gr.side + '/' + stack_aux + ' N' + gr.name, x_aux , y_aux - 14);

	                // Escribir Lote y Secuencia.
	                contexto.font = this.letra_bold_10_currier;
	                contexto.fillStyle = this.naranja_rojo;
	                contexto.fillText(gr.name_id, x_aux , y_aux - 28);
				}
              }
            } // End if write measures

            // "Guardar" cambios
            contexto.stroke();

            break; // End CASE elemento tipo 'P' (pieza).
        } // End switch
      } // End gr.points
    }); // End If piece.

    // Total de hojas usadas.
    this.num_sheet += sheet_count; // - this.num_sheet;

    // Se calculan el resto de datos necesarios sobre la hoja.

    // Area Bruta: Se calcula sumando el área utilizada (el total de la hoja)
    // y restando el área de los retales detectados (material que podrá reutilizarse).
    // tb += ts - tr;
    tb += ts - tr - tj;  // Lisec cálculos.

    if (tb <= 0) {
		// console.log('-> tb es cero. Se modifica. ');
		tb = ts;
	}

    // Porcentaje de Merma: Porcentaje que representa sobre la
    // "área bruta" la cantidad de m2 del "área del resto" (desperdicio).
    tm += tb <= 0 ? 0 : (td * 100) / tb;
    const oefBase = tn + td_oef_in;
    tm_oef = oefBase > 0 ? (td_oef_in * 100) / oefBase : 0;

    // -----------------------

    // let jump_line = this.jumpLine.nativeElement.cloneNode('jumpLine' + this.num_sheet);

    let info_sheet = this.infoSheet.nativeElement.cloneNode('infoSheet' + this.num_sheet);

    const lotDisplay = this.getSheetLotDisplay(lotList);
    info_sheet.innerHTML = '<div class="box">' +
                              '<div class="columns is-left is-vcentered is-multiline">' +
                                '<div class="column is-12">' +
                                  // '<label class="title is-4 has-text-centered has-text-grey">' + this.tr['st1_OptiName'] + ': </label>' +
                                  // '<label class="title is-4 has-text-centered">' + (this.currentOpti ? this.currentOpti.id : 'Prueba') + '</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  '<label class="title is-4 has-text-centered has-text-grey">' + this.tr['st1_Sheet'] + ': </label>' +
                                  '<label class="title is-4 has-text-centered">' + this.num_sheet + '/' + totalNumSheets + '</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  '<label class="title is-4 has-text-centered has-text-grey">' + this.tr['st1_fieldLote'] + ': </label>' +
                                  '<label class="title is-4 has-text-centered">' + lotDisplay + '</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  '<label class="title is-4 has-text-centered has-text-grey">' + this.tr['dtMatName'] + ': </label>' +
                                  '<label class="title is-4 has-text-centered">' + sheetMaterial + '</label>' +
                                  '<BR>' +
                                  '<label class="title is-6 has-text-centered">' + this.tr['st1_OptiNumPiece'] + ' </label>' +
                                  '<label class="has-text-centered">' + sheet_num_pieces + '</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  '<label class="title is-6 has-text-centered">' + this.tr['st1_OptiAreaB'] + ' </label>' +
                                  '<label class="has-text-centered">' + tb.toFixed(2) + ' m²</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  '<label class="title is-6 has-text-centered">' + this.tr['st1_OptiAreaP'] + ' </label>' +
                                  '<label class="has-text-centered">' + tn.toFixed(2) + ' m²</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  '<label class="title is-6 has-text-centered">' + this.tr['st1_OptiAreaR'] + ' </label>' +
                                  '<label class="has-text-centered">' + tr.toFixed(2) + ' m²</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  '<label class="title is-6 has-text-centered">' + this.tr['st1_OptiAreaT'] + ' </label>' +
                                  '<label class="has-text-centered">' + td.toFixed(2) + ' m²</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  '<label class="title is-6 has-text-centered">' + this.tr['st1_OptiAreaX'] + ' </label>' +
                                  '<label class="has-text-centered">' + tm.toFixed(2) + ' %</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                                  '<label class="title is-6 has-text-centered">Merma OEF: </label>' +
                                  '<label class="has-text-centered">' + tm_oef.toFixed(2) + ' %</label>' +
                                '</div>' +
                              '</div>' +
                            '</div><BR>';

    // NOTA: No funciona haciendolo hijo del canvas, no lo renderiza.
    // new_canvas.appendChild(info_sheet);

    // new_carousel_cell.appendChild(new_canvas);
    // containerIn.appendChild(new_carousel_cell);

    containerIn.appendChild(new_canvas);
    containerIn.appendChild(info_sheet);

    this.totalPieces += sheet_num_pieces;

    // console.log('**-> totalPieces:');
    // console.log(this.totalPieces);

    // console.log('--> drawSheetCanvas containerIn:');
    // console.log(containerIn);

    // -----------------------

    // Función que escribe las letas una a una de arriba hacia abajo.
    function writeHorizontal(text, x, y, verticalSpacing) {

      for (let i = 0; i < text.length; i++) {

        contexto.fillText(text[i], x, y + i * verticalSpacing);

      }
    } // End function writeHorizontal

    // Se devuelve la información recopilada sobre la hoja durante su procesamiento.
    return { ts: ts, tb: tb, tn: tn, tr: tr, td: td, tm: tm, td_oef_in: td_oef_in, tm_oef: tm_oef, tj: tj };

  } // End function drawSheetCanvas

  // --------------------
  //      IMPRESIÓN
  // --------------------

  print(): void {
    /*
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Impresión</title>
          <style>
          //........Estilo customizado.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
    */
    window.print();
  } // End function print

  buildGraphicsPrintFileName(): string {
    let lotText = 'lote';
    let materialText = 'material';

    if (this.totalLotList && this.totalLotList.length > 0) {
      lotText = this.totalLotList[0] ? this.totalLotList[0].toString() : 'lote';
    } else if (this.searchPieceForm && this.searchPieceForm.controls && this.searchPieceForm.controls.f_batchno) {
      lotText = this.searchPieceForm.controls.f_batchno.value ? this.searchPieceForm.controls.f_batchno.value.toString() : 'lote';
    }

    if (this.totalMaterialList && this.totalMaterialList.length > 0) {
      materialText = this.totalMaterialList[0] ? this.totalMaterialList[0].toString() : 'material';
    }

    lotText = lotText.replace(/[^a-zA-Z0-9_-]/g, '_');
    materialText = materialText.replace(/[^a-zA-Z0-9_-]/g, '_');

    return 'VScut-' + lotText + '-' + materialText;
  }

  buildPredictedCncFileNameForPrint(): string {
    const exportMode = this.fileForm && this.fileForm.controls && this.fileForm.controls.f_export && this.fileForm.controls.f_export.value
      ? this.fileForm.controls.f_export.value.toString().toUpperCase()
      : 'V40';

    let lotTxt = '';
    let matIdTxt = '';
    let matNameTxt = '';

    if (this.opti && this.opti.sheetList && this.opti.sheetList.length > 0) {
      for (let i = 0; i < this.opti.sheetList.length; i++) {
        const sh = this.opti.sheetList[i];
        if (!sh || !sh.pieces || sh.pieces.length < 1) continue;
        for (let j = 0; j < sh.pieces.length; j++) {
          const el = sh.pieces[j];
          if (!el || !el.piece) continue;
          const p: any = el.piece as any;
          const elAny: any = el as any;
          const shAny: any = sh as any;
          lotTxt = (p.piece_lot !== undefined && p.piece_lot !== null ? p.piece_lot
            : (elAny.lot !== undefined && elAny.lot !== null ? elAny.lot
              : (shAny.lot !== undefined && shAny.lot !== null ? shAny.lot : ''))).toString();
          matIdTxt = (p.piece_mat_id !== undefined && p.piece_mat_id !== null ? p.piece_mat_id
            : (shAny.mat_id !== undefined && shAny.mat_id !== null ? shAny.mat_id : '')).toString();
          matNameTxt = (p.piece_material !== undefined && p.piece_material !== null ? p.piece_material
            : (shAny.mat_name !== undefined && shAny.mat_name !== null ? shAny.mat_name
              : (shAny.mat_desc !== undefined && shAny.mat_desc !== null ? shAny.mat_desc : ''))).toString();
          break;
        }
        if (lotTxt || matIdTxt || matNameTxt) break;
      }
    }

    const baseLotMat = (lotTxt + matIdTxt).slice(0, 8);
    const lotLast3 = lotTxt ? lotTxt.slice(-3) : '000';
    const matNameSafe = matNameTxt ? matNameTxt.replace(/[\\/:*?"<>|]/g, '_').replace(/\s+/g, '_') : 'UNKNOW';
    const today = new Date();
    const yyyy = today.getFullYear().toString();
    const mm = ('0' + (today.getMonth() + 1)).slice(-2);
    const dd = ('0' + today.getDate()).slice(-2);
    const ymd = yyyy + mm + dd;
    const resolvedOptiId = this.resolveCurrentOptiId();
    const optiIdSafe = resolvedOptiId ? resolvedOptiId.toString() : '';
    const hasSavedOpti = optiIdSafe !== '';
    const fallbackBase = 'prueba';

    switch (exportMode) {
      case 'V40': return hasSavedOpti ? ('V40' + optiIdSafe + '.json') : (fallbackBase + '.v40');
      case 'OTD': return hasSavedOpti ? 'intermac_optimization.OTD' : (fallbackBase + '.otd');
      case 'BTR': return hasSavedOpti ? ('BTR' + optiIdSafe + '.R01') : (fallbackBase + '.r01');
      case 'TEC': return hasSavedOpti ? ('TEC' + optiIdSafe + '.R01') : (fallbackBase + '.r01');
      case 'ELO': return hasSavedOpti ? ((matIdTxt ? matIdTxt : '000') + matNameSafe + '.NST') : (fallbackBase + '.nst');
      case 'LSW': return hasSavedOpti ? (ymd + '_' + lotLast3 + '_' + (matIdTxt ? matIdTxt : '000') + '.zip') : (fallbackBase + '.zip');
      case 'LIOPT': {
        const dd = ('0' + today.getDate()).slice(-2);
        const mm = ('0' + (today.getMonth() + 1)).slice(-2);
        const yy = today.getFullYear().toString().slice(-2);
        const yymmdd = yy + mm + dd;
        const optiTxt = hasSavedOpti ? ('OPT' + ('00000' + optiIdSafe).slice(-5)) : 'OPT00000';
        return yymmdd + '_LIOPT580_' + optiTxt + '.zip';
      }
      default: return hasSavedOpti ? ('V40' + optiIdSafe + '.json') : (fallbackBase + '.v40');
    }
  }

  getDisplayedCncFileName(): string {
    const predicted = this.buildPredictedCncFileNameForPrint();
    const currentOptiId = this.resolveCurrentOptiId();
    const exported = this.lastExportedFileName ? this.lastExportedFileName.toString() : '';
    if (!exported) {
      return predicted;
    }
    if (!currentOptiId) {
      return exported;
    }
    const exportedDigits = exported.replace(/[^0-9]/g, '');
    return exportedDigits === currentOptiId.toString() ? exported : predicted;
  }

  buttonPrint(): void {
    console.log('-->--> Pulsado buttonPrint: ' + this.fileForm.controls.f_print.value);
    console.log(this.lastExportedFileName);

    switch (this.fileForm.controls.f_print.value) {

      case 'easels':

        this.buttonPrintEasels();

        break;

      case 'graphics':

        this.buttonPrintSheets(this.actual_sheet);

        // Se muestra la etiqueta que tiene el nombre del último archivo exportado.
    	//this.lastExportedFileModal = false;

        break;

      case 'sequences':

        this.buttonPrintSequences();

        break;

      case 'cutting':

        this.buttonPrintCutting();

        break;

      default:

        console.log('-> No se ha encontrado el modo seleccionado de impresión.');

        break;
    }
  } // End function buttonPrint

  // Función para imprimir el documento de "Orden de tronzado" de la optimización.
  buttonPrintCutting(): void {
    console.log('-->--> Pulsado buttonPrintCutting.');

    if (!this.optimizationList || this.optimizationList.length === 0) {
      console.log('->> >> No hay datos que optimizar cargados.');

      this.alertInfo = 'No hay datos cargados para optimizar.\nSeleccione un archivo de carga con un formato correcto.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      return;
    }

    switch (Number(this.fileForm.controls.f_mode.value)) {

      case 1:

        console.log('--> Imprimir orden tronzado MODO 1. cutTotalOrderList: ');
        console.log(this.cutTotalOrderList);

        let cut_order_list_mode1 = this.cutTotalOrderList.filter( p => p.type === 'P');
		console.log('--> buttonPrintCutting Lista de piezas ordenadas según tronzado MODO 1:');
        console.log(cut_order_list_mode1);

        let aux_mode1 = [];
        let groupList_mode1 = this.opti.groupListMode1;

        // Se mete la información de los caballetes continuos si los hubiese.
		let apile_list = this.getAdjacentEaselList(groupList_mode1);

		console.log(' -> Lista apilos y adyacentes return: ');
	    console.log(apile_list);

        for (let prop in groupList_mode1) {
          console.log(' Modo 1 Grupo: ' + prop);
          console.log(groupList_mode1[prop]);
          aux_mode1.push( { name: prop, content: groupList_mode1[prop] });
        }

        // NOTA: para usar la función de impresión en PDF.
        this.printEasels.emit({
          group_list: aux_mode1,
          sheet_list: this.opti.sheetList,
          cutting_list: cut_order_list_mode1,
          apile_list: apile_list,
          opti_info: this.currentOpti && this.showOptiId ? this.currentOpti : null,
          action: 'PrintCuttingMode1',
          back: 'file-list',
          mode: this.fileForm.controls.f_mode.value,
          level: this.fileForm.controls.f_level.value,
          block: this.fileForm.controls.f_blocks.value
        });

        break;

      case 2:
	  case 3:

        console.log('--> Imprimir orden tronzado MODO 2. cutTotalOrderList: ');
        console.log(this.cutTotalOrderList);

        let cut_order_list_mode2 = this.cutTotalOrderList.filter( p => p.type === 'P');
		console.log('--> buttonPrintCutting Lista de piezas ordenadas según tronzado MODO 2:');
        console.log(cut_order_list_mode2);

        let aux_mode2 = [];
        let groupList_mode2 = this.opti.groupListMode2;

        // Se mete la información de los caballetes continuos si los hubiese.
		let apile_list2 = this.getAdjacentEaselList(groupList_mode2);

		console.log(' -> Lista apilos y adyacentes: ');
	    console.log(apile_list2);

        for (let prop in groupList_mode2) {
          console.log(' Modo 2 Grupo: ' + prop);
          console.log(groupList_mode2[prop]);
          aux_mode2.push( { name: prop, content: groupList_mode2[prop] });
        }

        console.log(' -> Información de Grupos group_list pasada al controlador: ');
        console.log(aux_mode2);

        // NOTA: para usar la función de impresión en PDF.
        this.printEasels.emit({
          group_list: aux_mode2,
          sheet_list: this.opti.sheetList,
          cutting_list: cut_order_list_mode2,
          apile_list: apile_list2,
          opti_info: this.currentOpti && this.showOptiId ? this.currentOpti : null,
          action: 'PrintCuttingMode2',
          back: 'file-list',
          mode: this.fileForm.controls.f_mode.value,
          level: this.fileForm.controls.f_level.value,
          block: this.fileForm.controls.f_blocks.value
        });

        break;

      default:

        console.log('--> Modo de impresión no encontrado.');

        break;
    }
  } // End function buttonPrintCutting

  // Función para imprimir el documento de "Lotes y Secuencias" de la optimización.
  buttonPrintSequences(): void {
    console.log('-->--> Pulsado buttonPrintSequences.');

    if (!this.optimizationList || this.optimizationList.length === 0) {
      console.log('->> >> No hay datos que optimizar cargados.');

      this.alertInfo = 'No hay datos cargados para optimizar.\nSeleccione un archivo de carga con un formato correcto.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      return;
    }

    switch (Number(this.fileForm.controls.f_mode.value)) {

      case 1:

        console.log('--> Imprimir secuencias MODO 1.');

        let aux_mode1 = [];
        let groupList_mode1 = this.opti.groupListMode1;

        for (let prop in groupList_mode1) {
          console.log(' Modo 1 Grupo: ' + prop);
          console.log(groupList_mode1[prop]);
          aux_mode1.push( { name: prop, content: groupList_mode1[prop] });
        }

        // NOTA: para usar la función de impresión en PDF.
        this.printEasels.emit({
          group_list: aux_mode1,
          sheet_list: this.opti.sheetList,
          opti_info: this.currentOpti && this.showOptiId ? this.currentOpti : null,
          action: 'PrintSequencesMode1',
          back: 'file-list',
          mode: this.fileForm.controls.f_mode.value,
          level: this.fileForm.controls.f_level.value,
          block: this.fileForm.controls.f_blocks.value
        });

        break;

      case 2:

        console.log('--> Imprimir secuencias MODO 2.');

        let aux_mode2 = [];
        let groupList_mode2 = this.opti.groupListMode2;

        for (let prop in groupList_mode2) {
          console.log(' Modo 2 Grupo: ' + prop);
          console.log(groupList_mode2[prop]);
          aux_mode2.push( { name: prop, content: groupList_mode2[prop] });
        }

        console.log(' -> Información de Grupos group_list pasada al controlador: ');
        console.log(aux_mode2);

        // NOTA: para usar la función de impresión en PDF.
        this.printEasels.emit({
          group_list: aux_mode2,
          sheet_list: this.opti.sheetList,
          opti_info: this.currentOpti && this.showOptiId ? this.currentOpti : null,
          action: 'PrintSequencesMode2',
          back: 'file-list',
          mode: this.fileForm.controls.f_mode.value,
          level: this.fileForm.controls.f_level.value,
          block: this.fileForm.controls.f_blocks.value
        });

        break;

      case 3:

        console.log('--> Imprimir secuencias MODO 3.');

        let aux_mode3 = [];
        let groupList_mode3 = this.opti.groupListMode2;

        for (let prop in groupList_mode3) {
          console.log(' Modo 3 Grupo: ' + prop);
          console.log(groupList_mode3[prop]);
          aux_mode3.push( { name: prop, content: groupList_mode3[prop] });
        }

        console.log(' -> Información de Grupos group_list pasada al controlador: ');
        console.log(aux_mode3);

        // NOTA: para usar la función de impresión en PDF.
        this.printEasels.emit({
          group_list: aux_mode3,
          sheet_list: this.opti.sheetList,
          opti_info: this.currentOpti && this.showOptiId ? this.currentOpti : null,
          action: 'PrintSequencesMode3',
          back: 'file-list',
          mode: this.fileForm.controls.f_mode.value,
          level: this.fileForm.controls.f_level.value,
          block: this.fileForm.controls.f_blocks.value
        });

        break;

      default:

        console.log('--> Modo de impresión no encontrado.');

        break;
    }
  } // End function buttonPrintSequences

  async buttonPrintSheets(actualSheetIn: number): Promise<void> {
    console.log('-->--> Pulsado buttonPrintSheets: ' + actualSheetIn);

    const hasCurrentLayoutSnapshot =
      this.opti && Array.isArray(this.opti.sheetList) && this.opti.sheetList.length > 0 &&
      Array.isArray(this.lastTotalGraphicList) && this.lastTotalGraphicList.length > 0;

    // El PDF debe imprimir exactamente la geometría que está viendo el usuario.
    // Relanzar aquí la optimización podía escoger otra simulación y desalinear
    // Canvas, PDF y CNC. Sólo se calcula si todavía no existe ningún resultado.
    if (!hasCurrentLayoutSnapshot) {
      if (this.fileForm && this.fileForm.controls && this.fileForm.controls.f_zoom) {
        this.fileForm.controls.f_zoom.setValue(0.15);
      }
      await this.buttonStartOptimization(false, this.fileForm.controls.f_blocks.value ? this.fileForm.controls.f_blocks.value : false);
    }

    // Se muestran todas las hojas para que en la ventana de impresión se vean también todas.
    this.hideGraphic(0);

    if (!this.optimizationList || this.optimizationList.length === 0) {
      console.log('->> >> No hay datos que optimizar cargados.');

      this.alertInfo = 'No hay datos cargados para optimizar.\nSeleccione un archivo de carga con un formato correcto.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      return;
    }

    const optiInfoForPrint = this.showOptiId
      ? (this.currentOpti
          ? this.currentOpti
          : (this.routeOptiIdLabel && this.routeOptiIdLabel !== ''
              ? { id: Number(this.routeOptiIdLabel) }
              : null))
      : null;
    const optiIdForPrint = this.showOptiId && optiInfoForPrint && optiInfoForPrint.id !== undefined && optiInfoForPrint.id !== null
      ? Number(optiInfoForPrint.id)
      : null;
    const cuttingTableIdForPrint = Number(this.fileForm && this.fileForm.controls && this.fileForm.controls.f_cutting_table_id
      ? this.fileForm.controls.f_cutting_table_id.value
      : 0);
    const cuttingTableForPrint = (this.cuttingTables && cuttingTableIdForPrint > 0)
      ? this.cuttingTables.find(item => Number(item.id) === cuttingTableIdForPrint)
      : null;

    // Impresión en PDF desde backend (endpoint /print_sheets).
    this.printSheets.emit({
      sheet_list: this.opti.sheetList,
      cutting_list: this.cutTotalOrderList,
      total_graphic_list: this.buildPrintGraphicListSnapshot(),
      opti_info: optiInfoForPrint,
      opti_id: optiIdForPrint,
      total_stacks_preview: this.total_area_C,
      waste_percent_preview: Number(this.total_area_X.toFixed(2)),
      waste_percent_oef_preview: Number(this.total_area_X_OEF.toFixed(2)),
      rest_area_preview: Number(this.total_area_T.toFixed(2)),
      cnc_file_name: this.buildPredictedCncFileNameForPrint(),
      last_exported_file_name: this.lastExportedFileName ? this.lastExportedFileName : '',
      action: 'PrintFile',
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      f_cutting_table_id: cuttingTableIdForPrint > 0 ? cuttingTableIdForPrint : null,
      f_cutting_table_name: cuttingTableForPrint && cuttingTableForPrint.name ? cuttingTableForPrint.name.toString() : '',
      level: this.fileForm.controls.f_level.value,
      block: this.fileForm.controls.f_blocks.value,
      f_fill_piece: this.fileForm.controls.f_fill_piece.value,
      f_show_order: this.fileForm.controls.f_show_order.value,
      f_origin: this.fileForm.controls.f_origin.value,
      f_axis: this.fileForm.controls.f_axis.value,
      f_zoom: this.fileForm.controls.f_zoom.value,
      f_order: this.fileForm.controls.f_order.value,
      f_base: this.fileForm.controls.f_base.value,
      f_old: this.fileForm.controls.f_old.value,
      f_free: this.fileForm.controls.f_free.value,
      f_free_in: this.fileForm.controls.f_free_in.value,
      f_grade: this.fileForm.controls.f_grade.value,
      f_grade_rep: this.fileForm.controls.f_grade_rep.value,
      f_retal_width: this.fileForm.controls.f_retal_width.value,
      f_retal_height: this.fileForm.controls.f_retal_height.value,
      f_rute: this.fileForm.controls.f_rute.value,
      f_export: this.fileForm.controls.f_export.value,
      f_disband_l: this.fileForm.controls.f_disband_l.value,
      f_disband_r: this.fileForm.controls.f_disband_r.value,
      f_disband_t: this.fileForm.controls.f_disband_t.value,
      f_disband_b: this.fileForm.controls.f_disband_b.value,
      f_diecutting: this.fileForm.controls.f_diecutting.value,
      f_max_diecutting: this.fileForm.controls.f_max_diecutting.value
    });

    this.actual_sheet = actualSheetIn;

    // Se vuelve a colocar visualmente la página que estaba siendo mostrada.
    this.hideGraphic(this.actual_sheet);
    // console.log('->> >> Después de imprimir.');

    //this.lastExportedFileModal = false;

  } // End function buttonPrintSheets

  buttonPrintEasels(): void {
    console.log('-->--> Pulsado buttonPrintEasels.');

    if (!this.optimizationList || this.optimizationList.length === 0) {
      console.log('->> >> No hay datos que optimizar cargados.');

      this.alertInfo = 'No hay datos cargados para optimizar.\nSeleccione un archivo de carga con un formato correcto.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      return;
    }

    let aux = [];
    let groupList_aux = this.opti.groupInfoList;
    let apile_list = [];

    if (Number(this.fileForm.controls.f_mode.value) === 2 || Number(this.fileForm.controls.f_mode.value) === 3) {
		console.log('--> Imprimir grupos apilo MODO 2 o MODO 3.');
		groupList_aux = this.opti.groupListMode2;

		// Se mete la información de los caballetes continuos si los hubiese.
		apile_list = this.getAdjacentEaselList(groupList_aux);

	} else {
		console.log('--> Imprimir grupos apilo MODO 1.');
		groupList_aux = this.opti.groupListMode2;
		// Se mete la información de los caballetes continuos si los hubiese.
		apile_list = this.getAdjacentEaselList(groupList_aux);
	}

	console.log(' -> Lista apilos y adyacentes: ');
    console.log(apile_list);

    for (let prop in groupList_aux) {
      console.log(' Grupo: ' + prop);
      console.log(groupList_aux[prop]);
      aux.push( { name: prop, content: groupList_aux[prop] });
    }

    console.log(' -> Información de Grupo group_list para el controlador: ');
    console.log(aux);

    let action_aux = 'PrintFile';

    let cut_order_list_mode = this.cutTotalOrderList.filter( p => p.type === 'P');
	console.log('--> buttonPrintEasels Lista de piezas ordenadas según tronzado:');
    console.log(cut_order_list_mode);

    switch (Number(this.fileForm.controls.f_mode.value)) {

      case 1:

		action_aux = 'PrintFile1';

		break;

	  case 2:

		action_aux = 'PrintFile2';

		break;
	  case 3:

		action_aux = 'PrintFile3';

		break;
	}

    // NOTA: para usar la función de impresión en PDF.
    this.printEasels.emit({
      group_list: aux,
      sheet_list: this.opti.sheetList,
      cutting_list: cut_order_list_mode,
      apile_list: apile_list,
      opti_info: this.currentOpti && this.showOptiId ? this.currentOpti : null,
      action: action_aux,
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      level: this.fileForm.controls.f_level.value,
      block: this.fileForm.controls.f_blocks.value
    });

  } // End function buttonPrintEasels

  buttonExport(): void {

    console.log('-->--> Pulsado buttonExport.');

    if (!this.optimizationList || this.optimizationList.length === 0) {
      console.log('->> >> No hay datos que optimizar cargados.');

      this.alertInfo = 'No hay datos cargados para optimizar.\nSeleccione un archivo de carga con un formato correcto.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      return;
    }

    let aux = [];
    let groupList_aux = this.opti.groupInfoList;

    for (let prop in groupList_aux) {
      console.log(' Grupo: ' + prop);
      console.log(groupList_aux[prop]);
      aux.push( { name: prop, content: groupList_aux[prop] });
    }

    let aux_disband_l = 0;
    let aux_disband_b = 0;
    let aux_disband_r = 0;
    let aux_disband_t = 0;

    if (this.fileForm.controls.f_disband_l.value) {
      aux_disband_l = this.fileForm.controls.f_disband_l.value;
    } else {
      this.fileForm.controls.f_disband_l.setValue(0);
    }

    if (this.fileForm.controls.f_disband_b.value) {
      aux_disband_b = this.fileForm.controls.f_disband_b.value;
    } else {
      this.fileForm.controls.f_disband_b.setValue(0);
    }

    if (this.fileForm.controls.f_disband_r.value) {
      aux_disband_r = this.fileForm.controls.f_disband_r.value;
    } else {
      this.fileForm.controls.f_disband_r.setValue(0);
    }

    if (this.fileForm.controls.f_disband_t.value) {
      aux_disband_t = this.fileForm.controls.f_disband_t.value;
    } else {
      this.fileForm.controls.f_disband_t.setValue(0);
    }

    // console.log(' - Valor de desbande = ' + this.fileForm.controls.f_disband.value);
    this.opti.sheetList.forEach(s => {
      s.disband = {
        left: aux_disband_l, // this.fileForm.controls.f_disband_l.value,
        bottom: aux_disband_b, // this.fileForm.controls.f_disband_b.value,
        right: aux_disband_r, // this.fileForm.controls.f_disband_r.value,
        top: aux_disband_t // this.fileForm.controls.f_disband_t.value,
      }
    });

    if (this.fileForm.controls.f_diecutting.value) {
      // console.log(' - Valor de tronzado = ' + this.fileForm.controls.f_diecutting.value);
      this.opti.sheetList.forEach(s => {
        s.diecutting = this.fileForm.controls.f_diecutting.value;
      });
    }

	const safeExportMode = this.normalizeCncExportForProfile(this.fileForm.controls.f_export.value);
	if (safeExportMode !== this.fileForm.controls.f_export.value) {
	  this.fileForm.controls.f_export.setValue(safeExportMode);
	}

	console.log('-->--> Exportación seleccionada:' + safeExportMode);

    switch (safeExportMode) {
      case 'V40':

        console.log('-->--> Detectado V40.');
        this.createV40(aux);

        break;

      case 'LSW':
      case 'LIOPT':

        console.log('-->--> Detectado LSW.');
        /*
        // Aviso para informar que la exportación a Lisec puede fallar.
        if (!this.opti_level_fault) {

          // Se informa que para exportar a Lisec hace falta bajar el valor máximo de travera.
          this.alertInfo = 'Para exporta a formato "LSW" deberá bajar el valor de "Max.Travera".' +
          				   '\nAhora vale ' + this.max_travera + '.' +
          				   '\nUn valor adecuado suele ser dos tercios del ancho de la plancha usada.' +
          				   '\nModifique el valor, vuelva a optimizar e intente entonces exportar de nuevo.';
      	  this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
        } // */

        this.createLSW(aux);


        break;

      case 'OTD':

        console.log('-->--> Detectado OTD.');
        this.createOTD(aux);

        break;

      case 'BTR':

        console.log('-->--> Detectado BTR.');
        this.createBTR(aux);

        break;

      case 'ELO':

        console.log('-->--> Detectado ELO.');
        this.createELO(aux);

        break;

      case 'TEC':

        console.log('-->--> Detectado TEC.');
        this.createTEC(aux);

        break;

      default:
        console.log('-->--> Detectado exportación por defecto.');
        this.createV40(aux);

      break;
    }

  } // End function buttonExport

  normalizeCncExportForProfile(valueIn: any): string {
    const normalized = valueIn !== undefined && valueIn !== null
      ? valueIn.toString().toUpperCase().trim()
      : 'V40';
    const allowed = this.cncExportOptions && this.cncExportOptions.length > 0
      ? this.cncExportOptions
      : this.globals.getCncExportFamilies(this.permissions);
    return allowed.indexOf(normalized) !== -1 ? normalized : 'V40';
  }

  // Función que realiza los pasos necesarios para crear los ficheros que sirvan para exportar
  // la optimización actual a formato BTR (Bottero).
  createTEC(auxIn: any): void {

    console.log('-->--> Pulsado createTEC level0TraverseList:');
    console.log(this.level0TraverseList);

    let finalTEC = [];
    if (Array.isArray(this.level0TraverseList)) {
      finalTEC = this.level0TraverseList
        .filter((sheet) => sheet !== null && sheet !== undefined);
    } else if (this.level0TraverseList && typeof this.level0TraverseList === 'object') {
      finalTEC = Object.keys(this.level0TraverseList)
        .filter((key) => /^[0-9]+$/.test(key))
        .sort((a, b) => Number(a) - Number(b))
        .map((key) => this.level0TraverseList[key])
        .filter((sheet) => sheet !== null && sheet !== undefined);
    }

    console.log('-->--> Pulsado createTEC finalTEC:');
    console.log(finalTEC);

    const optiIdForExport = this.resolveCurrentOptiId();

    this.printEasels.emit({
      group_list: auxIn,
      sheet_list: finalTEC,
      opti_id: optiIdForExport,
      action: 'CreateTEC',
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      level: this.fileForm.controls.f_level.value,
      origin: Number(this.fileForm.controls.f_origin.value),
      merma: Number(this.total_area_X.toFixed(2)) * 100,
      bruto: Number(this.total_area_B.toFixed(2)) * 100,
      neto: Number(this.total_area_P.toFixed(2)) * 100,
      block: this.fileForm.controls.f_blocks.value
    });

  } // End function createTEC

  // Función que realiza los pasos necesarios para crear los ficheros que sirvan para exportar
  // la optimización actual a formato ELO (Elorglass).
  createELO(auxIn: any): void {

    console.log('-->--> Pulsado createELO level0TraverseList:');
    console.log(this.level0TraverseList);

    let finalELO = [];

    for (let prop in this.level0TraverseList) {
      finalELO.push(this.level0TraverseList[prop]);
    }

    console.log('-->--> Pulsado createELO finalELO:');
    console.log(finalELO);

    // Para usar la función de creación de ficheros BTR se pasa como acción el valor 'createELO'.
    this.printEasels.emit({
      group_list: auxIn,
      sheet_list: finalELO,
      action: 'CreateELO',
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      level: this.fileForm.controls.f_level.value,
      origin: Number(this.fileForm.controls.f_origin.value),
      merma: Number(this.total_area_X.toFixed(2)) * 100,
      bruto: Number(this.total_area_B.toFixed(2)) * 100,
      neto: Number(this.total_area_P.toFixed(2)) * 100,
      block: this.fileForm.controls.f_blocks.value
    });

  } // End function createELO

  // Función que realiza los pasos necesarios para crear los ficheros que sirvan para exportar
  // la optimización actual a formato BTR (Bottero).
  createBTR(auxIn: any): void {

    console.log('-->--> Pulsado createBTR level0TraverseList:');
    console.log(this.level0TraverseList);

    let finalBTR = [];

    for (let prop in this.level0TraverseList) {
      finalBTR.push(this.level0TraverseList[prop]);
    }

    console.log('-->--> Pulsado createBTR finalBTR:');
    console.log(finalBTR);

    const optiIdForExport = this.resolveCurrentOptiId();

    // Para usar la función de creación de ficheros BTR se pasa como acción el valor 'createBTR'.
    this.printEasels.emit({
      group_list: auxIn,
      sheet_list: finalBTR,
      opti_id: optiIdForExport,
      action: 'CreateBTR',
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      level: this.fileForm.controls.f_level.value,
      origin: Number(this.fileForm.controls.f_origin.value),
      merma: Number(this.total_area_X.toFixed(2)) * 100,
      bruto: Number(this.total_area_B.toFixed(2)) * 100,
      neto: Number(this.total_area_P.toFixed(2)) * 100,
      block: this.fileForm.controls.f_blocks.value
    });

  } // End function createBTR

  // Función que realiza los pasos necesarios para crear un fichero que sirva para exportar
  // la optimización actual a formato OTD que pueda ser cargado en un simulador de Intermac.
  createOTD(auxIn: any): void {
    console.log('-->--> Pulsado createOTD group_list:');
    console.log(auxIn);
    console.log('-->--> Pulsado createOTD this.opti.sheetList:');
    console.log(this.opti.sheetList);

    let finalOTD = [];

    for (let prop in this.level0TraverseList) {
      finalOTD.push(this.level0TraverseList[prop]);
    }

    console.log('-->--> Pulsado createOTD finalOTD:');
    console.log(finalOTD);

    // Para usar la función de creación de ficheros OTD se pasa como acción el valor 'CreateOTD'.
    this.printEasels.emit({
      group_list: auxIn,
      sheet_list: finalOTD, // this.opti.sheetList,
      action: 'CreateOTD',
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      level: this.fileForm.controls.f_level.value,
      origin: Number(this.fileForm.controls.f_origin.value),
      block: this.fileForm.controls.f_blocks.value
    });

  } // End function createOTD

  // Función que realiza los pasos necesarios para crear los ficheros que sirvan para exportar
  // la optimización actual a formato LSW que pueda ser cargado en un simulador de Lisec.
  createLSW(auxIn: any): void {

    console.log('-->--> Pulsado createLSW level0TraverseList:');
    console.log(this.level0TraverseList);

    const originalOriginValue = Number(this.fileForm.controls.f_origin.value);
    let forcedFallbackOrigin = false;
    let usedFallbackRebuild = false;
    const hasLevel0 = this.level0TraverseList && Object.keys(this.level0TraverseList).length > 0;
    if (!hasLevel0 && this.lastTotalGraphicList && this.lastTotalGraphicList.length > 0) {
      // RUTA FALLBACK HISTÓRICA:
      // Cuando la optimización viene desde BBDD antigua, puede no existir `level0TraverseList`.
      // Aquí se reconstruye "al vuelo" desde `lastTotalGraphicList` para exportar LSW sin
      // reoptimizar toda la pieza.
      // Compatibilidad histórica LSW: forzamos temporalmente origen 1 durante la reconstrucción
      // desde gráfico para evitar desplazamientos (x/y) que rompen TRA1 en ciertos datasets BBDD.
      if ((this.fileForm.controls.f_export.value === 'LSW' || this.fileForm.controls.f_export.value === 'LIOPT') && originalOriginValue !== 1) {
        this.fileForm.controls.f_origin.setValue(1, { emitEvent: false });
        forcedFallbackOrigin = true;
      }

      // Carga histórica: si no existe estructura runtime de traveras, se reconstruye
      // en el momento de exportar a partir del gráfico ya renderizado.
      const totalGraphicList = JSON.parse(JSON.stringify(this.lastTotalGraphicList));

      // Flujo equivalente al de la optimización normal antes de exportar CNC LSW.
      this.turnLastPiece(totalGraphicList);
      this.getCutOrder(totalGraphicList, true);

      // REGLA DE ESTABILIDAD LSW:
      // En fallback histórico, NO aplicar reorder para LSW. El reorder global puede ser útil
      // para pilas, pero aquí altera el sentido esperado por TRA1 en algunos datasets.
      const allowFallbackReorder = this.fileForm.controls.f_order.value &&
        this.fileForm.controls.f_export.value !== 'LSW' &&
        this.fileForm.controls.f_export.value !== 'LIOPT';
      if (allowFallbackReorder) {
        this.level0TraverseList = this.opti.orderTravXBySequence(this.level0TraverseList, totalGraphicList, false);
        this.getCutOrder(totalGraphicList, false);
      }

      console.log('--> createLSW fallback getCutOrder desde lastTotalGraphicList.');
      console.log(this.level0TraverseList);
      usedFallbackRebuild = true;

      // Se restaura el origen de usuario para no modificar estado de UI/formulario.
      if (forcedFallbackOrigin) {
        this.fileForm.controls.f_origin.setValue(originalOriginValue, { emitEvent: false });
      }
    }

    let finalLSW = [];
    const level0Keys = Object.keys(this.level0TraverseList || {});
    const sheetKeys = level0Keys
      .filter((k: string) => /^sheet_\d+$/.test(k))
      .sort((a: string, b: string) => Number(a.replace('sheet_', '')) - Number(b.replace('sheet_', '')));
    const numericKeys = level0Keys
      .filter((k: string) => /^\d+$/.test(k))
      .sort((a: string, b: string) => Number(a) - Number(b));

    // Si existe la forma "sheet_N", se usa como fuente canónica para evitar
    // duplicados con índices numéricos residuales tras reordenados.
    const keysToUse = sheetKeys.length > 0 ? sheetKeys : numericKeys;

    if (keysToUse.length > 0) {
      keysToUse.forEach((key: string) => {
        const sheetTraverseList = this.level0TraverseList[key];
        if (Array.isArray(sheetTraverseList) && sheetTraverseList.length > 0) {
          finalLSW.push(sheetTraverseList);
        }
      });
    } else {
      for (let prop in this.level0TraverseList) {
        finalLSW.push(this.level0TraverseList[prop]);
      }
    }

    if (usedFallbackRebuild && (this.fileForm.controls.f_export.value === 'LSW' || this.fileForm.controls.f_export.value === 'LIOPT')) {
      // Compatibilidad para carga histórica:
      // el backend LSW invierte internamente el orden de traveras X (sh.reverse()).
      // Según dataset, conviene enviar ASC o DESC para que la "cola" quede correcta.
      // Se elige orientación por hoja minimizando el ancho de cola detectado.
      finalLSW = finalLSW.map((sheetIn: any) => {
        if (!Array.isArray(sheetIn)) {
          return sheetIn;
        }
        const ascSheet = sheetIn.slice().sort((a: any, b: any) => {
          const ai = Number(a && a.sub_tr && a.sub_tr.ind);
          const bi = Number(b && b.sub_tr && b.sub_tr.ind);
          if (Number.isFinite(ai) && Number.isFinite(bi)) {
            return ai - bi;
          }
          return 0;
        });
        const descSheet = ascSheet.slice().reverse();

        // Heurística de selección de orientación:
        // "mejor" hoja = aquella cuya última travesa deja una cola menor (o nula).
        // Esto permitió compatibilizar series 1053-1057 y 1059-1060 en simulador LiSEC.
        const calcTailWidth = (arrIn: any[]): number => {
          if (!Array.isArray(arrIn) || arrIn.length === 0) {
            return Number.MAX_SAFE_INTEGER;
          }
          const lastTraverse = arrIn[arrIn.length - 1];
          const trPieces = lastTraverse && Array.isArray(lastTraverse.tr_pieces) ? lastTraverse.tr_pieces : [];
          if (trPieces.length === 0) {
            return 0;
          }
          const lastPiece = trPieces[trPieces.length - 1];
          if (lastPiece && lastPiece.type !== 'P') {
            const width = Number(lastPiece.width);
            if (Number.isFinite(width) && width >= 0) {
              return width;
            }
          }
          return 0;
        };

        const tailAsc = calcTailWidth(ascSheet);
        const tailDesc = calcTailWidth(descSheet);
        return tailAsc <= tailDesc ? ascSheet : descSheet;
      });
    }

    if (!finalLSW || finalLSW.length === 0) {
      this.alertInfo = 'No hay información de corte para exportar CNC LSW en esta optimización.';
      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
      return;
    }

    // console.log('-->--> Pulsado createLSW finalLSW:');
    // console.log(finalLSW);

	    // IMPORTANTE: Hay que recorrer toda la estructura que se va a enviar para
	    // volver a asignarles el caballete correcto (porque se obtuvo después).
	    // Son tres las zonas de la estructura que son necesarias modificar.
	    finalLSW.forEach(sh_tr => {
			sh_tr.forEach(tr_aux => {
				console.log('-> tr_aux = ');
				console.log(tr_aux);
				console.log(tr_aux.sub_tr);

			// ZONA 1: Piezas -----

			let tr_pieces = tr_aux.tr_pieces;

			tr_pieces.forEach(pz => {
				// console.log('--> pz:');
    			// console.log(pz);

    			let cut_order_piece = this.cutTotalOrderList.find(p => p.name_id === pz.name_id && p.num === pz.num);

				// console.log('· cut_order_piece: ');
	            // console.log(cut_order_piece);

	            if (cut_order_piece) {
	                pz.easel = cut_order_piece.easel;
	                pz['cut_order'] = cut_order_piece.cut_order;
	                pz['sequence_broked'] = cut_order_piece.sequence_broked;
	            }
			});

			// ZONA 2: Contenido -----

			let tr_content = tr_aux.sub_tr.tr_in;

			if (tr_content) {

				tr_content.forEach(cont => {
					let pieces = cont.pieces;

					pieces.forEach(pz => {

						// console.log('--> pz content:');
	    				// console.log(pz);

	    				let cut_order_piece = this.cutTotalOrderList.find(p => p.name_id === pz.name_id && p.num === pz.num);

						// console.log('· cut_order_piece content: ');
		            	// console.log(cut_order_piece);

						if (cut_order_piece) {
			                pz.easel = cut_order_piece.easel;
			                pz['cut_order'] = cut_order_piece.cut_order;
			                pz['sequence_broked'] = cut_order_piece.sequence_broked;
			            }
					});

					let tr_Y = cont.tr_in;

					if (tr_Y) {

						tr_Y.forEach(tr_y => {

							let pieces = tr_y.pieces;

							pieces.forEach(pz => {

								// console.log('--> pz tr_Y:');
			    				// console.log(pz);

			    				let cut_order_piece = this.cutTotalOrderList.find(p => p.name_id === pz.name_id && p.num === pz.num);

								// console.log('· cut_order_piece tr_Y: ');
				            	// console.log(cut_order_piece);

								if (cut_order_piece) {
					                pz.easel = cut_order_piece.easel;
					                pz['cut_order'] = cut_order_piece.cut_order;
					                pz['sequence_broked'] = cut_order_piece.sequence_broked;
					            }
							});
						});
					} // End If tr_Y.

				}); // End For tr_content.
			} // End If tr_content.

			// ZONA 3: Traveras Y -----

			let pieces = tr_aux.sub_tr.pieces;

			pieces.forEach(pz => {

				// console.log('--> pz tr_Y:');
				// console.log(pz);

				let cut_order_piece = this.cutTotalOrderList.find(p => p.name_id === pz.name_id && p.num === pz.num);

				// console.log('· cut_order_piece tr_Y: ');
            	// console.log(cut_order_piece);

				if (cut_order_piece) {
	                pz.easel = cut_order_piece.easel;
	                pz['cut_order'] = cut_order_piece.cut_order;
	                pz['sequence_broked'] = cut_order_piece.sequence_broked;
	            }
			});

			//------ Fin ZONAS
		});
	});

	console.log('--> finalLSW resultado:');
	console.log(finalLSW);

    // Para usar la función de creación de ficheros LSW se pasa como acción el valor 'createLSW'.
    const exportModeCode = this.fileForm && this.fileForm.controls && this.fileForm.controls.f_export
      ? this.fileForm.controls.f_export.value
      : 'LSW';
    this.printEasels.emit({
      group_list: auxIn,
      sheet_list: finalLSW,
      opti_id: this.resolveCurrentOptiId(),
      action: exportModeCode === 'LIOPT' ? 'CreateLIOPT' : 'CreateLSW',
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      level: this.fileForm.controls.f_level.value,
      origin: Number(this.fileForm.controls.f_origin.value),
      merma: Number(this.total_area_X.toFixed(2)) * 100,
      bruto: Number(this.total_area_B.toFixed(2)) * 100,
      neto: Number(this.total_area_P.toFixed(2)) * 100,
      block: this.fileForm.controls.f_blocks.value
    });

	  } // End function createLSW

  // Función que realiza los pasos necesarios para crear un fichero que sirva para exportar
  // la optimización actual a formato V40 que pueda ser cargado en un simulador de Turomas.
  createV40(auxIn: any): void {
    console.log('-->--> Pulsado createV40.');
    const optiIdForExport = this.resolveCurrentOptiId();

    // Para usar la función de creación de ficheros V40 se pasa como acción el valor 'CreateV40'.
    this.printEasels.emit({
      group_list: auxIn,
      sheet_list: this.opti.sheetList,
      opti_id: optiIdForExport,
      action: 'CreateV40',
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      level: this.fileForm.controls.f_level.value,
      origin: Number(this.fileForm.controls.f_origin.value),
      block: this.fileForm.controls.f_blocks.value,
      oef: this.buildOefPayload()
    });

  } // End function createV40

  private getOefSettings(): any {
    return {
      enabled: this.oefEnabled === true && this.disableOefForVsBudgetDirectInput !== true,
      preset: this.oefPreset ? this.oefPreset : 'equilibrado',
      benchmark: this.oefBenchmark === true,
      params: {
        phase: this.oefPhase && Number(this.oefPhase) >= 2 ? 2 : 1,
        allow_mirror: this.oefAllowMirror === true
      }
    };
  }

  private buildOefPayload(): any {
    const settings = this.getOefSettings();
    if (!settings.enabled) {
      return { enabled: false };
    }
    const selectedPrimitives = this.lastOefPreSearch && Array.isArray(this.lastOefPreSearch.selected_primitives)
      ? this.lastOefPreSearch.selected_primitives
      : [];
    return {
      enabled: true,
      preset: settings.preset,
      benchmark: settings.benchmark === true,
      params: settings.params || { phase: 2 },
      selected_primitives: selectedPrimitives
    };
  }

  private loadOefSettingsFromStorage(): void {
    const defaults = {
      enabled: false,
      preset: 'equilibrado',
      benchmark: false,
      params: { phase: 2, allow_mirror: false }
    };

    try {
      const raw = localStorage.getItem('vs_oef_settings');
      if (!raw) {
        return;
      }
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') {
        return;
      }
      this.oefEnabled = parsed.enabled === true;
      this.oefPreset = parsed.preset ? parsed.preset.toString() : defaults.preset;
      this.oefBenchmark = parsed.benchmark === true;
      const phaseRaw = Number(parsed.params && parsed.params.phase !== undefined ? parsed.params.phase : defaults.params.phase);
      this.oefPhase = Number.isFinite(phaseRaw) && phaseRaw >= 2 ? 2 : 1;
      this.oefAllowMirror = !!(parsed.params && parsed.params.allow_mirror === true);
    } catch (error) {
      this.oefEnabled = defaults.enabled;
      this.oefPreset = defaults.preset;
      this.oefBenchmark = defaults.benchmark;
      this.oefPhase = defaults.params.phase;
      this.oefAllowMirror = defaults.params.allow_mirror;
    }
  }

  private persistOefSettingsToStorage(): void {
    const settings = this.getOefSettings();
    localStorage.setItem('vs_oef_settings', JSON.stringify(settings));
  }

  onOefEnabledChange(eventIn: any): void {
    this.oefEnabled = !!(eventIn && eventIn.target && eventIn.target.checked);
    this.persistOefSettingsToStorage();
  }

  onOefPresetChange(eventIn: any): void {
    const value = eventIn && eventIn.target ? eventIn.target.value : this.oefPreset;
    this.oefPreset = value ? value.toString() : 'equilibrado';
    this.persistOefSettingsToStorage();
  }

  onOefPhaseChange(eventIn: any): void {
    const raw = Number(eventIn && eventIn.target ? eventIn.target.value : this.oefPhase);
    this.oefPhase = (Number.isFinite(raw) && raw >= 2) ? 2 : 1;
    this.persistOefSettingsToStorage();
  }

  onOefBenchmarkChange(eventIn: any): void {
    this.oefBenchmark = !!(eventIn && eventIn.target && eventIn.target.checked);
    this.persistOefSettingsToStorage();
  }

  onOefAllowMirrorChange(eventIn: any): void {
    this.oefAllowMirror = !!(eventIn && eventIn.target && eventIn.target.checked);
    this.persistOefSettingsToStorage();
  }

  private getPieceFigureId(pieceIn: any): number {
    const figureRaw = Number(pieceIn && pieceIn.figure);
    if (Number.isFinite(figureRaw) && figureRaw > 0) {
      return Math.round(figureRaw);
    }
    const inputRaw = Number(pieceIn && pieceIn.piece_figure_input);
    if (Number.isFinite(inputRaw) && inputRaw > 0) {
      return Math.round(inputRaw);
    }
    return 0;
  }

  private isPieceOefCandidate(pieceIn: any): boolean {
    if (!pieceIn) {
      return false;
    }
    if (pieceIn.source_from_vs_budget_direct === true) {
      return false;
    }
    const figure = this.getPieceFigureId(pieceIn);
    if (Number.isFinite(figure) && figure > 0) {
      return true;
    }
    if (pieceIn.dxf_points && pieceIn.dxf_points.length) {
      return true;
    }
    if (pieceIn.piece_dxf_points && pieceIn.piece_dxf_points.length) {
      return true;
    }
    if (Array.isArray(pieceIn.oef_internal_polygons) && pieceIn.oef_internal_polygons.length > 0) {
      return true;
    }
    if (Array.isArray(pieceIn.piece_oef_internal_polygons) && pieceIn.piece_oef_internal_polygons.length > 0) {
      return true;
    }
    return false;
  }

  private parseOefPoints(rawIn: any): any[] {
    if (!rawIn) {
      return [];
    }
    if (Array.isArray(rawIn)) {
      return rawIn;
    }
    if (typeof rawIn === 'string') {
      try {
        const parsed = JSON.parse(rawIn);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }
    return [];
  }

  private normalizeOefPolygon(pointsIn: any[], widthIn: number, heightIn: number): any[] {
    if (!Array.isArray(pointsIn) || pointsIn.length < 3) {
      return [];
    }
    const normalized = [];
    let minX = Number.POSITIVE_INFINITY;
    let minY = Number.POSITIVE_INFINITY;
    let maxX = Number.NEGATIVE_INFINITY;
    let maxY = Number.NEGATIVE_INFINITY;

    pointsIn.forEach(point => {
      const x = Number(point.x !== undefined ? point.x : (point.X !== undefined ? point.X : point[0]));
      const y = Number(point.y !== undefined ? point.y : (point.Y !== undefined ? point.Y : point[1]));
      if (!Number.isFinite(x) || !Number.isFinite(y)) {
        return;
      }
      minX = Math.min(minX, x);
      minY = Math.min(minY, y);
      maxX = Math.max(maxX, x);
      maxY = Math.max(maxY, y);
      normalized.push({ x: x, y: y });
    });

    if (normalized.length < 3) {
      return [];
    }

    // Algunos DXF repiten el primer punto al final para cerrar el contorno.
    // Se elimina ese duplicado para no distorsionar la detección geométrica.
    if (normalized.length >= 4) {
      const first = normalized[0];
      const last = normalized[normalized.length - 1];
      if (Math.abs(first.x - last.x) < 0.0001 && Math.abs(first.y - last.y) < 0.0001) {
        normalized.pop();
      }
    }
    if (normalized.length < 3) {
      return [];
    }

    const rangeX = Math.max(0.000001, maxX - minX);
    const rangeY = Math.max(0.000001, maxY - minY);
    const sx = widthIn / rangeX;
    const sy = heightIn / rangeY;

    return normalized.map(p => ({
      x: (p.x - minX) * sx,
      y: (p.y - minY) * sy
    }));
  }

  private getPolygonAreaAbs(polygonIn: any[]): number {
    if (!Array.isArray(polygonIn) || polygonIn.length < 3) {
      return 0;
    }
    let sum = 0;
    for (let i = 0; i < polygonIn.length; i++) {
      const p1 = polygonIn[i];
      const p2 = polygonIn[(i + 1) % polygonIn.length];
      const x1 = Number(p1 && p1.x);
      const y1 = Number(p1 && p1.y);
      const x2 = Number(p2 && p2.x);
      const y2 = Number(p2 && p2.y);
      if (!Number.isFinite(x1) || !Number.isFinite(y1) || !Number.isFinite(x2) || !Number.isFinite(y2)) {
        continue;
      }
      sum += (x1 * y2) - (x2 * y1);
    }
    return Math.abs(sum) * 0.5;
  }

  private isTriangleLikePiece(pieceIn: any, polygonIn: any[], widthIn: number, heightIn: number): boolean {
    const figure = this.getPieceFigureId(pieceIn);
    // Forma 38 (paralelogramo) nunca debe entrar en la regla triangular.
    // Si se clasifica como triángulo se generan candidatos "interlock" inválidos
    // con solapes, que es justo el comportamiento a evitar en OEF.
    if (this.isForm38Figure(figure)) {
      return false;
    }
    if (this.isTriangleFigure(figure)) {
      return true;
    }
    if (!Array.isArray(polygonIn) || polygonIn.length < 3) {
      return false;
    }
    if (polygonIn.length === 3) {
      return true;
    }
    const bboxArea = Math.max(0.000001, Number(widthIn) * Number(heightIn));
    const polyArea = this.getPolygonAreaAbs(polygonIn);
    const fillRatio = polyArea / bboxArea;
    // Triángulos DXF cerrados con punto repetido o con vértices intermedios
    // suelen quedar en ~0.5 del bounding-box.
    return fillRatio > 0.30 && fillRatio <= 0.62;
  }

  private isTriangleFigure(figureIn: number): boolean {
    const f = Number(figureIn);
    // Figuras triangulares conocidas en catálogo.
    const triangleIds = [
      3, 4, 20, 30, 43,
      200, 201, 430, 431, 440, 441, 5330, 5331,
      590, 591, 600, 601, 610, 611
    ];
    return triangleIds.indexOf(f) >= 0;
  }

  private isForm38Figure(figureIn: number): boolean {
    const figure = Number(figureIn);
    return figure === 37 || figure === 38 || figure === 371 || figure === 372;
  }

  private isParallelogramFigure(figureIn: number): boolean {
    const figure = Number(figureIn);
    return figure === 37 || figure === 38 || figure === 371 || figure === 372;
  }

  private getFigure372ResolvedValuesFromForm(updateControlsIn: boolean = false): any {
    const ctrl = this.figureForm && this.figureForm.controls ? this.figureForm.controls : null;
    if (!ctrl) return { ok: false, error: 'Formulario no disponible.' };

    const raw = {
      L: ctrl.figure_l.value,
      L1: ctrl.figure_l1.value,
      L2: ctrl.figure_l2.value,
      L3: ctrl.figure_b3.value,
      H1: ctrl.figure_h1.value,
      H2: ctrl.figure_h2.value
    };
    const isMissing = (v) => v === null || v === undefined || v === '';
    const missing = Object.keys(raw).filter(k => isMissing(raw[k]));
    if (missing.length > 1) {
      return { ok: false, error: 'La forma 372 solo permite dejar vacío un parámetro entre L, L1, L2, L3, H1 y H2.' };
    }

    const values: any = {};
    Object.keys(raw).forEach(k => {
      values[k] = isMissing(raw[k]) ? null : Number(raw[k]);
    });
    const invalid = Object.keys(values).filter(k => values[k] !== null && (!Number.isFinite(values[k]) || values[k] < 0));
    if (invalid.length > 0) {
      return { ok: false, error: 'Los parámetros de la forma 372 deben ser números positivos o cero.' };
    }

    const missingKey = missing.length === 1 ? missing[0] : '';
    if (missingKey === 'H1') {
      values.H1 = values.H2;
    } else if (missingKey === 'H2') {
      values.H2 = values.H1;
    } else if (missingKey === 'L') {
      values.L = Math.sqrt(Math.pow(values.L3 - values.L1 + values.L2, 2) + Math.pow(values.H1 - values.H2, 2));
    } else if (missingKey === 'L1' || missingKey === 'L2' || missingKey === 'L3') {
      const horizontalSq = Math.pow(values.L, 2) - Math.pow(values.H1 - values.H2, 2);
      if (horizontalSq < -0.000001) {
        return { ok: false, error: 'No se puede calcular la forma 372: L es menor que la diferencia entre H1 y H2.' };
      }
      const horizontal = Math.sqrt(Math.max(0, horizontalSq));
      if (missingKey === 'L1') values.L1 = values.L3 + values.L2 - horizontal;
      if (missingKey === 'L2') values.L2 = horizontal - values.L3 + values.L1;
      if (missingKey === 'L3') values.L3 = horizontal + values.L1 - values.L2;
    }

    if (!(values.L > 0 && values.L3 > 0 && values.H1 > 0 && values.H2 > 0)) {
      return { ok: false, error: 'Los valores L, L3, H1 y H2 de la forma 372 deben ser mayores que cero.' };
    }
    if (values.L1 < 0 || values.L2 < 0) {
      return { ok: false, error: 'Los valores L1 y L2 de la forma 372 no pueden ser negativos.' };
    }
    if ((values.L3 + values.L2 - values.L1) < -0.000001) {
      return { ok: false, error: 'La forma 372 no es válida: L1 no puede ser mayor que L3 + L2.' };
    }
    const expectedL = Math.sqrt(Math.pow(values.L3 - values.L1 + values.L2, 2) + Math.pow(values.H1 - values.H2, 2));
    if (Math.abs(expectedL - values.L) > 0.5) {
      return { ok: false, error: 'La forma 372 no es válida: L no coincide con L1, L2, L3, H1 y H2.' };
    }

    Object.keys(values).forEach(k => values[k] = Math.round(values[k] * 1000) / 1000);
    if (updateControlsIn) {
      ctrl.figure_l.setValue(values.L);
      ctrl.figure_l1.setValue(values.L1);
      ctrl.figure_l2.setValue(values.L2);
      ctrl.figure_b3.setValue(values.L3);
      ctrl.figure_h1.setValue(values.H1);
      ctrl.figure_h2.setValue(values.H2);
      ctrl.figure_h.setValue(Math.max(values.H1, values.H2));
    }
    return { ok: true, values: values };
  }

  private isForm38Piece(pieceIn: any): boolean {
    const figure = this.getPieceFigureId(pieceIn);
    return this.isForm38Figure(figure);
  }

  private getForm38EffectiveDimensions(pieceIn: any): any {
    const figure = this.getPieceFigureId(pieceIn);
    const rawL = Number(
      pieceIn && pieceIn.l !== undefined && pieceIn.l !== null
        ? pieceIn.l
        : (pieceIn && pieceIn.piece_l !== undefined && pieceIn.piece_l !== null ? pieceIn.piece_l : 0)
    );
    const rawH = Number(
      pieceIn && pieceIn.h !== undefined && pieceIn.h !== null
        ? pieceIn.h
        : (pieceIn && pieceIn.piece_h !== undefined && pieceIn.piece_h !== null ? pieceIn.piece_h : 0)
    );
    const rawB1 = Number(
      pieceIn && pieceIn.b1 !== undefined && pieceIn.b1 !== null
        ? pieceIn.b1
        : (pieceIn && pieceIn.piece_b1 !== undefined && pieceIn.piece_b1 !== null ? pieceIn.piece_b1 : 0)
    );
    const rawB2 = Number(
      pieceIn && pieceIn.b2 !== undefined && pieceIn.b2 !== null
        ? pieceIn.b2
        : (pieceIn && pieceIn.piece_b2 !== undefined && pieceIn.piece_b2 !== null ? pieceIn.piece_b2 : 0)
    );
    // Para OEF en forma 38 se debe usar geometría nominal de la pieza.
    // B1/B2 son parámetros auxiliares de construcción, no de tamaño base.
    const L = Number.isFinite(rawL) && rawL > 0 ? rawL : 0;
    const H = Number.isFinite(rawH) && rawH > 0 ? rawH : 0;
    const B1 = Number.isFinite(rawB1) && rawB1 >= 0 ? rawB1 : 0;
    const B2 = Number.isFinite(rawB2) && rawB2 >= 0 ? rawB2 : 0;
    let width = L;
    let height = H;
    if (figure === 37 || figure === 371) {
      width = L + (2 * B1);
      height = H + (2 * B2);
    } else if (figure === 372) {
      const rawL3 = Number(
        pieceIn && pieceIn.b3 !== undefined && pieceIn.b3 !== null
          ? pieceIn.b3
          : (pieceIn && pieceIn.piece_b3 !== undefined && pieceIn.piece_b3 !== null ? pieceIn.piece_b3 : 0)
      );
      const rawL1 = Number(
        pieceIn && pieceIn.l1 !== undefined && pieceIn.l1 !== null
          ? pieceIn.l1
          : (pieceIn && pieceIn.piece_l1 !== undefined && pieceIn.piece_l1 !== null ? pieceIn.piece_l1 : 0)
      );
      const rawL2 = Number(
        pieceIn && pieceIn.l2 !== undefined && pieceIn.l2 !== null
          ? pieceIn.l2
          : (pieceIn && pieceIn.piece_l2 !== undefined && pieceIn.piece_l2 !== null ? pieceIn.piece_l2 : 0)
      );
      const rawH1 = Number(
        pieceIn && pieceIn.h1 !== undefined && pieceIn.h1 !== null
          ? pieceIn.h1
          : (pieceIn && pieceIn.piece_h1 !== undefined && pieceIn.piece_h1 !== null ? pieceIn.piece_h1 : 0)
      );
      const rawH2 = Number(
        pieceIn && pieceIn.h2 !== undefined && pieceIn.h2 !== null
          ? pieceIn.h2
          : (pieceIn && pieceIn.piece_h2 !== undefined && pieceIn.piece_h2 !== null ? pieceIn.piece_h2 : 0)
      );
      const L3 = Number.isFinite(rawL3) && rawL3 > 0 ? rawL3 : L;
      const L1 = Number.isFinite(rawL1) && rawL1 >= 0 ? rawL1 : 0;
      const L2 = Number.isFinite(rawL2) && rawL2 >= 0 ? rawL2 : 0;
      const H372 = Math.max(rawH1, rawH2);
      width = Math.max(L3, L3 + L2, L1) + (2 * B1);
      height = (Number.isFinite(H372) && H372 > 0 ? H372 : H) + (2 * B2);
    }
    return {
      width: width > 0 ? width : null,
      height: height > 0 ? height : null
    };
  }

  private getOefPieceBaseDimensions(pieceIn: any): any {
    const figure = this.getPieceFigureId(pieceIn);
    const wRaw = Number(pieceIn && pieceIn.width !== undefined ? pieceIn.width : pieceIn && pieceIn.piece_width);
    const hRaw = Number(pieceIn && pieceIn.height !== undefined ? pieceIn.height : pieceIn && pieceIn.piece_height);
    // En trapecios (formas 5/6) OEF debe trabajar con la geometría nominal
    // de la forma (L x H), no con el bounding-box heredado de flujos previos.
    // Esto evita primitivos sobredimensionados (p.ej. 2948 mm en lugar de ~1200-1300 mm).
    if (figure === 5 || figure === 6) {
      const lRaw = Number(
        pieceIn && pieceIn.l !== undefined && pieceIn.l !== null
          ? pieceIn.l
          : (pieceIn && pieceIn.piece_l !== undefined && pieceIn.piece_l !== null ? pieceIn.piece_l : 0)
      );
      const hNomRaw = Number(
        pieceIn && pieceIn.h !== undefined && pieceIn.h !== null
          ? pieceIn.h
          : (pieceIn && pieceIn.piece_h !== undefined && pieceIn.piece_h !== null ? pieceIn.piece_h : 0)
      );
      const l = Number.isFinite(lRaw) && lRaw > 0 ? lRaw : 0;
      const hNom = Number.isFinite(hNomRaw) && hNomRaw > 0 ? hNomRaw : 0;
      if (l > 0 && hNom > 0) {
        return { width: l, height: hNom };
      }
    }
    if (this.isForm38Piece(pieceIn)) {
      const dims38 = this.getForm38EffectiveDimensions(pieceIn);
      if (Number.isFinite(Number(dims38 && dims38.width)) && Number(dims38.width) > 0 &&
          Number.isFinite(Number(dims38 && dims38.height)) && Number(dims38.height) > 0) {
        return { width: Number(dims38.width), height: Number(dims38.height) };
      }
    }
    return {
      width: Number.isFinite(wRaw) && wRaw > 0 ? wRaw : 0,
      height: Number.isFinite(hRaw) && hRaw > 0 ? hRaw : 0
    };
  }

  private getPiecePolygonTemplate(pieceIn: any, widthIn: number, heightIn: number): any[] {
    const figure = this.getPieceFigureId(pieceIn);
    const dxfRaw = pieceIn && pieceIn.dxf_points ? pieceIn.dxf_points : pieceIn.piece_dxf_points;
    const dxfPoints = this.parseOefPoints(dxfRaw);
    const dxfPolygon = this.normalizeOefPolygon(dxfPoints, widthIn, heightIn);
    if (this.isForm38Figure(figure) && figure !== 372) {
      // Para forma 38 solo se acepta DXF válido de 4+ vértices.
      // Si llega un contorno degenerado (p.ej. 3 puntos), se usa la
      // geometría paramétrica para no romper la generación de primitivos.
      if (dxfPolygon.length >= 4) {
        const normalizedDxf = this.normalizePolygonToBounds(dxfPolygon, widthIn, heightIn);
        if (normalizedDxf.length >= 4) {
          return normalizedDxf;
        }
      }
    } else if (dxfPolygon.length >= 3 && !this.hasTrapezoidLikeParams(pieceIn)) {
      return dxfPolygon;
    }

    if (figure === 20) {
      const rawL = Number(
        pieceIn && pieceIn.l !== undefined && pieceIn.l !== null
          ? pieceIn.l
          : (pieceIn && pieceIn.piece_l !== undefined && pieceIn.piece_l !== null ? pieceIn.piece_l : 0)
      );
      const rawB1 = Number(
        pieceIn && pieceIn.b1 !== undefined && pieceIn.b1 !== null
          ? pieceIn.b1
          : (pieceIn && pieceIn.piece_b1 !== undefined && pieceIn.piece_b1 !== null ? pieceIn.piece_b1 : 0)
      );
      const rawB2 = Number(
        pieceIn && pieceIn.b2 !== undefined && pieceIn.b2 !== null
          ? pieceIn.b2
          : (pieceIn && pieceIn.piece_b2 !== undefined && pieceIn.piece_b2 !== null ? pieceIn.piece_b2 : 0)
      );

      const L = Number.isFinite(rawL) && rawL > 0 ? rawL : Math.max(1, Number(widthIn));
      const B1 = Number.isFinite(rawB1) && rawB1 >= 0 ? rawB1 : 0;
      const B2 = Number.isFinite(rawB2) && rawB2 >= 0 ? rawB2 : 0;
      const triH = (Math.sqrt(3) / 2) * L;

      const expectedW = Math.max(0.000001, (2 * B1) + L);
      const expectedH = Math.max(0.000001, B1 + triH + B2);
      const fitW = Math.max(0.000001, Number(widthIn));
      const fitH = Math.max(0.000001, Number(heightIn));

      // Escala uniforme para mantener lados equiláteros.
      const s = Math.min(fitW / expectedW, fitH / expectedH);
      const offX = (fitW - (expectedW * s)) / 2;
      const offY = (fitH - (expectedH * s)) / 2;

      const xL = offX + (B1 * s);
      const xR = offX + ((B1 + L) * s);
      const xApex = offX + ((B1 + (L / 2)) * s);
      const yApex = offY + (B1 * s);
      const yBase = offY + ((B1 + triH) * s);

      return [
        { x: xL, y: yBase },
        { x: xApex, y: yApex },
        { x: xR, y: yBase }
      ];
    }

    if (figure === 5) {
      const rawB1 = Number(
        pieceIn && pieceIn.b1 !== undefined && pieceIn.b1 !== null
          ? pieceIn.b1
          : (pieceIn && pieceIn.piece_b1 !== undefined && pieceIn.piece_b1 !== null ? pieceIn.piece_b1 : 0)
      );
      const rawB2 = Number(
        pieceIn && pieceIn.b2 !== undefined && pieceIn.b2 !== null
          ? pieceIn.b2
          : (pieceIn && pieceIn.piece_b2 !== undefined && pieceIn.piece_b2 !== null ? pieceIn.piece_b2 : 0)
      );
      const rawB3 = Number(
        pieceIn && pieceIn.b3 !== undefined && pieceIn.b3 !== null
          ? pieceIn.b3
          : (pieceIn && pieceIn.piece_b3 !== undefined && pieceIn.piece_b3 !== null ? pieceIn.piece_b3 : 0)
      );
      const rawL = Number(
        pieceIn && pieceIn.l !== undefined && pieceIn.l !== null
          ? pieceIn.l
          : (pieceIn && pieceIn.piece_l !== undefined && pieceIn.piece_l !== null ? pieceIn.piece_l : 0)
      );
      const rawH = Number(
        pieceIn && pieceIn.h !== undefined && pieceIn.h !== null
          ? pieceIn.h
          : (pieceIn && pieceIn.piece_h !== undefined && pieceIn.piece_h !== null ? pieceIn.piece_h : 0)
      );
      const rawL1 = Number(
        pieceIn && pieceIn.l1 !== undefined && pieceIn.l1 !== null
          ? pieceIn.l1
          : (pieceIn && pieceIn.piece_l1 !== undefined && pieceIn.piece_l1 !== null ? pieceIn.piece_l1 : 0)
      );
      const rawL2 = Number(
        pieceIn && pieceIn.l2 !== undefined && pieceIn.l2 !== null
          ? pieceIn.l2
          : (pieceIn && pieceIn.piece_l2 !== undefined && pieceIn.piece_l2 !== null ? pieceIn.piece_l2 : 0)
      );

      const B1 = Number.isFinite(rawB1) && rawB1 >= 0 ? rawB1 : 0;
      const B2 = Number.isFinite(rawB2) && rawB2 >= 0 ? rawB2 : 0;
      const B3 = Number.isFinite(rawB3) && rawB3 >= 0 ? rawB3 : 0;
      const L = Number.isFinite(rawL) && rawL > 0 ? rawL : Math.max(1, Number(widthIn));
      const H = Number.isFinite(rawH) && rawH > 0 ? rawH : Math.max(1, Number(heightIn));
      const L1 = Number.isFinite(rawL1) ? Math.max(0, Math.min(rawL1, L + B3)) : 0;
      const L2 = Number.isFinite(rawL2) ? Math.max(0, Math.min(rawL2, B1 + L)) : 0;

      const yTop = B2;
      const yBase = B2 + H;
      const xBaseLeft = B1;
      const xBaseRight = B1 + L;
      const xTopLeft = L2;
      const xTopRight = B1 + L + B3 - L1;

      return this.normalizePolygonToBounds([
        { x: xBaseLeft, y: yBase },
        { x: xBaseRight, y: yBase },
        { x: xTopRight, y: yTop },
        { x: xTopLeft, y: yTop }
      ], widthIn, heightIn);
    }

    if (figure === 6) {
      const rawB1 = Number(
        pieceIn && pieceIn.b1 !== undefined && pieceIn.b1 !== null
          ? pieceIn.b1
          : (pieceIn && pieceIn.piece_b1 !== undefined && pieceIn.piece_b1 !== null ? pieceIn.piece_b1 : 0)
      );
      const rawB2 = Number(
        pieceIn && pieceIn.b2 !== undefined && pieceIn.b2 !== null
          ? pieceIn.b2
          : (pieceIn && pieceIn.piece_b2 !== undefined && pieceIn.piece_b2 !== null ? pieceIn.piece_b2 : 0)
      );
      const rawB3 = Number(
        pieceIn && pieceIn.b3 !== undefined && pieceIn.b3 !== null
          ? pieceIn.b3
          : (pieceIn && pieceIn.piece_b3 !== undefined && pieceIn.piece_b3 !== null ? pieceIn.piece_b3 : 0)
      );
      const rawL = Number(
        pieceIn && pieceIn.l !== undefined && pieceIn.l !== null
          ? pieceIn.l
          : (pieceIn && pieceIn.piece_l !== undefined && pieceIn.piece_l !== null ? pieceIn.piece_l : 0)
      );
      const rawH = Number(
        pieceIn && pieceIn.h !== undefined && pieceIn.h !== null
          ? pieceIn.h
          : (pieceIn && pieceIn.piece_h !== undefined && pieceIn.piece_h !== null ? pieceIn.piece_h : 0)
      );
      const rawL1 = Number(
        pieceIn && pieceIn.l1 !== undefined && pieceIn.l1 !== null
          ? pieceIn.l1
          : (pieceIn && pieceIn.piece_l1 !== undefined && pieceIn.piece_l1 !== null ? pieceIn.piece_l1 : 0)
      );
      const rawL2 = Number(
        pieceIn && pieceIn.l2 !== undefined && pieceIn.l2 !== null
          ? pieceIn.l2
          : (pieceIn && pieceIn.piece_l2 !== undefined && pieceIn.piece_l2 !== null ? pieceIn.piece_l2 : 0)
      );

      const B1 = Number.isFinite(rawB1) && rawB1 >= 0 ? rawB1 : 0;
      const B2 = Number.isFinite(rawB2) && rawB2 >= 0 ? rawB2 : 0;
      const B3 = Number.isFinite(rawB3) && rawB3 >= 0 ? rawB3 : 0;
      const L = Number.isFinite(rawL) && rawL > 0 ? rawL : Math.max(1, Number(widthIn));
      const H = Number.isFinite(rawH) && rawH > 0 ? rawH : Math.max(1, Number(heightIn));
      const L1 = Number.isFinite(rawL1) ? Math.max(0, Math.min(rawL1, L)) : 0;
      const L2 = Number.isFinite(rawL2) ? Math.max(0, Math.min(rawL2, L)) : 0;

      const x0 = B3;
      const y0 = B2;
      const xBL = x0;
      const yBL = y0 + H;
      const xBR = x0 + L;
      const yBR = yBL;
      const xTR = x0 + (L - L2);
      const yTR = y0;
      const xTL = x0 + L1;
      const yTL = y0;

      return this.normalizePolygonToBounds([
        { x: xBL, y: yBL },
        { x: xBR, y: yBR },
        { x: xTR, y: yTR },
        { x: xTL, y: yTL }
      ], widthIn, heightIn);
    }

    if (figure === 372) {
      const rawL3 = Number(
        pieceIn && pieceIn.b3 !== undefined && pieceIn.b3 !== null
          ? pieceIn.b3
          : (pieceIn && pieceIn.piece_b3 !== undefined && pieceIn.piece_b3 !== null ? pieceIn.piece_b3 : 0)
      );
      const rawH1 = Number(
        pieceIn && pieceIn.h1 !== undefined && pieceIn.h1 !== null
          ? pieceIn.h1
          : (pieceIn && pieceIn.piece_h1 !== undefined && pieceIn.piece_h1 !== null ? pieceIn.piece_h1 : 0)
      );
      const rawH2 = Number(
        pieceIn && pieceIn.h2 !== undefined && pieceIn.h2 !== null
          ? pieceIn.h2
          : (pieceIn && pieceIn.piece_h2 !== undefined && pieceIn.piece_h2 !== null ? pieceIn.piece_h2 : 0)
      );
      const rawL1 = Number(
        pieceIn && pieceIn.l1 !== undefined && pieceIn.l1 !== null
          ? pieceIn.l1
          : (pieceIn && pieceIn.piece_l1 !== undefined && pieceIn.piece_l1 !== null ? pieceIn.piece_l1 : 0)
      );
      const rawL2 = Number(
        pieceIn && pieceIn.l2 !== undefined && pieceIn.l2 !== null
          ? pieceIn.l2
          : (pieceIn && pieceIn.piece_l2 !== undefined && pieceIn.piece_l2 !== null ? pieceIn.piece_l2 : 0)
      );
      const rawB1 = Number(
        pieceIn && pieceIn.b1 !== undefined && pieceIn.b1 !== null
          ? pieceIn.b1
          : (pieceIn && pieceIn.piece_b1 !== undefined && pieceIn.piece_b1 !== null ? pieceIn.piece_b1 : 0)
      );
      const rawB2 = Number(
        pieceIn && pieceIn.b2 !== undefined && pieceIn.b2 !== null
          ? pieceIn.b2
          : (pieceIn && pieceIn.piece_b2 !== undefined && pieceIn.piece_b2 !== null ? pieceIn.piece_b2 : 0)
      );

      const L3 = Number.isFinite(rawL3) && rawL3 > 0 ? rawL3 : Math.max(1, Number(widthIn));
      const H1 = Number.isFinite(rawH1) && rawH1 > 0 ? rawH1 : Math.max(1, Number(heightIn));
      const H2 = Number.isFinite(rawH2) && rawH2 > 0 ? rawH2 : H1;
      const L1 = Number.isFinite(rawL1) ? Math.max(0, rawL1) : 0;
      const L2 = Number.isFinite(rawL2) ? Math.max(0, rawL2) : 0;
      const B1 = Number.isFinite(rawB1) && rawB1 >= 0 ? rawB1 : 0;
      const B2 = Number.isFinite(rawB2) && rawB2 >= 0 ? rawB2 : 0;
      const maxX = Math.max(L3, L3 + L2, L1);
      const rawW = Math.max(0.000001, maxX + (2 * B1));
      const rawHgt = Math.max(0.000001, Math.max(H1, H2) + (2 * B2));
      return this.normalizePolygonToBounds([
        { x: B1, y: B2 },
        { x: B1 + L3, y: B2 },
        { x: B1 + L3 + L2, y: B2 + H1 },
        { x: B1 + L1, y: B2 + H2 }
      ], Number(widthIn) > 0 ? Number(widthIn) : rawW, Number(heightIn) > 0 ? Number(heightIn) : rawHgt);
    }

    if (figure === 37 || figure === 371) {
      const rawL = Number(
        pieceIn && pieceIn.l !== undefined && pieceIn.l !== null
          ? pieceIn.l
          : (pieceIn && pieceIn.piece_l !== undefined && pieceIn.piece_l !== null ? pieceIn.piece_l : 0)
      );
      const rawH = Number(
        pieceIn && pieceIn.h !== undefined && pieceIn.h !== null
          ? pieceIn.h
          : (pieceIn && pieceIn.piece_h !== undefined && pieceIn.piece_h !== null ? pieceIn.piece_h : 0)
      );
      const rawL1 = Number(
        pieceIn && pieceIn.l1 !== undefined && pieceIn.l1 !== null
          ? pieceIn.l1
          : (pieceIn && pieceIn.piece_l1 !== undefined && pieceIn.piece_l1 !== null ? pieceIn.piece_l1 : 0)
      );
      const rawB1 = Number(
        pieceIn && pieceIn.b1 !== undefined && pieceIn.b1 !== null
          ? pieceIn.b1
          : (pieceIn && pieceIn.piece_b1 !== undefined && pieceIn.piece_b1 !== null ? pieceIn.piece_b1 : 0)
      );
      const rawB2 = Number(
        pieceIn && pieceIn.b2 !== undefined && pieceIn.b2 !== null
          ? pieceIn.b2
          : (pieceIn && pieceIn.piece_b2 !== undefined && pieceIn.piece_b2 !== null ? pieceIn.piece_b2 : 0)
      );

      const L = Number.isFinite(rawL) && rawL > 0 ? rawL : Math.max(1, Number(widthIn));
      const H = Number.isFinite(rawH) && rawH > 0 ? rawH : Math.max(1, Number(heightIn));
      const L1 = Number.isFinite(rawL1) ? Math.max(0, rawL1) : 0;
      const B1 = Number.isFinite(rawB1) && rawB1 >= 0 ? rawB1 : 0;
      const B2 = Number.isFinite(rawB2) && rawB2 >= 0 ? rawB2 : 0;
      const rawW = Math.max(0.000001, L + (2 * B1));
      const rawHgt = Math.max(0.000001, H + (2 * B2));
      // Geometría paralelogramo (37/371): caras superior e inferior paralelas e iguales.
      // La inclinación la aporta L1 (desfase horizontal entre ambas caras).
      const xTopL = B1 + L1;
      const xTopR = B1 + L + L1;
      const xBotL = B1;
      const xBotR = B1 + L;
      return this.normalizePolygonToBounds([
        { x: xBotL, y: rawHgt },
        { x: xBotR, y: rawHgt },
        { x: xTopR, y: 0 },
        { x: xTopL, y: 0 }
      ], Number(widthIn) > 0 ? Number(widthIn) : rawW, Number(heightIn) > 0 ? Number(heightIn) : rawHgt);
    }

    if (this.hasTrapezoidLikeParams(pieceIn)) {
      const rawL = Number(
        pieceIn && pieceIn.l !== undefined && pieceIn.l !== null
          ? pieceIn.l
          : (pieceIn && pieceIn.piece_l !== undefined && pieceIn.piece_l !== null ? pieceIn.piece_l : 0)
      );
      const rawH = Number(
        pieceIn && pieceIn.h !== undefined && pieceIn.h !== null
          ? pieceIn.h
          : (pieceIn && pieceIn.piece_h !== undefined && pieceIn.piece_h !== null ? pieceIn.piece_h : 0)
      );
      const rawL1 = Number(
        pieceIn && pieceIn.l1 !== undefined && pieceIn.l1 !== null
          ? pieceIn.l1
          : (pieceIn && pieceIn.piece_l1 !== undefined && pieceIn.piece_l1 !== null ? pieceIn.piece_l1 : 0)
      );
      const rawL2 = Number(
        pieceIn && pieceIn.l2 !== undefined && pieceIn.l2 !== null
          ? pieceIn.l2
          : (pieceIn && pieceIn.piece_l2 !== undefined && pieceIn.piece_l2 !== null ? pieceIn.piece_l2 : 0)
      );
      const L = Number.isFinite(rawL) && rawL > 0 ? rawL : Math.max(1, Number(widthIn));
      const H = Number.isFinite(rawH) && rawH > 0 ? rawH : Math.max(1, Number(heightIn));
      const L1 = Number.isFinite(rawL1) ? Math.max(0, Math.min(rawL1, L * 0.95)) : 0;
      const L2 = Number.isFinite(rawL2) ? Math.max(0, Math.min(rawL2, L * 0.95)) : 0;
      return this.normalizePolygonToBounds([
        { x: 0, y: H },
        { x: L, y: H },
        { x: Math.max(0, L - L2), y: 0 },
        { x: Math.min(L, L1), y: 0 }
      ], widthIn, heightIn);
    }

    if (this.isTriangleFigure(figure)) {
      return [
        { x: 0, y: heightIn },
        { x: widthIn / 2, y: 0 },
        { x: widthIn, y: heightIn }
      ];
    }

    if (this.isForm38Figure(figure)) {
      const rawL = Number(
        pieceIn && pieceIn.l !== undefined && pieceIn.l !== null
          ? pieceIn.l
          : (pieceIn && pieceIn.piece_l !== undefined && pieceIn.piece_l !== null ? pieceIn.piece_l : 0)
      );
      const rawL1 = Number(
        pieceIn && pieceIn.l1 !== undefined && pieceIn.l1 !== null
          ? pieceIn.l1
          : (pieceIn && pieceIn.piece_l1 !== undefined && pieceIn.piece_l1 !== null ? pieceIn.piece_l1 : 0)
      );
      const rawH = Number(
        pieceIn && pieceIn.h !== undefined && pieceIn.h !== null
          ? pieceIn.h
          : (pieceIn && pieceIn.piece_h !== undefined && pieceIn.piece_h !== null ? pieceIn.piece_h : 0)
      );

      const L = Number.isFinite(rawL) && rawL > 0 ? rawL : Math.max(1, Number(widthIn));
      const L1 = Number.isFinite(rawL1) ? Math.max(0, Math.min(rawL1, L)) : 0;
      const H = Number.isFinite(rawH) && rawH > 0 ? rawH : Math.max(1, Number(heightIn));

      const expectedW = Math.max(0.000001, L);
      const expectedH = Math.max(0.000001, H);
      const sx = Math.max(0.000001, Number(widthIn)) / expectedW;
      const sy = Math.max(0.000001, Number(heightIn)) / expectedH;

      const yB = 0;
      const yT = H;
      const xTL = 0;
      const xTR = L - L1;
      const xBR = L;
      const xBL = L1;

      const polygon = [
        { x: xBL * sx, y: yB * sy },
        { x: xBR * sx, y: yB * sy },
        { x: xTR * sx, y: yT * sy },
        { x: xTL * sx, y: yT * sy }
      ];
      // El paralelogramo debe ocupar completamente su bounding-box local
      // para que la barra OEF encaje exactamente con los lados del primitivo.
      return this.normalizePolygonToBounds(polygon, widthIn, heightIn);
    }

    return [
      { x: 0, y: 0 },
      { x: widthIn, y: 0 },
      { x: widthIn, y: heightIn },
      { x: 0, y: heightIn }
    ];
  }

  private mirrorPolygonVertical(polygonIn: any[], widthIn: number): any[] {
    return (polygonIn || []).map(p => ({ x: widthIn - p.x, y: p.y }));
  }

  private mirrorPolygonHorizontal(polygonIn: any[], heightIn: number): any[] {
    return (polygonIn || []).map(p => ({ x: p.x, y: heightIn - p.y }));
  }

  private rotatePolygon180InBounds(polygonIn: any[], widthIn: number, heightIn: number): any[] {
    return (polygonIn || []).map(p => ({
      x: widthIn - Number(p && p.x),
      y: heightIn - Number(p && p.y)
    }));
  }

  private normalizePolygonToBounds(polygonIn: any[], widthIn: number, heightIn: number): any[] {
    if (!Array.isArray(polygonIn) || polygonIn.length < 3) {
      return [];
    }
    const xs = polygonIn.map(p => Number(p && p.x)).filter(v => Number.isFinite(v));
    const ys = polygonIn.map(p => Number(p && p.y)).filter(v => Number.isFinite(v));
    if (!xs.length || !ys.length) {
      return [];
    }
    const minX = Math.min.apply(null, xs);
    const maxX = Math.max.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxY = Math.max.apply(null, ys);
    const spanX = Math.max(0.000001, maxX - minX);
    const spanY = Math.max(0.000001, maxY - minY);
    const sx = Math.max(0.000001, Number(widthIn)) / spanX;
    const sy = Math.max(0.000001, Number(heightIn)) / spanY;
    return polygonIn.map(p => ({
      x: (Number(p.x) - minX) * sx,
      y: (Number(p.y) - minY) * sy
    }));
  }

  private transformPolygon(polygonIn: any[], txIn: number, tyIn: number): any[] {
    return (polygonIn || []).map(p => ({ x: p.x + txIn, y: p.y + tyIn }));
  }

  private pointInPolygon(pointIn: any, polygonIn: any[]): boolean {
    if (!polygonIn || polygonIn.length < 3) {
      return false;
    }
    let inside = false;
    for (let i = 0, j = polygonIn.length - 1; i < polygonIn.length; j = i++) {
      const xi = polygonIn[i].x, yi = polygonIn[i].y;
      const xj = polygonIn[j].x, yj = polygonIn[j].y;
      const intersect = ((yi > pointIn.y) !== (yj > pointIn.y)) &&
        (pointIn.x < (((xj - xi) * (pointIn.y - yi)) / ((yj - yi) || 0.000001)) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  private orient(a: any, b: any, c: any): number {
    return ((b.x - a.x) * (c.y - a.y)) - ((b.y - a.y) * (c.x - a.x));
  }

  private segmentsIntersect(a1: any, a2: any, b1: any, b2: any): boolean {
    const o1 = this.orient(a1, a2, b1);
    const o2 = this.orient(a1, a2, b2);
    const o3 = this.orient(b1, b2, a1);
    const o4 = this.orient(b1, b2, a2);
    return ((o1 > 0) !== (o2 > 0)) && ((o3 > 0) !== (o4 > 0));
  }

  private polygonsOverlap(polyAIn: any[], polyBIn: any[]): boolean {
    if (!polyAIn || !polyBIn || polyAIn.length < 3 || polyBIn.length < 3) {
      return false;
    }
    for (let i = 0; i < polyAIn.length; i++) {
      const a1 = polyAIn[i];
      const a2 = polyAIn[(i + 1) % polyAIn.length];
      for (let j = 0; j < polyBIn.length; j++) {
        const b1 = polyBIn[j];
        const b2 = polyBIn[(j + 1) % polyBIn.length];
        if (this.segmentsIntersect(a1, a2, b1, b2)) {
          return true;
        }
      }
    }
    if (this.pointInPolygon(polyAIn[0], polyBIn) || this.pointInPolygon(polyBIn[0], polyAIn)) {
      return true;
    }
    return false;
  }

  private getOefCompositeUnits(itemIn: any): number {
    let polygons = itemIn && Array.isArray(itemIn.oef_internal_polygons) ? itemIn.oef_internal_polygons : [];
    if (!polygons.length && itemIn && Array.isArray(itemIn.piece_oef_internal_polygons)) {
      polygons = itemIn.piece_oef_internal_polygons;
    }
    if (!polygons.length) {
      return 1;
    }
    return Math.max(1, polygons.length);
  }

  private getOefCompositeTotalUnits(itemIn: any): number {
    const explicitRealUnits = Number(itemIn && (itemIn.oef_real_units !== undefined ? itemIn.oef_real_units : itemIn.piece_oef_real_units));
    if (Number.isFinite(explicitRealUnits) && explicitRealUnits > 1) {
      const packs = this.getOefPackUnits(itemIn);
      return Math.max(1, packs) * Math.max(1, Math.round(explicitRealUnits));
    }
    const polyUnits = this.getOefCompositeUnits(itemIn);
    const packs = this.getOefPackUnits(itemIn);
    return Math.max(1, packs) * Math.max(1, polyUnits);
  }

  private getOefPackUnits(itemIn: any): number {
    const runtimeUnitsRaw = Number(itemIn && itemIn.oef_runtime_units);
    const packsRaw = Number(itemIn && itemIn.units);
    const seqUnitRaw = Number(itemIn && itemIn.sequence_unit);
    const hasExplodedUnits = Number.isFinite(seqUnitRaw) && seqUnitRaw > 0 &&
      (!Number.isFinite(packsRaw) || packsRaw <= 0);
    const packs = hasExplodedUnits
      ? 1
      : (Number.isFinite(runtimeUnitsRaw) && runtimeUnitsRaw > 0
        ? Math.round(runtimeUnitsRaw)
        : (Number.isFinite(packsRaw) && packsRaw > 0 ? Math.round(packsRaw) : 1));
    return Math.max(1, packs);
  }

  private isOefCompositeItem(itemIn: any): boolean {
    const hasOefPolygons = !!(
      Array.isArray(itemIn && itemIn.oef_internal_polygons) && itemIn.oef_internal_polygons.length > 0
    );
    const hasPieceOefPolygons = !!(
      Array.isArray(itemIn && itemIn.piece_oef_internal_polygons) && itemIn.piece_oef_internal_polygons.length > 0
    );
    return !!(
      itemIn &&
      (
        itemIn.oef_generated === true ||
        itemIn.piece_oef_generated === true ||
        hasOefPolygons ||
        hasPieceOefPolygons
      )
    );
  }

  private buildRuntimeCoverageKey(itemIn: any): string {
    if (!itemIn) {
      return 'line:null';
    }
    const idLine = Number(itemIn.id_line !== undefined ? itemIn.id_line : itemIn.piece_id_line);
    if (Number.isFinite(idLine) && idLine > 0) {
      return 'line:' + idLine;
    }
    const orderno = Number(itemIn.orderno !== undefined ? itemIn.orderno : itemIn.piece_orderno);
    const orderpos = Number(itemIn.orderpos !== undefined ? itemIn.orderpos : itemIn.piece_orderpos);
    const matId = Number(itemIn.mat_id !== undefined ? itemIn.mat_id : itemIn.piece_mat_id);
    const figure = this.getPieceFigureId(itemIn);
    const l = Number(itemIn && itemIn.l !== undefined && itemIn.l !== null ? itemIn.l : itemIn && itemIn.piece_l);
    const l1 = Number(itemIn && itemIn.l1 !== undefined && itemIn.l1 !== null ? itemIn.l1 : itemIn && itemIn.piece_l1);
    const l2 = Number(itemIn && itemIn.l2 !== undefined && itemIn.l2 !== null ? itemIn.l2 : itemIn && itemIn.piece_l2);
    const hNom = Number(itemIn && itemIn.h !== undefined && itemIn.h !== null ? itemIn.h : itemIn && itemIn.piece_h);
    const h1 = Number(itemIn && itemIn.h1 !== undefined && itemIn.h1 !== null ? itemIn.h1 : itemIn && itemIn.piece_h1);
    const h2 = Number(itemIn && itemIn.h2 !== undefined && itemIn.h2 !== null ? itemIn.h2 : itemIn && itemIn.piece_h2);
    const b1 = Number(itemIn && itemIn.b1 !== undefined && itemIn.b1 !== null ? itemIn.b1 : itemIn && itemIn.piece_b1);
    const b2 = Number(itemIn && itemIn.b2 !== undefined && itemIn.b2 !== null ? itemIn.b2 : itemIn && itemIn.piece_b2);
    const b3 = Number(itemIn && itemIn.b3 !== undefined && itemIn.b3 !== null ? itemIn.b3 : itemIn && itemIn.piece_b3);
    const b4 = Number(itemIn && itemIn.b4 !== undefined && itemIn.b4 !== null ? itemIn.b4 : itemIn && itemIn.piece_b4);
    const lot = itemIn && itemIn.lot !== undefined && itemIn.lot !== null ? itemIn.lot.toString() : '';
    const sequence = itemIn && itemIn.sequence !== undefined && itemIn.sequence !== null ? itemIn.sequence.toString() : '';
    const dxfName = itemIn && itemIn.dxf_name ? itemIn.dxf_name.toString() : '';
    return [
      'fallback',
      Number.isFinite(orderno) ? orderno : 0,
      Number.isFinite(orderpos) ? orderpos : 0,
      Number.isFinite(matId) ? matId : 0,
      (itemIn && itemIn.id_client !== undefined && itemIn.id_client !== null) ? itemIn.id_client.toString() : '',
      lot,
      sequence,
      Number.isFinite(figure) ? figure : 0,
      Number.isFinite(l) ? Number(l).toFixed(2) : '0.00',
      Number.isFinite(l1) ? Number(l1).toFixed(2) : '0.00',
      Number.isFinite(l2) ? Number(l2).toFixed(2) : '0.00',
      Number.isFinite(hNom) ? Number(hNom).toFixed(2) : '0.00',
      Number.isFinite(h1) ? Number(h1).toFixed(2) : '0.00',
      Number.isFinite(h2) ? Number(h2).toFixed(2) : '0.00',
      Number.isFinite(b1) ? Number(b1).toFixed(2) : '0.00',
      Number.isFinite(b2) ? Number(b2).toFixed(2) : '0.00',
      Number.isFinite(b3) ? Number(b3).toFixed(2) : '0.00',
      Number.isFinite(b4) ? Number(b4).toFixed(2) : '0.00',
      dxfName
    ].join('|');
  }

  private ensureRuntimeVariantCoverage(baseListIn: any[], runtimeListIn: any[]): any[] {
    const baseList = Array.isArray(baseListIn) ? baseListIn : [];
    const runtimeList = Array.isArray(runtimeListIn) ? runtimeListIn : [];
    if (!baseList.length || !runtimeList.length) {
      return runtimeList;
    }

    const baseUnitsByKey = {};
    const runtimeUnitsByKey = {};
    const baseTemplateByKey = {};

    baseList.forEach(item => {
      if (!item || item.check !== true) {
        return;
      }
      const key = this.buildRuntimeCoverageKey(item);
      if (!baseTemplateByKey[key]) {
        baseTemplateByKey[key] = item;
      }
      baseUnitsByKey[key] = Number(baseUnitsByKey[key] || 0) + Number(this.getSelectedPieceUnits(item));
    });

    runtimeList.forEach(item => {
      if (!item || item.check !== true) {
        return;
      }
      const key = this.buildRuntimeCoverageKey(item);
      runtimeUnitsByKey[key] = Number(runtimeUnitsByKey[key] || 0) + Number(this.getSelectedPieceUnits(item));
    });

    let maxId = 0;
    runtimeList.forEach(item => {
      const id = Number(item && item.id);
      if (Number.isFinite(id) && id > maxId) {
        maxId = id;
      }
    });

    const patched = JSON.parse(JSON.stringify(runtimeList));
    Object.keys(baseUnitsByKey).forEach(key => {
      const baseUnits = Number(baseUnitsByKey[key] || 0);
      const runtimeUnits = Number(runtimeUnitsByKey[key] || 0);
      const deficit = Math.max(0, Math.round(baseUnits - runtimeUnits));
      if (deficit <= 0) {
        return;
      }
      const template = baseTemplateByKey[key];
      if (!template) {
        return;
      }
      maxId += 1;
      const dims = this.getOefPieceBaseDimensions(template);
      const w = Number(dims && dims.width);
      const h = Number(dims && dims.height);
      const poly = this.getPiecePolygonTemplate(template, w, h);
      const isGroupable = this.isOefPrimitiveGroupCandidate(template, poly, w, h);
      if (isGroupable) {
        const remainder = this.buildOefRuntimeRemainderRow(template, maxId, deficit);
        remainder.source = 'oef_runtime_coverage_deficit';
        patched.push(remainder);
        return;
      }
      const row = JSON.parse(JSON.stringify(template));
      row.id = maxId;
      row.units = deficit;
      row.check = true;
      row.oef_generated = false;
      row.oef_internal_polygons = null;
      row.oef_primitive_w = 0;
      row.oef_primitive_h = 0;
      row.oef_effective_area = 0;
      row.oef_runtime_units = deficit;
      row.oef_runtime_remainder = false;
      patched.push(row);
    });

    return patched;
  }

  private resolveSingleLotFromList(lotListIn: any[]): string {
    const lotList = [];
    (Array.isArray(lotListIn) ? lotListIn : []).forEach(v => {
      const raw = (v !== undefined && v !== null ? v.toString().trim() : '');
      if (!raw) {
        return;
      }
      raw.split(',').forEach(part => {
        const token = part !== undefined && part !== null ? part.toString().trim() : '';
        if (token) {
          const numericParts = token.match(/[0-9]+/g);
          if (numericParts && numericParts.length > 0) {
            numericParts.forEach(n => lotList.push(n));
          } else {
            lotList.push(token);
          }
        }
      });
    });
    if (!lotList.length) {
      return '';
    }
    const numeric = lotList.filter(v => /^[0-9]+$/.test(v));
    if (numeric.length === lotList.length) {
      const prefixCandidates = numeric.filter(candidate =>
        numeric.every(other => other === candidate || other.startsWith(candidate))
      );
      if (prefixCandidates.length > 0) {
        prefixCandidates.sort((a, b) => a.length - b.length || Number(a) - Number(b));
        return prefixCandidates[0];
      }
      numeric.sort((a, b) => Number(a) - Number(b));
      return numeric[0];
    }
    return lotList.join(', ');
  }

  private normalizeLotValue(lotIn: any): string {
    const raw = lotIn !== undefined && lotIn !== null ? lotIn.toString().trim() : '';
    if (!raw) {
      return '';
    }
    const firstToken = raw.split(',').map(v => v.trim()).find(v => v !== '');
    if (!firstToken) {
      return '';
    }
    const numericMatch = firstToken.match(/[0-9]+/);
    if (numericMatch && numericMatch.length > 0) {
      return numericMatch[0];
    }
    return firstToken;
  }

  private getNormalizedLotsFromValues(valuesIn: any[]): string[] {
    return Array.from(new Set(
      (Array.isArray(valuesIn) ? valuesIn : [])
        .map(v => this.normalizeLotValue(v))
        .filter(v => v !== '')
    ));
  }

  private getLotDisplayFromValues(valuesIn: any[]): string {
    const uniqueLots = this.getNormalizedLotsFromValues(valuesIn);
    if (!uniqueLots.length) {
      return '';
    }
    return uniqueLots.join(', ');
  }

  private getUniqueNormalizedLotFromValues(valuesIn: any[]): string {
    const uniqueLots = this.getNormalizedLotsFromValues(valuesIn);
    return uniqueLots.length === 1 ? uniqueLots[0] : '';
  }

  private getUniqueSelectedLot(): string {
    const rows = (Array.isArray(this.optimizationList) ? this.optimizationList : [])
      .filter(item => item && item.check === true);
    if (!rows.length) {
      return '';
    }
    return this.getUniqueNormalizedLotFromValues(
      rows.map(item => item && item.lot !== undefined ? item.lot : null)
    );
  }

  private getPrimaryLotForSave(): string {
    const sourceLots = (Array.isArray(this.optimizationList) ? this.optimizationList : [])
      .filter(item => item && item.check === true)
      .map(item => item && item.lot !== undefined && item.lot !== null ? item.lot : null)
      .filter(v => v !== null && v !== undefined && v !== '');
    const resolved = this.resolveSingleLotFromList(sourceLots);
    if (resolved) {
      return resolved;
    }
    const totalResolved = this.resolveSingleLotFromList(this.totalLotList);
    if (totalResolved) {
      return totalResolved;
    }
    if (this.currentOpti && this.currentOpti.od_lots_number) {
      const currentResolved = this.resolveSingleLotFromList(this.currentOpti.od_lots_number.toString().split(','));
      if (currentResolved) {
        return currentResolved;
      }
    }
    const batchNo = this.searchPieceForm && this.searchPieceForm.controls && this.searchPieceForm.controls.f_batchno
      ? this.searchPieceForm.controls.f_batchno.value
      : null;
    const batchResolved = this.resolveSingleLotFromList([batchNo]);
    if (batchResolved) {
      return batchResolved;
    }
    return '';
  }

  private getSheetLotDisplay(lotListIn: any[]): string {
    const fromCurrentOptiDisplay = this.getLotDisplayFromValues(
      this.currentOpti && this.currentOpti.od_lots_number
        ? this.currentOpti.od_lots_number.toString().split(',')
        : []
    );
    if (fromCurrentOptiDisplay) {
      return fromCurrentOptiDisplay;
    }
    const fromBatchDisplay = this.getLotDisplayFromValues([
      this.searchPieceForm && this.searchPieceForm.controls && this.searchPieceForm.controls.f_batchno
        ? this.searchPieceForm.controls.f_batchno.value
        : null
    ]);
    if (fromBatchDisplay) {
      return fromBatchDisplay;
    }
    const selectedRows = (Array.isArray(this.optimizationList) ? this.optimizationList : [])
      .filter(item => item && item.check === true)
      .map(item => item && item.lot !== undefined ? item.lot : null);
    const fromSelectedDisplay = this.getLotDisplayFromValues(selectedRows);
    if (fromSelectedDisplay) {
      return fromSelectedDisplay;
    }
    const fromSheet = this.getLotDisplayFromValues(lotListIn);
    if (fromSheet) {
      return fromSheet;
    }
    const fromTotal = this.getLotDisplayFromValues(this.totalLotList);
    if (fromTotal) {
      return fromTotal;
    }
    return 'N/D';
  }

  private buildOefMergeKey(itemIn: any): string {
    if (!this.isOefCompositeItem(itemIn)) {
      return 'STD';
    }
    const polygons = Array.isArray(itemIn && itemIn.oef_internal_polygons) && itemIn.oef_internal_polygons.length > 0
      ? itemIn.oef_internal_polygons
      : (Array.isArray(itemIn && itemIn.piece_oef_internal_polygons) ? itemIn.piece_oef_internal_polygons : []);
    const polyCount = polygons.length;
    const primitiveW = Number(itemIn && (itemIn.oef_primitive_w !== undefined ? itemIn.oef_primitive_w : itemIn.piece_oef_primitive_w));
    const primitiveH = Number(itemIn && (itemIn.oef_primitive_h !== undefined ? itemIn.oef_primitive_h : itemIn.piece_oef_primitive_h));
    const primitiveB1 = Number(itemIn && (itemIn.oef_primitive_b1 !== undefined ? itemIn.oef_primitive_b1 : itemIn.piece_oef_primitive_b1));
    const primitiveB2 = Number(itemIn && (itemIn.oef_primitive_b2 !== undefined ? itemIn.oef_primitive_b2 : itemIn.piece_oef_primitive_b2));
    const primitiveB3 = Number(itemIn && (itemIn.oef_primitive_b3 !== undefined ? itemIn.oef_primitive_b3 : itemIn.piece_oef_primitive_b3));
    const primitiveB4 = Number(itemIn && (itemIn.oef_primitive_b4 !== undefined ? itemIn.oef_primitive_b4 : itemIn.piece_oef_primitive_b4));
    const width = Number(itemIn && itemIn.width);
    const height = Number(itemIn && itemIn.height);
    const src = itemIn && itemIn.source ? itemIn.source.toString() : '';
    const sig = this.buildOefPolygonsSignature(polygons);
    return [
      'OEF',
      polyCount,
      Number.isFinite(primitiveW) ? primitiveW.toFixed(3) : '0',
      Number.isFinite(primitiveH) ? primitiveH.toFixed(3) : '0',
      Number.isFinite(primitiveB1) ? primitiveB1.toFixed(3) : '0',
      Number.isFinite(primitiveB2) ? primitiveB2.toFixed(3) : '0',
      Number.isFinite(primitiveB3) ? primitiveB3.toFixed(3) : '0',
      Number.isFinite(primitiveB4) ? primitiveB4.toFixed(3) : '0',
      Number.isFinite(width) ? width.toFixed(3) : '0',
      Number.isFinite(height) ? height.toFixed(3) : '0',
      src,
      sig
    ].join('|');
  }

  private buildStandardPieceMergeKey(itemIn: any): string {
    if (!itemIn) {
      return 'STD|empty';
    }
    const figure = this.getPieceFigureId(itemIn);
    const wRaw = Number(itemIn && itemIn.width);
    const hRaw = Number(itemIn && itemIn.height);
    const hasShapeParams =
      Number(itemIn && itemIn.l ? itemIn.l : 0) > 0 ||
      Number(itemIn && itemIn.h ? itemIn.h : 0) > 0 ||
      Number(itemIn && itemIn.l1 ? itemIn.l1 : 0) > 0 ||
      Number(itemIn && itemIn.l2 ? itemIn.l2 : 0) > 0 ||
      Number(itemIn && itemIn.b1 ? itemIn.b1 : 0) > 0 ||
      Number(itemIn && itemIn.b2 ? itemIn.b2 : 0) > 0 ||
      Number(itemIn && itemIn.b3 ? itemIn.b3 : 0) > 0 ||
      Number(itemIn && itemIn.b4 ? itemIn.b4 : 0) > 0 ||
      Number(itemIn && itemIn.r ? itemIn.r : 0) > 0 ||
      Number(itemIn && itemIn.r2 ? itemIn.r2 : 0) > 0 ||
      Number(itemIn && itemIn.r3 ? itemIn.r3 : 0) > 0 ||
      Number(itemIn && itemIn.r4 ? itemIn.r4 : 0) > 0;
    const hasDxf = !!(itemIn && itemIn.dxf_name && itemIn.dxf_name.toString().trim() !== '');
    const isSimpleRect = figure === 0 && !hasShapeParams && !hasDxf;
    const w = isSimpleRect ? Math.min(wRaw, hRaw) : wRaw;
    const h = isSimpleRect ? Math.max(wRaw, hRaw) : hRaw;
    return [
      'STD',
      figure,
      Number(itemIn && itemIn.mat_id ? itemIn.mat_id : 0),
      Number(itemIn && itemIn.stock_length ? itemIn.stock_length : 0),
      Number.isFinite(w) ? Number(w).toFixed(2) : '0.00',
      Number.isFinite(h) ? Number(h).toFixed(2) : '0.00',
      Number(itemIn && itemIn.l ? itemIn.l : 0),
      Number(itemIn && itemIn.l1 ? itemIn.l1 : 0),
      Number(itemIn && itemIn.l2 ? itemIn.l2 : 0),
      Number(itemIn && itemIn.h ? itemIn.h : 0),
      Number(itemIn && itemIn.h1 ? itemIn.h1 : 0),
      Number(itemIn && itemIn.h2 ? itemIn.h2 : 0),
      Number(itemIn && itemIn.b1 ? itemIn.b1 : 0),
      Number(itemIn && itemIn.b2 ? itemIn.b2 : 0),
      Number(itemIn && itemIn.b3 ? itemIn.b3 : 0),
      Number(itemIn && itemIn.b4 ? itemIn.b4 : 0),
      Number(itemIn && itemIn.r ? itemIn.r : 0),
      Number(itemIn && itemIn.r2 ? itemIn.r2 : 0),
      Number(itemIn && itemIn.r3 ? itemIn.r3 : 0),
      Number(itemIn && itemIn.r4 ? itemIn.r4 : 0),
      itemIn && itemIn.dxf_name ? itemIn.dxf_name.toString() : ''
    ].join('|');
  }

  private buildOefPolygonsSignature(polygonsIn: any[]): string {
    if (!Array.isArray(polygonsIn) || polygonsIn.length < 1) {
      return '';
    }
    const parts = polygonsIn.map((poly: any) => {
      const points = Array.isArray(poly) ? poly : [];
      if (points.length < 3) {
        return 'p0';
      }
      let minX = Number.POSITIVE_INFINITY;
      let minY = Number.POSITIVE_INFINITY;
      let maxX = Number.NEGATIVE_INFINITY;
      let maxY = Number.NEGATIVE_INFINITY;
      points.forEach((pt: any) => {
        const x = Number(pt && (pt.x !== undefined ? pt.x : pt[0]));
        const y = Number(pt && (pt.y !== undefined ? pt.y : pt[1]));
        if (Number.isFinite(x) && Number.isFinite(y)) {
          if (x < minX) { minX = x; }
          if (y < minY) { minY = y; }
          if (x > maxX) { maxX = x; }
          if (y > maxY) { maxY = y; }
        }
      });
      const w = Number.isFinite(minX) && Number.isFinite(maxX) ? (maxX - minX) : 0;
      const h = Number.isFinite(minY) && Number.isFinite(maxY) ? (maxY - minY) : 0;
      return 'p' + points.length + ':' + Number(w).toFixed(3) + 'x' + Number(h).toFixed(3);
    });
    return parts.join(';');
  }

  private getLooseNameIdKey(nameIdIn: any): string {
    const raw = nameIdIn !== undefined && nameIdIn !== null ? nameIdIn.toString() : '';
    if (!raw) {
      return '';
    }
    const idx = raw.indexOf('|id:');
    if (idx > 0) {
      return raw.substring(0, idx);
    }
    return raw;
  }

  private extractNameIdLotSeqKey(nameIdIn: any): string {
    const raw = nameIdIn !== undefined && nameIdIn !== null ? nameIdIn.toString() : '';
    if (!raw) {
      return '';
    }
    const match = raw.match(/^([0-9]+#[0-9]+)@/);
    return match && match[1] ? match[1] : '';
  }

  private extractNameIdFigure(nameIdIn: any): number {
    const raw = nameIdIn !== undefined && nameIdIn !== null ? nameIdIn.toString() : '';
    if (!raw) {
      return 0;
    }
    const match = raw.match(/\|f:([0-9]+)/);
    if (!match || !match[1]) {
      return 0;
    }
    const f = Number(match[1]);
    return Number.isFinite(f) ? Math.round(f) : 0;
  }

  private isSameNameIdLoose(aIn: any, bIn: any): boolean {
    const a = aIn !== undefined && aIn !== null ? aIn.toString() : '';
    const b = bIn !== undefined && bIn !== null ? bIn.toString() : '';
    if (!a || !b) {
      return false;
    }
    if (a === b) {
      return true;
    }
    return this.getLooseNameIdKey(a) === this.getLooseNameIdKey(b);
  }

  private isSameNameIdByLotSeqAndFigure(aIn: any, bIn: any): boolean {
    const aKey = this.extractNameIdLotSeqKey(aIn);
    const bKey = this.extractNameIdLotSeqKey(bIn);
    if (!aKey || !bKey || aKey !== bKey) {
      return false;
    }
    const fa = this.extractNameIdFigure(aIn);
    const fb = this.extractNameIdFigure(bIn);
    if (fa > 0 && fb > 0) {
      return fa === fb;
    }
    return true;
  }

  private normalizeTriangleGroupKey(itemIn: any): string {
    const w = Number(itemIn && itemIn.width ? itemIn.width : 0);
    const h = Number(itemIn && itemIn.height ? itemIn.height : 0);
    const minSide = Math.min(w, h);
    const maxSide = Math.max(w, h);
    const area = w * h;
    // Se normaliza para no separar triángulos equivalentes por rotación o pequeñas variaciones.
    return minSide.toFixed(1) + 'x' + maxSide.toFixed(1) + '|' + area.toFixed(1);
  }

  private isRectangleLikePolygon(polygonIn: any[], widthIn: number, heightIn: number): boolean {
    const polygon = (Array.isArray(polygonIn) ? polygonIn : [])
      .map(pt => ({ x: Number(pt && pt.x), y: Number(pt && pt.y) }))
      .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y));
    if (polygon.length < 4) {
      return false;
    }
    const width = Number(widthIn);
    const height = Number(heightIn);
    if (!(Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0)) {
      return false;
    }
    const bboxArea = Math.max(0.000001, width * height);
    const polyArea = this.getPolygonAreaAbs(polygon);
    const fillRatio = polyArea / bboxArea;
    if (!(fillRatio >= 0.97 && fillRatio <= 1.03)) {
      return false;
    }
    const edgeTol = Math.max(0.15, Math.min(width, height) * 0.0015);
    for (let i = 0; i < polygon.length; i++) {
      const a = polygon[i];
      const b = polygon[(i + 1) % polygon.length];
      const dx = Math.abs(Number(b.x) - Number(a.x));
      const dy = Math.abs(Number(b.y) - Number(a.y));
      const isAxisAligned = dx <= edgeTol || dy <= edgeTol;
      if (!isAxisAligned) {
        return false;
      }
    }
    return true;
  }

  private buildOefPolygonSignature(polygonIn: any[], widthIn: number, heightIn: number): string {
    const polygon = (Array.isArray(polygonIn) ? polygonIn : [])
      .map(pt => ({ x: Number(pt && pt.x), y: Number(pt && pt.y) }))
      .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y));
    if (polygon.length < 3) {
      return 'poly:none';
    }
    const span = Math.max(1, Number(widthIn), Number(heightIn));
    const edgeLens = [];
    for (let i = 0; i < polygon.length; i++) {
      const a = polygon[i];
      const b = polygon[(i + 1) % polygon.length];
      const dx = Number(b.x) - Number(a.x);
      const dy = Number(b.y) - Number(a.y);
      const len = Math.sqrt((dx * dx) + (dy * dy));
      if (Number.isFinite(len) && len > 0.0001) {
        edgeLens.push(Number((len / span).toFixed(4)));
      }
    }
    edgeLens.sort((a, b) => a - b);
    const bboxArea = Math.max(0.000001, Number(widthIn) * Number(heightIn));
    const fillRatio = Number((this.getPolygonAreaAbs(polygon) / bboxArea).toFixed(4));
    return 'v' + polygon.length + '|a' + fillRatio.toFixed(4) + '|e' + edgeLens.join(',');
  }

  private buildOefGenericGroupKey(pieceIn: any, polygonIn: any[], widthIn: number, heightIn: number): string {
    const figure = this.getPieceFigureId(pieceIn);
    const w = Number(widthIn);
    const h = Number(heightIn);
    const minSide = Math.min(w, h);
    const maxSide = Math.max(w, h);
    const polySignature = this.buildOefPolygonSignature(polygonIn, w, h);
    return 'f' + (Number.isFinite(figure) ? figure : 0) + '|' + minSide.toFixed(1) + 'x' + maxSide.toFixed(1) + '|' + polySignature;
  }

  private buildOefTrapezoidGroupKey(polygonIn: any[], widthIn: number, heightIn: number): string {
    const w = Number(widthIn);
    const h = Number(heightIn);
    const minSide = Math.min(w, h);
    const maxSide = Math.max(w, h);
    const polySignature = this.buildOefPolygonSignature(polygonIn, w, h);
    return 'trap|' + minSide.toFixed(1) + 'x' + maxSide.toFixed(1) + '|' + polySignature;
  }

  private hasTrapezoidLikeParams(pieceIn: any): boolean {
    const readNum = (a: string, b: string): number => {
      const raw = Number(pieceIn && pieceIn[a] !== undefined && pieceIn[a] !== null ? pieceIn[a] : (pieceIn ? pieceIn[b] : null));
      return Number.isFinite(raw) ? raw : NaN;
    };
    const L = readNum('l', 'piece_l');
    const H = readNum('h', 'piece_h');
    const L1 = readNum('l1', 'piece_l1');
    const L2 = readNum('l2', 'piece_l2');
    const B1 = readNum('b1', 'piece_b1');
    const B2 = readNum('b2', 'piece_b2');
    const B3 = readNum('b3', 'piece_b3');
    if (!(L > 0 && H > 0)) {
      return false;
    }
    if (!(L1 >= 0 && L2 >= 0)) {
      return false;
    }
    if (!(B1 >= 0 && B2 >= 0 && B3 >= 0)) {
      return false;
    }
    return (L1 > 0 || L2 > 0);
  }

  private isParallelogramLikePiece(pieceIn: any, polygonIn: any[], widthIn: number, heightIn: number): boolean {
    const figure = this.getPieceFigureId(pieceIn);
    if (this.isParallelogramFigure(figure)) {
      return true;
    }
    if (figure === 5 || figure === 6 || this.isTriangleFigure(figure)) {
      return false;
    }
    const polygon = (Array.isArray(polygonIn) ? polygonIn : [])
      .map(pt => ({ x: Number(pt && pt.x), y: Number(pt && pt.y) }))
      .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y));
    if (polygon.length !== 4) {
      return false;
    }
    if (this.isRectangleLikePolygon(polygon, widthIn, heightIn)) {
      return false;
    }
    const v = (a: any, b: any) => ({ x: Number(b.x) - Number(a.x), y: Number(b.y) - Number(a.y) });
    const cross = (u: any, w: any) => (Number(u.x) * Number(w.y)) - (Number(u.y) * Number(w.x));
    const v01 = v(polygon[0], polygon[1]);
    const v12 = v(polygon[1], polygon[2]);
    const v23 = v(polygon[2], polygon[3]);
    const v30 = v(polygon[3], polygon[0]);
    const tol = Math.max(0.5, (Math.max(1, Number(widthIn), Number(heightIn))) * 0.0025);
    const opp1Parallel = Math.abs(cross(v01, v23)) <= tol;
    const opp2Parallel = Math.abs(cross(v12, v30)) <= tol;
    return opp1Parallel && opp2Parallel;
  }

  private isTrapezoidLikePiece(pieceIn: any, polygonIn: any[], widthIn: number, heightIn: number): boolean {
    const figure = this.getPieceFigureId(pieceIn);
    if (this.isParallelogramFigure(figure)) {
      return false;
    }
    if (figure === 5 || figure === 6) {
      return true;
    }
    if (this.hasTrapezoidLikeParams(pieceIn)) {
      return true;
    }
    if (this.isForm38Figure(figure) || this.isTriangleFigure(figure)) {
      return false;
    }
    const polygon = (Array.isArray(polygonIn) ? polygonIn : [])
      .map(pt => ({ x: Number(pt && pt.x), y: Number(pt && pt.y) }))
      .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y));
    if (polygon.length < 4) {
      return false;
    }
    if (this.isRectangleLikePolygon(polygon, widthIn, heightIn)) {
      return false;
    }
    return true;
  }

  private buildForm38AutoEndCaps(polygonsIn: any[], widthIn: number, heightIn: number): any[] {
    if (!Array.isArray(polygonsIn) || polygonsIn.length < 2) {
      return [];
    }
    const w = Number(widthIn);
    const h = Number(heightIn);
    if (!(Number.isFinite(w) && w > 0 && Number.isFinite(h) && h > 0)) {
      return [];
    }
    const points = [];
    polygonsIn.forEach(poly => {
      (Array.isArray(poly) ? poly : []).forEach(pt => {
        const x = Number(pt && pt.x);
        const y = Number(pt && pt.y);
        if (Number.isFinite(x) && Number.isFinite(y)) {
          points.push({ x: x, y: y });
        }
      });
    });
    if (points.length < 6) {
      return [];
    }
    const ys = points.map(p => Number(p.y));
    const minY = Math.min.apply(null, ys);
    const maxY = Math.max.apply(null, ys);
    const yTol = Math.max(0.25, (maxY - minY) * 0.02);
    const topPts = points.filter(p => Math.abs(Number(p.y) - minY) <= yTol);
    const bottomPts = points.filter(p => Math.abs(Number(p.y) - maxY) <= yTol);
    if (!topPts.length || !bottomPts.length) {
      return [];
    }
    const leftTop = topPts.reduce((acc, p) => (!acc || Number(p.x) < Number(acc.x) ? p : acc), null);
    const leftBottom = bottomPts.reduce((acc, p) => (!acc || Number(p.x) < Number(acc.x) ? p : acc), null);
    const rightTop = topPts.reduce((acc, p) => (!acc || Number(p.x) > Number(acc.x) ? p : acc), null);
    const rightBottom = bottomPts.reduce((acc, p) => (!acc || Number(p.x) > Number(acc.x) ? p : acc), null);
    if (!leftTop || !leftBottom || !rightTop || !rightBottom) {
      return [];
    }

    const caps = [];
    const pushIfValid = (polyIn: any[]): void => {
      const poly = (Array.isArray(polyIn) ? polyIn : []).map(p => ({ x: Number(p.x), y: Number(p.y) }));
      if (poly.length < 3) {
        return;
      }
      if (!(this.getPolygonAreaAbs(poly) > 0.5)) {
        return;
      }
      caps.push(poly);
    };

    const leftDelta = Number(leftBottom.x) - Number(leftTop.x);
    if (Math.abs(leftDelta) > 0.5) {
      if (leftDelta > 0) {
        pushIfValid([
          { x: 0, y: minY },
          { x: 0, y: maxY },
          { x: Number(leftBottom.x), y: maxY }
        ]);
      } else {
        pushIfValid([
          { x: 0, y: minY },
          { x: Number(leftTop.x), y: minY },
          { x: 0, y: maxY }
        ]);
      }
    }

    const rightDelta = Number(rightBottom.x) - Number(rightTop.x);
    if (Math.abs(rightDelta) > 0.5) {
      if (rightDelta > 0) {
        pushIfValid([
          { x: Number(rightTop.x), y: minY },
          { x: w, y: minY },
          { x: w, y: maxY }
        ]);
      } else {
        pushIfValid([
          { x: w, y: minY },
          { x: Number(rightBottom.x), y: maxY },
          { x: w, y: maxY }
        ]);
      }
    }

    return caps;
  }

  private normalizeOefPolygonsToTightBBox(polygonsIn: any[]): any {
    const polygons = (Array.isArray(polygonsIn) ? polygonsIn : [])
      .map(poly => (Array.isArray(poly) ? poly : [])
        .map(pt => ({ x: Number(pt && pt.x), y: Number(pt && pt.y) }))
        .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y)))
      .filter(poly => poly.length >= 3);
    if (!polygons.length) {
      return {
        polygons: [],
        width: 0,
        height: 0,
        area: 0
      };
    }
    const pts = [];
    polygons.forEach(poly => poly.forEach(pt => pts.push(pt)));
    const xs = pts.map(pt => Number(pt.x));
    const ys = pts.map(pt => Number(pt.y));
    const minX = Math.min.apply(null, xs);
    const maxX = Math.max.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxY = Math.max.apply(null, ys);
    const width = Math.max(0, maxX - minX);
    const height = Math.max(0, maxY - minY);
    const normalized = polygons.map(poly => poly.map(pt => ({
      x: Number(pt.x) - minX,
      y: Number(pt.y) - minY
    })));
    const area = normalized.reduce((acc, poly) => acc + this.getPolygonAreaAbs(poly), 0);
    return {
      polygons: normalized,
      width: Number(width.toFixed(2)),
      height: Number(height.toFixed(2)),
      area: Number(area.toFixed(2))
    };
  }

  private getOefPrimitiveBorderKey(edgeIn: string): string {
    const key = edgeIn ? edgeIn.toString().toLowerCase() : '';
    if (key === 'b1' || key === 'b2' || key === 'b3' || key === 'b4') {
      return key;
    }
    return '';
  }

  private getOefCandidateBorderSessionKey(primitiveIn: any): string {
    if (!primitiveIn) {
      return '';
    }
    const source = primitiveIn.source ? primitiveIn.source.toString() : '';
    const pieces = Number(primitiveIn.pieces || 0).toFixed(0);
    const width = Number(primitiveIn.width || 0).toFixed(2);
    const height = Number(primitiveIn.height || 0).toFixed(2);
    const join = Number(this.getOefCandidateJoinLengthMm(primitiveIn) || 0).toFixed(2);
    return [source, pieces, width, height, join].join('|');
  }

  private loadOefCandidateBorderSessionMap(): any {
    try {
      const raw = sessionStorage.getItem('vs_oef_candidate_borders');
      if (!raw) {
        return {};
      }
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  private saveOefCandidateBorderSessionMap(): void {
    try {
      sessionStorage.setItem('vs_oef_candidate_borders', JSON.stringify(this.oefCandidateBorderSessionMap || {}));
    } catch (error) {
      // Sesión sin storage disponible: se conserva solo en memoria.
    }
  }

  private rememberOefCandidateBorders(primitiveIn: any): void {
    if (!primitiveIn) {
      return;
    }
    const key = this.getOefCandidateBorderSessionKey(primitiveIn);
    if (!key) {
      return;
    }
    const borders = this.getOefPrimitiveBorders(primitiveIn);
    const hasValue = borders.b1 > 0 || borders.b2 > 0 || borders.b3 > 0 || borders.b4 > 0;
    if (!this.oefCandidateBorderSessionMap) {
      this.oefCandidateBorderSessionMap = {};
    }
    if (hasValue) {
      this.oefCandidateBorderSessionMap[key] = borders;
    } else if (this.oefCandidateBorderSessionMap[key]) {
      delete this.oefCandidateBorderSessionMap[key];
    }
    this.saveOefCandidateBorderSessionMap();
  }

  private applyStoredOefCandidateBorders(primitiveIn: any): void {
    if (!primitiveIn) {
      return;
    }
    if (!this.oefCandidateBorderSessionMap) {
      this.oefCandidateBorderSessionMap = this.loadOefCandidateBorderSessionMap();
    }
    const stored = this.oefCandidateBorderSessionMap[this.getOefCandidateBorderSessionKey(primitiveIn)];
    if (!stored) {
      return;
    }
    ['b1', 'b2', 'b3', 'b4'].forEach(key => {
      const value = Number(stored[key]);
      primitiveIn['oef_' + key] = Number.isFinite(value) && value > 0 ? Number(value) : null;
    });
  }

  getOefCandidateBorderValue(primitiveIn: any, edgeIn: string): any {
    const key = this.getOefPrimitiveBorderKey(edgeIn);
    if (!primitiveIn || !key) {
      return '';
    }
    // b1..b4 también son parámetros geométricos del catálogo (por
    // ejemplo, en trapecios). Solo oef_b1..oef_b4 representan los márgenes
    // adicionales introducidos por el usuario en este modal.
    const raw = primitiveIn['oef_' + key];
    const value = Number(raw);
    return Number.isFinite(value) && value > 0 ? value : '';
  }

  onOefCandidateBorderChanged(primitiveIn: any, edgeIn: string, eventIn: any): void {
    const key = this.getOefPrimitiveBorderKey(edgeIn);
    if (!primitiveIn || !key) {
      return;
    }
    const raw = eventIn && eventIn.target ? eventIn.target.value : eventIn;
    const value = Number(raw);
    if (Number.isFinite(value) && value > 0) {
      primitiveIn['oef_' + key] = Number(value.toFixed(2));
    } else {
      primitiveIn['oef_' + key] = null;
    }
    this.rememberOefCandidateBorders(primitiveIn);
  }

  private getOefPrimitiveBorders(primitiveIn: any): any {
    const read = (keyIn: string): number => {
      const raw = primitiveIn ? primitiveIn['oef_' + keyIn] : null;
      const value = Number(raw);
      return Number.isFinite(value) && value > 0 ? Number(value) : 0;
    };
    return {
      b1: read('b1'),
      b2: read('b2'),
      b3: read('b3'),
      b4: read('b4')
    };
  }

  private applyOefPrimitiveBordersToTightBBox(tightIn: any, primitiveIn: any): any {
    const tight = tightIn || {};
    const polygons = Array.isArray(tight.polygons) ? tight.polygons : [];
    const width = Number(tight.width);
    const height = Number(tight.height);
    if (!polygons.length || !Number.isFinite(width) || width <= 0 || !Number.isFinite(height) || height <= 0) {
      return tightIn;
    }
    const borders = this.getOefPrimitiveBorders(primitiveIn);
    const b1 = borders.b1;
    const b2 = borders.b2;
    const b3 = borders.b3;
    const b4 = borders.b4;
    if (b1 <= 0 && b2 <= 0 && b3 <= 0 && b4 <= 0) {
      return {
        polygons: polygons,
        width: Number(width.toFixed(2)),
        height: Number(height.toFixed(2)),
        area: Number(tight.area || 0),
        b1: 0,
        b2: 0,
        b3: 0,
        b4: 0
      };
    }
    return {
      polygons: polygons.map(poly => (Array.isArray(poly) ? poly : []).map(pt => ({
        x: Number(pt && pt.x) + b1,
        y: Number(pt && pt.y) + b2
      })).filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y))).filter(poly => poly.length >= 3),
      width: Number((width + b1 + b3).toFixed(2)),
      height: Number((height + b2 + b4).toFixed(2)),
      area: Number(tight.area || 0),
      b1: Number(b1.toFixed(2)),
      b2: Number(b2.toFixed(2)),
      b3: Number(b3.toFixed(2)),
      b4: Number(b4.toFixed(2))
    };
  }

  private applyOefPrimitiveGeometryToRuntimeRow(rowIn: any, tightIn: any, primitiveIn: any): any {
    const bordered = this.applyOefPrimitiveBordersToTightBBox(tightIn, primitiveIn);
    if (!rowIn || !bordered) {
      return bordered;
    }
    rowIn.oef_internal_polygons = bordered.polygons;
    if (Number(bordered.width) > 0 && Number(bordered.height) > 0) {
      rowIn.width = Number(bordered.width);
      rowIn.height = Number(bordered.height);
    }
    rowIn.oef_primitive_w = Number(rowIn.width);
    rowIn.oef_primitive_h = Number(rowIn.height);
    rowIn.oef_effective_area = Number(bordered.area);
    rowIn.oef_primitive_b1 = Number(bordered.b1 || 0);
    rowIn.oef_primitive_b2 = Number(bordered.b2 || 0);
    rowIn.oef_primitive_b3 = Number(bordered.b3 || 0);
    rowIn.oef_primitive_b4 = Number(bordered.b4 || 0);
    return bordered;
  }

  private buildOefAuxiliaryBorderSegments(widthIn: number, heightIn: number, bordersIn: any): any[] {
    const width = Number(widthIn);
    const height = Number(heightIn);
    if (!(Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0)) {
      return [];
    }
    const b1 = Number(bordersIn && bordersIn.b1) > 0 ? Number(bordersIn.b1) : 0;
    const b2 = Number(bordersIn && bordersIn.b2) > 0 ? Number(bordersIn.b2) : 0;
    const b3 = Number(bordersIn && bordersIn.b3) > 0 ? Number(bordersIn.b3) : 0;
    const b4 = Number(bordersIn && bordersIn.b4) > 0 ? Number(bordersIn.b4) : 0;
    const out = [];
    if (b1 > 0 && b1 < width) {
      out.push({ x1: b1, y1: 0, x2: b1, y2: height });
    }
    if (b2 > 0 && b2 < height) {
      out.push({ x1: 0, y1: b2, x2: width, y2: b2 });
    }
    if (b3 > 0 && (width - b3) > 0) {
      out.push({ x1: width - b3, y1: 0, x2: width - b3, y2: height });
    }
    if (b4 > 0 && (height - b4) > 0) {
      out.push({ x1: 0, y1: height - b4, x2: width, y2: height - b4 });
    }
    return out;
  }

  private buildOefSideFillPolygonsToBBox(polygonsIn: any[]): any[] {
    const polys = (Array.isArray(polygonsIn) ? polygonsIn : [])
      .map(poly => (Array.isArray(poly) ? poly : [])
        .map(pt => ({ x: Number(pt && pt.x), y: Number(pt && pt.y) }))
        .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y)))
      .filter(poly => poly.length >= 3);
    if (!polys.length) {
      return [];
    }
    const allPts = [];
    polys.forEach(poly => poly.forEach(pt => allPts.push(pt)));
    const xs = allPts.map(p => Number(p.x));
    const ys = allPts.map(p => Number(p.y));
    const minX = Math.min.apply(null, xs);
    const maxX = Math.max.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxY = Math.max.apply(null, ys);
    const eps = 0.0001;
    const uniqueY = Array.from(new Set(allPts.map(p => Number(p.y)).filter(v => Number.isFinite(v))))
      .sort((a, b) => a - b);
    if (!uniqueY.length || uniqueY[0] > minY + eps) {
      uniqueY.unshift(minY);
    }
    if (uniqueY[uniqueY.length - 1] < maxY - eps) {
      uniqueY.push(maxY);
    }
    const getSpanAtY = (yIn: number): any => {
      const y = Number(yIn);
      const inter = [];
      polys.forEach(poly => {
        for (let i = 0; i < poly.length; i++) {
          const a = poly[i];
          const b = poly[(i + 1) % poly.length];
          const y1 = Number(a.y);
          const y2 = Number(b.y);
          const x1 = Number(a.x);
          const x2 = Number(b.x);
          if (!Number.isFinite(y1) || !Number.isFinite(y2) || !Number.isFinite(x1) || !Number.isFinite(x2)) {
            continue;
          }
          const yMinE = Math.min(y1, y2);
          const yMaxE = Math.max(y1, y2);
          if (y < (yMinE - eps) || y > (yMaxE + eps)) {
            continue;
          }
          if (Math.abs(y2 - y1) <= eps) {
            inter.push(x1);
            inter.push(x2);
            continue;
          }
          const t = (y - y1) / (y2 - y1);
          if (t < -eps || t > 1 + eps) {
            continue;
          }
          inter.push(x1 + (x2 - x1) * t);
        }
      });
      if (!inter.length) {
        return null;
      }
      inter.sort((a, b) => a - b);
      return { left: Number(inter[0]), right: Number(inter[inter.length - 1]) };
    };

    const fillers = [];
    const pushPoly = (polyIn: any[]): void => {
      const poly = (Array.isArray(polyIn) ? polyIn : [])
        .map(p => ({ x: Number(p && p.x), y: Number(p && p.y) }))
        .filter(p => Number.isFinite(p.x) && Number.isFinite(p.y));
      if (poly.length < 3) return;
      if (!(this.getPolygonAreaAbs(poly) > 0.5)) return;
      fillers.push(poly);
    };

    for (let i = 0; i < uniqueY.length - 1; i++) {
      const y0 = Number(uniqueY[i]);
      const y1 = Number(uniqueY[i + 1]);
      if (!(y1 - y0 > eps)) {
        continue;
      }
      const ym = (y0 + y1) / 2;
      const spanM = getSpanAtY(ym);
      if (!spanM) {
        continue;
      }
      const span0 = getSpanAtY(y0 + Math.min(0.01, (y1 - y0) * 0.25)) || spanM;
      const span1 = getSpanAtY(y1 - Math.min(0.01, (y1 - y0) * 0.25)) || spanM;

      if (Number(spanM.left) > (minX + 0.5)) {
        pushPoly([
          { x: minX, y: y0 },
          { x: Number(span0.left), y: y0 },
          { x: Number(span1.left), y: y1 },
          { x: minX, y: y1 }
        ]);
      }
      if (Number(spanM.right) < (maxX - 0.5)) {
        pushPoly([
          { x: Number(span0.right), y: y0 },
          { x: maxX, y: y0 },
          { x: maxX, y: y1 },
          { x: Number(span1.right), y: y1 }
        ]);
      }
    }
    return fillers;
  }

  private buildSyntheticForm38StripPolygons(widthIn: number, heightIn: number, piecesIn: number, verticalIn: boolean): any[] {
    const W = Number(widthIn);
    const H = Number(heightIn);
    const n = Math.max(2, Math.round(Number(piecesIn || 0)));
    if (!(Number.isFinite(W) && W > 0 && Number.isFinite(H) && H > 0)) {
      return [];
    }
    const polys = [];
    if (!verticalIn) {
      const step = W / n;
      const skew = Math.min(Math.max(H * 0.18, 2), Math.max(2, step * 0.35));
      const endSkew = Math.min(Math.max(skew * 0.6, 1), Math.max(1, step * 0.22));
      const t = [];
      const b = [];
      for (let i = 0; i <= n; i++) {
        const base = step * i;
        t.push(base - (skew / 2));
        b.push(base + (skew / 2));
      }
      t[0] = 0;
      b[0] = endSkew;
      t[n] = W - endSkew;
      b[n] = W;
      for (let i = 1; i < n; i++) {
        if (t[i] <= t[i - 1]) t[i] = t[i - 1] + 0.001;
        if (b[i] <= b[i - 1]) b[i] = b[i - 1] + 0.001;
      }
      for (let i = 0; i < n; i++) {
        polys.push([
          { x: t[i], y: 0 },
          { x: t[i + 1], y: 0 },
          { x: b[i + 1], y: H },
          { x: b[i], y: H }
        ]);
      }
      return polys;
    }

    const step = H / n;
    const skew = Math.min(Math.max(W * 0.18, 2), Math.max(2, step * 0.35));
    const endSkew = Math.min(Math.max(skew * 0.6, 1), Math.max(1, step * 0.22));
    const l = [];
    const r = [];
    for (let i = 0; i <= n; i++) {
      const base = step * i;
      l.push(base - (skew / 2));
      r.push(base + (skew / 2));
    }
    l[0] = 0;
    r[0] = endSkew;
    l[n] = H - endSkew;
    r[n] = H;
    for (let i = 1; i < n; i++) {
      if (l[i] <= l[i - 1]) l[i] = l[i - 1] + 0.001;
      if (r[i] <= r[i - 1]) r[i] = r[i - 1] + 0.001;
    }
    for (let i = 0; i < n; i++) {
      polys.push([
        { x: 0, y: l[i] },
        { x: W, y: r[i] },
        { x: W, y: r[i + 1] },
        { x: 0, y: l[i + 1] }
      ]);
    }
    return polys;
  }

  private buildInterlockedForm37StripPolygons(pieceIn: any, piecesIn: number): any[] {
    const dims = this.getOefPieceBaseDimensions(pieceIn);
    const width = Number(dims && dims.width);
    const height = Number(dims && dims.height);
    const n = Math.max(2, Math.round(Number(piecesIn || 0)));
    if (!(Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0)) {
      return [];
    }

    const basePoly = this.getPiecePolygonTemplate(pieceIn, width, height)
      .map(p => ({ x: Number(p && p.x), y: Number(p && p.y) }))
      .filter(p => Number.isFinite(p.x) && Number.isFinite(p.y));
    if (basePoly.length < 3) {
      return [];
    }

    const eps = 0.0001;
    const getInclinedEdge = (sideIn: 'left' | 'right'): any => {
      let best = null;
      for (let i = 0; i < basePoly.length; i++) {
        const p1 = basePoly[i];
        const p2 = basePoly[(i + 1) % basePoly.length];
        const dx = Number(p2.x) - Number(p1.x);
        const dy = Number(p2.y) - Number(p1.y);
        if (!Number.isFinite(dx) || !Number.isFinite(dy) || Math.abs(dx) <= eps || Math.abs(dy) <= eps) {
          continue;
        }
        const midX = (Number(p1.x) + Number(p2.x)) / 2;
        if (!best || (sideIn === 'right' && midX > best.midX) || (sideIn === 'left' && midX < best.midX)) {
          best = { p1: p1, p2: p2, midX: midX };
        }
      }
      if (!best) {
        return null;
      }
      const dy = Number(best.p2.y) - Number(best.p1.y);
      if (Math.abs(dy) <= eps) {
        return null;
      }
      const a = (Number(best.p2.x) - Number(best.p1.x)) / dy;
      const b = Number(best.p1.x) - (a * Number(best.p1.y));
      return {
        a: a,
        b: b,
        yMin: Math.min(Number(best.p1.y), Number(best.p2.y)),
        yMax: Math.max(Number(best.p1.y), Number(best.p2.y))
      };
    };

    const leftEdge = getInclinedEdge('left');
    const rightEdge = getInclinedEdge('right');
    let stepX = 0;
    if (leftEdge && rightEdge && Math.abs(Number(leftEdge.a) - Number(rightEdge.a)) <= 0.002) {
      const y0 = Math.max(Number(leftEdge.yMin), Number(rightEdge.yMin));
      const y1 = Math.min(Number(leftEdge.yMax), Number(rightEdge.yMax));
      if (Number.isFinite(y0) && Number.isFinite(y1) && (y1 - y0) > eps) {
        const yMid = (y0 + y1) / 2;
        stepX = ((Number(rightEdge.a) * yMid) + Number(rightEdge.b)) -
          ((Number(leftEdge.a) * yMid) + Number(leftEdge.b));
      }
    }

    if (!(Number.isFinite(stepX) && stepX > eps && stepX < width)) {
      const rawL1 = Number(
        pieceIn && pieceIn.l1 !== undefined && pieceIn.l1 !== null
          ? pieceIn.l1
          : (pieceIn && pieceIn.piece_l1 !== undefined && pieceIn.piece_l1 !== null ? pieceIn.piece_l1 : 0)
      );
      const L1 = Number.isFinite(rawL1) && rawL1 > 0 ? rawL1 : 0;
      stepX = Math.max(1, width - L1);
    }

    const out = [];
    for (let i = 0; i < n; i++) {
      const x = stepX * i;
      out.push(basePoly.map(pt => ({
        x: Number(pt.x) + x,
        y: Number(pt.y)
      })));
    }
    return out;
  }

  private polygonsToNormalizedPlacements(polygonsIn: any[]): any[] {
    const polys = (Array.isArray(polygonsIn) ? polygonsIn : [])
      .map(poly => (Array.isArray(poly) ? poly : [])
        .map(pt => ({ x: Number(pt && pt.x), y: Number(pt && pt.y) }))
        .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y)))
      .filter(poly => poly.length >= 3);
    return polys.map(poly => {
      const xs = poly.map(p => Number(p.x));
      const ys = poly.map(p => Number(p.y));
      const minX = Math.min.apply(null, xs);
      const minY = Math.min.apply(null, ys);
      const local = poly.map(pt => ({
        x: Number(pt.x) - minX,
        y: Number(pt.y) - minY
      }));
      const w = Math.max.apply(null, local.map(p => Number(p.x)));
      const h = Math.max.apply(null, local.map(p => Number(p.y)));
      return {
        x: Number(minX.toFixed(2)),
        y: Number(minY.toFixed(2)),
        w: Number(w.toFixed(2)),
        h: Number(h.toFixed(2)),
        flip: false,
        polygon: local
      };
    });
  }

  private generateTriangleInterlockCandidates(itemsIn: any[]): any[] {
    const triangles = (itemsIn || []).filter(item => item && item.is_triangle === true);
    if (!triangles.length) {
      return [];
    }

    const grouped = {};
    triangles.forEach(item => {
      const key = this.normalizeTriangleGroupKey(item);
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
    });

    let dominant = null;
    Object.keys(grouped).forEach(key => {
      if (!dominant || grouped[key].length > dominant.length) {
        dominant = grouped[key];
      }
    });

    if (!dominant || !dominant.length) {
      return [];
    }

    const first = dominant[0];
    const rawPoly = Array.isArray(first.polygon) ? first.polygon : [];
    if (rawPoly.length < 3) {
      return [];
    }
    const xs = rawPoly.map(p => Number(p && p.x)).filter(v => Number.isFinite(v));
    const ys = rawPoly.map(p => Number(p && p.y)).filter(v => Number.isFinite(v));
    if (!xs.length || !ys.length) {
      return [];
    }
    const minX = Math.min.apply(null, xs);
    const maxX = Math.max.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxY = Math.max.apply(null, ys);
    const polyW = maxX - minX;
    const polyH = maxY - minY;
    if (!(polyW > 0) || !(polyH > 0)) {
      return [];
    }

    const upPoly = rawPoly.map(p => ({ x: Number(p.x) - minX, y: Number(p.y) - minY }));
    const downPoly = this.mirrorPolygonHorizontal(upPoly, polyH);
    const stepX = polyW / 2;
    const maxK = Math.min(6, dominant.length);
    const candidates = [];

    for (let k = 2; k <= maxK; k++) {
      const placements = [];
      let usedArea = 0;

      for (let i = 0; i < k; i++) {
        const x = i * stepX;
        const y = 0;
        const isDown = (i % 2) === 1;
        const poly = isDown ? downPoly : upPoly;
        placements.push({
          x: x,
          y: y,
          w: polyW,
          h: polyH,
          flip: isDown,
          polygon: poly
        });
        usedArea += Number(dominant[i] && dominant[i].area ? dominant[i].area : (polyW * polyH * 0.5));
      }

      const placedPoints = [];
      placements.forEach(pl => {
        (pl.polygon || []).forEach(pt => {
          placedPoints.push({ x: Number(pt.x) + Number(pl.x), y: Number(pt.y) + Number(pl.y) });
        });
      });
      const pXs = placedPoints.map(p => Number(p.x)).filter(v => Number.isFinite(v));
      const pYs = placedPoints.map(p => Number(p.y)).filter(v => Number.isFinite(v));
      if (!pXs.length || !pYs.length) {
        continue;
      }
      const pMinX = Math.min.apply(null, pXs);
      const pMaxX = Math.max.apply(null, pXs);
      const pMinY = Math.min.apply(null, pYs);
      const pMaxY = Math.max.apply(null, pYs);
      const primitiveWidth = pMaxX - pMinX;
      const primitiveHeight = pMaxY - pMinY;
      const primitiveArea = primitiveWidth * primitiveHeight;
      const wastePct = primitiveArea > 0 ? ((primitiveArea - usedArea) * 100 / primitiveArea) : 0;
      const baselineArea = k * (Number(first.width) * Number(first.height));
      const improvementPct = baselineArea > 0 ? ((baselineArea - primitiveArea) * 100 / baselineArea) : 0;

      // Rebase de coordenadas a [0,0] del primitivo final.
      const normalizedPlacements = placements.map(pl => ({
        x: Number((pl.x - pMinX).toFixed(2)),
        y: Number((pl.y - pMinY).toFixed(2)),
        w: Number(pl.w),
        h: Number(pl.h),
        flip: pl.flip === true,
        polygon: (pl.polygon || []).map(pt => ({
          x: Number(pt.x),
          y: Number(pt.y)
        }))
      }));

      candidates.push({
        width: Number(primitiveWidth.toFixed(2)),
        height: Number(primitiveHeight.toFixed(2)),
        pieces: k,
        waste_pct: Number(Math.max(0, wastePct).toFixed(2)),
        improvement_pct: Number(Math.max(0, improvementPct).toFixed(2)),
        placements: normalizedPlacements,
        source: 'triangle_interlock_' + k
      });
    }

    return candidates;
  }

  private generateTrapezoidBandCandidates(itemsIn: any[]): any[] {
    const trapCandidates = (itemsIn || []).filter(item => item && item.is_trapezoid === true);
    if (!trapCandidates.length) {
      return [];
    }

    const grouped = {};
    trapCandidates.forEach(item => {
      const key = item && item.trap_group_key ? item.trap_group_key.toString() : '';
      if (!key) {
        return;
      }
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
    });
    let dominant = null;
    Object.keys(grouped).forEach(key => {
      if (!dominant || grouped[key].length > dominant.length) {
        dominant = grouped[key];
      }
    });
    if (!dominant || dominant.length < 2) {
      return [];
    }

    // Algunas entradas de trapecio llegan separadas por pequeñas variaciones de clave.
    // Se intenta ampliar el grupo dominante con piezas geométricamente compatibles.
    const seed = dominant[0];
    const seedW = Number(seed && seed.width);
    const seedH = Number(seed && seed.height);
    const tol = Math.max(0.8, Math.min(seedW, seedH) * 0.02);
    if (Number.isFinite(seedW) && Number.isFinite(seedH) && trapCandidates.length > dominant.length) {
      const pooled = trapCandidates.filter(item => {
        const w = Number(item && item.width);
        const h = Number(item && item.height);
        return Number.isFinite(w) && Number.isFinite(h) &&
          Math.abs(w - seedW) <= tol &&
          Math.abs(h - seedH) <= tol;
      });
      if (pooled.length > dominant.length) {
        dominant = pooled;
      }
    }

    const first = dominant[0];
    const width = Number(first && first.width);
    const height = Number(first && first.height);
    const basePoly = Array.isArray(first && first.polygon) ? first.polygon : [];
    if (!(Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0) || basePoly.length < 3) {
      return [];
    }

    const mirrorPoly = this.mirrorPolygonVertical(basePoly, width);
    const rotated180Poly = this.rotatePolygon180InBounds(basePoly, width, height);
    const eps = 0.001;
    const edgeLenTol = Math.max(1.2, Math.min(width, height) * 0.012);
    const pointTol = Math.max(1.2, Math.min(width, height) * 0.012);

    const getEdges = (polyIn: any[]): any[] => {
      const poly = Array.isArray(polyIn) ? polyIn : [];
      const edges = [];
      for (let i = 0; i < poly.length; i++) {
        const a = poly[i];
        const b = poly[(i + 1) % poly.length];
        const x1 = Number(a && a.x);
        const y1 = Number(a && a.y);
        const x2 = Number(b && b.x);
        const y2 = Number(b && b.y);
        if (!Number.isFinite(x1) || !Number.isFinite(y1) || !Number.isFinite(x2) || !Number.isFinite(y2)) {
          continue;
        }
        const dx = x2 - x1;
        const dy = y2 - y1;
        const len = Math.sqrt((dx * dx) + (dy * dy));
        if (!(len > eps)) {
          continue;
        }
        edges.push({
          a: { x: x1, y: y1 },
          b: { x: x2, y: y2 },
          len: len
        });
      }
      return edges;
    };

    const overlapsInterior = (polyAIn: any[], polyBIn: any[]): boolean => {
      return this.polygonsOverlap(polyAIn, polyBIn);
    };
    const getPolyMetrics = (polyIn: any[]): any => {
      const pts = (Array.isArray(polyIn) ? polyIn : [])
        .map(pt => ({ x: Number(pt && pt.x), y: Number(pt && pt.y) }))
        .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y));
      if (pts.length < 3) {
        return null;
      }
      const xs = pts.map(p => Number(p.x));
      const ys = pts.map(p => Number(p.y));
      const minX = Math.min.apply(null, xs);
      const maxX = Math.max.apply(null, xs);
      const minY = Math.min.apply(null, ys);
      const maxY = Math.max.apply(null, ys);
      const cx = xs.reduce((a, b) => a + b, 0) / xs.length;
      const cy = ys.reduce((a, b) => a + b, 0) / ys.length;
      return {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY,
        w: Math.max(0, maxX - minX),
        h: Math.max(0, maxY - minY),
        cx: cx,
        cy: cy
      };
    };
    const isDuplicatePlacement = (existingIn: any[], nextAbsIn: any[]): boolean => {
      const nextM = getPolyMetrics(nextAbsIn);
      if (!nextM) {
        return true;
      }
      const epsXY = Math.max(0.5, Math.min(width, height) * 0.0025);
      const epsC = Math.max(0.8, Math.min(width, height) * 0.004);
      for (let i = 0; i < existingIn.length; i++) {
        const exAbs = this.transformPolygon(existingIn[i].polygon, Number(existingIn[i].x), Number(existingIn[i].y));
        const exM = getPolyMetrics(exAbs);
        if (!exM) {
          continue;
        }
        const sameBox =
          Math.abs(Number(nextM.minX) - Number(exM.minX)) <= epsXY &&
          Math.abs(Number(nextM.maxX) - Number(exM.maxX)) <= epsXY &&
          Math.abs(Number(nextM.minY) - Number(exM.minY)) <= epsXY &&
          Math.abs(Number(nextM.maxY) - Number(exM.maxY)) <= epsXY;
        const sameCenter =
          Math.abs(Number(nextM.cx) - Number(exM.cx)) <= epsC &&
          Math.abs(Number(nextM.cy) - Number(exM.cy)) <= epsC;
        if (sameBox || sameCenter) {
          return true;
        }
      }
      return false;
    };

    const findJoinVectors = (prevPolyAbsIn: any[], nextPolyRelIn: any[]): any[] => {
      const prevEdges = getEdges(prevPolyAbsIn);
      const nextEdges = getEdges(nextPolyRelIn);
      const candidates = [];
      const candidateMap = {};
      prevEdges.forEach(pe => {
        nextEdges.forEach(ne => {
          if (Math.abs(Number(pe.len) - Number(ne.len)) > edgeLenTol) {
            return;
          }
          const pairs = [
            { pa: pe.a, pb: pe.b, na: ne.b, nb: ne.a },
            { pa: pe.b, pb: pe.a, na: ne.a, nb: ne.b }
          ];
          pairs.forEach(pair => {
            const tx = Number(pair.pa.x) - Number(pair.na.x);
            const ty = Number(pair.pa.y) - Number(pair.na.y);
            if (!(Number.isFinite(tx) && Number.isFinite(ty))) {
              return;
            }
            // Alinear una arista consigo misma puede producir (0, 0). En
            // trapecios simetricos el detector de cruce no distingue ese
            // caso de un contacto valido y acababa apilando copias exactas.
            if (Math.abs(tx) <= eps && Math.abs(ty) <= eps) {
              return;
            }
            if (tx < -eps) {
              return;
            }
            if (Math.abs(ty) > Math.max(8, height * 0.25)) {
              return;
            }
            const end2dx = (Number(pair.nb.x) + tx) - Number(pair.pb.x);
            const end2dy = (Number(pair.nb.y) + ty) - Number(pair.pb.y);
            const endErr = Math.sqrt((end2dx * end2dx) + (end2dy * end2dy));
            if (endErr > pointTol) {
              return;
            }
            const nextAbs = this.transformPolygon(nextPolyRelIn, tx, ty);
            if (overlapsInterior(prevPolyAbsIn, nextAbs)) {
              return;
            }
            // Priorizar encaje geométrico real (sin sesgo hacia tx≈width),
            // para evitar cadenas agrupadas en pares con banda intermedia.
            const score = (Math.abs(ty) * 5) + endErr + (Math.max(0, tx) * 0.0005);
            const kx = Number(tx).toFixed(3);
            const ky = Number(ty).toFixed(3);
            const key = kx + '|' + ky;
            const previous = candidateMap[key];
            if (!previous || score < previous.score) {
              const item = { tx: Number(tx), ty: Number(ty), score: Number(score) };
              candidateMap[key] = item;
            }
          });
        });
      });
      Object.keys(candidateMap).forEach(key => candidates.push(candidateMap[key]));
      candidates.sort((a, b) => Number(a.score) - Number(b.score));
      return candidates.slice(0, 10);
    };

    const finalize = (placementsIn: any[], sourceIn: string): any => {
      if (!Array.isArray(placementsIn) || placementsIn.length < 2) {
        return null;
      }
      const points = [];
      let usedArea = 0;
      placementsIn.forEach(pl => {
        const abs = this.transformPolygon(pl.polygon, Number(pl.x), Number(pl.y));
        abs.forEach(pt => points.push(pt));
        usedArea += Number(pl.area);
      });
      const xs = points.map(p => Number(p.x)).filter(v => Number.isFinite(v));
      const ys = points.map(p => Number(p.y)).filter(v => Number.isFinite(v));
      if (!xs.length || !ys.length) {
        return null;
      }
      const minX = Math.min.apply(null, xs);
      const maxX = Math.max.apply(null, xs);
      const minY = Math.min.apply(null, ys);
      const maxY = Math.max.apply(null, ys);
      const bandW = Math.max(0, maxX - minX);
      const bandH = Math.max(0, maxY - minY);
      if (!(bandW > 0 && bandH > 0)) {
        return null;
      }
      const placements = placementsIn.map(pl => ({
        x: Number((Number(pl.x) - minX).toFixed(2)),
        y: Number((Number(pl.y) - minY).toFixed(2)),
        w: Number(width.toFixed(2)),
        h: Number(height.toFixed(2)),
        flip: pl.flip === true,
        polygon: pl.polygon
      }));
      const bboxArea = bandW * bandH;
      const wastePct = bboxArea > 0 ? ((bboxArea - usedArea) * 100 / bboxArea) : 0;
      return {
        width: Number(bandW.toFixed(2)),
        height: Number(bandH.toFixed(2)),
        pieces: placements.length,
        waste_pct: Number(wastePct.toFixed(2)),
        placements: placements,
        source: sourceIn
      };
    };

    const candidates = [];
    const maxK = Math.min(6, dominant.length);
    const variants = [
      { key: 'same', pick: (i: number) => ({ poly: basePoly, flip: false }) },
      { key: 'alt', pick: (i: number) => (i % 2 === 0 ? { poly: basePoly, flip: false } : { poly: mirrorPoly, flip: true }) },
      { key: 'turn', pick: (i: number) => (i % 2 === 0 ? { poly: basePoly, flip: false } : { poly: rotated180Poly, flip: false }) }
    ];

    const buildPlacementsForVariant = (kIn: number, variantIn: any): any[] => {
      const placements = [];
      const backtrack = (indexIn: number): boolean => {
        if (indexIn >= kIn) {
          return true;
        }
        const picked = variantIn.pick(indexIn);
        const prev = placements[placements.length - 1];
        const prevAbs = this.transformPolygon(prev.polygon, Number(prev.x), Number(prev.y));
        const vecOptions = findJoinVectors(prevAbs, picked.poly);
        if (!vecOptions || vecOptions.length < 1) {
          return false;
        }
        for (let v = 0; v < vecOptions.length; v++) {
          const vec = vecOptions[v];
          const x = Number(prev.x) + Number(vec.tx);
          const y = Number(prev.y) + Number(vec.ty);
          const nextAbs = this.transformPolygon(picked.poly, x, y);
          const collide = placements.some(pl => overlapsInterior(this.transformPolygon(pl.polygon, Number(pl.x), Number(pl.y)), nextAbs));
          // polygonsOverlap permite que dos contornos compartan borde, algo
          // necesario para unir piezas, pero por ello no detecta bien dos
          // poligonos totalmente coincidentes. La comprobacion de caja/centro
          // evita aceptar placements duplicados antes de crear el primitivo.
          if (collide || isDuplicatePlacement(placements, nextAbs)) {
            continue;
          }
          placements.push({
            x: x,
            y: y,
            polygon: picked.poly,
            flip: picked.flip,
            area: Number(dominant[indexIn] && dominant[indexIn].area ? dominant[indexIn].area : (width * height))
          });
          if (backtrack(indexIn + 1)) {
            return true;
          }
          placements.pop();
        }
        return false;
      };

      const firstPicked = variantIn.pick(0);
      placements.push({
        x: 0,
        y: 0,
        polygon: firstPicked.poly,
        flip: firstPicked.flip,
        area: Number(dominant[0] && dominant[0].area ? dominant[0].area : (width * height))
      });

      return backtrack(1) ? placements : null;
    };

    variants.forEach(variant => {
      for (let k = 2; k <= maxK; k++) {
        const placements = buildPlacementsForVariant(k, variant);
        if (!placements || placements.length < k) {
          continue;
        }
        const created = finalize(placements, 'trap_band_h_' + variant.key + '_' + k);
        if (created) {
          candidates.push(created);
        }
      }
    });

    const createIncrementalFromTwoPiece = (twoPieceIn: any, kIn: number): any => {
      const placements2 = twoPieceIn && Array.isArray(twoPieceIn.placements) ? twoPieceIn.placements : [];
      if (placements2.length < 2 || kIn < 3) {
        return null;
      }
      const p0 = placements2[0];
      const p1 = placements2[1];
      const x0 = Number(p0 && p0.x);
      const y0 = Number(p0 && p0.y);
      const x1 = Number(p1 && p1.x);
      const y1 = Number(p1 && p1.y);
      if (!Number.isFinite(x0) || !Number.isFinite(y0) || !Number.isFinite(x1) || !Number.isFinite(y1)) {
        return null;
      }
      const poly0 = Array.isArray(p0 && p0.polygon) ? p0.polygon : [];
      const poly1 = Array.isArray(p1 && p1.polygon) ? p1.polygon : [];
      if (poly0.length < 3 || poly1.length < 3) {
        return null;
      }

      const placements = [];
      placements.push({
        x: Number(x0.toFixed(2)),
        y: Number(y0.toFixed(2)),
        polygon: poly0,
        flip: !!(p0 && p0.flip),
        area: Number(dominant[0] && dominant[0].area ? dominant[0].area : (width * height))
      });
      placements.push({
        x: Number(x1.toFixed(2)),
        y: Number(y1.toFixed(2)),
        polygon: poly1,
        flip: !!(p1 && p1.flip),
        area: Number(dominant[1] && dominant[1].area ? dominant[1].area : (width * height))
      });

      const polyKey = (polyIn: any[]): string => {
        return (Array.isArray(polyIn) ? polyIn : []).map(pt =>
          Number(pt && pt.x).toFixed(3) + ',' + Number(pt && pt.y).toFixed(3)
        ).join('|');
      };
      const templatePoolRaw = [
        { poly: poly0, flip: !!(p0 && p0.flip) },
        { poly: poly1, flip: !!(p1 && p1.flip) },
        { poly: basePoly, flip: false },
        { poly: mirrorPoly, flip: true },
        { poly: rotated180Poly, flip: false }
      ].filter(item => Array.isArray(item && item.poly) && item.poly.length >= 3);
      const templateMap = {};
      const templateOptions = [];
      templatePoolRaw.forEach(item => {
        const key = polyKey(item.poly);
        if (!templateMap[key]) {
          templateMap[key] = true;
          templateOptions.push(item);
        }
      });
      const getBBoxMetrics = (placementsIn: any[]): any => {
        const pointsLocal = [];
        placementsIn.forEach(pl => {
          const abs = this.transformPolygon(pl.polygon, Number(pl.x), Number(pl.y));
          abs.forEach(pt => pointsLocal.push(pt));
        });
        const xsLocal = pointsLocal.map(p => Number(p.x)).filter(v => Number.isFinite(v));
        const ysLocal = pointsLocal.map(p => Number(p.y)).filter(v => Number.isFinite(v));
        if (!xsLocal.length || !ysLocal.length) {
          return null;
        }
        const minXLocal = Math.min.apply(null, xsLocal);
        const maxXLocal = Math.max.apply(null, xsLocal);
        const minYLocal = Math.min.apply(null, ysLocal);
        const maxYLocal = Math.max.apply(null, ysLocal);
        const wLocal = Math.max(0, maxXLocal - minXLocal);
        const hLocal = Math.max(0, maxYLocal - minYLocal);
        if (!(wLocal > 0) || !(hLocal > 0)) {
          return null;
        }
        return {
          minX: minXLocal,
          minY: minYLocal,
          maxX: maxXLocal,
          maxY: maxYLocal,
          w: wLocal,
          h: hLocal,
          area: wLocal * hLocal
        };
      };

      // Beam-search incremental: prioriza compactación global para evitar bandas periódicas.
      let states = [{ placements: placements.slice() }];
      const beamWidth = 28;
      for (let indexIn = 2; indexIn < kIn; indexIn++) {
        const nextStates = [];
        states.forEach(state => {
          const curPlacements = state && Array.isArray(state.placements) ? state.placements : [];
          if (!curPlacements.length) {
            return;
          }
          const anchorIdxList = [];
          for (let a = curPlacements.length - 1; a >= 0; a--) {
            anchorIdxList.push(a);
          }
          for (let t = 0; t < templateOptions.length; t++) {
            const template = templateOptions[t].poly;
            for (let ai = 0; ai < anchorIdxList.length; ai++) {
              const anchor = curPlacements[anchorIdxList[ai]];
              const anchorAbs = this.transformPolygon(anchor.polygon, Number(anchor.x), Number(anchor.y));
              const vecOptions = findJoinVectors(anchorAbs, template);
              if (!vecOptions || vecOptions.length < 1) {
                continue;
              }
              for (let v = 0; v < vecOptions.length; v++) {
                const vec = vecOptions[v];
                const x = Number(anchor.x) + Number(vec.tx);
                const y = Number(anchor.y) + Number(vec.ty);
                const nextAbs = this.transformPolygon(template, x, y);
                const collide = curPlacements.some(pl => overlapsInterior(this.transformPolygon(pl.polygon, Number(pl.x), Number(pl.y)), nextAbs));
                if (collide || isDuplicatePlacement(curPlacements, nextAbs)) {
                  continue;
                }
                const nextPlacement = {
                  x: Number(x.toFixed(2)),
                  y: Number(y.toFixed(2)),
                  polygon: template,
                  flip: !!templateOptions[t].flip,
                  area: Number(dominant[Math.min(indexIn, dominant.length - 1)] && dominant[Math.min(indexIn, dominant.length - 1)].area
                    ? dominant[Math.min(indexIn, dominant.length - 1)].area
                    : (width * height))
                };
                const placementsNext = curPlacements.concat([nextPlacement]);
                const metrics = getBBoxMetrics(placementsNext);
                if (!metrics) {
                  continue;
                }
                nextStates.push({
                  placements: placementsNext,
                  bboxArea: Number(metrics.area),
                  bboxW: Number(metrics.w),
                  bboxH: Number(metrics.h),
                  // Penaliza saltos verticales y ramificación respecto al último tramo.
                  score: Number(metrics.area) +
                    (Math.abs(Number(y) - Number(curPlacements[curPlacements.length - 1].y)) * 0.18) +
                    (ai * 0.05)
                });
              }
            }
          }
        });
        if (!nextStates.length) {
          states = [];
          break;
        }
        nextStates.sort((a, b) => {
          if (Number(a.score) !== Number(b.score)) {
            return Number(a.score) - Number(b.score);
          }
          if (Number(a.bboxArea) !== Number(b.bboxArea)) {
            return Number(a.bboxArea) - Number(b.bboxArea);
          }
          if (Number(a.bboxW) !== Number(b.bboxW)) {
            return Number(a.bboxW) - Number(b.bboxW);
          }
          return Number(a.bboxH) - Number(b.bboxH);
        });
        states = nextStates.slice(0, beamWidth).map(s => ({ placements: s.placements }));
      }

      if (!states.length) {
        return null;
      }
      const bestState = states
        .map(s => ({ placements: s.placements, metrics: getBBoxMetrics(s.placements) }))
        .filter(s => s && s.metrics)
        .sort((a, b) => {
          if (Number(a.metrics.area) !== Number(b.metrics.area)) {
            return Number(a.metrics.area) - Number(b.metrics.area);
          }
          if (Number(a.metrics.w) !== Number(b.metrics.w)) {
            return Number(a.metrics.w) - Number(b.metrics.w);
          }
          return Number(a.metrics.h) - Number(b.metrics.h);
        })[0];
      if (!bestState || !bestState.placements || bestState.placements.length < kIn) {
        return null;
      }
      const placementsSolved = bestState.placements;

      let usedArea = 0;
      placementsSolved.forEach(pl => {
        usedArea += Number(pl.area);
      });
      const points = [];
      placementsSolved.forEach(pl => {
        const abs = this.transformPolygon(pl.polygon, Number(pl.x), Number(pl.y));
        abs.forEach(pt => points.push(pt));
      });
      const xs = points.map(p => Number(p.x)).filter(v => Number.isFinite(v));
      const ys = points.map(p => Number(p.y)).filter(v => Number.isFinite(v));
      if (!xs.length || !ys.length) {
        return null;
      }
      const minX = Math.min.apply(null, xs);
      const maxX = Math.max.apply(null, xs);
      const minY = Math.min.apply(null, ys);
      const maxY = Math.max.apply(null, ys);
      const bandW = Math.max(0, maxX - minX);
      const bandH = Math.max(0, maxY - minY);
      if (!(bandW > 0 && bandH > 0)) {
        return null;
      }
      const normalizedPlacements = placementsSolved.map(pl => ({
        x: Number((Number(pl.x) - minX).toFixed(2)),
        y: Number((Number(pl.y) - minY).toFixed(2)),
        w: Number(width.toFixed(2)),
        h: Number(height.toFixed(2)),
        flip: pl.flip === true,
        polygon: pl.polygon
      }));
      const bboxArea = bandW * bandH;
      const wastePct = bboxArea > 0 ? ((bboxArea - usedArea) * 100 / bboxArea) : 0;
      const src = twoPieceIn && twoPieceIn.source ? twoPieceIn.source.toString() : 'trap_band_h_chain_2';
      return {
        width: Number(bandW.toFixed(2)),
        height: Number(bandH.toFixed(2)),
        pieces: kIn,
        waste_pct: Number(Math.max(0, wastePct).toFixed(2)),
        placements: normalizedPlacements,
        source: src.replace(/_2$/, '') + '_chain_' + kIn
      };
    };

    const createLegacyLinearFromTwoPiece = (twoPieceIn: any, kIn: number): any => {
      const placements2 = twoPieceIn && Array.isArray(twoPieceIn.placements) ? twoPieceIn.placements : [];
      if (placements2.length < 2 || kIn < 3) {
        return null;
      }
      const p0 = placements2[0];
      const p1 = placements2[1];
      const x0 = Number(p0 && p0.x);
      const y0 = Number(p0 && p0.y);
      const x1 = Number(p1 && p1.x);
      const y1 = Number(p1 && p1.y);
      const dx = x1 - x0;
      const dy = y1 - y0;
      if (!Number.isFinite(dx) || !Number.isFinite(dy) || (Math.abs(dx) < 0.0001 && Math.abs(dy) < 0.0001)) {
        return null;
      }
      const poly0 = Array.isArray(p0 && p0.polygon) ? p0.polygon : [];
      const poly1 = Array.isArray(p1 && p1.polygon) ? p1.polygon : [];
      if (poly0.length < 3 || poly1.length < 3) {
        return null;
      }

      const placements = [];
      let usedArea = 0;
      for (let i = 0; i < kIn; i++) {
        const useAlt = (i % 2) === 1;
        const poly = useAlt ? poly1 : poly0;
        placements.push({
          x: Number((x0 + (i * dx)).toFixed(2)),
          y: Number((y0 + (i * dy)).toFixed(2)),
          polygon: poly,
          flip: useAlt,
          area: Number(dominant[Math.min(i, dominant.length - 1)] && dominant[Math.min(i, dominant.length - 1)].area
            ? dominant[Math.min(i, dominant.length - 1)].area
            : (width * height))
        });
        usedArea += Number(placements[i].area);
      }
      const points = [];
      placements.forEach(pl => {
        const abs = this.transformPolygon(pl.polygon, Number(pl.x), Number(pl.y));
        abs.forEach(pt => points.push(pt));
      });
      const xs = points.map(p => Number(p.x)).filter(v => Number.isFinite(v));
      const ys = points.map(p => Number(p.y)).filter(v => Number.isFinite(v));
      if (!xs.length || !ys.length) {
        return null;
      }
      const minX = Math.min.apply(null, xs);
      const maxX = Math.max.apply(null, xs);
      const minY = Math.min.apply(null, ys);
      const maxY = Math.max.apply(null, ys);
      const bandW = Math.max(0, maxX - minX);
      const bandH = Math.max(0, maxY - minY);
      if (!(bandW > 0 && bandH > 0)) {
        return null;
      }
      const normalizedPlacements = placements.map(pl => ({
        x: Number((Number(pl.x) - minX).toFixed(2)),
        y: Number((Number(pl.y) - minY).toFixed(2)),
        w: Number(width.toFixed(2)),
        h: Number(height.toFixed(2)),
        flip: pl.flip === true,
        polygon: pl.polygon
      }));
      const bboxArea = bandW * bandH;
      const wastePct = bboxArea > 0 ? ((bboxArea - usedArea) * 100 / bboxArea) : 0;
      const src = twoPieceIn && twoPieceIn.source ? twoPieceIn.source.toString() : 'trap_band_h_chain_2';
      return {
        width: Number(bandW.toFixed(2)),
        height: Number(bandH.toFixed(2)),
        pieces: kIn,
        waste_pct: Number(Math.max(0, wastePct).toFixed(2)),
        placements: normalizedPlacements,
        source: src.replace(/_2$/, '') + '_chain_' + kIn
      };
    };

    const realTwoPieceCandidates = candidates.filter(item =>
      item &&
      Number(item.pieces) === 2 &&
      item.source &&
      item.source.toString().indexOf('trap_band_h_') === 0 &&
      item.source.toString().indexOf('trap_band_h_bbox_') !== 0
    );
    if (realTwoPieceCandidates.length > 0 && maxK >= 3) {
      const existingKey = {};
      candidates.forEach(item => {
        const key = Number(item && item.pieces ? item.pieces : 0).toFixed(0) + '|' + (item && item.source ? item.source.toString().replace(/_2$/, '') : '');
        existingKey[key] = true;
      });
      // Estrategia estable para trapecios: priorizar 2+3.
      // En benchmark permitimos cadenas largas (hasta maxK) para comparar escenarios.
      const syntheticMaxK = this.oefBenchmark === true ? maxK : Math.min(3, maxK);
      realTwoPieceCandidates.forEach(two => {
        for (let k = 3; k <= syntheticMaxK; k++) {
          const key = Number(k).toFixed(0) + '|' + (two && two.source ? two.source.toString().replace(/_2$/, '') : '');
          if (existingKey[key]) {
            continue;
          }
          let synthetic = createIncrementalFromTwoPiece(two, k);
          if (!synthetic) {
            synthetic = createLegacyLinearFromTwoPiece(two, k);
          }
          if (synthetic) {
            candidates.push(synthetic);
            existingKey[key] = true;
          }
        }
      });
    }

    // Si ya tenemos candidatos reales de 2 y 3 piezas, descartamos cadenas largas
    // para evitar la banda periódica entre pares de trapecios.
    // En benchmark mantenemos también las largas para comparar rendimiento final.
    const hasReal2 = candidates.some(item =>
      item &&
      Number(item.pieces) === 2 &&
      item.source &&
      item.source.toString().indexOf('trap_band_h_') === 0 &&
      item.source.toString().indexOf('trap_band_h_bbox_') !== 0
    );
    const hasReal3 = candidates.some(item =>
      item &&
      Number(item.pieces) === 3 &&
      item.source &&
      item.source.toString().indexOf('trap_band_h_') === 0 &&
      item.source.toString().indexOf('trap_band_h_bbox_') !== 0
    );
    if (hasReal2 && hasReal3 && this.oefBenchmark !== true) {
      for (let i = candidates.length - 1; i >= 0; i--) {
        const item = candidates[i];
        const src = item && item.source ? item.source.toString() : '';
        const pieces = Math.round(Number(item && item.pieces ? item.pieces : 0));
        if (
          src.indexOf('trap_band_h_') === 0 &&
          src.indexOf('trap_band_h_bbox_') !== 0 &&
          pieces > 3
        ) {
          candidates.splice(i, 1);
        }
      }
    }

    if (candidates.length > 0) {
      return candidates;
    }

    // Fallback robusto: si no se consigue encaje por lados inclinados,
    // generar bandas por concatenación de bbox para no perder candidatos multi-pieza.
    const fallback = [];
    const maxKFallback = Math.min(6, dominant.length);
    const fallbackVariants = [
      { key: 'bbox_same', pick: (i: number) => ({ poly: basePoly, flip: false }) },
      { key: 'bbox_alt', pick: (i: number) => (i % 2 === 0 ? { poly: basePoly, flip: false } : { poly: mirrorPoly, flip: true }) },
      { key: 'bbox_turn', pick: (i: number) => (i % 2 === 0 ? { poly: basePoly, flip: false } : { poly: rotated180Poly, flip: false }) }
    ];

    fallbackVariants.forEach(variant => {
      for (let k = 2; k <= maxKFallback; k++) {
        const placements = [];
        for (let i = 0; i < k; i++) {
          const picked = variant.pick(i);
          placements.push({
            x: Number((i * width).toFixed(2)),
            y: 0,
            polygon: picked.poly,
            flip: picked.flip,
            area: Number(dominant[i] && dominant[i].area ? dominant[i].area : (width * height))
          });
        }
        const created = finalize(placements, 'trap_band_h_' + variant.key + '_' + k);
        if (created) {
          fallback.push(created);
        }
      }
    });

    return fallback;
  }

  private generateForcedTrapezoidBands(itemsIn: any[]): any[] {
    const traps = (itemsIn || []).filter(item => item && item.is_trapezoid === true);
    if (traps.length < 2) {
      return [];
    }
    const grouped = {};
    traps.forEach(item => {
      const key = item && item.trap_group_key ? item.trap_group_key.toString() : '';
      if (!key) {
        return;
      }
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
    });
    let dominant = null;
    Object.keys(grouped).forEach(key => {
      if (!dominant || grouped[key].length > dominant.length) {
        dominant = grouped[key];
      }
    });
    if (!dominant || dominant.length < 2) {
      return [];
    }

    // Pool de trapecios compatibles para evitar quedarse bloqueado en grupos de 2.
    const seed = dominant[0];
    const seedW = Number(seed && seed.width);
    const seedH = Number(seed && seed.height);
    const tol = Math.max(0.8, Math.min(seedW, seedH) * 0.02);
    if (Number.isFinite(seedW) && Number.isFinite(seedH) && traps.length > dominant.length) {
      const pooled = traps.filter(item => {
        const w = Number(item && item.width);
        const h = Number(item && item.height);
        return Number.isFinite(w) && Number.isFinite(h) &&
          Math.abs(w - seedW) <= tol &&
          Math.abs(h - seedH) <= tol;
      });
      if (pooled.length > dominant.length) {
        dominant = pooled;
      }
    }
    const first = dominant[0];
    const width = Number(first && first.width);
    const height = Number(first && first.height);
    const polygon = Array.isArray(first && first.polygon) ? first.polygon : [];
    if (!(Number.isFinite(width) && width > 0 && Number.isFinite(height) && height > 0) || polygon.length < 3) {
      return [];
    }
    const maxK = Math.min(6, dominant.length);
    const out = [];
    for (let k = 2; k <= maxK; k++) {
      const placements = [];
      let usedArea = 0;
      for (let i = 0; i < k; i++) {
        placements.push({
          x: Number((i * width).toFixed(2)),
          y: 0,
          w: Number(width.toFixed(2)),
          h: Number(height.toFixed(2)),
          flip: false,
          polygon: polygon
        });
        usedArea += Number(dominant[i] && dominant[i].area ? dominant[i].area : (width * height));
      }
      const bandW = width * k;
      const bandH = height;
      const bboxArea = bandW * bandH;
      const wastePct = bboxArea > 0 ? ((bboxArea - usedArea) * 100 / bboxArea) : 0;
      out.push({
        width: Number(bandW.toFixed(2)),
        height: Number(bandH.toFixed(2)),
        pieces: k,
        waste_pct: Number(wastePct.toFixed(2)),
        placements: placements,
        source: 'trap_force_h_' + k
      });
    }
    return out;
  }

  private generateInputTrapezoidBands(linesIn: any[]): any[] {
    const lines = (Array.isArray(linesIn) ? linesIn : []).filter(item => item && item.check === true);
    if (!lines.length) {
      return [];
    }
    const hasShapeParams = (itemIn: any): boolean => {
      const hasAny = (k1: string, k2: string): boolean =>
        !!(itemIn && ((itemIn[k1] !== undefined && itemIn[k1] !== null) || (itemIn[k2] !== undefined && itemIn[k2] !== null)));
      return hasAny('l', 'piece_l') &&
        hasAny('h', 'piece_h') &&
        hasAny('b1', 'piece_b1') &&
        hasAny('b2', 'piece_b2') &&
        hasAny('b3', 'piece_b3');
    };
    const trapLines = lines.filter(item => {
      const dims = this.getOefPieceBaseDimensions(item);
      const w = Number(dims && dims.width);
      const h = Number(dims && dims.height);
      const poly = this.getPiecePolygonTemplate(item, w, h);
	      const figure = this.getPieceFigureId(item);
      if (figure === 5 || figure === 6) {
        return true;
      }
      if (this.isTrapezoidLikePiece(item, poly, w, h)) {
        return true;
      }
      return hasShapeParams(item);
    });
    if (!trapLines.length) {
      return [];
    }
    const getUnits = (itemIn: any): number => {
      const u = Number(itemIn && itemIn.units);
      if (Number.isFinite(u) && u > 0) {
        return Math.max(1, Math.round(u));
      }
      return 1;
    };
    const base = trapLines
      .slice()
      .sort((a, b) => getUnits(b) - getUnits(a))[0];
    const totalUnits = trapLines.reduce((acc, item) => acc + getUnits(item), 0);
    if (totalUnits < 2) {
      return [];
    }
    const dims = this.getOefPieceBaseDimensions(base);
    const w = Number(dims && dims.width);
    const h = Number(dims && dims.height);
    if (!(Number.isFinite(w) && w > 0 && Number.isFinite(h) && h > 0)) {
      return [];
    }
    const poly = this.getPiecePolygonTemplate(base, w, h);
    if (!Array.isArray(poly) || poly.length < 3) {
      return [];
    }
    const out = [];
    const maxK = Math.min(6, totalUnits);
    for (let k = 2; k <= maxK; k++) {
      const placements = [];
      for (let i = 0; i < k; i++) {
        placements.push({
          x: Number((i * w).toFixed(2)),
          y: 0,
          w: Number(w.toFixed(2)),
          h: Number(h.toFixed(2)),
          flip: false,
          polygon: poly
        });
      }
      out.push({
        width: Number((w * k).toFixed(2)),
        height: Number(h.toFixed(2)),
        pieces: k,
        waste_pct: 0,
        placements: placements,
        source: 'trap_input_h_' + k
      });
    }
    return out;
  }

  private buildForcedTrapRuntimePrimitive(baseTemplateIn: any, totalUnitsIn: number, groupSizeIn?: number): any {
    const dims = this.getOefPieceBaseDimensions(baseTemplateIn);
    const w = Number(dims && dims.width);
    const h = Number(dims && dims.height);
    const safeW = Number.isFinite(w) && w > 0 ? w : 1;
    const safeH = Number.isFinite(h) && h > 0 ? h : 1;
    const polyRaw = this.getPiecePolygonTemplate(baseTemplateIn, safeW, safeH);
    const poly = (Array.isArray(polyRaw) && polyRaw.length >= 3)
      ? polyRaw
      : [
          { x: 0, y: safeH },
          { x: safeW, y: safeH },
          { x: safeW * 0.8, y: 0 },
          { x: safeW * 0.2, y: 0 }
        ];
    const mirrorPoly = this.mirrorPolygonVertical(poly, safeW);
    const totalUnits = Math.max(2, Math.round(Number(totalUnitsIn || 2)));
    const requestedGroup = Math.round(Number(groupSizeIn));
    const pieces = Number.isFinite(requestedGroup) && requestedGroup >= 2
      ? Math.max(2, Math.min(6, Math.min(totalUnits, requestedGroup)))
      : Math.max(2, Math.min(6, totalUnits));
    const placements = [];
    for (let i = 0; i < pieces; i++) {
      const useMirror = (i % 2) === 1;
      placements.push({
        x: Number((i * safeW).toFixed(2)),
        y: 0,
        w: Number(safeW.toFixed(2)),
        h: Number(safeH.toFixed(2)),
        flip: useMirror,
        polygon: useMirror ? mirrorPoly : poly
      });
    }
    return {
      width: Number((safeW * pieces).toFixed(2)),
      height: Number(safeH.toFixed(2)),
      pieces: pieces,
      waste_pct: 0,
      placements: placements,
      source: 'trap_runtime_hard_' + pieces + 'u_' + totalUnits
    };
  }

  private buildOefRuntimeRemainderRow(baseTemplateIn: any, idIn: number, unitsIn: number): any {
    const row = JSON.parse(JSON.stringify(baseTemplateIn || {}));
    row.id = idIn;
    row.units = Math.max(1, Math.round(Number(unitsIn || 1)));
    row.check = true;
    const baseFigureRaw = Number(baseTemplateIn && (
      baseTemplateIn.piece_figure_input !== undefined && baseTemplateIn.piece_figure_input !== null
        ? baseTemplateIn.piece_figure_input
        : baseTemplateIn.figure
    ));
    const baseFigure = (Number.isFinite(baseFigureRaw) && baseFigureRaw > 0) ? Math.round(baseFigureRaw) : 0;
    row.figure = baseFigure;
    row.piece_figure_input = baseFigure;
    row.dxf_points = null;
    row.piece_dxf_points = null;
    row.dxf_name = '';
    row.source = 'oef_runtime_remainder';

    const dims = this.getOefPieceBaseDimensions(baseTemplateIn);
    const safeW = Number.isFinite(Number(dims && dims.width)) && Number(dims.width) > 0 ? Number(dims.width) : 1;
    const safeH = Number.isFinite(Number(dims && dims.height)) && Number(dims.height) > 0 ? Number(dims.height) : 1;
    const polyRaw = this.getPiecePolygonTemplate(baseTemplateIn, safeW, safeH);
    const poly = (Array.isArray(polyRaw) && polyRaw.length >= 3)
      ? polyRaw
      : [
          { x: 0, y: safeH },
          { x: safeW, y: safeH },
          { x: safeW * 0.85, y: 0 },
          { x: safeW * 0.15, y: 0 }
        ];
    const tight = this.normalizeOefPolygonsToTightBBox([poly]);
    row.oef_internal_polygons = tight.polygons;
    if (Number(tight.width) > 0 && Number(tight.height) > 0) {
      row.width = Number(tight.width);
      row.height = Number(tight.height);
    } else {
      row.width = Number(safeW);
      row.height = Number(safeH);
    }
    row.oef_primitive_w = Number(row.width);
    row.oef_primitive_h = Number(row.height);
    row.oef_effective_area = Number(tight.area);
    this.applyOefRuntimeAreaMetrics(row, baseTemplateIn, 1);
    row.oef_generated = true;
    row.oef_runtime_units = Number(row.units);
    row.oef_runtime_remainder = true;
    return row;
  }

  private getOefBaseUnitArea(baseTemplateIn: any): number {
    const explicitBaseUnitArea = Number(baseTemplateIn && (
      baseTemplateIn.oef_base_unit_area !== undefined
        ? baseTemplateIn.oef_base_unit_area
        : baseTemplateIn.piece_oef_base_unit_area
    ));
    if (Number.isFinite(explicitBaseUnitArea) && explicitBaseUnitArea > 0) {
      return Number(explicitBaseUnitArea);
    }
    const explicitArea = Number(baseTemplateIn && baseTemplateIn.area);
    if (Number.isFinite(explicitArea) && explicitArea > 0) {
      return Number(explicitArea);
    }
    const dims = this.getOefPieceBaseDimensions(baseTemplateIn);
    const w = Number(dims && dims.width);
    const h = Number(dims && dims.height);
    if (Number.isFinite(w) && w > 0 && Number.isFinite(h) && h > 0) {
      return Number(((w * h) / 1000000).toFixed(2));
    }
    return 0;
  }

  private applyOefRuntimeAreaMetrics(rowIn: any, baseTemplateIn: any, realUnitsPerPackIn: number): void {
    if (!rowIn) {
      return;
    }
    const realUnits = Math.max(1, Math.round(Number(realUnitsPerPackIn || 1)));
    const baseUnitArea = this.getOefBaseUnitArea(baseTemplateIn);
    rowIn.oef_real_units = realUnits;
    rowIn.oef_base_unit_area = baseUnitArea > 0 ? Number(baseUnitArea) : 0;
    if (baseUnitArea > 0) {
      rowIn.area = Number((baseUnitArea * realUnits).toFixed(2));
    }
  }

  private generateForm38BandCandidates(
    itemsIn: any[],
    allowMirrorIn: boolean,
    maxSheetWidthIn: number,
    maxSheetHeightIn: number,
    maxTravIn: number
  ): any[] {
    const form38Items = (itemsIn || []).filter(item => item && item.is_form38 === true);
    if (!form38Items.length) {
      return [];
    }

    const grouped = {};
    form38Items.forEach(item => {
      const key = Number(item.width).toFixed(2) + 'x' + Number(item.height).toFixed(2);
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
    });

    let dominant = null;
    Object.keys(grouped).forEach(key => {
      if (!dominant || grouped[key].length > dominant.length) {
        dominant = grouped[key];
      }
    });
    if (!dominant || !dominant.length) {
      return [];
    }

    const first = dominant[0];
    const width = Number(first.width);
    const height = Number(first.height);
    if (!(width > 0) || !(height > 0)) {
      return [];
    }
    const eps = 0.0001;
    const sanitizePolygon = (polyIn: any[]): any[] => {
      return (Array.isArray(polyIn) ? polyIn : [])
        .map(p => ({ x: Number(p && p.x), y: Number(p && p.y) }))
        .filter(p => Number.isFinite(p.x) && Number.isFinite(p.y));
    };
    const isUsablePoly = (polyIn: any[]): boolean => {
      const poly = sanitizePolygon(polyIn);
      if (poly.length < 3) {
        return false;
      }
      const xs = poly.map(p => Number(p.x));
      const ys = poly.map(p => Number(p.y));
      const spanX = Math.max.apply(null, xs) - Math.min.apply(null, xs);
      const spanY = Math.max.apply(null, ys) - Math.min.apply(null, ys);
      if (!(spanX > eps) || !(spanY > eps)) {
        return false;
      }
      return this.getPolygonAreaAbs(poly) > eps;
    };
    const getFallbackPoly = (): any[] => ([
      { x: 0, y: height },
      { x: width, y: height },
      { x: width * 0.85, y: 0 },
      { x: width * 0.15, y: 0 }
    ]);
    let basePoly = sanitizePolygon(first.polygon);
    if (!isUsablePoly(basePoly)) {
      // Fallback robusto para no perder generación OEF de forma 38.
      basePoly = getFallbackPoly();
    }
    const firstFigure = this.getPieceFigureId(first);
    const isForm37Family = (firstFigure === 37 || firstFigure === 371);

    const maxK = Math.min(8, dominant.length);
    const candidates = [];
    const maxSheetWidthRaw = Number.isFinite(Number(maxSheetWidthIn)) && Number(maxSheetWidthIn) > 0 ? Number(maxSheetWidthIn) : 3210;
    const maxSheetHeightRaw = Number.isFinite(Number(maxSheetHeightIn)) && Number(maxSheetHeightIn) > 0 ? Number(maxSheetHeightIn) : 2550;
    const maxTrav = Number.isFinite(Number(maxTravIn)) && Number(maxTravIn) > 0 ? Number(maxTravIn) : 0;
    // El contexto real de optimización puede permitir longitudes mayores que la "plancha visible"
    // (según travesa y configuración de mesa). Se usa un límite efectivo coherente con MaxTrav.
    const maxSheetWidth = Math.max(maxSheetWidthRaw, maxTrav > 0 ? maxTrav : 0);
    const maxSheetHeight = Math.max(maxSheetHeightRaw, maxTrav > 0 ? maxTrav : 0);

    const overlapsInteriorConvex = (polyAIn: any[], polyBIn: any[]): boolean => {
      if (!Array.isArray(polyAIn) || !Array.isArray(polyBIn) || polyAIn.length < 3 || polyBIn.length < 3) {
        return false;
      }
      const axes = [];
      const pushAxes = (poly: any[]) => {
        for (let i = 0; i < poly.length; i++) {
          const p1 = poly[i];
          const p2 = poly[(i + 1) % poly.length];
          const dx = Number(p2.x) - Number(p1.x);
          const dy = Number(p2.y) - Number(p1.y);
          if (!Number.isFinite(dx) || !Number.isFinite(dy)) {
            continue;
          }
          const len = Math.sqrt((dx * dx) + (dy * dy));
          if (len <= eps) {
            continue;
          }
          axes.push({ x: -dy / len, y: dx / len });
        }
      };
      pushAxes(polyAIn);
      pushAxes(polyBIn);
      if (!axes.length) {
        return false;
      }

      const project = (poly: any[], axis: any) => {
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        poly.forEach(pt => {
          const v = (Number(pt.x) * Number(axis.x)) + (Number(pt.y) * Number(axis.y));
          if (v < min) min = v;
          if (v > max) max = v;
        });
        return { min: min, max: max };
      };

      for (let i = 0; i < axes.length; i++) {
        const axis = axes[i];
        const pA = project(polyAIn, axis);
        const pB = project(polyBIn, axis);
        const overlap = Math.min(pA.max, pB.max) - Math.max(pA.min, pB.min);
        // Si no hay solape positivo en algún eje, no hay intersección de interior.
        if (overlap <= eps) {
          return false;
        }
      }
      return true;
    };

    const signedOverlapConvex = (polyAIn: any[], polyBIn: any[]): number => {
      if (!Array.isArray(polyAIn) || !Array.isArray(polyBIn) || polyAIn.length < 3 || polyBIn.length < 3) {
        return Number.NEGATIVE_INFINITY;
      }
      const axes = [];
      const pushAxes = (poly: any[]) => {
        for (let i = 0; i < poly.length; i++) {
          const p1 = poly[i];
          const p2 = poly[(i + 1) % poly.length];
          const dx = Number(p2.x) - Number(p1.x);
          const dy = Number(p2.y) - Number(p1.y);
          const len = Math.sqrt((dx * dx) + (dy * dy));
          if (!Number.isFinite(dx) || !Number.isFinite(dy) || len <= eps) continue;
          axes.push({ x: -dy / len, y: dx / len });
        }
      };
      pushAxes(polyAIn);
      pushAxes(polyBIn);
      if (!axes.length) return Number.NEGATIVE_INFINITY;

      const project = (poly: any[], axis: any) => {
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        poly.forEach(pt => {
          const v = (Number(pt.x) * Number(axis.x)) + (Number(pt.y) * Number(axis.y));
          if (v < min) min = v;
          if (v > max) max = v;
        });
        return { min: min, max: max };
      };

      let minOverlap = Number.POSITIVE_INFINITY;
      for (let i = 0; i < axes.length; i++) {
        const axis = axes[i];
        const pA = project(polyAIn, axis);
        const pB = project(polyBIn, axis);
        const overlap = Math.min(pA.max, pB.max) - Math.max(pA.min, pB.min);
        if (overlap < minOverlap) minOverlap = overlap;
      }
      return minOverlap;
    };

    const getEdgeLineBySide = (polyIn: any[], sideIn: 'left' | 'right'): any => {
      if (!Array.isArray(polyIn) || polyIn.length < 3) return null;
      let best = null;
      for (let i = 0; i < polyIn.length; i++) {
        const p1 = polyIn[i];
        const p2 = polyIn[(i + 1) % polyIn.length];
        const x1 = Number(p1.x); const y1 = Number(p1.y);
        const x2 = Number(p2.x); const y2 = Number(p2.y);
        const dx = x2 - x1; const dy = y2 - y1;
        if (!Number.isFinite(dx) || !Number.isFinite(dy)) continue;
        // Solo bordes inclinados (ni horizontal ni vertical).
        if (Math.abs(dy) <= eps || Math.abs(dx) <= eps) continue;
        const midX = (x1 + x2) / 2;
        if (!best) {
          best = { p1: { x: x1, y: y1 }, p2: { x: x2, y: y2 }, midX: midX };
          continue;
        }
        if (sideIn === 'right' && midX > best.midX) {
          best = { p1: { x: x1, y: y1 }, p2: { x: x2, y: y2 }, midX: midX };
        } else if (sideIn === 'left' && midX < best.midX) {
          best = { p1: { x: x1, y: y1 }, p2: { x: x2, y: y2 }, midX: midX };
        }
      }
      if (!best) return null;
      const dy = best.p2.y - best.p1.y;
      if (Math.abs(dy) <= eps) return null;
      const a = (best.p2.x - best.p1.x) / dy; // x(y) = a*y + b
      const b = best.p1.x - (a * best.p1.y);
      const yMin = Math.min(best.p1.y, best.p2.y);
      const yMax = Math.max(best.p1.y, best.p2.y);
      return { a: a, b: b, yMin: yMin, yMax: yMax };
    };

    const mirroredBasePoly = sanitizePolygon(this.mirrorPolygonVertical(basePoly, width));
    const mirroredHorizontalBasePoly = sanitizePolygon(this.mirrorPolygonHorizontal(basePoly, height));
    const rotated180BasePoly = sanitizePolygon(this.rotatePolygon180InBounds(basePoly, width, height));
    const computeInterlockStepX = (prevPolyIn: any[], nextPolyIn: any[]): number | null => {
      const getSpanX = (polyIn: any[]): number => {
        const poly = sanitizePolygon(polyIn);
        if (!poly.length) return 0;
        const xs = poly.map(p => Number(p.x)).filter(v => Number.isFinite(v));
        if (!xs.length) return 0;
        return Math.max.apply(null, xs) - Math.min.apply(null, xs);
      };
      const rightEdge = getEdgeLineBySide(prevPolyIn, 'right');
      const leftEdge = getEdgeLineBySide(nextPolyIn, 'left');
      if (rightEdge && leftEdge && Math.abs(rightEdge.a - leftEdge.a) <= 0.002) {
        const yStart = Math.max(Number(rightEdge.yMin), Number(leftEdge.yMin));
        const yEnd = Math.min(Number(rightEdge.yMax), Number(leftEdge.yMax));
        if (Number.isFinite(yStart) && Number.isFinite(yEnd) && (yEnd - yStart) > eps) {
          const yMid = (yStart + yEnd) / 2;
          const xRight = (rightEdge.a * yMid) + rightEdge.b;
          const xLeft = (leftEdge.a * yMid) + leftEdge.b;
          const dxLine = xRight - xLeft;
          const maxExpected = Math.max(getSpanX(prevPolyIn), getSpanX(nextPolyIn)) * 2.5;
          if (Number.isFinite(dxLine) && dxLine > eps && (maxExpected <= eps || dxLine < maxExpected)) {
            return dxLine;
          }
        }
      }

      return null;
    };

    const hasExactInclinedJoin = (prevPolyIn: any[], nextPolyIn: any[], dxIn: number): boolean => {
      const rightEdge = getEdgeLineBySide(prevPolyIn, 'right');
      const leftEdge = getEdgeLineBySide(nextPolyIn, 'left');
      if (!rightEdge || !leftEdge) {
        return false;
      }
      const slopeTol = 0.0005;
      const lineTol = 0.08;
      if (Math.abs(Number(rightEdge.a) - Number(leftEdge.a)) > slopeTol) {
        return false;
      }
      const shiftedLeftB = Number(leftEdge.b) + Number(dxIn);
      if (Math.abs(Number(rightEdge.b) - shiftedLeftB) > lineTol) {
        return false;
      }
      const yStart = Math.max(Number(rightEdge.yMin), Number(leftEdge.yMin));
      const yEnd = Math.min(Number(rightEdge.yMax), Number(leftEdge.yMax));
      if (!(Number.isFinite(yStart) && Number.isFinite(yEnd))) {
        return false;
      }
      const overlap = yEnd - yStart;
      const prevRange = Number(rightEdge.yMax) - Number(rightEdge.yMin);
      const nextRange = Number(leftEdge.yMax) - Number(leftEdge.yMin);
      const required = Math.max(eps, Math.min(prevRange, nextRange) * 0.80);
      return overlap > required;
    };

    const getEdgeLineByBand = (polyIn: any[], sideIn: 'top' | 'bottom'): any => {
      if (!Array.isArray(polyIn) || polyIn.length < 3) return null;
      let best = null;
      for (let i = 0; i < polyIn.length; i++) {
        const p1 = polyIn[i];
        const p2 = polyIn[(i + 1) % polyIn.length];
        const x1 = Number(p1.x); const y1 = Number(p1.y);
        const x2 = Number(p2.x); const y2 = Number(p2.y);
        const dx = x2 - x1; const dy = y2 - y1;
        if (!Number.isFinite(dx) || !Number.isFinite(dy)) continue;
        if (Math.abs(dx) <= eps || Math.abs(dy) <= eps) continue;
        const midY = (y1 + y2) / 2;
        if (!best) {
          best = { p1: { x: x1, y: y1 }, p2: { x: x2, y: y2 }, midY: midY };
          continue;
        }
        if (sideIn === 'top' && midY > best.midY) {
          best = { p1: { x: x1, y: y1 }, p2: { x: x2, y: y2 }, midY: midY };
        } else if (sideIn === 'bottom' && midY < best.midY) {
          best = { p1: { x: x1, y: y1 }, p2: { x: x2, y: y2 }, midY: midY };
        }
      }
      if (!best) return null;
      const dx = best.p2.x - best.p1.x;
      if (Math.abs(dx) <= eps) return null;
      const a = (best.p2.y - best.p1.y) / dx; // y(x) = a*x + b
      const b = best.p1.y - (a * best.p1.x);
      const xMin = Math.min(best.p1.x, best.p2.x);
      const xMax = Math.max(best.p1.x, best.p2.x);
      return { a: a, b: b, xMin: xMin, xMax: xMax };
    };

    const computeInterlockStepY = (prevPolyIn: any[], nextPolyIn: any[]): number | null => {
      const getSpanY = (polyIn: any[]): number => {
        const poly = sanitizePolygon(polyIn);
        if (!poly.length) return 0;
        const ys = poly.map(p => Number(p.y)).filter(v => Number.isFinite(v));
        if (!ys.length) return 0;
        return Math.max.apply(null, ys) - Math.min.apply(null, ys);
      };
      const bottomEdge = getEdgeLineByBand(prevPolyIn, 'bottom');
      const topEdge = getEdgeLineByBand(nextPolyIn, 'top');
      if (bottomEdge && topEdge && Math.abs(bottomEdge.a - topEdge.a) <= 0.002) {
        const xStart = Math.max(Number(bottomEdge.xMin), Number(topEdge.xMin));
        const xEnd = Math.min(Number(bottomEdge.xMax), Number(topEdge.xMax));
        if (Number.isFinite(xStart) && Number.isFinite(xEnd) && (xEnd - xStart) > eps) {
          const xMid = (xStart + xEnd) / 2;
          const yBottom = (bottomEdge.a * xMid) + bottomEdge.b;
          const yTop = (topEdge.a * xMid) + topEdge.b;
          const dyLine = yBottom - yTop;
          const maxExpected = Math.max(getSpanY(prevPolyIn), getSpanY(nextPolyIn)) * 2.5;
          if (Number.isFinite(dyLine) && dyLine > eps && (maxExpected <= eps || dyLine < maxExpected)) {
            return dyLine;
          }
        }
      }
      return null;
    };

    const hasExactInclinedJoinY = (prevPolyIn: any[], nextPolyIn: any[], dyIn: number): boolean => {
      const bottomEdge = getEdgeLineByBand(prevPolyIn, 'bottom');
      const topEdge = getEdgeLineByBand(nextPolyIn, 'top');
      if (!bottomEdge || !topEdge) return false;
      const slopeTol = 0.0005;
      const lineTol = 0.08;
      if (Math.abs(Number(bottomEdge.a) - Number(topEdge.a)) > slopeTol) {
        return false;
      }
      const shiftedTopB = Number(topEdge.b) + Number(dyIn);
      if (Math.abs(Number(bottomEdge.b) - shiftedTopB) > lineTol) {
        return false;
      }
      const xStart = Math.max(Number(bottomEdge.xMin), Number(topEdge.xMin));
      const xEnd = Math.min(Number(bottomEdge.xMax), Number(topEdge.xMax));
      if (!(Number.isFinite(xStart) && Number.isFinite(xEnd))) {
        return false;
      }
      const overlap = xEnd - xStart;
      const prevRange = Number(bottomEdge.xMax) - Number(bottomEdge.xMin);
      const nextRange = Number(topEdge.xMax) - Number(topEdge.xMin);
      const required = Math.max(eps, Math.min(prevRange, nextRange) * 0.95);
      return overlap > required;
    };

    const fitsSheet = (wIn: number, hIn: number): boolean => {
      return (wIn <= maxSheetWidth && hIn <= maxSheetHeight) || (hIn <= maxSheetWidth && wIn <= maxSheetHeight);
    };
    const fitsMaxTrav = (wIn: number, hIn: number): boolean => {
      if (!(maxTrav > 0)) {
        return true;
      }
      return wIn <= maxTrav || hIn <= maxTrav;
    };

    const finalizeCandidate = (placementsIn: any[], sourceIn: string): any => {
      const isNarrowSource = typeof sourceIn === 'string' && sourceIn.indexOf('form38_narrow_v_') === 0;
      const narrowLogReject = (reasonIn: string, extraIn: any = null): void => {
        // Hook de diagnóstico (desactivado en entorno normal).
      };
      if (!placementsIn || placementsIn.length < 2) {
        narrowLogReject('placements_lt_2', { placements: placementsIn ? placementsIn.length : 0 });
        return null;
      }
      const pts = [];
      let usedGeomArea = 0;
      const absPolygons = [];
      placementsIn.forEach(pl => {
        const safePoly = sanitizePolygon(pl && pl.polygon);
        const polygon = isUsablePoly(safePoly) ? safePoly : getFallbackPoly();
        const polyAbs = this.transformPolygon(polygon, pl.x, pl.y);
        absPolygons.push(polyAbs);
        usedGeomArea += this.getPolygonAreaAbs(polygon);
        polyAbs.forEach(pt => pts.push(pt));
      });
      const xs = pts.map(p => Number(p.x)).filter(v => Number.isFinite(v));
      const ys = pts.map(p => Number(p.y)).filter(v => Number.isFinite(v));
      if (!xs.length || !ys.length) {
        narrowLogReject('invalid_points', { xs: xs.length, ys: ys.length });
        return null;
      }
      const minX = Math.min.apply(null, xs);
      const maxX = Math.max.apply(null, xs);
      const minY = Math.min.apply(null, ys);
      const maxY = Math.max.apply(null, ys);
      const primitiveWidth = maxX - minX;
      const primitiveHeight = maxY - minY;
      if (!(primitiveWidth > 0) || !(primitiveHeight > 0)) {
        narrowLogReject('invalid_bbox', { w: primitiveWidth, h: primitiveHeight });
        return null;
      }
      const primitiveArea = primitiveWidth * primitiveHeight;
      const areaSlack = isNarrowSource ? 2.0 : 0.1;
      const pairOverlapLimit = isNarrowSource ? 0.08 : 0.05;

      // Guarda de seguridad: si el área total de polígonos supera
      // el bounding-box, hay solape geométrico entre piezas.
      if (usedGeomArea > (primitiveArea + areaSlack)) {
        narrowLogReject('area_gt_bbox', {
          used_area: Number(usedGeomArea.toFixed(4)),
          bbox_area: Number(primitiveArea.toFixed(4)),
          slack: areaSlack
        });
        return null;
      }

      // Validación extra par-a-par para evitar aceptar solapes por tolerancias.
      for (let i = 0; i < absPolygons.length; i++) {
        for (let j = i + 1; j < absPolygons.length; j++) {
          const overlapSigned = signedOverlapConvex(absPolygons[i], absPolygons[j]);
          if (overlapSigned > pairOverlapLimit) {
            narrowLogReject('pair_overlap', {
              pair: [i, j],
              overlap: Number(overlapSigned.toFixed(4)),
              limit: pairOverlapLimit
            });
            return null;
          }
        }
      }
      if (!fitsSheet(primitiveWidth, primitiveHeight)) {
        narrowLogReject('sheet_limits', { w: primitiveWidth, h: primitiveHeight });
        return null;
      }
      if (!fitsMaxTrav(primitiveWidth, primitiveHeight)) {
        narrowLogReject('maxtrav_limits', { w: primitiveWidth, h: primitiveHeight, max_trav: maxTrav });
        return null;
      }

      const normalizedPlacements = placementsIn.map(pl => {
        const safePoly = sanitizePolygon(pl && pl.polygon);
        const polygon = isUsablePoly(safePoly) ? safePoly : getFallbackPoly();
        return {
        x: Number((pl.x - minX).toFixed(2)),
        y: Number((pl.y - minY).toFixed(2)),
        w: Number(width),
        h: Number(height),
        flip: pl.flip === true,
        polygon: polygon.map(pt => ({ x: Number(pt.x), y: Number(pt.y) }))
      };
      });

      const usedArea = usedGeomArea > 0
        ? usedGeomArea
        : placementsIn.reduce((acc, pl) => acc + Number(pl.area || 0), 0);
      const wastePct = primitiveArea > 0 ? ((primitiveArea - usedArea) * 100 / primitiveArea) : 0;
      const baselineArea = placementsIn.length * (width * height);
      const improvementPct = baselineArea > 0 ? ((baselineArea - primitiveArea) * 100 / baselineArea) : 0;

      const candidate = {
        width: Number(primitiveWidth.toFixed(2)),
        height: Number(primitiveHeight.toFixed(2)),
        pieces: placementsIn.length,
        waste_pct: Number(Math.max(0, wastePct).toFixed(2)),
        // No se clampa a 0 para no ocultar mejoras pequeñas/negativas por redondeo.
        improvement_pct: Number(improvementPct.toFixed(4)),
        placements: normalizedPlacements,
        source: sourceIn
      };
      const isForm38StripSource = typeof sourceIn === 'string' &&
        (sourceIn.indexOf('form38_band_h_') === 0 || sourceIn.indexOf('form38_narrow_v_') === 0);
      if (isForm38StripSource && !isForm37Family) {
        const syntheticPolys = this.buildSyntheticForm38StripPolygons(
          Number(candidate.width),
          Number(candidate.height),
          Number(candidate.pieces),
          sourceIn.indexOf('form38_narrow_v_') === 0
        );
        if (syntheticPolys.length > 0) {
          candidate.placements = this.polygonsToNormalizedPlacements(syntheticPolys);
        }
      }
      candidates.push(candidate);
      return candidate;
    };

    for (let k = 2; k <= maxK; k++) {
      const verticalPlacements = [];
      for (let i = 0; i < k; i++) {
        verticalPlacements.push({
          x: 0,
          y: i * height,
          flip: false,
          polygon: basePoly,
          area: Number(dominant[i] && dominant[i].area ? dominant[i].area : (width * height))
        });
      }
      finalizeCandidate(verticalPlacements, 'form38_stack_v_' + k);
    }

    // Para forma 38, la alternancia base + rot180 puede generar uniones válidas
    // sin necesidad de espejo. Si allowMirror está activo, se habilitan además
    // variantes extra basadas en espejo para ampliar candidatos.

    const tryBuildHorizontalBand = (kIn: number, variantIn: 'same' | 'rot180' | 'mirror'): boolean => {
      const horizontalPlacements = [];
      let valid = true;
      const contactTol = 0.05;

      for (let i = 0; i < kIn; i++) {
        const transformed = variantIn !== 'same' && ((i % 2) === 1);
        const polygon = transformed
          ? (variantIn === 'rot180' ? rotated180BasePoly : mirroredBasePoly)
          : basePoly;
        const flip = transformed;
        let x = 0;

        if (horizontalPlacements.length > 0) {
          const prev = horizontalPlacements[horizontalPlacements.length - 1];
          const stepX = computeInterlockStepX(prev.polygon, polygon);
          if (!(Number.isFinite(stepX) && stepX > eps)) {
            valid = false;
            break;
          }
          x = Number(prev.x) + stepX;
          if (!hasExactInclinedJoin(prev.polygon, polygon, stepX)) {
            valid = false;
            break;
          }
        }

        const y = 0;
        const polygonAbs = this.transformPolygon(polygon, x, y);
        if (horizontalPlacements.some(prev =>
          overlapsInteriorConvex(polygonAbs, this.transformPolygon(prev.polygon, prev.x, prev.y))
        )) {
          valid = false;
          break;
        }

        const signedAgainstPrev = horizontalPlacements.length > 0
          ? signedOverlapConvex(
              polygonAbs,
              this.transformPolygon(
                horizontalPlacements[horizontalPlacements.length - 1].polygon,
                horizontalPlacements[horizontalPlacements.length - 1].x,
                horizontalPlacements[horizontalPlacements.length - 1].y
              )
            )
          : 0;
        if (horizontalPlacements.length > 0 && (signedAgainstPrev > contactTol || signedAgainstPrev < -contactTol)) {
          valid = false;
          break;
        }

        horizontalPlacements.push({
          x: x,
          y: y,
          flip: flip,
          polygon: polygon,
          area: Number(dominant[i] && dominant[i].area ? dominant[i].area : (width * height))
        });
      }

      if (!valid) {
        return false;
      }

      const created = finalizeCandidate(horizontalPlacements, 'form38_band_h_' + variantIn + '_' + kIn);
      if (!created) {
        return false;
      }

      return true;
    };

    for (let k = 2; k <= maxK; k++) {
      if (isForm37Family && tryBuildHorizontalBand(k, 'same')) {
        continue;
      }
      // Prioridad: alternancia con giro 180º (encaja lados inclinados completos).
      const okRot180 = tryBuildHorizontalBand(k, 'rot180');
      // Respaldo: alternancia por espejo vertical para geometrías que lo permitan.
      if (!okRot180 && allowMirrorIn === true) {
        tryBuildHorizontalBand(k, 'mirror');
      }
    }

    const findNarrowVerticalJoinVector = (prevPolyIn: any[], nextPolyIn: any[]): any => {
      const narrowStepCap = Math.min(maxSheetWidthRaw, maxSheetHeightRaw);
      const getMinEdgeLen = (polyIn: any[]): number => {
        const poly = sanitizePolygon(polyIn);
        if (poly.length < 2) {
          return 0;
        }
        let minLen = Number.POSITIVE_INFINITY;
        for (let i = 0; i < poly.length; i++) {
          const p1 = poly[i];
          const p2 = poly[(i + 1) % poly.length];
          const dx = Number(p2.x) - Number(p1.x);
          const dy = Number(p2.y) - Number(p1.y);
          const len = Math.sqrt((dx * dx) + (dy * dy));
          if (Number.isFinite(len) && len > eps && len < minLen) {
            minLen = len;
          }
        }
        return Number.isFinite(minLen) ? minLen : 0;
      };
      const shortStepCap = (() => {
        const a = getMinEdgeLen(prevPolyIn);
        const b = getMinEdgeLen(nextPolyIn);
        const base = Math.min(
          a > eps ? a : Number.POSITIVE_INFINITY,
          b > eps ? b : Number.POSITIVE_INFINITY
        );
        if (!Number.isFinite(base) || !(base > eps)) {
          return narrowStepCap;
        }
        return Math.min(narrowStepCap, base * 2.4);
      })();
      const getEdges = (polyIn: any[]): any[] => {
        const poly = sanitizePolygon(polyIn);
        const out = [];
        if (poly.length < 3) {
          return out;
        }
        for (let i = 0; i < poly.length; i++) {
          const p1 = poly[i];
          const p2 = poly[(i + 1) % poly.length];
          const x1 = Number(p1.x);
          const y1 = Number(p1.y);
          const x2 = Number(p2.x);
          const y2 = Number(p2.y);
          if (!Number.isFinite(x1) || !Number.isFinite(y1) || !Number.isFinite(x2) || !Number.isFinite(y2)) {
            continue;
          }
          const dx = x2 - x1;
          const dy = y2 - y1;
          const len = Math.sqrt((dx * dx) + (dy * dy));
          if (!(len > eps)) {
            continue;
          }
          out.push({
            p1: { x: x1, y: y1 },
            p2: { x: x2, y: y2 },
            len: len
          });
        }
        return out;
      };
      const findByShortEdgeExactMatch = (): any => {
        const prevEdges = getEdges(prevPolyIn);
        const nextEdges = getEdges(nextPolyIn);
        if (!prevEdges.length || !nextEdges.length) {
          return null;
        }
        const prevMinLen = prevEdges.reduce((acc, e) => Math.min(acc, Number(e.len)), Number.POSITIVE_INFINITY);
        const nextMinLen = nextEdges.reduce((acc, e) => Math.min(acc, Number(e.len)), Number.POSITIVE_INFINITY);
        if (!(Number.isFinite(prevMinLen) && Number.isFinite(nextMinLen))) {
          return null;
        }
        const shortTolRatio = 1.10;
        const shortLenTol = 1.2;
        const pointTol = 2.0;
        const contactTol = 0.05;
        const prevShort = prevEdges.filter(e => Number(e.len) <= (prevMinLen * shortTolRatio));
        const nextShort = nextEdges.filter(e => Number(e.len) <= (nextMinLen * shortTolRatio));
        if (!prevShort.length || !nextShort.length) {
          return null;
        }

        let best = null;
        for (let i = 0; i < prevShort.length; i++) {
          const pe = prevShort[i];
          for (let j = 0; j < nextShort.length; j++) {
            const ne = nextShort[j];
            if (Math.abs(Number(pe.len) - Number(ne.len)) > Math.max(shortLenTol, Math.min(Number(pe.len), Number(ne.len)) * 0.02)) {
              continue;
            }
            const pairs = [
              { aPrev: pe.p1, bPrev: pe.p2, aNext: ne.p2, bNext: ne.p1 },
              { aPrev: pe.p2, bPrev: pe.p1, aNext: ne.p1, bNext: ne.p2 },
              { aPrev: pe.p1, bPrev: pe.p2, aNext: ne.p1, bNext: ne.p2 },
              { aPrev: pe.p2, bPrev: pe.p1, aNext: ne.p2, bNext: ne.p1 }
            ];
            for (let m = 0; m < pairs.length; m++) {
              const pair = pairs[m];
              const tx = Number(pair.aPrev.x) - Number(pair.aNext.x);
              const ty = Number(pair.aPrev.y) - Number(pair.aNext.y);
              if (!(Number.isFinite(tx) && Number.isFinite(ty) && ty > eps && ty <= narrowStepCap)) {
                continue;
              }
              const end2dx = (Number(pair.bNext.x) + tx) - Number(pair.bPrev.x);
              const end2dy = (Number(pair.bNext.y) + ty) - Number(pair.bPrev.y);
              const endErr = Math.sqrt((end2dx * end2dx) + (end2dy * end2dy));
              if (endErr > pointTol) {
                continue;
              }

              const prevAbs = this.transformPolygon(prevPolyIn, 0, 0);
              const nextAbs = this.transformPolygon(nextPolyIn, tx, ty);
              if (overlapsInteriorConvex(prevAbs, nextAbs)) {
                continue;
              }
              const signed = signedOverlapConvex(prevAbs, nextAbs);
              if (signed > contactTol || signed < -0.10) {
                continue;
              }
              const score = (Number(ty) * 10) + Math.abs(Number(tx)) + (endErr * 5);
              if (!best || score < best.score) {
                best = { tx: Number(tx), ty: Number(ty), score: score };
              }
            }
          }
        }
        return best ? { tx: best.tx, ty: best.ty } : null;
      };
      const strictShortJoin = findByShortEdgeExactMatch();
      if (strictShortJoin) {
        return strictShortJoin;
      }

      const getInclinedEdges = (polyIn: any[]): any[] => {
        const poly = sanitizePolygon(polyIn);
        const out = [];
        if (poly.length < 3) {
          return out;
        }
        for (let i = 0; i < poly.length; i++) {
          const p1 = poly[i];
          const p2 = poly[(i + 1) % poly.length];
          const x1 = Number(p1.x);
          const y1 = Number(p1.y);
          const x2 = Number(p2.x);
          const y2 = Number(p2.y);
          const dx = x2 - x1;
          const dy = y2 - y1;
          const len = Math.sqrt((dx * dx) + (dy * dy));
          if (!Number.isFinite(x1) || !Number.isFinite(y1) || !Number.isFinite(x2) || !Number.isFinite(y2)) {
            continue;
          }
          if (!(len > eps)) {
            continue;
          }
          if (Math.abs(dx) <= eps || Math.abs(dy) <= eps) {
            continue;
          }
          out.push({
            p1: { x: x1, y: y1 },
            p2: { x: x2, y: y2 },
            len: len,
            ux: dx / len,
            uy: dy / len
          });
        }
        return out;
      };

      const findByInclinedEdges = (): any => {
        const prevEdges = getInclinedEdges(prevPolyIn);
        const nextEdges = getInclinedEdges(nextPolyIn);
        if (!prevEdges.length || !nextEdges.length) {
          return null;
        }
        let best = null;
        const lenTol = 2.5;
        const dirTol = 0.18;
        const contactTol = 0.08;
        for (let i = 0; i < prevEdges.length; i++) {
          const pe = prevEdges[i];
          for (let j = 0; j < nextEdges.length; j++) {
            const ne = nextEdges[j];
            if (Math.abs(Number(pe.len) - Number(ne.len)) > lenTol) {
              continue;
            }
            // Cuatro combinaciones de extremos para no perder encajes válidos
            // por orientación local del contorno.
            const vectors = [
              { tx: Number(pe.p1.x) - Number(ne.p1.x), ty: Number(pe.p1.y) - Number(ne.p1.y), dot: (Number(pe.ux) * Number(ne.ux)) + (Number(pe.uy) * Number(ne.uy)) },
              { tx: Number(pe.p1.x) - Number(ne.p2.x), ty: Number(pe.p1.y) - Number(ne.p2.y), dot: (Number(pe.ux) * -Number(ne.ux)) + (Number(pe.uy) * -Number(ne.uy)) },
              { tx: Number(pe.p2.x) - Number(ne.p1.x), ty: Number(pe.p2.y) - Number(ne.p1.y), dot: (Number(pe.ux) * Number(ne.ux)) + (Number(pe.uy) * Number(ne.uy)) },
              { tx: Number(pe.p2.x) - Number(ne.p2.x), ty: Number(pe.p2.y) - Number(ne.p2.y), dot: (Number(pe.ux) * -Number(ne.ux)) + (Number(pe.uy) * -Number(ne.uy)) }
            ];
            for (let v = 0; v < vectors.length; v++) {
              const vec = vectors[v];
              if (Math.abs(Math.abs(Number(vec.dot)) - 1) > dirTol) {
                continue;
              }
              if (!(Number(vec.ty) > eps && Number(vec.ty) <= shortStepCap)) {
                continue;
              }
              if (Math.abs(Number(vec.tx)) > (Math.max(width, height) * 2.0)) {
                continue;
              }
              const prevAbs = this.transformPolygon(prevPolyIn, 0, 0);
              const nextAbs = this.transformPolygon(nextPolyIn, Number(vec.tx), Number(vec.ty));
              if (overlapsInteriorConvex(prevAbs, nextAbs)) {
                continue;
              }
              const signed = signedOverlapConvex(prevAbs, nextAbs);
              if (signed > contactTol || signed < -contactTol) {
                continue;
              }
              const score = (Math.abs(Number(vec.tx)) * 8) + Number(vec.ty);
              if (!best || Number(score) < Number(best.score)) {
                best = { tx: Number(vec.tx), ty: Number(vec.ty), score: Number(score) };
              }
            }
          }
        }
        return best;
      };

      const byInclined = findByInclinedEdges();
      if (byInclined) {
        return byInclined;
      }

      const getHorizontalEdges = (polyIn: any[]): any[] => {
        const poly = sanitizePolygon(polyIn);
        const out = [];
        if (poly.length < 3) {
          return out;
        }
        for (let i = 0; i < poly.length; i++) {
          const p1 = poly[i];
          const p2 = poly[(i + 1) % poly.length];
          const x1 = Number(p1.x);
          const y1 = Number(p1.y);
          const x2 = Number(p2.x);
          const y2 = Number(p2.y);
          if (!Number.isFinite(x1) || !Number.isFinite(y1) || !Number.isFinite(x2) || !Number.isFinite(y2)) {
            continue;
          }
          if (Math.abs(y2 - y1) > 0.2) {
            continue;
          }
          const left = Math.min(x1, x2);
          const right = Math.max(x1, x2);
          const len = right - left;
          if (len <= eps) {
            continue;
          }
          out.push({
            y: (y1 + y2) * 0.5,
            x1: left,
            x2: right,
            len: len
          });
        }
        return out;
      };

      const prevTopEdges = getHorizontalEdges(prevPolyIn).sort((a, b) => {
        if (b.y !== a.y) return b.y - a.y;
        return b.len - a.len;
      });
      const nextBottomEdges = getHorizontalEdges(nextPolyIn).sort((a, b) => {
        if (a.y !== b.y) return a.y - b.y;
        return b.len - a.len;
      });
      if (!prevTopEdges.length || !nextBottomEdges.length) {
        return null;
      }

      let best = null;
      const lenTol = 2.5;
      const overlapTarget = 0.70;
      const contactTol = 0.12;
      const yMax = Math.min(Math.max(width, height) * 2.5, shortStepCap);

      for (let i = 0; i < prevTopEdges.length; i++) {
        const ePrev = prevTopEdges[i];
        for (let j = 0; j < nextBottomEdges.length; j++) {
          const eNext = nextBottomEdges[j];
          if (Math.abs(Number(ePrev.len) - Number(eNext.len)) > lenTol) {
            continue;
          }
          const ty = Number(ePrev.y) - Number(eNext.y);
          if (!(ty > eps && ty <= yMax)) {
            continue;
          }
          const txCandidates = [
            Number(ePrev.x1) - Number(eNext.x1),
            Number(ePrev.x2) - Number(eNext.x2),
            ((Number(ePrev.x1) + Number(ePrev.x2)) * 0.5) - ((Number(eNext.x1) + Number(eNext.x2)) * 0.5)
          ];

          for (let c = 0; c < txCandidates.length; c++) {
            const tx = Number(txCandidates[c]);
            const nextX1 = Number(eNext.x1) + tx;
            const nextX2 = Number(eNext.x2) + tx;
            const overlap = Math.min(Number(ePrev.x2), nextX2) - Math.max(Number(ePrev.x1), nextX1);
            if (!(overlap >= (Math.min(Number(ePrev.len), Number(eNext.len)) * overlapTarget))) {
              continue;
            }

            const prevAbs = this.transformPolygon(prevPolyIn, 0, 0);
            const nextAbs = this.transformPolygon(nextPolyIn, tx, ty);
            if (overlapsInteriorConvex(prevAbs, nextAbs)) {
              continue;
            }
            const signed = signedOverlapConvex(prevAbs, nextAbs);
            if (signed > contactTol || signed < -contactTol) {
              continue;
            }

            const score = (Math.abs(Number(tx)) * 8) + Number(ty);
            if (!best || Number(score) < Number(best.score)) {
              best = { tx: tx, ty: ty, score: Number(score) };
            }
          }
        }
      }

      return best;
    };

    const narrowStats = {
      attempts: 0,
      built: 0,
      fail_no_join: 0,
      fail_overlap: 0,
      fail_contact: 0,
      fail_backtrack: 0,
      fail_finalize: 0
    };
    const shearStats = {
      attempts: 0,
      built: 0,
      fail_no_step: 0,
      fail_overlap: 0,
      fail_contact: 0,
      fail_finalize: 0
    };

    const tryBuildNarrowVerticalByShear = (kIn: number): boolean => {
      shearStats.attempts += 1;
      const getHorizontalEdges = (polyIn: any[]): any[] => {
        const poly = sanitizePolygon(polyIn);
        const out = [];
        if (poly.length < 3) {
          return out;
        }
        for (let i = 0; i < poly.length; i++) {
          const p1 = poly[i];
          const p2 = poly[(i + 1) % poly.length];
          const x1 = Number(p1.x);
          const y1 = Number(p1.y);
          const x2 = Number(p2.x);
          const y2 = Number(p2.y);
          if (!Number.isFinite(x1) || !Number.isFinite(y1) || !Number.isFinite(x2) || !Number.isFinite(y2)) {
            continue;
          }
          if (Math.abs(y2 - y1) > 0.2) {
            continue;
          }
          const left = Math.min(x1, x2);
          const right = Math.max(x1, x2);
          const len = right - left;
          if (!(len > eps)) {
            continue;
          }
          out.push({ y: (y1 + y2) * 0.5, x1: left, x2: right, len: len });
        }
        return out;
      };
      const computeShearStep = (prevPolyIn: any[], nextPolyIn: any[]): any => {
        const findByScan = (): any => {
          const prevAbs = this.transformPolygon(prevPolyIn, 0, 0);
          if (!prevAbs.length) {
            return null;
          }
          const maxDy = Math.min(Math.max(200, Number(height) * 0.85), Math.min(maxSheetWidthRaw, maxSheetHeightRaw));
          const maxDx = Math.max(200, Number(width) * 2.5);
          const stepDy = 20;
          const stepDx = 10;
          const baseW = Math.max(1, Number(width));
          let best = null;

          for (let ty = stepDy; ty <= maxDy; ty += stepDy) {
            for (let tx = -maxDx; tx <= maxDx; tx += stepDx) {
              const nextAbs = this.transformPolygon(nextPolyIn, tx, ty);
              if (overlapsInteriorConvex(prevAbs, nextAbs)) {
                continue;
              }
              const signed = signedOverlapConvex(prevAbs, nextAbs);
              if (signed > 0.05 || signed < -0.25) {
                continue;
              }
              const xs = []
                .concat(prevAbs.map(p => Number(p && p.x)))
                .concat(nextAbs.map(p => Number(p && p.x)))
                .filter(v => Number.isFinite(v));
              if (!xs.length) {
                continue;
              }
              const boxW = Math.max.apply(null, xs) - Math.min.apply(null, xs);
              if (boxW > (baseW * 1.22)) {
                continue;
              }
              // Prioridad: barra compacta y contacto casi tangente.
              const score = (boxW * 10) + (Math.abs(signed) * 1000) + Math.abs(tx) + (ty * 0.2);
              if (!best || score < best.score) {
                best = { tx: tx, ty: ty, score: score };
              }
            }
            if (best) {
              break;
            }
          }
          return best ? { tx: best.tx, ty: best.ty } : null;
        };

        const prevTop = getHorizontalEdges(prevPolyIn).sort((a, b) => {
          if (b.y !== a.y) return b.y - a.y;
          return b.len - a.len;
        })[0];
        const nextBottom = getHorizontalEdges(nextPolyIn).sort((a, b) => {
          if (a.y !== b.y) return a.y - b.y;
          return b.len - a.len;
        })[0];
        if (!prevTop || !nextBottom) {
          return findByScan();
        }
        if (Math.abs(Number(prevTop.len) - Number(nextBottom.len)) > 3.0) {
          return findByScan();
        }
        const ty = Number(prevTop.y) - Number(nextBottom.y);
        if (!(ty > eps && ty <= Math.min(maxSheetWidthRaw, maxSheetHeightRaw))) {
          return findByScan();
        }
        const txDirect = Number(prevTop.x1) - Number(nextBottom.x1);
        const txReverse = Number(prevTop.x1) - Number(nextBottom.x2);
        const errDirect = Math.abs((Number(nextBottom.x2) + txDirect) - Number(prevTop.x2));
        const errReverse = Math.abs((Number(nextBottom.x1) + txReverse) - Number(prevTop.x2));
        const tx = errDirect <= errReverse ? txDirect : txReverse;
        const err = Math.min(errDirect, errReverse);
        if (err > 2.0) {
          return findByScan();
        }
        const prevAbs = this.transformPolygon(prevPolyIn, 0, 0);
        const nextAbs = this.transformPolygon(nextPolyIn, tx, ty);
        if (overlapsInteriorConvex(prevAbs, nextAbs)) {
          return findByScan();
        }
        const signed = signedOverlapConvex(prevAbs, nextAbs);
        if (signed > 0.05 || signed < -0.10) {
          return findByScan();
        }
        return { tx: tx, ty: ty };
      };

      const baseOptions = [
        { key: 'base', polygon: sanitizePolygon(basePoly), flip: false },
        { key: 'rot180', polygon: sanitizePolygon(rotated180BasePoly), flip: true }
      ];
      if (allowMirrorIn === true) {
        baseOptions.push({ key: 'mirror_v', polygon: sanitizePolygon(mirroredBasePoly), flip: true });
      }
      const options = baseOptions.filter(opt => isUsablePoly(opt.polygon));
      const contactTol = 0.12;
      const contactGapTol = 0.35;

      for (let a = 0; a < options.length; a++) {
        for (let b = 0; b < options.length; b++) {
          if (a === b) {
            continue;
          }
          const optA = options[a];
          const optB = options[b];
          const stepAB = computeShearStep(optA.polygon, optB.polygon);
          const stepBA = computeShearStep(optB.polygon, optA.polygon);
          if (!stepAB || !stepBA) {
            shearStats.fail_no_step += 1;
            continue;
          }
          const placements = [];
          let ok = true;
          for (let i = 0; i < kIn; i++) {
            const useA = (i % 2) === 0;
            const option = useA ? optA : optB;
            let x = 0;
            let y = 0;
            if (placements.length > 0) {
              const prev = placements[placements.length - 1];
              const prevWasA = ((i - 1) % 2) === 0;
              const step = prevWasA ? stepAB : stepBA;
              x = Number(prev.x) + Number(step.tx);
              y = Number(prev.y) + Number(step.ty);
            }
            const polyAbs = this.transformPolygon(option.polygon, x, y);
            for (let z = 0; z < placements.length; z++) {
              const prevAbs = this.transformPolygon(placements[z].polygon, placements[z].x, placements[z].y);
              if (overlapsInteriorConvex(polyAbs, prevAbs)) {
                shearStats.fail_overlap += 1;
                ok = false;
                break;
              }
              if (signedOverlapConvex(polyAbs, prevAbs) > 0.05) {
                shearStats.fail_overlap += 1;
                ok = false;
                break;
              }
            }
            if (!ok) {
              break;
            }
            if (placements.length > 0) {
              const prev = placements[placements.length - 1];
              const signedAgainstPrev = signedOverlapConvex(
                polyAbs,
                this.transformPolygon(prev.polygon, prev.x, prev.y)
              );
              if (signedAgainstPrev > contactTol || signedAgainstPrev < -contactTol) {
                shearStats.fail_contact += 1;
                ok = false;
                break;
              }
            }
            placements.push({
              x: x,
              y: y,
              flip: option.flip === true,
              polygon: option.polygon,
              area: Number(dominant[i] && dominant[i].area ? dominant[i].area : (width * height))
            });
          }
          if (!ok) {
            continue;
          }
          const created = finalizeCandidate(placements, 'form38_narrow_v_shear_' + kIn + '_' + optA.key + '-' + optB.key);
          if (created) {
            shearStats.built += 1;
            return true;
          }
          shearStats.fail_finalize += 1;
        }
      }
      return false;
    };

    const tryBuildNarrowVerticalBandFlexible = (kIn: number): boolean => {
      narrowStats.attempts += 1;
      const kStats = {
        k: kIn,
        fail_no_join: 0,
        fail_no_join_no_vec: 0,
        fail_no_join_tx: 0,
        fail_no_join_step: 0,
        fail_no_join_strict: 0,
        fail_no_join_pos: 0,
        fail_no_join_bar: 0,
        fail_overlap: 0,
        fail_contact: 0,
        fail_backtrack: 0,
        fail_finalize: 0,
        built: 0
      };
      const contactTol = 0.12;
      const contactGapTol = 0.35;
      const getPolySpan = (polyIn: any[]): any => {
        const poly = sanitizePolygon(polyIn);
        if (!poly.length) {
          return { w: 0, h: 0 };
        }
        const xs = poly.map(p => Number(p.x)).filter(v => Number.isFinite(v));
        const ys = poly.map(p => Number(p.y)).filter(v => Number.isFinite(v));
        if (!xs.length || !ys.length) {
          return { w: 0, h: 0 };
        }
        return {
          w: Math.max.apply(null, xs) - Math.min.apply(null, xs),
          h: Math.max.apply(null, ys) - Math.min.apply(null, ys)
        };
      };
      const getAbsBBox = (polyAIn: any[], polyBIn: any[]): any => {
        const pts = []
          .concat(Array.isArray(polyAIn) ? polyAIn : [])
          .concat(Array.isArray(polyBIn) ? polyBIn : []);
        const xs = pts.map(p => Number(p && p.x)).filter(v => Number.isFinite(v));
        const ys = pts.map(p => Number(p && p.y)).filter(v => Number.isFinite(v));
        if (!xs.length || !ys.length) {
          return { w: 0, h: 0 };
        }
        return {
          w: Math.max.apply(null, xs) - Math.min.apply(null, xs),
          h: Math.max.apply(null, ys) - Math.min.apply(null, ys)
        };
      };
      const rotatePolygon90ForNarrow = (polyIn: any[]): any[] => {
        return sanitizePolygon(polyIn).map(pt => ({
          x: Number(pt.y),
          y: Number(width) - Number(pt.x)
        }));
      };
      const rotatePolygon90AltForNarrow = (polyIn: any[]): any[] => {
        return sanitizePolygon(polyIn).map(pt => ({
          x: Number(height) - Number(pt.y),
          y: Number(pt.x)
        }));
      };
      const computeInterlockStepXAnyInclined = (prevPolyIn: any[], nextPolyIn: any[]): number | null => {
        const getInclinedLines = (polyIn: any[]): any[] => {
          const poly = sanitizePolygon(polyIn);
          const out = [];
          if (poly.length < 3) {
            return out;
          }
          for (let i = 0; i < poly.length; i++) {
            const p1 = poly[i];
            const p2 = poly[(i + 1) % poly.length];
            const x1 = Number(p1.x);
            const y1 = Number(p1.y);
            const x2 = Number(p2.x);
            const y2 = Number(p2.y);
            const dx = x2 - x1;
            const dy = y2 - y1;
            const len = Math.sqrt((dx * dx) + (dy * dy));
            if (!Number.isFinite(dx) || !Number.isFinite(dy) || len <= eps) {
              continue;
            }
            if (Math.abs(dx) <= eps || Math.abs(dy) <= eps) {
              continue;
            }
            out.push({
              a: dx / dy, // x(y) = a*y + b
              b: x1 - ((dx / dy) * y1),
              yMin: Math.min(y1, y2),
              yMax: Math.max(y1, y2),
              len: len
            });
          }
          return out;
        };

        const prevLines = getInclinedLines(prevPolyIn);
        const nextLines = getInclinedLines(nextPolyIn);
        if (!prevLines.length || !nextLines.length) {
          return null;
        }

        let best = null;
        const slopeTol = 0.002;
        const lenTol = 0.8;
        const lineTol = 0.2;
        for (let i = 0; i < prevLines.length; i++) {
          const pL = prevLines[i];
          for (let j = 0; j < nextLines.length; j++) {
            const nL = nextLines[j];
            if (Math.abs(Number(pL.a) - Number(nL.a)) > slopeTol) {
              continue;
            }
            if (Math.abs(Number(pL.len) - Number(nL.len)) > lenTol) {
              continue;
            }
            const yStart = Math.max(Number(pL.yMin), Number(nL.yMin));
            const yEnd = Math.min(Number(pL.yMax), Number(nL.yMax));
            if (!Number.isFinite(yStart) || !Number.isFinite(yEnd) || (yEnd - yStart) <= eps) {
              continue;
            }

            const stepSigned = Number(pL.b) - Number(nL.b);
            if (!Number.isFinite(stepSigned) || Math.abs(stepSigned) <= eps) {
              continue;
            }
            const shiftedNextB = Number(nL.b) + stepSigned;
            if (Math.abs(Number(pL.b) - shiftedNextB) > lineTol) {
              continue;
            }

            const prevAbs = this.transformPolygon(prevPolyIn, 0, 0);
            const nextAbs = this.transformPolygon(nextPolyIn, stepSigned, 0);
            if (overlapsInteriorConvex(prevAbs, nextAbs)) {
              continue;
            }
            const signed = signedOverlapConvex(prevAbs, nextAbs);
            if (signed > 0.08 || signed < -0.08) {
              continue;
            }

            if (best === null || Math.abs(stepSigned) < Math.abs(best)) {
              best = stepSigned;
            }
          }
        }
        return best;
      };
      const findJoinVectorByScan = (prevPolyIn: any[], nextPolyIn: any[]): any => {
        const prevAbs = this.transformPolygon(prevPolyIn, 0, 0);
        if (!prevAbs.length) {
          return null;
        }
        let best = null;
        const maxDy = Math.min(maxSheetHeightRaw, Math.max(200, height));
        const maxDx = Math.max(width * 2, 800);
        const step = 20;
        for (let dy = step; dy <= maxDy; dy += step) {
          for (let tx = -maxDx; tx <= maxDx; tx += step) {
            const nextAbs = this.transformPolygon(nextPolyIn, tx, dy);
            if (overlapsInteriorConvex(prevAbs, nextAbs)) {
              continue;
            }
            const signed = signedOverlapConvex(prevAbs, nextAbs);
            // contacto casi tangente (sin hueco grande ni solape).
            if (signed > 0.05 || signed < -0.12) {
              continue;
            }
            const pairBox = getAbsBBox(prevAbs, nextAbs);
            if (!(Number(pairBox.w) > 0) || !(Number(pairBox.h) > 0)) {
              continue;
            }
            // Prioriza la unión más compacta por área de bbox, y después
            // menor ancho (lado corto) y menor deriva lateral.
            const score = (Number(pairBox.w) * Number(pairBox.h)) +
              (Number(pairBox.w) * 1000) +
              (Math.abs(tx) * 10) +
              dy;
            if (!best || score < best.score) {
              best = { tx: tx, ty: dy, score: score };
            }
          }
        }
        return best ? { tx: best.tx, ty: best.ty } : null;
      };
      const findJoinVectorByScanAligned = (prevPolyIn: any[], nextPolyIn: any[], txFixedIn: number): any => {
        const prevAbs = this.transformPolygon(prevPolyIn, 0, 0);
        if (!prevAbs.length) {
          return null;
        }
        const txFixed = Number(txFixedIn);
        if (!Number.isFinite(txFixed)) {
          return null;
        }
        let best = null;
        const maxDy = Math.min(maxSheetHeightRaw, Math.max(200, height));
        const stepDy = 10;
        for (let dy = stepDy; dy <= maxDy; dy += stepDy) {
          const nextAbs = this.transformPolygon(nextPolyIn, txFixed, dy);
          if (overlapsInteriorConvex(prevAbs, nextAbs)) {
            continue;
          }
          const signed = signedOverlapConvex(prevAbs, nextAbs);
          if (signed > 0.05 || signed < -0.16) {
            continue;
          }
          const pairBox = getAbsBBox(prevAbs, nextAbs);
          if (!(Number(pairBox.w) > 0) || !(Number(pairBox.h) > 0)) {
            continue;
          }
          const score = (Math.abs(signed) * 1000) + Number(dy);
          if (!best || score < best.score) {
            best = { tx: txFixed, ty: dy, score: score };
          }
        }
        return best ? { tx: best.tx, ty: best.ty } : null;
      };
      const baseOptions = [
        { key: 'base', polygon: basePoly, flip: false },
        { key: 'rot180', polygon: rotated180BasePoly, flip: true }
      ];
      // Para unión vertical por lado corto se prioriza el encaje "extremo-extremo"
      // entre orientación base y giro 180º. Las variantes espejo tienden a crear
      // cuñas laterales (como en los logs) y se excluyen en esta rama.

      const options = baseOptions
        .map(opt => ({
          key: opt.key,
          polygon: sanitizePolygon(opt.polygon),
          flip: opt.flip === true
        }))
        .filter(opt => isUsablePoly(opt.polygon));
      // Prioriza la orientación base para que, al hacer backtracking "first-fit",
      // se pruebe antes la cadena base-rot180 (suele cerrar mejor los extremos).
      options.sort((a, b) => {
        const aBase = a.key === 'base' ? 0 : 1;
        const bBase = b.key === 'base' ? 0 : 1;
        return aBase - bBase;
      });
      if (options.length < 2) {
        return false;
      }

      const chosen = [];
      const backtrack = (idxIn: number): boolean => {
        if (idxIn >= kIn) {
          return true;
        }
        for (let i = 0; i < options.length; i++) {
          const option = options[i];
          const prev = chosen.length > 0 ? chosen[chosen.length - 1] : null;
          if (prev && prev.source_key === option.key) {
            // Para unión extremo-extremo vertical se requiere alternar orientación.
            continue;
          }
          let x = 0;
          let y = 0;
          if (prev) {
            let joinVec = null;
            const joinCandidates = [];
            const stepYBand = computeInterlockStepY(prev.polygon, option.polygon);
            if (Number.isFinite(stepYBand) && Number(stepYBand) > eps) {
              joinCandidates.push({ tx: 0, ty: Number(stepYBand), src: 'band' });
            }
            const joinShort = findNarrowVerticalJoinVector(prev.polygon, option.polygon);
            if (joinShort && Number.isFinite(Number(joinShort.tx)) && Number.isFinite(Number(joinShort.ty))) {
              joinCandidates.push({
                tx: Number(joinShort.tx),
                ty: Number(joinShort.ty),
                src: 'short'
              });
            }
            if (joinCandidates.length > 1) {
              const prevSpanForJoin = getPolySpan(prev.polygon);
              const baseWForJoin = Math.max(1, Number(prevSpanForJoin.w));
              let bestJoin = null;
              joinCandidates.forEach(candidate => {
                const nextAbs = this.transformPolygon(option.polygon, Number(candidate.tx), Number(candidate.ty));
                const prevAbs = this.transformPolygon(prev.polygon, 0, 0);
                const pairBox = getAbsBBox(prevAbs, nextAbs);
                const widthPenalty = Number(pairBox.w) / baseWForJoin;
                const score = (widthPenalty * 1000) + (Number(candidate.ty) * 0.5) + Math.abs(Number(candidate.tx));
                if (!bestJoin || score < bestJoin.score) {
                  bestJoin = {
                    tx: Number(candidate.tx),
                    ty: Number(candidate.ty),
                    score: score
                  };
                }
              });
              if (bestJoin) {
                joinVec = { tx: Number(bestJoin.tx), ty: Number(bestJoin.ty) };
              }
            } else if (joinCandidates.length === 1) {
              joinVec = { tx: Number(joinCandidates[0].tx), ty: Number(joinCandidates[0].ty) };
            }
            if (!joinVec || !Number.isFinite(Number(joinVec.tx)) || !Number.isFinite(Number(joinVec.ty))) {
              // Fallback: estimación por encaje inclinado en espacio rotado.
              const prevRot = rotatePolygon90ForNarrow(prev.polygon);
              const nextRot = rotatePolygon90ForNarrow(option.polygon);
              const stepY = computeInterlockStepXAnyInclined(prevRot, nextRot);
              if (Number.isFinite(stepY) && Math.abs(Number(stepY)) > eps) {
                joinVec = { tx: 0, ty: Math.abs(Number(stepY)) };
              }
            }
            if (!joinVec || !Number.isFinite(Number(joinVec.tx)) || !Number.isFinite(Number(joinVec.ty))) {
              // Fallback rotación alternativa para capturar el eje corto cuando
              // la primera rotación proyecta el paso sobre el eje largo.
              const prevRotAlt = rotatePolygon90AltForNarrow(prev.polygon);
              const nextRotAlt = rotatePolygon90AltForNarrow(option.polygon);
              const stepYAlt = computeInterlockStepXAnyInclined(prevRotAlt, nextRotAlt);
              if (Number.isFinite(stepYAlt) && Math.abs(Number(stepYAlt)) > eps) {
                joinVec = { tx: 0, ty: Math.abs(Number(stepYAlt)) };
              }
            }
            if (!joinVec || !Number.isFinite(Number(joinVec.tx)) || !Number.isFinite(Number(joinVec.ty))) {
              // Fallback adicional: usa paso de encaje inclinado en geometría original
              // y lo proyecta como avance vertical estrecho.
              const stepYFromOriginal = computeInterlockStepXAnyInclined(prev.polygon, option.polygon);
              if (Number.isFinite(stepYFromOriginal) && Math.abs(Number(stepYFromOriginal)) > eps) {
                joinVec = { tx: 0, ty: Math.abs(Number(stepYFromOriginal)) };
              }
            }
            if (!joinVec || !Number.isFinite(Number(joinVec.tx)) || !Number.isFinite(Number(joinVec.ty))) {
              // Último fallback robusto: búsqueda geométrica discreta.
              joinVec = findJoinVectorByScan(prev.polygon, option.polygon);
            }
            if (!joinVec || !Number.isFinite(Number(joinVec.tx)) || !Number.isFinite(Number(joinVec.ty))) {
              narrowStats.fail_no_join += 1;
              kStats.fail_no_join += 1;
              kStats.fail_no_join_no_vec += 1;
              continue;
            }
            // Regla dura para tiras "narrow_v": sin deriva lateral.
            // Se busca un encaje con tx=0 y, si existe, se usa siempre.
            const alignedNoDrift = findJoinVectorByScanAligned(prev.polygon, option.polygon, 0);
            if (alignedNoDrift && Number.isFinite(Number(alignedNoDrift.ty)) && Number(alignedNoDrift.ty) > eps) {
              joinVec = { tx: 0, ty: Number(alignedNoDrift.ty) };
            } else {
              joinVec = { tx: 0, ty: Number(joinVec.ty) };
            }
            const prevSpan = getPolySpan(prev.polygon);
            const lateralTol = Math.max(8, Number(prevSpan.w) * 0.22);
            if (Math.abs(Number(joinVec.tx)) > lateralTol) {
              // Unión vertical por lado estrecho: no se admite deriva lateral grande.
              // Si se permite, aparece el "mini amago" (barra abierta en cuña).
              narrowStats.fail_no_join += 1;
              kStats.fail_no_join += 1;
              kStats.fail_no_join_tx += 1;
              continue;
            }
            const maxUsefulStep = Math.min(maxSheetWidthRaw, maxSheetHeightRaw);
            let minEdgePrev = Number.POSITIVE_INFINITY;
            (sanitizePolygon(prev.polygon) || []).forEach((pt, idxPt, arr) => {
              const nPt = arr[(idxPt + 1) % arr.length];
              const dx = Number(nPt.x) - Number(pt.x);
              const dy = Number(nPt.y) - Number(pt.y);
              const len = Math.sqrt((dx * dx) + (dy * dy));
              if (Number.isFinite(len) && len > eps && len < minEdgePrev) {
                minEdgePrev = len;
              }
            });
            let minEdgeNext = Number.POSITIVE_INFINITY;
            (sanitizePolygon(option.polygon) || []).forEach((pt, idxPt, arr) => {
              const nPt = arr[(idxPt + 1) % arr.length];
              const dx = Number(nPt.x) - Number(pt.x);
              const dy = Number(nPt.y) - Number(pt.y);
              const len = Math.sqrt((dx * dx) + (dy * dy));
              if (Number.isFinite(len) && len > eps && len < minEdgeNext) {
                minEdgeNext = len;
              }
            });
            const minShortEdge = Math.min(
              Number.isFinite(minEdgePrev) ? minEdgePrev : Number.POSITIVE_INFINITY,
              Number.isFinite(minEdgeNext) ? minEdgeNext : Number.POSITIVE_INFINITY
            );
            const shortEdgeCap = Number.isFinite(minShortEdge) && minShortEdge > eps
              ? (minShortEdge * 2.4)
              : Number(height) * 0.8;
            const maxNarrowStep = Math.min(maxUsefulStep, shortEdgeCap);
            if (Number(joinVec.ty) > maxNarrowStep) {
              narrowStats.fail_no_join += 1;
              kStats.fail_no_join += 1;
              kStats.fail_no_join_step += 1;
              continue;
            }
            const prevRotCheck = rotatePolygon90ForNarrow(prev.polygon);
            const nextRotCheck = rotatePolygon90ForNarrow(option.polygon);
            // Validación de unión inclinada:
            // se intenta estricto y, si no pasa, se acepta un fallback
            // siempre que el paso sea estrecho y la geometría no solape.
            const strictJoinY = Math.abs(Number(joinVec.tx)) <= 1.0 &&
              hasExactInclinedJoinY(prev.polygon, option.polygon, Number(joinVec.ty));
            const strictJoin = strictJoinY ||
              hasExactInclinedJoin(prevRotCheck, nextRotCheck, Math.abs(Number(joinVec.ty)));
            if (!strictJoin) {
              kStats.fail_no_join_strict += 1;
            }
            // Evita deriva lateral acumulada: se prueban alternativas de X
            // (normal, espejo y centrada) y se escoge la que minimiza el ancho
            // global de la tira en construcción.
            const tyBase = Number(prev.y) + Number(joinVec.ty);
            const xCandidates = [];
            xCandidates.push(Number(prev.x) + Number(joinVec.tx));
            if (Math.abs(Number(joinVec.tx)) > eps) {
              xCandidates.push(Number(prev.x) - Number(joinVec.tx));
            }
            xCandidates.push(Number(prev.x));
            const uniqueX = xCandidates.filter((xv, idx, arr) => arr.findIndex(v => Math.abs(Number(v) - Number(xv)) <= 0.001) === idx);
            let bestPlacement = null;
            const prevAbsForTry = this.transformPolygon(prev.polygon, Number(prev.x), Number(prev.y));
            uniqueX.forEach(xTry => {
              const yTry = tyBase;
              const polyTry = this.transformPolygon(option.polygon, Number(xTry), Number(yTry));
              if (overlapsInteriorConvex(polyTry, prevAbsForTry)) {
                return;
              }
              const signedTry = signedOverlapConvex(polyTry, prevAbsForTry);
              if (signedTry > contactTol || signedTry < -contactGapTol) {
                return;
              }
              const ptsAll = [];
              chosen.forEach(ch => {
                const abs = this.transformPolygon(ch.polygon, Number(ch.x), Number(ch.y));
                abs.forEach(pt => ptsAll.push(pt));
              });
              polyTry.forEach(pt => ptsAll.push(pt));
              const xsAll = ptsAll.map(pt => Number(pt && pt.x)).filter(v => Number.isFinite(v));
              if (!xsAll.length) {
                return;
              }
              const widthAll = Math.max.apply(null, xsAll) - Math.min.apply(null, xsAll);
              const score = (Number(widthAll) * 1000) + Math.abs(Number(xTry));
              if (!bestPlacement || score < Number(bestPlacement.score)) {
                bestPlacement = {
                  x: Number(xTry),
                  y: Number(yTry),
                  score: Number(score)
                };
              }
            });
            if (bestPlacement) {
              x = Number(bestPlacement.x);
              y = Number(bestPlacement.y);
            } else {
              x = Number(prev.x) + Number(joinVec.tx);
              y = Number(prev.y) + Number(joinVec.ty);
            }
            if (!Number.isFinite(x) || !Number.isFinite(y)) {
              narrowStats.fail_no_join += 1;
              kStats.fail_no_join += 1;
              kStats.fail_no_join_pos += 1;
              continue;
            }
            const prevAbsForBar = this.transformPolygon(prev.polygon, Number(prev.x), Number(prev.y));
            const nextAbsForBar = this.transformPolygon(option.polygon, x, y);
            const pairBox = getAbsBBox(prevAbsForBar, nextAbsForBar);
            const baseW = Math.max(1, Number(prevSpan.w));
            if (Number(pairBox.w) > (baseW * 1.18)) {
              // Garantiza una barra real: el ancho no puede crecer de forma excesiva
              // al apilar por lado estrecho.
              narrowStats.fail_no_join += 1;
              kStats.fail_no_join += 1;
              kStats.fail_no_join_bar += 1;
              continue;
            }
          }
          let polygonAbs = this.transformPolygon(option.polygon, x, y);
          let rejectByOverlap = false;
          const lastChosenIndex = chosen.length - 1;
          for (let z = 0; z < chosen.length; z++) {
            const prevAbs = this.transformPolygon(chosen[z].polygon, chosen[z].x, chosen[z].y);
            const isImmediatePrev = z === lastChosenIndex;
            if (isImmediatePrev) {
              // El par adyacente se valida con contactTol más abajo.
              // Aquí evitamos doble rechazo por pequeñas tolerancias numéricas.
              continue;
            }
            if (overlapsInteriorConvex(polygonAbs, prevAbs)) {
              rejectByOverlap = true;
              break;
            }
            // Misma tolerancia que finalizeCandidate para no aceptar
            // candidatos que luego serán descartados al final.
            if (signedOverlapConvex(polygonAbs, prevAbs) > 0.10) {
              rejectByOverlap = true;
              break;
            }
          }
          if (rejectByOverlap) {
            narrowStats.fail_overlap += 1;
            kStats.fail_overlap += 1;
            continue;
          }
          if (prev) {
            // Control mínimo del par adyacente:
            // se permite hueco/tolerancia, pero no solape positivo.
            const prevAbs = this.transformPolygon(prev.polygon, prev.x, prev.y);
            let signedAgainstPrev = signedOverlapConvex(polygonAbs, prevAbs);
            let hasOverlapWithPrev = overlapsInteriorConvex(polygonAbs, prevAbs) || signedAgainstPrev > contactTol;
            if (hasOverlapWithPrev) {
              // Ajuste fino: desplazar en Y unos mm para evitar micro-solape
              // sin perder la unión por el lado corto.
              const maxNudge = Math.max(20, Math.round(Number(height) * 0.12));
              let solvedByNudge = false;
              for (let nudge = 1; nudge <= maxNudge; nudge++) {
                const yTry = Number(y) + nudge;
                const polyTry = this.transformPolygon(option.polygon, x, yTry);
                const signedTry = signedOverlapConvex(polyTry, prevAbs);
                if (!overlapsInteriorConvex(polyTry, prevAbs) && signedTry <= contactTol) {
                  y = yTry;
                  polygonAbs = polyTry;
                  signedAgainstPrev = signedTry;
                  solvedByNudge = true;
                  break;
                }
              }
              hasOverlapWithPrev = !solvedByNudge;
            }
            if (hasOverlapWithPrev) {
              // Fallback final: recálculo del vector por barrido geométrico.
              // Se usa cuando el vector "ideal" produce solape numérico persistente.
              const joinVecScan = findJoinVectorByScan(prev.polygon, option.polygon);
              if (joinVecScan && Number.isFinite(Number(joinVecScan.tx)) && Number.isFinite(Number(joinVecScan.ty))) {
                const xScan = Number(prev.x) + Number(joinVecScan.tx);
                const yScan = Number(prev.y) + Number(joinVecScan.ty);
                const polyScan = this.transformPolygon(option.polygon, xScan, yScan);
                const signedScan = signedOverlapConvex(polyScan, prevAbs);
                if (!overlapsInteriorConvex(polyScan, prevAbs) && signedScan <= contactTol) {
                  x = xScan;
                  y = yScan;
                  polygonAbs = polyScan;
                  hasOverlapWithPrev = false;
                }
              }
            }
            if (hasOverlapWithPrev) {
              narrowStats.fail_contact += 1;
              kStats.fail_contact += 1;
              continue;
            }
            // Si x/y han cambiado por nudge o scan, se revalida no solape con
            // piezas no adyacentes ya colocadas.
            for (let z = 0; z < chosen.length - 1; z++) {
              const prevOtherAbs = this.transformPolygon(chosen[z].polygon, chosen[z].x, chosen[z].y);
              if (overlapsInteriorConvex(polygonAbs, prevOtherAbs) || signedOverlapConvex(polygonAbs, prevOtherAbs) > 0.10) {
                rejectByOverlap = true;
                break;
              }
            }
            if (rejectByOverlap) {
              narrowStats.fail_overlap += 1;
              kStats.fail_overlap += 1;
              continue;
            }
          }
          chosen.push({
            x: x,
            y: y,
            flip: option.flip === true,
            polygon: option.polygon,
            area: Number(dominant[idxIn] && dominant[idxIn].area ? dominant[idxIn].area : (width * height)),
            source_key: option.key
          });
          if (backtrack(idxIn + 1)) {
            return true;
          }
          chosen.pop();
        }
        return false;
      };

      if (!backtrack(0)) {
        narrowStats.fail_backtrack += 1;
        kStats.fail_backtrack += 1;
        return false;
      }
      const chainKey = chosen.map(item => item.source_key || 'x').join('-');
      const created = finalizeCandidate(chosen, 'form38_narrow_v_flex_' + kIn + '_' + chainKey);
      if (!created) {
        narrowStats.fail_finalize += 1;
        kStats.fail_finalize += 1;
      } else {
        narrowStats.built += 1;
        kStats.built += 1;
      }
      return !!created;
    };

    for (let k = 2; k <= maxK; k++) {
      const builtDet = tryBuildNarrowVerticalByShear(k);
      if (!builtDet) {
        tryBuildNarrowVerticalBandFlexible(k);
      }
    }
    return candidates;
  }

  private isOefPrimitiveGroupCandidate(pieceIn: any, polygonIn: any[], widthIn: number, heightIn: number): boolean {
    if (this.isTriangleLikePiece(pieceIn, polygonIn, widthIn, heightIn)) {
      return true;
    }
    if (this.isForm38Piece(pieceIn)) {
      return true;
    }
    if (!Array.isArray(polygonIn) || polygonIn.length < 3) {
      return false;
    }
    if (this.isRectangleLikePolygon(polygonIn, widthIn, heightIn)) {
      return false;
    }
    return true;
  }

  private runOefPrimitiveSearchBeforeOptimization(): any {
    const settings = this.getOefSettings();
    if (!settings.enabled) {
      this.lastOefPreSearch = null;
      return null;
    }

    const selectedPieces = (this.optimizationList || []).filter(item => item && item.check === true);
    const candidates = selectedPieces.filter(piece => this.isPieceOefCandidate(piece));
    if (!candidates.length) {
      this.lastOefPreSearch = {
        enabled: true,
        has_candidates: false,
        candidate_count: 0,
        primitive_count: 0
      };
      return this.lastOefPreSearch;
    }

    const checkedSheets = (this.sheetList_datafile || []).filter(sheet => sheet && sheet.check === true);
    let maxSheetWidth = 0;
    let maxSheetHeight = 0;
    checkedSheets.forEach(sheet => {
      const w = Number(sheet.width !== undefined ? sheet.width : sheet.sheet_width);
      const h = Number(sheet.height !== undefined ? sheet.height : sheet.sheet_height);
      if (Number.isFinite(w) && w > maxSheetWidth) maxSheetWidth = w;
      if (Number.isFinite(h) && h > maxSheetHeight) maxSheetHeight = h;
    });

    if (maxSheetWidth <= 0 || maxSheetHeight <= 0) {
      maxSheetWidth = 3210;
      maxSheetHeight = 2550;
    }

    const speedProfile = this.getOptimizationSpeedProfile();
    const speedLevel = speedProfile.level || 'fast';
    const speedCfg = speedLevel === 'optimal'
      ? { unit_cap: 24, strategies: ['longest_side', 'area', 'height', 'width'], max_candidates: 18 }
      : (speedLevel === 'medium'
          ? { unit_cap: 14, strategies: ['longest_side', 'area'], max_candidates: 10 }
          : { unit_cap: 8, strategies: ['longest_side'], max_candidates: 6 });

    const expandedBase = [];
    candidates.forEach(piece => {
      const unitsRaw = Number(piece.units);
      const units = Number.isFinite(unitsRaw) && unitsRaw > 0 ? Math.min(speedCfg.unit_cap, Math.round(unitsRaw)) : 1;
      const dims = this.getOefPieceBaseDimensions(piece);
      const w = Number(dims && dims.width);
      const h = Number(dims && dims.height);
      if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
        return;
      }
      const polygon = this.getPiecePolygonTemplate(piece, w, h);
	      const figure = this.getPieceFigureId(piece);
      const genericGroupKey = this.buildOefGenericGroupKey(piece, polygon, w, h);
      const trapGroupKey = this.buildOefTrapezoidGroupKey(polygon, w, h);
      for (let i = 0; i < units; i++) {
        expandedBase.push({
          width: w,
          height: h,
          area: Number.isFinite(Number(piece.area)) && Number(piece.area) > 0 ? Number(piece.area) : w * h,
          polygon: polygon,
          figure: figure,
          group_key: genericGroupKey,
          trap_group_key: trapGroupKey,
          is_triangle: this.isTriangleLikePiece(piece, polygon, w, h),
          is_trapezoid: this.isTrapezoidLikePiece(piece, polygon, w, h),
          is_form38: this.isForm38Piece(piece)
        });
      }
    });

    const sortByStrategy = (itemsIn, strategyIn) => {
      const out = itemsIn.slice();
      if (strategyIn === 'area') {
        out.sort((a, b) => b.area - a.area);
        return out;
      }
      if (strategyIn === 'height') {
        out.sort((a, b) => {
          if (b.height !== a.height) return b.height - a.height;
          return b.area - a.area;
        });
        return out;
      }
      if (strategyIn === 'width') {
        out.sort((a, b) => {
          if (b.width !== a.width) return b.width - a.width;
          return b.area - a.area;
        });
        return out;
      }
      out.sort((a, b) => {
        const aMax = Math.max(a.width, a.height);
        const bMax = Math.max(b.width, b.height);
        if (bMax !== aMax) {
          return bMax - aMax;
        }
        return b.area - a.area;
      });
      return out;
    };

    const buildPrimitives = (itemsIn) => {
      const primitives = [];
      let current = null;
      let cursorY = 0;
      let rowHeight = 0;
      const openPrimitive = () => {
        current = { width: 0, height: 0, used_area: 0, pieces: 0, placements: [] };
        primitives.push(current);
        cursorY = 0;
        rowHeight = 0;
      };
      const place = (itemIn) => {
        const options = itemIn.is_triangle
          ? [
              { w: itemIn.width, h: itemIn.height, polygon: itemIn.polygon, flip: false },
              { w: itemIn.width, h: itemIn.height, polygon: this.mirrorPolygonVertical(itemIn.polygon, itemIn.width), flip: true }
            ]
          : [
              { w: itemIn.width, h: itemIn.height, polygon: itemIn.polygon, flip: false }
            ];

        for (let i = 0; i < options.length; i++) {
          const option = options[i];
          if (option.w > maxSheetWidth || option.h > maxSheetHeight) {
            continue;
          }

          const step = 2;
          for (let x = 0; x + option.w <= maxSheetWidth; x += step) {
            if (cursorY + option.h > maxSheetHeight) {
              continue;
            }

            const polyAbs = this.transformPolygon(option.polygon, x, cursorY);
            let collide = false;
            for (let p = 0; p < current.placements.length; p++) {
              if (this.polygonsOverlap(polyAbs, current.placements[p].polygon_abs || [])) {
                collide = true;
                break;
              }
            }
            if (collide) {
              continue;
            }

            current.used_area += itemIn.area;
            current.pieces += 1;
            current.placements.push({
              x: x,
              y: cursorY,
              w: option.w,
              h: option.h,
              flip: option.flip === true,
              polygon: option.polygon,
              polygon_abs: polyAbs
            });
            current.width = Math.max(current.width, x + option.w);
            current.height = Math.max(current.height, cursorY + option.h);
            rowHeight = Math.max(rowHeight, option.h);
            return true;
          }
        }

        if (rowHeight > 0) {
          cursorY += rowHeight;
          rowHeight = 0;
          return place(itemIn);
        }
        return false;
      };
      itemsIn.forEach(item => {
        if (!current) {
          openPrimitive();
        }
        if (!place(item)) {
          openPrimitive();
          place(item);
        }
      });
      return primitives
        .filter(p => p && Number(p.pieces) > 0 && Number(p.width) > 0 && Number(p.height) > 0 && Array.isArray(p.placements) && p.placements.length > 0)
        .map(p => {
        const area = p.width * p.height;
        const wastePct = area > 0 ? ((area - p.used_area) * 100 / area) : 0;
        return {
          width: Number(p.width.toFixed(2)),
          height: Number(p.height.toFixed(2)),
          pieces: p.pieces,
          waste_pct: Number(wastePct.toFixed(2)),
          placements: (p.placements || []).map(plc => ({
            x: plc.x,
            y: plc.y,
            w: plc.w,
            h: plc.h,
            flip: plc.flip === true,
            polygon: plc.polygon || []
          }))
        };
      });
    };

    const candidateMap = {};
    speedCfg.strategies.forEach(strategy => {
      const sorted = sortByStrategy(expandedBase, strategy);
      const generated = buildPrimitives(sorted);
      generated.forEach(p => {
        const key = p.width + 'x' + p.height + '|' + p.pieces + '|' + p.waste_pct;
        if (!candidateMap[key]) {
          candidateMap[key] = p;
        }
      });
    });

    const triangleCandidates = this.generateTriangleInterlockCandidates(expandedBase);
    triangleCandidates.forEach(p => {
      const key = p.width + 'x' + p.height + '|' + p.pieces + '|' + p.waste_pct + '|' + (p.source || 'triangle');
      if (!candidateMap[key]) {
        candidateMap[key] = p;
      }
    });

    let maxTravForOef = Number(this.calculateMaxTrav());
    if (!(Number.isFinite(maxTravForOef) && maxTravForOef > 0)) {
      maxTravForOef = Number(this.fileForm && this.fileForm.controls && this.fileForm.controls.f_max_diecutting
        ? this.fileForm.controls.f_max_diecutting.value
        : 0);
    }
    const onlyForm38Expanded = expandedBase.length > 0 && expandedBase.every(item => item && item.is_form38 === true);
    let allowMirrorForForm38 = !!(settings && settings.params && settings.params.allow_mirror);

    const form38Candidates = this.generateForm38BandCandidates(
      expandedBase,
      allowMirrorForForm38,
      maxSheetWidth,
      maxSheetHeight,
      maxTravForOef
    );
    form38Candidates.forEach(p => {
      const key = p.width + 'x' + p.height + '|' + p.pieces + '|' + p.waste_pct + '|' + (p.source || 'form38');
      if (!candidateMap[key]) {
        candidateMap[key] = p;
      }
    });

    const trapezoidCandidates = this.generateTrapezoidBandCandidates(expandedBase);
    trapezoidCandidates.forEach(p => {
      const key = p.width + 'x' + p.height + '|' + p.pieces + '|' + p.waste_pct + '|' + (p.source || 'trap');
      if (!candidateMap[key]) {
        candidateMap[key] = p;
      }
    });
    const inputTrapCandidates = this.generateInputTrapezoidBands(candidates);
    inputTrapCandidates.forEach(p => {
      const key = p.width + 'x' + p.height + '|' + p.pieces + '|' + p.waste_pct + '|' + (p.source || 'trap_input');
      if (!candidateMap[key]) {
        candidateMap[key] = p;
      }
    });
    const forcedTrapezoidCandidates = this.generateForcedTrapezoidBands(expandedBase);
    forcedTrapezoidCandidates.forEach(p => {
      const key = p.width + 'x' + p.height + '|' + p.pieces + '|' + p.waste_pct + '|' + (p.source || 'trap_force');
      if (!candidateMap[key]) {
        candidateMap[key] = p;
      }
    });

    const allCandidates = Object.keys(candidateMap)
      .map(k => candidateMap[k])
      .filter(c =>
        c &&
        Number(c.width) > 0 &&
        Number(c.height) > 0 &&
        Number(c.pieces) > 0 &&
        Array.isArray(c.placements) &&
        c.placements.length > 0
      );
    const trianglePinned = allCandidates
      .filter(c => c && c.source && c.source.toString().indexOf('triangle_interlock_') === 0)
      .sort((a, b) => a.pieces - b.pieces);
    const rankedOthers = allCandidates
      .filter(c => !(c && c.source && c.source.toString().indexOf('triangle_interlock_') === 0))
      .sort((a, b) => {
        if (a.waste_pct !== b.waste_pct) return a.waste_pct - b.waste_pct;
        if (b.pieces !== a.pieces) return b.pieces - a.pieces;
        return (a.width * a.height) - (b.width * b.height);
      });

    const primitiveSummary = []
      .concat(trianglePinned)
      .concat(rankedOthers)
      .slice(0, Math.max(speedCfg.max_candidates, trianglePinned.length));

    const onlyTrianglesInBatch = expandedBase.length > 0 && expandedBase.every(item => item && item.is_triangle === true);
    const onlyForm38InBatch = onlyForm38Expanded;
    const hasTrianglesInBatch = expandedBase.some(item => item && item.is_triangle === true);
    const hasForm38InBatch = expandedBase.some(item => item && item.is_form38 === true);
    const hasTrapezoidsInBatch = expandedBase.some(item => item && item.is_trapezoid === true);
    const mixedOefFamilies = Number(hasTrianglesInBatch ? 1 : 0) + Number(hasForm38InBatch ? 1 : 0) + Number(hasTrapezoidsInBatch ? 1 : 0) >= 2;
    const form38Pinned = allCandidates
      .filter(c => c && c.source && c.source.toString().indexOf('form38_') === 0)
      .sort((a, b) => {
        if (a.waste_pct !== b.waste_pct) return a.waste_pct - b.waste_pct;
        if (b.pieces !== a.pieces) return b.pieces - a.pieces;
        return (a.width * a.height) - (b.width * b.height);
      });

    const trapPinned = allCandidates
      .filter(c =>
        c &&
        c.source &&
        (
          c.source.toString().indexOf('trap_band_h_') === 0 ||
          c.source.toString().indexOf('trap_input_h_') === 0 ||
          c.source.toString().indexOf('trap_force_h_') === 0
        )
      )
      .sort((a, b) => {
        if (b.pieces !== a.pieces) return b.pieces - a.pieces;
        if (a.waste_pct !== b.waste_pct) return a.waste_pct - b.waste_pct;
        return (a.width * a.height) - (b.width * b.height);
      });

    const buildForm38Summary = (): any[] => {
      const filtered = form38Pinned.filter(item => {
        if (Number(item && item.pieces) < 2) {
          return false;
        }
        const source = item && item.source ? item.source.toString() : '';
        if (source.indexOf('form38_') !== 0) {
          return false;
        }
        // Sin espejo explícito, se excluyen solo variantes que dependen de mirror.
        if (allowMirrorForForm38 !== true && source.indexOf('_mirror_') >= 0) {
          return false;
        }
        return true;
      });
      const classifyFamily = (sourceIn: string): string => {
        if (sourceIn.indexOf('form38_band_h_') === 0) {
          return 'long';
        }
        if (sourceIn.indexOf('form38_narrow_v_') === 0) {
          return 'short';
        }
        return '';
      };
      const scoreCandidate = (itemIn: any): number => {
        const imp = this.getOefCandidateImprovementPct(itemIn);
        const area = Number(itemIn && itemIn.width ? itemIn.width : 0) * Number(itemIn && itemIn.height ? itemIn.height : 0);
        const waste = Number(itemIn && itemIn.waste_pct !== undefined ? itemIn.waste_pct : 9999);
        let score = 0;
        score += (Number.isFinite(imp) ? imp : 0) * 100000;
        if (Number.isFinite(area) && area > 0) {
          score -= area;
        }
        if (Number.isFinite(waste)) {
          score -= waste;
        }
        return score;
      };
      const availableForm38Units = (expandedBase || []).reduce((acc, item) => {
        if (!item || item.is_form38 !== true) {
          return acc;
        }
        return acc + 1;
      }, 0);
      const maxPiecesByAvailability = Math.min(6, Math.max(0, Math.round(Number(availableForm38Units))));
      const buildDeterministicForm38Families = (): any[] => {
        const seedPiece = (candidates || []).find(p => this.isForm38Piece(p)) || null;
        if (!seedPiece) {
          return [];
        }
        const dims = this.getOefPieceBaseDimensions(seedPiece);
        const L = Number(dims && dims.width);
        const H = Number(dims && dims.height);
        const rawL1 = Number(
          seedPiece && seedPiece.l1 !== undefined && seedPiece.l1 !== null
            ? seedPiece.l1
            : (seedPiece && seedPiece.piece_l1 !== undefined && seedPiece.piece_l1 !== null ? seedPiece.piece_l1 : 0)
        );
        const L1 = Number.isFinite(rawL1) && rawL1 >= 0 ? rawL1 : 0;
        const seedFigure = this.getPieceFigureId(seedPiece);
        const isSeedForm37Family = (seedFigure === 37 || seedFigure === 371);
        if (!(Number.isFinite(L) && L > 0 && Number.isFinite(H) && H > 0)) {
          return [];
        }
        if (maxPiecesByAvailability < 2) {
          return [];
        }
        const stepLong = Math.max(1, L - L1);
        const stepShort = Math.max(1, H - L1);
        const out = [];
        for (let k = 2; k <= maxPiecesByAvailability; k++) {
          const baseArea = k * L * H;

          const longW = Number((L + ((k - 1) * stepLong)).toFixed(2));
          const longH = Number(H.toFixed(2));
          const longArea = longW * longH;
          const longImp = baseArea > 0 ? ((baseArea - longArea) * 100 / baseArea) : 0;
          if (longW > 0 && longH > 0 && longImp > 0) {
            const longPolys = isSeedForm37Family
              ? this.buildInterlockedForm37StripPolygons(seedPiece, k)
              : this.buildSyntheticForm38StripPolygons(longW, longH, k, false);
            const longPts = [];
            longPolys.forEach(poly => (poly || []).forEach(pt => longPts.push(pt)));
            const longXs = longPts.map(pt => Number(pt && pt.x)).filter(v => Number.isFinite(v));
            const longYs = longPts.map(pt => Number(pt && pt.y)).filter(v => Number.isFinite(v));
            const realLongW = longXs.length ? Number((Math.max.apply(null, longXs) - Math.min.apply(null, longXs)).toFixed(2)) : longW;
            const realLongH = longYs.length ? Number((Math.max.apply(null, longYs) - Math.min.apply(null, longYs)).toFixed(2)) : longH;
            const realLongArea = realLongW * realLongH;
            const realLongImp = baseArea > 0 ? ((baseArea - realLongArea) * 100 / baseArea) : longImp;
            out.push({
              width: realLongW,
              height: realLongH,
              pieces: k,
              waste_pct: 0,
              improvement_pct: Number(realLongImp.toFixed(4)),
              join_length_mm: Number(H.toFixed(2)),
              placements: this.polygonsToNormalizedPlacements(longPolys),
              source: 'form38_band_h_det_' + k
            });
          }

          const shortW = Number(L.toFixed(2));
          const shortH = Number((H + ((k - 1) * stepShort)).toFixed(2));
          const shortArea = shortW * shortH;
          const shortImp = baseArea > 0 ? ((baseArea - shortArea) * 100 / baseArea) : 0;
          if (shortW > 0 && shortH > 0 && shortImp > 0) {
            const shortPolys = this.buildSyntheticForm38StripPolygons(shortW, shortH, k, true);
            out.push({
              width: shortW,
              height: shortH,
              pieces: k,
              waste_pct: 0,
              improvement_pct: Number(shortImp.toFixed(4)),
              join_length_mm: Number(stepLong.toFixed(2)),
              placements: this.polygonsToNormalizedPlacements(shortPolys),
              source: 'form38_narrow_v_det_' + k
            });
          }
        }
        return out;
      };

      const bestPositiveByFamilyPieces = {};
      const bestAnyByFamilyPieces = {};
      const deterministic = buildDeterministicForm38Families();
      const pool = deterministic.length > 0 ? deterministic : filtered;
      pool.forEach(item => {
        const source = item && item.source ? item.source.toString() : '';
        const family = classifyFamily(source);
        const pieces = Math.round(Number(item && item.pieces ? item.pieces : 0));
        if (!family || pieces < 2 || pieces > 6) {
          return;
        }
        const improvement = this.getOefCandidateImprovementPct(item);
        const key = family + '|' + pieces;
        if (!bestAnyByFamilyPieces[key] || scoreCandidate(item) > scoreCandidate(bestAnyByFamilyPieces[key])) {
          bestAnyByFamilyPieces[key] = item;
        }
        if (Number.isFinite(improvement) && improvement > 0) {
          if (!bestPositiveByFamilyPieces[key] || scoreCandidate(item) > scoreCandidate(bestPositiveByFamilyPieces[key])) {
            bestPositiveByFamilyPieces[key] = item;
          }
        }
      });

      const picked = [];
      // 5 por lado largo + 5 por lado corto.
      for (let k = 2; k <= 6; k++) {
        const key = 'long|' + k;
        const longCandidate = bestPositiveByFamilyPieces[key] || bestAnyByFamilyPieces[key];
        if (longCandidate) {
          picked.push(longCandidate);
        }
      }
      for (let k = 2; k <= 6; k++) {
        const key = 'short|' + k;
        const shortCandidate = bestPositiveByFamilyPieces[key] || bestAnyByFamilyPieces[key];
        if (shortCandidate) {
          picked.push(shortCandidate);
        }
      }

      return picked;
    };

    const buildTrapSummary = (): any[] => {
      const filtered = trapPinned.filter(item => Number(item && item.pieces) >= 2);
      const realJoined = filtered.filter(item => {
        const src = item && item.source ? item.source.toString() : '';
        return src.indexOf('trap_band_h_') === 0 && src.indexOf('trap_band_h_bbox_') !== 0;
      });
      const sourcePool = realJoined.length > 0 ? realJoined : filtered;
      const picked = [];
      const targetMax = Math.max(speedCfg.max_candidates, 6);
      for (let k = 6; k >= 2; k--) {
        const found = sourcePool.find(item => Number(item && item.pieces) === k);
        if (found && picked.indexOf(found) < 0) {
          picked.push(found);
        }
      }
      sourcePool.forEach(item => {
        if (picked.length >= targetMax) {
          return;
        }
        if (picked.indexOf(item) < 0) {
          picked.push(item);
        }
      });
      if (!picked.length) {
        const forced = this.generateForcedTrapezoidBands(expandedBase)
          .filter(item => Number(item && item.pieces) >= 2)
          .sort((a, b) => Number(b.pieces) - Number(a.pieces));
        forced.forEach(item => {
          if (picked.length >= targetMax) {
            return;
          }
          picked.push(item);
        });
      }
      return picked.slice(0, targetMax);
    };

    const onlyTrapezoidsInBatch = expandedBase.length > 0 && expandedBase.every(item => item && item.is_trapezoid === true);

    const buildTriangleSummary = (): any[] => {
      return trianglePinned
        .filter(item => {
          const pieces = Math.round(Number(item && item.pieces ? item.pieces : 0));
          return pieces === 2 || pieces === 3;
        })
        .slice(0, 2);
    };

    const buildMixedFamiliesSummary = (): any[] => {
      const out = [];
      const map = {};
      const form38Units = expandedBase.filter(item => item && item.is_form38 === true).length;
      const trapezoidUnits = expandedBase.filter(item => item && item.is_trapezoid === true).length;
      const triangleUnits = expandedBase.filter(item => item && item.is_triangle === true).length;
      const pickBestByPieces = (listIn: any[], availableUnitsIn: number): any[] => {
        const maxPieces = Math.max(2, Math.round(Number(availableUnitsIn) || 0));
        const bestByPieces = {};
        const score = (itemIn: any): number => {
          const improvement = Number(this.getOefCandidateImprovementPct(itemIn));
          const waste = Number(itemIn && itemIn.waste_pct !== undefined ? itemIn.waste_pct : 9999);
          const area = Number(itemIn && itemIn.width ? itemIn.width : 0) * Number(itemIn && itemIn.height ? itemIn.height : 0);
          return ((Number.isFinite(improvement) ? improvement : 0) * 1000000) -
            ((Number.isFinite(waste) ? waste : 9999) * 1000) -
            (Number.isFinite(area) ? area : 0);
        };
        (listIn || []).forEach(item => {
          const pieces = Math.round(Number(item && item.pieces ? item.pieces : 0));
          if (pieces < 2 || pieces > maxPieces) {
            return;
          }
          if (!bestByPieces[pieces] || score(item) > score(bestByPieces[pieces])) {
            bestByPieces[pieces] = item;
          }
        });
        return Object.keys(bestByPieces)
          .map(key => Number(key))
          .filter(pieces => Number.isFinite(pieces))
          .sort((a, b) => b - a)
          .map(pieces => bestByPieces[pieces]);
      };
      const addList = (listIn: any[], maxIn: number): void => {
        const list = (listIn || []).slice(0, Math.max(0, maxIn));
        list.forEach(item => {
          if (!item) {
            return;
          }
          const key = Number(item.width).toFixed(2) + 'x' + Number(item.height).toFixed(2) +
            '|' + Number(item.pieces).toFixed(0) + '|' + (item.source ? item.source.toString() : '');
          if (map[key]) {
            return;
          }
          map[key] = true;
          out.push(item);
        });
      };

      if (hasForm38InBatch) {
        const form38List = pickBestByPieces(buildForm38Summary(), form38Units);
        addList(form38List, form38List.length);
      }
      if (hasTrapezoidsInBatch) {
        const trapList = pickBestByPieces(buildTrapSummary(), trapezoidUnits);
        addList(trapList, trapList.length);
      }
      if (hasTrianglesInBatch) {
        const triangleList = pickBestByPieces(buildTriangleSummary(), triangleUnits);
        addList(triangleList, triangleList.length);
      }
      // En mezcla multi-familia se conserva una alternativa por numero de
      // piezas y familia. Asi un cambio de unidades puede ofrecer 4, 5 o 6
      // piezas sin llenar el modal de variantes geometricas equivalentes.
      if (out.length < 1) {
        const fallbackList = pickBestByPieces(primitiveSummary, expandedBase.length);
        addList(fallbackList, fallbackList.length);
      }
      return out;
    };

    const normalizedSummary = onlyTrianglesInBatch && trianglePinned.length > 0
      ? buildTriangleSummary()
      : (onlyForm38InBatch && form38Pinned.length > 0
          ? buildForm38Summary()
          : (onlyTrapezoidsInBatch && trapPinned.length > 0
              ? buildTrapSummary()
              : (mixedOefFamilies
                  ? buildMixedFamiliesSummary()
                  : primitiveSummary)))

    // Garantía trapecios: si el lote es sólo trapecios, nunca devolver resumen de 1 pieza.
    const trapForcedSummary = onlyTrapezoidsInBatch
      ? this.generateForcedTrapezoidBands(expandedBase).filter(item => Number(item && item.pieces) >= 2)
      : [];
    const trapNormalizedSummary = onlyTrapezoidsInBatch
      ? ((normalizedSummary || []).filter(item => Number(item && item.pieces) >= 2))
      : normalizedSummary;
    const finalSummaryRaw = onlyTrapezoidsInBatch
      ? (trapNormalizedSummary.length > 0 ? trapNormalizedSummary : trapForcedSummary)
      : normalizedSummary;

    const validSummary = (finalSummaryRaw || []).filter(item =>
      item &&
      Number(item.width) > 0 &&
      Number(item.height) > 0 &&
      Number(item.pieces) > 0 &&
      Array.isArray(item.placements) &&
      item.placements.length > 0
    );

    const avgWaste = validSummary.length > 0
      ? validSummary.reduce((acc, p) => acc + p.waste_pct, 0) / validSummary.length
      : 0;

    if (!validSummary.length) {
      this.lastOefPreSearch = {
        enabled: true,
        preset: settings.preset,
        phase: settings.params && settings.params.phase ? settings.params.phase : 2,
        benchmark: settings.benchmark === true,
        params: {
          phase: settings && settings.params && settings.params.phase ? settings.params.phase : 2,
          allow_mirror: allowMirrorForForm38
        },
        speed_level: speedLevel,
        has_candidates: false,
        candidate_count: candidates.length,
        expanded_count: expandedBase.length,
        primitive_count: 0,
        avg_waste_pct: 0,
        primitives: []
      };
      return this.lastOefPreSearch;
    }

    this.lastOefPreSearch = {
      enabled: true,
      preset: settings.preset,
      phase: settings.params && settings.params.phase ? settings.params.phase : 2,
      benchmark: settings.benchmark === true,
      params: {
        phase: settings && settings.params && settings.params.phase ? settings.params.phase : 2,
        allow_mirror: allowMirrorForForm38
      },
      speed_level: speedLevel,
      has_candidates: true,
      candidate_count: candidates.length,
      expanded_count: expandedBase.length,
      primitive_count: validSummary.length,
      avg_waste_pct: Number(avgWaste.toFixed(2)),
      primitives: validSummary
    };
    return this.lastOefPreSearch;
  }

  getOefCandidateImprovementPct(itemIn: any): number {
    const toNumber = (valueIn: any): number => {
      if (valueIn === undefined || valueIn === null) {
        return NaN;
      }
      if (typeof valueIn === 'number') {
        return Number.isFinite(valueIn) ? valueIn : NaN;
      }
      const txt = valueIn.toString().trim().replace('%', '').replace(',', '.');
      const parsed = Number(txt);
      return Number.isFinite(parsed) ? parsed : NaN;
    };
    const polygonAreaAbs = (polyIn: any[]): number => {
      if (!Array.isArray(polyIn) || polyIn.length < 3) {
        return 0;
      }
      let sum = 0;
      for (let i = 0; i < polyIn.length; i++) {
        const a = polyIn[i];
        const b = polyIn[(i + 1) % polyIn.length];
        const ax = Number(a && a.x);
        const ay = Number(a && a.y);
        const bx = Number(b && b.x);
        const by = Number(b && b.y);
        if (!Number.isFinite(ax) || !Number.isFinite(ay) || !Number.isFinite(bx) || !Number.isFinite(by)) {
          return 0;
        }
        sum += (ax * by) - (bx * ay);
      }
      return Math.abs(sum) / 2;
    };
    const polygonBBoxArea = (polyIn: any[]): number => {
      if (!Array.isArray(polyIn) || polyIn.length < 3) {
        return 0;
      }
      const xs = polyIn.map(pt => Number(pt && pt.x)).filter(v => Number.isFinite(v));
      const ys = polyIn.map(pt => Number(pt && pt.y)).filter(v => Number.isFinite(v));
      if (!xs.length || !ys.length) {
        return 0;
      }
      const w = Math.max.apply(null, xs) - Math.min.apply(null, xs);
      const h = Math.max.apply(null, ys) - Math.min.apply(null, ys);
      if (!(w > 0) || !(h > 0)) {
        return 0;
      }
      return w * h;
    };
    const primitiveW = Number(itemIn && itemIn.width);
    const primitiveH = Number(itemIn && itemIn.height);
    const placements = itemIn && Array.isArray(itemIn.placements) ? itemIn.placements : [];
    if (Number.isFinite(primitiveW) && Number.isFinite(primitiveH) && primitiveW > 0 && primitiveH > 0 && placements.length > 0) {
      // Mejora respecto a optimizador ordinario (suma de bounding-boxes por pieza).
      const baselineBBoxArea = placements.reduce((acc, pl) => {
        const pw = Number(pl && pl.w);
        const ph = Number(pl && pl.h);
        if (Number.isFinite(pw) && pw > 0 && Number.isFinite(ph) && ph > 0) {
          return acc + (pw * ph);
        }
        const polyBBox = polygonBBoxArea(Array.isArray(pl && pl.polygon) ? pl.polygon : []);
        if (Number.isFinite(polyBBox) && polyBBox > 0) {
          return acc + polyBBox;
        }
        return acc;
      }, 0);
      const primitiveBBoxArea = primitiveW * primitiveH;
      if (Number.isFinite(baselineBBoxArea) && baselineBBoxArea > 0 && Number.isFinite(primitiveBBoxArea) && primitiveBBoxArea > 0) {
        return Number((((baselineBBoxArea - primitiveBBoxArea) * 100) / baselineBBoxArea).toFixed(2));
      }
      // Fallback: mejora geométrica por área real de las figuras.
      const baselineRealArea = placements.reduce((acc, pl) => {
        const explicitArea = Number(pl && pl.area);
        if (Number.isFinite(explicitArea) && explicitArea > 0) {
          return acc + explicitArea;
        }
        const polyArea = polygonAreaAbs(Array.isArray(pl && pl.polygon) ? pl.polygon : []);
        if (Number.isFinite(polyArea) && polyArea > 0) {
          return acc + polyArea;
        }
        return acc;
      }, 0);
      if (Number.isFinite(baselineRealArea) && baselineRealArea > 0) {
        return Number((((baselineRealArea - primitiveBBoxArea) * 100) / baselineRealArea).toFixed(2));
      }
    }
    const imp = toNumber(itemIn && itemIn.improvement_pct);
    if (Number.isFinite(imp)) {
      return imp;
    }
    return 0;
  }

  getOefCandidateJoinLengthMm(itemIn: any): number {
    const src = itemIn && itemIn.source ? itemIn.source.toString() : '';
    if (
      src.indexOf('trap_band_h_bbox_') === 0 ||
      src.indexOf('trap_force_h_') === 0 ||
      src.indexOf('trap_input_h_') === 0
    ) {
      return 0;
    }
    const explicit = Number(itemIn && itemIn.join_length_mm);
    if (Number.isFinite(explicit) && explicit > 0) {
      return Number(explicit.toFixed(2));
    }
    const placements = itemIn && Array.isArray(itemIn.placements) ? itemIn.placements : [];
    if (placements.length >= 2) {
      const getSpan = (plIn: any): any => {
        const poly = plIn && Array.isArray(plIn.polygon) ? plIn.polygon : [];
        if (poly.length >= 3) {
          const xs = poly.map(pt => Number(pt && pt.x)).filter(v => Number.isFinite(v));
          const ys = poly.map(pt => Number(pt && pt.y)).filter(v => Number.isFinite(v));
          if (xs.length > 0 && ys.length > 0) {
            const w = Math.max.apply(null, xs) - Math.min.apply(null, xs);
            const h = Math.max.apply(null, ys) - Math.min.apply(null, ys);
            if (w > 0 && h > 0) {
              return { w: Number(w), h: Number(h) };
            }
          }
        }
        const w = Number(plIn && plIn.w);
        const h = Number(plIn && plIn.h);
        return {
          w: Number.isFinite(w) && w > 0 ? w : 0,
          h: Number.isFinite(h) && h > 0 ? h : 0
        };
      };
      const spanA = getSpan(placements[0]);
      const spanB = getSpan(placements[1]);
      const ax = Number(placements[0] && placements[0].x) + (Number(spanA.w) / 2);
      const ay = Number(placements[0] && placements[0].y) + (Number(spanA.h) / 2);
      const bx = Number(placements[1] && placements[1].x) + (Number(spanB.w) / 2);
      const by = Number(placements[1] && placements[1].y) + (Number(spanB.h) / 2);
      const dx = Math.abs(Number(bx) - Number(ax));
      const dy = Math.abs(Number(by) - Number(ay));
      const join = dx >= dy ? Number(spanA.h) : Number(spanA.w);
      if (Number.isFinite(join) && join > 0) {
        return Number(join.toFixed(2));
      }
    }
    const w = Number(itemIn && itemIn.width);
    const h = Number(itemIn && itemIn.height);
    if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
      return Number(Math.min(w, h).toFixed(2));
    }
    return 0;
  }

  private promptOefCandidatesSelection(preSearchIn: any): Promise<boolean> {
    return new Promise(resolve => {
      this.oefCandidateList = preSearchIn && preSearchIn.primitives ? preSearchIn.primitives : [];
      this.oefCandidateSelectionMap = {};
      let hasPositiveImprovement = false;
      this.oefCandidateList.forEach((item, index) => {
        this.applyStoredOefCandidateBorders(item);
        const improvement = this.getOefCandidateImprovementPct(item);
        const checkedByImprovement = Number.isFinite(improvement) && improvement > 0;
        this.oefCandidateSelectionMap[index] = checkedByImprovement;
        if (checkedByImprovement) {
          hasPositiveImprovement = true;
        }
      });
      if (this.oefCandidateList.length > 0 && !hasPositiveImprovement) {
        this.oefCandidateSelectionMap[0] = true;
      }
      console.log('[OEF modal] auto-selection:', this.oefCandidateList.map((item, index) => ({
        index: index,
        pieces: Number(item && item.pieces ? item.pieces : 0),
        source: item && item.source ? item.source : '',
        improvement_pct: item && item.improvement_pct !== undefined ? item.improvement_pct : null,
        waste_pct: item && item.waste_pct !== undefined ? item.waste_pct : null,
        displayed_improvement: this.getOefCandidateImprovementPct(item),
        checked: this.oefCandidateSelectionMap[index] === true
      })));
      this.oefCandidateSelectedIndex = this.oefCandidateList.length > 0 ? 0 : -1;
      this.oefSelectedCandidate = this.oefCandidateSelectedIndex >= 0 ? this.oefCandidateList[this.oefCandidateSelectedIndex] : null;
      this.oefCandidatesResolver = resolve;
      this.oefCandidatesModal = true;
    });
  }

  showOefCandidatesModal(value: boolean): void {
    this.oefCandidatesModal = value;
  }

  selectOefCandidate(indexIn: number): void {
    this.oefCandidateSelectedIndex = indexIn;
    this.oefSelectedCandidate = (indexIn >= 0 && indexIn < this.oefCandidateList.length)
      ? this.oefCandidateList[indexIn]
      : null;
  }

  toggleOefCandidateSelection(indexIn: number, eventIn: any): void {
    const checked = !!(eventIn && eventIn.target && eventIn.target.checked);
    this.oefCandidateSelectionMap[indexIn] = checked;
    this.selectOefCandidate(indexIn);
  }

  areAllOefCandidatesChecked(): boolean {
    const total = Array.isArray(this.oefCandidateList) ? this.oefCandidateList.length : 0;
    if (total < 1) {
      return false;
    }
    for (let i = 0; i < total; i++) {
      if (this.oefCandidateSelectionMap[i] !== true) {
        return false;
      }
    }
    return true;
  }

  toggleAllOefCandidates(eventIn: any): void {
    const checked = !!(eventIn && eventIn.target && eventIn.target.checked);
    const total = Array.isArray(this.oefCandidateList) ? this.oefCandidateList.length : 0;
    for (let i = 0; i < total; i++) {
      this.oefCandidateSelectionMap[i] = checked;
    }
    if (checked && total > 0 && this.oefCandidateSelectedIndex < 0) {
      this.selectOefCandidate(0);
    }
  }

  private getSelectedOefCandidates(): any[] {
    return (this.oefCandidateList || []).filter((item, index) => this.oefCandidateSelectionMap[index] === true);
  }

  cancelOefCandidatesModal(): void {
    this.oefCandidatesModal = false;
    if (this.oefCandidatesResolver) {
      const resolver = this.oefCandidatesResolver;
      this.oefCandidatesResolver = null;
      resolver(false);
    }
  }

  confirmOefCandidatesModal(): void {
    this.oefCandidatesModal = false;
    if (this.lastOefPreSearch) {
      const selectedMany = this.getSelectedOefCandidates();
      selectedMany.forEach(item => this.rememberOefCandidateBorders(item));
      this.lastOefPreSearch.selected_index = this.oefCandidateSelectedIndex;
      this.lastOefPreSearch.selected_primitive = this.oefSelectedCandidate;
      this.lastOefPreSearch.selected_primitives = selectedMany;
    }
    if (this.oefCandidatesResolver) {
      const resolver = this.oefCandidatesResolver;
      this.oefCandidatesResolver = null;
      resolver(true);
    }
  }

  getSelectedOefPrimitivePreviewData(): any {
    const primitive = this.oefSelectedCandidate;
    if (!primitive) {
      return null;
    }

    const baseW = Number(primitive.width);
    const baseH = Number(primitive.height);
    const borders = this.getOefPrimitiveBorders(primitive);
    const w = baseW + borders.b1 + borders.b3;
    const h = baseH + borders.b2 + borders.b4;
    if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
      return null;
    }

    const svgW = 680;
    const svgH = 390;
    const margin = 18;
    const drawW = Math.max(1, svgW - (margin * 2));
    const drawH = Math.max(1, svgH - (margin * 2));
    const scale = Math.min(drawW / w, drawH / h);
    const sheetW = w * scale;
    const sheetH = h * scale;
    const sheetX = (svgW - sheetW) / 2;
    const sheetY = (svgH - sheetH) / 2;
    return {
      svgW: svgW,
      svgH: svgH,
      sheetX: sheetX,
      sheetY: sheetY,
      sheetW: sheetW,
      sheetH: sheetH,
      scale: scale,
      oefOffsetX: borders.b1,
      oefOffsetY: borders.b2,
      auxSegments: this.buildOefAuxiliaryBorderSegments(w, h, borders),
      placements: primitive.placements || []
    };
  }

  getOefPlacementPolygonPoints(previewIn: any, placementIn: any): string {
    if (!previewIn || !placementIn || !Array.isArray(placementIn.polygon) || placementIn.polygon.length < 3) {
      return '';
    }
    return placementIn.polygon.map(point => {
      const x = previewIn.sheetX + ((Number(previewIn.oefOffsetX || 0) + Number(placementIn.x || 0) + Number(point.x || 0)) * Number(previewIn.scale || 1));
      const y = previewIn.sheetY + ((Number(previewIn.oefOffsetY || 0) + Number(placementIn.y || 0) + Number(point.y || 0)) * Number(previewIn.scale || 1));
      return x + ',' + y;
    }).join(' ');
  }

  isOefCandidateChecked(indexIn: number): boolean {
    return this.oefCandidateSelectionMap && this.oefCandidateSelectionMap[indexIn] === true;
  }

  getOefSelectedCount(): number {
    return this.getSelectedOefCandidates().length;
  }

  private enforceParallelogramForForm37(polyIn: any[], widthIn: number, heightIn: number): any[] {
    if (!Array.isArray(polyIn) || polyIn.length < 4) {
      return polyIn;
    }
    let poly = polyIn
      .map(pt => ({ x: Number(pt && pt.x), y: Number(pt && pt.y) }))
      .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y));
    if (poly.length === 5) {
      const first = poly[0];
      const last = poly[poly.length - 1];
      if (Math.abs(first.x - last.x) <= 0.000001 && Math.abs(first.y - last.y) <= 0.000001) {
        poly = poly.slice(0, 4);
      }
    }
    if (poly.length !== 4) {
      return polyIn;
    }
    const cross = (a: any, b: any, c: any, d: any): number =>
      ((Number(b.x) - Number(a.x)) * (Number(d.y) - Number(c.y))) -
      ((Number(b.y) - Number(a.y)) * (Number(d.x) - Number(c.x)));
    const span = Math.max(
      1,
      Math.abs(poly[1].x - poly[0].x), Math.abs(poly[1].y - poly[0].y),
      Math.abs(poly[2].x - poly[1].x), Math.abs(poly[2].y - poly[1].y),
      Math.abs(poly[3].x - poly[2].x), Math.abs(poly[3].y - poly[2].y),
      Math.abs(poly[0].x - poly[3].x), Math.abs(poly[0].y - poly[3].y)
    );
    const tol = span * 0.0005;
    const oppAParallel = Math.abs(cross(poly[0], poly[1], poly[3], poly[2])) <= tol;
    const oppBParallel = Math.abs(cross(poly[1], poly[2], poly[0], poly[3])) <= tol;
    if (oppAParallel && oppBParallel) {
      return poly;
    }

    const buildCandidate = (moveIndex: number): any[] => {
      const out = poly.map(pt => ({ x: pt.x, y: pt.y }));
      if (moveIndex === 0) out[0] = { x: out[1].x + out[3].x - out[2].x, y: out[1].y + out[3].y - out[2].y };
      else if (moveIndex === 1) out[1] = { x: out[0].x + out[2].x - out[3].x, y: out[0].y + out[2].y - out[3].y };
      else if (moveIndex === 2) out[2] = { x: out[1].x + out[3].x - out[0].x, y: out[1].y + out[3].y - out[0].y };
      else out[3] = { x: out[0].x + out[2].x - out[1].x, y: out[0].y + out[2].y - out[1].y };
      return out;
    };
    const minX = -0.000001;
    const minY = -0.000001;
    const maxX = Number(widthIn) + 0.000001;
    const maxY = Number(heightIn) + 0.000001;
    const inBounds = (pt: any): boolean => pt.x >= minX && pt.x <= maxX && pt.y >= minY && pt.y <= maxY;
    const priorities = [2, 1, 0, 3];
    let best: any = null;
    priorities.forEach((idx) => {
      const candidate = buildCandidate(idx);
      const moved = candidate[idx];
      const ref = poly[idx];
      const moveScore = Math.abs(moved.x - ref.x) + Math.abs(moved.y - ref.y);
      const allFinite = candidate.every(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y));
      const inside = allFinite && candidate.every(inBounds);
      if (!allFinite) {
        return;
      }
      const rank = inside ? 0 : 1;
      if (!best || rank < best.rank || (rank === best.rank && moveScore < best.moveScore)) {
        best = { rank: rank, moveScore: moveScore, candidate: candidate };
      }
    });
    return best ? best.candidate : poly;
  }

  private snapInterlockedForm37Polygons(polygonsIn: any[], widthIn: number): any[] {
    const polys = (Array.isArray(polygonsIn) ? polygonsIn : [])
      .map(poly => (Array.isArray(poly) ? poly : [])
        .map(pt => ({ x: Number(pt && pt.x), y: Number(pt && pt.y) }))
        .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y)))
      .filter(poly => poly.length >= 3);
    if (polys.length < 2) {
      return polys;
    }

    const eps = 0.0001;
    const edgeLine = (polyIn: any[], sideIn: 'left' | 'right'): any => {
      let best = null;
      for (let i = 0; i < polyIn.length; i++) {
        const p1 = polyIn[i];
        const p2 = polyIn[(i + 1) % polyIn.length];
        const dx = Number(p2.x) - Number(p1.x);
        const dy = Number(p2.y) - Number(p1.y);
        if (!Number.isFinite(dx) || !Number.isFinite(dy) || Math.abs(dx) <= eps || Math.abs(dy) <= eps) {
          continue;
        }
        const midX = (Number(p1.x) + Number(p2.x)) / 2;
        if (!best || (sideIn === 'right' && midX > best.midX) || (sideIn === 'left' && midX < best.midX)) {
          best = { p1: p1, p2: p2, midX: midX };
        }
      }
      if (!best) {
        return null;
      }
      const dy = Number(best.p2.y) - Number(best.p1.y);
      if (Math.abs(dy) <= eps) {
        return null;
      }
      const a = (Number(best.p2.x) - Number(best.p1.x)) / dy;
      const b = Number(best.p1.x) - (a * Number(best.p1.y));
      return {
        a: a,
        b: b,
        yMin: Math.min(Number(best.p1.y), Number(best.p2.y)),
        yMax: Math.max(Number(best.p1.y), Number(best.p2.y))
      };
    };

    const sorted = polys.slice().sort((a, b) => {
      const ax = Math.min.apply(null, a.map(pt => Number(pt.x)));
      const bx = Math.min.apply(null, b.map(pt => Number(pt.x)));
      return ax - bx;
    });
    const maxSnap = Math.max(40, Number(widthIn || 0) * 0.12);
    const out = [sorted[0].map(pt => ({ x: Number(pt.x), y: Number(pt.y) }))];

    for (let i = 1; i < sorted.length; i++) {
      let current = sorted[i].map(pt => ({ x: Number(pt.x), y: Number(pt.y) }));
      const prev = out[out.length - 1];
      const prevRight = edgeLine(prev, 'right');
      const currLeft = edgeLine(current, 'left');
      if (prevRight && currLeft && Math.abs(Number(prevRight.a) - Number(currLeft.a)) <= 0.002) {
        const y0 = Math.max(Number(prevRight.yMin), Number(currLeft.yMin));
        const y1 = Math.min(Number(prevRight.yMax), Number(currLeft.yMax));
        if (Number.isFinite(y0) && Number.isFinite(y1) && (y1 - y0) > eps) {
          const yMid = (y0 + y1) / 2;
          const prevX = (Number(prevRight.a) * yMid) + Number(prevRight.b);
          const currX = (Number(currLeft.a) * yMid) + Number(currLeft.b);
          const dx = prevX - currX;
          if (Number.isFinite(dx) && Math.abs(dx) <= maxSnap) {
            current = current.map(pt => ({ x: Number(pt.x) + dx, y: Number(pt.y) }));
          }
        }
      }
      out.push(current);
    }

    return out;
  }

  private getOefTransformedGeometry(drawIn: any): any {
    const polygons = drawIn && Array.isArray(drawIn.oef_internal_polygons) ? drawIn.oef_internal_polygons : [];
    if (!polygons.length || !drawIn || !Array.isArray(drawIn.points) || drawIn.points.length < 4) {
      return null;
    }

    const xs = drawIn.points.map(p => Number(p && p.x)).filter(v => Number.isFinite(v));
    const ys = drawIn.points.map(p => Number(p && p.y)).filter(v => Number.isFinite(v));
    if (!xs.length || !ys.length) {
      return null;
    }

    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const width = Math.max.apply(null, xs) - minX;
    const height = Math.max.apply(null, ys) - minY;
    if (!(width > 0) || !(height > 0)) {
      return null;
    }

    const primitiveW = Number(drawIn.oef_primitive_w || width);
    const primitiveH = Number(drawIn.oef_primitive_h || height);
    let b1 = Number(drawIn.oef_primitive_b1 || drawIn.piece_oef_primitive_b1 || 0);
    let b2 = Number(drawIn.oef_primitive_b2 || drawIn.piece_oef_primitive_b2 || 0);
    let b3 = Number(drawIn.oef_primitive_b3 || drawIn.piece_oef_primitive_b3 || 0);
    let b4 = Number(drawIn.oef_primitive_b4 || drawIn.piece_oef_primitive_b4 || 0);
    const rawOefPts = [];
    polygons.forEach(poly => (Array.isArray(poly) ? poly : []).forEach(pt => rawOefPts.push(pt)));
    let rawMinX = 0;
    let rawMaxX = primitiveW;
    let rawMinY = 0;
    let rawMaxY = primitiveH;
    if (rawOefPts.length > 0) {
      const rawXs = rawOefPts.map(pt => Number(pt && pt.x)).filter(v => Number.isFinite(v));
      const rawYs = rawOefPts.map(pt => Number(pt && pt.y)).filter(v => Number.isFinite(v));
      if (rawXs.length > 0 && rawYs.length > 0) {
        rawMinX = Math.min.apply(null, rawXs);
        rawMaxX = Math.max.apply(null, rawXs);
        rawMinY = Math.min.apply(null, rawYs);
        rawMaxY = Math.max.apply(null, rawYs);
        if (!(b1 > 0) && rawMinX > 0.5) { b1 = rawMinX; }
        if (!(b2 > 0) && rawMinY > 0.5) { b2 = rawMinY; }
        if (!(b3 > 0) && (primitiveW - rawMaxX) > 0.5) { b3 = primitiveW - rawMaxX; }
        if (!(b4 > 0) && (primitiveH - rawMaxY) > 0.5) { b4 = primitiveH - rawMaxY; }
      }
    }
    const rotation = ((((Number(drawIn.rotation) || 0) % 360) + 360) % 360);
    const rotatePoint = (ptIn: any): any => {
      const x = Number(ptIn && ptIn.x);
      const y = Number(ptIn && ptIn.y);
      if (!Number.isFinite(x) || !Number.isFinite(y)) {
        return { x: 0, y: 0 };
      }
      if (rotation === 90) { return { x: primitiveH - y, y: x }; }
      if (rotation === 180) { return { x: primitiveW - x, y: primitiveH - y }; }
      if (rotation === 270) { return { x: y, y: primitiveW - x }; }
      return { x: x, y: y };
    };

    let transformedPolygonsRaw = (Array.isArray(polygons) ? polygons : [])
      .map(poly => {
        if (!Array.isArray(poly)) {
          return null;
        }
        const rotated = poly
          .map(p => rotatePoint(p))
          .filter(pt => Number.isFinite(Number(pt.x)) && Number.isFinite(Number(pt.y)));
        return rotated.length >= 3 ? rotated : null;
      })
      .filter(poly => Array.isArray(poly) && poly.length >= 3);

    const auxSegmentsRaw = [];
    const addAuxSegment = (aIn: any, bIn: any): void => {
      const a = rotatePoint(aIn);
      const b = rotatePoint(bIn);
      if (Number.isFinite(Number(a.x)) && Number.isFinite(Number(a.y)) && Number.isFinite(Number(b.x)) && Number.isFinite(Number(b.y))) {
        auxSegmentsRaw.push({ a: a, b: b });
      }
    };
    if (b1 > 0 && b1 < primitiveW) {
      addAuxSegment({ x: b1, y: 0 }, { x: b1, y: primitiveH });
    }
    if (b2 > 0 && b2 < primitiveH) {
      addAuxSegment({ x: 0, y: b2 }, { x: primitiveW, y: b2 });
    }
    if (b3 > 0 && (primitiveW - b3) > 0) {
      addAuxSegment({ x: primitiveW - b3, y: 0 }, { x: primitiveW - b3, y: primitiveH });
    }
    if (b4 > 0 && (primitiveH - b4) > 0) {
      addAuxSegment({ x: 0, y: primitiveH - b4 }, { x: primitiveW, y: primitiveH - b4 });
    }
    if (!transformedPolygonsRaw.length) {
      return null;
    }

    const allPts = [];
    [
      { x: 0, y: 0 },
      { x: primitiveW, y: 0 },
      { x: primitiveW, y: primitiveH },
      { x: 0, y: primitiveH }
    ].map(pt => rotatePoint(pt)).forEach(pt => allPts.push(pt));
    transformedPolygonsRaw.forEach(poly => poly.forEach(pt => allPts.push(pt)));
    const allX = allPts.map(pt => Number(pt && pt.x)).filter(v => Number.isFinite(v));
    const allY = allPts.map(pt => Number(pt && pt.y)).filter(v => Number.isFinite(v));
    if (!allX.length || !allY.length) {
      return null;
    }

    const minPolyX = Math.min.apply(null, allX);
    const maxPolyX = Math.max.apply(null, allX);
    const minPolyY = Math.min.apply(null, allY);
    const maxPolyY = Math.max.apply(null, allY);
    const spanX = Math.max(0.000001, maxPolyX - minPolyX);
    const spanY = Math.max(0.000001, maxPolyY - minPolyY);
    const needsFit = (spanX > (width + 0.001)) || (spanY > (height + 0.001));
    const s = needsFit ? Math.min(width / spanX, height / spanY) : 1;
    const offX = (width - (spanX * s)) / 2;
    const offY = (height - (spanY * s)) / 2;

    const transformedPolygons = transformedPolygonsRaw.map(poly => poly.map(pt => ({
      x: ((Number(pt.x) - minPolyX) * s) + offX,
      y: ((Number(pt.y) - minPolyY) * s) + offY
    })));
    const auxSegments = auxSegmentsRaw.map(seg => ({
      a: {
        x: ((Number(seg.a.x) - minPolyX) * s) + offX,
        y: ((Number(seg.a.y) - minPolyY) * s) + offY
      },
      b: {
        x: ((Number(seg.b.x) - minPolyX) * s) + offX,
        y: ((Number(seg.b.y) - minPolyY) * s) + offY
      }
    })).filter(seg =>
      Number.isFinite(Number(seg.a.x)) && Number.isFinite(Number(seg.a.y)) &&
      Number.isFinite(Number(seg.b.x)) && Number.isFinite(Number(seg.b.y))
    );

    return {
      minX: minX,
      minY: minY,
      width: width,
      height: height,
      polygons: transformedPolygons,
      auxSegments: auxSegments
    };
  }

  private normalizeOefCompositeCanvasBox(drawIn: any, sheetWidthIn: number, sheetHeightIn: number): void {
    if (!drawIn || !Array.isArray(drawIn.points) || drawIn.points.length < 4) {
      return;
    }
    if (!(drawIn.oef_generated === true || (Array.isArray(drawIn.oef_internal_polygons) && drawIn.oef_internal_polygons.length > 0))) {
      return;
    }

    const primitiveW = Number(drawIn.oef_primitive_w || drawIn.piece_oef_primitive_w || 0);
    const primitiveH = Number(drawIn.oef_primitive_h || drawIn.piece_oef_primitive_h || 0);
    if (!(Number.isFinite(primitiveW) && primitiveW > 0 && Number.isFinite(primitiveH) && primitiveH > 0)) {
      return;
    }

    const xs = drawIn.points.map(p => Number(p && p.x)).filter(v => Number.isFinite(v));
    const ys = drawIn.points.map(p => Number(p && p.y)).filter(v => Number.isFinite(v));
    if (!xs.length || !ys.length) {
      return;
    }

    const minX = Math.min.apply(null, xs);
    const maxX = Math.max.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxY = Math.max.apply(null, ys);
    const currentW = maxX - minX;
    const currentH = maxY - minY;
    if (!(currentW > 0 && currentH > 0)) {
      return;
    }

    const rotation = ((((Number(drawIn.rotation) || 0) % 360) + 360) % 360);
    const targetW = (rotation === 90 || rotation === 270) ? primitiveH : primitiveW;
    const targetH = (rotation === 90 || rotation === 270) ? primitiveW : primitiveH;
    const tolerance = 0.5;
    if (Math.abs(currentW - targetW) <= tolerance && Math.abs(currentH - targetH) <= tolerance) {
      return;
    }

    const sheetW = Number(sheetWidthIn);
    const sheetH = Number(sheetHeightIn);
    const keepRight = Number.isFinite(sheetW) && Math.abs(sheetW - maxX) < Math.abs(minX);
    const keepBottom = Number.isFinite(sheetH) && Math.abs(sheetH - maxY) < Math.abs(minY);
    const nextMinX = keepRight ? (maxX - targetW) : minX;
    const nextMaxX = keepRight ? maxX : (minX + targetW);
    const nextMinY = keepBottom ? (maxY - targetH) : minY;
    const nextMaxY = keepBottom ? maxY : (minY + targetH);

    if (![nextMinX, nextMaxX, nextMinY, nextMaxY].every(v => Number.isFinite(v))) {
      return;
    }

    drawIn.points = [
      { x: nextMinX, y: nextMinY },
      { x: nextMaxX, y: nextMinY },
      { x: nextMaxX, y: nextMaxY },
      { x: nextMinX, y: nextMaxY }
    ];
  }

  private isPointInsidePolygon(xIn: number, yIn: number, polygonIn: any[]): boolean {
    if (!Array.isArray(polygonIn) || polygonIn.length < 3) {
      return false;
    }
    let inside = false;
    for (let i = 0, j = polygonIn.length - 1; i < polygonIn.length; j = i++) {
      const xi = Number(polygonIn[i] && polygonIn[i].x);
      const yi = Number(polygonIn[i] && polygonIn[i].y);
      const xj = Number(polygonIn[j] && polygonIn[j].x);
      const yj = Number(polygonIn[j] && polygonIn[j].y);
      if (!Number.isFinite(xi) || !Number.isFinite(yi) || !Number.isFinite(xj) || !Number.isFinite(yj)) {
        continue;
      }
      const intersects = ((yi > yIn) !== (yj > yIn)) &&
        (xIn < (((xj - xi) * (yIn - yi)) / ((yj - yi) || 0.0000001)) + xi);
      if (intersects) {
        inside = !inside;
      }
    }
    return inside;
  }

  private findFirstMeasureSlotInPolygon(polygonIn: any[]): any {
    if (!Array.isArray(polygonIn) || polygonIn.length < 3) {
      return null;
    }

    const xs = polygonIn.map(p => Number(p && p.x)).filter(v => Number.isFinite(v));
    const ys = polygonIn.map(p => Number(p && p.y)).filter(v => Number.isFinite(v));
    if (!xs.length || !ys.length) {
      return null;
    }

    const minX = Math.min.apply(null, xs);
    const maxX = Math.max.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxY = Math.max.apply(null, ys);
    const bw = maxX - minX;
    const bh = maxY - minY;
    if (!(bw > 0) || !(bh > 0)) {
      return null;
    }

    const widthRatios = [0.72, 0.62, 0.54, 0.46, 0.38];
    const heightRatios = [0.42, 0.34, 0.28, 0.22];

    for (const wr of widthRatios) {
      for (const hr of heightRatios) {
        const w = Math.max(18, Math.min(bw - 4, bw * wr));
        const h = Math.max(12, Math.min(bh - 4, bh * hr));
        if (!(w > 0) || !(h > 0) || w >= bw || h >= bh) {
          continue;
        }

        const halfW = w / 2;
        const halfH = h / 2;
        const step = Math.max(2, Math.min(8, Math.floor(Math.min(w, h) / 3)));
        for (let y = minY + halfH + 2; y <= maxY - halfH - 2; y += step) {
          for (let x = minX + halfW + 2; x <= maxX - halfW - 2; x += step) {
            const okCenter = this.isPointInsidePolygon(x, y, polygonIn);
            const okLT = this.isPointInsidePolygon(x - halfW, y - halfH, polygonIn);
            const okRT = this.isPointInsidePolygon(x + halfW, y - halfH, polygonIn);
            const okRB = this.isPointInsidePolygon(x + halfW, y + halfH, polygonIn);
            const okLB = this.isPointInsidePolygon(x - halfW, y + halfH, polygonIn);
            if (okCenter && okLT && okRT && okRB && okLB) {
              return { cx: x, cy: y, w: w, h: h };
            }
          }
        }
      }
    }

    return null;
  }

  private drawOefInternalCuts(contextIn: any, drawIn: any, disbandIn: any, xPlusIn: number, yPlusIn: number, zoomIn: number): void {
    const geometry = this.getOefTransformedGeometry(drawIn);
    if (!geometry) {
      return;
    }
    const minX = Number(geometry.minX);
    const minY = Number(geometry.minY);
    const width = Number(geometry.width);
    const height = Number(geometry.height);
    const transformedPolygons = Array.isArray(geometry.polygons) ? geometry.polygons : [];

    const isBorderSegment = (aIn: any, bIn: any): boolean => {
      const eps = 0.001;
      const onLeft = Math.abs(aIn.x) <= eps && Math.abs(bIn.x) <= eps;
      const onRight = Math.abs(aIn.x - width) <= eps && Math.abs(bIn.x - width) <= eps;
      const onBottom = Math.abs(aIn.y) <= eps && Math.abs(bIn.y) <= eps;
      const onTop = Math.abs(aIn.y - height) <= eps && Math.abs(bIn.y - height) <= eps;
      return onLeft || onRight || onBottom || onTop;
    };

    const idText = (() => {
      const group = drawIn && drawIn.group !== undefined && drawIn.group !== null ? drawIn.group.toString() : '';
      const seq = drawIn && drawIn.sequence !== undefined && drawIn.sequence !== null ? drawIn.sequence.toString() : '';
      if (group || seq) {
        return (group + seq).trim();
      }
      return drawIn && drawIn.name ? drawIn.name.toString() : '';
    })();

    if (!transformedPolygons.length) {
      return;
    }

    contextIn.save();
    const rectX = (disbandIn.left + xPlusIn + minX) * zoomIn;
    const rectY = (disbandIn.top + yPlusIn + minY) * zoomIn;
    const rectW = width * zoomIn;
    const rectH = height * zoomIn;

    // Fondo de "resto" dentro del bounding-box del primitivo compuesto.
    if (this.fileForm.controls.f_fill_piece.value) {
      contextIn.fillStyle = this.rojo_claro;
      contextIn.fillRect(rectX, rectY, rectW, rectH);
    }

    // Masa real de pieza dentro del primitivo OEF. Se rellena en un único path
    // para evitar juntas visuales falsas entre polígonos OEF que comparten corte.
    if (this.fileForm.controls.f_fill_piece.value) {
      contextIn.beginPath();
      transformedPolygons.forEach(poly => {
        poly.forEach((pt, idx) => {
          const px = (disbandIn.left + xPlusIn + minX + Number(pt.x)) * zoomIn;
          const py = (disbandIn.top + yPlusIn + minY + Number(pt.y)) * zoomIn;
          if (idx === 0) {
            contextIn.moveTo(px, py);
          } else {
            contextIn.lineTo(px, py);
          }
        });
        contextIn.closePath();
      });
      contextIn.fillStyle = this.amarillo_claro;
      contextIn.fill();
    }

    if (!this.fileForm.controls.f_fill_piece.value) {
      transformedPolygons.forEach(poly => {
        contextIn.beginPath();
        poly.forEach((pt, idx) => {
          const px = (disbandIn.left + xPlusIn + minX + Number(pt.x)) * zoomIn;
          const py = (disbandIn.top + yPlusIn + minY + Number(pt.y)) * zoomIn;
          if (idx === 0) {
            contextIn.moveTo(px, py);
          } else {
            contextIn.lineTo(px, py);
          }
        });
        contextIn.closePath();
        contextIn.lineWidth = 0.8;
        contextIn.strokeStyle = '#4a4a4a';
        contextIn.stroke();
      });
    }

    // Etiqueta identificador en cada triángulo.
    if (idText) {
      contextIn.fillStyle = '#111';
      contextIn.font = 'bold 9pt Courier New';
      contextIn.textAlign = 'center';
      transformedPolygons.forEach(poly => {
        const centroid = poly.reduce((acc, p) => ({ x: acc.x + Number(p.x), y: acc.y + Number(p.y) }), { x: 0, y: 0 });
        const cx = centroid.x / poly.length;
        const cy = centroid.y / poly.length;
        contextIn.fillText(
          idText,
          (disbandIn.left + xPlusIn + minX + cx) * zoomIn,
          (disbandIn.top + yPlusIn + minY + cy) * zoomIn
        );
      });
    }

    // Líneas internas (solo las que no son borde exterior del bounding-box).
    contextIn.lineWidth = 0.8;
    contextIn.strokeStyle = '#4a4a4a';
    contextIn.beginPath();
    const drawnSegments = {};
    const segmentKey = (aIn: any, bIn: any): string => {
      const ax = Math.round(Number(aIn.x) * 1000);
      const ay = Math.round(Number(aIn.y) * 1000);
      const bx = Math.round(Number(bIn.x) * 1000);
      const by = Math.round(Number(bIn.y) * 1000);
      const k1 = ax + ',' + ay;
      const k2 = bx + ',' + by;
      return k1 < k2 ? (k1 + '|' + k2) : (k2 + '|' + k1);
    };

    transformedPolygons.forEach(poly => {
      for (let i = 0; i < poly.length; i++) {
        const a = poly[i];
        const b = poly[(i + 1) % poly.length];
        if (!a || !b || !Number.isFinite(Number(a.x)) || !Number.isFinite(Number(a.y)) || !Number.isFinite(Number(b.x)) || !Number.isFinite(Number(b.y))) {
          continue;
        }
        if (isBorderSegment(a, b)) {
          continue;
        }
        const key = segmentKey(a, b);
        if (drawnSegments[key]) {
          continue;
        }
        drawnSegments[key] = true;
        contextIn.moveTo((disbandIn.left + xPlusIn + minX + Number(a.x)) * zoomIn, (disbandIn.top + yPlusIn + minY + Number(a.y)) * zoomIn);
        contextIn.lineTo((disbandIn.left + xPlusIn + minX + Number(b.x)) * zoomIn, (disbandIn.top + yPlusIn + minY + Number(b.y)) * zoomIn);
      }
    });
    const auxSegments = Array.isArray(geometry.auxSegments) ? geometry.auxSegments : [];
    auxSegments.forEach(seg => {
      const a = seg && seg.a;
      const b = seg && seg.b;
      if (!a || !b || !Number.isFinite(Number(a.x)) || !Number.isFinite(Number(a.y)) || !Number.isFinite(Number(b.x)) || !Number.isFinite(Number(b.y))) {
        return;
      }
      const key = segmentKey(a, b);
      if (drawnSegments[key]) {
        return;
      }
      drawnSegments[key] = true;
      contextIn.moveTo((disbandIn.left + xPlusIn + minX + Number(a.x)) * zoomIn, (disbandIn.top + yPlusIn + minY + Number(a.y)) * zoomIn);
      contextIn.lineTo((disbandIn.left + xPlusIn + minX + Number(b.x)) * zoomIn, (disbandIn.top + yPlusIn + minY + Number(b.y)) * zoomIn);
    });

    contextIn.stroke();
    contextIn.restore();
  }

  private buildOefRuntimeOptimizationVariants(): any[][] {
    if (!this.getOefSettings().enabled) {
      return [];
    }
    if (!this.lastOefPreSearch) {
      return [];
    }
    const selectedRaw = Array.isArray(this.lastOefPreSearch.selected_primitives)
      ? this.lastOefPreSearch.selected_primitives.filter(item => !!item)
      : [];
    if (!selectedRaw.length) {
      const fallback = this.buildOefRuntimeOptimizationList();
      return (fallback && fallback.length > 0) ? [fallback] : [];
    }

    const pools: any[][] = [];
    const poolMap = {};
	    const isTrapPrimitive = (itemIn: any): boolean => {
	      const src = itemIn && itemIn.source ? itemIn.source.toString() : '';
	      return src.indexOf('trap_band_') === 0 ||
	        src.indexOf('trap_input_') === 0 ||
	        src.indexOf('trap_force_') === 0 ||
	        src.indexOf('trap_runtime_') === 0;
	    };
    const selectedOnlyTrap = selectedRaw.length > 0 && selectedRaw.every(item => isTrapPrimitive(item));
    const addPool = (poolIn: any[]): void => {
      const pool = (poolIn || []).filter(item => !!item);
      if (!pool.length) {
        return;
      }
      const key = pool
        .map(item => {
          const src = item && item.source ? item.source.toString() : '';
          const pcs = Number(item && item.pieces ? item.pieces : 0).toFixed(0);
          const w = Number(item && item.width ? item.width : 0).toFixed(2);
          const h = Number(item && item.height ? item.height : 0).toFixed(2);
          const borders = this.getOefPrimitiveBorders(item);
          return src + '|' + pcs + '|' + w + 'x' + h +
            '|b' + borders.b1.toFixed(2) + ',' + borders.b2.toFixed(2) + ',' + borders.b3.toFixed(2) + ',' + borders.b4.toFixed(2);
        })
        .sort()
        .join('||');
      if (poolMap[key]) {
        return;
      }
      poolMap[key] = true;
      pools.push(pool);
    };

    const targetUnits = (Array.isArray(this.optimizationList) ? this.optimizationList : [])
      .reduce((acc, item) => {
        if (!item || item.check !== true) {
          return acc;
        }
        return acc + this.getSelectedPieceUnits(item);
      }, 0);

    // La combinación completa representa exactamente la selección del modal.
    addPool(selectedRaw);
    const selectedFamilies = {};
    selectedRaw.forEach(item => {
      const src = item && item.source ? item.source.toString() : '';
      const family = src.indexOf('trap_') === 0
        ? 'trap'
        : (src.indexOf('triangle_') === 0
            ? 'triangle'
            : (src.indexOf('form38_') === 0 ? 'form38' : 'other'));
      selectedFamilies[family] = true;
    });
    // Las variantes individuales solo tienen sentido cuando todos los
    // candidatos pertenecen a la misma familia. En una selección mixta
    // permitirlas hacía que una simulación posterior ignorase otra familia.
    if (Object.keys(selectedFamilies).length <= 1) {
      selectedRaw.forEach(item => addPool([item]));
    }

    if (selectedOnlyTrap && targetUnits >= 4 && selectedRaw.length > 1) {
      const canReachWithTwoSizes = (aIn: number, bIn: number, targetIn: number): boolean => {
        const a = Math.max(0, Math.round(Number(aIn)));
        const b = Math.max(0, Math.round(Number(bIn)));
        const t = Math.max(0, Math.round(Number(targetIn)));
        if (a < 2 || b < 2 || t < 2) {
          return false;
        }
        for (let x = 0; x <= Math.floor(t / a); x++) {
          const rest = t - (x * a);
          if (rest < 0) continue;
          if (rest % b === 0) {
            const y = rest / b;
            if ((x + y) > 0) {
              return true;
            }
          }
        }
        return false;
      };
      for (let i = 0; i < selectedRaw.length; i++) {
        for (let j = i + 1; j < selectedRaw.length; j++) {
          const a = Number(selectedRaw[i] && selectedRaw[i].pieces ? selectedRaw[i].pieces : 0);
          const b = Number(selectedRaw[j] && selectedRaw[j].pieces ? selectedRaw[j].pieces : 0);
          if (canReachWithTwoSizes(a, b, targetUnits)) {
            addPool([selectedRaw[i], selectedRaw[j]]);
          }
        }
      }
    }

    const originalSelected = this.lastOefPreSearch.selected_primitives;
    const variants: any[][] = [];
    const variantMap = {};
    const rotateOefPolygons90 = (polysIn: any[], wIn: number, hIn: number): any[] => {
      const src = Array.isArray(polysIn) ? polysIn : [];
      const w = Number(wIn);
      const h = Number(hIn);
      if (!(Number.isFinite(w) && w > 0 && Number.isFinite(h) && h > 0) || src.length < 1) {
        return [];
      }
      return src
        .map(poly => (Array.isArray(poly) ? poly : [])
          .map(pt => ({
            x: Number(h - Number(pt && pt.y)),
            y: Number(pt && pt.x)
          }))
          .filter(pt => Number.isFinite(pt.x) && Number.isFinite(pt.y)))
        .filter(poly => poly.length >= 3);
    };
    const buildRotatedRuntimeList = (listIn: any[], familyIn: string = 'trap'): any[] => {
      const list = JSON.parse(JSON.stringify(listIn || []));
      let changed = false;
      list.forEach(item => {
        if (!item || item.check !== true) {
          return;
        }
        const isOef = item.oef_generated === true || (Array.isArray(item.oef_internal_polygons) && item.oef_internal_polygons.length > 0);
        if (!isOef) {
          return;
        }
        const figure = this.getPieceFigureId(item);
        const dims = this.getOefPieceBaseDimensions(item);
        const baseW = Number(dims && dims.width);
        const baseH = Number(dims && dims.height);
        const basePoly = this.getPiecePolygonTemplate(item, baseW, baseH);
        const itemFamily = this.isForm38Figure(figure)
          ? 'form38'
          : (this.isTrapezoidLikePiece(item, basePoly, baseW, baseH) ? 'trap' : 'other');
        if (itemFamily !== familyIn) {
          return;
        }
        const w = Number(item.width);
        const h = Number(item.height);
        const polys = Array.isArray(item.oef_internal_polygons) ? item.oef_internal_polygons : [];
        if (!(Number.isFinite(w) && w > 0 && Number.isFinite(h) && h > 0) || polys.length < 1) {
          return;
        }
        const rotated = rotateOefPolygons90(polys, w, h);
        if (!rotated.length) {
          return;
        }
        // rotateOefPolygons90 ya gira dentro de la caja exterior completa.
        // No normalizar de nuevo: hacerlo recortaba los bordes B1..B4 y
        // convertía, por ejemplo, 3360 (3200 + 80 + 80) en 3200 mm.
        item.oef_internal_polygons = rotated;
        item.width = Number(h);
        item.height = Number(w);
        item.oef_primitive_w = Number(h);
        item.oef_primitive_h = Number(w);
        const oldB1 = Number(item.oef_primitive_b1 || 0);
        const oldB2 = Number(item.oef_primitive_b2 || 0);
        const oldB3 = Number(item.oef_primitive_b3 || 0);
        const oldB4 = Number(item.oef_primitive_b4 || 0);
        item.oef_primitive_b1 = oldB4;
        item.oef_primitive_b2 = oldB1;
        item.oef_primitive_b3 = oldB2;
        item.oef_primitive_b4 = oldB3;
        item.oef_lock_rotation = true;
        item.oef_layout_priority = 0;
        this.applyOefRuntimeAreaMetrics(
          item,
          item,
          Number(item && (item.oef_real_units !== undefined ? item.oef_real_units : item.piece_oef_real_units)) || 1
        );
        changed = true;
      });
      return changed ? list : null;
    };
    const pushVariant = (
      runtimeListIn: any[],
      strategyIn: string = 'standard',
      strategyLabelIn: string = 'OEF estándar'
    ): void => {
      if (!runtimeListIn || runtimeListIn.length < 1) {
        return;
      }
      runtimeListIn.forEach(item => {
        if (!item) return;
        item.oef_layout_strategy = strategyIn;
        item.oef_layout_strategy_label = strategyLabelIn;
        if (strategyIn === 'central_remainder' && this.isOefCompositeItem(item)) {
          // La L necesita conservar tanto el brazo vertical como el horizontal.
          // El motor general puede girar piezas para hacerlas caber, por lo que
          // esta estrategia bloquea expresamente la orientación preparada.
          item.oef_lock_rotation = true;
          if (!Number.isFinite(Number(item.oef_layout_priority))) {
            item.oef_layout_priority = 1;
          }
        }
      });
      const signature = runtimeListIn
        .filter(it => it && it.check === true)
        .map(it => {
          const w = Number(it && it.width ? it.width : 0).toFixed(2);
          const h = Number(it && it.height ? it.height : 0).toFixed(2);
          const u = Number(it && it.units ? it.units : 0).toFixed(0);
          const op = Array.isArray(it && it.oef_internal_polygons) ? it.oef_internal_polygons.length : 0;
          return w + 'x' + h + '|' + u + '|' + op;
        })
        .sort()
        .join('||') + '|strategy:' + strategyIn;
      if (!signature || variantMap[signature]) {
        return;
      }
      variantMap[signature] = true;
      variants.push(runtimeListIn);
    };
    pools.forEach(pool => {
      this.lastOefPreSearch.selected_primitives = pool;
      const runtimeList = this.buildOefRuntimeOptimizationList();
      if (!runtimeList || runtimeList.length < 1) {
        return;
      }
      pushVariant(runtimeList, 'standard', 'OEF estándar');
      if (selectedOnlyTrap) {
        const rotatedVariant = buildRotatedRuntimeList(runtimeList, 'trap');
        if (rotatedVariant && rotatedVariant.length > 0) {
          pushVariant(rotatedVariant, 'standard', 'OEF estándar');
        }
      } else if (selectedFamilies['form38'] && selectedFamilies['trap']) {
        // Estrategia de retal central: probar los paralelogramos en vertical
        // manteniendo los trapecios en horizontal para formar una L.
        const form38Vertical = buildRotatedRuntimeList(runtimeList, 'form38');
        if (form38Vertical && form38Vertical.length > 0) {
          pushVariant(form38Vertical, 'central_remainder', 'OEF retal central');
        }
        const trapVertical = buildRotatedRuntimeList(runtimeList, 'trap');
        if (trapVertical && trapVertical.length > 0) {
          pushVariant(trapVertical, 'central_remainder', 'OEF retal central');
        }
        if (form38Vertical && form38Vertical.length > 0) {
          const bothVertical = buildRotatedRuntimeList(form38Vertical, 'trap');
          if (bothVertical && bothVertical.length > 0) {
            pushVariant(bothVertical, 'central_remainder', 'OEF retal central');
          }
        }
      }
    });
    this.lastOefPreSearch.selected_primitives = originalSelected;
    if (!variants.length) {
      return variants;
    }

    // En lotes sólo trapecio hay que conservar todas las variantes seleccionadas
    // para mantener trazabilidad modal -> runtime (incluidas 6 + resto).
    if (selectedOnlyTrap) {
      const hasExactNoRemainder = variants.some(list =>
        (list || [])
          .filter(it => it && it.check === true)
          .every(it => it && it.oef_runtime_remainder !== true)
      );
      if (hasExactNoRemainder) {
        const withoutRemainder = variants.filter(list =>
          (list || [])
            .filter(it => it && it.check === true)
            .every(it => it && it.oef_runtime_remainder !== true)
        );
        if (withoutRemainder.length > 0) {
          return withoutRemainder;
        }
      }
      return variants;
    }

    const getNonOefUnits = (listIn: any[]): number => {
      return (listIn || []).reduce((acc, item) => {
        if (!item || item.check !== true) {
          return acc;
        }
        if (this.isOefCompositeItem(item)) {
          return acc;
        }
        return acc + this.getSelectedPieceUnits(item);
      }, 0);
    };
    let minNonOefUnits = Number.POSITIVE_INFINITY;
    variants.forEach(list => {
      const nonOefUnits = getNonOefUnits(list);
      if (nonOefUnits < minNonOefUnits) {
        minNonOefUnits = nonOefUnits;
      }
    });
    const filtered = variants.filter(list => getNonOefUnits(list) === minNonOefUnits);
    return filtered.length > 0 ? filtered : variants;
  }

  private orderOefRowsByLayoutPriority(listIn: any[]): any[] {
    return (Array.isArray(listIn) ? listIn : [])
      .map((item, index) => ({ item: item, index: index }))
      .sort((a, b) => {
        const aPriority = Number.isFinite(Number(a.item && a.item.oef_layout_priority))
          ? Number(a.item.oef_layout_priority)
          : 1;
        const bPriority = Number.isFinite(Number(b.item && b.item.oef_layout_priority))
          ? Number(b.item.oef_layout_priority)
          : 1;
        return (aPriority - bPriority) || (a.index - b.index);
      })
      .map(entry => entry.item);
  }

  private buildOefRuntimeOptimizationList(): any[] {
    if (!this.getOefSettings().enabled) {
      return null;
    }
    const selected = (this.lastOefPreSearch && Array.isArray(this.lastOefPreSearch.selected_primitives))
      ? this.lastOefPreSearch.selected_primitives
      : [];
    if (!Array.isArray(this.optimizationList) || this.optimizationList.length === 0) {
      return null;
    }

    const cloned = JSON.parse(JSON.stringify(this.optimizationList));
    const getRuntimeUnits = (itemIn: any): number => {
      const u = Number(itemIn && itemIn.units);
      // En la lista base previa a runtime, "units" ya representa unidades reales de entrada.
      // No aplicar multiplicadores OEF aquí para evitar inflar 800 -> 1000.
      return (Number.isFinite(u) && u > 0) ? Math.max(1, Math.round(u)) : 1;
    };
    const checkedLines = cloned.filter(item => item && item.check === true);
    const checkedUnits = checkedLines.reduce((acc, item) => acc + getRuntimeUnits(item), 0);
    console.log('[OEF runtime] checked lines/units:', checkedLines.length, checkedUnits);
    const isTrapCheckedLine = (itemIn: any): boolean => {
      if (!itemIn) {
        return false;
      }
      const dims = this.getOefPieceBaseDimensions(itemIn);
      const w = Number(dims && dims.width);
      const h = Number(dims && dims.height);
      if (!(Number.isFinite(w) && w > 0 && Number.isFinite(h) && h > 0)) {
        return false;
      }
      const poly = this.getPiecePolygonTemplate(itemIn, w, h);
      return this.isTrapezoidLikePiece(itemIn, poly, w, h);
    };
    const checkedTrapLines = checkedLines.filter(item => isTrapCheckedLine(item));
    const checkedTrapUnits = checkedTrapLines.reduce((acc, item) => acc + getRuntimeUnits(item), 0);
    console.log('[OEF runtime] checked trap lines/units:', checkedTrapLines.length, checkedTrapUnits);

    // Ruta determinista desde pre-search: si ya existe candidato trapecio 2+ piezas,
    // se usa directamente aquí para construir el primitivo runtime.
    const preSearchSelectedRaw = (this.lastOefPreSearch && Array.isArray(this.lastOefPreSearch.selected_primitives))
      ? this.lastOefPreSearch.selected_primitives
      : [];
    const preSearchAllRaw = (this.lastOefPreSearch && Array.isArray(this.lastOefPreSearch.primitives))
      ? this.lastOefPreSearch.primitives
      : [];
    const preSearchPoolRaw = [];
    const preSearchPoolMap = {};
    preSearchSelectedRaw.concat(preSearchAllRaw).forEach(item => {
      if (!item) {
        return;
      }
      const key = Number(item && item.width ? item.width : 0).toFixed(2) + 'x' +
        Number(item && item.height ? item.height : 0).toFixed(2) + '|' +
        Number(item && item.pieces ? item.pieces : 0).toFixed(0) + '|' +
        (item && item.source ? item.source.toString() : '');
      if (preSearchPoolMap[key]) {
        return;
      }
      preSearchPoolMap[key] = true;
      preSearchPoolRaw.push(item);
    });
    const preSearchTrapCandidates = preSearchPoolRaw
      .filter(item =>
        item &&
        Number(item.pieces) >= 2 &&
        item.source &&
        (
          item.source.toString().indexOf('trap_') === 0 ||
          item.source.toString().indexOf('trap_band_') === 0 ||
          item.source.toString().indexOf('trap_input_') === 0 ||
          item.source.toString().indexOf('trap_force_') === 0 ||
          item.source.toString().indexOf('trap_runtime_') === 0
        )
      )
      .sort((a, b) => Number(b.pieces) - Number(a.pieces));
    console.log('[OEF runtime] pre-search trap candidates:', preSearchTrapCandidates.map(item => ({
      source: item && item.source ? item.source : '',
      pieces: Number(item && item.pieces ? item.pieces : 0),
      width: Number(item && item.width ? item.width : 0),
      height: Number(item && item.height ? item.height : 0)
    })));
    const trapOnlyChecked = checkedLines.length > 0 && checkedTrapLines.length === checkedLines.length;
    if (trapOnlyChecked && checkedTrapLines.length > 0 && checkedTrapUnits >= 2 && preSearchTrapCandidates.length > 0) {
      const baseTemplate = checkedTrapLines[0];
      const selectedTrapCandidates = preSearchSelectedRaw
        .filter(item =>
          item &&
          Number(item.pieces) >= 2 &&
          Number(item.pieces) <= checkedTrapUnits &&
          item.source &&
          (
            item.source.toString().indexOf('trap_') === 0 ||
            item.source.toString().indexOf('trap_band_') === 0 ||
            item.source.toString().indexOf('trap_input_') === 0 ||
            item.source.toString().indexOf('trap_force_') === 0 ||
            item.source.toString().indexOf('trap_runtime_') === 0
          )
        );
      const scoreTrapCandidate = (itemIn: any): number => {
        const src = itemIn && itemIn.source ? itemIn.source.toString() : '';
        const pieces = Math.round(Number(itemIn && itemIn.pieces ? itemIn.pieces : 0));
        const waste = Number(itemIn && itemIn.waste_pct !== undefined ? itemIn.waste_pct : 9999);
        let score = 0;
        // Prioridad principal: máximo número de piezas combinadas.
        score += (Math.max(0, pieces) * 100000);
        if (src.indexOf('trap_band_h_alt_') === 0) {
          score += 9000;
        } else if (src.indexOf('trap_band_h_turn_') === 0) {
          score += 8500;
        } else if (src.indexOf('trap_band_h_same_') === 0) {
          score += 7000;
        } else if (src.indexOf('trap_band_h_bbox_alt_') === 0) {
          score += 5000;
        } else if (src.indexOf('trap_band_h_bbox_turn_') === 0) {
          score += 4500;
        } else if (src.indexOf('trap_band_h_bbox_same_') === 0) {
          score += 1000;
        } else if (src.indexOf('trap_force_h_') === 0) {
          score += 600;
        } else if (src.indexOf('trap_input_h_') === 0) {
          score += 300;
        }
        if (Number.isFinite(waste)) {
          score -= waste;
        }
        return score;
      };
      const candidatePool = selectedTrapCandidates.length > 0
        ? selectedTrapCandidates
        : preSearchTrapCandidates;
      const bestByPieces = {};
      candidatePool.forEach(item => {
        const pieces = Math.max(2, Math.round(Number(item && item.pieces ? item.pieces : 0)));
        if (pieces > checkedUnits) {
          return;
        }
        if (!bestByPieces[pieces] || scoreTrapCandidate(item) > scoreTrapCandidate(bestByPieces[pieces])) {
          bestByPieces[pieces] = item;
        }
      });
      const sizeOptions = Object.keys(bestByPieces)
        .map(k => Number(k))
        .filter(v => Number.isFinite(v) && v >= 2 && v <= checkedTrapUnits)
        .sort((a, b) => b - a);
      const buildBestPlan = (targetUnitsIn: number): any => {
        const dp = new Array(targetUnitsIn + 1).fill(null);
        dp[0] = { units: 0, score: 0, packs: 0, counts: {} };
        for (let u = 1; u <= targetUnitsIn; u++) {
          let best = null;
          sizeOptions.forEach(size => {
            if (u - size < 0 || !dp[u - size]) {
              return;
            }
            const candRef = bestByPieces[size];
            if (!candRef) {
              return;
            }
            const prev = dp[u - size];
            const counts = JSON.parse(JSON.stringify(prev.counts || {}));
            counts[size] = Number(counts[size] || 0) + 1;
            const next = {
              units: Number(prev.units || 0) + size,
              score: Number(prev.score || 0) + Number(scoreTrapCandidate(candRef)),
              packs: Number(prev.packs || 0) + 1,
              counts: counts
            };
            if (!best) {
              best = next;
              return;
            }
            if (Number(next.score) > Number(best.score)) {
              best = next;
            } else if (Number(next.score) === Number(best.score) && Number(next.packs) < Number(best.packs)) {
              best = next;
            }
          });
          dp[u] = best;
        }
        if (dp[targetUnitsIn]) {
          return dp[targetUnitsIn];
        }
        for (let u = targetUnitsIn - 1; u >= 2; u--) {
          if (dp[u]) {
            return dp[u];
          }
        }
        return null;
      };
      const plan = buildBestPlan(checkedTrapUnits);
      const coveredUnits = plan && Number.isFinite(Number(plan.units)) ? Number(plan.units) : 0;
      const remainder = Math.max(0, checkedTrapUnits - coveredUnits);
      const planRows = [];
      if (plan && plan.counts) {
        Object.keys(plan.counts).forEach(key => {
          const size = Number(key);
          const packs = Number(plan.counts[key] || 0);
          const candidate = bestByPieces[size];
          if (packs > 0 && candidate) {
            planRows.push({
              candidate: candidate,
              pieces: size,
              packs: packs
            });
          }
        });
      }
      planRows.sort((a, b) => Number(b.pieces) - Number(a.pieces));
      console.log('[OEF runtime] pre-search path plan:', {
        checkedUnits: checkedTrapUnits,
        coveredUnits: coveredUnits,
        remainder: remainder,
        rows: planRows.map(r => ({
          source: r.candidate && r.candidate.source ? r.candidate.source : '',
          pieces: r.pieces,
          packs: r.packs
        }))
      });
      if (planRows.length > 0) {
        console.log('[OEF runtime] pre-search path applied');
        let maxId = 0;
        cloned.forEach(item => {
          const id = Number(item && item.id);
          if (Number.isFinite(id) && id > maxId) {
            maxId = id;
          }
        });
        checkedTrapLines.forEach(item => {
          item.check = false;
          item.units = 0;
        });
        const injected = [];
        const dimsBase = this.getOefPieceBaseDimensions(baseTemplate);
        const baseW = Number(dimsBase && dimsBase.width);
        const baseH = Number(dimsBase && dimsBase.height);
        const safeW = Number.isFinite(baseW) && baseW > 0 ? baseW : 1;
        const safeH = Number.isFinite(baseH) && baseH > 0 ? baseH : 1;
        const basePolyRaw = this.getPiecePolygonTemplate(baseTemplate, safeW, safeH);
        const basePoly = (Array.isArray(basePolyRaw) && basePolyRaw.length >= 3)
          ? basePolyRaw
          : [
              { x: 0, y: safeH },
              { x: safeW, y: safeH },
              { x: safeW * 0.8, y: 0 },
              { x: safeW * 0.2, y: 0 }
            ];
        const mirrorBasePoly = this.mirrorPolygonVertical(basePoly, safeW);
        planRows.forEach(planRow => {
          const candidate = planRow.candidate;
          const packs = Number(planRow.packs || 0);
          for (let packIndex = 0; packIndex < packs; packIndex++) {
            maxId += 1;
            const row = JSON.parse(JSON.stringify(baseTemplate));
            row.id = maxId;
            row.lot = (baseTemplate && baseTemplate.lot !== undefined && baseTemplate.lot !== null)
              ? baseTemplate.lot
              : 0;
            row.units = 1;
	            row.width = Number(candidate && candidate.width ? candidate.width : safeW);
	            row.height = Number(candidate && candidate.height ? candidate.height : safeH);
	            const baseFigureRaw = Number(baseTemplate && (
	              baseTemplate.piece_figure_input !== undefined && baseTemplate.piece_figure_input !== null
	                ? baseTemplate.piece_figure_input
	                : baseTemplate.figure
	            ));
	            const baseFigure = (Number.isFinite(baseFigureRaw) && baseFigureRaw > 0) ? Math.round(baseFigureRaw) : 0;
	            row.figure = baseFigure;
	            row.piece_figure_input = baseFigure;
	            row.source = (candidate && candidate.source) ? candidate.source.toString() : 'trap_runtime_pack';
	            row.dxf_points = null;
	            row.piece_dxf_points = null;
	            row.dxf_name = '';
            let internalPolygons = (candidate && Array.isArray(candidate.placements) ? candidate.placements : [])
              .map(pl => {
                const px = Number(pl && pl.x);
                const py = Number(pl && pl.y);
                const points = Array.isArray(pl && pl.polygon) ? pl.polygon : [];
                if (!Number.isFinite(px) || !Number.isFinite(py) || points.length < 3) {
                  return null;
                }
                const polygon = points.map(pt => ({
                  x: Number((pt && pt.x) || 0) + px,
                  y: Number((pt && pt.y) || 0) + py
                }));
                return polygon.length >= 3 ? polygon : null;
              })
              .filter(poly => Array.isArray(poly) && poly.length >= 3);
            if (internalPolygons.length < 2) {
              internalPolygons = [
                basePoly,
                this.transformPolygon(mirrorBasePoly, safeW, 0)
              ];
            }
            const tight = this.normalizeOefPolygonsToTightBBox(internalPolygons);
            this.applyOefPrimitiveGeometryToRuntimeRow(row, tight, candidate);
            this.applyOefRuntimeAreaMetrics(row, baseTemplate, Number(planRow && planRow.pieces ? planRow.pieces : 1));
            row.oef_generated = true;
            row.oef_runtime_units = 1;
            row.oef_runtime_remainder = false;
            row.check = true;
            injected.push(row);
            console.log('[OEF runtime] injected row pre-search:', {
              units: Number(row.units),
              width: Number(row.width),
              height: Number(row.height),
              oef_polygons: Array.isArray(row.oef_internal_polygons) ? row.oef_internal_polygons.length : 0
            });
          }
        });

        if (remainder > 0) {
          for (let remIndex = 0; remIndex < remainder; remIndex++) {
            maxId += 1;
            const rem = JSON.parse(JSON.stringify(baseTemplate));
            rem.id = maxId;
            rem.lot = (baseTemplate && baseTemplate.lot !== undefined && baseTemplate.lot !== null)
              ? baseTemplate.lot
              : 0;
	            rem.units = 1;
	            const remBaseFigureRaw = Number(baseTemplate && (
	              baseTemplate.piece_figure_input !== undefined && baseTemplate.piece_figure_input !== null
	                ? baseTemplate.piece_figure_input
	                : baseTemplate.figure
	            ));
	            const remBaseFigure = (Number.isFinite(remBaseFigureRaw) && remBaseFigureRaw > 0) ? Math.round(remBaseFigureRaw) : 0;
	            rem.figure = remBaseFigure;
	            rem.piece_figure_input = remBaseFigure;
	            rem.source = 'trap_runtime_remainder';
	            rem.dxf_points = null;
	            rem.piece_dxf_points = null;
	            rem.dxf_name = '';
            const remTight = this.normalizeOefPolygonsToTightBBox([basePoly]);
            rem.oef_internal_polygons = remTight.polygons;
            if (Number(remTight.width) > 0 && Number(remTight.height) > 0) {
              rem.width = Number(remTight.width);
              rem.height = Number(remTight.height);
            } else {
              rem.width = Number(safeW);
              rem.height = Number(safeH);
            }
            rem.oef_primitive_w = Number(rem.width);
            rem.oef_primitive_h = Number(rem.height);
            rem.oef_effective_area = Number(remTight.area);
            this.applyOefRuntimeAreaMetrics(rem, baseTemplate, 1);
            rem.oef_generated = true;
            rem.oef_runtime_units = 1;
            rem.oef_runtime_remainder = true;
            rem.check = true;
            injected.push(rem);
          }
        }
        const resultList = cloned.concat(injected);
        console.log('[OEF runtime] result list pre-search summary:',
          (resultList || []).filter(it => it && it.check === true).map(it => ({
            id: it.id,
            units: Number(it.units),
            width: Number(it.width),
            height: Number(it.height),
            oef: !!(it.oef_generated === true || (Array.isArray(it.oef_internal_polygons) && it.oef_internal_polygons.length > 0)),
            oef_polygons: Array.isArray(it.oef_internal_polygons) ? it.oef_internal_polygons.length : 0
          }))
        );
        return resultList;
      }
      console.log('[OEF runtime] pre-search path skipped because packs=0');
    }

    // Ruta determinista trapecio: si hay 2+ unidades trapecio seleccionadas,
    // se fuerza un primitivo compuesto con el mayor tamaño de grupo posible (hasta 6).
    const trapLines = cloned.filter(item => {
      if (!item || item.check !== true) {
        return false;
      }
      const dims = this.getOefPieceBaseDimensions(item);
      const w = Number(dims && dims.width);
      const h = Number(dims && dims.height);
      if (!(Number.isFinite(w) && w > 0 && Number.isFinite(h) && h > 0)) {
        return false;
      }
      const poly = this.getPiecePolygonTemplate(item, w, h);
      return this.isTrapezoidLikePiece(item, poly, w, h);
    });
    const trapTotalUnits = trapLines.reduce((acc, item) => acc + getRuntimeUnits(item), 0);
    console.log('[OEF runtime] direct trap path lines/units:', trapLines.length, trapTotalUnits);
    const directTrapOnly = (trapLines.length > 0 && checkedLines.length > 0 && trapLines.length === checkedLines.length);
    if (trapLines.length > 0 && trapTotalUnits >= 2 && directTrapOnly) {
      const baseTemplate = trapLines[0];
      const targetGroupSize = Math.max(2, Math.min(6, Math.round(Number(trapTotalUnits))));
      const forcedPrimitive = this.buildForcedTrapRuntimePrimitive(baseTemplate, trapTotalUnits, targetGroupSize);
      const groupSize = Math.max(2, Math.round(Number(forcedPrimitive && forcedPrimitive.pieces ? forcedPrimitive.pieces : 2)));
      const packs = Math.floor(trapTotalUnits / groupSize);
      console.log('[OEF runtime] direct trap path packs/group:', { packs: packs, groupSize: groupSize });
      if (packs > 0) {
        console.log('[OEF runtime] direct trap path applied');
        let maxId = 0;
        cloned.forEach(item => {
          const id = Number(item && item.id);
          if (Number.isFinite(id) && id > maxId) {
            maxId = id;
          }
        });
        trapLines.forEach(item => {
          item.check = false;
          item.units = 0;
        });
        const injected = [];
        for (let packIndex = 0; packIndex < packs; packIndex++) {
          maxId += 1;
          const row = JSON.parse(JSON.stringify(baseTemplate));
          row.id = maxId;
          row.lot = (baseTemplate && baseTemplate.lot !== undefined && baseTemplate.lot !== null)
            ? baseTemplate.lot
            : 0;
          row.units = 1;
	          row.width = Number(forcedPrimitive && forcedPrimitive.width ? forcedPrimitive.width : 0);
	          row.height = Number(forcedPrimitive && forcedPrimitive.height ? forcedPrimitive.height : 0);
	          const directBaseFigureRaw = Number(baseTemplate && (
	            baseTemplate.piece_figure_input !== undefined && baseTemplate.piece_figure_input !== null
	              ? baseTemplate.piece_figure_input
	              : baseTemplate.figure
	          ));
	          const directBaseFigure = (Number.isFinite(directBaseFigureRaw) && directBaseFigureRaw > 0) ? Math.round(directBaseFigureRaw) : 0;
	          row.figure = directBaseFigure;
	          row.piece_figure_input = directBaseFigure;
	          row.source = (forcedPrimitive && forcedPrimitive.source) ? forcedPrimitive.source.toString() : 'trap_runtime_forced';
	          row.dxf_points = null;
	          row.piece_dxf_points = null;
	          row.dxf_name = '';
          const internalPolygons = (forcedPrimitive && Array.isArray(forcedPrimitive.placements) ? forcedPrimitive.placements : [])
            .map(pl => {
              const px = Number(pl && pl.x);
              const py = Number(pl && pl.y);
              const points = Array.isArray(pl && pl.polygon) ? pl.polygon : [];
              if (!Number.isFinite(px) || !Number.isFinite(py) || points.length < 3) {
                return null;
              }
              const polygon = points.map(pt => ({
                x: Number((pt && pt.x) || 0) + px,
                y: Number((pt && pt.y) || 0) + py
              }));
              return polygon.length >= 3 ? polygon : null;
            })
            .filter(poly => Array.isArray(poly) && poly.length >= 3);
          const tight = this.normalizeOefPolygonsToTightBBox(internalPolygons);
          this.applyOefPrimitiveGeometryToRuntimeRow(row, tight, forcedPrimitive);
          this.applyOefRuntimeAreaMetrics(row, baseTemplate, Number(groupSize));
          row.oef_generated = true;
          row.oef_runtime_units = 1;
          row.oef_runtime_remainder = false;
          row.check = true;
          injected.push(row);
        }

        const remainder = trapTotalUnits - (packs * groupSize);
        if (remainder > 0) {
          const dimsBase = this.getOefPieceBaseDimensions(baseTemplate);
          const baseW = Number(dimsBase && dimsBase.width);
          const baseH = Number(dimsBase && dimsBase.height);
          const safeW = Number.isFinite(baseW) && baseW > 0 ? baseW : 1;
          const safeH = Number.isFinite(baseH) && baseH > 0 ? baseH : 1;
          const basePolyRaw = this.getPiecePolygonTemplate(baseTemplate, safeW, safeH);
          const basePoly = (Array.isArray(basePolyRaw) && basePolyRaw.length >= 3)
            ? basePolyRaw
            : [
                { x: 0, y: safeH },
                { x: safeW, y: safeH },
                { x: safeW * 0.8, y: 0 },
                { x: safeW * 0.2, y: 0 }
              ];
          for (let remIndex = 0; remIndex < remainder; remIndex++) {
            maxId += 1;
            const rem = JSON.parse(JSON.stringify(baseTemplate));
            rem.id = maxId;
            rem.lot = (baseTemplate && baseTemplate.lot !== undefined && baseTemplate.lot !== null)
              ? baseTemplate.lot
              : 0;
	            rem.units = 1;
	            const directRemBaseFigureRaw = Number(baseTemplate && (
	              baseTemplate.piece_figure_input !== undefined && baseTemplate.piece_figure_input !== null
	                ? baseTemplate.piece_figure_input
	                : baseTemplate.figure
	            ));
	            const directRemBaseFigure = (Number.isFinite(directRemBaseFigureRaw) && directRemBaseFigureRaw > 0) ? Math.round(directRemBaseFigureRaw) : 0;
	            rem.figure = directRemBaseFigure;
	            rem.piece_figure_input = directRemBaseFigure;
	            rem.source = 'trap_runtime_remainder';
	            rem.dxf_points = null;
	            rem.piece_dxf_points = null;
	            rem.dxf_name = '';
            const remTight = this.normalizeOefPolygonsToTightBBox([basePoly]);
            rem.oef_internal_polygons = remTight.polygons;
            if (Number(remTight.width) > 0 && Number(remTight.height) > 0) {
              rem.width = Number(remTight.width);
              rem.height = Number(remTight.height);
            } else {
              rem.width = Number(safeW);
              rem.height = Number(safeH);
            }
            rem.oef_primitive_w = Number(rem.width);
            rem.oef_primitive_h = Number(rem.height);
            rem.oef_effective_area = Number(remTight.area);
            this.applyOefRuntimeAreaMetrics(rem, baseTemplate, 1);
            rem.oef_generated = true;
            rem.oef_runtime_units = 1;
            rem.oef_runtime_remainder = true;
            rem.check = true;
            injected.push(rem);
          }
        }
        return cloned.concat(injected);
      }
    }
    if (trapLines.length > 0 && trapTotalUnits >= 2 && !directTrapOnly) {
      console.log('[OEF runtime] direct trap path skipped (mixed families selected).');
    }

    const groupableLines = cloned.filter(item => {
      if (!item || item.check !== true) {
        return false;
      }
      const dims = this.getOefPieceBaseDimensions(item);
      const w = Number(dims && dims.width);
      const h = Number(dims && dims.height);
      if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
        return false;
      }
      const polygon = this.getPiecePolygonTemplate(item, w, h);
      return this.isOefPrimitiveGroupCandidate(item, polygon, w, h);
    });
    if (!groupableLines.length) {
      console.log('[OEF runtime] no groupable lines');
      return null;
    }

    const groupedByKey = {};
    groupableLines.forEach(item => {
	      const figure = this.getPieceFigureId(item);
      const dims = this.getOefPieceBaseDimensions(item);
      const w = Number(dims && dims.width ? dims.width : 0);
      const h = Number(dims && dims.height ? dims.height : 0);
      const polygon = this.getPiecePolygonTemplate(item, w, h);
      const key = this.isForm38Figure(figure)
        ? (this.buildRuntimeCoverageKey(item) + '|' + this.buildOefGenericGroupKey(item, polygon, w, h))
        : (this.isTriangleLikePiece(item, polygon, w, h)
            ? this.normalizeTriangleGroupKey(item)
            : (this.isTrapezoidLikePiece(item, polygon, w, h)
                ? this.buildOefTrapezoidGroupKey(polygon, w, h)
                : this.buildOefGenericGroupKey(item, polygon, w, h)));
      if (!groupedByKey[key]) {
        groupedByKey[key] = [];
      }
      groupedByKey[key].push(item);
    });

    // Ruta mixta: cuando hay varias familias de formas groupables (triángulos/paralelogramos/trapecios),
    // se construye runtime OEF por familia para evitar que una sola domine todo el lote.
    const groupKeys = Object.keys(groupedByKey).filter(key => {
      const group = groupedByKey[key] || [];
      const units = group.reduce((acc, item) => acc + getRuntimeUnits(item), 0);
      return units >= 2;
    });
    if (groupKeys.length > 1) {
      const getPrimitiveFamily = (itemIn: any): string => {
        const src = itemIn && itemIn.source ? itemIn.source.toString() : '';
        if (src.indexOf('trap_') === 0) return 'trap';
        if (src.indexOf('triangle_') === 0) return 'triangle';
        if (src.indexOf('form38_') === 0) return 'form38';
        return 'other';
      };
      const getGroupFamily = (groupIn: any[]): string => {
        const first = groupIn && groupIn.length > 0 ? groupIn[0] : null;
        if (!first) return 'other';
	        const figure = this.getPieceFigureId(first);
        const dims = this.getOefPieceBaseDimensions(first);
        const w = Number(dims && dims.width ? dims.width : 0);
        const h = Number(dims && dims.height ? dims.height : 0);
        const poly = this.getPiecePolygonTemplate(first, w, h);
        if (this.isForm38Figure(figure)) return 'form38';
        if (this.isTriangleLikePiece(first, poly, w, h)) return 'triangle';
        if (this.isTrapezoidLikePiece(first, poly, w, h)) return 'trap';
        return 'other';
      };
      const scorePrimitive = (familyIn: string, primitiveIn: any): number => {
        const pieces = Math.max(0, Math.round(Number(primitiveIn && primitiveIn.pieces ? primitiveIn.pieces : 0)));
        const waste = Number(primitiveIn && primitiveIn.waste_pct !== undefined ? primitiveIn.waste_pct : 9999);
        const area = Number(primitiveIn && primitiveIn.width ? primitiveIn.width : 0) * Number(primitiveIn && primitiveIn.height ? primitiveIn.height : 0);
        const src = primitiveIn && primitiveIn.source ? primitiveIn.source.toString() : '';
        let score = pieces * 100000;
        if (familyIn === 'trap') {
          if (src.indexOf('trap_band_h_') === 0 || src.indexOf('trap_force_h_') === 0) score += 10000;
        } else if (familyIn === 'triangle') {
          if (src.indexOf('triangle_interlock_') === 0) score += 10000;
        } else if (familyIn === 'form38') {
          if (src.indexOf('form38_band_h_') === 0) score += 10000;
          if (src.indexOf('form38_narrow_v_') === 0) score += 6000;
        }
        if (Number.isFinite(waste)) score -= waste;
        if (Number.isFinite(area) && area > 0) score -= (area / 1000);
        return score;
      };
      const hasExplicitPrimitiveSelection = preSearchSelectedRaw.length > 0;
      const allPrimitives = (hasExplicitPrimitiveSelection ? preSearchSelectedRaw : preSearchAllRaw)
        .filter(p => p && Number(p.pieces) >= 2);
      let maxId = 0;
      cloned.forEach(item => {
        const id = Number(item && item.id);
        if (Number.isFinite(id) && id > maxId) maxId = id;
      });
      const injectedMixed = [];
      let appliedMixed = false;
      groupKeys.forEach(key => {
        const group = groupedByKey[key] || [];
        if (!group.length) return;
        const family = getGroupFamily(group);
        if (family === 'other') return;
        const groupUnits = group.reduce((acc, item) => acc + getRuntimeUnits(item), 0);
        if (groupUnits < 2) return;
        const baseTemplate = group[0];
        const selectedFamilyPool = preSearchSelectedRaw.filter(p =>
          p &&
          Number(p.pieces) >= 2 &&
          getPrimitiveFamily(p) === family
        );
        let familyPool = hasExplicitPrimitiveSelection
          ? selectedFamilyPool
          : allPrimitives.filter(p => getPrimitiveFamily(p) === family);
        if (familyPool.length < 1 && family === 'trap' && !hasExplicitPrimitiveSelection) {
          familyPool = [this.buildForcedTrapRuntimePrimitive(baseTemplate, groupUnits)];
        }
        if (familyPool.length < 1) return;
        const bestByPieces = {};
        familyPool.forEach(p => {
          const size = Math.max(2, Math.round(Number(p && p.pieces ? p.pieces : 0)));
          if (size > groupUnits) return;
          if (!bestByPieces[size] || scorePrimitive(family, p) > scorePrimitive(family, bestByPieces[size])) {
            bestByPieces[size] = p;
          }
        });
        const allSizes = Object.keys(bestByPieces)
          .map(k => Number(k))
          .filter(v => Number.isFinite(v) && v >= 2 && v <= groupUnits)
          .sort((a, b) => b - a);
        if (allSizes.length < 1) return;
        // Solo se pueden utilizar tamaños elegidos expresamente en el modal.
        const sizes = allSizes;
        const dp = new Array(groupUnits + 1).fill(null);
        dp[0] = { units: 0, score: 0, counts: {} };
        for (let u = 1; u <= groupUnits; u++) {
          let best = null;
          sizes.forEach(size => {
            if (u - size < 0 || !dp[u - size]) return;
            const prev = dp[u - size];
            const counts = JSON.parse(JSON.stringify(prev.counts || {}));
            counts[size] = Number(counts[size] || 0) + 1;
            const next = {
              units: Number(prev.units || 0) + size,
              score: Number(prev.score || 0) + scorePrimitive(family, bestByPieces[size]),
              counts: counts
            };
            if (!best || Number(next.score) > Number(best.score)) best = next;
          });
          dp[u] = best;
        }
        let plan = dp[groupUnits];
        if (!plan) {
          for (let u = groupUnits - 1; u >= 2; u--) {
            if (dp[u]) {
              plan = dp[u];
              break;
            }
          }
        }
        if (!plan || !plan.counts) return;
        const coveredUnits = Number(plan.units || 0);
        const remainderUnits = Math.max(0, groupUnits - coveredUnits);
        Object.keys(plan.counts)
          .map(k => Number(k))
          .sort((a, b) => b - a)
          .forEach(size => {
            const packs = Number(plan.counts[size] || 0);
            const primitive = bestByPieces[size];
            if (!(packs > 0) || !primitive) return;
            maxId += 1;
            const row = JSON.parse(JSON.stringify(baseTemplate));
            row.id = maxId;
            row.lot = (baseTemplate && baseTemplate.lot !== undefined && baseTemplate.lot !== null)
              ? baseTemplate.lot
              : 0;
            row.units = packs;
            row.width = Number(primitive && primitive.width ? primitive.width : row.width);
            row.height = Number(primitive && primitive.height ? primitive.height : row.height);
            const mixedBaseFigureRaw = Number(baseTemplate && (
              baseTemplate.piece_figure_input !== undefined && baseTemplate.piece_figure_input !== null
                ? baseTemplate.piece_figure_input
                : baseTemplate.figure
            ));
            const mixedBaseFigure = (Number.isFinite(mixedBaseFigureRaw) && mixedBaseFigureRaw > 0) ? Math.round(mixedBaseFigureRaw) : 0;
            row.figure = mixedBaseFigure;
            row.piece_figure_input = mixedBaseFigure;
            row.dxf_points = null;
            row.piece_dxf_points = null;
            row.dxf_name = '';
            const internalPolygons = (primitive && Array.isArray(primitive.placements) ? primitive.placements : [])
              .map(pl => {
                const px = Number(pl && pl.x);
                const py = Number(pl && pl.y);
                const points = Array.isArray(pl && pl.polygon) ? pl.polygon : [];
                if (!Number.isFinite(px) || !Number.isFinite(py) || points.length < 3) return null;
                const polygon = points.map(pt => ({
                  x: Number((pt && pt.x) || 0) + px,
                  y: Number((pt && pt.y) || 0) + py
                }));
                return polygon.length >= 3 ? polygon : null;
              })
              .filter(poly => Array.isArray(poly) && poly.length >= 3);
            const tight = this.normalizeOefPolygonsToTightBBox(internalPolygons);
            this.applyOefPrimitiveGeometryToRuntimeRow(row, tight, primitive);
            this.applyOefRuntimeAreaMetrics(row, baseTemplate, Math.max(2, Math.round(Number(primitive && primitive.pieces ? primitive.pieces : 2))));
            row.oef_generated = true;
            row.oef_runtime_units = Number(row.units);
            row.check = true;
            injectedMixed.push(row);
          });
        group.forEach(item => {
          item.check = false;
          item.units = 0;
        });
        if (remainderUnits > 0) {
          maxId += 1;
          const remainder = this.buildOefRuntimeRemainderRow(baseTemplate, maxId, remainderUnits);
          remainder.lot = (baseTemplate && baseTemplate.lot !== undefined && baseTemplate.lot !== null)
            ? baseTemplate.lot
            : 0;
          injectedMixed.push(remainder);
        }
        appliedMixed = true;
      });
      if (appliedMixed && injectedMixed.length > 0) {
        console.log('[OEF runtime] mixed families runtime applied:', injectedMixed.map(it => ({
          id: it.id,
          units: Number(it.units),
          width: Number(it.width),
          height: Number(it.height),
          oef: !!(it.oef_generated === true),
          oef_polygons: Array.isArray(it.oef_internal_polygons) ? it.oef_internal_polygons.length : 0
        })));
        return cloned.concat(injectedMixed);
      }
    }

    let dominantKey = null;
    let dominantUnits = 0;
    let dominantTrapKey = null;
    let dominantTrapUnits = 0;
    const trapPool = [];
    let trapPoolUnits = 0;
    Object.keys(groupedByKey).forEach(key => {
      const group = groupedByKey[key] || [];
      const units = group.reduce((acc, item) => acc + getRuntimeUnits(item), 0);
      if (units > dominantUnits) {
        dominantUnits = units;
        dominantKey = key;
      }
      const first = group.length > 0 ? group[0] : null;
      if (first) {
        const dims = this.getOefPieceBaseDimensions(first);
        const w = Number(dims && dims.width ? dims.width : 0);
        const h = Number(dims && dims.height ? dims.height : 0);
        const poly = this.getPiecePolygonTemplate(first, w, h);
        const isTrapGroup = this.isTrapezoidLikePiece(first, poly, w, h);
        if (isTrapGroup && units > dominantTrapUnits) {
          dominantTrapUnits = units;
          dominantTrapKey = key;
        }
        if (isTrapGroup) {
          group.forEach(item => trapPool.push(item));
          trapPoolUnits += units;
        }
      }
    });
    // Si los trapecios llegan fragmentados en varias claves (pequeñas variaciones),
    // se crea un pool común para que OEF pueda combinarlos igualmente.
    if (!dominantTrapKey && trapPool.length > 0 && trapPoolUnits >= 2) {
      dominantTrapKey = '__trap_pool__';
      dominantTrapUnits = trapPoolUnits;
      groupedByKey[dominantTrapKey] = trapPool;
    }
    // Si hay grupo trapecio válido, tiene prioridad para forzar la combinación OEF.
    if (dominantTrapKey && dominantTrapUnits >= 2) {
      dominantKey = dominantTrapKey;
      dominantUnits = dominantTrapUnits;
    }
    if (!dominantKey || dominantUnits < 2) {
      console.log('[OEF runtime] no dominant group with 2+ units', { dominantKey: dominantKey, dominantUnits: dominantUnits });
      return null;
    }

    const targetGroup = groupedByKey[dominantKey];
    const baseTemplate = targetGroup[0];
    const dominantIsForm38 = typeof dominantKey === 'string' && dominantKey.indexOf('f38|') >= 0;
    const baseDims = this.getOefPieceBaseDimensions(baseTemplate);
    const baseW = Number(baseDims && baseDims.width);
    const baseH = Number(baseDims && baseDims.height);
    const basePoly = this.getPiecePolygonTemplate(baseTemplate, baseW, baseH);
    const dominantIsTrap = this.isTrapezoidLikePiece(baseTemplate, basePoly, baseW, baseH);
    const selectedSorted = selected
      .slice()
      .filter(item => Number(item && item.pieces) >= 2 && Number(item && item.width) > 0 && Number(item && item.height) > 0)
      .sort((a, b) => Number(b.pieces) - Number(a.pieces));
    const isForm38RuntimeCandidate = (itemIn: any): boolean => {
      const src = itemIn && itemIn.source ? itemIn.source.toString() : '';
      return src.indexOf('form38_band_h_') === 0 || src.indexOf('form38_narrow_v_') === 0;
    };
    const rankForm38Candidate = (itemIn: any): number => {
      const src = itemIn && itemIn.source ? itemIn.source.toString() : '';
      let score = 0;
      if (src.indexOf('form38_band_h_') === 0) {
        score += 1000000;
      } else if (src.indexOf('form38_narrow_v_') === 0) {
        score += 800000;
      } else if (src.indexOf('form38_stack_v_') === 0) {
        score += 600000;
      }
      const pieces = Math.max(0, Math.round(Number(itemIn && itemIn.pieces ? itemIn.pieces : 0)));
      score += (pieces * 1000);
      const area = Number(itemIn && itemIn.width ? itemIn.width : 0) * Number(itemIn && itemIn.height ? itemIn.height : 0);
      if (Number.isFinite(area) && area > 0) {
        score -= Math.round(area);
      }
      const waste = Number(itemIn && itemIn.waste_pct !== undefined ? itemIn.waste_pct : 9999);
      if (Number.isFinite(waste)) {
        score -= waste;
      }
      return score;
    };
    const preSearchForm38Pool = preSearchPoolRaw
      .filter(item => Number(item && item.pieces) >= 2 && Number(item && item.width) > 0 && Number(item && item.height) > 0)
      .filter(item => isForm38RuntimeCandidate(item));
    const form38SelectedSorted = selectedSorted.filter(item => isForm38RuntimeCandidate(item));
    let candidateSourceSorted = selectedSorted;
    if (dominantIsForm38) {
      candidateSourceSorted = form38SelectedSorted.length > 0
        ? form38SelectedSorted
        : preSearchForm38Pool.slice().sort((a, b) => rankForm38Candidate(b) - rankForm38Candidate(a));
    }
    if (!candidateSourceSorted.length && !dominantIsTrap) {
      console.log('[OEF runtime] no selectedSorted and dominant is not trap');
      return null;
    }

    // Si existe candidato exacto para el número de piezas dominantes,
    // elegimos el más compacto (menor área de bounding-box) para evitar
    // primitvos "de columna" cuando hay alternativa interlock más eficiente.
    // IMPORTANTE: se limita a los candidatos seleccionados por usuario.
    const exactPool = [];
    candidateSourceSorted.forEach(item => {
      if (
        Math.round(Number(item && item.pieces)) === dominantUnits &&
        Number(item && item.width) > 0 &&
        Number(item && item.height) > 0
      ) {
        exactPool.push(item);
      }
    });
    const uniqueExact = [];
    const exactKeyMap = {};
    exactPool.forEach(item => {
      const key = Number(item.width).toFixed(2) + 'x' + Number(item.height).toFixed(2) + '|' +
        Number(item.pieces).toFixed(0) + '|' + (item.source ? item.source.toString() : '');
      if (!exactKeyMap[key]) {
        exactKeyMap[key] = true;
        uniqueExact.push(item);
      }
    });
    uniqueExact.sort((a, b) => {
      const aSrc = a && a.source ? a.source.toString() : '';
      const bSrc = b && b.source ? b.source.toString() : '';
      if (dominantIsForm38) {
        const aBandH = aSrc.indexOf('form38_band_h_') === 0 ? 1 : 0;
        const bBandH = bSrc.indexOf('form38_band_h_') === 0 ? 1 : 0;
        if (bBandH !== aBandH) {
          return bBandH - aBandH;
        }
      }
      if (dominantIsTrap) {
        const aTrapBand = (aSrc.indexOf('trap_band_h_') === 0 || aSrc.indexOf('trap_force_h_') === 0) ? 1 : 0;
        const bTrapBand = (bSrc.indexOf('trap_band_h_') === 0 || bSrc.indexOf('trap_force_h_') === 0) ? 1 : 0;
        if (bTrapBand !== aTrapBand) {
          return bTrapBand - aTrapBand;
        }
      }
      const aInterlock = aSrc.indexOf('triangle_interlock_') === 0 ? 1 : 0;
      const bInterlock = bSrc.indexOf('triangle_interlock_') === 0 ? 1 : 0;
      if (bInterlock !== aInterlock) {
        return bInterlock - aInterlock;
      }
      const aArea = Number(a.width) * Number(a.height);
      const bArea = Number(b.width) * Number(b.height);
      if (aArea !== bArea) {
        return aArea - bArea;
      }
      const aWaste = Number(a.waste_pct !== undefined ? a.waste_pct : 9999);
      const bWaste = Number(b.waste_pct !== undefined ? b.waste_pct : 9999);
      return aWaste - bWaste;
    });
    const exactCandidate = (uniqueExact.length > 0 ? uniqueExact[0] : null);
    const candidateQueue = exactCandidate
      ? [exactCandidate].concat(candidateSourceSorted.filter(item => item !== exactCandidate))
      : candidateSourceSorted;
    const trapAwareQueue = dominantIsTrap
      ? candidateQueue.filter(item => Number(item && item.pieces) >= 2)
      : candidateQueue;
    let runtimeQueue = trapAwareQueue;
    if (dominantIsTrap && trapAwareQueue.length === 0) {
      runtimeQueue = [this.buildForcedTrapRuntimePrimitive(baseTemplate, dominantUnits)];
      console.log('[OEF runtime] dominant trap, forced runtime queue used');
    } else if (dominantIsTrap) {
      console.log('[OEF runtime] dominant trap, selected runtime queue used:', trapAwareQueue.map(item => ({
        source: item && item.source ? item.source : '',
        pieces: Number(item && item.pieces ? item.pieces : 0),
        width: Number(item && item.width ? item.width : 0),
        height: Number(item && item.height ? item.height : 0)
      })));
    }
    if (dominantIsTrap && trapAwareQueue.length === 0) {
      const forcedPieces = Math.max(2, Math.min(6, Math.round(Number(dominantUnits || 2))));
      const forcedPlacements = [];
      const safeW = Number.isFinite(baseW) && baseW > 0 ? baseW : 1;
      const safeH = Number.isFinite(baseH) && baseH > 0 ? baseH : 1;
      const safePoly = (Array.isArray(basePoly) && basePoly.length >= 3)
        ? basePoly
        : [
            { x: 0, y: safeH },
            { x: safeW, y: safeH },
            { x: safeW * 0.8, y: 0 },
            { x: safeW * 0.2, y: 0 }
          ];
      for (let i = 0; i < forcedPieces; i++) {
        forcedPlacements.push({
          x: Number((i * safeW).toFixed(2)),
          y: 0,
          w: Number(safeW.toFixed(2)),
          h: Number(safeH.toFixed(2)),
          flip: false,
          polygon: safePoly
        });
      }
      const forcedPrimitive = {
        width: Number((safeW * forcedPieces).toFixed(2)),
        height: Number(safeH.toFixed(2)),
        pieces: forcedPieces,
        waste_pct: 0,
        placements: forcedPlacements,
        source: 'trap_runtime_force_' + forcedPieces
      };
      runtimeQueue = [forcedPrimitive];
    }

    const form38PlanCandidatesRaw = dominantIsForm38
      ? runtimeQueue
          .slice()
          .filter(item =>
            item &&
            isForm38RuntimeCandidate(item) &&
            Number(item.pieces) >= 2 &&
            Number(item.width) > 0 &&
            Number(item.height) > 0
          )
      : [];
    let form38PlanCandidates = form38PlanCandidatesRaw.slice();
    if (form38PlanCandidates.length > 0) {
      const nonStack = form38PlanCandidates.filter(item => {
        const src = item && item.source ? item.source.toString() : '';
        return src.indexOf('form38_stack_v_') !== 0;
      });
      if (nonStack.length > 0) {
        form38PlanCandidates = nonStack;
      }
      form38PlanCandidates = form38PlanCandidates.sort((a, b) => rankForm38Candidate(b) - rankForm38Candidate(a));
    }
    let form38PlanByUnits = null;
    if (dominantIsForm38 && form38PlanCandidates.length > 0) {
      const bestByPieces = {};
      form38PlanCandidates.forEach(item => {
        const pieces = Math.max(2, Math.round(Number(item && item.pieces ? item.pieces : 0)));
        if (pieces > dominantUnits) {
          return;
        }
        if (!bestByPieces[pieces] || rankForm38Candidate(item) > rankForm38Candidate(bestByPieces[pieces])) {
          bestByPieces[pieces] = item;
        }
      });
      const pieceSizes = Object.keys(bestByPieces)
        .map(key => Number(key))
        .filter(size => Number.isFinite(size) && size >= 2 && size <= dominantUnits)
        .sort((a, b) => b - a);
      if (pieceSizes.length > 0) {
        const dp = new Array(dominantUnits + 1).fill(null);
        dp[0] = {
          totalPacks: 0,
          totalArea: 0,
          counts: {}
        };
        for (let u = 1; u <= dominantUnits; u++) {
          for (let i = 0; i < pieceSizes.length; i++) {
            const size = pieceSizes[i];
            const prev = u - size;
            if (prev < 0 || !dp[prev]) {
              continue;
            }
            const primitive = bestByPieces[size];
            if (!primitive) {
              continue;
            }
            const primArea = Number(primitive.width) * Number(primitive.height);
            const candidateState = {
              totalPacks: Number(dp[prev].totalPacks) + 1,
              totalArea: Number(dp[prev].totalArea) + (Number.isFinite(primArea) && primArea > 0 ? primArea : 0),
              counts: Object.assign({}, dp[prev].counts)
            };
            candidateState.counts[size] = (Number(candidateState.counts[size]) || 0) + 1;
            const current = dp[u];
            const better = !current ||
              candidateState.totalArea < current.totalArea ||
              (candidateState.totalArea === current.totalArea && candidateState.totalPacks < current.totalPacks);
            if (better) {
              dp[u] = candidateState;
            }
          }
        }
        if (dp[dominantUnits]) {
          form38PlanByUnits = dp[dominantUnits].counts;
          console.log('[OEF runtime] form38 exact plan:', {
            dominantUnits: dominantUnits,
            plan: form38PlanByUnits
          });
          const plannedQueue = [];
          Object.keys(form38PlanByUnits)
            .map(key => Number(key))
            .sort((a, b) => b - a)
            .forEach(size => {
              const packs = Number(form38PlanByUnits[size]) || 0;
              if (packs <= 0) {
                return;
              }
              const primitive = bestByPieces[size];
              if (!primitive) {
                return;
              }
              plannedQueue.push(Object.assign({}, primitive, { oef_forced_packs: packs }));
            });
          if (plannedQueue.length > 0) {
            runtimeQueue = plannedQueue;
          }
        }
      }
    }

    let maxId = 0;
    cloned.forEach(item => {
      const id = Number(item && item.id);
      if (Number.isFinite(id) && id > maxId) {
        maxId = id;
      }
    });

    const injected = [];
    let remainingUnits = dominantUnits;
    runtimeQueue.forEach(primitive => {
      const groupSize = Math.max(2, Math.round(Number(primitive.pieces)));
      const forcedPacks = Number(primitive && primitive.oef_forced_packs);
      const packs = (Number.isFinite(forcedPacks) && forcedPacks > 0)
        ? Math.round(forcedPacks)
        : Math.floor(remainingUnits / groupSize);
      if (packs <= 0) {
        return;
      }
      maxId += 1;
      const row = JSON.parse(JSON.stringify(baseTemplate));
      row.id = maxId;
      row.units = packs;
      row.width = Number(primitive.width);
      row.height = Number(primitive.height);
      // El primitivo OEF se inyecta como rectángulo externo para que el
      // optimizador ordinario lo apoye al borde de plancha y aproveche mejor.
      const runtimeBaseFigureRaw = Number(baseTemplate && (
        baseTemplate.piece_figure_input !== undefined && baseTemplate.piece_figure_input !== null
          ? baseTemplate.piece_figure_input
          : baseTemplate.figure
      ));
      const runtimeBaseFigure = (Number.isFinite(runtimeBaseFigureRaw) && runtimeBaseFigureRaw > 0) ? Math.round(runtimeBaseFigureRaw) : 0;
      row.figure = runtimeBaseFigure;
      row.piece_figure_input = runtimeBaseFigure;
      row.dxf_points = null;
      row.piece_dxf_points = null;
      row.dxf_name = '';
      let internalPolygons = (primitive.placements || [])
        .map(pl => {
          const px = Number(pl && pl.x);
          const py = Number(pl && pl.y);
          const points = Array.isArray(pl && pl.polygon) ? pl.polygon : [];
          if (!Number.isFinite(px) || !Number.isFinite(py) || points.length < 3) {
            return null;
          }
          const polygon = points.map(pt => ({
            x: Number((pt && pt.x) || 0) + px,
            y: Number((pt && pt.y) || 0) + py
          }));
          return polygon.length >= 3 ? polygon : null;
        })
        .filter(poly => Array.isArray(poly) && poly.length >= 3);
      const primitiveSource = primitive && primitive.source ? primitive.source.toString() : '';
      const shouldAddForm38Caps = this.isForm38Piece(baseTemplate) &&
        (primitiveSource.indexOf('form38_band_h_') === 0 || primitiveSource.indexOf('form38_narrow_v_') === 0);
      if (shouldAddForm38Caps) {
        const isVerticalStrip = primitiveSource.indexOf('form38_narrow_v_') === 0;
        const synthetic = this.buildSyntheticForm38StripPolygons(
          Number(primitive.width),
          Number(primitive.height),
          Number(primitive.pieces),
          isVerticalStrip
        );
        if (synthetic.length > 0) {
          internalPolygons = synthetic;
        } else {
          const autoCaps = this.buildForm38AutoEndCaps(internalPolygons, Number(primitive.width), Number(primitive.height));
          if (autoCaps.length > 0) {
            internalPolygons = internalPolygons.concat(autoCaps);
          }
          const sideFillers = this.buildOefSideFillPolygonsToBBox(internalPolygons);
          if (sideFillers.length > 0) {
            internalPolygons = internalPolygons.concat(sideFillers);
          }
        }
      }
      const tight = this.normalizeOefPolygonsToTightBBox(internalPolygons);
      this.applyOefPrimitiveGeometryToRuntimeRow(row, tight, primitive);
      this.applyOefRuntimeAreaMetrics(row, baseTemplate, Number(groupSize));
      row.oef_generated = true;
      row.oef_runtime_units = Number(row.units);
      row.check = true;
      injected.push(row);
      remainingUnits -= packs * groupSize;
    });

    targetGroup.forEach(item => {
      item.check = false;
      item.units = 0;
    });
    if (remainingUnits > 0) {
      maxId += 1;
      const remainder = this.buildOefRuntimeRemainderRow(baseTemplate, maxId, remainingUnits);
      injected.push(remainder);
    }

    if (!injected.length) {
      return null;
    }
    return cloned.concat(injected);
  }


  hideGraphic(actualSheetIn): void {

    // console.log('-->--> hideGraphic. Hoja actual visualizada = ' + actualSheetIn);

    if (actualSheetIn === 0) {
      this.actual_sheet = 0;
    }

    // Se obtiene el canvas perteneciente a la hoja actual y se esconde el resto.
    let id_canvas = 'canvasGraphic' + actualSheetIn.toString();

    // let canvas_aux = document.getElementById(id_canvas);

    let children = this.graphic_container.childNodes;

    // console.log('-->--> hideGraphic graphic children:');
    // console.log(children);

    let info_ok = 0;

    // Se esconden todos los hijos.
    children.forEach((sheet, i) => {
      sheet.setAttribute('hidden', 'hidden');
    });

    // Se muestran sólo los que deben aparecer en la página actual.
    children.forEach((sheet, i) => {
      // console.log('-->--> sheet ' + i);
      // console.log(sheet);

      let hidden = sheet.getAttribute('hidden');

      if (actualSheetIn === i + 1 || actualSheetIn === 0) {

        info_ok++;

        if (hidden) {

          // console.log('--> Mostrando hijo: ' + (i + 1));
          sheet.removeAttribute('hidden');

          for (let h = 1; h < this.num_page_children; h++) {
            // console.log('--> sub-hijo: ' + (i + 1 + h));

            if (i + h < children.length) {
              children[i + h].removeAttribute('hidden');
            }
          }
        }
      }
    });

  } // End function hideGraphic

  buttonNextGraphic(): void {

    console.log('-->--> Pulsado buttonNextGraphic.');

    if (this.actual_sheet === 0) {
      this.actual_sheet++;
    } else {
      this.actual_sheet += this.num_page_children;
    }

    this.hideGraphic(this.actual_sheet);

  } // End function buttonNextGraphic

  buttonFirstGraphic(): void {

    console.log('-->--> Pulsado buttonFirstGraphic.');

    this.actual_sheet = 1;
    this.hideGraphic(this.actual_sheet);

  } // End function buttonFirstGraphic

  buttonLastGraphic(): void {

    console.log('-->--> Pulsado buttonLastGraphic.');

    const total = this.graphic_container && this.graphic_container.childNodes
      ? this.graphic_container.childNodes.length
      : 0;

    if (total <= 0) {
      this.actual_sheet = 0;
      this.hideGraphic(0);
      return;
    }

    const maxFirst = Math.max(1, total - this.num_page_children + 1);
    this.actual_sheet = maxFirst;
    this.hideGraphic(this.actual_sheet);

  } // End function buttonLastGraphic

  buttonBeforeGraphic(): void {

    console.log('-->--> Pulsado buttonBeforeGraphic.');

    this.actual_sheet -= this.num_page_children;

    if (this.actual_sheet < 0) {
      this.actual_sheet = 0;
    }

    this.hideGraphic(this.actual_sheet);

  } // End function buttonBeforeGraphic

  // Función que dado un listado de piezas las modifica para
  // que su lado mayor sea la base de la pieza (ancho).
  // También comprueba que todas las piezas tengan un espesor
  // y si no es así le asigna un valor por defecto.
  setBaseMaxSide(pieceListIn: any) {

	let depth_aux = this.default_depth; // Espesor por defecto de un material.

	if (this.sheetList_datafile && this.sheetList_datafile[0] && this.sheetList_datafile[0].depth) {

		console.log('-->> setBaseMaxSide espesor de la primera hoja =');
		console.log(this.sheetList_datafile[0]);

		// Se coge el espesor de la primera hoja cargada para usarlo por defecto.
		depth_aux = this.sheetList_datafile[0].depth;
	}

	pieceListIn.forEach(p => {

		      // Si la pieza no tiene espesor se le pone 4mm por defecto.
      	if (!p.stock_length) p['stock_length'] = depth_aux;

		// Se modifica para que la base sea el lado mayor de la pieza.
		if (p.height > p.width) {
			let width_aux = p.width;
          	p.width = p.height;
          	p.height = width_aux;
		}
	});

	// console.log('-> setBaseMaxSide pieceListIn =');
	// console.log(pieceListIn);

  } // End function setBaseMaxSide.

  setBaseMinSide(pieceListIn: any) {

	let depth_aux = this.default_depth; // Espesor por defecto de un material.

	if (this.sheetList_datafile && this.sheetList_datafile[0] && this.sheetList_datafile[0].depth) {

		console.log('-->> setBaseMinSide espesor de la primera hoja =');
		console.log(this.sheetList_datafile[0]);

		// Se coge el espesor de la primera hoja cargada para usarlo por defecto.
		depth_aux = this.sheetList_datafile[0].depth;
	}

	pieceListIn.forEach(p => {

		      // Si la pieza no tiene espesor se le pone 4mm por defecto.
      	if (!p.stock_length) p['stock_length'] = depth_aux;

		// Se modifica para que la base sea el lado menor de la pieza.
		if (p.width > p.height) {
			let width_aux = p.width;
          	p.width = p.height;
          	p.height = width_aux;
		}
	});

	// console.log('-> setBaseMinSide pieceListIn =');
	// console.log(pieceListIn);

  } // End function setBaseMinSide.


  // ---------------------------------
  //    FUNCIONES DE FILTRADO
  // ---------------------------------

  filterPieceFile(element: any): boolean {
    console.log('filterPieceFile Item: ');
    console.log(element);

      if (element['type_content'] === 'piece') {
      return true;
    }
    return false;
  } // End function filterPieceFile

  filterSheetFile(element: any): boolean {
    console.log('filterSheetFile Item: ');
    console.log(element);

      if (element['type_content'] === 'sheet') {
      return true;
    }
    return false;
  } // End function filterSheetFile


  // ---------------------------------
  //    FUNCIONES DESCARGA ARCHIVOS
  // ---------------------------------

  buttonDownloadFile() {
    console.log('-->  buttonDownloadFile: pulsado botón descargar optimización...');

    // Modo A: Para lanzar la descarga en el navegador (se le pasa la url directamente).
    // window.open('./assets/attachments/budgets/csv_products.csv');
    // window.open('./assets/attachments/budgets/csv_packages.csv');

    // IMPORTANTE: Hacer que no pueda seguir hasta no recibir
    // Leemos el archivo del servidor con nombre "csv_packages.csv" y se guarda su contenido en la variable.
    // NO sirve.
    // await this.readFileList(['csv_products.csv', 'csv_packages.csv']);

    // Modo B: Al ejecutar readFile lee del servidor el archivo cuyo nombre es pasado como parámetro.
    // Además automáticamente hace que su contenido se descargue directamente en el navegador.
    // this.readFile.emit({file_name: 'csv_products.csv'});
    // this.readFile.emit({file_name: 'csv_packages.csv'});

    // Modo C: Al construir anteriormente el CSV emitiendo con la función "makeCsvBudget"
    // se colocan los datos de esos archivos en la variable Redux "fileList".
    // Ahora se recorren todos los archivos almacenados en esa variable y se descargan uno a uno en el navegador.
    // NOTA: Se ha escogido este método por si hubiese varios usuarios a la vez creando archivos que no haya
    // peligro cuando se machacan en el servidor los archivos "csv_products.csv" y "csv_packages.csv", ya
    // que cada usuario va a tener una copia de la información estimada en su variable Redux "fileList".
    this.fileList.forEach ((file, index) => {
      this.auxFunction.downloadFile(file);
    });

    console.log('-->  buttonDownloadFile: terminadas todas las lecturas de archivos.');

  } // End function buttonDownloadFile

  // -----------

  // Función que seleccionaa todas las planchas cargadas.
  selectAllSheets() {

    console.log('selectAllSheets: ');

    let infinite = false;

    this.totalSelectedSheets = 0;

    // Señalamos todo el listdo como "marcado".
    this.sheetList_datafile.forEach((st, index) => {
      st['check'] = true;
    });

  } // End function selectAllSheets

  // Función que cuenta el total de planchas cargadas.
  // Si alguna tiene su espesor a cero entonces le asigna el valor por defecto.
  countTotalSheets() {

    console.log('countTotalSheets: ');

    let infinite = false;

    this.totalSelectedSheets = 0;

    // Señalamos todo el listdo como "marcado".
    this.sheetList_datafile.forEach((st, index) => {

	  // console.log('countTotalSheets st: ');
	  // console.log('st: ');

      if (st['check']) {
		this.totalSelectedSheets += st['unit'];

        if (st['unit'] === -1) infinite = true;
	  }

	  if (!st['depth'] || st['depth'] === 0) {

		st['depth'] = this.default_depth;

		console.log('-> Encontrada hoja sin espesor.');
		console.log(st);
      }
    });

    // Con que exista una plancha con infinitas unidades se
    //  mostrará el total también como infinito.
    if (infinite) this.totalSelectedSheets = -1;

  } // End function countTotalSheets

  // Modifica un campo numérico de una plancha.
  sheetChangeNumber(event: any, sheetIn: any, fieldIn: string) {
    console.log('sheetChangeNumber: ' + fieldIn);
    console.log(sheetIn);

    console.log('->> sheetChangeNumber event:');
    console.log(event.target.value);

    const previousValue = Number(sheetIn && sheetIn[fieldIn] !== undefined && sheetIn[fieldIn] !== null ? sheetIn[fieldIn] : 0);
    let valueIn = Number(event.target.value);

    if (fieldIn === 'width' || fieldIn === 'height') {
      const candidateWidth = fieldIn === 'width'
        ? (valueIn > 0 ? valueIn : 1)
        : Number(sheetIn && sheetIn.width ? sheetIn.width : 0);
      const candidateHeight = fieldIn === 'height'
        ? (valueIn > 0 ? valueIn : 1)
        : Number(sheetIn && sheetIn.height ? sheetIn.height : 0);

      const tableLimits = this.getSelectedCuttingTableSheetLimits();
      if (tableLimits && tableLimits.width > 0 && tableLimits.height > 0) {
        if (candidateWidth > tableLimits.width || candidateHeight > tableLimits.height) {
          const prevSafe = previousValue > 0 ? previousValue : 1;
          sheetIn[fieldIn] = prevSafe;
          if (event && event.target) {
            event.target.value = prevSafe;
          }
          const tableLabel = tableLimits.name ? tableLimits.name : 'seleccionada';
          const message =
            'La mesa de corte "' + tableLabel + '" no permite usar esta medida de hoja. ' +
            'Máximo permitido: ' + tableLimits.width + ' x ' + tableLimits.height + ' mm.';
          this.alertInfo = message;
          this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
          return;
        }
      }
    }

    if (fieldIn === 'unit' && sheetIn['check']) {

	    // Se le quita el valor anterior al total de hojas y se le añade el nuevo.
	    this.totalSelectedSheets -= sheetIn['unit'];
	    this.totalSelectedSheets += valueIn;
	}

    if (valueIn === -1 || valueIn === 0) {
      sheetIn[fieldIn] = valueIn;
    } else {
      // Se actuliza también el valor en el target para que se visualice en la pestaña de piezas.
      sheetIn[fieldIn] = event.target.value = valueIn > 0 ? valueIn : 1;
    }

    //this.countTotalSheets();

    // El ancho de la hoja más grande usada será colocado automáticamente como "max travera".
	let max_trav_aux = this.calculateMaxTrav();

	this.fileForm.controls.f_max_diecutting.setValue(max_trav_aux);

  } // End function sheetChangeNumber

  private getSelectedCuttingTableSheetLimits(): any {
    if (!this.fileForm || !this.fileForm.controls || !this.cuttingTables || this.cuttingTables.length < 1) {
      return null;
    }

    const selectedId = Number(this.fileForm.controls.f_cutting_table_id.value);
    if (!(selectedId > 0)) return null;

    const selectedTable = this.cuttingTables.find(item => Number(item.id) === selectedId);
    if (!selectedTable) return null;

    const master = this.parseCuttingTableMasterData(selectedTable);
    if (!master) return null;

    return {
      name: selectedTable && selectedTable.name ? selectedTable.name.toString() : '',
      width: Number(master.sheet_width || 0),
      height: Number(master.sheet_height || 0)
    };
  }

  // Modifica un campo numérico de una pieza.
  formChangeAngle1(event: any, pieceIn: any, fieldIn: string) {
    console.log('formChangeAngle1: ' + fieldIn);
    console.log(pieceIn);

    console.log('->> formChangeAngle1 event:');
    console.log(event.target.value);

    let valueIn = Number(event.target.value);

    this.figureForm.controls.figure_r.setValue(180 - valueIn);

  } // End function formChangeAngle1

  // Modifica un campo numérico de una pieza.
  formChangeAngle2(event: any, pieceIn: any, fieldIn: string) {
    console.log('formChangeAngle2: ' + fieldIn);
    console.log(pieceIn);

    console.log('->> formChangeAngle2 event:');
    console.log(event.target.value);

    let valueIn = Number(event.target.value);

    this.figureForm.controls.figure_l2.setValue(180 - valueIn);

  } // End function formChangeAngle2

  // Modifica un campo numérico de una pieza.
  pieceChangePaneno(event: any, pieceIn: any, fieldIn: string) {
    console.log('pieceChangePaneno: ' + fieldIn);
    console.log(pieceIn);

    console.log('->> pieceChangePaneno event:');
    console.log(event.target.value);

    let valueIn = Number(event.target.value);

    pieceIn.paneno = valueIn;

  } // End function pieceChangePaneno.

  // Modifica un campo numérico de una pieza.
  pieceChangeNumber(event: any, pieceIn: any, fieldIn: string) {
    console.log('pieceChangeNumber: ' + fieldIn);
    console.log(pieceIn);

    console.log('->> pieceChangeNumber event:');
    console.log(event.target.value);

    let valueIn = Number(event.target.value);

    if (fieldIn === 'units' && pieceIn['check']) {
      // En filas OEF compuestas "units" puede ser packs y no unidades reales.
      const beforeUnits = this.getSelectedPieceUnits(pieceIn);
      const nextUnits = (valueIn > 0 ? valueIn : 1);
      const simulated = Object.assign({}, pieceIn, { units: nextUnits });
      const realUnitsPerPack = Math.max(
        1,
        Math.round(
          Number(
            pieceIn && (
              pieceIn.oef_real_units !== undefined
                ? pieceIn.oef_real_units
                : pieceIn.piece_oef_real_units
            )
          ) || 1
        )
      );
      if (realUnitsPerPack > 1) {
        simulated.oef_runtime_units = Math.max(1, Math.round(nextUnits / realUnitsPerPack));
      }
      const afterUnits = this.getSelectedPieceUnits(simulated);
      this.totalSelectedPieces -= beforeUnits;
      this.totalSelectedPieces += afterUnits;
    }

    pieceIn[fieldIn] = event.target.value = valueIn > 0 ? valueIn : 1;
    if (fieldIn === 'units') {
      const realUnitsPerPack = Math.max(
        1,
        Math.round(
          Number(
            pieceIn && (
              pieceIn.oef_real_units !== undefined
                ? pieceIn.oef_real_units
                : pieceIn.piece_oef_real_units
            )
          ) || 1
        )
      );
      if (realUnitsPerPack > 1) {
        pieceIn.oef_runtime_units = Math.max(1, Math.round(Number(pieceIn[fieldIn]) / realUnitsPerPack));
      }
    }

  } // End function pieceChangeNumber

  pieceChangePriority(pieceIn: any, eventIn: any): void {
    if (!pieceIn) {
      return;
    }
    pieceIn.priority = eventIn && eventIn.target && eventIn.target.checked ? 1 : 0;
  }

  // Modifica un campo numérico de una pieza.
  pieceChangeSteps(event: any, pieceIn: any, fieldIn: string) {
    console.log('pieceChangeSteps: ' + fieldIn);
    console.log(pieceIn);

    console.log('->> pieceChangeSteps event:');
    console.log(event.target.value);

    let valueIn = '';

    if(event.target.value) valueIn = event.target.value.toString();

    pieceIn[fieldIn] = valueIn;

  } // End function pieceChangeSteps


  // Modifica un campo de texto de una pieza.
  pieceChangeText(event: any, pieceIn: any, fieldIn: string) {
    console.log('pieceChangeText: ' + fieldIn);
    console.log(pieceIn);

    console.log('->> pieceChangeText event:');
    console.log(event.target.value);

    let valueIn = event.target.value.toString();

    pieceIn[fieldIn] = valueIn;

  } // End function pieceChangeText

  // Modifica un campo numérico de una pieza.
  getFigureThumbPath(figureIdIn: number): string {
    if (Number(figureIdIn) === 926 || Number(figureIdIn) === 2026 || Number(figureIdIn) === 63) return 'assets/forms/form_0.png';
    return 'assets/forms/form_' + figureIdIn + '.png';
  }

  getFigureCatalogLabel(figureIdIn: number): string {
    if (Number(figureIdIn) === 926) return 'Forma DXF 926';
    return 'Forma ' + figureIdIn;
  }

  getFigureTags(figureIdIn: number): string[] {
    const figureId = Number(figureIdIn);
    const tags: string[] = [];

    if ([926, 2026, 63].includes(figureId)) {
      tags.push('dxf', 'especial');
    }

    // Familias solicitadas por operación (admiten solapes).
    if ([37, 38, 371, 372].includes(figureId)) {
      tags.push('paralelogramos');
    }

    if ([51, 60, 61].includes(figureId)) {
      tags.push('medio puntos');
    }

    if ([1, 2, 3, 4, 9, 10].includes(figureId)) {
      tags.push('esquinas');
    }

    if ([19, 21, 22, 23, 24].includes(figureId)) {
      tags.push('poliedros');
    }

    if ([25, 26, 27, 28, 52, 53, 54, 57, 59, 60, 61, 62].includes(figureId)) {
      tags.push('tapas');
    }

    if ([30, 31, 32, 33, 34, 35, 36].includes(figureId)) {
      tags.push('dobles');
    }

    if ([20, 21, 22, 23, 24].includes(figureId)) {
      tags.push('triángulos');
    }

    if ([5, 6, 7, 8, 33, 34, 35, 36].includes(figureId)) {
      tags.push('trapecios');
    }

    if ([50].includes(figureId)) {
      tags.push('medio punto');
    }

    if ([29].includes(figureId)) {
      tags.push('círculos');
    }

    if ([0, 1, 2, 55].includes(figureId)) {
      tags.push('rectángulos');
    }

    if ([44, 45, 46, 47, 48, 49, 51, 52, 53, 54, 56, 57, 58, 59, 60, 61, 62].includes(figureId)) {
      tags.push('especiales');
    }

    if (tags.length < 1) {
      tags.push('catálogo');
    }

    return Array.from(new Set(tags));
  }

  getFigureCatalogTagOptions(): string[] {
    const tagMap = {};
    (this.figureCatalogIds || []).forEach((id) => {
      this.getFigureTags(id).forEach((tag) => {
        tagMap[tag] = true;
      });
    });
    return Object.keys(tagMap).sort((a, b) => a.localeCompare(b));
  }

  isFigureTagSelected(tagIn: string): boolean {
    return (this.figureCatalogTagFilter || '').toLowerCase() === (tagIn || '').toLowerCase();
  }

  toggleFigureTagFilter(tagIn: string) {
    const tag = (tagIn || '').toLowerCase();
    if (this.figureCatalogTagFilter === tag) {
      this.figureCatalogTagFilter = '';
      return;
    }
    this.figureCatalogTagFilter = tag;
  }

  getFilteredFigureCatalogIds(): number[] {
    const filter = (this.figureCatalogFilter || '').trim();
    const filterLower = filter.toLowerCase();
    const tagFilter = (this.figureCatalogTagFilter || '').trim().toLowerCase();
    return this.figureCatalogIds.filter((id) => {
      const idTxt = String(id);
      const label = this.getFigureCatalogLabel(id).toLowerCase();
      const tags = this.getFigureTags(id).map((t) => t.toLowerCase());

      let matchesText = true;
      if (filterLower.length > 0) {
        matchesText = false;
        if (idTxt.indexOf(filter) !== -1) matchesText = true;
        if (!matchesText && label.indexOf(filterLower) !== -1) matchesText = true;
        if (!matchesText && Number(id) === 926 && filterLower === 'dxf') matchesText = true;
        if (!matchesText && tags.some((tag) => tag.indexOf(filterLower) !== -1)) matchesText = true;
      }

      let matchesTag = true;
      if (tagFilter.length > 0) {
        matchesTag = tags.includes(tagFilter);
      }

      return matchesText && matchesTag;
    });
  }

  isFigureCatalogSelected(figureIdIn: number): boolean {
    const currentValue = Number(this.figureForm.controls.figure_id.value);
    return currentValue === Number(figureIdIn);
  }

  isDxfFigureSelected(): boolean {
    const formId = Number(this.figureForm.controls.figure_id.value);
    return formId === 926 || formId === 2026 || formId === 63;
  }

  private normalizeDxfPoints(pointsIn: any): any[] {
    if (!pointsIn) return [];
    let pointsAux = pointsIn;
    if (typeof pointsAux === 'string') {
      try {
        pointsAux = JSON.parse(pointsAux);
      } catch (error) {
        return [];
      }
    }
    if (!Array.isArray(pointsAux)) return [];
    return pointsAux
      .map((p) => {
        const x = Number(p && p.x !== undefined ? p.x : 0);
        const y = Number(p && p.y !== undefined ? p.y : 0);
        return { x: x, y: y };
      })
      .filter((p) => !isNaN(p.x) && !isNaN(p.y));
  }

  getDxfPreviewData(): any {
    if (!this.isDxfFigureSelected()) return null;
    const pointsRaw = this.normalizeDxfPoints(this.figureDxfPoints);
    if (!pointsRaw || pointsRaw.length < 3) return null;
    const xs = pointsRaw.map(p => Number(p.x || 0));
    const ys = pointsRaw.map(p => Number(p.y || 0));
    const minX = Math.min.apply(null, xs);
    const maxX = Math.max.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxY = Math.max.apply(null, ys);
    const shapeW = maxX - minX;
    const shapeH = maxY - minY;
    if (!(shapeW > 0 && shapeH > 0)) return null;

    const B1 = Number(this.figureForm.controls.figure_b1.value || 0);
    const B2 = Number(this.figureForm.controls.figure_b2.value || 0);
    const B3 = Number(this.figureForm.controls.figure_b3.value || 0);
    const B4 = Number(this.figureForm.controls.figure_b4.value || 0);

    const W0 = B1 + shapeW + B3;
    const H0 = B2 + shapeH + B4;
    if (!(W0 > 0 && H0 > 0)) return null;

    const margin = 28;
    const innerW = 224;
    const innerH = 132;
    const svgW = (margin * 2) + innerW;
    const svgH = (margin * 2) + innerH;
    const scale = Math.min(innerW / W0, innerH / H0);
    const drawW = W0 * scale;
    const drawH = H0 * scale;
    const offX = margin + ((innerW - drawW) / 2);
    const offY = margin + ((innerH - drawH) / 2);

    const toSvgX = (xIn) => offX + (xIn * scale);
    const toSvgY = (yIn) => offY + ((H0 - yIn) * scale);

    const contourNorm = pointsRaw.map(p => ({
      x: (Number(p.x || 0) - minX) + B1,
      y: (Number(p.y || 0) - minY) + B2
    }));
    const polylinePoints = contourNorm.map(p => (toSvgX(p.x).toFixed(2) + ',' + toSvgY(p.y).toFixed(2))).join(' ');

    const xB1 = toSvgX(B1);
    const xB3 = toSvgX(B1 + shapeW);
    const yTop = offY;
    const yBottom = offY + drawH;
    const yMid = offY + (drawH / 2);

    return {
      svgW: svgW,
      svgH: svgH,
      rectX: offX,
      rectY: offY,
      rectW: drawW,
      rectH: drawH,
      polylinePoints: polylinePoints,
      xB1: xB1,
      xB3: xB3,
      yTop: yTop,
      yBottom: yBottom,
      yMid: yMid,
      lblB1x: Math.max(4, offX - 20),
      lblB1y: yMid + 5,
      lblB2x: offX + (drawW / 2),
      lblB2y: Math.max(14, offY - 10),
      lblB3x: Math.min(svgW - 4, offX + drawW + 20),
      lblB3y: yMid + 5,
      lblB4x: offX + (drawW / 2),
      lblB4y: Math.min(svgH - 4, offY + drawH + 16)
    };
  }

  private figure61MinRadiusCacheKey = '';
  private figure61MinRadiusCacheValue = 0;

  private resolveFigure61BestArc(xL: number, xR: number, yB: number, yT: number, R: number): any {
    const cx = (xL + xR) / 2;
    const cy = (yB + yT) / 2;
    const halfL = Math.abs(xR - xL) / 2;
    const halfH = Math.abs(yT - yB) / 2;
    if (!(R > Math.max(halfL, halfH) + 0.000001)) return null;

    const ySpan = Math.sqrt(Math.max(0, (R * R) - (halfL * halfL)));
    const xSpan = Math.sqrt(Math.max(0, (R * R) - (halfH * halfH)));
    const pStart = { x: cx + xSpan, y: yB };
    const pEnd = { x: xL, y: cy + ySpan };
    const a0 = Math.atan2(pStart.y - cy, pStart.x - cx);
    const a1 = Math.atan2(pEnd.y - cy, pEnd.x - cx);
    let daCcw = a1 - a0;
    while (daCcw <= 0) daCcw += (2 * Math.PI);
    const daCw = daCcw - (2 * Math.PI);
    const scoreDa = (daIn) => {
      const nEval = 64;
      let score = -999999;
      for (let i = 1; i < nEval; i++) {
        const t = i / nEval;
        const a = a0 + (daIn * t);
        const x = cx + (R * Math.cos(a));
        const y = cy + (R * Math.sin(a));
        const s = (x - xL) + (y - yB);
        if (s > score) score = s;
      }
      return score;
    };
    const da = (scoreDa(daCcw) >= scoreDa(daCw)) ? daCcw : daCw;
    return { c: { x: cx, y: cy, a0: a0 }, da: da, pStart: pStart, pEnd: pEnd };
  }

  private computeFigure61ContainmentMinRadius(LIn: any, HIn: any): number {
    const L = Number(LIn || 0);
    const H = Number(HIn || 0);
    if (!(L > 0 && H > 0)) return 0;

    const cacheKey = `${L.toFixed(6)}|${H.toFixed(6)}`;
    if (cacheKey === this.figure61MinRadiusCacheKey) return this.figure61MinRadiusCacheValue;

    const high = Math.max(L / 2, H / 2) + 0.000001;
    this.figure61MinRadiusCacheKey = cacheKey;
    this.figure61MinRadiusCacheValue = high;
    return high;
  }

  private ensureFigure61RadiusControlEnabled() {
    if (!this.figureForm || !this.figureForm.controls) return;
    const formId = Number(this.figureForm.controls.figure_id ? this.figureForm.controls.figure_id.value : 0);
    if (formId !== 61) return;
    const rCtrl = this.figureForm.controls.figure_r;
    if (rCtrl && rCtrl.disabled) rCtrl.enable();
  }

  getCatalogPreviewData(): any {
    const formId = Number(this.figureForm.controls.figure_id.value);
    if ((formId < 1 || formId > 62) && formId !== 371 && formId !== 372) return null;

    const toN = (v, d) => {
      const n = Number(v);
      return isNaN(n) ? d : n;
    };

    const B1 = Math.max(0, toN(this.figureForm.controls.figure_b1.value, 0));
    const B2 = Math.max(0, toN(this.figureForm.controls.figure_b2.value, 0));
    const B3 = Math.max(0, toN(this.figureForm.controls.figure_b3.value, 0));
    const B4 = Math.max(0, toN(this.figureForm.controls.figure_b4.value, 0));
    const L = Math.max(0, toN(this.figureForm.controls.figure_l.value, 0));
    const L1 = Math.max(0, toN(this.figureForm.controls.figure_l1.value, 0));
    const L2 = Math.max(0, toN(this.figureForm.controls.figure_l2.value, 0));
    const H = Math.max(0, toN(this.figureForm.controls.figure_h.value, 0));
    const H1 = Math.max(0, toN(this.figureForm.controls.figure_h1.value, 0));
    const H2 = Math.max(0, toN(this.figureForm.controls.figure_h2.value, 0));

    let W0 = 0;
    let H0 = 0;
    const contour = [];
    const aux = [];
    const auxPolylines = [];

    if (formId === 1) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B3 + L + B1;
      H0 = H + B2;
      const xL = B3;
      const xR = B3 + L;
      const yB = 0;
      const yTL = H;
      const yTR = Math.max(0, H1);
      contour.push({ x: xL, y: yB }, { x: xL, y: yTL }, { x: xR, y: yTR }, { x: xR, y: yB }, { x: xL, y: yB });
      aux.push({ x1: xL, y1: 0, x2: xL, y2: H0 }, { x1: xR, y1: 0, x2: xR, y2: H0 });
    } else if (formId === 2) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B3 + L + B1;
      H0 = H + B2;
      const xL = B3;
      const xR = B3 + L;
      const yB = 0;
      const yTL = Math.max(0, H1);
      const yTR = H;
      contour.push({ x: xL, y: yB }, { x: xL, y: yTL }, { x: xR, y: yTR }, { x: xR, y: yB }, { x: xL, y: yB });
      aux.push({ x1: xL, y1: 0, x2: xL, y2: H0 }, { x1: xR, y1: 0, x2: xR, y2: H0 });
    } else if (formId === 3) {
      if (!(L > 0 && H > 0 && L1 >= 0)) return null;
      W0 = L + B1;
      H0 = H + B2;
      const l1c = Math.min(L, L1);
      const h1c = Math.max(0, H1);
      contour.push({ x: 0, y: 0 }, { x: 0, y: H }, { x: l1c, y: H }, { x: L, y: h1c }, { x: L, y: 0 }, { x: 0, y: 0 });
      aux.push({ x1: l1c, y1: H, x2: L + B1, y2: H }, { x1: L, y1: h1c, x2: L, y2: H + B2 });
    } else if (formId === 4) {
      if (!(L > 0 && H > 0 && L1 >= 0)) return null;
      W0 = L + B1;
      H0 = H + B2;
      const l1c = Math.min(L, L1);
      const h1c = Math.max(0, H1);
      const xL = B1;
      const xR = B1 + L;
      contour.push({ x: xL, y: 0 }, { x: xR, y: 0 }, { x: xR, y: H }, { x: xR - l1c, y: H }, { x: xL, y: h1c }, { x: xL, y: 0 });
      aux.push({ x1: xL, y1: 0, x2: xL, y2: H0 }, { x1: xR, y1: 0, x2: xR, y2: H0 }, { x1: 0, y1: H, x2: W0, y2: H });
    } else if (formId === 5) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B3;
      H0 = B2 + H + B2;
      const l1c = Math.max(0, Math.min(W0, L1));
      const l2c = Math.max(0, Math.min(W0, L2));
      const yTop = B2;
      const yBase = B2 + H;
      const xBaseLeft = B1;
      const xBaseRight = B1 + L;
      const xTopLeft = l2c;
      const xTopRight = W0 - l1c;
      contour.push(
        { x: xBaseLeft, y: yBase },
        { x: xBaseRight, y: yBase },
        { x: xTopRight, y: yTop },
        { x: xTopLeft, y: yTop },
        { x: xBaseLeft, y: yBase }
      );
      aux.push(
        { x1: xBaseLeft, y1: 0, x2: xBaseLeft, y2: H0 },
        { x1: xBaseRight, y1: 0, x2: xBaseRight, y2: H0 },
        { x1: 0, y1: yTop, x2: W0, y2: yTop },
        { x1: 0, y1: yBase, x2: W0, y2: yBase }
      );
    } else if (formId === 6) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B3 + L + B1;
      H0 = B2 + H + B2;
      const l1c = Math.max(0, Math.min(L, L1));
      const l2c = Math.max(0, Math.min(L, L2));
      const yTop = B2;
      const yBase = B2 + H;
      const xLeft = B3;
      const xRight = B3 + L;
      contour.push(
        { x: xLeft, y: yBase },
        { x: xRight, y: yBase },
        { x: xRight - l2c, y: yTop },
        { x: xLeft + l1c, y: yTop },
        { x: xLeft, y: yBase }
      );
      aux.push(
        { x1: xLeft, y1: 0, x2: xLeft, y2: H0 },
        { x1: xRight, y1: 0, x2: xRight, y2: H0 },
        { x1: 0, y1: yTop, x2: W0, y2: yTop },
        { x1: 0, y1: yBase, x2: W0, y2: yBase }
      );
    } else if (formId === 7) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B3;
      H0 = B2 + H + B2;
      const l1c = Math.max(0, Math.min(L, L1));
      const l2c = Math.max(0, Math.min(L, L2));
      const h1c = Math.max(0, Math.min(H, H1));
      const yTop = B2;
      const yBase = B2 + H;
      const xLeft = B1;
      const xRight = B1 + L;
      const yStep = B2 + H - h1c;
      contour.push(
        { x: xLeft, y: yBase },
        { x: xRight, y: yBase },
        { x: xRight, y: yStep },
        { x: xRight - l1c, y: yTop },
        { x: xLeft + l2c, y: yTop },
        { x: xLeft, y: yBase }
      );
      aux.push(
        { x1: xLeft, y1: 0, x2: xLeft, y2: H0 },
        { x1: xRight, y1: 0, x2: xRight, y2: H0 },
        { x1: 0, y1: yTop, x2: W0, y2: yTop },
        { x1: 0, y1: yBase, x2: W0, y2: yBase }
      );
    } else if (formId === 8) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B3 + L + B1;
      H0 = B2 + H + B2;
      const l1c = Math.max(0, Math.min(L, L1));
      const l2c = Math.max(0, Math.min(L, L2));
      const h1c = Math.max(0, Math.min(H, H1));
      const yTop = B2;
      const yBase = B2 + H;
      const xLeft = B3;
      const xRight = B3 + L;
      const yStep = B2 + H - h1c;
      contour.push(
        { x: xLeft, y: yBase },
        { x: xRight, y: yBase },
        { x: xRight - l2c, y: yTop },
        { x: xLeft + l1c, y: yTop },
        { x: xLeft, y: yStep },
        { x: xLeft, y: yBase }
      );
      aux.push(
        { x1: xLeft, y1: 0, x2: xLeft, y2: H0 },
        { x1: xRight, y1: 0, x2: xRight, y2: H0 },
        { x1: 0, y1: yTop, x2: W0, y2: yTop },
        { x1: 0, y1: yBase, x2: W0, y2: yBase }
      );
    } else if (formId === 9) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B3;
      H0 = B2 + H;
      const x0 = B1;
      const y0 = B2;
      const xBL = x0;
      const yBL = y0 + H;
      const xBR = x0 + L;
      const yStepR = yBL - Math.min(H, H2);
      const yStepL = yBL - Math.min(H, H1);
      const yT = y0;
      const xTL = x0 + Math.min(L, L2);
      const xTR = x0 + (L - Math.min(L, L1));
      contour.push(
        { x: xBL, y: yBL },
        { x: xBR, y: yBL },
        { x: xBR, y: yStepR },
        { x: xTR, y: yT },
        { x: xTL, y: yT },
        { x: xBL, y: yStepL },
        { x: xBL, y: yBL }
      );
      aux.push(
        { x1: xBL, y1: 0, x2: xBL, y2: H0 },
        { x1: xBR, y1: 0, x2: xBR, y2: H0 },
        { x1: 0, y1: yT, x2: W0, y2: yT },
        { x1: 0, y1: yBL, x2: W0, y2: yBL }
      );
    } else if (formId === 10) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B3 + L + B1;
      H0 = B2 + H;
      const x0 = B3;
      const y0 = B2;
      const xBL = x0;
      const yBL = y0 + H;
      const xBR = x0 + L;
      const yStepR = y0 + (H - Math.min(H, H1));
      const yStepL = y0 + (H - Math.min(H, H2));
      const yT = y0;
      const xTR = x0 + (L - Math.min(L, L2));
      const xTL = x0 + Math.min(L, L1);
      contour.push(
        { x: xBL, y: yBL },
        { x: xBR, y: yBL },
        { x: xBR, y: yStepR },
        { x: xTR, y: yT },
        { x: xTL, y: yT },
        { x: xBL, y: yStepL },
        { x: xBL, y: yBL }
      );
      aux.push(
        { x1: xBL, y1: 0, x2: xBL, y2: H0 },
        { x1: xBR, y1: 0, x2: xBR, y2: H0 },
        { x1: 0, y1: yT, x2: W0, y2: yT },
        { x1: 0, y1: yBL, x2: W0, y2: yBL }
      );
    } else if (formId === 11) {
      if (!(L > 0 && H > 0 && L1 > 0)) return null;
      W0 = B1 + L + B3;
      H0 = B2 + H + B4;
      const x0 = B1;
      const y0 = B2;
      const xBR = x0 + L;
      const yB = y0 + H;
      const xBL = xBR - Math.min(L, L1);
      const yRTop = yB - Math.min(H, H1);
      contour.push(
        { x: x0, y: y0 },
        { x: xBR, y: yRTop },
        { x: xBR, y: yB },
        { x: xBL, y: yB },
        { x: x0, y: y0 }
      );
      aux.push(
        { x1: x0, y1: 0, x2: x0, y2: H0 },
        { x1: xBR, y1: 0, x2: xBR, y2: H0 },
        { x1: 0, y1: y0, x2: W0, y2: y0 },
        { x1: 0, y1: yB, x2: W0, y2: yB }
      );
    } else if (formId === 12) {
      if (!(L > 0 && H > 0 && L1 > 0)) return null;
      W0 = B3 + L + B1;
      H0 = B2 + H + B4;
      const x0 = B3;
      const y0 = B2;
      const xBL = x0;
      const yBL = y0 + H;
      const xBR = x0 + Math.min(L, L1);
      const xTR = x0 + L;
      const xK = x0;
      const yK = y0 + (H - Math.min(H, H1));
      contour.push(
        { x: xBL, y: yBL },
        { x: xBR, y: yBL },
        { x: xTR, y: y0 },
        { x: xK, y: yK },
        { x: xBL, y: yBL }
      );
      aux.push(
        { x1: xBL, y1: 0, x2: xBL, y2: H0 },
        { x1: xTR, y1: 0, x2: xTR, y2: H0 },
        { x1: 0, y1: y0, x2: W0, y2: y0 },
        { x1: 0, y1: yBL, x2: W0, y2: yBL }
      );
    } else if (formId === 13) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B3 + L + B1;
      H0 = B2 + H + B4;
      const x0 = B3;
      const y0 = B2;
      const yBottom = y0 + H;
      const xBL = x0;
      const xBR = x0 + L;
      const xTop = x0 + Math.min(L, L1);
      const yLeft = y0 + (H - Math.min(H, H1));
      contour.push(
        { x: xBL, y: yBottom },
        { x: xBR, y: yBottom },
        { x: xTop, y: y0 },
        { x: xBL, y: yLeft },
        { x: xBL, y: yBottom }
      );
      aux.push(
        { x1: xBL, y1: 0, x2: xBL, y2: H0 },
        { x1: xBR, y1: 0, x2: xBR, y2: H0 },
        { x1: 0, y1: y0, x2: W0, y2: y0 },
        { x1: 0, y1: yBottom, x2: W0, y2: yBottom }
      );
    } else if (formId === 14) {
      if (!(L > 0 && H > 0 && L1 > 0)) return null;
      W0 = B3 + L + B3 + B1;
      H0 = B2 + H + B3;
      const x0 = B3;
      const y0 = B2;
      const yBottom = y0 + H;
      const xA = x0;
      const xC = x0 + Math.min(L, L1);
      const xD = x0 + L;
      const yD = yBottom - Math.min(H, H1);
      contour.push(
        { x: xA, y: y0 },
        { x: xA, y: yBottom },
        { x: xC, y: yBottom },
        { x: xD, y: yD },
        { x: xA, y: y0 }
      );
      aux.push(
        { x1: xA, y1: 0, x2: xA, y2: H0 },
        { x1: xD, y1: 0, x2: xD, y2: H0 },
        { x1: 0, y1: y0, x2: W0, y2: y0 },
        { x1: 0, y1: yBottom, x2: W0, y2: yBottom }
      );
    } else if (formId === 15) {
      if (!(L > 0 && H > 0 && L1 > 0)) return null;
      W0 = B1 + L + B3;
      H0 = B2 + H + B3;
      const x0 = B3;
      const y0 = B2;
      const yBottom = y0 + H;
      const xA = x0;
      const xC = x0 + Math.min(L, L1);
      const xD = x0 + L;
      const yD = yBottom - Math.min(H, H1);
      // Espejo horizontal de la 14 en el ancho total del bbox.
      const mirrorX = (xIn) => (W0 - xIn);
      contour.push(
        { x: mirrorX(xA), y: y0 },
        { x: mirrorX(xA), y: yBottom },
        { x: mirrorX(xC), y: yBottom },
        { x: mirrorX(xD), y: yD },
        { x: mirrorX(xA), y: y0 }
      );
      aux.push(
        { x1: mirrorX(xA), y1: 0, x2: mirrorX(xA), y2: H0 },
        { x1: mirrorX(xD), y1: 0, x2: mirrorX(xD), y2: H0 },
        { x1: 0, y1: y0, x2: W0, y2: y0 },
        { x1: 0, y1: yBottom, x2: W0, y2: yBottom }
      );
    } else if (formId === 16) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B3;
      H0 = B2 + H + B3;
      const xL = B1;
      const xR = xL + L;
      const yT = B2;
      const yB = yT + H;
      const xK = xR - Math.min(L, L1);
      const yK = yT;
      const yD = yB - Math.min(H, H1);
      contour.push(
        { x: xL, y: yB },
        { x: xK, y: yK },
        { x: xR, y: yD },
        { x: xR, y: yB },
        { x: xL, y: yB }
      );
      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 },
        { x1: 0, y1: yT, x2: W0, y2: yT },
        { x1: 0, y1: yB, x2: W0, y2: yB }
      );
    } else if (formId === 17) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B3 + L + B1;
      H0 = B2 + H + B3;
      const xL = B3;
      const xR = xL + L;
      const yT = B2;
      const yB = yT + H;
      const xK = xL + Math.min(L, L1);
      const yK = yB - Math.min(H, H1);
      contour.push(
        { x: xL, y: yB },
        { x: xL, y: yT },
        { x: xK, y: yK },
        { x: xR, y: yB },
        { x: xL, y: yB }
      );
      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 },
        { x1: 0, y1: yT, x2: W0, y2: yT },
        { x1: 0, y1: yB, x2: W0, y2: yB }
      );
      {
        // Extensión auxiliar del lado superior inclinado hasta la banda opuesta.
        const xA = xL;
        const yA = yT;
        const xB = xK;
        const yB0 = yK;
        const dx = xB - xA;
        if (Math.abs(dx) > 1e-9) {
          const xTarget = xR;
          const t = (xTarget - xA) / dx;
          const yHit = yA + (t * (yB0 - yA));
          if (yHit >= 0 && yHit <= H0) {
            aux.push({ x1: xK, y1: yK, x2: xTarget, y2: yHit });
          }
        }
      }
    } else if (formId === 18) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B3;
      H0 = B2 + H + B3;
      const xL = B1;
      const xR = xL + L;
      const yT = B2;
      const yB = yT + H;
      const xK = xR - Math.min(L, L1);
      const yK = yB - Math.min(H, H1);
      contour.push(
        { x: xL, y: yB },
        { x: xR, y: yB },
        { x: xR, y: yT },
        { x: xK, y: yK },
        { x: xL, y: yB }
      );
      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 },
        { x1: 0, y1: yT, x2: W0, y2: yT },
        { x1: 0, y1: yB, x2: W0, y2: yB }
      );
      {
        // Extensión auxiliar del lado superior inclinado hasta la banda opuesta.
        const xA = xR;
        const yA = yT;
        const xB = xK;
        const yB0 = yK;
        const dx = xB - xA;
        if (Math.abs(dx) > 1e-9) {
          const xTarget = xL;
          const t = (xTarget - xA) / dx;
          const yHit = yA + (t * (yB0 - yA));
          if (yHit >= 0 && yHit <= H0) {
            aux.push({ x1: xK, y1: yK, x2: xTarget, y2: yHit });
          }
        }
      }
    } else if (formId === 19) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B1;
      H0 = B2 + H + B2;
      const xL = B1;
      const xR = xL + L;
      const yT = B2;
      const yB = yT + H;
      const xLT = xL + Math.min(L / 2, L1);
      const xRT = xR - Math.min(L / 2, L1);
      const yVT = yT + Math.min(H / 2, H1);
      const yVB = yB - Math.min(H / 2, H1);
      contour.push(
        { x: xLT, y: yT },
        { x: xRT, y: yT },
        { x: xR, y: yVT },
        { x: xR, y: yVB },
        { x: xRT, y: yB },
        { x: xLT, y: yB },
        { x: xL, y: yVB },
        { x: xL, y: yVT },
        { x: xLT, y: yT }
      );
      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 },
        { x1: 0, y1: yT, x2: W0, y2: yT },
        { x1: 0, y1: yB, x2: W0, y2: yB }
      );
    } else if (formId === 20) {
      if (!(L > 0)) return null;
      const triH = (Math.sqrt(3) / 2) * L;
      W0 = B1 + L + B1;
      H0 = B1 + triH + B2;
      const xL = B1;
      const xR = xL + L;
      const xApex = xL + (L / 2);
      const yApex = B1;
      const yBase = yApex + triH;
      contour.push(
        { x: xL, y: yBase },
        { x: xApex, y: yApex },
        { x: xR, y: yBase },
        { x: xL, y: yBase }
      );
      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 },
        { x1: 0, y1: yBase, x2: W0, y2: yBase },
        { x1: 0, y1: yApex, x2: W0, y2: yApex }
      );
    } else if (formId === 21 || formId === 22 || formId === 23 || formId === 24) {
      if (!(L > 0)) return null;
      const n = formId - 16;
      const sideBand = (formId === 24) ? B1 : B2;
      const bottomBand = B1;
      const topBand = B1;
      const Rpoly = L / (2 * Math.sin(Math.PI / n));
      const a = L / (2 * Math.tan(Math.PI / n));
      const rotate180 = (formId === 21 || formId === 23);

      let polyW = 2 * Rpoly;
      let polyH = a + Rpoly;
      if (formId === 22) {
        polyH = 2 * a;
      } else if (formId === 24) {
        polyW = 2 * a;
        polyH = 2 * a;
      }

      W0 = polyW + (2 * sideBand);
      H0 = polyH + bottomBand + topBand;

      let cx = sideBand + Rpoly;
      let cy = bottomBand + a;
      if (formId === 24) {
        cx = sideBand + a;
        cy = bottomBand + a;
      } else if (rotate180) {
        // Al rotar 180º (21/23), para apoyar en banda inferior B1 se usa centro en R.
        cy = bottomBand + Rpoly;
      }

      const start = ((-Math.PI / 2) - (Math.PI / n)) + (rotate180 ? Math.PI : 0);
      for (let i = 0; i < n; i++) {
        const ang = start + (i * 2 * Math.PI / n);
        const x = cx + (Rpoly * Math.cos(ang));
        const y = cy + (Rpoly * Math.sin(ang));
        contour.push({ x: x, y: y });
      }
      contour.push({ x: contour[0].x, y: contour[0].y });

      const xL = sideBand;
      const xR = sideBand + polyW;
      const yT = topBand;
      const yB = topBand + polyH;
      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 },
        { x1: 0, y1: yT, x2: W0, y2: yT },
        { x1: 0, y1: yB, x2: W0, y2: yB }
      );
    } else if (formId === 25) {
      if (!(L > 0 && H > 0)) return null;
      const r0 = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      const r = Math.min(r0, L / 2, H);
      W0 = L + (2 * B1);
      H0 = H + B2 + B3;
      const x0 = B1;
      const x1 = x0 + L;
      const y0 = B2;
      const y1 = y0 + H;
      const seg = 10;
      contour.push({ x: x0, y: y0 });
      contour.push({ x: x0, y: y1 - r });
      for (let i = 0; i <= seg; i++) {
        const t = i / seg;
        const ang = Math.PI - (t * (Math.PI / 2));
        contour.push({ x: (x0 + r) + (r * Math.cos(ang)), y: (y1 - r) + (r * Math.sin(ang)) });
      }
      contour.push({ x: x1 - r, y: y1 });
      for (let i = 0; i <= seg; i++) {
        const t = i / seg;
        const ang = (Math.PI / 2) - (t * (Math.PI / 2));
        contour.push({ x: (x1 - r) + (r * Math.cos(ang)), y: (y1 - r) + (r * Math.sin(ang)) });
      }
      contour.push({ x: x1, y: y0 });
      contour.push({ x: x0, y: y0 });
      // Banda auxiliar inferior B2.
      aux.push(
        { x1: 0, y1: y0, x2: W0, y2: y0 }
      );
    } else if (formId === 26) {
      if (!(L > 0 && H > 0)) return null;
      const r0 = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      const r = Math.min(r0, L / 2, H / 2);
      W0 = L + (2 * B1);
      H0 = H + (2 * B2);
      const x0 = B1;
      const x1 = x0 + L;
      const y0 = B2;
      const y1 = y0 + H;
      const seg = 8;
      contour.push({ x: x0 + r, y: y0 });
      contour.push({ x: x1 - r, y: y0 });
      for (let i = 0; i <= seg; i++) {
        const t = i / seg;
        const ang = (-Math.PI / 2) + (t * (Math.PI / 2));
        contour.push({ x: (x1 - r) + (r * Math.cos(ang)), y: (y0 + r) + (r * Math.sin(ang)) });
      }
      contour.push({ x: x1, y: y1 - r });
      for (let i = 0; i <= seg; i++) {
        const t = i / seg;
        const ang = (0) + (t * (Math.PI / 2));
        contour.push({ x: (x1 - r) + (r * Math.cos(ang)), y: (y1 - r) + (r * Math.sin(ang)) });
      }
      contour.push({ x: x0 + r, y: y1 });
      for (let i = 0; i <= seg; i++) {
        const t = i / seg;
        const ang = (Math.PI / 2) + (t * (Math.PI / 2));
        contour.push({ x: (x0 + r) + (r * Math.cos(ang)), y: (y1 - r) + (r * Math.sin(ang)) });
      }
      contour.push({ x: x0, y: y0 + r });
      for (let i = 0; i <= seg; i++) {
        const t = i / seg;
        const ang = Math.PI + (t * (Math.PI / 2));
        contour.push({ x: (x0 + r) + (r * Math.cos(ang)), y: (y0 + r) + (r * Math.sin(ang)) });
      }
      contour.push({ x: x0 + r, y: y0 });
    } else if (formId === 27) {
      if (!(L > 0 && H > 0 && H1 >= 0)) return null;
      const Rv = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      if (!(Rv > 0)) return null;
      const yA = Math.max(0, Math.min(H, H1));
      const yB = H;
      const xA = B2;
      const xB = B2 + L;
      W0 = L + B1 + B2;
      // Forma 27 usa dos convenciones históricas para la flecha del arco:
      // R completa cuando ambos extremos tienen la misma altura y R/2
      // cuando el arco une extremos a distinta altura. Debe coincidir con
      // la envolvente que calcula y persiste el optimizador.
      const arcRise = Rv / (Math.abs(H - H1) > 0.0001 ? 2 : 1);
      H0 = H + B3 + arcRise;

      const dxAB = (xB - xA);
      const dyAB = (yB - yA);
      const arcBase = Math.sqrt((dxAB * dxAB) + (dyAB * dyAB));
      if (!(arcBase > 0)) return null;
      const radioAux = (((arcBase / 2) * (arcBase / 2)) + (Rv * Rv)) / (2 * Rv);
      const mx = xA + (dxAB / 2);
      const my = yA + (dyAB / 2);
      const mod = Math.sqrt((dxAB * dxAB) + (dyAB * dyAB));
      const ux = dxAB / mod;
      const uy = dyAB / mod;
      const cx = mx + (uy * (radioAux - Rv));
      const cy = my + (-ux * (radioAux - Rv));
      const a0 = Math.atan2(yA - cy, xA - cx);
      const a1 = Math.atan2(yB - cy, xB - cx);
      const seg = 24;

      contour.push({ x: xA, y: 0 });
      contour.push({ x: xA, y: yA });
      for (let i = 0; i <= seg; i++) {
        let t = i / seg;
        let ang = a0 - (t * ((a0 - a1 + (2 * Math.PI)) % (2 * Math.PI)));
        contour.push({ x: cx + (radioAux * Math.cos(ang)), y: cy + (radioAux * Math.sin(ang)) });
      }
      contour.push({ x: xB, y: 0 });
      contour.push({ x: xA, y: 0 });
      aux.push(
        { x1: xA, y1: 0, x2: xA, y2: H0 },
        { x1: xB, y1: 0, x2: xB, y2: H0 }
      );
    } else if (formId === 28) {
      const geometry28 = this.buildFigure28Geometry(
        B1,
        B2,
        B3,
        L,
        H,
        H1,
        this.figureForm.controls.figure_r.value,
        true
      );
      if (!geometry28) return null;
      W0 = geometry28.width;
      H0 = geometry28.height;
      contour.push({ x: geometry28.xLeft, y: geometry28.yBottom });
      contour.push({ x: geometry28.xRight, y: geometry28.yBottom });
      contour.push({ x: geometry28.xRight, y: geometry28.yRight });
      geometry28.arcPoints.slice().reverse().forEach((point) => contour.push(point));
      contour.push({ x: geometry28.xLeft, y: geometry28.yBottom });
      // Las bandas auxiliares sólo existen cuando tienen anchura.
      if (B1 > 0.000001) {
        aux.push({ x1: geometry28.primitiveLeft, y1: 0, x2: geometry28.primitiveLeft, y2: H0 });
      }
      if (B2 > 0.000001) {
        aux.push({ x1: geometry28.primitiveRight, y1: 0, x2: geometry28.primitiveRight, y2: H0 });
      }
    } else if (formId === 29) {
      const Rv = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      if (!(Rv > 0)) return null;
      W0 = 2 * (Rv + B1);
      H0 = W0;
      const cx = W0 / 2;
      const cy = H0 / 2;
      const seg = 40;
      for (let i = 0; i <= seg; i++) {
        const ang = (i / seg) * 2 * Math.PI;
        contour.push({ x: cx + (Rv * Math.cos(ang)), y: cy + (Rv * Math.sin(ang)) });
      }
      // Auxiliares laterales en el eje horizontal medio.
      aux.push(
        { x1: 0, y1: cy, x2: B1, y2: cy },
        { x1: W0 - B1, y1: cy, x2: W0, y2: cy }
      );
    } else if (formId === 30 || formId === 31) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B1;
      H0 = H;
      const xL = B1;
      const xR = B1 + L;
      const y0 = 0;
      const y1 = H;
      contour.push(
        { x: xL, y: y0 },
        { x: xR, y: y0 },
        { x: xR, y: y1 },
        { x: xL, y: y1 },
        { x: xL, y: y0 }
      );
      const yLeft = (formId === 30) ? (H - Math.max(0, Math.min(H, H2))) : Math.max(0, Math.min(H, H1));
      const yRight = (formId === 30) ? Math.max(0, Math.min(H, H1)) : (H - Math.max(0, Math.min(H, H2)));
      aux.push(
        { x1: xL, y1: yLeft, x2: xR, y2: yRight },
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 }
      );
    } else if (formId === 32) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B1;
      H0 = B2 + H + B2;
      const xL = B1;
      const xR = B1 + L;
      const yB = B2;
      const yT = B2 + H;
      const xTL = B1 + Math.max(0, Math.min(L, L1));
      const xTM = B1 + Math.max(0, Math.min(L, L1 + L2));
      const xBR = B1 + L - Math.max(0, Math.min(L, L1));
      const xBM = B1 + L - Math.max(0, Math.min(L, L1 + L2));
      contour.push(
        { x: xL, y: yB },
        { x: xBR, y: yB },
        { x: xR, y: yT },
        { x: xTL, y: yT },
        { x: xL, y: yB }
      );
      aux.push(
        { x1: xTM, y1: yT, x2: xBM, y2: yB },
        { x1: 0, y1: yB, x2: W0, y2: yB },
        { x1: 0, y1: yT, x2: W0, y2: yT }
      );
    } else if (formId === 33 || formId === 34) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B2 + L + B2;
      H0 = B2 + H + B2;
      const xL = B2;
      const xR = B2 + L;
      const yB = B2;
      const yT = B2 + H;
      const b1c = Math.max(0, Math.min(H, B1));

      contour.push(
        { x: xL, y: yB },
        { x: xR, y: yB },
        { x: xR, y: yT },
        { x: xL, y: yT },
        { x: xL, y: yB }
      );

      if (formId === 33) {
        aux.push(
          { x1: xL, y1: yT, x2: xR, y2: B2 + b1c },
          { x1: xL, y1: B2 + H - b1c, x2: xR, y2: yB }
        );
      } else {
        aux.push(
          { x1: xL, y1: B2 + b1c, x2: xR, y2: yT },
          { x1: xL, y1: yB, x2: xR, y2: B2 + H - b1c }
        );
      }

      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 },
        { x1: 0, y1: yB, x2: W0, y2: yB },
        { x1: 0, y1: yT, x2: W0, y2: yT }
      );
    } else if (formId === 35 || formId === 36) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B1;
      H0 = B2 + H + B2;
      const l1c = Math.max(0, Math.min(L, L1));
      const yB = B2;
      const yT = B2 + H;
      let xBL = B1;
      let xBR = B1 + L - l1c;
      let xTR = B1 + L;
      let xTL = B1 + l1c;
      if (formId === 36) {
        xBL = B1 + l1c;
        xBR = B1 + L;
        xTR = B1 + L - l1c;
        xTL = B1;
      }
      const xBM = (xBL + xBR) / 2;
      const xTM = (xTL + xTR) / 2;

      contour.push(
        { x: xBL, y: yB },
        { x: xBR, y: yB },
        { x: xTR, y: yT },
        { x: xTL, y: yT },
        { x: xBL, y: yB }
      );
      aux.push(
        { x1: xBM, y1: yB, x2: xTM, y2: yT },
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: B1 + L, y1: 0, x2: B1 + L, y2: H0 },
        { x1: 0, y1: yB, x2: W0, y2: yB },
        { x1: 0, y1: yT, x2: W0, y2: yT }
      );
    } else if (formId === 37 || formId === 371) {
      let lUse = L;
      let hUse = H;
      let l1Use = L1;
      if (formId === 371) {
        const hBase = Math.max(0, H1);
        const wBase = Math.max(0, B3);
        const a1Base = Math.max(0, L2);
        if (!(hBase > 0 && wBase > 0 && a1Base > 0)) return null;
        const angleDeg = 90 - a1Base;
        const angleRad = angleDeg * (Math.PI / 180);
        l1Use = hBase * Math.sin(angleRad);
        hUse = hBase * Math.cos(angleRad);
        lUse = wBase + l1Use;
      }
      if (!(lUse > 0 && hUse > 0)) return null;
      W0 = B1 + lUse + B1;
      H0 = B2 + hUse + B2;
      const l1c = Math.max(0, Math.min(lUse, l1Use));
      const yB = B2;
      const yT = B2 + hUse;
      contour.push(
        { x: B1, y: yB },
        { x: B1 + lUse - l1c, y: yB },
        { x: B1 + lUse, y: yT },
        { x: B1 + l1c, y: yT },
        { x: B1, y: yB }
      );
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: B1 + lUse, y1: 0, x2: B1 + lUse, y2: H0 },
        { x1: 0, y1: yB, x2: W0, y2: yB },
        { x1: 0, y1: yT, x2: W0, y2: yT }
      );
    } else if (formId === 372) {
      const resolved372 = this.getFigure372ResolvedValuesFromForm(false);
      if (!resolved372.ok) {
        W0 = 100;
        H0 = 100;
        contour.push(
          { x: 20, y: 80 },
          { x: 80, y: 80 },
          { x: 80, y: 20 },
          { x: 20, y: 20 },
          { x: 20, y: 80 }
        );
        aux.push(
          { x1: 20, y1: 0, x2: 20, y2: 100 },
          { x1: 80, y1: 0, x2: 80, y2: 100 },
          { x1: 0, y1: 20, x2: 100, y2: 20 },
          { x1: 0, y1: 80, x2: 100, y2: 80 }
        );
      } else {
        const vals = resolved372.values;
        W0 = B1 + Math.max(vals.L3, vals.L3 + vals.L2, vals.L1) + B1;
        H0 = B2 + Math.max(vals.H1, vals.H2) + B2;
        const yB = B2;
        const p1 = { x: B1, y: yB };
        const p2 = { x: B1 + vals.L3, y: yB };
        const p3 = { x: B1 + vals.L3 + vals.L2, y: B2 + vals.H1 };
        const p4 = { x: B1 + vals.L1, y: B2 + vals.H2 };
        contour.push(p1, p2, p3, p4, p1);

        const clipLineToRect = (a, b) => {
          const dx = b.x - a.x;
          const dy = b.y - a.y;
          const eps = 0.000001;
          const candidates = [];
          const addPoint = (t) => {
            const x = a.x + (dx * t);
            const y = a.y + (dy * t);
            if (x >= -eps && x <= W0 + eps && y >= -eps && y <= H0 + eps) {
              const clamped = {
                x: Math.max(0, Math.min(W0, x)),
                y: Math.max(0, Math.min(H0, y))
              };
              if (!candidates.some(pt => Math.abs(pt.x - clamped.x) < eps && Math.abs(pt.y - clamped.y) < eps)) {
                candidates.push(clamped);
              }
            }
          };
          if (Math.abs(dx) > eps) {
            addPoint((0 - a.x) / dx);
            addPoint((W0 - a.x) / dx);
          }
          if (Math.abs(dy) > eps) {
            addPoint((0 - a.y) / dy);
            addPoint((H0 - a.y) / dy);
          }
          if (candidates.length < 2) {
            return null;
          }

          let best = null;
          let bestDistance = -1;
          for (let i = 0; i < candidates.length; i++) {
            for (let j = i + 1; j < candidates.length; j++) {
              const distance = Math.pow(candidates[i].x - candidates[j].x, 2) + Math.pow(candidates[i].y - candidates[j].y, 2);
              if (distance > bestDistance) {
                bestDistance = distance;
                best = { a: candidates[i], b: candidates[j] };
              }
            }
          }
          return best;
        };
        [clipLineToRect(p1, p4), clipLineToRect(p2, p3)].filter(Boolean).forEach(seg => {
          aux.push({ x1: seg.a.x, y1: seg.a.y, x2: seg.b.x, y2: seg.b.y });
        });
      }
    } else if (formId === 38) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B1;
      H0 = B2 + H + B2;
      const l1c = Math.max(0, Math.min(L, L1));
      const yB = B2;
      const yT = B2 + H;
      contour.push(
        { x: B1 + l1c, y: yB },
        { x: B1 + L, y: yB },
        { x: B1 + L - l1c, y: yT },
        { x: B1, y: yT },
        { x: B1 + l1c, y: yB }
      );
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: B1 + L, y1: 0, x2: B1 + L, y2: H0 },
        { x1: 0, y1: yB, x2: W0, y2: yB },
        { x1: 0, y1: yT, x2: W0, y2: yT }
      );
    } else if (formId === 40) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B1;
      H0 = B2 + H + B3;
      const l1c = Math.max(0, Math.min(L, L1));
      const h1c = Math.max(0, Math.min(H, H1));
      const h2c = Math.max(0, Math.min(H, H2));
      const yB = B2;
      const yT = B2 + H;
      contour.push(
        { x: B1, y: yB },
        { x: B1 + L, y: yB },
        { x: B1 + L, y: B2 + h2c },
        { x: B1 + l1c, y: yT },
        { x: B1, y: B2 + h1c },
        { x: B1, y: yB }
      );
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: B1 + L, y1: 0, x2: B1 + L, y2: H0 },
        { x1: 0, y1: yB, x2: W0, y2: yB },
        { x1: 0, y1: yT, x2: W0, y2: yT }
      );
    } else if (formId === 41) {
      if (!(L > 0 && H > 0)) return null;
      const l1c = Math.max(0, L1);
      const l2c = Math.max(0, L2);
      let d1 = 0;
      let yShoulder = H * 0.5;
      const dMin = 0;
      const dMax = Math.min(l1c, l2c - (L / 2));
      if (dMax > dMin && H > 0) {
        const f = (d) => {
          const a1 = (l1c * l1c) - (d * d);
          const b1 = (l2c * l2c) - ((d + (L / 2)) * (d + (L / 2)));
          if (a1 < 0 || b1 < 0) return -H;
          return Math.sqrt(a1) + Math.sqrt(b1) - H;
        };
        let lo = dMin;
        let hi = dMax;
        let flo = f(lo);
        let fhi = f(hi);
        if (flo === 0) {
          d1 = lo;
        } else if (fhi === 0) {
          d1 = hi;
        } else if ((flo > 0 && fhi < 0) || (flo < 0 && fhi > 0)) {
          for (let i = 0; i < 40; i++) {
            const mid = (lo + hi) / 2;
            const fmid = f(mid);
            if (fmid === 0) {
              lo = mid;
              hi = mid;
              break;
            }
            if ((flo > 0 && fmid > 0) || (flo < 0 && fmid < 0)) {
              lo = mid;
              flo = fmid;
            } else {
              hi = mid;
              fhi = fmid;
            }
          }
          d1 = (lo + hi) / 2;
        }
        const rem = (l1c * l1c) - (d1 * d1);
        if (rem >= 0) yShoulder = Math.sqrt(rem);
      }
      W0 = B1 + L + (2 * d1) + B3;
      H0 = H + B2;
      const xSL = B1;
      const xBL = B1 + d1;
      const xBR = B1 + d1 + L;
      const xSR = B1 + d1 + L + d1;
      const xA = B1 + d1 + (L / 2);
      contour.push(
        { x: xBL, y: 0 },
        { x: xBR, y: 0 },
        { x: xSR, y: yShoulder },
        { x: xA, y: H },
        { x: xSL, y: yShoulder },
        { x: xBL, y: 0 }
      );
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: W0 - B3, y1: 0, x2: W0 - B3, y2: H0 },
        { x1: 0, y1: H, x2: W0, y2: H }
      );
    } else if (formId === 42) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B1;
      H0 = B2 + H + B2;
      const l1c = Math.max(0, Math.min(L, L1));
      const l2c = Math.max(0, Math.min(L, L2));
      const h1c = Math.max(0, Math.min(H, H1));
      const h2c = Math.max(0, Math.min(H, H2));
      const xL = B1;
      const xR = B1 + L;
      const yB = B2;
      const yT = B2 + H;
      contour.push(
        { x: xL, y: yB },
        { x: B1 + L - l2c, y: yB },
        { x: xR, y: B2 + h2c },
        { x: xR, y: yT },
        { x: B1 + l1c, y: yT },
        { x: xL, y: B2 + H - h1c },
        { x: xL, y: yB }
      );
      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 },
        { x1: 0, y1: yB, x2: W0, y2: yB },
        { x1: 0, y1: yT, x2: W0, y2: yT }
      );
    } else if (formId === 43) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B1;
      H0 = B2 + H + B2;
      const l1c = Math.max(0, Math.min(L, L1));
      contour.push(
        { x: B1 + l1c, y: B2 },
        { x: B1, y: B2 + H },
        { x: B1 + L, y: B2 + H },
        { x: B1 + l1c, y: B2 }
      );
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: 0, y1: B2, x2: W0, y2: B2 }
      );
    } else if (formId === 44) {
      if (!(L > 0)) return null;
      let xApex = L / 2;
      let hTri = 0;
      const l1c = Math.max(0, L1);
      const l2c = Math.max(0, L2);
      if (L > 0) {
        xApex = ((l1c * l1c) - (l2c * l2c) + (L * L)) / (2 * L);
        const hSq = (l1c * l1c) - (xApex * xApex);
        if (hSq > 0) hTri = Math.sqrt(hSq);
      }
      W0 = B1 + L + B1;
      H0 = B2 + hTri + B2;
      const xL = B1;
      const xR = B1 + L;
      const xT = B1 + xApex;
      const yB = B2;
      const yT = B2 + hTri;
      contour.push(
        { x: xL, y: yB },
        { x: xR, y: yB },
        { x: xT, y: yT },
        { x: xL, y: yB }
      );
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: B1 + L, y1: 0, x2: B1 + L, y2: H0 },
        { x1: 0, y1: yB, x2: W0, y2: yB },
        { x1: 0, y1: yT, x2: W0, y2: yT }
      );
	    } else if (formId === 45 || formId === 46) {
	      if (!(L > 0 && H > 0)) return null;
	      let cx = L;
	      let cy = H;
	      if (formId === 45) {
	        const l1c = Math.max(0, Math.min(H, L1));
	        const l2c = Math.max(0, Math.min(L, L2));
	        cx = L - l2c;
	        cy = H - l1c;
	        if (cy < 0) cy = 0;
	      } else {
	        const d = Math.sqrt((L * L) + (H * H));
	        if (d > 0) {
	          const a = ((L1 * L1) - (L2 * L2) + (d * d)) / (2 * d);
	          const hSq = (L1 * L1) - (a * a);
	          if (hSq >= 0) {
	            const hh = Math.sqrt(hSq);
	            const ux = L / d;
	            const uy = -H / d;
	            const p2x = a * ux;
	            const p2y = H + (a * uy);
	            const c1x = p2x - (hh * uy);
	            const c1y = p2y + (hh * ux);
	            const c2x = p2x + (hh * uy);
	            const c2y = p2y - (hh * ux);
	            if (c1y >= c2y) { cx = c1x; cy = c1y; } else { cx = c2x; cy = c2y; }
	          }
	        }
	      }
	      const innerW = formId === 46 ? Math.max(L, cx) : L;
	      const innerH = formId === 46 ? Math.max(H, cy) : H;
	      W0 = B1 + innerW + B3;
	      H0 = B2 + innerH + B3;
	      contour.push(
	        { x: B1, y: B2 },
	        { x: B1, y: B2 + H },
	        { x: B1 + cx, y: B2 + cy },
	        { x: B1 + L, y: B2 },
	        { x: B1, y: B2 }
	      );
	      if (formId === 46) {
	        aux.push({ x1: B1, y1: 0, x2: B1, y2: H0 });
	        aux.push({ x1: 0, y1: B2, x2: W0, y2: B2 });
	        const xB = B1;
	        const yB = B2 + H;
	        const xC = B1 + cx;
	        const yC = B2 + cy;
	        if (xC !== xB) {
	          const tExt = (W0 - xC) / (xC - xB);
	          const yExt = yC + (tExt * (yC - yB));
	          if (isFinite(yExt) && yExt >= 0 && yExt <= H0) {
	            aux.push({ x1: xC, y1: yC, x2: W0, y2: yExt });
	          }
	        }
	      } else if (formId === 45) {
	        aux.push({ x1: B1, y1: 0, x2: B1, y2: H0 });
	        aux.push({ x1: 0, y1: B2, x2: W0, y2: B2 });
	        const xB = B1;
	        const yB = B2 + H;
	        const xC = B1 + cx;
	        const yC = B2 + cy;
	        if (xC !== xB) {
	          const tExt = (W0 - xC) / (xC - xB);
	          const yExt = yC + (tExt * (yC - yB));
	          if (isFinite(yExt) && yExt >= 0 && yExt <= H0) {
	            aux.push({ x1: xC, y1: yC, x2: W0, y2: yExt });
	          }
	        }
	      } else {
	        aux.push(
	          { x1: B1, y1: 0, x2: B1, y2: H0 },
	          { x1: W0 - B3, y1: 0, x2: W0 - B3, y2: H0 },
	          { x1: 0, y1: B2, x2: W0, y2: B2 },
	          { x1: 0, y1: B2 + innerH, x2: W0, y2: B2 + innerH }
	        );
	      }
	    } else if (formId === 47) {
      if (!(L > 0 && H > 0)) return null;
      const l1c = Math.max(0, Math.min(L, L1));
      const l2c = Math.max(0, Math.min(L, L2));
      const h1c = Math.max(0, Math.min(H, H1));
      W0 = B1 + L + B1;
      H0 = B2 + H + B3;
      contour.push(
        { x: B1, y: B2 },
        { x: B1 + l1c, y: B2 + H },
        { x: B1 + L - l2c, y: B2 + h1c },
        { x: B1 + L, y: B2 },
        { x: B1, y: B2 }
      );
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: B1 + L, y1: 0, x2: B1 + L, y2: H0 },
        { x1: 0, y1: B2, x2: W0, y2: B2 },
        { x1: 0, y1: B2 + H, x2: W0, y2: B2 + H }
      );
    } else if (formId === 48) {
      if (!(L > 0 && H > 0)) return null;
      const l1c = Math.max(0, Math.min(L / 2, L1));
      const l2c = Math.max(0, Math.min(L / 2, L2));
      const h1c = Math.max(0, Math.min(H / 2, H1));
      const h2c = Math.max(0, Math.min(H / 2, H2));
      W0 = B1 + L + B1;
      H0 = B2 + H + B3;
      contour.push(
        { x: B1 + l1c, y: B2 },
        { x: B1 + L - l1c, y: B2 },
        { x: B1 + L, y: B2 + h1c },
        { x: B1 + L, y: B2 + H - h2c },
        { x: B1 + L - l2c, y: B2 + H },
        { x: B1 + l2c, y: B2 + H },
        { x: B1, y: B2 + H - h2c },
        { x: B1, y: B2 + h1c },
        { x: B1 + l1c, y: B2 }
      );
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: B1 + L, y1: 0, x2: B1 + L, y2: H0 },
        { x1: 0, y1: B2, x2: W0, y2: B2 },
        { x1: 0, y1: B2 + H, x2: W0, y2: B2 + H }
      );
    } else if (formId === 49) {
      if (!(L > 0 && H > 0)) return null;
      const l1c = Math.max(0, Math.min(L, L1));
      const l2c = Math.max(0, Math.min(L, L2));
      const h1c = Math.max(0, Math.min(H, H1));
      const Wm = B1 + L + B1;
      const Hm = B2 + H + B3;
      const xBR = B1 + L - l2c;
      let xTop = xBR;
      if (H > 0) {
        const dxTop = (l1c * h1c) / H;
        xTop = xBR + dxTop;
        if (xTop > (B1 + L)) xTop = B1 + L;
      }
      W0 = Wm;
      H0 = Hm;
      contour.push(
        { x: B1, y: B2 },
        { x: B1 + l1c, y: B2 + H },
        { x: xTop, y: B2 + h1c },
        { x: xBR, y: B2 },
        { x: B1, y: B2 }
      );
      aux.push({ x1: 0, y1: B2, x2: W0, y2: B2 });
      const xA = B1;
      const yA = B2;
      const xB = B1 + l1c;
      const yB = B2 + H;
      const xC = xTop;
      const yC = B2 + h1c;
      if (yB !== yA) {
        const tTop = (H0 - yB) / (yB - yA);
        const xTopExt = xB + (tTop * (xB - xA));
        if (isFinite(xTopExt) && xTopExt >= 0 && xTopExt <= W0) {
          aux.push({ x1: xB, y1: yB, x2: xTopExt, y2: H0 });
        }
      }
      if (xC !== xB) {
        const tRight = (W0 - xC) / (xC - xB);
        const yRightExt = yC + (tRight * (yC - yB));
        if (isFinite(yRightExt) && yRightExt >= 0 && yRightExt <= H0) {
          aux.push({ x1: xC, y1: yC, x2: W0, y2: yRightExt });
        }
      }
    } else if (formId === 50) {
      if (!(L > 0 && H > 0)) return null;
      const Wm = B1 + L + B1;
      const Hm = B2 + H + B3;
      const halfL = L / 2;
      const R = ((halfL * halfL) + (H * H)) / (2 * H);
      if (!(R > 0) || halfL > R) return null;
      const d = Math.sqrt((R * R) - (halfL * halfL));
      const xC = B1 + halfL;
      const yC = B2 - d;
      const xL = B1;
      const xR = B1 + L;
      const yChord = B2;
      const leftAng = Math.atan2(d, -halfL);
      const rightAng = Math.atan2(d, halfL);
      const n = 24;
      W0 = Wm;
      H0 = Hm;
      contour.push({ x: xL, y: yChord });
      for (let i = 0; i <= n; i++) {
        const t = i / n;
        const ang = leftAng + ((rightAng - leftAng) * t);
        contour.push({ x: xC + (R * Math.cos(ang)), y: yC + (R * Math.sin(ang)) });
      }
      contour.push({ x: xR, y: yChord });
      contour.push({ x: xL, y: yChord });
      aux.push({ x1: 0, y1: yChord, x2: W0, y2: yChord });
    } else if (formId === 51) {
      if (!(L > 0)) return null;
      const halfL = L / 2;
      const R = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      if (!(R > 0) || halfL > R) return null;
      const d = Math.sqrt((R * R) - (halfL * halfL));
      const hSeg = R - d;
      const Wm = B1 + L + B1;
      const Hm = B2 + hSeg + B3;
      const xC = B1 + halfL;
      const yC = B2 - d;
      const xL = B1;
      const xR = B1 + L;
      const yChord = B2;
      const leftAng = Math.atan2(d, -halfL);
      const rightAng = Math.atan2(d, halfL);
      const n = 24;
      W0 = Wm;
      H0 = Hm;
      contour.push({ x: xL, y: yChord });
      for (let i = 0; i <= n; i++) {
        const t = i / n;
        const ang = leftAng + ((rightAng - leftAng) * t);
        contour.push({ x: xC + (R * Math.cos(ang)), y: yC + (R * Math.sin(ang)) });
      }
      contour.push({ x: xR, y: yChord });
      contour.push({ x: xL, y: yChord });
      aux.push({ x1: 0, y1: yChord, x2: W0, y2: yChord });
    } else if (formId === 52) {
      if (!(L > 0 && H > 0)) return null;
      let rs = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      let rt = Math.max(0, toN(this.figureForm.controls.figure_r2.value, 0));
      const Wm = B1 + L + B1;
      const Hm = B2 + H + B2;
      const xOuterL = B1;
      const xOuterR = B1 + L;
      const yB = B2;
      const yT = B2 + H;
      const xMid = B1 + (L / 2);
      W0 = Wm;
      H0 = Hm;
      const halfL = L / 2;
      if (rt <= 0) rt = halfL;
      if (rs <= 0) rs = H / 2;
      let ss = 0;
      let st = 0;
      for (let it = 0; it < 12; it++) {
        let cTop = halfL - ss;
        if (cTop < 0.001) cTop = 0.001;
        if (cTop >= rt) cTop = rt - 0.001;
        if (cTop < 0.001) cTop = 0.001;
        st = rt - Math.sqrt(Math.max(0, (rt * rt) - (cTop * cTop)));
        const halfSide = Math.max(0.001, (H / 2) - st);
        if (rs <= halfSide) rs = halfSide + 0.001;
        const ssNew = rs - Math.sqrt(Math.max(0, (rs * rs) - (halfSide * halfSide)));
        if (Math.abs(ssNew - ss) < 0.0001) {
          ss = ssNew;
          break;
        }
        ss = ssNew;
      }
      if (ss < 0) ss = 0;
      if (ss > (halfL - 0.001)) ss = halfL - 0.001;
      const xLV = xOuterL + ss;
      const xRV = xOuterR - ss;
      let cTopFinal = (xRV - xLV) / 2;
      if (cTopFinal < 0.001) cTopFinal = 0.001;
      if (cTopFinal >= rt) rt = cTopFinal + 0.001;
      st = rt - Math.sqrt(Math.max(0, (rt * rt) - (cTopFinal * cTopFinal)));
      const yVTop = yT - st;
      const yVBot = yB + st;
      const halfSideFinal = Math.max(0.001, (yVTop - yVBot) / 2);
      if (rs <= halfSideFinal) rs = halfSideFinal + 0.001;
      const yMid = (yVTop + yVBot) / 2;
      const cxLeft = xOuterL + rs;
      const cxRight = xOuterR - rs;
      const cyTop = yT - rt;
      const cyBottom = yB + rt;
      const nTop = 24;
      const nSide = 20;
      const nAux = 16;
      const addPt = (arr, x, y) => {
        const last = arr.length > 0 ? arr[arr.length - 1] : null;
        if (!last || Math.abs(last.x - x) > 0.000001 || Math.abs(last.y - y) > 0.000001) arr.push({ x: x, y: y });
      };
      const topY = (x) => {
        const dx = x - xMid;
        const rad = (rt * rt) - (dx * dx);
        const root = rad > 0 ? Math.sqrt(rad) : 0;
        return cyTop + root;
      };
      const bottomY = (x) => {
        const dx = x - xMid;
        const rad = (rt * rt) - (dx * dx);
        const root = rad > 0 ? Math.sqrt(rad) : 0;
        return cyBottom - root;
      };
      addPt(contour, xLV, yVTop);
      for (let i = 1; i <= nTop; i++) {
        const t = i / nTop;
        const x = xLV + ((xRV - xLV) * t);
        addPt(contour, x, topY(x));
      }
      for (let i = 1; i <= nSide; i++) {
        const t = i / nSide;
        const y = yVTop + ((yVBot - yVTop) * t);
        const dy = y - yMid;
        const rad = (rs * rs) - (dy * dy);
        const root = rad > 0 ? Math.sqrt(rad) : 0;
        addPt(contour, cxRight + root, y);
      }
      for (let i = 1; i <= nTop; i++) {
        const t = i / nTop;
        const x = xRV + ((xLV - xRV) * t);
        addPt(contour, x, bottomY(x));
      }
      for (let i = 1; i <= nSide; i++) {
        const t = i / nSide;
        const y = yVBot + ((yVTop - yVBot) * t);
        const dy = y - yMid;
        const rad = (rs * rs) - (dy * dy);
        const root = rad > 0 ? Math.sqrt(rad) : 0;
        addPt(contour, cxLeft - root, y);
      }
      addPt(contour, xLV, yVTop);
      const buildArcByX = (x0, x1, n, yAtX) => {
        const pts = [];
        for (let i = 0; i <= n; i++) {
          const t = i / n;
          const x = x0 + ((x1 - x0) * t);
          pts.push({ x: x, y: yAtX(x) });
        }
        return pts;
      };
      auxPolylines.push(
        buildArcByX(0, xLV, nAux, topY),
        buildArcByX(xRV, W0, nAux, topY),
        buildArcByX(0, xLV, nAux, bottomY),
        buildArcByX(xRV, W0, nAux, bottomY)
      );
    } else if (formId === 53) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B1 + L + B1;
      H0 = B2 + H + B2;
      const xc = B1 + (L / 2);
      const yc = B2 + (H / 2);
      const rx = L / 2;
      const ry = H / 2;
      const n = 48;
      for (let i = 0; i <= n; i++) {
        const a = (2 * Math.PI * i) / n;
        contour.push({ x: xc + (rx * Math.cos(a)), y: yc + (ry * Math.sin(a)) });
      }
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: B1 + L, y1: 0, x2: B1 + L, y2: H0 },
        { x1: 0, y1: B2, x2: W0, y2: B2 },
        { x1: 0, y1: B2 + H, x2: W0, y2: B2 + H }
      );
    } else if (formId === 54) {
      if (!(L1 > 0 && L2 > 0 && H1 > 0 && H2 > 0)) return null;
      W0 = B1 + L1 + L2 + B1;
      H0 = B2 + H1 + H2 + B2;
      const x0 = B1 + L1;
      const y0 = B2 + H1;
      const n = 64;
      for (let i = 0; i <= n; i++) {
        const a = (2 * Math.PI * i) / n;
        const c = Math.cos(a);
        const s = Math.sin(a);
        const rx = c >= 0 ? L2 : L1;
        const ry = s >= 0 ? H2 : H1;
        contour.push({ x: x0 + (rx * c), y: y0 + (ry * s) });
      }
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: B1 + L1 + L2, y1: 0, x2: B1 + L1 + L2, y2: H0 },
        { x1: 0, y1: B2, x2: W0, y2: B2 },
        { x1: 0, y1: B2 + H1 + H2, x2: W0, y2: B2 + H1 + H2 }
      );
    } else if (formId === 55) {
      if (!(L > 0 && H > 0)) return null;
      W0 = B4 + L + B2;
      H0 = B3 + H + B1;
      const x0 = B4;
      const x1 = B4 + L;
      const yB = B1;
      const yT = B1 + H;
      let rBL = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      let rTL = Math.max(0, toN(this.figureForm.controls.figure_r2.value, 0));
      let rTR = Math.max(0, toN(this.figureForm.controls.figure_r3.value, 0));
      let rBR = Math.max(0, toN(this.figureForm.controls.figure_r4.value, 0));
      const maxR = Math.min((x1 - x0) / 2, (yT - yB) / 2);
      rBL = Math.min(rBL, maxR);
      rTL = Math.min(rTL, maxR);
      rTR = Math.min(rTR, maxR);
      rBR = Math.min(rBR, maxR);
      const n = 12;
      const addPt = (x, y) => {
        const last = contour.length > 0 ? contour[contour.length - 1] : null;
        if (!last || Math.abs(last.x - x) > 0.000001 || Math.abs(last.y - y) > 0.000001) contour.push({ x: x, y: y });
      };
      addPt(x0 + rTL, yT);
      addPt(x1 - rTR, yT);
      if (rTR > 0) {
        const cx = x1 - rTR;
        const cy = yT - rTR;
        for (let i = 1; i <= n; i++) {
          const a = (Math.PI / 2) - (i * (Math.PI / 2) / n);
          addPt(cx + (rTR * Math.cos(a)), cy + (rTR * Math.sin(a)));
        }
      } else {
        addPt(x1, yT);
      }
      addPt(x1, yB + rBR);
      if (rBR > 0) {
        const cx = x1 - rBR;
        const cy = yB + rBR;
        for (let i = 1; i <= n; i++) {
          const a = i * ((-Math.PI / 2) / n);
          addPt(cx + (rBR * Math.cos(a)), cy + (rBR * Math.sin(a)));
        }
      } else {
        addPt(x1, yB);
      }
      addPt(x0 + rBL, yB);
      if (rBL > 0) {
        const cx = x0 + rBL;
        const cy = yB + rBL;
        for (let i = 1; i <= n; i++) {
          const a = (-Math.PI / 2) - (i * (Math.PI / 2) / n);
          addPt(cx + (rBL * Math.cos(a)), cy + (rBL * Math.sin(a)));
        }
      } else {
        addPt(x0, yB);
      }
      addPt(x0, yT - rTL);
      if (rTL > 0) {
        const cx = x0 + rTL;
        const cy = yT - rTL;
        for (let i = 1; i <= n; i++) {
          const a = Math.PI - (i * (Math.PI / 2) / n);
          addPt(cx + (rTL * Math.cos(a)), cy + (rTL * Math.sin(a)));
        }
      } else {
        addPt(x0, yT);
      }
      addPt(x0 + rTL, yT);
    } else if (formId === 56) {
      if (!(L > 0 && H > 0)) return null;
      let rBL = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      let rTL = Math.max(0, toN(this.figureForm.controls.figure_r2.value, 0));
      let rTR = Math.max(0, toN(this.figureForm.controls.figure_r3.value, 0));
      let rBR = Math.max(0, toN(this.figureForm.controls.figure_r4.value, 0));
      if ((rTL + rTR) > L) { const s = L / (rTL + rTR); rTL *= s; rTR *= s; }
      if ((rBL + rBR) > L) { const s = L / (rBL + rBR); rBL *= s; rBR *= s; }
      if ((rTL + rBL) > H) { const s = H / (rTL + rBL); rTL *= s; rBL *= s; }
      if ((rTR + rBR) > H) { const s = H / (rTR + rBR); rTR *= s; rBR *= s; }
      W0 = B1 + L + B1;
      H0 = B2 + H + B2;
      const xL = B1;
      const xR = B1 + L;
      const yB = B2;
      const yT = B2 + H;
      const n = 12;
      const addPt = (x, y) => {
        const last = contour.length > 0 ? contour[contour.length - 1] : null;
        if (!last || Math.abs(last.x - x) > 0.000001 || Math.abs(last.y - y) > 0.000001) contour.push({ x: x, y: y });
      };
      addPt(xL + rBL, yB);
      addPt(xR - rBR, yB);
      for (let i = 0; i <= n; i++) {
        const a = Math.PI + (i * ((Math.PI / 2) - Math.PI) / n);
        addPt(xR + (rBR * Math.cos(a)), yB + (rBR * Math.sin(a)));
      }
      addPt(xR, yT - rTR);
      for (let i = 0; i <= n; i++) {
        const a = (-Math.PI / 2) + (i * ((-Math.PI) - (-Math.PI / 2)) / n);
        addPt(xR + (rTR * Math.cos(a)), yT + (rTR * Math.sin(a)));
      }
      addPt(xL + rTL, yT);
      for (let i = 0; i <= n; i++) {
        const a = i * ((-Math.PI / 2) / n);
        addPt(xL + (rTL * Math.cos(a)), yT + (rTL * Math.sin(a)));
      }
      addPt(xL, yB + rBL);
      for (let i = 0; i < n; i++) {
        const a = (Math.PI / 2) + (i * (0 - (Math.PI / 2)) / n);
        addPt(xL + (rBL * Math.cos(a)), yB + (rBL * Math.sin(a)));
      }
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: B1 + L, y1: 0, x2: B1 + L, y2: H0 },
        { x1: 0, y1: B2, x2: W0, y2: B2 },
        { x1: 0, y1: B2 + H, x2: W0, y2: B2 + H }
      );
    } else if (formId === 57 || formId === 58) {
      if (!(L > 0 && H > 0)) return null;
      const R = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      const R1 = Math.max(0, Math.min(toN(this.figureForm.controls.figure_r2.value, 0), L / 2, H));
      const R2 = Math.max(0, Math.min(toN(this.figureForm.controls.figure_r3.value, 0), L / 2, H1));
      W0 = B1 + L + B1;
      H0 = B2 + Math.max(H, H1) + B3;
      const xL = B1;
      const xR = B1 + L;
      const yB = B2;
      const yTopL = B2 + H;
      const yTopR = B2 + H1;
      const topPts = [];
      const addTopPt = (x, y) => {
        const n = topPts.length;
        if (n > 0) {
          const last = topPts[n - 1];
          if (Math.abs(last.x - x) < 0.000001 && Math.abs(last.y - y) < 0.000001) return;
        }
        topPts.push({ x: x, y: y });
      };
      const addArcByRadius = (p0, p1, radius, preferUpper) => {
        const dx = p1.x - p0.x;
        const dy = p1.y - p0.y;
        const d = Math.sqrt((dx * dx) + (dy * dy));
        if (d <= 0.000001 || radius <= 0.000001) {
          addTopPt(p1.x, p1.y);
          return;
        }
        if (preferUpper) {
          const yUpperLimit = H0;
          const roomTop = Math.max(1, yUpperLimit - Math.max(p0.y, p1.y));
          const qx = (p0.x * 0.72) + (p1.x * 0.28);
          const qy = Math.min(yUpperLimit, Math.max(p0.y, p1.y) + Math.max(80, Math.min(radius * 2.4, roomTop * 0.98)));
          const nArc = 96;
          for (let i = 1; i < nArc; i++) {
            const t = i / nArc;
            const u = 1 - t;
            const x = (u * u * p0.x) + (2 * u * t * qx) + (t * t * p1.x);
            let y = (u * u * p0.y) + (2 * u * t * qy) + (t * t * p1.y);
            if (y > yUpperLimit) y = yUpperLimit;
            addTopPt(x, y);
          }
          addTopPt(p1.x, p1.y);
          return;
        }
        const yUpperLimit = H0;
        const yMax = Math.max(p0.y, p1.y);
        const yMin = Math.min(p0.y, p1.y);
        const roomUp = Math.max(0, yUpperLimit - yMax);
        const roomDown = Math.max(0, yMin - yB);
        let curveUp = false;
        if (curveUp && roomUp <= 0.000001 && roomDown > 0.000001) curveUp = false;
        if (!curveUp && roomDown <= 0.000001 && roomUp > 0.000001) curveUp = true;
        const maxCtrl = Math.max(1, (curveUp ? roomUp : roomDown) * 0.98);
        let c = Math.max(1, Math.min(radius, maxCtrl));
        const s = curveUp ? 1 : -1;
        const evalArcY = (ctrl) => {
          const cp1t = { x: p0.x, y: p0.y + (s * ctrl) };
          const cp2t = { x: p1.x, y: p1.y + (s * ctrl) };
          let top = -Infinity;
          let bottom = Infinity;
          const nEval = 24;
          for (let k = 1; k <= nEval; k++) {
            const t = k / nEval;
            const u = 1 - t;
            const y = (u * u * u * p0.y) + (3 * u * u * t * cp1t.y) + (3 * u * t * t * cp2t.y) + (t * t * t * p1.y);
            if (y > top) top = y;
            if (y < bottom) bottom = y;
          }
          return { top: top, bottom: bottom };
        };
        for (let it = 0; it < 8; it++) {
          const evalY = evalArcY(c);
          if (curveUp) {
            if (evalY.top <= (yUpperLimit + 0.000001)) break;
            const den = evalY.top - yMax;
            if (den <= 0.000001) break;
            const scale = (yUpperLimit - yMax) / den;
            c = Math.max(1, c * Math.max(0.1, Math.min(0.95, scale)));
          } else {
            if (evalY.bottom >= (yB - 0.000001)) break;
            const den = yMin - evalY.bottom;
            if (den <= 0.000001) break;
            const scale = (yMin - yB) / den;
            c = Math.max(1, c * Math.max(0.1, Math.min(0.95, scale)));
          }
        }
        const cp1 = { x: p0.x, y: p0.y + (s * c) };
        const cp2 = { x: p1.x, y: p1.y + (s * c) };
        const nArc = 96;
        for (let i = 1; i < nArc; i++) {
          const t = i / nArc;
          const u = 1 - t;
          const x = (u * u * u * p0.x) + (3 * u * u * t * cp1.x) + (3 * u * t * t * cp2.x) + (t * t * t * p1.x);
          let y = (u * u * u * p0.y) + (3 * u * u * t * cp1.y) + (3 * u * t * t * cp2.y) + (t * t * t * p1.y);
          if (preferUpper && y > yUpperLimit) y = yUpperLimit;
          addTopPt(x, y);
        }
        addTopPt(p1.x, p1.y);
      };
      const pArcA = { x: xL, y: yTopL };
      const pArcB = { x: xR, y: yTopR };
      addTopPt(pArcB.x, pArcB.y);
      addArcByRadius(pArcB, pArcA, R, formId === 57);
      if (topPts.length > 1) {
        topPts.shift();
      }
      contour.push({ x: xL + R1, y: yB });
      contour.push({ x: xR - R2, y: yB });
      if (R2 > 0) {
        for (let i = 1; i <= 12; i++) {
          const a = (-Math.PI / 2) + (i * (Math.PI / 2) / 12);
          contour.push({ x: (xR - R2) + (R2 * Math.cos(a)), y: (yB + R2) + (R2 * Math.sin(a)) });
        }
      } else {
        contour.push({ x: xR, y: yB });
      }
      contour.push({ x: xR, y: yTopR });
      for (let i = 0; i < topPts.length; i++) {
        contour.push({ x: topPts[i].x, y: topPts[i].y });
      }
      contour.push({ x: xL, y: yB + R1 });
      if (R1 > 0) {
        for (let i = 1; i <= 12; i++) {
          const a = Math.PI + (i * (Math.PI / 2) / 12);
          contour.push({ x: (xL + R1) + (R1 * Math.cos(a)), y: (yB + R1) + (R1 * Math.sin(a)) });
        }
      } else {
        contour.push({ x: xL, y: yB });
      }
      contour.push({ x: xL + R1, y: yB });
      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 },
        { x1: 0, y1: yB, x2: W0, y2: yB }
      );
      if (formId === 58) {
        aux.push({ x1: 0, y1: B2 + Math.max(H, H1), x2: W0, y2: B2 + Math.max(H, H1) });
      }
    } else if (formId === 59) {
      if (!(H > 0)) return null;
      const side = H;
      W0 = B1 + side + B2;
      H0 = B1 + H + B2;
      const xL = B1;
      const xR = B1 + side;
      const yB = B1;
      const yT = B1 + H;
      contour.push({ x: xL, y: yB });
      contour.push({ x: xR, y: yB });
      const n = 28;
      for (let i = 1; i <= n; i++) {
        const a = (i * (Math.PI / 2) / n);
        contour.push({ x: xL + (side * Math.cos(a)), y: yB + (H * Math.sin(a)) });
      }
      contour.push({ x: xL, y: yB });
      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: xR, y1: 0, x2: xR, y2: H0 },
        { x1: 0, y1: yB, x2: W0, y2: yB },
        { x1: 0, y1: yT, x2: W0, y2: yT }
      );
    } else if (formId === 60) {
      if (!(L > 0 && H > 0)) return null;
      let H1c = Math.max(0, toN(this.figureForm.controls.figure_h1.value, 0));
      if (H1c > H) H1c = H;
      W0 = B1 + L + B3;
      H0 = B2 + H + B3;
      const xL = B1;
      const xR = B1 + L;
      const yB = B2;
      const yA = B2 + H;
      const p0x = xR;
      const p0y = yB;
      const p1x = xL;
      const p1y = yA;
      const dx = p1x - p0x;
      const dy = p1y - p0y;
      const d = Math.sqrt((dx * dx) + (dy * dy));
      if (H1c <= 0) H1c = d / 4;
      if (H1c >= (d / 2)) H1c = (d / 2) - 0.000001;
      contour.push({ x: xL, y: yB });
      contour.push({ x: xR, y: yB });
      {
        const xMin = xL;
        const xMax = xR + B3;
        const yMin = yB;
        const yMax = yA + B3;
        const ddx = p1x - p0x;
        const ddy = p1y - p0y;
        const dd = Math.sqrt((ddx * ddx) + (ddy * ddy));
        if (dd > 0.000001) {
          let s = H1c;
          const rr = ((dd * dd) / (8 * s)) + (s / 2);
          const mx = (p0x + p1x) / 2;
          const my = (p0y + p1y) / 2;
          const uxChord = ddx / dd;
          const uyChord = ddy / dd;
          const nx = -uyChord;
          const ny = uxChord;
          const h = rr - s;
          const centers = [
            { x: mx + (nx * h), y: my + (ny * h) },
            { x: mx - (nx * h), y: my - (ny * h) }
          ];
          let best = null;
          const nEval = 72;
          for (let cIdx = 0; cIdx < centers.length; cIdx++) {
            const c = centers[cIdx];
            const ang0 = Math.atan2(p0y - c.y, p0x - c.x);
            const ang1 = Math.atan2(p1y - c.y, p1x - c.x);
            let dMinor = ang1 - ang0;
            while (dMinor > Math.PI) dMinor -= (2 * Math.PI);
            while (dMinor <= -Math.PI) dMinor += (2 * Math.PI);
            const da = dMinor;
            let overflow = 0;
            let score = -999999;
            for (let j = 1; j < nEval; j++) {
              const t = j / nEval;
              const a = ang0 + (da * t);
              const x = c.x + (rr * Math.cos(a));
              const y = c.y + (rr * Math.sin(a));
              if (x < xMin) overflow += (xMin - x);
              else if (x > xMax) overflow += (x - xMax);
              if (y < yMin) overflow += (yMin - y);
              else if (y > yMax) overflow += (y - yMax);
              const sScore = (x * 0.5) + y;
              if (sScore > score) score = sScore;
            }
            const candidate = { c: c, rr: rr, ang0: ang0, da: da, overflow: overflow, score: score };
            if (
              best === null ||
              candidate.overflow < best.overflow ||
              (candidate.overflow === best.overflow && candidate.score > best.score) ||
              (candidate.overflow === best.overflow && candidate.score === best.score && Math.abs(candidate.da) < Math.abs(best.da))
            ) {
              best = candidate;
            }
          }
          if (best !== null) {
            for (let i = 1; i <= 24; i++) {
              const t = i / 24;
              const a = best.ang0 + (best.da * t);
              contour.push({ x: best.c.x + (best.rr * Math.cos(a)), y: best.c.y + (best.rr * Math.sin(a)) });
            }
          } else {
            contour.push({ x: xL, y: yA });
          }
        } else {
          contour.push({ x: xL, y: yA });
        }
      }
      contour.push({ x: xL, y: yB });
      aux.push(
        { x1: xL, y1: 0, x2: xL, y2: H0 },
        { x1: 0, y1: yB, x2: W0, y2: yB }
      );
    } else if (formId === 61) {
      if (!(L > 0 && H > 0)) return null;
      const RIn = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      const xL = B1;
      const xR = B1 + L;
      const yB = B2;
      const yT = B2 + H;
      const minContainR = this.computeFigure61ContainmentMinRadius(L, H);
      const R = (RIn > minContainR) ? RIn : minContainR;
      const cx = xL + (L / 2);
      const cy = yB + (H / 2);
      W0 = (cx + R) + B3;
      H0 = (cy + R) + B3;
      const best = this.resolveFigure61BestArc(xL, xR, yB, yT, R);
      contour.push({ x: xL, y: yB });
      contour.push(best ? { x: best.pStart.x, y: best.pStart.y } : { x: xR, y: yB });
      if (best) {
        for (let i = 1; i <= 64; i++) {
          const t = i / 64;
          const a = best.c.a0 + (best.da * t);
          contour.push({ x: best.c.x + (R * Math.cos(a)), y: best.c.y + (R * Math.sin(a)) });
        }
      } else {
        contour.push({ x: xL, y: yT });
      }
      contour.push({ x: xL, y: yB });
      aux.push(
        { x1: B1, y1: 0, x2: B1, y2: H0 },
        { x1: 0, y1: B2, x2: W0, y2: B2 }
      );
    } else if (formId === 62) {
      if (!(L > 0)) return null;
      const RIn = Math.max(0, toN(this.figureForm.controls.figure_r.value, 0));
      const AIn = Math.max(0, toN(this.figureForm.controls.figure_r2.value, 0));
      let angleRad = (AIn * Math.PI) / 180;
      if (angleRad < (1 * Math.PI / 180)) angleRad = 1 * Math.PI / 180;
      if (angleRad > (120 * Math.PI / 180)) angleRad = 120 * Math.PI / 180;
      const R = Math.max(0.000001, RIn);
      const rIn = Math.max(0, R - L);
      const cosA = Math.cos(angleRad);
      const leftNeedOuter = rIn - (R * cosA);
      const leftNeedInner = rIn * (1 - cosA);
      const leftExtra = Math.max(0, rIn - B1, leftNeedOuter, leftNeedInner);
      const shapeH = (angleRad <= (Math.PI / 2)) ? Math.max(0, (R * Math.sin(angleRad))) : R;
      W0 = B1 + L + B2 + leftExtra;
      H0 = (2 * B3) + shapeH;
      const yBase = B3;
      const xC = B1 + leftExtra - rIn;
      const yC = yBase;
      const pI0 = { x: xC + rIn, y: yC };
      const pO0 = { x: xC + R, y: yC };
      const pI1 = { x: xC + (rIn * Math.cos(angleRad)), y: yC + (rIn * Math.sin(angleRad)) };
      const pO1 = { x: xC + (R * Math.cos(angleRad)), y: yC + (R * Math.sin(angleRad)) };
      contour.push({ x: pI0.x, y: pI0.y });
      contour.push({ x: pO0.x, y: pO0.y });
      for (let i = 1; i <= 48; i++) {
        const t = i / 48;
        const a = t * angleRad;
        contour.push({ x: xC + (R * Math.cos(a)), y: yC + (R * Math.sin(a)) });
      }
      contour.push({ x: pI1.x, y: pI1.y });
      for (let i = 1; i <= 24; i++) {
        const t = i / 24;
        const a = angleRad * (1 - t);
        contour.push({ x: xC + (rIn * Math.cos(a)), y: yC + (rIn * Math.sin(a)) });
      }
      contour.push({ x: pI0.x, y: pI0.y });
      aux.push({ x1: 0, y1: yBase, x2: W0, y2: yBase });
      {
        const dxAux = (pO1.x - pI1.x);
        const dyAux = (pO1.y - pI1.y);
        const epsAux = 0.000001;
        const ptsAux = [];
        const pushAux = (pt) => {
          if (!pt) return;
          for (let i = 0; i < ptsAux.length; i++) {
            if (Math.abs(ptsAux[i].x - pt.x) < 0.0001 && Math.abs(ptsAux[i].y - pt.y) < 0.0001) return;
          }
          ptsAux.push(pt);
        };
        if (Math.abs(dxAux) > epsAux) {
          const tL = (0 - pI1.x) / dxAux;
          const yL = pI1.y + (tL * dyAux);
          if (yL >= yBase && yL <= H0) pushAux({ x: 0, y: yL });
          const tR = (W0 - pI1.x) / dxAux;
          const yR = pI1.y + (tR * dyAux);
          if (yR >= yBase && yR <= H0) pushAux({ x: W0, y: yR });
        }
        if (Math.abs(dyAux) > epsAux) {
          const tB = (yBase - pI1.y) / dyAux;
          const xB = pI1.x + (tB * dxAux);
          if (xB >= 0 && xB <= W0) pushAux({ x: xB, y: yBase });
          const tT = (H0 - pI1.y) / dyAux;
          const xT = pI1.x + (tT * dxAux);
          if (xT >= 0 && xT <= W0) pushAux({ x: xT, y: H0 });
        }
        if (ptsAux.length >= 2) {
          let iA = 0;
          let iB = 1;
          let dBest = -1;
          for (let i = 0; i < ptsAux.length; i++) {
            for (let j = i + 1; j < ptsAux.length; j++) {
              const dxp = ptsAux[i].x - ptsAux[j].x;
              const dyp = ptsAux[i].y - ptsAux[j].y;
              const dd = (dxp * dxp) + (dyp * dyp);
              if (dd > dBest) {
                dBest = dd;
                iA = i;
                iB = j;
              }
            }
          }
          const A = ptsAux[iA];
          const B = ptsAux[iB];
          const yA0 = Math.min(A.y, B.y);
          const yB0 = Math.max(A.y, B.y);
          if (yB0 > yBase + 0.0001) {
            const y1 = Math.max(yA0, yBase);
            const y2 = yB0;
            const xAtY = (yy) => (A.x + (((B.x - A.x) * (yy - A.y)) / (B.y - A.y)));
            aux.push({ x1: xAtY(y1), y1: y1, x2: xAtY(y2), y2: y2 });
          }
        }
      }
    }

    if (!(W0 > 0 && H0 > 0) || contour.length < 3) return null;

    const margin = 24;
    const innerW = 224;
    const innerH = 132;
    const svgW = (margin * 2) + innerW;
    const svgH = (margin * 2) + innerH;
    const scale = Math.min(innerW / W0, innerH / H0);
    const drawW = W0 * scale;
    const drawH = H0 * scale;
    const offX = margin + ((innerW - drawW) / 2);
    const offY = margin + ((innerH - drawH) / 2);
    const toSvgX = (xIn) => offX + (xIn * scale);
    const toSvgY = (yIn) => offY + ((H0 - yIn) * scale);

    const mapY = (yIn) => ((formId >= 5 && formId <= 20) ? (offY + (yIn * scale)) : toSvgY(yIn));
    const contourPoints = contour.map((p) => (toSvgX(p.x).toFixed(2) + ',' + mapY(p.y).toFixed(2))).join(' ');
    const auxLines = aux.map((l) => ({
      x1: toSvgX(l.x1), y1: mapY(l.y1), x2: toSvgX(l.x2), y2: mapY(l.y2)
    }));
    const auxCurvePoints = auxPolylines.map((poly) => poly.map((p) => (toSvgX(p.x).toFixed(2) + ',' + mapY(p.y).toFixed(2))).join(' '));

    return {
      svgW: svgW,
      svgH: svgH,
      rectX: offX,
      rectY: offY,
      rectW: drawW,
      rectH: drawH,
      contourPoints: contourPoints,
      auxLines: auxLines,
      auxCurvePoints: auxCurvePoints
    };
  }

  private computeFigure52Profile(LIn: any, HIn: any, rIn: any, r1In: any): any {
    const toN = (v, d) => {
      const n = Number(v);
      return isNaN(n) ? d : n;
    };
    const L = Math.max(0, toN(LIn, 0));
    const H = Math.max(0, toN(HIn, 0));
    if (!(L > 0 && H > 0)) return null;

    let rs = Math.max(0, toN(rIn, 0));
    let rt = Math.max(0, toN(r1In, 0));
    const halfL = L / 2;
    if (rt <= 0) rt = halfL;
    if (rs <= 0) rs = H / 2;

    let ss = 0;
    let st = 0;
    for (let it = 0; it < 12; it++) {
      let cTop = halfL - ss;
      if (cTop < 0.001) cTop = 0.001;
      if (cTop >= rt) cTop = rt - 0.001;
      if (cTop < 0.001) cTop = 0.001;
      st = rt - Math.sqrt(Math.max(0, (rt * rt) - (cTop * cTop)));
      const halfSide = Math.max(0.001, (H / 2) - st);
      if (rs <= halfSide) rs = halfSide + 0.001;
      const ssNew = rs - Math.sqrt(Math.max(0, (rs * rs) - (halfSide * halfSide)));
      if (Math.abs(ssNew - ss) < 0.0001) {
        ss = ssNew;
        break;
      }
      ss = ssNew;
    }

    if (!isFinite(ss) || !isFinite(st) || !isFinite(rs) || !isFinite(rt)) return null;
    if (ss < 0) ss = 0;
    if (ss > (halfL - 0.001)) ss = halfL - 0.001;
    if (st < 0) st = 0;
    if (st > ((H / 2) - 0.001)) st = (H / 2) - 0.001;

    const topSpan = Math.max(0, L - (2 * ss));
    const sideSpan = Math.max(0, H - (2 * st));
    const cTop = Math.max(0.000001, (L / 2) - ss);
    const topDen = Math.max(0.000001, rt - st);
    const topSlope = cTop / topDen;
    return {
      L: L,
      H: H,
      rs: rs,
      rt: rt,
      ss: ss,
      st: st,
      topSpan: topSpan,
      sideSpan: sideSpan,
      topRatio: topSpan / L,
      sideRatio: sideSpan / H,
      topSlope: topSlope
    };
  }

  private getFigure28RadiusRangeValues(
    lIn: any,
    hIn: any,
    h1In: any
  ): any {
    return getForm28SagittaInfo(lIn, hIn, h1In);
  }

  private buildFigure28Geometry(
    b1In: any,
    b2In: any,
    b3In: any,
    lIn: any,
    hIn: any,
    h1In: any,
    rIn: any,
    clampRadiusIn: boolean = false
  ): any {
    return buildForm28Geometry({
      b1: b1In,
      b2: b2In,
      b3: b3In,
      l: lIn,
      h: hIn,
      h1: h1In,
      r: rIn
    }, {
      clampSagitta: clampRadiusIn
    });
  }

  getFigureGeometryWarning(): string {
    const formId = Number(this.figureForm && this.figureForm.controls && this.figureForm.controls.figure_id ? this.figureForm.controls.figure_id.value : 0);
    if (formId === 28) {
      const L = Number(this.figureForm.controls.figure_l.value);
      const H = Number(this.figureForm.controls.figure_h.value);
      const H1 = Number(this.figureForm.controls.figure_h1.value);
      const R = Number(this.figureForm.controls.figure_r.value);
      if (!(R >= 1)) return 'Aviso: R* es la flecha (Stichmaß) y debe ser igual o mayor que 1 mm.';
      const info = this.getFigure28RadiusRangeValues(L, H, H1);
      if (info && info.max < info.min) {
        return 'Aviso: no existe un valor entero de R* válido. Modifique L, H o H1.';
      }
      if (info && R > info.max) {
        return `Aviso: R* debe estar entre ${info.min} y ${info.max} mm. Un valor superior hace que el arco invada el marco envolvente y LiSEC no permite grabarlo.`;
      }
      const geometry = this.buildFigure28Geometry(
        this.figureForm.controls.figure_b1.value,
        this.figureForm.controls.figure_b2.value,
        this.figureForm.controls.figure_b3.value,
        L,
        H,
        H1,
        R,
        false
      );
      if (L > 0 && H > 0 && H1 >= 0 && !geometry) {
        return 'Aviso: R* produce un contorno auto-intersectado. Reduzca la flecha o modifique L, H y H1.';
      }
      return '';
    }
    if (formId === 61) {
      const L = Number(this.figureForm.controls.figure_l.value || 0);
      const H = Number(this.figureForm.controls.figure_h.value || 0);
      const R = Number(this.figureForm.controls.figure_r.value || 0);
      if (L > 0 && H > 0) {
        const minR = this.computeFigure61ContainmentMinRadius(L, H);
        if (R > 0 && R < minR) {
          return `Aviso: en Forma 61 debe cumplirse R >= ${Math.ceil(minR)} con centro de círculo en el punto medio de L/H.`;
        }
      }
      return '';
    }
    if (formId !== 52) return '';

    const profile = this.computeFigure52Profile(
      this.figureForm.controls.figure_l.value,
      this.figureForm.controls.figure_h.value,
      this.figureForm.controls.figure_r.value,
      this.figureForm.controls.figure_r2.value
    );
    if (!profile) return '';

    if (profile.topRatio <= 0.005) {
      return 'Aviso: combinación conflictiva para Forma 52. R y R1 colapsan el tramo superior (vista previa inestable y posible geometría no deseada). Reduzca R/R1 o incremente L/H.';
    }

    if (profile.topSlope > 2.0 || profile.topRatio >= 0.85 || profile.sideRatio <= 0.50 || profile.sideRatio >= 0.95) {
      return 'Aviso: la combinación actual se aleja del perfil típico de catálogo de la Forma 52. Ajuste R/R1 o pulse Demo para cargar un punto de partida estable.';
    }

    return '';
  }

  getFigureRMin(): number {
    const formId = Number(this.figureForm && this.figureForm.controls && this.figureForm.controls.figure_id ? this.figureForm.controls.figure_id.value : 0);
    if (formId === 28) return 1;
    if (formId === 61) {
      const L = Number(this.figureForm && this.figureForm.controls && this.figureForm.controls.figure_l ? this.figureForm.controls.figure_l.value : 0);
      const H = Number(this.figureForm && this.figureForm.controls && this.figureForm.controls.figure_h ? this.figureForm.controls.figure_h.value : 0);
      const minR = this.computeFigure61ContainmentMinRadius(L, H);
      if (isFinite(minR) && minR > 0) return minR;
    }
    return 0;
  }

  getFigureRMax(): any {
    const formId = Number(this.figureForm && this.figureForm.controls && this.figureForm.controls.figure_id ? this.figureForm.controls.figure_id.value : 0);
    if (formId !== 28) return null;
    const info = this.getFigure28RadiusRangeValues(
      this.figureForm.controls.figure_l.value,
      this.figureForm.controls.figure_h.value,
      this.figureForm.controls.figure_h1.value
    );
    return info ? info.max : null;
  }

  private enforceFigure61RadiusMin() {
    if (!this.figureForm || !this.figureForm.controls) return;
    const formId = Number(this.figureForm.controls.figure_id ? this.figureForm.controls.figure_id.value : 0);
    if (formId !== 61) return;
    const L = Number(this.figureForm.controls.figure_l ? this.figureForm.controls.figure_l.value : 0);
    const H = Number(this.figureForm.controls.figure_h ? this.figureForm.controls.figure_h.value : 0);
    const rCtrl = this.figureForm.controls.figure_r;
    if (!rCtrl) return;
    const R = Number(rCtrl.value || 0);
    if (!(L > 0 && H > 0) || !(R > 0)) return;
    const minR = this.computeFigure61ContainmentMinRadius(L, H);
    if (R < minR) {
      rCtrl.setValue(Math.ceil(minR));
    }
    this.ensureFigure61RadiusControlEnabled();
  }

  onFigureLOrHChanged() {
    this.enforceFigure61RadiusMin();
  }

  onFigureRChanged() {
    if (this.figureForm && this.figureForm.controls && this.figureForm.controls.figure_r) {
      const rCtrl = this.figureForm.controls.figure_r;
      const rRaw = Number(rCtrl.value);
      if (isFinite(rRaw)) {
        const rInt = Math.round(rRaw);
        if (rInt !== rRaw) rCtrl.setValue(rInt);
      }
    }
    this.enforceFigure61RadiusMin();
  }

  getActivePreviewMetricsLabel(): string {
    if (!this.figureForm || !this.figureForm.controls) return '';
    const formId = Number(this.figureForm.controls.figure_id ? this.figureForm.controls.figure_id.value : 0);
    if (formId === 372) {
      const resolved372 = this.getFigure372ResolvedValuesFromForm(false);
      if (!resolved372.ok) return resolved372.error;
      const vals = resolved372.values;
      return `LxH: ${Math.round(vals.L3)}x${Math.round(Math.max(vals.H1, vals.H2))} | L=${vals.L}, L1=${vals.L1}, L2=${vals.L2}, H1=${vals.H1}, H2=${vals.H2}`;
    }
    if (formId === 28) {
      const R = Number(this.figureForm.controls.figure_r.value);
      const info = this.getFigure28RadiusRangeValues(
        this.figureForm.controls.figure_l.value,
        this.figureForm.controls.figure_h.value,
        this.figureForm.controls.figure_h1.value
      );
      const geometry = this.buildFigure28Geometry(
        this.figureForm.controls.figure_b1.value,
        this.figureForm.controls.figure_b2.value,
        this.figureForm.controls.figure_b3.value,
        this.figureForm.controls.figure_l.value,
        this.figureForm.controls.figure_h.value,
        this.figureForm.controls.figure_h1.value,
        R,
        false
      );
      if (!info) return '';
      if (!geometry) {
        return `R* válido: ${info.min}–${info.max} mm (flecha) | límite sin desborde: ${Math.round(info.noOverhangSagitta * 100) / 100} mm`;
      }
      const arcType = geometry.arcType === 'semicircle' ? 'semicírculo' : 'arco menor';
      return `R*: ${Math.round(geometry.sagitta * 100) / 100} mm (flecha) | radio real: ${Math.round(geometry.circleRadius * 100) / 100} mm | ${arcType} | máximo sin desborde=${Math.round(info.noOverhangSagitta * 100) / 100} mm`;
    }
    if (formId !== 61) return '';
    const L = Number(this.figureForm.controls.figure_l.value || 0);
    const H = Number(this.figureForm.controls.figure_h.value || 0);
    const B1 = Number(this.figureForm.controls.figure_b1.value || 0);
    const B2 = Number(this.figureForm.controls.figure_b2.value || 0);
    const B3 = Number(this.figureForm.controls.figure_b3.value || 0);
    const RIn = Number(this.figureForm.controls.figure_r.value || 0);
    if (!(L > 0 && H > 0)) return '';
    const minContainR = this.computeFigure61ContainmentMinRadius(L, H);
    const R = (RIn > minContainR) ? RIn : minContainR;
    const cx = B1 + (L / 2);
    const cy = B2 + (H / 2);
    const W0 = (cx + R) + B3;
    const H0 = (cy + R) + B3;
    const lhRatio = (L / H).toFixed(3);
    const whRatio = (W0 > 0 && H0 > 0) ? (W0 / H0).toFixed(3) : '-';
    return `LxH: ${L}x${H} (ratio ${lhRatio}) | Primitivo: ${Math.round(W0)}x${Math.round(H0)} (ratio ${whRatio})`;
  }

  isFigureDemoAvailable(): boolean {
    const formId = this.resolveFigureId(
      this.figureForm && this.figureForm.controls && this.figureForm.controls.figure_id
        ? this.figureForm.controls.figure_id.value
        : 0
    );
    return [
      25, 26, 27, 28, 29,
      45, 46,
      50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62
    ].includes(formId);
  }

  applyFigureDemoValues() {
    const formId = this.resolveFigureId(
      this.figureForm && this.figureForm.controls && this.figureForm.controls.figure_id
        ? this.figureForm.controls.figure_id.value
        : 0
    );
    if (!this.isFigureDemoAvailable()) return;

    const toN = (v, d) => {
      const n = Number(v);
      return isNaN(n) ? d : n;
    };
    const setIfEmpty = (controlName, value) => {
      const c = this.figureForm.controls[controlName];
      if (!c) return;
      const current = Number(c.value);
      if (!isFinite(current) || current <= 0) c.setValue(Math.round(value));
    };

    const L = Math.max(0, toN(this.figureForm.controls.figure_l.value, 0));
    const H = Math.max(0, toN(this.figureForm.controls.figure_h.value, 0));

    // Base mínima para demos que dependen de L/H.
    if ([25, 26, 27, 28, 45, 46, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 61, 62].includes(formId)) {
      setIfEmpty('figure_l', 600);
      setIfEmpty('figure_h', 900);
    }

    const Lm = Math.max(0, toN(this.figureForm.controls.figure_l.value, 0));
    const Hm = Math.max(0, toN(this.figureForm.controls.figure_h.value, 0));
    const minSide = Math.max(1, Math.min(Lm || 1, Hm || 1));

    switch (formId) {
      case 25:
        this.figureForm.controls.figure_r.setValue(Math.round(Math.max(minSide * 0.18, 80)));
        break;
      case 26:
        this.figureForm.controls.figure_r.setValue(Math.round(Math.max(minSide * 0.16, 70)));
        break;
      case 27:
        this.figureForm.controls.figure_h1.setValue(Math.round(Math.max(1, Hm * 0.82)));
        this.figureForm.controls.figure_r.setValue(Math.round(Math.max(minSide * 0.30, 120)));
        break;
      case 28:
        const demoH1 = Math.round(Math.max(1, Hm * 0.78));
        this.figureForm.controls.figure_h1.setValue(demoH1);
        const demoInfo28 = this.getFigure28RadiusRangeValues(Lm, Hm, demoH1);
        const preferredR28 = Math.round(Math.max(minSide * 0.30, 120));
        this.figureForm.controls.figure_r.setValue(
          demoInfo28 && demoInfo28.max >= demoInfo28.min
            ? Math.max(demoInfo28.min, Math.min(preferredR28, demoInfo28.max))
            : 1
        );
        break;
      case 29:
        setIfEmpty('figure_r', 300);
        break;
      case 45:
      case 46:
        this.figureForm.controls.figure_l1.setValue(Math.round(Math.max(1, Hm * 0.35)));
        this.figureForm.controls.figure_l2.setValue(Math.round(Math.max(1, Lm * 0.35)));
        break;
      case 50:
        // Sin parámetros de radio en catálogo: L/H ya marcan la demo.
        break;
      case 51:
        this.figureForm.controls.figure_r.setValue(Math.round(Math.max((Lm / 2) + 20, Hm * 0.60)));
        break;
      case 52:
        this.applyFigure52DemoValues();
        break;
      case 53:
        // Elipse pura (L/H).
        break;
      case 54:
        this.figureForm.controls.figure_l1.setValue(Math.round(Math.max(1, Lm * 0.45)));
        this.figureForm.controls.figure_l2.setValue(Math.round(Math.max(1, Lm * 0.55)));
        this.figureForm.controls.figure_h1.setValue(Math.round(Math.max(1, Hm * 0.45)));
        this.figureForm.controls.figure_h2.setValue(Math.round(Math.max(1, Hm * 0.55)));
        break;
      case 55:
        this.figureForm.controls.figure_r.setValue(Math.round(Math.max(minSide * 0.12, 35)));
        this.figureForm.controls.figure_r2.setValue(Math.round(Math.max(minSide * 0.10, 30)));
        this.figureForm.controls.figure_r3.setValue(Math.round(Math.max(minSide * 0.10, 30)));
        this.figureForm.controls.figure_r4.setValue(Math.round(Math.max(minSide * 0.12, 35)));
        break;
      case 56:
        this.figureForm.controls.figure_r.setValue(Math.round(Math.max(minSide * 0.13, 40)));
        this.figureForm.controls.figure_r2.setValue(Math.round(Math.max(minSide * 0.13, 40)));
        this.figureForm.controls.figure_r3.setValue(Math.round(Math.max(minSide * 0.13, 40)));
        this.figureForm.controls.figure_r4.setValue(Math.round(Math.max(minSide * 0.13, 40)));
        break;
      case 57:
      case 58:
        this.figureForm.controls.figure_h1.setValue(Math.round(Math.max(1, Hm * 0.90)));
        this.figureForm.controls.figure_r.setValue(Math.round(Math.max(Hm * 0.80, Lm * 0.80)));
        this.figureForm.controls.figure_r2.setValue(Math.round(Math.max(minSide * 0.14, 60)));
        this.figureForm.controls.figure_r3.setValue(Math.round(Math.max(minSide * 0.14, 60)));
        break;
      case 59:
        setIfEmpty('figure_h', 700);
        break;
      case 60:
        this.figureForm.controls.figure_h1.setValue(Math.round(Math.max(1, Math.min(Hm * 0.30, Hm - 1))));
        break;
      case 61: {
        const minR = this.computeFigure61ContainmentMinRadius(Lm, Hm);
        this.figureForm.controls.figure_r.setValue(Math.round(Math.max(minR + 50, Math.max(Hm, Lm) * 0.90)));
        break;
      }
      case 62:
        this.figureForm.controls.figure_r.setValue(Math.round(Math.max(Lm * 1.60, Hm * 1.20)));
        this.figureForm.controls.figure_r2.setValue(45);
        break;
      default:
        break;
    }
  }

  private resolveFigureId(valueIn: any): number {
    const direct = Number(valueIn);
    if (Number.isFinite(direct)) {
      return Math.round(direct);
    }
    const raw = (valueIn !== undefined && valueIn !== null) ? String(valueIn).trim() : '';
    if (raw === '') {
      return 0;
    }
    const byTag = raw.match(/f\s*:\s*(\d{1,4})/i);
    if (byTag && byTag[1]) {
      return Number(byTag[1]);
    }
    const byDigits = raw.match(/(\d{1,4})/);
    if (byDigits && byDigits[1]) {
      return Number(byDigits[1]);
    }
    return 0;
  }

  applyFigure52DemoValues() {
    const formId = Number(this.figureForm && this.figureForm.controls && this.figureForm.controls.figure_id ? this.figureForm.controls.figure_id.value : 0);
    if (formId !== 52) return;

    const toN = (v, d) => {
      const n = Number(v);
      return isNaN(n) ? d : n;
    };

    let L = Math.max(0, toN(this.figureForm.controls.figure_l.value, 0));
    let H = Math.max(0, toN(this.figureForm.controls.figure_h.value, 0));

    // Base mínima para poder calcular una demo consistente.
    if (!(L > 0)) {
      L = 600;
      this.figureForm.controls.figure_l.setValue(L);
    }
    if (!(H > 0)) {
      H = 900;
      this.figureForm.controls.figure_h.setValue(H);
    }

    // Plantilla demo "4 arcos suaves" cercana al catálogo:
    // - R (laterales) amplio para reducir pendiente.
    // - R1 (superior/inferior) suficientemente grande para evitar hombro brusco.
    let demoR = Math.max(H * 1.0, L * 1.2);
    let demoR1 = Math.max(L * 0.60, H * 0.32);

    // Ajuste rápido de seguridad para evitar perfiles excesivamente pendientes.
    let profile = this.computeFigure52Profile(L, H, demoR, demoR1);
    if (!profile || profile.topSlope > 2.0 || profile.topRatio < 0.55) {
      demoR = Math.max(H * 1.1, L * 1.3);
      demoR1 = Math.max(L * 0.65, H * 0.36);
      profile = this.computeFigure52Profile(L, H, demoR, demoR1);
    }

    if (!profile) {
      demoR = Math.max(H * 0.9, L * 1.0);
      demoR1 = Math.max(L * 0.55, H * 0.30);
    }

    if (isFinite(demoR) && demoR > 0) this.figureForm.controls.figure_r.setValue(Math.round(demoR));
    if (isFinite(demoR1) && demoR1 > 0) this.figureForm.controls.figure_r2.setValue(Math.round(demoR1));
  }

  getCatalogReferenceImageTransform(): string {
    const formId = Number(this.figureForm.controls.figure_id.value);
    if (formId === 21) return 'rotate(-90deg)';
    return 'none';
  }

  getCatalogActivePreviewTransform(): string {
    const formId = Number(this.figureForm.controls.figure_id.value);
    if (formId === 21 || formId === 23 || formId === 43) return 'rotate(180deg)';
    return 'none';
  }

  getCatalogActiveFallbackTransform(): string {
    const formId = Number(this.figureForm.controls.figure_id.value);
    if (formId === 21) return 'rotate(-90deg)';
    return 'none';
  }

  onFigureCatalogFilterInput(event: any) {
    this.figureCatalogFilter = (event && event.target && event.target.value) ? String(event.target.value) : '';
  }

  private parseDxfLineSegments(textIn: string): any[] {
    const lines = textIn.replace(/\r/g, '').split('\n');
    const tokens = [];
    for (let i = 0; i < lines.length - 1; i += 2) {
      tokens.push({ code: lines[i].trim(), value: lines[i + 1].trim() });
    }
    let inEntities = false;
    const segments = [];
    const near = (a: any, b: any) => (Math.abs(Number(a.x) - Number(b.x)) <= 0.5 && Math.abs(Number(a.y) - Number(b.y)) <= 0.5);
    const addPolylineSegments = (pointsIn: any[], closedIn: boolean) => {
      const points = (pointsIn || [])
        .map(p => ({ x: Number(p.x), y: Number(p.y) }))
        .filter(p => Number.isFinite(p.x) && Number.isFinite(p.y));
      if (points.length < 2) return;
      for (let j = 0; j < points.length - 1; j++) {
        segments.push({ x1: points[j].x, y1: points[j].y, x2: points[j + 1].x, y2: points[j + 1].y });
      }
      if (closedIn && !near(points[0], points[points.length - 1])) {
        segments.push({
          x1: points[points.length - 1].x,
          y1: points[points.length - 1].y,
          x2: points[0].x,
          y2: points[0].y
        });
      }
    };
    let i = 0;
    while (i < tokens.length) {
      const t = tokens[i];
      if (t.code === '0' && t.value === 'SECTION' && i + 1 < tokens.length && tokens[i + 1].code === '2' && tokens[i + 1].value === 'ENTITIES') {
        inEntities = true;
        i += 2;
        continue;
      }
      if (inEntities && t.code === '0' && t.value === 'ENDSEC') break;
      if (inEntities && t.code === '0' && t.value === 'LINE') {
        let x1 = null;
        let y1 = null;
        let x2 = null;
        let y2 = null;
        i += 1;
        while (i < tokens.length && tokens[i].code !== '0') {
          const c = tokens[i].code;
          const v = Number(tokens[i].value);
          if (c === '10') x1 = v;
          else if (c === '20') y1 = v;
          else if (c === '11') x2 = v;
          else if (c === '21') y2 = v;
          i += 1;
        }
        if (x1 !== null && y1 !== null && x2 !== null && y2 !== null) {
          segments.push({ x1: x1, y1: y1, x2: x2, y2: y2 });
        }
        continue;
      }
      if (inEntities && t.code === '0' && t.value === 'LWPOLYLINE') {
        const points = [];
        let closed = false;
        let pendingX = null;
        i += 1;
        while (i < tokens.length && tokens[i].code !== '0') {
          const c = tokens[i].code;
          const v = Number(tokens[i].value);
          if (c === '70' && Number.isFinite(v)) {
            closed = (Math.round(v) & 1) === 1;
          } else if (c === '10' && Number.isFinite(v)) {
            pendingX = v;
          } else if (c === '20' && pendingX !== null && Number.isFinite(v)) {
            points.push({ x: pendingX, y: v });
            pendingX = null;
          }
          i += 1;
        }
        addPolylineSegments(points, closed);
        continue;
      }
      i += 1;
    }
    return segments;
  }

  private buildPolylineFromSegments(segmentsIn: any[]): any[] {
    if (!segmentsIn || segmentsIn.length < 1) return [];
    const segments = segmentsIn.map(s => ({ x1: s.x1, y1: s.y1, x2: s.x2, y2: s.y2 }));
    const near = (a: any, b: any) => (Math.abs(a.x - b.x) <= 0.5 && Math.abs(a.y - b.y) <= 0.5);
    const points = [{ x: segments[0].x1, y: segments[0].y1 }, { x: segments[0].x2, y: segments[0].y2 }];
    segments.splice(0, 1);
    let guard = 0;
    while (segments.length > 0 && guard < 10000) {
      guard += 1;
      const tail = points[points.length - 1];
      let foundIndex = -1;
      let nextPoint = null;
      for (let i = 0; i < segments.length; i++) {
        const s = segments[i];
        const p1 = { x: s.x1, y: s.y1 };
        const p2 = { x: s.x2, y: s.y2 };
        if (near(tail, p1)) {
          foundIndex = i;
          nextPoint = p2;
          break;
        }
        if (near(tail, p2)) {
          foundIndex = i;
          nextPoint = p1;
          break;
        }
      }
      if (foundIndex < 0) break;
      points.push(nextPoint);
      segments.splice(foundIndex, 1);
      if (near(points[points.length - 1], points[0])) break;
    }
    return points;
  }

  private isPolylineClosed(pointsIn: any[]): boolean {
    if (!pointsIn || pointsIn.length < 3) return false;
    const first = pointsIn[0];
    const last = pointsIn[pointsIn.length - 1];
    return (Math.abs(Number(first.x) - Number(last.x)) <= 0.5) && (Math.abs(Number(first.y) - Number(last.y)) <= 0.5);
  }

  private computeOpenEndpoints(segmentsIn: any[]): any[] {
    const near = (a: any, b: any) => (Math.abs(a.x - b.x) <= 0.5 && Math.abs(a.y - b.y) <= 0.5);
    const endpoints: any[] = [];
    (segmentsIn || []).forEach((s) => {
      endpoints.push({ x: Number(s.x1), y: Number(s.y1) });
      endpoints.push({ x: Number(s.x2), y: Number(s.y2) });
    });
    const used = new Array(endpoints.length).fill(false);
    for (let i = 0; i < endpoints.length; i++) {
      if (used[i]) continue;
      for (let j = i + 1; j < endpoints.length; j++) {
        if (used[j]) continue;
        if (near(endpoints[i], endpoints[j])) {
          used[i] = true;
          used[j] = true;
          break;
        }
      }
    }
    return endpoints.filter((_, i) => !used[i]);
  }

  private repairOpenContourSegments(segmentsIn: any[]): any[] {
    if (!segmentsIn || segmentsIn.length < 1) return [];
    const openEndpoints = this.computeOpenEndpoints(segmentsIn);
    if (!openEndpoints || openEndpoints.length !== 2) return [];
    const repaired = segmentsIn.map((s) => ({ x1: s.x1, y1: s.y1, x2: s.x2, y2: s.y2 }));
    repaired.push({
      x1: Number(openEndpoints[0].x),
      y1: Number(openEndpoints[0].y),
      x2: Number(openEndpoints[1].x),
      y2: Number(openEndpoints[1].y)
    });
    return repaired;
  }

  private applyDxfPolyline(poly: any[], fileNameIn: string): boolean {
    if (!poly || poly.length < 3 || !this.isPolylineClosed(poly)) return false;
    const xs = poly.map(p => p.x);
    const ys = poly.map(p => p.y);
    const minX = Math.min.apply(null, xs);
    const maxX = Math.max.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxY = Math.max.apply(null, ys);
    const w = maxX - minX;
    const h = maxY - minY;
    if (w <= 0 || h <= 0) return false;
    const normalized = poly.map(p => ({ x: Number((p.x - minX).toFixed(3)), y: Number((p.y - minY).toFixed(3)) }));
    this.figureDxfName = fileNameIn;
    this.figureDxfPoints = normalized;
    this.figureDxfWidth = Number(w.toFixed(3));
    this.figureDxfHeight = Number(h.toFixed(3));
    this.figureDxfError = '';
    this.figureDxfBrowserError = '';
    this.figureDxfRepairAvailable = false;
    return true;
  }

  private loadFigureDxfFile(file: any): Promise<boolean> {
    return new Promise((resolve) => {
      this.figureDxfError = '';
      this.figureDxfBrowserError = '';
      this.figureDxfRepairAvailable = false;
      if (!file || !file.name || file.name.toLowerCase().indexOf('.dxf') < 0) {
        this.figureDxfError = 'Selecciona un fichero DXF válido.';
        this.figureDxfBrowserError = this.figureDxfError;
        resolve(false);
        return;
      }
      const reader = new FileReader();
      reader.onload = (loadEvent: any) => {
        try {
          const text = loadEvent && loadEvent.target ? String(loadEvent.target.result || '') : '';
          const segments = this.parseDxfLineSegments(text);
          if (!segments || segments.length < 1) {
            this.figureDxfError = 'El DXF no contiene entidades LINE/LWPOLYLINE en ENTITIES.';
            this.figureDxfBrowserError = this.figureDxfError;
            resolve(false);
            return;
          }
          const poly = this.buildPolylineFromSegments(segments);
          if (!poly || poly.length < 3 || !this.isPolylineClosed(poly)) {
            this.figureDxfError = 'No se pudo reconstruir un contorno cerrado desde el DXF.';
            this.figureDxfBrowserError = this.figureDxfError;
            this.figureDxfRepairAvailable = true;
            resolve(false);
            return;
          }
          const ok = this.applyDxfPolyline(poly, file.name);
          if (!ok) {
            this.figureDxfError = 'El contorno DXF no tiene ancho/alto válidos.';
            this.figureDxfBrowserError = this.figureDxfError;
            resolve(false);
            return;
          }
          resolve(true);
        } catch (error) {
          this.figureDxfError = 'No se pudo leer el DXF.';
          this.figureDxfBrowserError = this.figureDxfError;
          resolve(false);
        }
      };
      reader.readAsText(file);
    });
  }

  onFigureDxfFileChange(event: any) {
    const files = event && event.target ? event.target.files : null;
    if (!files || files.length < 1) return;
    const file = files[0];
    this.figureDxfSourceFile = file;
    this.loadFigureDxfFile(file);
    if (event && event.target) event.target.value = '';
  }

  openFigureDxfFileChooser() {
    this.figureDxfError = '';
    this.figureDxfRepairAvailable = false;
    if (this.figureDxfFileInput && this.figureDxfFileInput.nativeElement) {
      this.figureDxfFileInput.nativeElement.click();
    }
  }

  openFigureDxfBrowserModal() {
    this.figureDxfError = '';
    this.figureDxfBrowserError = '';
    this.figureDxfRepairAvailable = false;
    this.figureDxfBrowserModal = true;
    this.figureDxfBrowserFilter = '';
    this.figureDxfBrowserSelectedIndex = -1;
    this.figureDxfBackupName = this.figureDxfName || '';
    this.figureDxfBackupPoints = JSON.parse(JSON.stringify(this.figureDxfPoints || []));
    this.figureDxfBackupWidth = Number(this.figureDxfWidth || 0);
    this.figureDxfBackupHeight = Number(this.figureDxfHeight || 0);
    if (this.figureDxfDirectoryInput && this.figureDxfDirectoryInput.nativeElement) {
      this.figureDxfDirectoryInput.nativeElement.click();
    }
    setTimeout(() => {
      if (this.figureDxfBrowserListPanel && this.figureDxfBrowserListPanel.nativeElement) {
        this.figureDxfBrowserListPanel.nativeElement.focus();
      }
    }, 0);
  }

  closeFigureDxfBrowserModal(keepSelection: boolean) {
    if (!keepSelection) {
      this.figureDxfName = this.figureDxfBackupName || '';
      this.figureDxfPoints = JSON.parse(JSON.stringify(this.figureDxfBackupPoints || []));
      this.figureDxfWidth = Number(this.figureDxfBackupWidth || 0);
      this.figureDxfHeight = Number(this.figureDxfBackupHeight || 0);
      this.figureDxfError = '';
      this.figureDxfRepairAvailable = false;
    }
    this.figureDxfBrowserModal = false;
  }

  onFigureDxfDirectoryChange(event: any) {
    const files = event && event.target ? event.target.files : null;
    if (!files || files.length < 1) return;
    const dxfFiles = Array.from(files)
      .filter((f: any) => !!f && !!f.name && String(f.name).toLowerCase().endsWith('.dxf'))
      .sort((a: any, b: any) => String(a.name).localeCompare(String(b.name)));
    this.figureDxfBrowserFiles = dxfFiles;
    this.figureDxfBrowserSelectedIndex = -1;
    this.figureDxfBrowserError = '';
    if (dxfFiles.length < 1) {
      this.figureDxfBrowserError = 'No hay ficheros DXF en la carpeta seleccionada.';
      return;
    }
    const firstFile: any = dxfFiles[0];
    const relPath = (firstFile && firstFile.webkitRelativePath) ? String(firstFile.webkitRelativePath) : '';
    this.figureDxfBrowserDirName = relPath.indexOf('/') > 0 ? relPath.split('/')[0] : '';
    this.selectFigureDxfBrowserFile(0);
    setTimeout(() => {
      if (this.figureDxfBrowserListPanel && this.figureDxfBrowserListPanel.nativeElement) {
        this.figureDxfBrowserListPanel.nativeElement.focus();
      }
    }, 0);
    if (event && event.target) event.target.value = '';
  }

  getFilteredFigureDxfBrowserFiles(): any[] {
    const filter = (this.figureDxfBrowserFilter || '').trim().toLowerCase();
    if (filter === '') return this.figureDxfBrowserFiles || [];
    return (this.figureDxfBrowserFiles || []).filter((f: any) => String(f.name || '').toLowerCase().indexOf(filter) !== -1);
  }

  isFigureDxfBrowserSelectedFile(fileIn: any): boolean {
    if (!this.figureDxfBrowserFiles || this.figureDxfBrowserSelectedIndex < 0) return false;
    return this.figureDxfBrowserFiles[this.figureDxfBrowserSelectedIndex] === fileIn;
  }

  selectFigureDxfBrowserFileByRef(fileIn: any) {
    if (!fileIn || !this.figureDxfBrowserFiles || this.figureDxfBrowserFiles.length < 1) return;
    const index = this.figureDxfBrowserFiles.indexOf(fileIn);
    if (index < 0) return;
    this.selectFigureDxfBrowserFile(index);
  }

  selectFigureDxfBrowserFile(indexIn: number) {
    if (!this.figureDxfBrowserFiles || indexIn < 0 || indexIn >= this.figureDxfBrowserFiles.length) return;
    this.figureDxfBrowserSelectedIndex = indexIn;
    const file = this.figureDxfBrowserFiles[indexIn];
    this.figureDxfSourceFile = file;
    this.loadFigureDxfFile(file);
  }

  applyFigureDxfBrowserSelection() {
    if (this.figureDxfBrowserSelectedIndex < 0) {
      this.figureDxfBrowserError = 'Selecciona un fichero DXF.';
      return;
    }
    this.closeFigureDxfBrowserModal(true);
  }

  onFigureDxfBrowserKeydown(event: any) {
    if (!event) return;
    const key = String(event.key || '').toLowerCase();
    const filtered = this.getFilteredFigureDxfBrowserFiles();
    if (!filtered || filtered.length < 1) return;
    if (key === 'arrowdown' || key === 'down') {
      event.preventDefault();
      const currentFile = (this.figureDxfBrowserSelectedIndex >= 0 && this.figureDxfBrowserFiles)
        ? this.figureDxfBrowserFiles[this.figureDxfBrowserSelectedIndex]
        : null;
      let filteredIndex = currentFile ? filtered.indexOf(currentFile) : -1;
      filteredIndex = Math.min(filtered.length - 1, filteredIndex + 1);
      this.selectFigureDxfBrowserFileByRef(filtered[filteredIndex]);
      return;
    }
    if (key === 'arrowup' || key === 'up') {
      event.preventDefault();
      const currentFile = (this.figureDxfBrowserSelectedIndex >= 0 && this.figureDxfBrowserFiles)
        ? this.figureDxfBrowserFiles[this.figureDxfBrowserSelectedIndex]
        : null;
      let filteredIndex = currentFile ? filtered.indexOf(currentFile) : filtered.length;
      filteredIndex = Math.max(0, filteredIndex - 1);
      this.selectFigureDxfBrowserFileByRef(filtered[filteredIndex]);
      return;
    }
    if (key === 'enter') {
      event.preventDefault();
      this.applyFigureDxfBrowserSelection();
    }
  }

  chooseFigureDxfBrowserDirectory() {
    if (this.figureDxfDirectoryInput && this.figureDxfDirectoryInput.nativeElement) {
      this.figureDxfDirectoryInput.nativeElement.click();
    }
  }

  onFigureB1Changed() {
    if (!this.figureForm || !this.figureForm.controls || !this.figureForm.controls.figure_b1) return;
    const b1Value = Number(this.figureForm.controls.figure_b1.value);
    if (isNaN(b1Value)) return;
    if (this.figureForm.controls.figure_b1.disabled) return;

    const targets = ['figure_b2', 'figure_b3', 'figure_b4']
      .filter((key) => this.figureForm.controls[key] && !this.figureForm.controls[key].disabled);
    if (targets.length < 1) return;

    const needsCopy = targets.some((key) => Number(this.figureForm.controls[key].value) !== b1Value);
    if (!needsCopy) return;

    const confirmed = window.confirm('¿Desea copiar el valor de B1 en el resto de bordes (B2, B3 y B4)?');
    if (!confirmed) return;

    targets.forEach((key) => this.figureForm.controls[key].setValue(b1Value));
  }

  repairFigureDxfContour() {
    this.figureDxfError = '';
    this.figureDxfBrowserError = '';
    this.figureDxfRepairAvailable = false;
    let file: any = null;
    const filesSource = this.figureDxfBrowserFiles || [];
    const idx = Number(this.figureDxfBrowserSelectedIndex);
    if (filesSource && filesSource.length > 0 && idx >= 0 && idx < filesSource.length) {
      file = filesSource[idx];
    } else if (this.figureDxfSourceFile) {
      file = this.figureDxfSourceFile;
    }
    if (!file) {
      this.figureDxfError = 'No hay un fichero DXF seleccionado para reparar.';
      this.figureDxfBrowserError = this.figureDxfError;
      return;
    }
    const reader = new FileReader();
    reader.onload = (loadEvent: any) => {
      try {
        const text = loadEvent && loadEvent.target ? String(loadEvent.target.result || '') : '';
        const segments = this.parseDxfLineSegments(text);
        const repairedSegments = this.repairOpenContourSegments(segments);
        if (!repairedSegments || repairedSegments.length < 1) {
          this.figureDxfError = 'No se pudo reparar automáticamente el contorno abierto.';
          this.figureDxfBrowserError = this.figureDxfError;
          this.figureDxfRepairAvailable = true;
          return;
        }
        const repairedPoly = this.buildPolylineFromSegments(repairedSegments);
        if (!repairedPoly || repairedPoly.length < 3 || !this.isPolylineClosed(repairedPoly)) {
          this.figureDxfError = 'No se pudo reparar automáticamente el contorno abierto.';
          this.figureDxfBrowserError = this.figureDxfError;
          this.figureDxfRepairAvailable = true;
          return;
        }
        const ok = this.applyDxfPolyline(repairedPoly, file.name);
        if (!ok) {
          this.figureDxfError = 'No se pudo reparar automáticamente el contorno abierto.';
          this.figureDxfBrowserError = this.figureDxfError;
          this.figureDxfRepairAvailable = true;
          return;
        }
      } catch (error) {
        this.figureDxfError = 'No se pudo reparar automáticamente el contorno abierto.';
        this.figureDxfBrowserError = this.figureDxfError;
        this.figureDxfRepairAvailable = true;
      }
    };
    reader.readAsText(file);
  }

  selectFigureFromCatalog(figureIdIn: number) {
    this.figureForm.controls.figure_id.setValue(String(figureIdIn));
    this.pieceChangeFigure({ target: { value: String(figureIdIn) } });
  }

  pieceChangeFigure(event: any) {
    console.log('->> pieceChangeFigure event:');
    console.log(event.target.value);

    let form_value = event.target.value;

    if (Number(form_value) === 926 || Number(form_value) === 2026 || Number(form_value) === 63) this.actual_piece_graphic = './assets/forms/form_0.png';
    else this.actual_piece_graphic = './assets/forms/form_' + form_value + '.png';

    switch(Number(event.target.value)) {
		case 0:
			console.log('->> Seleccionada forma 0.');

			// Se vacían los valores de los campos.
			this.figureForm.controls.figure_b1.setValue(null);
		    this.figureForm.controls.figure_b2.setValue(null);
		    this.figureForm.controls.figure_b3.setValue(null);
		    this.figureForm.controls.figure_b4.setValue(null);
		    this.figureForm.controls.figure_l.setValue(null);
		    this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
		    this.figureForm.controls.figure_h2.setValue(null);
		    this.figureForm.controls.figure_r.setValue(null);
		    this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			// Se deshabilitan todos los campos de la forma.
			this.figureForm.controls.figure_b1.disable();
			this.figureForm.controls.figure_b2.disable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.disable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

			break;

		case 1:
			console.log('->> Seleccionada forma 1.');

			this.figureForm.controls.figure_b4.setValue(null);
			this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

			break;

		case 2:
			console.log('->> Seleccionada forma 2.');

			this.figureForm.controls.figure_b4.setValue(null);
			this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h2.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
        	this.figureForm.controls.figure_r3.setValue(null);
        	this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

			break;

		// ------------ Nuevas formas añadidas E.

		case 3:
	    case 4:
	        console.log('->> Seleccionada forma 3 y 4.');

	        this.figureForm.controls.figure_b3.setValue(null);
	        this.figureForm.controls.figure_b4.setValue(null);
	        this.figureForm.controls.figure_l2.setValue(null);
	        this.figureForm.controls.figure_h2.setValue(null);
	        this.figureForm.controls.figure_r.setValue(null);
	        this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

	        this.figureForm.controls.figure_b1.enable();
	        this.figureForm.controls.figure_b2.enable();
	        this.figureForm.controls.figure_b3.disable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_l.enable();
	        this.figureForm.controls.figure_l1.enable();
	        this.figureForm.controls.figure_l2.disable();
	        this.figureForm.controls.figure_h.enable();
	        this.figureForm.controls.figure_h1.enable();
	        this.figureForm.controls.figure_h2.disable();
	        this.figureForm.controls.figure_r.disable();
	        this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

	        break;

	    case 5:
	    case 6:
	      console.log('->> Seleccionada forma 5 ó 6.');

	      this.figureForm.controls.figure_b4.setValue(null);
	      this.figureForm.controls.figure_h1.setValue(null);
	      this.figureForm.controls.figure_h2.setValue(null);
	      this.figureForm.controls.figure_r.setValue(null);
	      this.figureForm.controls.figure_r2.setValue(null);
	      this.figureForm.controls.figure_r3.setValue(null);
	      this.figureForm.controls.figure_r4.setValue(null);

	      this.figureForm.controls.figure_b1.enable();
	      this.figureForm.controls.figure_b2.enable();
	      this.figureForm.controls.figure_b3.enable();
	      this.figureForm.controls.figure_b4.disable();
	      this.figureForm.controls.figure_l.enable();
	      this.figureForm.controls.figure_l1.enable();
	      this.figureForm.controls.figure_l2.enable();
	      this.figureForm.controls.figure_h.enable();
	      this.figureForm.controls.figure_h1.disable();
	      this.figureForm.controls.figure_h2.disable();
	      this.figureForm.controls.figure_r.disable();
	      this.figureForm.controls.figure_r2.disable();
          this.figureForm.controls.figure_r3.disable();
          this.figureForm.controls.figure_r4.disable();

	      break;

	    case 7:
	    case 8:
	      console.log('->> Seleccionada forma 7 ó 8.');

	      this.figureForm.controls.figure_b4.setValue(null);
	      this.figureForm.controls.figure_h2.setValue(null);
	      this.figureForm.controls.figure_r.setValue(null);
	      this.figureForm.controls.figure_r2.setValue(null);
	      this.figureForm.controls.figure_r3.setValue(null);
	      this.figureForm.controls.figure_r4.setValue(null);

	      this.figureForm.controls.figure_b1.enable();
	      this.figureForm.controls.figure_b2.enable();
	      this.figureForm.controls.figure_b3.enable();
	      this.figureForm.controls.figure_b4.disable();
	      this.figureForm.controls.figure_l.enable();
	      this.figureForm.controls.figure_l1.enable();
	      this.figureForm.controls.figure_l2.enable();
	      this.figureForm.controls.figure_h.enable();
	      this.figureForm.controls.figure_h1.enable();
	      this.figureForm.controls.figure_h2.disable();
	      this.figureForm.controls.figure_r.disable();
	      this.figureForm.controls.figure_r2.disable();
          this.figureForm.controls.figure_r3.disable();
          this.figureForm.controls.figure_r4.disable();

	      break;

		case 9:
	    case 10:
	        console.log('->> Seleccionada forma 9 y 10.');

			this.figureForm.controls.figure_b4.setValue(null);
	        this.figureForm.controls.figure_r.setValue(null);
	        this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

	        this.figureForm.controls.figure_b1.enable();
	        this.figureForm.controls.figure_b2.enable();
	        this.figureForm.controls.figure_b3.enable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_l.enable();
	        this.figureForm.controls.figure_l1.enable();
	        this.figureForm.controls.figure_l2.enable();
	        this.figureForm.controls.figure_h.enable();
	        this.figureForm.controls.figure_h1.enable();
	        this.figureForm.controls.figure_h2.enable();
	        this.figureForm.controls.figure_r.disable();
	        this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

	        break;

	      case 11:
	      case 12:
	      case 13:
	        console.log('->> Seleccionada forma 11,12 y 13.');

	        this.figureForm.controls.figure_l2.setValue(null);
	        this.figureForm.controls.figure_h2.setValue(null);
	        this.figureForm.controls.figure_r.setValue(null);
	        this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

	        this.figureForm.controls.figure_b1.enable();
	        this.figureForm.controls.figure_b2.enable();
	        this.figureForm.controls.figure_b3.enable();
	        this.figureForm.controls.figure_b4.enable();
	        this.figureForm.controls.figure_l.enable();
	        this.figureForm.controls.figure_l1.enable();
	        this.figureForm.controls.figure_l2.disable();
	        this.figureForm.controls.figure_h.enable();
	        this.figureForm.controls.figure_h1.enable();
	        this.figureForm.controls.figure_h2.disable();
	        this.figureForm.controls.figure_r.disable();
	        this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();


	        break;

		      case 14:
		      case 15:
		      case 16:
		      case 17:
		      case 18:
		      case 19:
		        console.log('->> Seleccionada forma 14,15,16,17,18 y 19.');

	        this.figureForm.controls.figure_b4.setValue(null);
	        this.figureForm.controls.figure_l2.setValue(null);
	        this.figureForm.controls.figure_h2.setValue(null);
	        this.figureForm.controls.figure_r.setValue(null);
	        this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

	        this.figureForm.controls.figure_b1.enable();
	        this.figureForm.controls.figure_b2.enable();
	        this.figureForm.controls.figure_b3.enable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_l.enable();
	        this.figureForm.controls.figure_l1.enable();
	        this.figureForm.controls.figure_l2.disable();
	        this.figureForm.controls.figure_h.enable();
	        this.figureForm.controls.figure_h1.enable();
	        this.figureForm.controls.figure_h2.disable();
	        this.figureForm.controls.figure_r.disable();
	        this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
		        this.figureForm.controls.figure_r4.disable();


		        break;

		      case 20:
		        console.log('->> Seleccionada forma 20.');

		        this.figureForm.controls.figure_b3.setValue(null);
		        this.figureForm.controls.figure_b4.setValue(null);
		        this.figureForm.controls.figure_l1.setValue(null);
		        this.figureForm.controls.figure_l2.setValue(null);
		        this.figureForm.controls.figure_h.setValue(null);
		        this.figureForm.controls.figure_h1.setValue(null);
		        this.figureForm.controls.figure_h2.setValue(null);
		        this.figureForm.controls.figure_r.setValue(null);
		        this.figureForm.controls.figure_r2.setValue(null);
		        this.figureForm.controls.figure_r3.setValue(null);
		        this.figureForm.controls.figure_r4.setValue(null);

		        this.figureForm.controls.figure_b1.enable();
		        this.figureForm.controls.figure_b2.enable();
		        this.figureForm.controls.figure_b3.disable();
		        this.figureForm.controls.figure_b4.disable();
		        this.figureForm.controls.figure_l.enable();
		        this.figureForm.controls.figure_l1.disable();
		        this.figureForm.controls.figure_l2.disable();
		        this.figureForm.controls.figure_h.disable();
		        this.figureForm.controls.figure_h1.disable();
		        this.figureForm.controls.figure_h2.disable();
		        this.figureForm.controls.figure_r.disable();
		        this.figureForm.controls.figure_r2.disable();
		        this.figureForm.controls.figure_r3.disable();
		        this.figureForm.controls.figure_r4.disable();

		        break;
		      case 21:
		      case 22:
		      case 23:
		        console.log('->> Seleccionada forma 21,22 ó 23.');
		        this.figureForm.controls.figure_b3.setValue(null);
		        this.figureForm.controls.figure_b4.setValue(null);
		        this.figureForm.controls.figure_l1.setValue(null);
		        this.figureForm.controls.figure_l2.setValue(null);
		        this.figureForm.controls.figure_h.setValue(null);
		        this.figureForm.controls.figure_h1.setValue(null);
		        this.figureForm.controls.figure_h2.setValue(null);
		        this.figureForm.controls.figure_r.setValue(null);
		        this.figureForm.controls.figure_r2.setValue(null);
		        this.figureForm.controls.figure_r3.setValue(null);
		        this.figureForm.controls.figure_r4.setValue(null);
		        this.figureForm.controls.figure_b1.enable();
		        this.figureForm.controls.figure_b2.enable();
		        this.figureForm.controls.figure_b3.disable();
		        this.figureForm.controls.figure_b4.disable();
		        this.figureForm.controls.figure_l.enable();
		        this.figureForm.controls.figure_l1.disable();
		        this.figureForm.controls.figure_l2.disable();
		        this.figureForm.controls.figure_h.disable();
		        this.figureForm.controls.figure_h1.disable();
		        this.figureForm.controls.figure_h2.disable();
		        this.figureForm.controls.figure_r.disable();
		        this.figureForm.controls.figure_r2.disable();
		        this.figureForm.controls.figure_r3.disable();
		        this.figureForm.controls.figure_r4.disable();
		        break;
		      case 24:
		        console.log('->> Seleccionada forma 24.');
		        this.figureForm.controls.figure_b2.setValue(null);
		        this.figureForm.controls.figure_b3.setValue(null);
		        this.figureForm.controls.figure_b4.setValue(null);
		        this.figureForm.controls.figure_l1.setValue(null);
		        this.figureForm.controls.figure_l2.setValue(null);
		        this.figureForm.controls.figure_h.setValue(null);
		        this.figureForm.controls.figure_h1.setValue(null);
		        this.figureForm.controls.figure_h2.setValue(null);
		        this.figureForm.controls.figure_r.setValue(null);
		        this.figureForm.controls.figure_r2.setValue(null);
		        this.figureForm.controls.figure_r3.setValue(null);
		        this.figureForm.controls.figure_r4.setValue(null);
		        this.figureForm.controls.figure_b1.enable();
		        this.figureForm.controls.figure_b2.disable();
		        this.figureForm.controls.figure_b3.disable();
		        this.figureForm.controls.figure_b4.disable();
		        this.figureForm.controls.figure_l.enable();
		        this.figureForm.controls.figure_l1.disable();
		        this.figureForm.controls.figure_l2.disable();
		        this.figureForm.controls.figure_h.disable();
		        this.figureForm.controls.figure_h1.disable();
		        this.figureForm.controls.figure_h2.disable();
		        this.figureForm.controls.figure_r.disable();
		        this.figureForm.controls.figure_r2.disable();
		        this.figureForm.controls.figure_r3.disable();
		        this.figureForm.controls.figure_r4.disable();
		        break;


	    case 25:
	      console.log('->> Seleccionada forma 25.');

	      this.figureForm.controls.figure_l1.setValue(null);
	      this.figureForm.controls.figure_l2.setValue(null);

	      this.figureForm.controls.figure_b1.enable();
	      this.figureForm.controls.figure_b2.enable();
	      this.figureForm.controls.figure_b3.enable();
	      this.figureForm.controls.figure_b4.disable();
	      this.figureForm.controls.figure_l.enable();
	      this.figureForm.controls.figure_l1.disable();
	      this.figureForm.controls.figure_l2.disable();
	      this.figureForm.controls.figure_h.enable();
	      this.figureForm.controls.figure_h1.disable();
	      this.figureForm.controls.figure_r.enable();
	      this.figureForm.controls.figure_r2.disable();
	      this.figureForm.controls.figure_r3.disable();
	      this.figureForm.controls.figure_r4.disable();
	      this.figureForm.controls.figure_h2.disable();

	      break;

	    case 26:
	      console.log('->> Seleccionada forma 26.');

	      this.figureForm.controls.figure_l1.setValue(null);
	      this.figureForm.controls.figure_l2.setValue(null);

	      this.figureForm.controls.figure_b1.enable();
	      this.figureForm.controls.figure_b2.enable();
	      this.figureForm.controls.figure_b3.disable();
	      this.figureForm.controls.figure_b4.disable();
	      this.figureForm.controls.figure_l.enable();
	      this.figureForm.controls.figure_l1.disable();
	      this.figureForm.controls.figure_l2.disable();
	      this.figureForm.controls.figure_h.enable();
	      this.figureForm.controls.figure_h1.disable();
	      this.figureForm.controls.figure_r.enable();
	      this.figureForm.controls.figure_r2.disable();
	      this.figureForm.controls.figure_r3.disable();
	      this.figureForm.controls.figure_r4.disable();
	      this.figureForm.controls.figure_b4.disable();
	      this.figureForm.controls.figure_h2.disable();

	      break;

		// ------------ Fin nuevas formas añadidas E.

		case 27:
			console.log('->> Seleccionada forma 27.');

			this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

			break;
		case 28:
			console.log('->> Seleccionada forma 28.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 30:
		case 31:
			console.log('->> Seleccionada forma 30 ó 31.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.disable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 32:
			console.log('->> Seleccionada forma 32.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 33:
		case 34:
			console.log('->> Seleccionada forma 33 ó 34.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 35:
		case 36:
			console.log('->> Seleccionada forma 35 ó 36.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 29:
			console.log('->> Seleccionada forma 29.');

		    this.figureForm.controls.figure_b2.setValue(null);
		    this.figureForm.controls.figure_b3.setValue(null);
		    this.figureForm.controls.figure_l.setValue(null);
		    this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.disable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.disable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

			break;

		case 37:
			console.log('->> Seleccionada forma 37.');

			this.figureForm.controls.figure_b3.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
        	this.figureForm.controls.figure_r3.setValue(null);
        	this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
			this.figureForm.controls.figure_r4.disable();

			break;
		case 38:
			console.log('->> Seleccionada forma 38.');
			this.figureForm.controls.figure_b3.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
		    this.figureForm.controls.figure_h2.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 40:
			console.log('->> Seleccionada forma 40.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 41:
			console.log('->> Seleccionada forma 41.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 42:
			console.log('->> Seleccionada forma 42.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;

		case 371:
			console.log('->> Seleccionada forma 371.');

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.disable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

			break;

		case 372:
			console.log('->> Seleccionada forma 372.');

			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

			break;

		case 43:
			console.log('->> Seleccionada forma 43.');

			this.figureForm.controls.figure_b3.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

			break;
		case 44:
			console.log('->> Seleccionada forma 44.');
			this.figureForm.controls.figure_b3.setValue(null);
			this.figureForm.controls.figure_h.setValue(null);
			this.figureForm.controls.figure_h1.setValue(null);
			this.figureForm.controls.figure_h2.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 45:
		case 46:
			console.log('->> Seleccionada forma 45 ó 46.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 47:
		case 49:
			console.log('->> Seleccionada forma 47 ó 49.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 48:
			console.log('->> Seleccionada forma 48.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;

		case 50:
			console.log('->> Seleccionada forma 50.');

			this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

			break;
		case 51:
			console.log('->> Seleccionada forma 51.');
			this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
		    this.figureForm.controls.figure_h2.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 52:
			console.log('->> Seleccionada forma 52.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.enable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 53:
			console.log('->> Seleccionada forma 53.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 54:
			console.log('->> Seleccionada forma 54.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.disable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 56:
			console.log('->> Seleccionada forma 56.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.enable();
	        this.figureForm.controls.figure_r3.enable();
	        this.figureForm.controls.figure_r4.enable();
			break;
		case 57:
		case 58:
			console.log('->> Seleccionada forma 57/58.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.enable();
	        this.figureForm.controls.figure_r3.enable();
	        this.figureForm.controls.figure_r4.disable();
			break;
			case 59:
				console.log('->> Seleccionada forma 59.');
				this.figureForm.controls.figure_b1.enable();
				this.figureForm.controls.figure_b2.enable();
				this.figureForm.controls.figure_b3.disable();
				this.figureForm.controls.figure_b4.disable();
				this.figureForm.controls.figure_l.disable();
				this.figureForm.controls.figure_l1.disable();
				this.figureForm.controls.figure_l2.disable();
				this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 60:
			console.log('->> Seleccionada forma 60.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
			this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 61:
			console.log('->> Seleccionada forma 61.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 62:
			console.log('->> Seleccionada forma 62.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.enable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
			case 926:
			case 2026:
			case 63:
				console.log('->> Seleccionada forma 926 (DXF libre).');
				if (this.figureForm.controls.figure_b1.value === null || this.figureForm.controls.figure_b1.value === undefined) this.figureForm.controls.figure_b1.setValue(0);
				if (this.figureForm.controls.figure_b2.value === null || this.figureForm.controls.figure_b2.value === undefined) this.figureForm.controls.figure_b2.setValue(0);
				if (this.figureForm.controls.figure_b3.value === null || this.figureForm.controls.figure_b3.value === undefined) this.figureForm.controls.figure_b3.setValue(0);
				if (this.figureForm.controls.figure_b4.value === null || this.figureForm.controls.figure_b4.value === undefined) this.figureForm.controls.figure_b4.setValue(0);
				this.figureForm.controls.figure_l.setValue(null);
				this.figureForm.controls.figure_l1.setValue(null);
				this.figureForm.controls.figure_l2.setValue(null);
			this.figureForm.controls.figure_h.setValue(null);
			this.figureForm.controls.figure_h1.setValue(null);
			this.figureForm.controls.figure_h2.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);
				this.figureForm.controls.figure_b1.enable();
				this.figureForm.controls.figure_b2.enable();
				this.figureForm.controls.figure_b3.enable();
				this.figureForm.controls.figure_b4.enable();
			this.figureForm.controls.figure_l.disable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;

		case 55:
	        console.log('->> Seleccionada forma 55.');

	        this.figureForm.controls.figure_b1.enable();
	        this.figureForm.controls.figure_b2.enable();
	        this.figureForm.controls.figure_b3.enable();
	        this.figureForm.controls.figure_b4.enable();
	        this.figureForm.controls.figure_l.enable();
	        this.figureForm.controls.figure_l1.disable();
	        this.figureForm.controls.figure_l2.disable();
	        this.figureForm.controls.figure_h.enable();
	        this.figureForm.controls.figure_h1.disable();
	        this.figureForm.controls.figure_h2.disable();
	        this.figureForm.controls.figure_r.enable();
	        this.figureForm.controls.figure_r2.enable();
	        this.figureForm.controls.figure_r3.enable();
	        this.figureForm.controls.figure_r4.enable();

	        break;

	} // End Switch // */
    this.ensureFigure61RadiusControlEnabled();

  } // End function pieceChangeFigure

  // -----------

  buttonSheetClone(itemIn: any, indexIn: number): void {

    console.log('---> Entrando en buttonSheetClone:');
    console.log(itemIn);

    let new_sheet = JSON.parse(JSON.stringify(itemIn));

    // Inserta la nueva plancha justo después de la plancha que se quiere duplicar.
    this.sheetList_datafile.splice(indexIn, 0, new_sheet);

    // Se actualiza también el total de planchas.
    this.totalSelectedSheets += itemIn['unit'];

  } // End function buttonSheetClone

  removeSheet(itemIn: any, indexIn: number): void {
    console.log('---> Entrando en removeSheet: ' + indexIn);

    let num_aux = this.sheetList_datafile[indexIn].unit;

    // Se elimina la pieza del listdo.
	this.sheetList_datafile.splice(indexIn, 1);

    // Se resta el número de unidades de esa entrada al número total de planchas.
    this.totalSelectedSheets = this.totalSelectedSheets - num_aux;

  } // End function removeSheet

  // Modifica un campo numérico de una plancha.
  sheetChangeMaterialId(event: any, sheetIn: any, fieldIn: string) {
    console.log('sheetChangeMaterialId: ' + fieldIn);
    console.log(sheetIn);

    console.log('->> sheetChangeMaterialId event:');
    console.log(event.target.value);

    let valueIn = Number(event.target.value);

	sheetIn[fieldIn] = valueIn;

	if (fieldIn === 'mat_id' && sheetIn['check']) {

	    // Si hay piezas o planchas sin material se les asigna el de esta plancha modificada.
		this.matchSheetPieceMaterial();
	}


  } // End function sheetChangeMaterialId

  // Modifica un campo de texto de una hoja.
  sheetChangeMaterialDesc(event: any, sheetIn: any, fieldIn: string) {
    console.log('sheetChangeMaterialDesc: ' + fieldIn);
    console.log(sheetIn);

    console.log('->> sheetChangeMaterialDesc event:');
    console.log(event.target.value);

    let valueIn = '';

    if(event.target.value) valueIn = event.target.value.toString();

    if (fieldIn === 'mat_desc' || fieldIn === 'mat_name') {
      sheetIn.mat_desc = valueIn;
      sheetIn.mat_name = valueIn;
      const shouldCopyToPieces = this.shouldCopyMaterialToPieces(valueIn);
      if (shouldCopyToPieces) {
        const confirmed = window.confirm('¿Desea copiar esta descripción de material a todas las líneas de la pestaña Piezas?');
        if (confirmed) {
          this.copyMaterialDescToPieces(valueIn);
        }
      }
      return;
    }

    sheetIn[fieldIn] = valueIn;

  } // End function sheetChangeMaterialDesc

  // Modifica la descripción de material desde la pestaña de piezas y permite sincronizar con planchas.
  pieceChangeMaterialDesc(event: any, pieceIn: any, indexIn: number = -1) {
    console.log('pieceChangeMaterialDesc');
    console.log(pieceIn);

    let valueIn = '';
    if (event && event.target && event.target.value !== undefined && event.target.value !== null) {
      valueIn = event.target.value.toString();
    }

    pieceIn.mat_desc = valueIn;
    pieceIn.mat_name = valueIn;

    // Caso manual esperado: si se modifica la primera línea de Piezas,
    // se propaga automáticamente al resto de líneas de esa pestaña.
    if (indexIn === 0 && this.optimizationList && this.optimizationList.length > 1) {
      this.copyMaterialDescToPieces(valueIn);
    }

    const shouldCopyToSheets = this.shouldCopyMaterialToSheets(valueIn);
    if (shouldCopyToSheets) {
      const confirmed = window.confirm('¿Desea copiar esta descripción de material a todas las líneas de la pestaña Planchas?');
      if (confirmed) {
        this.copyMaterialDescToSheets(valueIn);
      }
    }
  } // End function pieceChangeMaterialDesc

  // Modifica un campo de texto de una hoja.
  sheetChangeReference(event: any, sheetIn: any, fieldIn: string) {
    console.log('sheetChangeReference: ' + fieldIn);
    console.log(sheetIn);

    console.log('->> sheetChangeReference event:');
    console.log(event.target.value);

    let valueIn = '';

    if(event.target.value) valueIn = event.target.value.toString();

    sheetIn[fieldIn] = valueIn;

  } // End function sheetChangeReference

  // Función para añadir una nueva pieza "desde cero" en el listdo de optimización.
  buttonAddSheet(): void {

    console.log('---> Entrando en buttonAddSheet:');

    let materialDesc = 'Material genérico';
    let materialName = 'Genérico';
    if (this.optimizationList && this.optimizationList.length > 0) {
      const firstPiece = this.optimizationList[0];
      if (firstPiece && firstPiece.mat_desc && firstPiece.mat_desc.toString().trim() !== '') {
        materialDesc = firstPiece.mat_desc.toString().trim();
        materialName = materialDesc;
      } else if (firstPiece && firstPiece.mat_name && firstPiece.mat_name.toString().trim() !== '') {
        materialName = firstPiece.mat_name.toString().trim();
        materialDesc = materialName;
      }
    }

    const randomMatId = 555000000 + Math.floor(Math.random() * 1000000);

    let new_sheet = {
			barcode: null,
			check: true,
			depth: this.default_depth, // 4mm es el mínimo por defecto
		diecutting:  0,
		disband_b: this.fileForm.controls.f_disband_l.value,
		disband_l: this.fileForm.controls.f_disband_b.value,
		disband_r: this.fileForm.controls.f_disband_r.value,
		disband_t: this.fileForm.controls.f_disband_t.value,
		format: null,
		height: 3210,
		id_process: null,
		lager: null,
		location: null,
			mat_id: randomMatId,
			mat_name: materialName,
			mat_desc: materialDesc,
		max_diecutting: this.fileForm.controls.max_diecutting,
		reference: null,
		retal: false,
		retal_h: this.fileForm.controls.f_retal_width.value,
		retal_w: this.fileForm.controls.f_retal_height.value,
		side: 'A',
		unit: -1,
		weight: 2.5,
		width: 6000
	};

    // Inserta la nueva plancha justo después de la última plancha que hubiese.
    this.sheetList_datafile.push(new_sheet);

    // Se actualiza el total de hojas.
    this.countTotalSheets();

    // El ancho de la hoja más grande usada será colocado automáticamente como "max travera".
	let max_trav_aux = this.calculateMaxTrav();

	this.fileForm.controls.f_max_diecutting.setValue(max_trav_aux);

	// Si hay piezas sin material se les asigna el de la primera plancha.
	this.matchSheetPieceMaterial();

	this.matchPieceMaterial();

  } // End function buttonAddSheet

  buttonEditFigure(itemIn: any, indexIn: number): void  {

    console.log('->> >> buttonEditFigure: ' + indexIn);
    console.log(itemIn);

    this.actual_piece = itemIn;

    // Se asignan en el formulario de edición los valores de la pieza seleccionada.
    this.figureForm.controls.figure_id.setValue(this.actual_piece['figure']);
    this.figureForm.controls.figure_b1.setValue(this.actual_piece['b1']);
    this.figureForm.controls.figure_b2.setValue(this.actual_piece['b2']);
    this.figureForm.controls.figure_b3.setValue(this.actual_piece['b3']);
    this.figureForm.controls.figure_b4.setValue(this.actual_piece['b4']);
    this.figureForm.controls.figure_l.setValue(this.actual_piece['l']);
    this.figureForm.controls.figure_l1.setValue(this.actual_piece['l1']);
    this.figureForm.controls.figure_l2.setValue(this.actual_piece['l2']);
    this.figureForm.controls.figure_h.setValue(this.actual_piece['h']);
    this.figureForm.controls.figure_h1.setValue(this.actual_piece['h1']);
    this.figureForm.controls.figure_h2.setValue(this.actual_piece['h2']);
    this.figureForm.controls.figure_r.setValue(this.actual_piece['r']);
    this.figureForm.controls.figure_r2.setValue(this.actual_piece['r2']);
    this.figureForm.controls.figure_r3.setValue(this.actual_piece['r3']);
    this.figureForm.controls.figure_r4.setValue(this.actual_piece['r4']);

    let form_aux = this.actual_piece['figure'];

    // Se modifica la imagen de la forma para que se muestre la de la pieza.
    if (Number(form_aux) === 926 || Number(form_aux) === 2026 || Number(form_aux) === 63) this.actual_piece_graphic = './assets/forms/form_0.png';
    else this.actual_piece_graphic = './assets/forms/form_' + form_aux + '.png';

    this.figureDxfName = '';
    if (this.actual_piece['dxf_name']) this.figureDxfName = String(this.actual_piece['dxf_name']);
    else if (this.actual_piece['piece_dxf_name']) this.figureDxfName = String(this.actual_piece['piece_dxf_name']);
    else if (this.actual_piece['form_DXF_NAME']) this.figureDxfName = String(this.actual_piece['form_DXF_NAME']);
    this.figureDxfPoints = [];
    if (this.actual_piece['dxf_points']) this.figureDxfPoints = this.normalizeDxfPoints(this.actual_piece['dxf_points']);
    else if (this.actual_piece['piece_dxf_points']) this.figureDxfPoints = this.normalizeDxfPoints(this.actual_piece['piece_dxf_points']);
    else if (this.actual_piece['form_DXF_POINTS']) this.figureDxfPoints = this.normalizeDxfPoints(this.actual_piece['form_DXF_POINTS']);
    this.figureDxfWidth = Number(this.actual_piece['dxf_w'] || this.actual_piece['piece_dxf_w'] || this.actual_piece['form_DXF_W'] || 0);
	    this.figureDxfHeight = Number(this.actual_piece['dxf_h'] || this.actual_piece['piece_dxf_h'] || this.actual_piece['form_DXF_H'] || 0);
	    this.figureDxfError = '';
	    this.figureDxfRepairAvailable = false;

    switch(Number(form_aux)) {
		case 0:
			console.log('->> Seleccionada forma 0.');

			// Se vacían los valores de los campos.
			this.figureForm.controls.figure_b1.setValue(null);
		    this.figureForm.controls.figure_b2.setValue(null);
		    this.figureForm.controls.figure_b3.setValue(null);
		    this.figureForm.controls.figure_b4.setValue(null);
		    this.figureForm.controls.figure_l.setValue(null);
		    this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
		    this.figureForm.controls.figure_h2.setValue(null);
		    this.figureForm.controls.figure_r.setValue(null);
		    this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			// Se deshabilitan todos los campos de la forma.
			this.figureForm.controls.figure_b1.disable();
			this.figureForm.controls.figure_b2.disable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.disable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

			break;

		case 1:
			console.log('->> Seleccionada forma 1.');

			this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			// Se deshabilitan todos los campos de la forma.
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_h2.disable();

			break;

		case 2:
			console.log('->> Seleccionada forma 2.');

			this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_h2.disable();

			break;

		// ------------ Nuevas formas añadidas F.

		case 3:
	    case 4:
	        console.log('->> Seleccionada forma 3 y 4.');

	        this.figureForm.controls.figure_b3.setValue(null);
	        this.figureForm.controls.figure_l2.setValue(null);
	        this.figureForm.controls.figure_r.setValue(null);

	        this.figureForm.controls.figure_b1.enable();
	        this.figureForm.controls.figure_b2.enable();
	        this.figureForm.controls.figure_b3.disable();
	        this.figureForm.controls.figure_l.enable();
	        this.figureForm.controls.figure_l1.enable();
	        this.figureForm.controls.figure_l2.disable();
	        this.figureForm.controls.figure_h.enable();
	        this.figureForm.controls.figure_h1.enable();
	        this.figureForm.controls.figure_r.disable();

	        break;

	    case 5:
	    case 6:
	      console.log('->> Seleccionada forma 5 ó 6.');

	      this.figureForm.controls.figure_h1.setValue(null);
	      this.figureForm.controls.figure_r.setValue(null);

	      this.figureForm.controls.figure_b1.enable();
	      this.figureForm.controls.figure_b2.enable();
	      this.figureForm.controls.figure_b3.enable();
	      this.figureForm.controls.figure_l.enable();
	      this.figureForm.controls.figure_l1.enable();
	      this.figureForm.controls.figure_l2.enable();
	      this.figureForm.controls.figure_h.enable();
	      this.figureForm.controls.figure_h1.disable();
	      this.figureForm.controls.figure_r.disable();
	      this.figureForm.controls.figure_r2.disable();
	      this.figureForm.controls.figure_r3.disable();
	      this.figureForm.controls.figure_r4.disable();
	      this.figureForm.controls.figure_b4.disable();
	      this.figureForm.controls.figure_h2.disable();

	      break;

	    case 7:
	    case 8:
	      console.log('->> Seleccionada forma 7 ó 8.');

	      this.figureForm.controls.figure_r.setValue(null);

	      this.figureForm.controls.figure_b1.enable();
	      this.figureForm.controls.figure_b2.enable();
	      this.figureForm.controls.figure_b3.enable();
	      this.figureForm.controls.figure_l.enable();
	      this.figureForm.controls.figure_l1.enable();
	      this.figureForm.controls.figure_l2.enable();
	      this.figureForm.controls.figure_h.enable();
	      this.figureForm.controls.figure_h1.enable();
	      this.figureForm.controls.figure_r.disable();

	      break;

	    case 9:
	    case 10:
	        console.log('->> Seleccionada forma 9 y 10.');

			this.figureForm.controls.figure_b4.setValue(null);
	        this.figureForm.controls.figure_r.setValue(null);
	        this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

	        this.figureForm.controls.figure_b1.enable();
	        this.figureForm.controls.figure_b2.enable();
	        this.figureForm.controls.figure_b3.enable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_l.enable();
	        this.figureForm.controls.figure_l1.enable();
	        this.figureForm.controls.figure_l2.enable();
	        this.figureForm.controls.figure_h.enable();
	        this.figureForm.controls.figure_h1.enable();
	        this.figureForm.controls.figure_h2.enable();
	        this.figureForm.controls.figure_r.disable();
	        this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();

	        break;

	      case 11:
	      case 12:
	      case 13:
	        console.log('->> Seleccionada forma 11,12 y 13.');

	        this.figureForm.controls.figure_l2.setValue(null);
	        this.figureForm.controls.figure_h2.setValue(null);
	        this.figureForm.controls.figure_r.setValue(null);
	        this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

	        this.figureForm.controls.figure_b1.enable();
	        this.figureForm.controls.figure_b2.enable();
	        this.figureForm.controls.figure_b3.enable();
	        this.figureForm.controls.figure_b4.enable();
	        this.figureForm.controls.figure_l.enable();
	        this.figureForm.controls.figure_l1.enable();
	        this.figureForm.controls.figure_l2.disable();
	        this.figureForm.controls.figure_h.enable();
	        this.figureForm.controls.figure_h1.enable();
	        this.figureForm.controls.figure_h2.disable();
	        this.figureForm.controls.figure_r.disable();
	        this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();


	        break;

		      case 14:
		      case 15:
		      case 16:
		      case 17:
		      case 18:
		      case 19:
		        console.log('->> Seleccionada forma 14,15,16,17,18 y 19.');

	        this.figureForm.controls.figure_b4.setValue(null);
	        this.figureForm.controls.figure_l2.setValue(null);
	        this.figureForm.controls.figure_h2.setValue(null);
	        this.figureForm.controls.figure_r.setValue(null);
	        this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

	        this.figureForm.controls.figure_b1.enable();
	        this.figureForm.controls.figure_b2.enable();
	        this.figureForm.controls.figure_b3.enable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_l.enable();
	        this.figureForm.controls.figure_l1.enable();
	        this.figureForm.controls.figure_l2.disable();
	        this.figureForm.controls.figure_h.enable();
	        this.figureForm.controls.figure_h1.enable();
	        this.figureForm.controls.figure_h2.disable();
	        this.figureForm.controls.figure_r.disable();
	        this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
		        this.figureForm.controls.figure_r4.disable();


		        break;

		      case 20:
		        console.log('->> Seleccionada forma 20.');

		        this.figureForm.controls.figure_b3.setValue(null);
		        this.figureForm.controls.figure_b4.setValue(null);
		        this.figureForm.controls.figure_l1.setValue(null);
		        this.figureForm.controls.figure_l2.setValue(null);
		        this.figureForm.controls.figure_h.setValue(null);
		        this.figureForm.controls.figure_h1.setValue(null);
		        this.figureForm.controls.figure_h2.setValue(null);
		        this.figureForm.controls.figure_r.setValue(null);
		        this.figureForm.controls.figure_r2.setValue(null);
		        this.figureForm.controls.figure_r3.setValue(null);
		        this.figureForm.controls.figure_r4.setValue(null);

		        this.figureForm.controls.figure_b1.enable();
		        this.figureForm.controls.figure_b2.enable();
		        this.figureForm.controls.figure_b3.disable();
		        this.figureForm.controls.figure_b4.disable();
		        this.figureForm.controls.figure_l.enable();
		        this.figureForm.controls.figure_l1.disable();
		        this.figureForm.controls.figure_l2.disable();
		        this.figureForm.controls.figure_h.disable();
		        this.figureForm.controls.figure_h1.disable();
		        this.figureForm.controls.figure_h2.disable();
		        this.figureForm.controls.figure_r.disable();
		        this.figureForm.controls.figure_r2.disable();
		        this.figureForm.controls.figure_r3.disable();
		        this.figureForm.controls.figure_r4.disable();

		        break;
		      case 21:
		      case 22:
		      case 23:
		        console.log('->> Seleccionada forma 21,22 ó 23.');
		        this.figureForm.controls.figure_b3.setValue(null);
		        this.figureForm.controls.figure_b4.setValue(null);
		        this.figureForm.controls.figure_l1.setValue(null);
		        this.figureForm.controls.figure_l2.setValue(null);
		        this.figureForm.controls.figure_h.setValue(null);
		        this.figureForm.controls.figure_h1.setValue(null);
		        this.figureForm.controls.figure_h2.setValue(null);
		        this.figureForm.controls.figure_r.setValue(null);
		        this.figureForm.controls.figure_r2.setValue(null);
		        this.figureForm.controls.figure_r3.setValue(null);
		        this.figureForm.controls.figure_r4.setValue(null);
		        this.figureForm.controls.figure_b1.enable();
		        this.figureForm.controls.figure_b2.enable();
		        this.figureForm.controls.figure_b3.disable();
		        this.figureForm.controls.figure_b4.disable();
		        this.figureForm.controls.figure_l.enable();
		        this.figureForm.controls.figure_l1.disable();
		        this.figureForm.controls.figure_l2.disable();
		        this.figureForm.controls.figure_h.disable();
		        this.figureForm.controls.figure_h1.disable();
		        this.figureForm.controls.figure_h2.disable();
		        this.figureForm.controls.figure_r.disable();
		        this.figureForm.controls.figure_r2.disable();
		        this.figureForm.controls.figure_r3.disable();
		        this.figureForm.controls.figure_r4.disable();
		        break;
		      case 24:
		        console.log('->> Seleccionada forma 24.');
		        this.figureForm.controls.figure_b2.setValue(null);
		        this.figureForm.controls.figure_b3.setValue(null);
		        this.figureForm.controls.figure_b4.setValue(null);
		        this.figureForm.controls.figure_l1.setValue(null);
		        this.figureForm.controls.figure_l2.setValue(null);
		        this.figureForm.controls.figure_h.setValue(null);
		        this.figureForm.controls.figure_h1.setValue(null);
		        this.figureForm.controls.figure_h2.setValue(null);
		        this.figureForm.controls.figure_r.setValue(null);
		        this.figureForm.controls.figure_r2.setValue(null);
		        this.figureForm.controls.figure_r3.setValue(null);
		        this.figureForm.controls.figure_r4.setValue(null);
		        this.figureForm.controls.figure_b1.enable();
		        this.figureForm.controls.figure_b2.disable();
		        this.figureForm.controls.figure_b3.disable();
		        this.figureForm.controls.figure_b4.disable();
		        this.figureForm.controls.figure_l.enable();
		        this.figureForm.controls.figure_l1.disable();
		        this.figureForm.controls.figure_l2.disable();
		        this.figureForm.controls.figure_h.disable();
		        this.figureForm.controls.figure_h1.disable();
		        this.figureForm.controls.figure_h2.disable();
		        this.figureForm.controls.figure_r.disable();
		        this.figureForm.controls.figure_r2.disable();
		        this.figureForm.controls.figure_r3.disable();
		        this.figureForm.controls.figure_r4.disable();
		        break;

	    case 25:
	      console.log('->> Seleccionada forma 25.');

	      this.figureForm.controls.figure_l1.setValue(null);
	      this.figureForm.controls.figure_l2.setValue(null);

	      this.figureForm.controls.figure_b1.enable();
	      this.figureForm.controls.figure_b2.enable();
	      this.figureForm.controls.figure_b3.enable();
	      this.figureForm.controls.figure_l.enable();
	      this.figureForm.controls.figure_l1.disable();
	      this.figureForm.controls.figure_l2.disable();
	      this.figureForm.controls.figure_h.enable();
	      this.figureForm.controls.figure_h1.disable();
	      this.figureForm.controls.figure_r.enable();
	      this.figureForm.controls.figure_r2.disable();
	      this.figureForm.controls.figure_r3.disable();
	      this.figureForm.controls.figure_r4.disable();
	      this.figureForm.controls.figure_b4.disable();
	      this.figureForm.controls.figure_h2.disable();

	      break;

	    case 26:
	      console.log('->> Seleccionada forma 26.');

	      this.figureForm.controls.figure_l1.setValue(null);
	      this.figureForm.controls.figure_l2.setValue(null);

	      this.figureForm.controls.figure_b1.enable();
	      this.figureForm.controls.figure_b2.enable();
	      this.figureForm.controls.figure_b3.disable();
	      this.figureForm.controls.figure_l.enable();
	      this.figureForm.controls.figure_l1.disable();
	      this.figureForm.controls.figure_l2.disable();
	      this.figureForm.controls.figure_h.enable();
	      this.figureForm.controls.figure_h1.disable();
	      this.figureForm.controls.figure_r.enable();
	      this.figureForm.controls.figure_r2.disable();
	      this.figureForm.controls.figure_r3.disable();
	      this.figureForm.controls.figure_r4.disable();
	      this.figureForm.controls.figure_b4.disable();
	      this.figureForm.controls.figure_h2.disable();

	      break;

		// ------------ Fin nuevas formas añadidas F.

		case 27:
			console.log('->> Seleccionada forma 27.');

			this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_h2.disable();

			break;
		case 28:
			console.log('->> Seleccionada forma 28.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
	        break;
		case 30:
		case 31:
			console.log('->> Seleccionada forma 30 ó 31.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.disable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        break;
		case 32:
			console.log('->> Seleccionada forma 32.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        break;
		case 33:
		case 34:
			console.log('->> Seleccionada forma 33 ó 34.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        break;
		case 35:
		case 36:
			console.log('->> Seleccionada forma 35 ó 36.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_b4.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        break;

		case 29:
			console.log('->> Seleccionada forma 29.');

			this.figureForm.controls.figure_b2.setValue(null);
		    this.figureForm.controls.figure_b3.setValue(null);
		    this.figureForm.controls.figure_l.setValue(null);
		    this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.disable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_l.disable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_h2.disable();

			break;

		case 37:
			console.log('->> Edición: Seleccionada forma 37.');

			this.figureForm.controls.figure_b3.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_h2.disable();

			break;
		case 38:
			console.log('->> Edición: Seleccionada forma 38.');
			this.figureForm.controls.figure_b3.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
		    this.figureForm.controls.figure_h2.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_h2.disable();
			break;
		case 40:
			console.log('->> Edición: Seleccionada forma 40.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 41:
			console.log('->> Edición: Seleccionada forma 41.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 42:
			console.log('->> Edición: Seleccionada forma 42.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;

		case 371:
			console.log('->> Edición: Seleccionada forma 371.');

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.disable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_h2.disable();

			break;

		case 372:
			console.log('->> Edición: Seleccionada forma 372.');

			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();

			break;

		case 43:
			console.log('->> Seleccionada forma 43.');

			this.figureForm.controls.figure_b3.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_h2.disable();

			break;
		case 44:
			console.log('->> Seleccionada forma 44.');
			this.figureForm.controls.figure_b3.setValue(null);
			this.figureForm.controls.figure_h.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
		    this.figureForm.controls.figure_h2.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_h2.disable();
			break;
		case 45:
		case 46:
			console.log('->> Seleccionada forma 45 ó 46.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 47:
		case 49:
			console.log('->> Seleccionada forma 47 ó 49.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;
		case 48:
			console.log('->> Seleccionada forma 48.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			break;

		case 50:
			console.log('->> Seleccionada forma 50.');

			this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);

			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
	        this.figureForm.controls.figure_h2.disable();

			break;
		case 51:
			console.log('->> Seleccionada forma 51.');
			this.figureForm.controls.figure_l1.setValue(null);
		    this.figureForm.controls.figure_l2.setValue(null);
		    this.figureForm.controls.figure_h.setValue(null);
		    this.figureForm.controls.figure_h1.setValue(null);
		    this.figureForm.controls.figure_h2.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			break;
		case 52:
			console.log('->> Seleccionada forma 52.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.enable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			break;
		case 53:
			console.log('->> Seleccionada forma 53.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			break;
		case 54:
			console.log('->> Seleccionada forma 54.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_l.disable();
			this.figureForm.controls.figure_l1.enable();
			this.figureForm.controls.figure_l2.enable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.enable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			break;
		case 56:
			console.log('->> Seleccionada forma 56.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.disable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.enable();
	        this.figureForm.controls.figure_r3.enable();
	        this.figureForm.controls.figure_r4.enable();
	        this.figureForm.controls.figure_b4.disable();
			break;
		case 57:
		case 58:
			console.log('->> Seleccionada forma 57/58.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.enable();
	        this.figureForm.controls.figure_r3.enable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			break;
			case 59:
				console.log('->> Seleccionada forma 59.');
				this.figureForm.controls.figure_b1.enable();
				this.figureForm.controls.figure_b2.enable();
				this.figureForm.controls.figure_b3.disable();
				this.figureForm.controls.figure_l.disable();
				this.figureForm.controls.figure_l1.disable();
				this.figureForm.controls.figure_l2.disable();
				this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			break;
		case 60:
			console.log('->> Seleccionada forma 60.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.enable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
			this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			break;
		case 61:
			console.log('->> Seleccionada forma 61.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.enable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			break;
		case 62:
			console.log('->> Seleccionada forma 62.');
			this.figureForm.controls.figure_b1.enable();
			this.figureForm.controls.figure_b2.enable();
			this.figureForm.controls.figure_b3.enable();
			this.figureForm.controls.figure_l.enable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.enable();
			this.figureForm.controls.figure_r2.enable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
	        this.figureForm.controls.figure_b4.disable();
			break;
			case 926:
			case 2026:
			case 63:
				console.log('->> Seleccionada forma 926 (DXF libre).');
				if (this.figureForm.controls.figure_b1.value === null || this.figureForm.controls.figure_b1.value === undefined) this.figureForm.controls.figure_b1.setValue(0);
				if (this.figureForm.controls.figure_b2.value === null || this.figureForm.controls.figure_b2.value === undefined) this.figureForm.controls.figure_b2.setValue(0);
				if (this.figureForm.controls.figure_b3.value === null || this.figureForm.controls.figure_b3.value === undefined) this.figureForm.controls.figure_b3.setValue(0);
				if (this.figureForm.controls.figure_b4.value === null || this.figureForm.controls.figure_b4.value === undefined) this.figureForm.controls.figure_b4.setValue(0);
				this.figureForm.controls.figure_l.setValue(null);
				this.figureForm.controls.figure_l1.setValue(null);
				this.figureForm.controls.figure_l2.setValue(null);
			this.figureForm.controls.figure_h.setValue(null);
			this.figureForm.controls.figure_h1.setValue(null);
			this.figureForm.controls.figure_h2.setValue(null);
			this.figureForm.controls.figure_r.setValue(null);
			this.figureForm.controls.figure_r2.setValue(null);
	        this.figureForm.controls.figure_r3.setValue(null);
	        this.figureForm.controls.figure_r4.setValue(null);
				this.figureForm.controls.figure_b1.enable();
				this.figureForm.controls.figure_b2.enable();
				this.figureForm.controls.figure_b3.enable();
				this.figureForm.controls.figure_b4.enable();
			this.figureForm.controls.figure_l.disable();
			this.figureForm.controls.figure_l1.disable();
			this.figureForm.controls.figure_l2.disable();
			this.figureForm.controls.figure_h.disable();
			this.figureForm.controls.figure_h1.disable();
			this.figureForm.controls.figure_h2.disable();
			this.figureForm.controls.figure_r.disable();
			this.figureForm.controls.figure_r2.disable();
	        this.figureForm.controls.figure_r3.disable();
	        this.figureForm.controls.figure_r4.disable();
			break;

		case 55:
	      console.log('->> Seleccionada forma 55.');

	      /*
	      this.figureForm.controls.figure_l.setValue(null);
	      this.figureForm.controls.figure_h.setValue(null);
	      this.figureForm.controls.figure_r.setValue(null);
	      this.figureForm.controls.figure_r2.setValue(null);
	      this.figureForm.controls.figure_r3.setValue(null);
	      this.figureForm.controls.figure_r4.setValue(null);
	      */

	      this.figureForm.controls.figure_b1.enable();
	      this.figureForm.controls.figure_b2.enable();
	      this.figureForm.controls.figure_b3.enable();
	      this.figureForm.controls.figure_b4.enable();
	      this.figureForm.controls.figure_l.enable();
	      this.figureForm.controls.figure_l1.disable();
	      this.figureForm.controls.figure_l2.disable();
	      this.figureForm.controls.figure_h.enable();
	      this.figureForm.controls.figure_h1.disable();
	      this.figureForm.controls.figure_h2.disable();
	      this.figureForm.controls.figure_r.enable();
	      this.figureForm.controls.figure_r2.enable();
	      this.figureForm.controls.figure_r3.enable();
	      this.figureForm.controls.figure_r4.enable();

	      break;

	} // End Switch // */
    this.ensureFigure61RadiusControlEnabled();

    this.showFigureModal(true);

  } // End function buttonEditFigure

  buttonPieceClone(itemIn: any, indexIn: number): void {

    console.log('---> Entrando en buttonPieceClone: ' + indexIn);
    console.log(itemIn);

    let new_piece = JSON.parse(JSON.stringify(itemIn));

    const maxSequence = this.optimizationList.reduce((acc, piece) => {
      const value = Number(piece && piece.sequence ? piece.sequence : 0);
      return value > acc ? value : acc;
    }, 0);
    const maxOrderPos = this.optimizationList.reduce((acc, piece) => {
      const value = Number(piece && piece.orderpos ? piece.orderpos : 0);
      return value > acc ? value : acc;
    }, 0);

    new_piece.sequence = maxSequence > 0 ? (maxSequence + 1) : 1;
    new_piece.orderpos = maxOrderPos > 0 ? (maxOrderPos + 1) : 1;
    new_piece.id = null;
    new_piece.check = true;

    // Se añade al final para mantener orden visual ascendente de Secuencia/Línea.
    this.optimizationList.push(new_piece);

    // Se actualiza también el total de piezas.
    this.totalSelectedPieces += this.getSelectedPieceUnits(new_piece);

  } // End function buttonPieceClone

  // Función para añadir una nueva pieza "desde cero" en el listdo de optimización.
  buttonAddPiece(): void {

    console.log('---> Entrando en buttonAddPiece:');

    const hasPreviousPiece = this.optimizationList && this.optimizationList.length > 0;
    const previousPiece = hasPreviousPiece ? this.optimizationList[this.optimizationList.length - 1] : null;

    let new_piece: any;

    if (previousPiece) {
      new_piece = JSON.parse(JSON.stringify(previousPiece));
      const previousSequence = Number(previousPiece.sequence || 0);
      const previousOrderPos = Number(previousPiece.orderpos || 0);

      new_piece.id = null;
      new_piece.sequence = previousSequence > 0 ? (previousSequence + 1) : 1;
      new_piece.orderpos = previousOrderPos > 0 ? (previousOrderPos + 1) : 1;
      new_piece.check = true;
      if (new_piece.units === undefined || new_piece.units === null || Number(new_piece.units) < 1) {
        new_piece.units = 1;
      }
    } else {
      new_piece = {
        id: null,
        lot: 1,
        sequence: 1,
        mat_id: 0,
        mat_name: 'Genérico',
        mat_desc: 'Material genérico',
        steps: 'CORTE',
        orderno: 1,
        orderpos: 1,
        paneno: 1,
        width: 1000,
        height: 1000,
        depth: this.default_depth, // 4mm es el mínimo por defecto
        units: 1,
        priority: 0,
        figure: 0,
        l: null,
        l1: null,
        l2: null,
        h: null,
        h1: null,
        h2: null,
        r: null,
        r2: null,
        r3: null,
        r4: null,
        b1: null,
        b2: null,
        b3: null,
        b4: null,
        dxf_name: null,
        dxf_points: null,
        dxf_w: null,
        dxf_h: null,
        easel: '',
        decoat: 0,
        group: 'A',
        check: true
      };
    }

	this.optimizationList.push(new_piece);

	// Se actualiza el total de piezas.
    this.totalSelectedPieces += 1;

	// Se le asigna el material de la primera plancha.
	this.matchSheetPieceMaterial();

  } // End function buttonAddPiece

  removePiece(item: any, indexIn: number): void {
    console.log('---> Entrando en removePiece: ' + indexIn);

    let num_aux = Number(this.optimizationList[indexIn].units);

    // Se elimina la pieza del listdo.
	this.optimizationList.splice(indexIn, 1);

    // Se resta el número de unidades de esa entrada al número total de piezas.
    this.totalSelectedPieces = this.totalSelectedPieces - num_aux;

  } // End function removePiece

  // -----------

  // Función que limpia la "entrada de piezas" y la "entrada de hojas"
  // carga la información de la optimización actual seleccionada que exista.
  chargePiecesOpti() {
    this.disableOefForVsBudgetDirectInput = false;
	console.log('---> Entrando en chargePiecesOpti: ');
	// console.log(this.chargeOpti);
	// console.log('---> chargeSheetOpti: ');
	// console.log(this.chargeSheetOpti);

	// Se limpian las piezas y planchas que hubise cargadas.
	this.emptyCSV('piece');
	this.emptyCSV('sheet');

	// Se inicializa la lista de optimizaciones simuladas.
	this.total_better_opti_list = [];

	// CARGA DE PIEZAS -------------

	// A) Se ordenan las piezas para que aparezcan en el mismo orden que tenían cuando
	// se grabó la optimización (porque de momento esto influye en el resultado).
	//this.chargeOpti = this.opti.orderByListOrder(this.chargeOpti, false);

	// B) Se ordenan las piezas según "list_order" guardado para reproducir
	// de forma estable la optimización histórica al recargarla.
	this.chargeOpti = this.opti.orderByListOrder(this.chargeOpti, false);

    // Restaurar modo OEF al cargar optimización histórica cuando hay rastro OEF.
    const hasStoredOefRows = Array.isArray(this.chargeOpti)
      ? this.chargeOpti.some(row => row && (row['oef_generated'] === true || Number(row['oef_generated']) === 1))
      : false;
    const currentOptiOefUsed = !!(this.currentOpti && (this.currentOpti['od_oef_used'] === true || Number(this.currentOpti['od_oef_used']) === 1));
    if (currentOptiOefUsed || hasStoredOefRows) {
      this.oefEnabled = true;
      if (this.currentOpti && this.currentOpti['od_oef_preset']) {
        this.oefPreset = this.currentOpti['od_oef_preset'].toString();
      }
      const phaseRaw = Number(this.currentOpti && this.currentOpti['od_oef_phase'] !== undefined ? this.currentOpti['od_oef_phase'] : this.oefPhase);
      this.oefPhase = Number.isFinite(phaseRaw) && phaseRaw >= 2 ? 2 : 1;
      this.persistOefSettingsToStorage();
    }

    const parseMaybeJson = (valueIn: any): any => {
      if (valueIn === undefined || valueIn === null || valueIn === '') {
        return null;
      }
      if (Array.isArray(valueIn) || typeof valueIn === 'object') {
        return valueIn;
      }
      if (typeof valueIn === 'string') {
        try {
          return JSON.parse(valueIn);
        } catch (error) {
          return valueIn;
        }
      }
      return valueIn;
    };

	// Se colocan las piezas de la optimización actual.
	// Al recargar, puede venir mezcla de filas base y filas derivadas OEF.
	// Aquí se reconstruye 1 entrada por línea de pedido (id_line), priorizando
	// geometría base si existe y conservando unidades reales (total_unit).
	const loadedPiecesRaw = [];
    const isGeneratedOefRow = (rowIn: any): boolean => {
      return rowIn && (rowIn['oef_generated'] === true || Number(rowIn['oef_generated']) === 1);
    };
	    const getLineKey = (rowIn: any): string => {
	      if (!rowIn) { return 'line:null'; }

	      // Los primitivos OEF cargados desde BD pueden venir sin id_line válido.
	      // En ese caso NO se deben fusionar entre sí usando una key por lote/secuencia,
	      // porque al unificar lotes (p.ej. todo a lote=1) colisionan familias distintas.
	      // Cada fila OEF debe preservarse como su propia entrada.
	      if (isGeneratedOefRow(rowIn)) {
	        // Clave por línea fuente (pedido/posición), no por polígono.
	        // Evita crear 8-9 líneas en pestaña Piezas a partir de primitivas OEF derivadas.
	        return [
	          'oef-source-fallback',
	          rowIn['orderno'] !== undefined ? rowIn['orderno'] : '',
	          rowIn['orderpos'] !== undefined ? rowIn['orderpos'] : '',
	          rowIn['mat_id'] !== undefined ? rowIn['mat_id'] : '',
	          rowIn['id_client'] !== undefined ? rowIn['id_client'] : '',
	          rowIn['reference'] !== undefined ? rowIn['reference'] : '',
	          rowIn['sequence'] !== undefined ? rowIn['sequence'] : '',
	          rowIn['lot'] !== undefined ? rowIn['lot'] : ''
	        ].join('|');
	      }

	      const idLine = Number(rowIn['id_line']);
	      if (Number.isFinite(idLine) && idLine > 0) {
	        return 'line:' + idLine;
	      }

	      return [
	        'fallback',
	        rowIn['lot'] !== undefined ? rowIn['lot'] : '',
	        rowIn['sequence'] !== undefined ? rowIn['sequence'] : '',
	        rowIn['orderno'] !== undefined ? rowIn['orderno'] : '',
	        rowIn['orderpos'] !== undefined ? rowIn['orderpos'] : '',
	        rowIn['form_id'] !== undefined ? rowIn['form_id'] : '',
	        rowIn['l'] !== undefined ? rowIn['l'] : '',
	        rowIn['h'] !== undefined ? rowIn['h'] : '',
	        rowIn['b1'] !== undefined ? rowIn['b1'] : '',
	        rowIn['b2'] !== undefined ? rowIn['b2'] : '',
	        rowIn['l1'] !== undefined ? rowIn['l1'] : '',
	        rowIn['l2'] !== undefined ? rowIn['l2'] : '',
	        rowIn['width'] !== undefined ? rowIn['width'] : '',
	        rowIn['height'] !== undefined ? rowIn['height'] : ''
	      ].join('|');
	    };
    const groupedByLine = {};
    (this.chargeOpti || []).forEach((row: any) => {
      const key = getLineKey(row);
      if (!groupedByLine[key]) {
        groupedByLine[key] = [];
      }
      groupedByLine[key].push(row);
    });
    const chargeOptiRows = Object.keys(groupedByLine).map(key => {
      const rows: any[] = groupedByLine[key];
      const baseRows = rows.filter(row => !isGeneratedOefRow(row));
      const scoreRowForPick = (rowIn: any): number => {
        if (!rowIn) { return 0; }
        let score = 0;
        const formId = Number(rowIn['form_id']);
        if (Number.isFinite(formId) && formId > 0) { score += 200; }
        const pol = parseMaybeJson(rowIn['oef_internal_polygons']);
        if (Array.isArray(pol) && pol.length > 0) { score += 100 + pol.length; }
        ['l', 'h', 'l1', 'l2', 'b1', 'b2', 'b3', 'b4', 'r', 'r2', 'r3', 'r4'].forEach(key => {
          const v = Number(rowIn[key]);
          if (Number.isFinite(v) && v > 0) { score += 1; }
        });
        return score;
      };
      const pickRows = baseRows.length > 0 ? baseRows : rows;
      const pick = pickRows.slice().sort((a, b) => scoreRowForPick(b) - scoreRowForPick(a))[0];
      const totalUnitCandidates = rows
        .map(row => Number(row && row['total_unit']))
        .filter(v => Number.isFinite(v) && v > 0);
      const countRows = baseRows.length > 0 ? baseRows : rows;
      const totalPanenoAsPiecesSum = countRows
        .map(row => {
          const paneno = Number(row && row['total_paneno']);
          if (!Number.isFinite(paneno) || paneno <= 0) {
            return 0;
          }
          const polygons = parseMaybeJson(row && row['oef_internal_polygons']);
          const polygonsCount = Array.isArray(polygons) ? polygons.length : 0;
          const pieceFactor = (isGeneratedOefRow(row) && polygonsCount > 1) ? polygonsCount : 1;
          return paneno * pieceFactor;
        })
        .reduce((acc, v) => acc + v, 0);
      const rowUnitCandidates = rows
        .map(row => Number(row && row['num_of']))
        .filter(v => Number.isFinite(v) && v > 0);
      const maxTotalUnit = totalUnitCandidates.length > 0 ? Math.max.apply(null, totalUnitCandidates) : 0;
      const maxRowUnits = rowUnitCandidates.length > 0 ? Math.max.apply(null, rowUnitCandidates) : 0;
      const resolvedUnits = Math.max(1, maxTotalUnit, maxRowUnits, totalPanenoAsPiecesSum);
      const cloned = JSON.parse(JSON.stringify(pick));
      const copyFirstUseful = (targetIn: any, rowsIn: any[], fieldIn: string): void => {
        const isUseful = (valueIn: any): boolean => {
          if (valueIn === undefined || valueIn === null) { return false; }
          if (typeof valueIn === 'string') { return valueIn.trim() !== ''; }
          if (Array.isArray(valueIn)) { return valueIn.length > 0; }
          if (typeof valueIn === 'number') { return Number.isFinite(valueIn) && valueIn !== 0; }
          return true;
        };
        if (isUseful(targetIn[fieldIn])) {
          return;
        }
        const found = (rowsIn || []).find(r => r && isUseful(r[fieldIn]));
        if (found) {
          targetIn[fieldIn] = found[fieldIn];
        }
      };
      const copyMaxPositive = (targetIn: any, rowsIn: any[], fieldIn: string): void => {
        const values = (rowsIn || [])
          .map(r => Number(r && r[fieldIn]))
          .filter(v => Number.isFinite(v) && v > 0);
        if (values.length > 0) {
          targetIn[fieldIn] = Math.max.apply(null, values);
        }
      };
      // Reconstrucción robusta: completar la fila elegida con datos de forma
      // presentes en cualquier fila del mismo grupo (base u OEF derivadas).
      [
        'form_id',
        'l', 'l1', 'l2', 'h', 'h1', 'h2',
        'b1', 'b2', 'b3', 'b4',
        'r', 'r2', 'r3', 'r4',
        'dxf_name', 'dxf_points', 'dxf_w', 'dxf_h',
        'form_DXF_NAME', 'form_DXF_POINTS', 'form_DXF_W', 'form_DXF_H',
        'piece_dxf_name', 'piece_dxf_points', 'piece_dxf_w', 'piece_dxf_h',
        'oef_primitive_b1', 'oef_primitive_b2', 'oef_primitive_b3', 'oef_primitive_b4',
        'piece_oef_primitive_b1', 'piece_oef_primitive_b2', 'piece_oef_primitive_b3', 'piece_oef_primitive_b4'
      ].forEach(field => copyFirstUseful(cloned, rows, field));
      copyMaxPositive(cloned, rows, 'form_id');
      const onlyGeneratedCluster = baseRows.length < 1 && rows.length > 1;
      cloned._charge_units_override = resolvedUnits;
      // Sólo desactivamos OEF si para esa línea existe fila base explícita.
      // Si la línea sólo existe como primitivo OEF guardado, hay que respetarlo
      // para no perder figura/parámetros al recargar desde BD.
      // Cuando hay varias filas OEF derivadas para la misma línea fuente,
      // se reconstruye la línea de entrada y no debe quedar como primitivo OEF.
      cloned._charge_force_disable_oef = baseRows.length > 0 || onlyGeneratedCluster;
      return cloned;
    });

	chargeOptiRows.forEach(ca => {
        const dxfPointsParsed = parseMaybeJson(ca['dxf_points'] ? ca['dxf_points'] : (ca['piece_dxf_points'] ? ca['piece_dxf_points'] : ca['form_DXF_POINTS']));
        const oefPolygonsParsed = parseMaybeJson(ca['oef_internal_polygons'] ? ca['oef_internal_polygons'] : ca['piece_oef_internal_polygons']);
        let oefGenerated = ca['oef_generated'] === true || Number(ca['oef_generated']) === 1 ||
          (Array.isArray(oefPolygonsParsed) && oefPolygonsParsed.length > 0);
        let resolvedFormId = (ca['form_id'] !== undefined && ca['form_id'] !== null)
          ? Number(ca['form_id'])
          : ((ca['piece_figure_input'] !== undefined && ca['piece_figure_input'] !== null)
            ? Number(ca['piece_figure_input'])
            : 0);
        const totalPaneno = Number(ca['total_paneno']);
        const totalUnit = Number(ca['total_unit']);
        const hasOefPolygons = Array.isArray(oefPolygonsParsed) && oefPolygonsParsed.length > 0;
        let oefPrimitiveW = Number(ca['oef_primitive_w'] !== undefined && ca['oef_primitive_w'] !== null ? ca['oef_primitive_w'] : 0);
        let oefPrimitiveH = Number(ca['oef_primitive_h'] !== undefined && ca['oef_primitive_h'] !== null ? ca['oef_primitive_h'] : 0);
        let oefPrimitiveB1 = Number(ca['oef_primitive_b1'] !== undefined && ca['oef_primitive_b1'] !== null ? ca['oef_primitive_b1'] : (ca['piece_oef_primitive_b1'] !== undefined && ca['piece_oef_primitive_b1'] !== null ? ca['piece_oef_primitive_b1'] : 0));
        let oefPrimitiveB2 = Number(ca['oef_primitive_b2'] !== undefined && ca['oef_primitive_b2'] !== null ? ca['oef_primitive_b2'] : (ca['piece_oef_primitive_b2'] !== undefined && ca['piece_oef_primitive_b2'] !== null ? ca['piece_oef_primitive_b2'] : 0));
        let oefPrimitiveB3 = Number(ca['oef_primitive_b3'] !== undefined && ca['oef_primitive_b3'] !== null ? ca['oef_primitive_b3'] : (ca['piece_oef_primitive_b3'] !== undefined && ca['piece_oef_primitive_b3'] !== null ? ca['piece_oef_primitive_b3'] : 0));
        let oefPrimitiveB4 = Number(ca['oef_primitive_b4'] !== undefined && ca['oef_primitive_b4'] !== null ? ca['oef_primitive_b4'] : (ca['piece_oef_primitive_b4'] !== undefined && ca['piece_oef_primitive_b4'] !== null ? ca['piece_oef_primitive_b4'] : 0));
        const loadedWidth = Number(ca['width']);
        const loadedHeight = Number(ca['height']);
        const isOefCompositeLoaded = oefGenerated && hasOefPolygons && oefPolygonsParsed.length > 1;

        let resolvedWidth = (isOefCompositeLoaded && Number.isFinite(oefPrimitiveW) && oefPrimitiveW > 0)
          ? oefPrimitiveW
          : loadedWidth;
        let resolvedHeight = (isOefCompositeLoaded && Number.isFinite(oefPrimitiveH) && oefPrimitiveH > 0)
          ? oefPrimitiveH
          : loadedHeight;

        // Si una fila ya contiene un primitivo OEF compuesto (múltiples polígonos internos),
        // se conserva en UI la unidad real (pieza), pero runtime trabaja por packs.
        let resolvedUnits = Number(ca['_charge_units_override']);
        if (!Number.isFinite(resolvedUnits) || resolvedUnits <= 0) {
          resolvedUnits = (Number.isFinite(totalPaneno) && totalPaneno > 0 ? totalPaneno : (Number.isFinite(totalUnit) && totalUnit > 0 ? totalUnit : 1));
        }
        let resolvedRuntimeUnits = Math.max(1, Math.round(Number(resolvedUnits)));
        let resolvedOefRealUnits = 1;
        // Compatibilidad legacy: solo si no hay métricas OEF de primitivo guardadas.
        // En guardados actuales forzar polígonos->units multiplica piezas al recargar.
        if (isOefCompositeLoaded && resolvedUnits <= 1 && Array.isArray(oefPolygonsParsed) && oefPolygonsParsed.length > 1) {
          const hasPrimitiveMetrics = (Number.isFinite(oefPrimitiveW) && oefPrimitiveW > 0) ||
            (Number.isFinite(oefPrimitiveH) && oefPrimitiveH > 0) ||
            (Number(ca['oef_effective_area']) > 0);
          if (!hasPrimitiveMetrics) {
            resolvedUnits = oefPolygonsParsed.length;
          }
        }

        let resolvedOefPolygons: any = hasOefPolygons ? JSON.parse(JSON.stringify(oefPolygonsParsed)) : null;

        // Política de carga: no inferir forma por geometría.
        // La forma debe venir inventariada desde BD (form_id / piece_figure_input).

        const forceDisableOef = ca['_charge_force_disable_oef'] === true;
        // Solo corregir por packs cuando realmente se vaya a mantener OEF compuesto.
        if (!forceDisableOef && isOefCompositeLoaded && Array.isArray(resolvedOefPolygons) && resolvedOefPolygons.length > 1) {
          const internalPieceCount = Math.max(1, Math.round(Number(resolvedOefPolygons.length)));
          const rawUnits = Math.max(1, Math.round(Number(resolvedUnits)));
          resolvedUnits = rawUnits;
          resolvedRuntimeUnits = Math.max(1, Math.round(rawUnits / internalPieceCount));
          resolvedOefRealUnits = internalPieceCount;
        } else {
          resolvedRuntimeUnits = Math.max(1, Math.round(Number(resolvedUnits)));
          resolvedOefRealUnits = 1;
        }
        if (forceDisableOef) {
          oefGenerated = false;
          resolvedOefPolygons = null;
          oefPrimitiveW = 0;
          oefPrimitiveH = 0;
          oefPrimitiveB1 = 0;
          oefPrimitiveB2 = 0;
          oefPrimitiveB3 = 0;
          oefPrimitiveB4 = 0;
          resolvedRuntimeUnits = Math.max(1, Math.round(Number(resolvedUnits)));
          resolvedOefRealUnits = 1;
          // Si al recargar agrupamos filas OEF derivadas como línea base, recuperar
          // dimensiones nominales de la forma para la pestaña Piezas.
          if (resolvedFormId === 38) {
            const lNom = Number(ca['l']);
            const hNom = Number(ca['h']);
            if (Number.isFinite(lNom) && lNom > 0) { resolvedWidth = lNom; }
            if (Number.isFinite(hNom) && hNom > 0) { resolvedHeight = hNom; }
          } else if (resolvedFormId === 6 || resolvedFormId === 5) {
            const lNom = Number(ca['l']);
            const hNom = Number(ca['h']);
            if (Number.isFinite(lNom) && lNom > 0) { resolvedWidth = lNom; }
            if (Number.isFinite(hNom) && hNom > 0) { resolvedHeight = hNom; }
          } else if (resolvedFormId === 20) {
            const lNom = Number(ca['l']);
            if (Number.isFinite(lNom) && lNom > 0) {
              resolvedWidth = lNom;
              resolvedHeight = Number(((Math.sqrt(3) / 2) * lNom).toFixed(2));
            }
          }
        }

        // Normalización de dimensiones base para evitar dividir líneas por rotación
        // (caso típico: forma 38 cargada como 500x700 y 700x500).
        if (resolvedFormId === 38) {
          const rawL = Number(ca['l']);
          const rawH = Number(ca['h']);
          if (Number.isFinite(rawL) && rawL > 0 && Number.isFinite(rawH) && rawH > 0) {
            resolvedWidth = rawL;
            resolvedHeight = rawH;
          }
        } else if (resolvedFormId === 6 || resolvedFormId === 5) {
          const rawL = Number(ca['l']);
          const rawH = Number(ca['h']);
          if (Number.isFinite(rawL) && rawL > 0 && Number.isFinite(rawH) && rawH > 0) {
            resolvedWidth = rawL;
            resolvedHeight = rawH;
          }
        } else if (resolvedFormId === 20) {
          const rawL = Number(ca['l']);
          if (Number.isFinite(rawL) && rawL > 0) {
            resolvedWidth = rawL;
            resolvedHeight = Number(((Math.sqrt(3) / 2) * rawL).toFixed(2));
          }
        }

        // Corrección de compatibilidad para primitvos OEF antiguos de figura 20:
        // si el contorno llega mal escalado, se regenera según L/B1/B2.
        if (isOefCompositeLoaded && oefGenerated === true && Array.isArray(resolvedOefPolygons) && resolvedOefPolygons.length > 0 &&
            resolvedFormId === 20 && Number.isFinite(resolvedWidth) && Number.isFinite(resolvedHeight)) {
          const L = Number(ca['l']);
          if (Number.isFinite(L) && L > 0) {
            const triH = (Math.sqrt(3) / 2) * L;
            const tri = [
              { x: 0, y: triH },
              { x: L / 2, y: 0 },
              { x: L, y: triH }
            ];
            const triFlip = tri.map(pt => ({ x: pt.x, y: triH - pt.y }));
            const polyCount = Math.max(2, resolvedOefPolygons ? resolvedOefPolygons.length : 2);
            const stepX = L / 2;
            const rebuilt = [];
            for (let i = 0; i < polyCount; i++) {
              const px = i * stepX;
              const src = (i % 2) === 1 ? triFlip : tri;
              rebuilt.push(src.map(pt => ({ x: Number((pt.x + px).toFixed(2)), y: Number(pt.y.toFixed(2)) })));
            }
            // Rebase a [0,0]
            const mergedPoints = [];
            rebuilt.forEach(poly => {
              (poly || []).forEach(pt => mergedPoints.push(pt));
            });
            const xs = mergedPoints.map(pt => Number(pt.x));
            const ys = mergedPoints.map(pt => Number(pt.y));
            const minX = Math.min.apply(null, xs);
            const minY = Math.min.apply(null, ys);
            const maxX = Math.max.apply(null, xs);
            const maxY = Math.max.apply(null, ys);
            resolvedOefPolygons = rebuilt.map(poly => poly.map(pt => ({ x: Number((pt.x - minX).toFixed(2)), y: Number((pt.y - minY).toFixed(2)) })));

            // Se recalculan medidas reales del primitivo compuesto.
            oefPrimitiveW = Number((maxX - minX).toFixed(2));
            oefPrimitiveH = Number((maxY - minY).toFixed(2));
            resolvedWidth = oefPrimitiveW;
            resolvedHeight = oefPrimitiveH;
          }
        }

		let p_aux = {
			b1: ca['b1'],
			b2: ca['b2'],
			b3: ca['b3'],
			b4: ca['b4'],
			barcode: ca['barcode'],
			check: true,
			client: ca['client'],
			date: ca['date'],
			decoat: ca['decoat'],
			easel: ca['easel'],
			figure: resolvedFormId,
			flip: false,
			group: ca['group'],
			h: ca['h'],
			h1: ca['h1'],
			h2: ca['h2'],
			id: null, // ca['id'],
			id_client: ca['id_client'],
			id_line: ca['id_line'],
			l: ca['l'],
			l1: ca['l1'],
			l2: ca['l2'],
			lot: ca['lot'],
			mat_desc: ca['mat_desc'],
			mat_id: ca['mat_id'],
			mat_name: ca['mat_name'],
			num_of: ca['num_of'],
			orderno: ca['orderno'],
			orderpos: ca['orderpos'],
			paneno: ca['paneno'],
			packing: ca['packing'],
			pos_of: ca['pos_of'],
			priority: ca['priority'],
			project_reference: ca['project_reference'],
			r: ca['r'],
			r2: ca['r2'],
	        r3: ca['r3'],
	        r4: ca['r4'],
            dxf_name: ca['dxf_name'] ? ca['dxf_name'] : (ca['piece_dxf_name'] ? ca['piece_dxf_name'] : ca['form_DXF_NAME']),
            dxf_points: dxfPointsParsed,
            dxf_w: ca['dxf_w'] ? ca['dxf_w'] : (ca['piece_dxf_w'] ? ca['piece_dxf_w'] : ca['form_DXF_W']),
            dxf_h: ca['dxf_h'] ? ca['dxf_h'] : (ca['piece_dxf_h'] ? ca['piece_dxf_h'] : ca['form_DXF_H']),
            oef_generated: oefGenerated,
            oef_internal_polygons: resolvedOefPolygons,
            oef_primitive_w: Number.isFinite(oefPrimitiveW) && oefPrimitiveW > 0 ? oefPrimitiveW : 0,
            oef_primitive_h: Number.isFinite(oefPrimitiveH) && oefPrimitiveH > 0 ? oefPrimitiveH : 0,
            oef_primitive_b1: Number.isFinite(oefPrimitiveB1) && oefPrimitiveB1 > 0 ? oefPrimitiveB1 : 0,
            oef_primitive_b2: Number.isFinite(oefPrimitiveB2) && oefPrimitiveB2 > 0 ? oefPrimitiveB2 : 0,
            oef_primitive_b3: Number.isFinite(oefPrimitiveB3) && oefPrimitiveB3 > 0 ? oefPrimitiveB3 : 0,
            oef_primitive_b4: Number.isFinite(oefPrimitiveB4) && oefPrimitiveB4 > 0 ? oefPrimitiveB4 : 0,
	            oef_effective_area: Number(ca['oef_effective_area'] !== undefined && ca['oef_effective_area'] !== null ? ca['oef_effective_area'] : 0),
	            oef_base_unit_area: Number(ca['oef_base_unit_area'] !== undefined && ca['oef_base_unit_area'] !== null
	              ? ca['oef_base_unit_area']
	              : (ca['piece_oef_base_unit_area'] !== undefined && ca['piece_oef_base_unit_area'] !== null ? ca['piece_oef_base_unit_area'] : 0)),
	            oef_real_units: resolvedOefRealUnits,
	            // En runtime se trabaja por packs para OEF compuesto.
	            oef_runtime_units: resolvedRuntimeUnits,
				reference: ca['reference'],
				route: ca['route'],
				sequence: ca['sequence'],
			steps: ca['steps'].trim(),
			stock_length: ca['depth'],
			units: resolvedUnits,
			width: resolvedWidth,
            piece_figure_input: resolvedFormId,
			height: resolvedHeight,
			// list_order: ca['list_order']
		};

		loadedPiecesRaw.push(p_aux);
	});

	    const mergeLoadedPieces = (listIn: any[]): any[] => {
	      const result = [];
	      const mergedMap = {};
        const buildSourceIdentityKey = (itemIn: any): string => [
          Number(itemIn && itemIn.id_line ? itemIn.id_line : 0),
          itemIn && itemIn.lot !== undefined && itemIn.lot !== null ? itemIn.lot.toString() : '',
          itemIn && itemIn.sequence !== undefined && itemIn.sequence !== null ? itemIn.sequence.toString() : '',
          itemIn && itemIn.orderno !== undefined && itemIn.orderno !== null ? itemIn.orderno.toString() : '',
          itemIn && itemIn.orderpos !== undefined && itemIn.orderpos !== null ? itemIn.orderpos.toString() : '',
          Number(itemIn && itemIn.mat_id ? itemIn.mat_id : 0),
          Number(itemIn && itemIn.figure ? itemIn.figure : 0)
        ].join('|');
	      const buildOefPolySignature = (itemIn: any): string => {
	        const polys = Array.isArray(itemIn && itemIn.oef_internal_polygons) ? itemIn.oef_internal_polygons : [];
	        if (polys.length < 1) {
	          return 'no-oef';
	        }
	        const flat = [];
	        polys.forEach(poly => (Array.isArray(poly) ? poly : []).forEach(pt => {
	          flat.push(Number(pt && pt.x).toFixed(2) + ',' + Number(pt && pt.y).toFixed(2));
	        }));
	        return 'oef:' + polys.length + ':' + flat.join(';');
	      };

	      listIn.forEach(item => {
	        const units = Number(item && item.units);
	        if (!item || !Number.isFinite(units) || units <= 0) {
	          return;
	        }
	        const isSimpleRect = Number(item.figure) === 0 &&
	          !(Number(item.l || 0) > 0 || Number(item.h || 0) > 0 || Number(item.l1 || 0) > 0 || Number(item.l2 || 0) > 0 ||
	            Number(item.b1 || 0) > 0 || Number(item.b2 || 0) > 0 || Number(item.b3 || 0) > 0 || Number(item.b4 || 0) > 0) &&
	          !(item.dxf_name && item.dxf_name.toString() !== '');
	        const wRaw = Number(item.width);
	        const hRaw = Number(item.height);
	        const wNorm = isSimpleRect ? Math.min(wRaw, hRaw) : wRaw;
	        const hNorm = isSimpleRect ? Math.max(wRaw, hRaw) : hRaw;
	        const key = [
	          Number(item.figure),
	          Number(item.id_line),
	          item.lot !== undefined && item.lot !== null ? item.lot.toString() : '',
	          item.sequence !== undefined && item.sequence !== null ? item.sequence.toString() : '',
	          item.orderno !== undefined && item.orderno !== null ? item.orderno.toString() : '',
	          item.orderpos !== undefined && item.orderpos !== null ? item.orderpos.toString() : '',
	          Number(item.mat_id),
	          Number(item.stock_length),
	          Number(wNorm).toFixed(2),
	          Number(hNorm).toFixed(2),
	          Number(item.l || 0),
          Number(item.l1 || 0),
          Number(item.l2 || 0),
          Number(item.h || 0),
          Number(item.h1 || 0),
          Number(item.h2 || 0),
          Number(item.b1 || 0),
          Number(item.b2 || 0),
          Number(item.b3 || 0),
          Number(item.b4 || 0),
          Number(item.r || 0),
          Number(item.r2 || 0),
	          Number(item.r3 || 0),
	          Number(item.r4 || 0),
	          item.dxf_name ? item.dxf_name.toString() : '',
	          buildOefPolySignature(item)
	        ].join('|');

	        const existing = mergedMap[key];
	        if (!existing) {
	          const clone = JSON.parse(JSON.stringify(item));
	          clone.units = Math.max(1, Math.round(Number(item.units)));
	          const cloneRealUnits = Math.max(1, Math.round(Number(clone.oef_real_units || 1)));
	          clone.oef_runtime_units = cloneRealUnits > 1
	            ? Math.max(1, Math.round(Number(clone.units) / cloneRealUnits))
	            : clone.units;
	          mergedMap[key] = clone;
	          result.push(clone);
	        } else {
            const itemUnits = Math.max(1, Math.round(Number(item.units)));
            const existingUnits = Math.max(1, Math.round(Number(existing.units)));
            const sourceKeyA = buildSourceIdentityKey(existing);
            const sourceKeyB = buildSourceIdentityKey(item);
            const bothSimpleRect =
              Number(existing.figure) === 0 &&
              Number(item.figure) === 0 &&
              !this.isOefCompositeItem(existing) &&
              !this.isOefCompositeItem(item);
            // En cargas históricas la misma línea recta puede venir duplicada
            // por rotación (500x700 / 700x500). Debe mantenerse max(unidades), no suma.
	            if (bothSimpleRect && sourceKeyA === sourceKeyB) {
	              existing.units = Math.max(existingUnits, itemUnits);
	            } else {
		            existing.units = existingUnits + itemUnits;
	            }
            const existingRealUnits = Math.max(1, Math.round(Number(existing.oef_real_units || 1)));
	          existing.oef_runtime_units = existingRealUnits > 1
              ? Math.max(1, Math.round(Number(existing.units) / existingRealUnits))
              : Number(existing.units);
	        }
	      });

      return result;
    };

    this.optimizationList = mergeLoadedPieces(loadedPiecesRaw);

	// Se actualiza el número de piezas que se visualiza en la pestaña.
	this.countSelectedPieces();

	console.log('---> chargePiecesOpti new optimizationList: ');
	// console.log(this.optimizationList);

	// CARGA DE HOJAS -------------

	// Se ordenan las hojas para que aparezcan en el mismo orden que tenían cuando
	// se grabó la optimización (porque de momento esto influye en el resultado).
	this.chargeSheetOpti = this.opti.orderByListOrder(this.chargeSheetOpti, false);

	// Se cargan las hojas que usa la optimización cargada.
	this.sheetList_datafile = this.chargeSheetOpti;

	if (this.sheetList_datafile && this.sheetList_datafile[0] && this.sheetList_datafile[0].format) {
		console.log('---> chargePiecesOpti new sheetList_datafile: ');
		//console.log(this.sheetList_datafile);
		console.log(this.sheetList_datafile[0]);

		// Se selecciona el tipo de formato (lenguaje) usado en la optimización.
		// NOTA: De momento se puede utilizar el marcado por la primera hoja que se usó.
		this.fileForm.controls.f_export.setValue(
		  this.normalizeCncExportForProfile(this.sheetList_datafile[0].format)
		);

		this.fileForm.controls.f_disband_l.setValue(this.sheetList_datafile[0].disband_l);
		this.fileForm.controls.f_disband_r.setValue(this.sheetList_datafile[0].disband_r);
		this.fileForm.controls.f_disband_t.setValue(this.sheetList_datafile[0].disband_t);
		this.fileForm.controls.f_disband_b.setValue(this.sheetList_datafile[0].disband_b);
		this.fileForm.controls.f_retal_width.setValue(this.sheetList_datafile[0].retal_w);
		this.fileForm.controls.f_retal_height.setValue(this.sheetList_datafile[0].retal_h);
		this.fileForm.controls.f_diecutting.setValue(this.sheetList_datafile[0].diecutting);
		this.fileForm.controls.f_max_diecutting.setValue(this.sheetList_datafile[0].max_diecutting);
		this.fileForm.controls.f_blocks.setValue(this.sheetList_datafile[0].block);
		this.fileForm.controls.f_base.setValue(this.sheetList_datafile[0].base);
		this.fileForm.controls.f_order.setValue(this.sheetList_datafile[0].order ? true : false);
		this.fileForm.controls.f_order.setValue(this.sheetList_datafile[0].order);
		this.fileForm.controls.f_old.setValue(this.sheetList_datafile[0].resite);
		this.fileForm.controls.f_level.setValue(this.sheetList_datafile[0].level ? this.sheetList_datafile[0].level : 20);
		this.fileForm.controls.f_mode.setValue(this.sheetList_datafile[0].mode ? this.sheetList_datafile[0].mode : 1);
		this.fileForm.controls.f_free.setValue(this.sheetList_datafile[0].free ? this.sheetList_datafile[0].free : 0);
		this.fileForm.controls.f_free_in.setValue(this.sheetList_datafile[0].free_in ? this.sheetList_datafile[0].free_in : 1);
		this.fileForm.controls.f_grade.setValue(this.sheetList_datafile[0].grade ? this.sheetList_datafile[0].grade : 0);
		this.fileForm.controls.f_grade_rep.setValue(this.sheetList_datafile[0].grade_rep ? this.sheetList_datafile[0].grade_rep : 999);
		this.fileForm.controls.f_origin.setValue(this.sheetList_datafile[0].origin ? this.sheetList_datafile[0].origin.toString() : '1');
		this.fileForm.controls.f_axis.setValue(this.sheetList_datafile[0].axis.toString());
		this.fileForm.controls.f_zoom.setValue(this.sheetList_datafile[0].zoom.toString());
		this.fileForm.controls.f_rute.setValue(this.sheetList_datafile[0].paths);
		this.fileForm.controls.f_fill_piece.setValue(this.sheetList_datafile[0].color);
		this.fileForm.controls.f_show_order.setValue(this.sheetList_datafile[0].cut_order);
	}

	// Se actualiza el número de hojas que se visualiza en la pestaña.
	this.countTotalSheets();

    const blockAutoStart = this.fileForm.controls.f_blocks.value ? this.fileForm.controls.f_blocks.value : false;

    // Recuperar mesa guardada en la optimización antes de lanzar la optimización automática.
    if (!this.ensureCuttingTableResolvedForChargeOpti()) {
      this.pendingChargeOptiAutoStart = true;
      this.pendingChargeOptiAutoStartBlock = blockAutoStart;
      return;
    }

	// Carga histórica: se debe renderizar con los datos guardados (piezas/hojas/parámetros)
	// y no ejecutar "Mejorar" automáticamente para evitar cambiar el resultado elegido.
    const persistedSnapshot = this.parseLayoutSnapshotFromCurrentOpti();
    const snapshotApplied = this.applyLayoutSnapshot(persistedSnapshot);
	    if (!snapshotApplied) {
		  this.buttonStartOptimization(false, blockAutoStart);
	    } else {
	      // En modo snapshot histórico se mantiene visible el ID original.
	      this.showOptiId = true;
	      this.tryHistoricalPdfAutogen();
	    }

	this.activateTab('tabGraphic');

	// Se muestra el ID de la optimización cargada.
	this.showOptiId = true;

  } // End function chargePiecesOpti

  tryHistoricalPdfAutogen() {
    const jobRaw = localStorage.getItem('vs_auto_historical_pdf_job');
    if (!jobRaw) {
      return;
    }

    let job = null;
    try {
      job = JSON.parse(jobRaw);
    } catch (e) {
      localStorage.removeItem('vs_auto_historical_pdf_job');
      return;
    }

    if (!job || !job.opti_id) {
      localStorage.removeItem('vs_auto_historical_pdf_job');
      return;
    }

    const currentOptiId = this.currentOpti && this.currentOpti.id
      ? Number(this.currentOpti.id)
      : (this.routeOptiIdLabel && this.routeOptiIdLabel !== '' ? Number(this.routeOptiIdLabel) : 0);
    if (currentOptiId !== Number(job.opti_id)) {
      return;
    }

    localStorage.removeItem('vs_auto_historical_pdf_job');
    const mode = job.mode ? job.mode.toString() : 'pdf_docs';
    this.alertInfo = mode === 'graphics_only'
      ? 'Generando PDF histórico de Gráficos para la optimización ' + job.opti_id + '...'
      : (mode === 'cnc_only'
        ? 'Generando ficheros CNC históricos para la optimización ' + job.opti_id + '...'
        : 'Generando PDFs históricos de la optimización ' + job.opti_id + '...');

    const isWorkerFrame = window.self !== window.top;

    setTimeout(async () => {
      try {
        let pdfResult = { groups: '', cutting: '' };
        if (mode !== 'graphics_only' && mode !== 'cnc_only') {
          pdfResult = await this.generateAutoBatchPdfSections(this.currentOpti);
        }

        let graphicsDone = false;
        let graphicsSection = '';
        if (mode === 'graphics_only') {
          graphicsSection = await this.generateAutoSheetsPdfSection(this.currentOpti);
          graphicsDone = graphicsSection !== '';
        }

        let cncFiles = [];
        if (mode === 'cnc_only') {
          cncFiles = await this.generateAutoBatchCncFiles();
        }

        localStorage.setItem('vs_auto_historical_pdf_result', JSON.stringify({
          opti_id: job.opti_id,
          mode: mode,
          groups: pdfResult && pdfResult.groups ? pdfResult.groups : '',
          cutting: pdfResult && pdfResult.cutting ? pdfResult.cutting : '',
          graphics: graphicsSection,
          graphics_done: graphicsDone,
          cnc_files: cncFiles
        }));
      } catch (e) {
        localStorage.setItem('vs_auto_historical_pdf_result', JSON.stringify({
          opti_id: job.opti_id,
          mode: mode,
          groups: '',
          cutting: '',
          graphics: '',
          graphics_done: false,
          cnc_files: []
        }));
      }

      if (!isWorkerFrame) {
        this.router.navigate(['/auto-opti-lote']);
      } else {
        // El iframe sólo actúa como worker: al terminar se deja inactivo.
        setTimeout(() => {
          window.location.replace('about:blank');
        }, 200);
      }
    }, 300);
  }

  // --------------------
  // FUNCIONES INVENTARIO
  // --------------------

  // Función para añadir una nueva HOJA en el listdo de optimización.
  buttonAddMaterialSheet(itemIn: any, indexIn: number): void {

    console.log('---> Entrando en buttonAddMaterialSheet:');
    console.log(itemIn);

    let oracle_sheet = JSON.parse(JSON.stringify(itemIn));

    let new_sheet = {
		barcode: null,
		check: true,
		depth: this.default_depth, // 4mm es el mínimo por defecto
		diecutting:  this.fileForm.controls.diecutting,
		disband_b: this.fileForm.controls.f_disband_b.value,
		disband_l: this.fileForm.controls.f_disband_l.value,
		disband_r: this.fileForm.controls.f_disband_r.value,
		disband_t: this.fileForm.controls.f_disband_t.value,
		format: null,
		height: oracle_sheet['LAG_HOEHE'],
		id_process: null,
		lager: oracle_sheet['LAG_MANDANT'],
		location: oracle_sheet['LAGM_PLATZ'],
		mat_desc: oracle_sheet['MAT_DESC'],
		mat_id: oracle_sheet['LAG_ART_NUM'],
		mat_name: oracle_sheet['MAT_DESC'],
		max_diecutting: this.fileForm.controls.max_diecutting,
		reference: oracle_sheet['LAG_REFERENZ'],
		retal: false,
		retal_h: this.fileForm.controls.f_retal_width.value,
		retal_w: this.fileForm.controls.f_retal_height.value,
		side: 'A',
		unit: oracle_sheet['ID_LAGER_ST'] + oracle_sheet['RESERVED'],
		weight: 2.5,
		width: oracle_sheet['LAG_BREITE']
	};

    // Inserta la nueva plancha justo después de la última plancha que hubiese.
    this.sheetList_datafile.push(new_sheet);

    // Se actualiza también el total de piezas.
    this.countTotalSheets();

    // El ancho de la hoja más grande usada será colocado automáticamente como "max travera".
	let max_trav_aux = this.calculateMaxTrav();

	this.fileForm.controls.f_max_diecutting.setValue(max_trav_aux);

	// Si hay piezas sin material se les asigna el de la primera plancha.
	this.matchSheetPieceMaterial();

    // Se cierra el modal del inventario.
    this.showInventoryModal(false);

    // Se muestra la pestaña de planchas cargadas.
    this.activateTab('tabSheet');

  } // End function buttonAddMaterialSheet

  // Función que asigna a todas las piezas de la optimización que no
  // tienen material el mismo que tiene la primera plancha cargada.
  matchSheetPieceMaterial() {

	console.log('Ejecutando función matchSheetPieceMaterial:');

	let correct_material = null;

	if (this.sheetList_datafile && this.sheetList_datafile[0] && this.sheetList_datafile[0].mat_id) {
		correct_material = this.sheetList_datafile[0];
	} else if (this.sheetList_datafile && this.sheetList_datafile[1] && this.sheetList_datafile[1].mat_id) {
		correct_material = this.sheetList_datafile[1];
	} else if (this.sheetList_datafile && this.sheetList_datafile[2] && this.sheetList_datafile[2].mat_id) {
		correct_material = this.sheetList_datafile[2];
	}

	console.log('correct_material:');
	console.log(correct_material);

	if (correct_material && correct_material.mat_id) {
		this.optimizationList.forEach(p => {
			if(!p.mat_id || p.mat_id === 0 || Number(p.mat_id) === Number(correct_material.mat_id)) {

				console.log('-> Encontrada pieza sin material o con el mismo material que el modificado.');

				p.mat_id = correct_material.mat_id;
				p.mat_name = correct_material.mat_name;
				p.mat_desc = correct_material.mat_desc;
				p.depth = correct_material.depth;
			}
		});

		this.sheetList_datafile.forEach(sh => {
			if(!sh.mat_id || sh.mat_id === 0 || Number(sh.mat_id) === Number(correct_material.mat_id)) {

				console.log('-> Encontrada plancha sin material o con el mismo material que el modificado.');

				sh.mat_id = correct_material.mat_id;
				sh.mat_name = correct_material.mat_name;
				sh.mat_desc = correct_material.mat_desc;
				sh.depth = correct_material.depth;
			}
		});
	}
  } // End function matchSheetPieceMaterial

  // Función que asigna a la hoja creada sin material el material
  // que tiene la primera pieza cargada en el listado de piezas.
  matchPieceMaterial() {

	console.log('Ejecutando función matchPieceMaterial:');

	let depth_aux = this.default_depth; // Espesor por defecto de un material.

	let correct_material = null;

	if (this.optimizationList && this.optimizationList.length > 0) {
		correct_material = this.optimizationList.find(pz => Number(pz.mat_id) > 0);
	}

	console.log('correct_material:');
	console.log(correct_material);

	if (correct_material && correct_material.mat_id) {

		// Se coge el espesor de la primera pieza.
		if (correct_material.stock_length) depth_aux = correct_material.stock_length;

			this.sheetList_datafile.forEach(sh => {
				const sheetDesc = sh && sh.mat_desc !== undefined && sh.mat_desc !== null ? sh.mat_desc.toString() : '';
				const sheetName = sh && sh.mat_name !== undefined && sh.mat_name !== null ? sh.mat_name.toString() : '';
				const isGenericMaterial = this.isGenericMaterialText(sheetDesc) || this.isGenericMaterialText(sheetName);
				const isAutoSheet = !!(sh && sh._auto_from_cutting_table);

				if(!sh.mat_id || Number(sh.mat_id) === 0 || isGenericMaterial || isAutoSheet) {

				console.log('-> Encontrada plancha sin material. Se asigna el de la primera pieza cargada.');
				console.log(correct_material);

				sh.mat_id = correct_material.mat_id;
				sh.mat_name = correct_material.mat_name;
				sh.mat_desc = correct_material.mat_desc ? correct_material.mat_desc : correct_material.mat_name;
				sh.depth = depth_aux;
			}
		});
	}
  } // End function matchPieceMaterial

  private isGenericMaterialText(valueIn: any): boolean {
    if (valueIn === undefined || valueIn === null) {
      return true;
    }
    const txt = valueIn.toString().trim().toLowerCase();
    if (txt === '') return true;
    return (
      txt === 'material genérico' ||
      txt === 'material generico' ||
      txt === 'material' ||
      txt === 'genérico' ||
      txt === 'generico'
    );
  }

  private ensureDefaultSheetFromSelectedCuttingTable(): void {
    if (!this.fileForm || !this.fileForm.controls) return;

    const selectedId = Number(this.fileForm.controls.f_cutting_table_id.value);
    if (!(selectedId > 0) || !this.cuttingTables || this.cuttingTables.length < 1) return;

    const selectedTable = this.cuttingTables.find(item => Number(item.id) === selectedId);
    if (!selectedTable) return;

    const masterData = this.parseCuttingTableMasterData(selectedTable);
    const materialDesc = this.getPreferredMaterialDescFromPieces();
    const materialId = this.getPreferredMaterialIdFromPieces();

    const shouldCreate = !this.sheetList_datafile || this.sheetList_datafile.length === 0;
    if (shouldCreate) {
      const newSheet = this.buildDefaultSheetByTable(masterData, materialDesc, materialId);
      this.sheetList_datafile.push(newSheet);
      this.countTotalSheets();
      const maxTravAux = this.calculateMaxTrav();
      this.fileForm.controls.f_max_diecutting.setValue(maxTravAux);
      return;
    }

    // Si sólo existe una hoja autogenerada, se actualiza con la nueva mesa.
    if (this.sheetList_datafile.length === 1 && this.sheetList_datafile[0] && this.sheetList_datafile[0]._auto_from_cutting_table) {
      const row = this.sheetList_datafile[0];
      row.width = masterData.sheet_width;
      row.height = masterData.sheet_height;
      row.unit = -1;
      row.mat_desc = materialDesc;
      row.mat_name = materialDesc;
      if (!row.mat_id || Number(row.mat_id) <= 0) {
        row.mat_id = materialId;
      }
      this.countTotalSheets();
      const maxTravAux = this.calculateMaxTrav();
      this.fileForm.controls.f_max_diecutting.setValue(maxTravAux);
    }
  }

  private buildDefaultSheetByTable(masterDataIn: any, materialDescIn: string, materialIdIn: number): any {
    return {
      barcode: null,
      check: true,
      depth: this.default_depth,
      diecutting: 0,
      disband_b: this.fileForm.controls.f_disband_b.value,
      disband_l: this.fileForm.controls.f_disband_l.value,
      disband_r: this.fileForm.controls.f_disband_r.value,
      disband_t: this.fileForm.controls.f_disband_t.value,
      format: null,
      height: Number(masterDataIn && masterDataIn.sheet_height ? masterDataIn.sheet_height : 3210),
      id_process: null,
      lager: null,
      location: null,
      mat_id: materialIdIn,
      mat_name: materialDescIn,
      mat_desc: materialDescIn,
      max_diecutting: this.fileForm.controls.max_diecutting,
      reference: null,
      retal: false,
      retal_h: this.fileForm.controls.f_retal_width.value,
      retal_w: this.fileForm.controls.f_retal_height.value,
      side: 'A',
      unit: -1,
      weight: 2.5,
      width: Number(masterDataIn && masterDataIn.sheet_width ? masterDataIn.sheet_width : 6000),
      _auto_from_cutting_table: true
    };
  }

  private getPreferredMaterialDescFromPieces(): string {
    const defaultText = 'Material Generico';
    if (!this.optimizationList || this.optimizationList.length < 1) return defaultText;
    const firstPiece = this.optimizationList[0];
    if (!firstPiece) return defaultText;
    const txtRaw = (firstPiece.mat_desc !== undefined && firstPiece.mat_desc !== null && firstPiece.mat_desc !== '')
      ? firstPiece.mat_desc
      : firstPiece.mat_name;
    const txt = txtRaw ? txtRaw.toString().trim() : '';
    if (txt === '') return defaultText;

    const lower = txt.toLowerCase();
    if (lower === 'material genérico' || lower === 'material generico' || lower === 'genérico' || lower === 'generico') {
      return defaultText;
    }
    return txt;
  }

  private getPreferredMaterialIdFromPieces(): number {
    if (this.optimizationList && this.optimizationList.length > 0) {
      const pieceWithId = this.optimizationList.find(p => p && Number(p.mat_id) > 0);
      if (pieceWithId) return Number(pieceWithId.mat_id);
    }
    return 555000000 + Math.floor(Math.random() * 1000000);
  }

  private shouldCopyMaterialToSheets(valueIn: string): boolean {
    if (!this.sheetList_datafile || this.sheetList_datafile.length < 1) return false;
    const value = valueIn !== undefined && valueIn !== null ? valueIn.toString() : '';
    return this.sheetList_datafile.some(sh => {
      if (!sh) return false;
      const current = sh.mat_desc !== undefined && sh.mat_desc !== null ? sh.mat_desc.toString() : '';
      return current !== value;
    });
  }

  private shouldCopyMaterialToPieces(valueIn: string): boolean {
    if (!this.optimizationList || this.optimizationList.length < 1) return false;
    const value = valueIn !== undefined && valueIn !== null ? valueIn.toString() : '';
    return this.optimizationList.some(p => {
      if (!p) return false;
      const current = p.mat_desc !== undefined && p.mat_desc !== null ? p.mat_desc.toString() : '';
      return current !== value;
    });
  }

  private copyMaterialDescToSheets(valueIn: string): void {
    if (!this.sheetList_datafile || this.sheetList_datafile.length < 1) return;
    for (let i = 0; i < this.sheetList_datafile.length; i++) {
      const row = this.sheetList_datafile[i];
      if (!row) continue;
      row.mat_desc = valueIn;
      row.mat_name = valueIn;
    }
  }

  private copyMaterialDescToPieces(valueIn: string): void {
    if (!this.optimizationList || this.optimizationList.length < 1) return;
    for (let i = 0; i < this.optimizationList.length; i++) {
      const row = this.optimizationList[i];
      if (!row) continue;
      row.mat_desc = valueIn;
      row.mat_name = valueIn;
    }
  }

  // Función que llama al webservice de VS-Stock que devuelve el inventario del usuario logueado.
  async loadInventory() {

	console.log('Ejecutando función loadInventory:');

  	// Llamar webservice usando Fetch nativo.
    // Usando la solicitud por defecto GET.
    // fetch('http://betawebapp.vidrioservice.com:8079/api/create_remnant_opti?pax=331122&usx=oracle&opti=34')
	// .then((response) => response.json())
	// .then((json) => console.log(json));

	// fetch('http://betawebapp.vidrioservice.com:8079/api/load_prod_data?pax=331122&usx=oracle&opti=34')
	// .then((response) => response.json())
	// .then((json) => console.log(json));

	this.inventoriesList = [];

	await this.changeChargeModal(true);

	let params_inventory = '';

	if (this.searchInventoryForm.controls.f_lager.value && this.searchInventoryForm.controls.f_lager.value !== '')
	 params_inventory += ('&filterField_0=' + this.searchInventoryForm.controls.f_lager.value);

	if (this.searchInventoryForm.controls.f_mat.value && this.searchInventoryForm.controls.f_mat.value !== '')
	 params_inventory += ('&filterField_3=' + this.searchInventoryForm.controls.f_mat.value);

	if (this.searchInventoryForm.controls.f_width.value && this.searchInventoryForm.controls.f_width.value !== '')
	 params_inventory += ('&filterField_4=' + this.searchInventoryForm.controls.f_width.value);

	if (this.searchInventoryForm.controls.f_height.value && this.searchInventoryForm.controls.f_height.value !== '')
	 params_inventory += ('&filterField_5=' + this.searchInventoryForm.controls.f_height.value);

	// Ejemplo: '?pax=331122&usx=oracle';
	let params_user = this.globals.webServiceAccess[this.current_user_enviroment];
	console.log(' -> params_user = ' + params_user);

	let oracle_enviroment = this.globals.oracleEnvironment[this.current_user_enviroment];
	console.log(' -> oracle_enviroment = ' + oracle_enviroment);

	let path_vs_stock =  this.globals.pathVsStock[this.current_user_enviroment];

	let path_base_webservice = path_vs_stock + '?pax=' + params_user.toString() + '&usx=' + oracle_enviroment;
	// Hay que pasar como parámetros los filtros de la búsqueda del material.
	try {
		const response = await fetch(path_base_webservice + params_inventory);
		if (!response.ok) {
			throw new Error('VS-Stock respondió con HTTP ' + response.status);
		}

		const json = await response.json();
		console.log('Respuesta obtenida por loadInventory:');
		// console.log(json);
		this.inventoriesList = json;
	} catch (error) {
		console.error('ERROR loadInventory: ');
		console.error(error);
	} finally {
		await this.changeChargeModal(false);
	}

  } // End function loadInventory.

  // --------------------------------
  // 	Control piezas VS-Floor
  // --------------------------------

  // Función para añadir todas las piezas marcadas de VS-Floor al listdo de optimización.
  buttonAddFloorMultiPieces(): void {

	console.log('---> Entrando en buttonAddFloorMultiPieces:');
	//console.log(this.pieceList.data);

	let selected_floor_pieces = this.pieceList.data.filter(p => p['check']);

	console.log('-> selected_floor_pieces:');
	console.log(selected_floor_pieces);

	let new_piece = null;

    if (this.searchPieceForm.controls.f_broke.value) {

		console.log('---> Cargar sólo roturas de VS-Floor:');

		let exist_broked = '';

		selected_floor_pieces.forEach(itemIn => {

			let lot_exist = this.optimizationList.find(p => {
				if (itemIn.id === p.id) {

					console.log('-> Encontrada pieza/rotura que ya estaba añadida en el listado.');
					return true;
				}
				return false;
			});

			// console.log('-> Pieza rota ya fue añadida:');
			// console.log(lot_exist);

			if (!lot_exist) {
					const matDesc = this.resolveFloorMaterialDesc(itemIn, itemIn);
					new_piece = {
					  id: itemIn['id'],
				      lot: itemIn['batchno'],
				      sequence: itemIn['batchseq'],
				      mat_id: itemIn['materialid'],
				      mat_name: matDesc,
				      mat_desc: matDesc,
				      steps: itemIn['stepdesc'].trim(),
			      orderno: itemIn['orderno'],
				  orderpos: itemIn['orderpos'],
				  paneno: itemIn['paneno'],
			      width: itemIn['width_add'],
			      height: itemIn['height_add'],
			      units: Number(itemIn['unitstotal']), // itemIn['units'],
			      priority: itemIn['as_batchno']['prio'],
			      figure: itemIn['as_batchno']['forma'],
			      l: itemIn['as_batchno']['param_L'],
			      l1: itemIn['as_batchno']['param_L1'],
			      l2: itemIn['as_batchno']['param_L2'],
			      h: itemIn['as_batchno']['param_H'],
			      h1: itemIn['as_batchno']['param_H1'],
			      h2: itemIn['as_batchno']['param_H2'],
			      r: itemIn['as_batchno']['param_R'],
			      r2: itemIn['as_batchno']['param_R2'],
	              r3: itemIn['as_batchno']['param_R3'],
	              r4: itemIn['as_batchno']['param_R4'],
			      b1: itemIn['as_batchno']['param_B1'],
			      b2: itemIn['as_batchno']['param_B2'],
			      b3: itemIn['as_batchno']['param_B3'],
			      b4: itemIn['as_batchno']['param_B4'],
			      easel: '',
			      decoat: 0,
			      group: 'A',
			      check: true
			    };

			    this.optimizationList.push(new_piece);
			    this.totalSelectedPieces += Number(itemIn['units']);
			} else {
				console.log('-> No se añaden estas piezas/roturas porque ya están en la optimización.');

				exist_broked +=  '<p>   · Rotura -> Lote: ' + lot_exist.lot +	' -> Material: ' + lot_exist.mat_name + ' - ' + lot_exist.mat_id + '</p>';
			}
	   });

	   if (exist_broked !== '') {
			this.alertInfo = 'Los siguientes piezas/roturas ya estaban añadidas en la optimización:';
			this.alertInfo += exist_broked;

			this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
	   }

	} else {

		console.log('---> Cargar piezas de inventario de VS-Floor:');

		let exist_lot = '';

		selected_floor_pieces.forEach(itemIn => {

			let lot_exist = this.optimizationList.find(p => {
				if (itemIn.batchno === p.lot &&
					Number(itemIn.materialid) === Number(p.mat_id)) {
					// && itemIn.stepdesc === p.steps) {

					console.log('-> Encontrado un lote/material que ya estaba añadido en el listado.');
					return true;
				}
				return false;
			});

			// console.log('-> Lote/material ya fue añadido:');
			// console.log(lot_exist);

			if (!lot_exist) {

				// console.log('-> Lote y Pasos:');
			    // console.log(itemIn);

				let lot_pieces = this.pieceList.data_detail.filter(p => {

					// console.log('-> Piezas pasos: ' + p.stepdesc);
					// console.log(p);
			    	// console.log(itemIn.stepdesc);
			    	// console.log(itemIn.stepdesc.includes(p.stepdesc));

					if (p.batchno === itemIn.batchno && p.materialid === itemIn.materialid) {
						// && itemIn.stepdesc.includes(p.stepdesc.trim())) {

							// console.log('-> Añadida pieza al lote actual: ' + p.batchno);
							return true;
					}

					return false;
				});

				lot_pieces.forEach(item => {

						//let units_piece = item['barcodeunits'] - item['finish'];
						let units_piece = Number(item['unitstotal']);

						const matDesc = this.resolveFloorMaterialDesc(item, itemIn);
						new_piece = {
					      lot: item['batchno'],
					      sequence: item['batchseq'],
					      mat_id: item['materialid'],
					      mat_name: matDesc,
					      mat_desc: matDesc,
					      steps: item['stepdesc'].trim(),
				      orderno: item['orderno'],
				  	  orderpos: item['orderpos'],
				  	  paneno: item['paneno'],
				      width: item['width_add'],
				      height: item['height_add'],
				      units: units_piece,
				      priority: item['prio'],
				      figure: item['forma'],
				      l: item['param_L'],
				      l1: item['param_L1'],
				      l2: item['param_L2'],
				      h: item['param_H'],
				      h1: item['param_H1'],
				      h2: item['param_H2'],
				      r: item['param_R'],
				      r2: item['param_R2'],
		              r3: item['param_R3'],
		              r4: item['param_R4'],
				      b1: item['param_B1'],
				      b2: item['param_B2'],
				      b3: item['param_B3'],
				      b4: item['param_B4'],
				      easel: '',
				      decoat: 0,
				      group: 'A',
				      check: true
				    };

				    this.optimizationList.push(new_piece);
				this.totalSelectedPieces += Number(units_piece);

			      });

			} else {
				console.log('-> No se añade el lote/material porque ya está en la optimización.');

				exist_lot +=  '<p>   · Lote: ' + lot_exist.lot + ' --> Material: ' + lot_exist.mat_name + ' - ' + lot_exist.mat_id +
							  ' --> Pasos: ' + lot_exist.steps + '</p>';
			}
		});

		if (exist_lot !== '') {
			this.alertInfo = 'Los siguientes lotes ya estaban añadidos en la optimización:';
			this.alertInfo += exist_lot;

			this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
		}

	} // End If rotura

		// Se ordenan las piezas según estos campos: "BATCHNO,BATCHSEQ,PANENO"
		this.optimizationList = this.opti.orderByLot(this.optimizationList, '', false);
	    // Sincronizar material de planchas auto/genéricas con piezas cargadas desde VS-Floor.
	    this.matchPieceMaterial();

	    // Se cierra el modal del listado de piezas.
	    this.showPieceModal(false);

    // Se muestra la pestaña de planchas cargadas.
    this.activateTab('tabPiece');

  } // End function buttonAddFloorMultiPieces

  // Función para añadir una PIEZA de VS-Floor al listdo de optimización.
	  buttonAddFloorPiece(itemIn: any, indexIn: number): void {

    console.log('---> Entrando en buttonAddFloorPiece:');
    console.log(itemIn);
    console.log(this.pieceList.data_detail);

    let lot_pieces = this.pieceList.data_detail.filter(p =>
    	p.batchno === itemIn.batchno &&
    	p.materialid === itemIn.materialid);

    console.log('---> lot_pieces:');
    console.log(lot_pieces);

    let new_piece = null;

	    if (this.searchPieceForm.controls.f_broke.value) {
			const matDesc = this.resolveFloorMaterialDesc(itemIn, itemIn);
			new_piece = {
		      lot: itemIn['batchno'],
		      sequence: itemIn['batchseq'],
		      mat_id: itemIn['materialid'],
		      mat_name: matDesc,
		      mat_desc: matDesc,
		      steps: itemIn['stepdesc'].trim(),
	      orderno: itemIn['orderno'],
		  orderpos: itemIn['orderpos'],
		  paneno: itemIn['paneno'],
	      width: itemIn['width_add'],
	      height: itemIn['height_add'],
	      units: Number(itemIn['units']),
	      priority: itemIn['as_batchno']['prio'],
	      figure: itemIn['as_batchno']['forma'],
	      l: itemIn['as_batchno']['param_L'],
	      l1: itemIn['as_batchno']['param_L1'],
	      l2: itemIn['as_batchno']['param_L2'],
	      h: itemIn['as_batchno']['param_H'],
	      h1: itemIn['as_batchno']['param_H1'],
	      h2: itemIn['as_batchno']['param_H2'],
	      r: itemIn['as_batchno']['param_R'],
	      r2: itemIn['as_batchno']['param_R2'],
          r3: itemIn['as_batchno']['param_R3'],
          r4: itemIn['as_batchno']['param_R4'],
	      b1: itemIn['as_batchno']['param_B1'],
	      b2: itemIn['as_batchno']['param_B2'],
	      b3: itemIn['as_batchno']['param_B3'],
	      b4: itemIn['as_batchno']['param_B4'],
	      easel: '',
	      decoat: 0,
	      group: 'A',
	      check: true
	    };

	    this.optimizationList.push(new_piece);
	    this.totalSelectedPieces += Number(itemIn['units']);

	} else {

			lot_pieces.forEach(item => {

			// let units_piece = item['barcodeunits'] - item['finish'];
			let units_piece = Number(item['unitstotal']);

				const matDesc = this.resolveFloorMaterialDesc(item, itemIn);
				new_piece = {
			      lot: item['batchno'],
			      sequence: item['batchseq'],
			      mat_id: item['materialid'],
			      mat_name: matDesc,
			      mat_desc: matDesc,
			      steps: item['stepdesc'].trim(),
		      orderno: item['orderno'],
			  orderpos: item['orderpos'],
			  paneno: item['paneno'],
		      width: item['width_add'],
		      height: item['height_add'],
		      units: units_piece,
		      priority: item['prio'],
		      figure: item['forma'],
		      l: item['param_L'],
		      l1: item['param_L1'],
		      l2: item['param_L2'],
		      h: item['param_H'],
		      h1: item['param_H1'],
		      h2: item['param_H2'],
		      r: item['param_R'],
		      r2: item['param_R2'],
          	  r3: item['param_R3'],
          	  r4: item['param_R4'],
		      b1: item['param_B1'],
		      b2: item['param_B2'],
		      b3: item['param_B3'],
		      b4: item['param_B4'],
		      easel: '',
		      decoat: 0,
		      group: 'A',
		      check: true
		    };

		    this.optimizationList.push(new_piece);
		    this.totalSelectedPieces += Number(units_piece);
		});
	}

    // Sincronizar material de planchas auto/genéricas con piezas cargadas desde VS-Floor.
    this.matchPieceMaterial();

    // Se cierra el modal del listado de piezas.
    this.showPieceModal(false);

    // Se muestra la pestaña de planchas cargadas.
    this.activateTab('tabPiece');

	  } // End function buttonAddFloorPiece

  private resolveFloorMaterialDesc(itemIn: any, fallbackIn?: any): string {
    const fromItemDesc = itemIn && itemIn.materialdesc !== undefined && itemIn.materialdesc !== null
      ? itemIn.materialdesc.toString().trim()
      : '';
    if (fromItemDesc !== '') {
      return fromItemDesc;
    }

    const fromFallbackDesc = fallbackIn && fallbackIn.materialdesc !== undefined && fallbackIn.materialdesc !== null
      ? fallbackIn.materialdesc.toString().trim()
      : '';
    if (fromFallbackDesc !== '') {
      return fromFallbackDesc;
    }

    const fromItemName = itemIn && itemIn.mat_name !== undefined && itemIn.mat_name !== null
      ? itemIn.mat_name.toString().trim()
      : '';
    if (fromItemName !== '') {
      return fromItemName;
    }

    const fromFallbackName = fallbackIn && fallbackIn.mat_name !== undefined && fallbackIn.mat_name !== null
      ? fallbackIn.mat_name.toString().trim()
      : '';
    if (fromFallbackName !== '') {
      return fromFallbackName;
    }

    const fromItemId = itemIn && itemIn.materialid !== undefined && itemIn.materialid !== null
      ? itemIn.materialid.toString()
      : '';
    if (fromItemId !== '') {
      return fromItemId;
    }

    return 'Material sin descripción';
  }

  // Función que busca piezas existentes en VS-Floor (incluídas roturas).
  async loadPieces() {

	console.log('Ejecutando función loadPieces:');

	await this.changeChargeModal(true);

	let data = [];

    const p = { ...data, ...this.searchPieceForm.value };

    this.loadPiece.emit(p);

    await this.changeChargeModal(false);

  } // End function loadPieces.

  private getAutoBatchHeartbeatKey(jobIn: any): string {
    const lot = this.getAutoBatchLotFilter(jobIn);
    const material = jobIn && jobIn.materialid !== undefined && jobIn.materialid !== null
      ? jobIn.materialid.toString()
      : '0';
    const queueIndexRaw = localStorage.getItem('vs_auto_batch_index');
    const queueIndex = queueIndexRaw !== null && queueIndexRaw !== undefined ? queueIndexRaw.toString() : '0';
    return 'ao|' + lot + '|' + material + '|' + queueIndex;
  }

  private touchAutoBatchLocalHeartbeat(statusIn: string) {
    if (!this.autoBatchJob) {
      return;
    }

    const now = Date.now();
    const payload = {
      ts: now,
      status: statusIn ? statusIn.toString() : '',
      stage: this.autoBatchStage ? this.autoBatchStage.toString() : '',
      materialid: this.autoBatchJob.materialid !== undefined && this.autoBatchJob.materialid !== null
        ? this.autoBatchJob.materialid.toString()
        : '',
      materialdesc: this.autoBatchJob.materialdesc !== undefined && this.autoBatchJob.materialdesc !== null
        ? this.autoBatchJob.materialdesc.toString()
        : ''
    };
    localStorage.setItem('vs_auto_batch_local_hb', JSON.stringify(payload));
  }

  private emitAutoBatchHeartbeat(statusIn: string, forceBackendIn: boolean = false) {
    if (!this.autoBatchJob) {
      return;
    }

    this.touchAutoBatchLocalHeartbeat(statusIn);

    const mustSendBackend = forceBackendIn || (this.autoBatchHeartbeatTicks % 3 === 0);
    if (!mustSendBackend) {
      return;
    }

    const payload = {
      job_key: this.getAutoBatchHeartbeatKey(this.autoBatchJob),
      lot: this.getAutoBatchLotFilter(this.autoBatchJob),
      materialid: this.autoBatchJob.materialid !== undefined && this.autoBatchJob.materialid !== null
        ? this.autoBatchJob.materialid.toString()
        : '',
      materialdesc: this.autoBatchJob.materialdesc !== undefined && this.autoBatchJob.materialdesc !== null
        ? this.autoBatchJob.materialdesc.toString()
        : '',
      stage: this.autoBatchStage ? this.autoBatchStage.toString() : '',
      status: statusIn ? statusIn.toString() : '',
      seq: this.autoBatchHeartbeatTicks
    };

    this.fileService.autoBatchHeartbeatTouch(payload).subscribe((response: any) => {
      const serverTs = response && response.server_ts ? Number(response.server_ts) : Date.now();
      localStorage.setItem('vs_auto_batch_backend_hb', JSON.stringify({
        ts: Date.now(),
        server_ts: serverTs,
        status: payload.status,
        stage: payload.stage
      }));
    });
  }

  private startAutoBatchHeartbeat() {
    this.stopAutoBatchHeartbeat(false);
    this.autoBatchHeartbeatTicks = 0;
    this.emitAutoBatchHeartbeat('running', true);

    this.autoBatchHeartbeatTimer = setInterval(() => {
      if (!this.autoBatchMode) {
        this.stopAutoBatchHeartbeat(false);
        return;
      }
      this.autoBatchHeartbeatTicks += 1;
      this.emitAutoBatchHeartbeat('running');
    }, 2000);
  }

  private stopAutoBatchHeartbeat(sendStopIn: boolean = true) {
    if (this.autoBatchHeartbeatTimer) {
      clearInterval(this.autoBatchHeartbeatTimer);
      this.autoBatchHeartbeatTimer = null;
    }

    if (sendStopIn && this.autoBatchJob) {
      this.emitAutoBatchHeartbeat('done', true);
    }
  }

  startAutoBatchJob() {
    const jobRaw = localStorage.getItem('vs_auto_batch_current_job');

    if (!jobRaw) {
      return;
    }

    this.autoBatchJob = JSON.parse(jobRaw);
    this.autoBatchMode = true;
    this.autoBatchStage = 'loading_pieces';
    this.autoBatchPendingResult = null;
    this.autoBatchWarnings = [];
    this.autoBatchStartTimeMs = performance.now();
    localStorage.setItem('vs_auto_batch_job_started_at', Date.now().toString());
    this.startAutoBatchHeartbeat();

    this.emptyCSV('piece');
    this.emptyCSV('sheet');

    this.searchPieceForm.controls.f_broke.setValue(false);
    this.searchPieceForm.controls.f_finished.setValue(true);
    this.searchPieceForm.controls.f_batchno.setValue(this.getAutoBatchLotFilter(this.autoBatchJob));
    this.searchPieceForm.controls.f_mat.setValue(null);
    this.searchPieceForm.controls.offset.setValue(1);
    this.searchPieceForm.controls.pagesize.setValue(5000);

    this.fileForm.controls.f_mode.setValue(this.mapAutoMode(this.autoBatchJob.strategy));
    this.fileForm.controls.f_export.setValue(
      this.normalizeCncExportForProfile(this.mapAutoExportMode(this.autoBatchJob.export_mode))
    );
    this.fileForm.controls.f_free.setValue(this.mapAutoFreedom(this.autoBatchJob.freedom));
    this.fileForm.controls.f_speed.setValue(this.mapAutoSpeed(this.autoBatchJob.speed));
    this.fileForm.controls.f_diecutting.setValue(this.mapAutoMinTronz(this.autoBatchJob.min_tronz));
    this.fileForm.controls.f_max_diecutting.setValue(this.mapAutoMaxTrav(this.autoBatchJob.max_trav));
    this.fileForm.controls.f_level.setValue(this.mapAutoLevel(this.autoBatchJob.level));
    const cuttingTableIdForAuto = this.mapAutoCuttingTableId(this.autoBatchJob);
    this.fileForm.controls.f_cutting_table_id.setValue(cuttingTableIdForAuto);

    // Auto Opti: priorizar los parámetros maestros de la mesa de corte
    // (origen y desbandes), con fallback a los bordes del job si no hay mesa válida.
    let tableMasterApplied = false;
    if (cuttingTableIdForAuto && Number(cuttingTableIdForAuto) > 0) {
      this.applySelectedCuttingTable(false, false);
      const selectedTable = this.cuttingTables && this.cuttingTables.length > 0
        ? this.cuttingTables.find(item => Number(item.id) === Number(cuttingTableIdForAuto))
        : null;
      tableMasterApplied = !!selectedTable;
    }

    if (!tableMasterApplied) {
      this.fileForm.controls.f_origin.setValue(this.mapAutoOrigin(this.autoBatchJob.origin));
      if (!this.applyAutoBatchDisbands(this.autoBatchJob)) {
        this.applyAutoBatchOriginBorders(this.autoBatchJob);
      }
    }
    this.optiForm.controls.save.setValue(true);

    this.loadPieces();
  }

  runAutoBatchJobWithPieceList(pieceDataIn: any) {
    if (!this.autoBatchJob || !pieceDataIn || !pieceDataIn.data_detail) {
      this.finishAutoBatchJob(false, 'No se han recibido piezas desde Floor.');
      return;
    }

    const lotSet = this.getAutoBatchLotSet(this.autoBatchJob);
    const pieces = pieceDataIn.data_detail.filter(p =>
      Number(p.materialid) === Number(this.autoBatchJob.materialid) &&
      lotSet.has(p.batchno.toString())
    );

    if (!pieces || pieces.length === 0) {
      this.finishAutoBatchJob(false, 'No hay piezas para el material/lote seleccionado.');
      return;
    }

    this.optimizationList = [];
    this.sheetList_datafile = [];
    this.totalSelectedPieces = 0;
    this.totalSelectedSheets = 0;

    pieces.forEach(item => {
      const units_piece = Number(item['unitstotal']);
      const new_piece = {
        lot: item['batchno'],
        sequence: item['batchseq'],
        mat_id: item['materialid'],
        mat_name: item['materialdesc'],
        mat_desc: item['materialdesc'],
        steps: item['stepdesc'].trim(),
        orderno: item['orderno'],
        orderpos: item['orderpos'],
        paneno: item['paneno'],
        width: item['width_add'],
        height: item['height_add'],
        units: units_piece,
        priority: item['prio'],
        figure: item['forma'],
        l: item['param_L'],
        l1: item['param_L1'],
        l2: item['param_L2'],
        h: item['param_H'],
        h1: item['param_H1'],
        h2: item['param_H2'],
        r: item['param_R'],
        r2: item['param_R2'],
        r3: item['param_R3'],
        r4: item['param_R4'],
        b1: item['param_B1'],
        b2: item['param_B2'],
        b3: item['param_B3'],
        b4: item['param_B4'],
        easel: '',
        decoat: 0,
        group: 'A',
        check: true
      };

      this.optimizationList.push(new_piece);
      this.totalSelectedPieces += units_piece;
    });

    if (this.autoBatchJob.remnant &&
        Number(this.autoBatchJob.remnant.width) > 0 &&
        Number(this.autoBatchJob.remnant.height) > 0 &&
        Number(this.autoBatchJob.remnant.units) > 0) {
      this.sheetList_datafile.push(this.createAutoBatchSheet(
        Number(this.autoBatchJob.remnant.width),
        Number(this.autoBatchJob.remnant.height),
        Number(this.autoBatchJob.remnant.units),
        true
      ));
    }

    this.sheetList_datafile.push(this.createAutoBatchSheet(
      Number(this.autoBatchJob.sheet.width),
      Number(this.autoBatchJob.sheet.height),
      Number(this.autoBatchJob.sheet.units),
      false
    ));

    this.countTotalSheets();
    this.autoBatchStage = 'running';
    this.emitAutoBatchHeartbeat('running', true);

    setTimeout(() => {
      this.multipleOptimization();
    }, 120);
  }

  createAutoBatchSheet(widthIn: number, heightIn: number, unitsIn: number, isRetalIn: boolean): any {
    return {
      barcode: null,
      check: true,
      depth: this.default_depth,
      diecutting: this.fileForm.controls.f_diecutting.value ? this.fileForm.controls.f_diecutting.value : 0,
      disband_b: this.fileForm.controls.f_disband_b.value ? this.fileForm.controls.f_disband_b.value : 0,
      disband_l: this.fileForm.controls.f_disband_l.value ? this.fileForm.controls.f_disband_l.value : 0,
      disband_r: this.fileForm.controls.f_disband_r.value ? this.fileForm.controls.f_disband_r.value : 0,
      disband_t: this.fileForm.controls.f_disband_t.value ? this.fileForm.controls.f_disband_t.value : 0,
      format: this.fileForm.controls.f_export.value ? this.fileForm.controls.f_export.value : 'V40',
      height: heightIn,
      id_process: null,
      lager: null,
      location: null,
      mat_id: this.autoBatchJob.materialid,
      mat_name: this.autoBatchJob && this.autoBatchJob.materialdesc ? this.autoBatchJob.materialdesc.toString() : this.autoBatchJob.materialid.toString(),
      mat_desc: this.autoBatchJob && this.autoBatchJob.materialdesc ? this.autoBatchJob.materialdesc.toString() : this.autoBatchJob.materialid.toString(),
      max_diecutting: this.fileForm.controls.f_max_diecutting.value,
      reference: isRetalIn ? 'RETAL_AUTO' : 'PLANCHA_AUTO',
      retal: isRetalIn,
      retal_h: this.fileForm.controls.f_retal_height.value ? this.fileForm.controls.f_retal_height.value : 0,
      retal_w: this.fileForm.controls.f_retal_width.value ? this.fileForm.controls.f_retal_width.value : 0,
      side: 'A',
      unit: unitsIn,
      weight: 2.5,
      width: widthIn
    };
  }

  mapAutoMode(strategyIn: string): number {
    if (strategyIn === 'less_stacks') {
      return 3;
    }
    return 2;
  }

  mapAutoOrigin(originIn: string): string {
    if (originIn === 'LT') return '1';
    if (originIn === 'LB') return '2';
    if (originIn === 'RB') return '3';
    if (originIn === 'RT') return '4';
    return '1';
  }

  applyAutoBatchOriginBorders(jobIn: any) {
    const borderX = jobIn && jobIn.origin_border_x !== undefined ? Number(jobIn.origin_border_x) : 0;
    const borderY = jobIn && jobIn.origin_border_y !== undefined ? Number(jobIn.origin_border_y) : 0;
    const safeX = (!isNaN(borderX) && borderX > 0) ? borderX : 0;
    const safeY = (!isNaN(borderY) && borderY > 0) ? borderY : 0;
    const origin = jobIn && jobIn.origin ? jobIn.origin.toString() : 'LT';

    // Primero limpiamos todos los desbandes para evitar arrastres de configuración previa.
    this.fileForm.controls.f_disband_l.setValue(0);
    this.fileForm.controls.f_disband_b.setValue(0);
    this.fileForm.controls.f_disband_r.setValue(0);
    this.fileForm.controls.f_disband_t.setValue(0);

    // Regla acordada:
    // X -> lado horizontal de la esquina origen (arriba/abajo)
    // Y -> lado vertical de la esquina origen (izquierda/derecha)
    if (origin === 'LB') {
      this.fileForm.controls.f_disband_b.setValue(safeX);
      this.fileForm.controls.f_disband_l.setValue(safeY);
      return;
    }
    if (origin === 'RB') {
      this.fileForm.controls.f_disband_b.setValue(safeX);
      this.fileForm.controls.f_disband_r.setValue(safeY);
      return;
    }
    if (origin === 'RT') {
      this.fileForm.controls.f_disband_t.setValue(safeX);
      this.fileForm.controls.f_disband_r.setValue(safeY);
      return;
    }

    // Default: LT.
    this.fileForm.controls.f_disband_t.setValue(safeX);
    this.fileForm.controls.f_disband_l.setValue(safeY);
  }

  applyAutoBatchDisbands(jobIn: any): boolean {
    const disbandL = jobIn && jobIn.disband_l !== undefined ? Number(jobIn.disband_l) : NaN;
    const disbandB = jobIn && jobIn.disband_b !== undefined ? Number(jobIn.disband_b) : NaN;
    const disbandR = jobIn && jobIn.disband_r !== undefined ? Number(jobIn.disband_r) : NaN;
    const disbandT = jobIn && jobIn.disband_t !== undefined ? Number(jobIn.disband_t) : NaN;

    const hasAny =
      (!isNaN(disbandL) && disbandL >= 0) ||
      (!isNaN(disbandB) && disbandB >= 0) ||
      (!isNaN(disbandR) && disbandR >= 0) ||
      (!isNaN(disbandT) && disbandT >= 0);

    if (!hasAny) {
      return false;
    }

    this.fileForm.controls.f_disband_l.setValue(!isNaN(disbandL) && disbandL >= 0 ? disbandL : 0);
    this.fileForm.controls.f_disband_b.setValue(!isNaN(disbandB) && disbandB >= 0 ? disbandB : 0);
    this.fileForm.controls.f_disband_r.setValue(!isNaN(disbandR) && disbandR >= 0 ? disbandR : 0);
    this.fileForm.controls.f_disband_t.setValue(!isNaN(disbandT) && disbandT >= 0 ? disbandT : 0);
    return true;
  }

  mapAutoExportMode(exportModeIn: string): string {
    if (exportModeIn === 'LIOPT') return 'LIOPT';
    if (exportModeIn === 'LSW') return 'LSW';
    if (exportModeIn === 'OTD') return 'OTD';
    if (exportModeIn === 'BTR') return 'BTR';
    if (exportModeIn === 'ELO') return 'ELO';
    if (exportModeIn === 'TEC') return 'TEC';
    return 'V40';
  }

  mapAutoLevel(levelIn: any): number {
    const levelNum = Number(levelIn);
    if (!isNaN(levelNum) && levelNum > 0) {
      return levelNum;
    }
    return 20;
  }

  mapAutoCuttingTableId(jobIn: any): any {
    if (jobIn && jobIn.cutting_table_id !== undefined && jobIn.cutting_table_id !== null && jobIn.cutting_table_id !== '') {
      const idNum = Number(jobIn.cutting_table_id);
      if (!isNaN(idNum) && idNum > 0) {
        return idNum;
      }
    }

    if (this.cuttingTables && this.cuttingTables.length > 0) {
      const exportCode = this.mapAutoExportMode(jobIn && jobIn.export_mode ? jobIn.export_mode.toString() : '');
      const tableFound = this.cuttingTables.find(item => {
        if (!item) return false;
        const master = this.parseCuttingTableMasterData(item);
        return master && master.cnc_family && master.cnc_family.toString().toUpperCase() === exportCode;
      });
      if (tableFound && tableFound.id) {
        return tableFound.id;
      }
      return this.cuttingTables[0].id;
    }

    return null;
  }

  getAutoBatchLotList(jobIn: any): string[] {
    if (!jobIn) {
      return [];
    }

    if (jobIn.lot_list && Array.isArray(jobIn.lot_list)) {
      return Array.from(new Set(
        jobIn.lot_list
          .map(item => item !== null && item !== undefined ? item.toString().trim() : '')
          .filter(item => item !== '')
      ));
    }

    if (jobIn.lot !== null && jobIn.lot !== undefined) {
      return Array.from(new Set(
        jobIn.lot
          .toString()
          .split(',')
          .map(item => item.trim())
          .filter(item => item !== '')
      ));
    }

    return [];
  }

  getAutoBatchLotSet(jobIn: any): Set<string> {
    return new Set(this.getAutoBatchLotList(jobIn));
  }

  getAutoBatchLotFilter(jobIn: any): string {
    return this.getAutoBatchLotList(jobIn).join(',');
  }

  mapAutoFreedom(freedomIn: string): number {
    if (freedomIn === 'H') return 1;
    if (freedomIn === 'X') return 2;
    if (freedomIn === 'Y') return 3;
    if (freedomIn === 'Z') return 4;
    return 2;
  }

  mapAutoSpeed(speedIn: string): string {
    if (speedIn === 'optimal') return 'optimal';
    if (speedIn === 'medium') return 'medium';
    return 'fast';
  }

  mapAutoMinTronz(minTronzIn: any): number {
    const value = Number(minTronzIn);
    if (isNaN(value) || value < 0) {
      return 0;
    }
    return value;
  }

  mapAutoMaxTrav(maxTravIn: any): number {
    const value = Number(maxTravIn);
    if (isNaN(value) || value <= 0) {
      return this.fileForm && this.fileForm.controls && this.fileForm.controls.f_max_diecutting
        ? Number(this.fileForm.controls.f_max_diecutting.value ? this.fileForm.controls.f_max_diecutting.value : 2500)
        : 2500;
    }
    return value;
  }

  addAutoBatchWarning(warningIn: string) {
    if (!this.autoBatchMode) {
      return;
    }
    const txt = warningIn ? warningIn.toString().trim() : '';
    if (!txt) {
      return;
    }
    if (!this.autoBatchWarnings) {
      this.autoBatchWarnings = [];
    }
    if (!this.autoBatchWarnings.includes(txt)) {
      this.autoBatchWarnings.push(txt);
    }
  }

  finishAutoBatchJob(successIn: boolean, errorIn: string, resultIn?: any) {
    if (!this.autoBatchMode) {
      return;
    }

    const queueRaw = localStorage.getItem('vs_auto_batch_queue');
    const indexRaw = localStorage.getItem('vs_auto_batch_index');

    let index = indexRaw ? Number(indexRaw) : 0;
    index += 1;
    localStorage.setItem('vs_auto_batch_index', index.toString());

    const result = resultIn ? resultIn : this.buildAutoBatchResult(successIn, errorIn, null);
    this.applyAutoBatchWarningsToResult(result, successIn);

    localStorage.setItem('vs_auto_batch_last_result', JSON.stringify(result));
    localStorage.setItem('vs_auto_batch_continue', '1');

    if (queueRaw) {
      const queue = JSON.parse(queueRaw);
      if (index >= queue.length) {
        localStorage.removeItem('vs_auto_batch_current_job');
      }
    }

    this.autoBatchMode = false;
    this.autoBatchStage = 'done';
    this.autoBatchPendingResult = null;
    this.autoBatchWarnings = [];
    this.autoBatchStartTimeMs = 0;
    this.stopAutoBatchHeartbeat(true);
    localStorage.setItem('vs_auto_batch_resume_hint', JSON.stringify({
      source: 'file-list',
      ts: Date.now()
    }));
    this.router.navigate(['/auto-opti-lote']);
  }

  buildAutoBatchResult(successIn: boolean, errorIn: string, optiIdIn: any): any {
    const elapsedMs = this.autoBatchStartTimeMs > 0 ? (performance.now() - this.autoBatchStartTimeMs) : 0;
    const elapsedSeconds = elapsedMs > 0 ? Number((elapsedMs / 1000).toFixed(2)) : 0;
    const elapsedFormatted = elapsedSeconds > 0 ? this.formatarTiempo(elapsedSeconds) : '-';

    const warningList = this.autoBatchWarnings && this.autoBatchWarnings.length > 0 ? this.autoBatchWarnings.slice() : [];
    const warningCount = warningList.length;
    const statusText = successIn
      ? (warningCount > 0 ? ('OK con avisos (' + warningCount + ')') : 'OK')
      : 'ERROR: ' + errorIn;

    return {
      materialid: this.autoBatchJob ? this.autoBatchJob.materialid : 0,
      materialdesc: this.autoBatchJob ? this.autoBatchJob.materialdesc : '',
      cutting_table_id: this.autoBatchJob && this.autoBatchJob.cutting_table_id ? Number(this.autoBatchJob.cutting_table_id) : null,
      cutting_table_name: this.autoBatchJob && this.autoBatchJob.cutting_table_name ? this.autoBatchJob.cutting_table_name.toString() : '',
      level: this.fileForm && this.fileForm.controls && this.fileForm.controls.f_level ? Number(this.fileForm.controls.f_level.value) : this.mapAutoLevel(this.autoBatchJob && this.autoBatchJob.level),
      strategy: this.autoBatchJob ? this.autoBatchJob.strategy : '',
      speed: this.autoBatchJob ? this.autoBatchJob.speed : 'fast',
      lot_scope: this.getAutoBatchLotList(this.autoBatchJob),
      lots_used: this.getAutoBatchUsedLots(),
      opti_id: successIn ? (optiIdIn ? optiIdIn : '-') : '-',
      sheets_used: successIn ? this.num_sheet : '-',
      stacks: successIn ? this.total_area_C : '-',
      waste: successIn ? Number(this.total_area_X.toFixed(2)) + '%' : '-',
      a_cola: successIn ? Number(this.total_area_J.toFixed(2)) : '-',
      a_resto: successIn ? Number(this.total_area_T.toFixed(2)) : '-',
      optimization_time: elapsedFormatted,
      optimization_time_seconds: elapsedSeconds,
      pdf_groups_section: '',
      pdf_cutting_section: '',
      pdf_graphics_section: '',
      status: statusText,
      warnings: warningList,
      warning_count: warningCount,
      pieces_count: this.autoBatchJob && this.autoBatchJob.floor_summary ? this.autoBatchJob.floor_summary.pieces_count : 0,
      units_total: this.autoBatchJob && this.autoBatchJob.floor_summary ? this.autoBatchJob.floor_summary.units_total : 0,
      area_total_m2: this.autoBatchJob && this.autoBatchJob.floor_summary ? this.autoBatchJob.floor_summary.area_total_m2 : 0
    };
  }

  applyAutoBatchWarningsToResult(resultIn: any, successIn: boolean) {
    if (!resultIn) {
      return;
    }

    const warningList = this.autoBatchWarnings && this.autoBatchWarnings.length > 0 ? this.autoBatchWarnings.slice() : [];
    const warningCount = warningList.length;

    resultIn.warnings = warningList;
    resultIn.warning_count = warningCount;

    if (successIn) {
      resultIn.status = warningCount > 0 ? ('OK con avisos (' + warningCount + ')') : 'OK';
    }
  }

  getAutoBatchUsedLots(): string[] {
    if (!this.optimizationList || this.optimizationList.length === 0) {
      return [];
    }

    return Array.from(new Set(
      this.optimizationList
        .map(item => item && item.lot !== undefined && item.lot !== null ? item.lot.toString().trim() : '')
        .filter(item => item !== '')
    ));
  }

  chooseAutoSimulationByStrategy(simulationListIn: any[]): any {
    if (!simulationListIn || simulationListIn.length === 0) {
      return null;
    }

    const list = simulationListIn
      .filter(s => s && s.maxtrav > 0)
      .sort((a, b) => {
        const strategy = this.autoBatchJob ? this.autoBatchJob.strategy : 'less_waste';

        if (strategy === 'less_stacks') {
          if (a.ne !== b.ne) return a.ne - b.ne;
          if (a.ns !== b.ns) return a.ns - b.ns;
          if (a.tm !== b.tm) return a.tm - b.tm;
          if (a.rm !== b.rm) return b.rm - a.rm;
          return a.maxtrav - b.maxtrav;
        }

        if (a.tm !== b.tm) return a.tm - b.tm;
        if (a.ns !== b.ns) return a.ns - b.ns;
        if (a.ne !== b.ne) return a.ne - b.ne;
        if (a.rm !== b.rm) return b.rm - a.rm;
        return a.maxtrav - b.maxtrav;
      });

    if (list.length === 0) {
      return null;
    }

    return list[0];
  }

  buildAutoBatchNote(): string {
    const dateNow = new Date();
    const year = dateNow.getFullYear().toString();
    const month = (dateNow.getMonth() + 1).toString().padStart(2, '0');
    const day = dateNow.getDate().toString().padStart(2, '0');
    const hour = dateNow.getHours().toString().padStart(2, '0');
    const minute = dateNow.getMinutes().toString().padStart(2, '0');
    return 'Opt. Auto ' + year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
  }

  async generateAutoBatchPdfSections(optiInfoIn: any): Promise<any> {
    const result = { groups: '', cutting: '' };

    if (!this.opti || !this.opti.sheetList || this.opti.sheetList.length === 0) {
      return result;
    }

    const modeValue = Number(this.fileForm.controls.f_mode.value);
    let groupAction = 'PrintFile2';
    let cuttingAction = 'PrintCuttingMode2';

    if (modeValue === 1) {
      groupAction = 'PrintFile1';
      cuttingAction = 'PrintCuttingMode1';
    } else if (modeValue === 3) {
      groupAction = 'PrintFile3';
      cuttingAction = 'PrintCuttingMode2';
    }

    const groupListAux = this.opti.groupListMode2 ? this.opti.groupListMode2 : this.opti.groupInfoList;
    const groupList = [];
    for (const prop in groupListAux) {
      if (groupListAux.hasOwnProperty(prop)) {
        groupList.push({ name: prop, content: groupListAux[prop] });
      }
    }

    const apileList = this.getAdjacentEaselList(groupListAux);
    const cuttingList = this.cutTotalOrderList ? this.cutTotalOrderList.filter(p => p.type === 'P') : [];
    const optiInfoForPrint = this.showOptiId
      ? (optiInfoIn ? optiInfoIn
          : (this.currentOpti
              ? this.currentOpti
              : (this.routeOptiIdLabel && this.routeOptiIdLabel !== ''
                  ? { id: Number(this.routeOptiIdLabel) }
                  : null)))
      : null;
    const optiIdForPrint = this.showOptiId && optiInfoForPrint && optiInfoForPrint.id !== undefined && optiInfoForPrint.id !== null
      ? Number(optiInfoForPrint.id)
      : null;

    const groupsPayload = {
      group_list: groupList,
      sheet_list: this.opti.sheetList,
      cutting_list: cuttingList,
      apile_list: apileList,
      opti_info: optiInfoForPrint,
      opti_id: optiIdForPrint,
      action: groupAction,
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      level: this.fileForm.controls.f_level.value,
      block: this.fileForm.controls.f_blocks.value
    };

    const cuttingPayload = {
      group_list: groupList,
      sheet_list: this.opti.sheetList,
      cutting_list: cuttingList,
      apile_list: apileList,
      opti_info: optiInfoForPrint,
      opti_id: optiIdForPrint,
      action: cuttingAction,
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      level: this.fileForm.controls.f_level.value,
      block: this.fileForm.controls.f_blocks.value
    };

    result.groups = await this.generateAutoPdfFromPayload(groupsPayload);
    result.cutting = await this.generateAutoPdfFromPayload(cuttingPayload);

    return result;
  }

  async generateAutoSheetsPdfSection(optiInfoIn: any): Promise<string> {
    if (!this.opti || !this.opti.sheetList || this.opti.sheetList.length === 0) {
      return '';
    }

    const optiInfoForPrint = this.showOptiId
      ? (optiInfoIn ? optiInfoIn
          : (this.currentOpti
              ? this.currentOpti
              : (this.routeOptiIdLabel && this.routeOptiIdLabel !== ''
                  ? { id: Number(this.routeOptiIdLabel) }
                  : null)))
      : null;
    const optiIdForPrint = this.showOptiId && optiInfoForPrint && optiInfoForPrint.id !== undefined && optiInfoForPrint.id !== null
      ? Number(optiInfoForPrint.id)
      : null;
    const cuttingTableIdForPrint = Number(this.fileForm && this.fileForm.controls && this.fileForm.controls.f_cutting_table_id
      ? this.fileForm.controls.f_cutting_table_id.value
      : 0);
    const cuttingTableForPrint = (this.cuttingTables && cuttingTableIdForPrint > 0)
      ? this.cuttingTables.find(item => Number(item.id) === cuttingTableIdForPrint)
      : null;

    const payload = {
      sheet_list: this.opti.sheetList,
      cutting_list: this.cutTotalOrderList,
      total_graphic_list: this.buildPrintGraphicListSnapshot(),
      opti_info: optiInfoForPrint,
      opti_id: optiIdForPrint,
      total_stacks_preview: this.total_area_C,
      waste_percent_preview: Number(this.total_area_X.toFixed(2)),
      waste_percent_oef_preview: Number(this.total_area_X_OEF.toFixed(2)),
      rest_area_preview: Number(this.total_area_T.toFixed(2)),
      cnc_file_name: this.buildPredictedCncFileNameForPrint(),
      last_exported_file_name: this.lastExportedFileName ? this.lastExportedFileName : '',
      action: 'PrintFile',
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      f_cutting_table_id: cuttingTableIdForPrint > 0 ? cuttingTableIdForPrint : null,
      f_cutting_table_name: cuttingTableForPrint && cuttingTableForPrint.name ? cuttingTableForPrint.name.toString() : '',
      level: this.fileForm.controls.f_level.value,
      block: this.fileForm.controls.f_blocks.value,
      f_fill_piece: this.fileForm.controls.f_fill_piece.value,
      f_show_order: this.fileForm.controls.f_show_order.value,
      f_origin: this.fileForm.controls.f_origin.value,
      f_axis: this.fileForm.controls.f_axis.value,
      f_zoom: this.fileForm.controls.f_zoom.value,
      f_order: this.fileForm.controls.f_order.value,
      f_base: this.fileForm.controls.f_base.value,
      f_old: this.fileForm.controls.f_old.value,
      f_free: this.fileForm.controls.f_free.value,
      f_free_in: this.fileForm.controls.f_free_in.value,
      f_grade: this.fileForm.controls.f_grade.value,
      f_grade_rep: this.fileForm.controls.f_grade_rep.value,
      f_retal_width: this.fileForm.controls.f_retal_width.value,
      f_retal_height: this.fileForm.controls.f_retal_height.value,
      f_rute: this.fileForm.controls.f_rute.value,
      f_export: this.fileForm.controls.f_export.value,
      f_disband_l: this.fileForm.controls.f_disband_l.value,
      f_disband_r: this.fileForm.controls.f_disband_r.value,
      f_disband_t: this.fileForm.controls.f_disband_t.value,
      f_disband_b: this.fileForm.controls.f_disband_b.value,
      f_diecutting: this.fileForm.controls.f_diecutting.value,
      f_max_diecutting: this.fileForm.controls.f_max_diecutting.value
    };

    const response: any = await this.printSheetsWithTimeout(payload, 180000);
    return response && response.section ? response.section : '';
  }

  async generateAutoPdfFromPayload(payloadIn: any): Promise<string> {
    const response: any = await this.printEaselsWithTimeout(payloadIn, 180000);
    return response && response.section ? response.section : '';
  }

  async generateAutoBatchCncFiles(): Promise<any[]> {
    if (!this.opti || !this.opti.sheetList || this.opti.sheetList.length === 0) {
      return [];
    }

    const payload = this.buildAutoBatchCncPayload();
    if (!payload) {
      return [];
    }

    const response = await this.printEaselsWithTimeout(payload, 240000);

    return this.extractAutoBatchCncFiles(response);
  }

  private printEaselsWithTimeout(payloadIn: any, timeoutMs: number): Promise<any> {
    return new Promise(resolve => {
      let done = false;
      let sub: any = null;

      const timer = setTimeout(() => {
        if (done) {
          return;
        }
        done = true;
        if (sub) {
          sub.unsubscribe();
        }
        resolve(null);
      }, timeoutMs);

      sub = this.fileService.printEasels(payloadIn).subscribe(
        (response: any) => {
          if (done) {
            return;
          }
          done = true;
          clearTimeout(timer);
          resolve(response ? response : null);
        },
        () => {
          if (done) {
            return;
          }
          done = true;
          clearTimeout(timer);
          resolve(null);
        }
      );
    });
  }

  private printSheetsWithTimeout(payloadIn: any, timeoutMs: number): Promise<any> {
    return new Promise(resolve => {
      let done = false;
      let sub: any = null;

      const timer = setTimeout(() => {
        if (done) {
          return;
        }
        done = true;
        if (sub) {
          sub.unsubscribe();
        }
        resolve(null);
      }, timeoutMs);

      sub = this.fileService.printSheets(payloadIn).subscribe(
        (response: any) => {
          if (done) {
            return;
          }
          done = true;
          clearTimeout(timer);
          resolve(response ? response : null);
        },
        () => {
          if (done) {
            return;
          }
          done = true;
          clearTimeout(timer);
          resolve(null);
        }
      );
    });
  }

  buildAutoBatchCncPayload(): any {
    const exportMode = this.fileForm && this.fileForm.controls && this.fileForm.controls.f_export && this.fileForm.controls.f_export.value
      ? this.fileForm.controls.f_export.value.toString()
      : 'V40';

    const groupList = [];
    const groupListAux = this.opti && this.opti.groupInfoList ? this.opti.groupInfoList : {};
    for (const prop in groupListAux) {
      if (groupListAux.hasOwnProperty(prop)) {
        groupList.push({ name: prop, content: groupListAux[prop] });
      }
    }

    const disbandL = this.fileForm.controls.f_disband_l.value ? Number(this.fileForm.controls.f_disband_l.value) : 0;
    const disbandB = this.fileForm.controls.f_disband_b.value ? Number(this.fileForm.controls.f_disband_b.value) : 0;
    const disbandR = this.fileForm.controls.f_disband_r.value ? Number(this.fileForm.controls.f_disband_r.value) : 0;
    const disbandT = this.fileForm.controls.f_disband_t.value ? Number(this.fileForm.controls.f_disband_t.value) : 0;
    const diecutting = this.fileForm.controls.f_diecutting.value ? Number(this.fileForm.controls.f_diecutting.value) : 0;

    if (this.opti && this.opti.sheetList && this.opti.sheetList.length > 0) {
      this.opti.sheetList.forEach(s => {
        s.disband = {
          left: disbandL,
          bottom: disbandB,
          right: disbandR,
          top: disbandT
        };
        if (diecutting > 0) {
          s.diecutting = diecutting;
        }
      });
    }

    let action = 'CreateV40';
    let sheetListToExport = this.opti.sheetList;
    if (exportMode === 'LSW' || exportMode === 'LIOPT') {
      action = exportMode === 'LIOPT' ? 'CreateLIOPT' : 'CreateLSW';
      sheetListToExport = this.buildLevel0TraverseSheetList();
    } else if (exportMode === 'OTD') {
      action = 'CreateOTD';
      sheetListToExport = this.buildLevel0TraverseSheetList();
    } else if (exportMode === 'BTR') {
      action = 'CreateBTR';
      sheetListToExport = this.buildLevel0TraverseSheetList();
    } else if (exportMode === 'ELO') {
      action = 'CreateELO';
      sheetListToExport = this.buildLevel0TraverseSheetList();
    } else if (exportMode === 'TEC') {
      action = 'CreateTEC';
      sheetListToExport = this.buildLevel0TraverseSheetList();
    }

    return {
      group_list: groupList,
      sheet_list: sheetListToExport,
      opti_id: this.resolveCurrentOptiId(),
      action: action,
      back: 'file-list',
      mode: this.fileForm.controls.f_mode.value,
      level: this.fileForm.controls.f_level.value,
      origin: Number(this.fileForm.controls.f_origin.value),
      merma: Number(this.total_area_X.toFixed(2)) * 100,
      bruto: Number(this.total_area_B.toFixed(2)) * 100,
      neto: Number(this.total_area_P.toFixed(2)) * 100,
      block: this.fileForm.controls.f_blocks.value,
      oef: action === 'CreateV40' ? this.buildOefPayload() : undefined
    };
  }

  buildLevel0TraverseSheetList(): any[] {
    const listOut = [];
    if (!this.level0TraverseList) {
      return listOut;
    }
    for (const prop in this.level0TraverseList) {
      if (this.level0TraverseList.hasOwnProperty(prop)) {
        listOut.push(this.level0TraverseList[prop]);
      }
    }
    return listOut;
  }

  private resolveCurrentOptiId(): number | null {
    const candidates = [];
    if (this.currentOpti) {
      candidates.push(this.currentOpti.id);
      candidates.push(this.currentOpti.opti_id);
      candidates.push(this.currentOpti.od_opti_number);
    }
    if (this.selectedFile) {
      candidates.push(this.selectedFile['id']);
      candidates.push(this.selectedFile['opti_id']);
      candidates.push(this.selectedFile['optimization_id']);
    }
    if (this.opti && this.opti.sheetList && this.opti.sheetList.length > 0) {
      const firstSheet = this.opti.sheetList[0];
      if (firstSheet) {
        candidates.push(firstSheet['opti_id']);
        candidates.push(firstSheet['optimization_id']);
      }
      const firstSheetPiece = firstSheet && firstSheet.pieces && firstSheet.pieces.length > 0 && firstSheet.pieces[0]
        ? (firstSheet.pieces[0].piece ? firstSheet.pieces[0].piece : firstSheet.pieces[0])
        : null;
      if (firstSheetPiece) {
        candidates.push(firstSheetPiece['opti_id']);
        candidates.push(firstSheetPiece['piece_opti_id']);
      }
    }
    if (this.chargeSheetOpti && this.chargeSheetOpti.length > 0) {
      candidates.push(this.chargeSheetOpti[0]['opti_id']);
      candidates.push(this.chargeSheetOpti[0]['optimization_id']);
    }
    if (this.chargeOpti && this.chargeOpti.length > 0) {
      candidates.push(this.chargeOpti[0]['opti_id']);
      candidates.push(this.chargeOpti[0]['piece_opti_id']);
      candidates.push(this.chargeOpti[0]['optimization_id']);
    }
    candidates.push(this.routeOptiIdLabel);

    for (let i = 0; i < candidates.length; i++) {
      const value = candidates[i];
      if (value === undefined || value === null) {
        continue;
      }
      const raw = value.toString().trim();
      if (raw === '') {
        continue;
      }
      const digits = raw.replace(/[^0-9]/g, '');
      if (!digits) {
        continue;
      }
      const idNum = Number(digits);
      if (!isNaN(idNum) && idNum > 0) {
        return idNum;
      }
    }

    return null;
  }

  extractAutoBatchCncFiles(responseIn: any): any[] {
    const filesOut = [];
    if (!responseIn || !responseIn.action) {
      return filesOut;
    }

    if (responseIn.action === 'CreateV40') {
      if (responseIn.file_name && responseIn.turomas_JSON) {
        filesOut.push({
          file_name: responseIn.file_name,
          content: responseIn.turomas_JSON,
          mime_type: 'application/json;charset=utf-8'
        });
      }
      return filesOut;
    }

    if (responseIn.action === 'CreateOTD') {
      if (responseIn.file_name && responseIn.intermac_OTD) {
        filesOut.push({
          file_name: responseIn.file_name,
          content: responseIn.intermac_OTD,
          mime_type: 'text/plain;charset=utf-8'
        });
      }
      return filesOut;
    }

    if (responseIn.action === 'CreateLSW' || responseIn.action === 'CreateLIOPT') {
      if (responseIn.file_name) {
        filesOut.push({
          file_name: responseIn.file_name,
          asset_url: '/assets/attachments/lisec/' + responseIn.file_name
        });
      }
      return filesOut;
    }

    if (responseIn.action === 'CreateBTR') {
      if (responseIn.content && responseIn.file_name && responseIn.content.tra1 && responseIn.file_name.tra1) {
        filesOut.push({
          file_name: responseIn.file_name.tra1,
          content: responseIn.content.tra1,
          mime_type: 'text/plain;charset=utf-8'
        });
      }
      return filesOut;
    }

    if (responseIn.action === 'CreateTEC') {
      if (responseIn.file_name && responseIn.content) {
        filesOut.push({
          file_name: responseIn.file_name,
          content: responseIn.content,
          mime_type: 'text/plain;charset=utf-8'
        });
      }
      return filesOut;
    }

    if (responseIn.action === 'CreateELO') {
      if (responseIn.content && responseIn.file_name) {
        if (responseIn.content.nst && responseIn.file_name.nst) {
          filesOut.push({
            file_name: responseIn.file_name.nst,
            content: responseIn.content.nst,
            mime_type: 'text/plain;charset=utf-8'
          });
        }
        if (responseIn.content.cmt && responseIn.file_name.cmt) {
          filesOut.push({
            file_name: responseIn.file_name.cmt,
            content: responseIn.content.cmt,
            mime_type: 'text/plain;charset=utf-8'
          });
        }
        if (responseIn.content.dcs && responseIn.file_name.dcs) {
          filesOut.push({
            file_name: responseIn.file_name.dcs,
            content: responseIn.content.dcs,
            mime_type: 'text/plain;charset=utf-8'
          });
        }
      }
    }

    return filesOut;
  }

  // Función que se lanza cuando se pulsa un elemento del listado de piezas proveniente de VS-Floor.
  changeFloorCheck(itemIn: any) {

    console.log('-> changeFloorCheck itemIn pulsado:');
    console.log(itemIn);

    if (itemIn['check']) {
      itemIn['check'] = false;
      // this.totalSelectedPieces -= Number(itemIn['units']);
    } else {
      itemIn['check'] = true;
      // this.totalSelectedPieces += Number(itemIn['units']);
    }
  } // End function changeFloorCheck

  // --------------------------------
  //    FIN Control piezas VS-Floor
  // --------------------------------

  // -----------

  optiButtonFocus() {

	console.log('* optiButtonFocus: Valor foco en max_travera = ');
	//console.log(this.maxTravField.nativeElement.hasFocus());

	// Colocamos inicialmente el foco en el botón de optimizar.
    //this.optiButton.nativeElement.focus();

    // Se lanza la optimización sin grabar piezas (parámetro a false).
    this.buttonStartOptimization(false, this.fileForm.controls.f_blocks.value);

    this.activateTab('tabGraphic');

  } // End function optiButtonFocus.

  // --------- Detectar tecla presionada
  onKeydown(event: any) {
    console.log('Presionada tecla...');
    console.log(event);

    if (event.key === 'Enter') {
      console.log('--> Tecla ENTER.');

      // if (!this.maxTravField.nativeElement.hasFocus()) {

		this.loadInventory();

	  // }
    }
  } // End function onKeydown

  // -----------

  delay(miliseconds) {

    console.log('delay...');

    return new Promise(function(resolve) {
        setTimeout(resolve, miliseconds);
    });
  }

  async myAsyncFunction() {

    console.log('Before the delay');

    await this.delay(this.setTimeout_aux);

    console.log('After the delay');
  }

  formatarTiempo(totalSegundos: number): string {
    const horas = Math.floor(totalSegundos / 3600);
    const minutos = Math.floor((totalSegundos % 3600) / 60);
    const segundos = Math.floor(totalSegundos % 60);

    // Añadir ceros a la izquierda si es necesario (ej. "05" en vez de "5")
    const pad = (num: number) => num.toString().padStart(2, '0');
	/*
	if (pad(horas) === '00') {

		if (pad(minutos) === '00') {
			return `${pad(segundos)}`;
		} else {
			return `${pad(minutos)}:${pad(segundos)}`;
		}
	} else {
		return `${pad(horas)}:${pad(minutos)}:${pad(segundos)}`;
	} */

	return `${pad(horas)}:${pad(minutos)}:${pad(segundos)}`;
   } // End function formatarTiempo.

  private getOptimizationDurationSeconds(): number {
    if (this.autoBatchMode && this.autoBatchStartTimeMs > 0) {
      const elapsedMsAuto = performance.now() - this.autoBatchStartTimeMs;
      if (elapsedMsAuto > 0) {
        return Number((elapsedMsAuto / 1000).toFixed(2));
      }
    }

    const secondsFromDuration = this.parseDurationToSeconds(this.time_duration);
    if (secondsFromDuration > 0) {
      return Number(secondsFromDuration.toFixed(2));
    }

    if (this.time_start > 0 && this.time_end > this.time_start) {
      const elapsedMs = this.time_end - this.time_start;
      return Number((elapsedMs / 1000).toFixed(2));
    }

    return 0;
  }

  private parseDurationToSeconds(durationIn: string): number {
    if (!durationIn || durationIn.toString().trim() === '') {
      return 0;
    }

    const raw = durationIn.toString().trim();
    const parts = raw.split(':');

    if (parts.length === 3) {
      const hours = Number(parts[0]);
      const minutes = Number(parts[1]);
      const seconds = Number(parts[2]);
      if (!isNaN(hours) && !isNaN(minutes) && !isNaN(seconds)) {
        return (hours * 3600) + (minutes * 60) + seconds;
      }
    }

    const numeric = Number(raw.replace(',', '.'));
    if (!isNaN(numeric) && numeric > 0) {
      return numeric;
    }

    return 0;
  }

} // End Class FileComponent
